/* eslint-disable */
import { number, plural, select } from 'messageformat-runtime';
import { en } from 'messageformat-runtime/lib/plurals';

export default{
  LANGUAGE_LABEL: {
    EN_US: function() { return "English-US"; },
    ES_MX: function() { return "Español"; },
    ES_ES: function() { return "Español-España"; },
    FR_FR: function() { return "Français-France"; },
    PT_PT: function() { return "Português-Portugal"; },
    PT_BR: function() { return "Português do Brasil"; },
    ZH_CN: function() { return "简体中文"; },
    ZH_TW: function() { return "繁體中文"; },
    JA_JP: function() { return "日本語"; },
    KO_KP: function() { return "한국어"; },
    RU_RU: function() { return "Русский"; },
    DE_DE: function() { return "Deutsch"; },
    AR_SA: function() { return "عربى"; },
    HE_IL: function() { return "עִברִית"; },
    PL_PL: function() { return "Polski"; },
    IT_IT: function() { return "Italiano"; },
    FR_CA: function() { return "Français-Canada"; },
    NL_NL: function() { return "Nederlands"; },
    RO_RO: function() { return "Română"; },
    SV_SE: function() { return "Svenska"; },
    ID_ID: function() { return "Bahasa Indonesia"; },
    TH_TH: function() { return "ไทย"; },
    TR_TR: function() { return "Türkçe"; },
    VI_VI: function() { return "Tiếng Việt"; },
    NB_NO: function() { return "Bokmål"; },
    DA_DK: function() { return "Dansk"; },
    FI_FI: function() { return "Suomi"; },
  },

  LANGUAGE_ENGLISH_LABEL: {
    EN_US: function() { return ""; },
    ES_MX: function() { return "Spanish"; },
    ES_ES: function() { return "Spanish - Spain"; },
    FR_FR: function() { return "French - France"; },
    PT_PT: function() { return "Portuguese - Portugal"; },
    PT_BR: function() { return "Portuguese - Brazil"; },
    ZH_CN: function() { return "Chinese Simplified"; },
    ZH_TW: function() { return "Chinese Traditional"; },
    JA_JP: function() { return "Japanese"; },
    KO_KP: function() { return "Korean"; },
    RU_RU: function() { return "Russian"; },
    DE_DE: function() { return "German"; },
    AR_SA: function() { return "Arabic"; },
    HE_IL: function() { return "Hebrew"; },
    PL_PL: function() { return "Polish"; },
    IT_IT: function() { return "Italian"; },
    FR_CA: function() { return "French - Canada"; },
    NL_NL: function() { return "Dutch"; },
    RO_RO: function() { return "Romanian"; },
    SV_SE: function() { return "Swedish"; },
    ID_ID: function() { return "Indonesian"; },
    TH_TH: function() { return "Thai"; },
    TR_TR: function() { return "Turkish"; },
    VI_VI: function() { return "Vietnamese"; },
    NB_NO: function() { return "Norwegian Bokmål"; },
    DA_DK: function() { return "Danish"; },
    FI_FI: function() { return "Finnish"; },
  },

  USERS_LIST: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }); },
  LANGUAGE: {
    TRANSLATING: function() { return "Translating, please wait..."; },
    FTE: {
      TITLE: function() { return "Your Language Preference"; },
      SUBTITLE: {
        EN_US: function() { return "NovoEd now supports <b>English-United States</b> and other languages."; },
        ES_MX: function() { return "NovoEd now supports <b>Spanish-Mexico</b> and other languages."; },
        ES_ES: function() { return "NovoEd now supports <b>Spanish-Spain</b> and other languages."; },
        FR_FR: function() { return "NovoEd now supports <b>French-France</b> and other languages."; },
        PT_PT: function() { return "NovoEd now supports <b>Portuguese-Portugal</b> and other languages."; },
        ZH_CN: function() { return "NovoEd now supports <b>简体中文</b> and other languages."; },
        JA_JP: function() { return "NovoEd now supports <b>日本語</b> and other languages."; },
        KO_KP: function() { return "NovoEd now supports <b>한국어</b> and other languages."; },
      },

      DETAILS: function() { return "You can access and update your language preference from the dropdown menu under your profile image."; },
      CONFIRM: function() { return "Got It!"; },
    },

  },

  TIME: {
    HOUR: function() { return "hour"; },
    HOURS: function() { return "hours"; },
    DAYS: function() { return "days"; },
  },

  JOIN: {
    TWO: {
      AND: function() { return " and "; },
      OR: function() { return " or "; },
    },

    THREE_OR_FOUR: {
      COMMA: function() { return ", "; },
      AND: function() { return " and "; },
      OR: function() { return " or "; },
    },

    MANY: {
      COMMA: function() { return ", "; },
      AND: function() { return " and "; },
      OR: function() { return " or "; },
    },

  },

  TIME_SINCE: {
    MONTHS_AGO: function(monthsCount: number) { return "Last updated: " + monthsCount + " " + plural(monthsCount, 0, en, { one: "month", other: "months" }) + " ago"; },
    DAYS_AGO: function(daysCount: number) { return "Last updated: " + daysCount + " " + plural(daysCount, 0, en, { one: "day", other: "days" }) + " ago"; },
    HOURS_AGO: function(hoursCount: number) { return "Last updated: " + hoursCount + " " + plural(hoursCount, 0, en, { one: "hour", other: "hours" }) + " ago"; },
    MINUTES_AGO: function(minutesCount: number) { return "Last updated: " + minutesCount + " " + plural(minutesCount, 0, en, { one: "minute", other: "minutes" }) + " ago"; },
    LESS_THAN_MINUTE_AGO: function() { return "Last update: less than a minute ago"; },
    LIGHT_MONTHS_AGO: function(monthsCount: number) { return monthsCount + " " + plural(monthsCount, 0, en, { one: "month", other: "months" }); },
    LIGHT_DAYS_AGO: function(daysCount: number) { return daysCount + " " + plural(daysCount, 0, en, { one: "day", other: "days" }); },
    LIGHT_HOURS_AGO: function(hoursCount: number) { return hoursCount + " " + plural(hoursCount, 0, en, { one: "hour", other: "hours" }); },
    LIGHT_MINUTES_AGO: function(minutesCount: number) { return minutesCount + " " + plural(minutesCount, 0, en, { one: "minute", other: "minutes" }); },
    LIGHT_LESS_THAN_MINUTE_AGO: function() { return "Just now"; },
  },

  DASHBOARD: {
    TITLE: function() { return "Learner Dashboard"; },
    HOME: function() { return "Courses"; },
    NEW: function() { return "New"; },
    MY_LEARNING: function() { return "My Learning"; },
    SUBMISSIONS_PENDING_APPROVAL: function(courseCount: number, submissionCount: number) { return plural(submissionCount, 0, en, { one: " Submission ", other: " Submissions " }) + " from " + plural(courseCount, 0, en, { one: " 1 Course Needs ", other: " " + number("en", courseCount, 0) + " Courses Need " }) + " Approval"; },
    TODOS_COMING_UP: function(count: number) { return "Upcoming " + plural(count, 0, en, { one: " To-do ", other: " To-dos " }); },
    TODOS_TO_CATCH_UP_ON: function(count: number) { return plural(count, 0, en, { one: " To-do ", other: " To-dos " }) + " to Catch Up On"; },
    ACTIVE_DRAFTS: function(count: number) { return "Active " + plural(count, 0, en, { one: " Draft ", other: " Drafts " }); },
    SAVED_RESPONSES: function(count: number) { return "Saved " + plural(count, 0, en, { one: " Response ", other: " Responses " }); },
    SUBMISSIONS: function(count: number) { return plural(count, 0, en, { one: " Submission ", other: " Submissions " }); },
    COURSES: function(count: number) { return plural(count, 0, en, { one: " Course ", other: " Courses " }); },
    START_LEARNING: function() { return "Start Learning"; },
    KEEP_LEARNING: function() { return "Keep Learning"; },
    OPEN_TO_ORG: function() { return "Open to the whole organization"; },
    OFFERED_TO: function() { return "Offered to:"; },
    LEARN_MORE: function() { return "Learn More"; },
    ENROLLED_COUNT: function(count: number) { return plural(count, 0, en, { one: " 1 learner enrolled ", other: " " + number("en", count, 0) + " learners enrolled " }); },
    CURRENT_COURSES: function(count: number) { return "Current " + plural(count, 0, en, { one: " Course ", other: " Courses " }); },
    COMPLETED_COURSES: function(count: number) { return "Completed " + plural(count, 0, en, { one: " Course ", other: " Courses " }); },
    COURSE_STATEMENTS_AND_CERTIFICATES: function(count: number) { return plural(count, 0, en, { one: " Course Statement or Certificate ", other: " Course Statements and Certificates " }); },
    SHOW_ALL: function() { return "Show All"; },
    SHOW_LESS: function() { return "Show Less"; },
    TODAY: function() { return "Today"; },
    DUE: function() { return "Due:"; },
    DUE_TODAY: function() { return "Due: Today"; },
    DUE_TODAY_AT: function() { return "Due: Today at"; },
    DUE_IN_HOURS: function(deadline: string) { return "Due in " + deadline + " hours"; },
    DUE_IN_DAYS: function(deadline: string) { return "Due in " + deadline + " days"; },
    DUE_IN_MONTHS: function(deadline: string) { return "Due in " + deadline + " months"; },
    STARTS_DATE: function(startDate: string) { return "Starts " + startDate; },
    COMPLETED_DATE: function(endDate: string) { return "Completed " + endDate; },
    COURSE_STARTED: function(startDate: string) { return "Started " + startDate; },
    COURSE_STARTING: function(startDate: string) { return "Starting " + startDate; },
    COURSE_ENDING: function(endDate: string) { return "Ending " + endDate; },
    COMPLETE_IN: function(days: number) { return "Complete in " + plural(days, 0, en, { one: " 1 day ", other: " " + number("en", days, 0) + " days " }); },
    DAYS_REMAINING: function(days: string) { return "Less than " + days + " " + plural(days, 0, en, { one: " day remaining ", other: " days remaining " }); },
    STARTED: function() { return "Started"; },
    ENDING: function() { return "Ending"; },
    COURSE_ACCESS_EXPLANATION: function() { return "You have access to the content till"; },
    OPEN_UNTIL: function(closeDate: string) { return "Open until " + closeDate; },
    LAST_UPDATED: {
      MONTHS_AGO: function(lastUpdated: string) { return "Last update: about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " month ", other: " months " }) + " ago"; },
      DAYS_AGO: function(lastUpdated: string) { return "Last update: about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Last update: about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Last update: about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Last update: less than a minute ago"; },
    },

    STARTING_TODAY: function() { return "Starting in less than 24 hours"; },
    STARTING_THIS_WEEK: function(countdownToRelease: number) { return "Starting in " + countdownToRelease + " " + plural(countdownToRelease, 0, en, { one: " day ", other: " days " }); },
    FOR: function() { return "for"; },
    CONFIRMATION: {
      ARE_YOU_SURE: function() { return "Are You Sure?"; },
      YES_SURE: function() { return "Yes, I'm Sure"; },
      WITHDRAW_MSG: function() { return "Withdrawing from this course means you will no longer have access to the course content and you will be removed from all your teams and groups."; },
      AUDIT: {
        AUDIT_MSG: function() { return "Auditing this course allows you to enjoy the lectures without the obligation to complete the course requirements. If you audit this course:"; },
        AUDIT_MSG_MOBILE: function() { return "Auditing means you can enjoy the content without completing the course."; },
        NO_REFUND: function() { return "You will not receive a refund."; },
        NO_LECTURES: function() { return "You will still be able to view lectures and submit individual assignments."; },
        NO_TEAM_ASSIGNMENTS: function() { return "You will not be able to participate in team assignments."; },
        REMOVED_FROM_TEAMS: function() { return "You will be removed from your current teams."; },
        CANCEL_INVITATIONS: function() { return "Your outstanding team invitations and membership requests will be cancelled."; },
        NO_STATEMENT_OF_ACCOMPLISHMENT: function() { return "You will not be eligible for a statement of accomplishment."; },
      },

    },

    LOGO_ALT: function() { return "Organization logo"; },
    ENROLLMENT_SETTINGS_LABEL: function() { return "Enrollment Settings"; },
    SUBMISSION_COMMENTS_LABEL: function() { return "Submission Comments"; },
    NAVBAR_LABEL: function(d) { return d.CourseAlias + " Header"; },
    GO_TO_DASHBOARD: function() { return "Go to Dashboard"; },
    BACK_TO_DASHBOARD: function() { return "Back to Dashboard"; },
    BACK_TO_JOURNEY_HOME_TOOLTIP: function() { return "Back to Journey Home"; },
    ADMIN_OPTIONS_TOOLTIP: function() { return "Admin Options"; },
    BACK: function() { return "Back"; },
    TABS: {
      IN_PROGRESS: {
        TITLE: function() { return "In Progress"; },
        X_CLOSING_SOON: function(closingSoonCount: number) { return closingSoonCount + " Closing Soon"; },
      },

      DISCOVERY: {
        TITLE: function() { return "Discover More"; },
        START_LEARNING: function() { return "Start Learning"; },
        DISCOVER_LEARNING: function() { return "Discover More Learning"; },
        SUBTITLE: function() { return "Explore curated content focused on specific categories to help advance your learning!"; },
      },

      DRAFTS: {
        X_DUE_SOON: function(dueSoonCount: number) { return dueSoonCount + " Due Soon"; },
        TITLE: function(draftsCount: number) { return "Active " + plural(draftsCount, 0, en, { one: "Draft", other: "Drafts" }); },
      },

      TODOS: {
        TITLE: function(todosCount: number) { return "Upcoming " + plural(todosCount, 0, en, { one: "To-Do", other: "To-Dos" }); },
      },

      SUBMISSIONS: {
        X_NEED_REVISION: function(needRevisionCount: number) { return needRevisionCount + " Need Revision"; },
        X_PENDING_APPROVAL: function(pendingApprovalCount: number) { return pendingApprovalCount + " Pending Approval"; },
        X_RECENTLY_APPROVED: function(recentlyApprovedCount: number) { return recentlyApprovedCount + " Recently Approved"; },
        TITLE: function(submissionsCount: number) { return plural(submissionsCount, 0, en, { one: "Submission", other: "Submissions" }); },
      },

      COMPLETED: {
        TITLE: function() { return "Completed"; },
        ARCHIVED_CONTENT_TITLE: function() { return "Archived"; },
        VIEW_ARCHIVED_LEARNING: function() { return "View Archived Learning"; },
        HIDE_ARCHIVED_LEARNING: function() { return "Hide Archived Learning"; },
        X_WITH_CERTIFICATE: function(withCertificateCount: number) { return withCertificateCount + " with Certificate"; },
      },

      ARCHIVED: {
        TITLE: function() { return "Archived"; },
      },

    },

    NOTHING_HERE: function() { return "Nothing here yet"; },
  },

  MENTOR_DASHBOARD: {
    TITLE: function(d) { return d.MentorTitleAlias + " Dashboard"; },
    TABLE_HEADER_NOTES: function() { return "Notes"; },
    NO_ENROLLMENT: function() { return "No Enrolled Courses Yet"; },
    COPY_EMAIL: function() { return "Copy Email"; },
    COPY_SUCCESS: function() { return "Email Copied to Clipboard"; },
  },

  SUPERVISOR_ADMIN_DASHBOARD: {
    TITLE: function() { return "Mentor Dashboard"; },
    TABLE: {
      COLUMN_HEADERS: {
        NAME: function() { return "Name"; },
        SCENARIO_NAME: function() { return "Scenario Name"; },
        PENDING_REVIEW: function() { return "Pending Review For..."; },
        MENTEES_NUMBER: function() { return "Assigned to You"; },
      },

      PENDING_MENTEES: function(d) { return "Pending " + d.MenteeAlias + "(s)"; },
    },

    MENTOR_CTA: function() { return "Practice Feedback Pending"; },
    DROPDOWN_SUFFIX: function() { return "Pending"; },
    DROPDOWN_DEFAULT: function() { return "All Practices"; },
    TABS: {
      ALL: function() { return "All"; },
      PENDING_SUBMISSIONS: function() { return "Practice Submissions Pending Feedback"; },
    },

  },

  COURSE_ADMIN_DASHBOARD: {
    ADMIN_DASHBOARD: function() { return "Admin Dashboard"; },
    TABS: {
      LAST_VISITED: function() { return "Last Visited"; },
      ACTIVE: function() { return "Active"; },
      FUTURE: function() { return "Future"; },
      PAST: function() { return "Past"; },
      DEMO: function() { return "Demo"; },
    },

    TABLE: {
      NAME: function() { return "Name"; },
      RELEASE_DATE: function() { return "Release Date"; },
      NUM_OF_ENROLLEES: function() { return "Enrollment"; },
      COMPLETION_RATE: function() { return "Completion Rate"; },
      SEARCH: function() { return "Search..."; },
      ENROLLEES: function() { return "Enrollees"; },
    },

    SORTING: {
      LAST_ACTIVITY: function() { return "Last Activity"; },
      RELEASE_DATE: function() { return "Release Date"; },
      START_DATE: function() { return "Start Date"; },
      END_DATE: function() { return "End Date"; },
      CLOSE_DATE: function() { return "Close Date"; },
      ARIA_LABEL: {
        SORT_ASC: function() { return "Sort Ascending"; },
        SORT_DESC: function() { return "Sort Descending"; },
      },

    },

    SEARCH_RESULTS: function() { return "Search Results for"; },
    CLEAR_SEARCH: function() { return "Clear Search"; },
    NOT_APPLICABLE: function() { return "N/A"; },
    WAITLISTED: function(waitlistedCount: number) { return waitlistedCount + " Waitlisted"; },
  },

  NOVOED: {
    TEAMS: function() { return "Teams"; },
    COURSES: function() { return "Courses"; },
    MORE: function() { return "More"; },
    MORE_LC: function() { return "more"; },
    LESS: function() { return "Less"; },
    CLOSE: function() { return "Close"; },
    VIEW: function() { return "View"; },
    CANCEL: function() { return "Cancel"; },
    DELETE: function() { return "Delete"; },
    FULLSCREEN: function() { return "View in Full Page"; },
    REDIRECTING: function() { return "Redirecting..."; },
    SELECT: function() { return "Select"; },
    STOP: function() { return "Stop"; },
  },

  COLORS: {
    BLACK: function() { return "Black"; },
    WHITE: function() { return "White"; },
  },

  LHS: {
    ADMIN_TOOLS: function() { return "Admin Tools"; },
    ORG_ADMIN_TOOLS: {
      TITLE: function() { return "Organization Admin Tools"; },
      LEARN_PLUS: function() { return "Learn+"; },
      MENTOR_PLUS: function() { return "Mentor+"; },
      PLATFORM_SETTINGS: function() { return "Platform Settings"; },
    },

    COURSE_MENTEES: function() { return "Course Mentees"; },
    MY_MENTEES: function() { return "My Mentees"; },
    DASHBOARD: function() { return "My Dashboard"; },
    DASHBOARDS: function() { return "Dashboards"; },
    DASHBOARDS_LIST: {
      ORG_ADMIN: function() { return "Org Dashboard"; },
      LEARNER: function() { return "Learner Dashboard"; },
      MENTOR: function(d) { return d.MentorTitleAlias + " Dashboard"; },
      COURSE_ADMIN: function() { return "Course Admin Dashboard"; },
    },

    MY_LEARNING: function() { return "My Learning"; },
    ALL_LOADED: function() { return "All Loaded"; },
    NOTHING_HERE_YET: function() { return "Nothing here yet."; },
    NO_MENTEES: function() { return "No Mentees Assigned Yet"; },
    NO_ITEMS: function() { return "No Items Yet"; },
    NO_TEAMS_GROUPS: function() { return "No Teams or Groups Yet"; },
    COURSE_CARD: {
      ADMIN: function() { return "Admin"; },
      CLOSED: function() { return "Closed"; },
      CURRENT_PROGRAM: function() { return "Current Program"; },
      CURRENT_COURSE: function(d) { return "Current " + d.courseAlias; },
      IN_CURRENT_COURSE: function(d) { return "In Current " + d.courseAlias; },
    },

    TEAMS_AND_GROUPS: function() { return "Teams & Groups"; },
    PRACTICE: function() { return "Practice"; },
    SETTINGS: function() { return "Settings"; },
    UNREAD: function(numUnread: string) { return numUnread + " Unread"; },
    NAVIGATION_LABEL: function() { return "My Enrollments and Settings"; },
    OPEN_LHS: function() { return "Open My Enrollments and Settings Navigation"; },
    CLOSE_LHS: function() { return "Close My Enrollments and Settings Navigation"; },
    DOWNLOAD_USER_ENROLLMENT_DATA: function() { return "Download User and Enrollment Data"; },
    GO_TO_COURSE: function(courseName: string) { return "Go to " + courseName + " Home"; },
    OPEN_TEAM_WORKSPACE: function(teamName: string) { return "Open " + teamName + " Workspace"; },
    OPEN_IN_NEW_TAB: function() { return "Opens in new window"; },
    ANNOUNCEMENTS: {
      TITLE: function() { return "Announcements"; },
      NONE_YET: function() { return "There are no announcements for this course yet."; },
      TOTAL_AND_UNREAD: function(numTotal: string, numUnread: string) { return numTotal + " total, " + numUnread + " unread"; },
      NO_ANNOUNCEMENTS_YET: function() { return "No announcements yet."; },
    },

    NOTIFICATIONS: {
      YOUR_PRACTICES: function() { return "Your Practices"; },
      TITLE: function() { return "Notifications"; },
      NONE_YET: function() { return "There are no notifications for this course yet."; },
      UPDATES_ABOVE: function() { return "Updates Above"; },
      MARK_AS_READ: function() { return "Mark all as Read"; },
      NEW_ABOVE: function(numNew: string) { return numNew + " new above"; },
      NO_NOTIFICATIONS_YET: function() { return "No notifications yet."; },
      ADDED_MEMBER_TO_TEAM_BY_ADMIN: {
        SELF: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " added you to " + d.teamName + ". Go to " + d.teamAlias + " workspace to start collaborating."; },
        OTHERS: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " added " + d.objectFirstName + " " + d.objectLastName + " to " + d.teamName + "."; },
      },

      ADDED_MENTOR_TO_TEAM_BY_ADMIN: {
        SELF: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " added you to " + d.teamName + "."; },
        OTHERS: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " added " + d.objectFirstName + " " + d.objectLastName + " to " + d.teamName + "."; },
      },

      ADDED_TO_GROUP_BY_ADMIN: {
        SELF: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " added you to " + d.teamName + ". Go to " + d.groupAlias + " profile to start collaborating."; },
        OTHERS: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " added " + d.objectFirstName + " " + d.objectLastName + " to " + d.teamName + "."; },
      },

      EXERCISE_DUE_IN_24_HOURS: function(objectTitle: string) { return objectTitle + " is due in 24 hours and we have not received your submission."; },
      EXERCISE_SOFT_DUE_IN_24_HOURS: function(objectTitle: string) { return objectTitle + " has a soft deadline in 24 hours and we have not received your submission."; },
      GROUP_INVITATION_ACCEPTED: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " accepted your invitation to join your " + d.groupAlias + ", " + d.teamName + "."; },
      INCOMPLETE_PROFILE: function() { return "Welcome! Please fill out your profile so other participants can get to know you."; },
      MEETING_SCHEDULED: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " scheduled a meeting for " + d.time + "."; },
      MENTIONED_IN_DISCUSSION_COMMENT: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " mentioned you in a comment."; },
      MENTIONED_IN_DISCUSSION_POST: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " mentioned you in a comment."; },
      MENTIONED_IN_DISCUSSION_TOPIC: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " mentioned you in a post."; },
      MENTIONED_IN_SUBMISSION_COMMENT: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " mentioned you in a comment."; },
      MENTIONED_IN_SUBMISSION_POST: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " mentioned you in a comment."; },
      MENTIONED_IN_TEAM_PROFILE_COMMENT: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " mentioned you in a comment."; },
      MENTIONED_IN_TEAM_PROFILE_POST: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " mentioned you in a post."; },
      MENTIONED_IN_WORKSPACE: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " mentioned you in a message in your workspace."; },
      MENTIONED_IN_PRACTICE_SCENARIO: function(d) { return d.subject0FirstName + " has mentioned you on " + select(d.isObjectCurrentUser, { true: "your", other: d.objectFirstName + " " + d.objectLastName + "'s" }) + " practice for " + d.scenarioTitle; },
      NEW_COMMENT_FOR_FORUM_POST: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " replied to " + select(d.isObjectCurrentUser, { true: "your comment", other: "a comment you are following" }) + " on " + d.topicTitle + "."; },
      NEW_COMMENT_FOR_GROUP: {
        SELF: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " comm ented on your " + d.groupAlias + " post for " + d.teamName + "."; },
        OTHERS: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " commented on a post by " + d.objectFirstName + " " + d.objectLastName + " from " + d.teamName + "."; },
      },

      NEW_COMMENT_FOR_SUBMISSION: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " commented on " + d.objectTitle + "."; },
      NEW_COMMENT_FOR_SUBMISSION_POST: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " replied to " + select(d.isObjectCurrentUser, { true: "your comment", other: "a comment you are following" }) + " on " + d.ownerTitle + "."; },
      NEW_COMMENT_FOR_TEAM: {
        SELF: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " commented on your " + d.teamAlias + " post for " + d.teamName + "."; },
        OTHERS: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " commented on a post by " + d.objectFirstName + " " + d.objectLastName + " from " + d.teamName + "."; },
      },

      NEW_COMMENT_ON_PRACTICE_SUBMISSION: {
        ONE: function(d) { return d.subject0FirstName + " has left you a comment on your practice for " + d.scenarioTitle; },
        TWO: function(d) { return d.subject0FirstName + " and " + d.subject1FirstName + " have left you a comment on your practice for " + d.scenarioTitle; },
        THREE: function(d) { return d.subject0FirstName + ", " + d.subject1FirstName + ", and " + d.subject2FirstName + " have left you a comment on your practice for " + d.scenarioTitle; },
        MULTIPLE: function(newCommentsCount: number, read: string, scenarioTitle: string) { return "There are " + newCommentsCount + " " + select(read, { true: "", other: "new" }) + " comments on your practice for " + scenarioTitle; },
      },

      NEW_DOCUMENT_ON_WORKSPACE: {
        SINGLE: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " shared a document: " + d.documentName + " in " + d.teamName + " workspace."; },
        MULTIPLE: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " shared documents in " + d.teamName + " workspace."; },
      },

      NEW_MEETING_POLL: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " is polling your availability for " + d.objectTitle + "."; },
      NEW_POST_FOR_GROUP: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + ", " + plural(d.subjectCount, 0, en, { one: "member", other: "members" }) + " of " + d.objectName + ", posted on " + d.objectName + "'s profile."; },
      NEW_POST_FOR_SUBMISSION: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " commented on " + d.objectTitle + "."; },
      NEW_POST_FOR_TEAM_FOR_FOLLOWER: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + ", " + plural(d.subjectCount, 0, en, { one: "member", other: "members" }) + " of " + d.objectName + ", shared " + select(d.hasMultiplePosts, { true: "posts", other: "a post" }) + "."; },
      NEW_POST_FOR_TEAM_FOR_MEMBER: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + ", " + plural(d.subjectCount, 0, en, { one: "member", other: "members" }) + " of " + d.objectName + ", shared " + select(d.hasMultiplePosts, { true: "posts", other: "a post" }) + "."; },
      NEW_POST_FOR_TOPIC: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " commented on " + d.objectTitle; },
      NEW_REPLY_ON_FEEDBACK_REQUEST: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + ", " + plural(d.subjectCount, 0, en, { one: "posted a reply", other: "posted replies" }) + " on " + d.objectFirstName + " " + d.objectLastName + "'s feedback request."; },
      NEW_REPLY_ON_MENTOR_FEEDBACK: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + ", " + plural(d.subjectCount, 0, en, { one: "posted a reply", other: "posted replies" }) + " on " + d.objectFirstName + " " + d.objectLastName + "'s feedback."; },
      NEW_TOPIC_FOR_FORUM: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " created a post on " + d.forumTitle + "."; },
      NEW_PRACTICE_SKILLS_RATING_NOTIFICATION: function(objectFirstName: string, scenarioTitle: string) { return objectFirstName + " has left skills feedback for your practice submission in <b>" + scenarioTitle + "</b>"; },
      NEW_EXERCICE_SKILLS_RATING_NOTIFICATION: function(objectFirstName: string, objectTitle: string) { return objectFirstName + " has left skills feedback for your submission in " + objectTitle; },
      PAYMENT_DUE_IN_1DAY: function(d) { return "Payment for " + d.courseName + " is due in less than 24 hours. You will not be able to access the " + d.courseAlias + " after the payment deadline."; },
      PAYMENT_DUE_IN_5DAYS: function(courseName: string) { return "Your payment for " + courseName + " is due in less than 5 days."; },
      PEER_EVALUATIONS_DUE_IN_24_HOURS: function(objectTitle: string, targetGoal: number) { return "Peer evaluations for " + objectTitle + " are due in 24 hours. Please submit " + plural(targetGoal, 0, en, { one: "1 review", other: number("en", targetGoal, 0) + " reviews" }) + "."; },
      PEER_EVALUATIONS_OPEN: function(objectTitle: string, targetGoal: number) { return "Peer evaluations for " + objectTitle + " are in progress. Please submit " + plural(targetGoal, 0, en, { one: "1 review", other: number("en", targetGoal, 0) + " reviews" }) + "."; },
      PEER_REVIEW_RECEIVED: function(exerciseTitle: string, numPeerReviews: number) { return "You have received " + plural(numPeerReviews, 0, en, { one: "an evaluation", other: number("en", numPeerReviews, 0) + " evaluations from your peers" }) + " for " + exerciseTitle + "."; },
      REMOVED_FROM_GROUP_BY_ADMIN: function(d) { return d.subject0FirstName + " " + d.subject0LastName + " removed " + select(d.isObjectCurrentUser, { true: "you", other: d.objectFirstName + " " + d.objectLastName }) + " from " + d.teamName + "."; },
      REMOVED_MEMBER_FROM_TEAM_BY_ADMIN: {
        SELF: function(teamName: string) { return "You have been removed from " + teamName + " by an administrator."; },
        OTHERS: function(objectFirstName: string, objectLastName: string, teamName: string) { return objectFirstName + " " + objectLastName + " has been removed from " + teamName + " by an administrator."; },
      },

      REQUEST_TO_JOIN_GROUP_ACCEPTED: function(teamName: string) { return "Your request to join " + teamName + " was accepted."; },
      REQUEST_TO_JOIN_GROUP_REJECTED: function(teamName: string) { return "Your request to join " + teamName + " was declined."; },
      REQUEST_TO_JOIN_TEAM_ACCEPTED: function(teamName: string) { return "Your request to join " + teamName + " was accepted."; },
      REQUEST_TO_JOIN_TEAM_REJECTED: function(teamName: string) { return "Your request to join " + teamName + " was declined."; },
      REQUEST_TO_JOIN_GROUP: function(objectFirstName: string, objectLastName: string, teamName: string) { return objectFirstName + " " + objectLastName + " has requested to join " + teamName + "."; },
      SUBMISSIONS_VIEWABLE: function(objectTitle: string) { return "Submissions from " + objectTitle + " are now available for review. Explore and learn from your peers."; },
      SUBMISSION_ACCEPTED: function(exerciseTitle: string, hasComments: string) { return "Your submission for " + exerciseTitle + " has been approved " + select(hasComments, { true: "with comments.", other: "." }); },
      SUBMISSION_REJECTED: function(exerciseTitle: string) { return "Your submission for " + exerciseTitle + " has been sent back for revision. Please review feedback and revise."; },
      SUBMISSION_REJECTED_NOT_REVISABLE: function(exerciseTitle: string) { return "Your submission for " + exerciseTitle + " was not approved. Please review the feedback received."; },
      TEACHING_TEAM_REVIEW_RECEIVED: {
        SINGLE: function(d) { return "You have received an evaluation from " + d.teachingTeamNameDowncasedSingularized + " member " + d.subject0FirstName + " " + d.subject0LastName + " for " + d.exerciseTitle + "."; },
        MULTIPLE: function(d) { return d.teachingTeamNameCapitalizedSingularized + " members, " + plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + ", left you evaluations for " + d.exerciseTitle + "."; },
      },

      TEAM_INVITATION_ACCEPTED: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " accepted your invitation to join your " + d.teamAlias + ", " + d.teamName + "."; },
      TEAM_MEMBER_LEFT: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " left your " + d.teamAlias + ", " + d.teamName + "."; },
      TEAM_WORKSPACE_DOCUMENT_CREATED: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " shared a document: " + d.documentName + " in " + d.teamName + " workspace."; },
      TEAM_WORKSPACE_EXTERNAL_DOCUMENT_CREATED: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " shared a document: " + d.documentName + " in " + d.teamName + " workspace."; },
      TEAM_WORKSPACE_MEETING_CREATED: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " has created a meeting in " + d.teamName + " workspace."; },
      TEAM_WORKSPACE_MEETING_UPDATED: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " has changed the details for the meeting, " + d.meetingTitle + ", in " + d.teamName + " workspace."; },
      TEAM_WORKSPACE_POST_COMMENT_CREATED: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " commented in " + d.teamName + " workspace."; },
      TEAM_WORKSPACE_POST_COMMENT_REPLY_CREATED: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " replied to a comment you are following in " + d.teamName + " workspace."; },
      TEAM_WORKSPACE_POST_CREATED: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " posted " + plural(d.subjectCount, 0, en, { one: "a message", other: "messages" }) + " on " + d.teamName + "'s workspace."; },
      TEAM_WORKSPACE_POST: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " posted " + plural(d.subjectCount, 0, en, { one: "a message", other: "messages" }) + " on " + d.teamName + "'s workspace."; },
      TEAM_WORKSPACE_SUBMISSION_POST_CREATED: function(d) { return plural(d.subjectCount, 3, en, { "0": "", "1": d.subject0FirstName + " " + d.subject0LastName, "2": d.subject0FirstName + " " + d.subject0LastName + " and " + d.subject1FirstName + " " + d.subject1LastName, "3": d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", and " + d.subject2FirstName + " " + d.subject2LastName, one: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and 1 other", other: d.subject0FirstName + " " + d.subject0LastName + ", " + d.subject1FirstName + " " + d.subject1LastName + ", " + d.subject2FirstName + " " + d.subject2LastName + " and " + number("en", d.subjectCount, 3) + " others" }) + " shared a submission in " + d.teamName + " workspace."; },
      TIMED_QUIZ_RESULTS_RELEASED_WITH_POINTS: function(d) { return "Results are in! Congratulations, you have earned " + d.pointsReceived + " " + plural(d.pointsReceived, 0, en, { one: d.pointsAliasSingularized, other: d.pointsAliasPluralized }) + " for completing " + d.objectTitle + ". You may now view feedback on your responses."; },
      TIMED_QUIZ_RESULTS_RELEASED: function(objectTitle: string) { return "Results are in for " + objectTitle + "! You may now view feedback on your responses."; },
      TEAM_DISCUSSION_ACTIVITY_COMMENT: function(d) { return "Your teammates participated in the " + d.teamAlias + " discussion - " + d.teamTopicTitle + ". Join the discussion."; },
      TEAM_DISCUSSION_ACTIVITY_REPLY: function(d) { return "Your teammates participated in the " + d.teamAlias + " discussion - " + d.teamTopicTitle + ". Join the discussion."; },
      FEATURED_PRACTICE_SUBMISSION: {
        SELF: function(scenarioTitle: string) { return "Your practice submission has been featured in <b>" + scenarioTitle + "</b>"; },
        OTHERS: function(scenarioTitle: string) { return "A new practice submission has been featured in <b>" + scenarioTitle + "</b>"; },
      },

      VIEW_IT_NOW: function() { return "View it now"; },
    },

    INVITATIONS: {
      TITLE: function() { return "Invitations"; },
    },

    MESSAGES: {
      TITLE: function() { return "Messages"; },
      NONE_YET: function() { return "You have not received any messages yet."; },
      COMPOSE_NEW: function() { return "Compose a New Message"; },
    },

    CONTENT_SEARCH: {
      OPEN_BUTTON_LABEL: function() { return "Search"; },
      CLEAR_INPUT: function() { return "Clear"; },
      LOADING_RESULT_TEXT: function() { return "Loading Search Results..."; },
      SEARCH_RESULTS_TOP_LABEL: function(count: number) { return "Search Results (" + count + ")"; },
      SEARCH_CONTENT_INPUT_PLACEHOLDER: function() { return "Search Content..."; },
      CURRENT_COURSE: function(d) { return "Current " + d.CourseAlias; },
      ALL_COURSES: function() { return "All Learning"; },
      I_WANT_TO_SEARCH_IN: function() { return "I want to search in:"; },
      RECENT_SEARCH: function() { return "Recent Search:"; },
      END_OF_RESULTS: function() { return "End of the Search Results"; },
      RESULTS_NOT_FOUND: function() { return "No Results Found"; },
      INVALID_SEARCH: function() { return "Minimum search length is 3 characters"; },
    },

    BOOKMARKS: {
      NOTE: function() { return "Note"; },
      OPEN_BUTTON_LABEL: function() { return "Bookmarks"; },
      EDIT_NOTE_ARIA_LABEL: function() { return "Click to edit bookmark note"; },
      NOTE_EDITOR_ARIA_LABEL: function() { return "Bookmark note"; },
      ADD_THOUGHTS_ARIA_LABEL: function() { return "Click to add your thoughts"; },
      TOGGLE: function() { return "Click to toggle"; },
      DISCUSSION_SNIPPET: function() { return "Discussion Snippet"; },
      SUBMISSION_SNIPPET: function() { return "Submission Snippet"; },
      LECTURE_PAGE_SNIPPET: function() { return "Lecture Page Snippet"; },
      IMAGE_SNIPPET: function() { return "Image Snippet"; },
      VIDEO_SNIPPET: function() { return "Video Snippet"; },
      ATTACHMENT_SNIPPET: function() { return "Attachment Snippet"; },
      AUDIO_SNIPPET: function() { return "Audio Snippet"; },
      COMMENT_REPLY_SNIPPET: function() { return "Comment reply Snippet"; },
      UNHIGHLIGHT: function() { return "Click to unhighlight"; },
      NO_NOTES: {
        GENERAL: function() { return "You can save content you've found useful by clicking the bookmark icon near the content. You will find all of your bookmarks here."; },
        ADDITIONAL: function() { return "Click the note icon to create notes."; },
        COURSE: function(d) { return "No bookmarks or notes for this " + d.courseAlias + "."; },
      },

      CREATE_NEW_NOTE: function() { return "Create New Note"; },
      ALL_BOOKMARKS: function() { return "All Bookmarks & Notes"; },
      SELECT_FROM_DIFFERENT_COURSES: function() { return "Select bookmarks Under Courses"; },
      ACTIVE_COURSES: function() { return "Active Courses"; },
      CLOSED_COURSES: function() { return "Closed Courses"; },
      ADD_YOUR_THOUGHTS: function() { return "Add your thoughts"; },
      DELETE_BOOKMARK: function() { return "Delete this bookmark?"; },
      DELETE_NOTE: function() { return "Delete this note?"; },
      SHOW_ALL: function() { return "Show All Bookmarks/Notes in this Course"; },
      SHOW_MORE: function() { return "Show More"; },
      SHOW_LESS: function() { return "Show less"; },
      UNSAVED_NOTE: function() { return "You have an unsaved note"; },
      ADD_BOOKMARK: {
        ADD: function() { return "Add Bookmark"; },
        LESSON: function(d) { return "Add Bookmark for " + d.lectureAlias; },
      },

      OPEN_BOOKMARK: function() { return "Open Bookmark"; },
      SNIPPET_TITLE: {
        TEAM_WORKSPACE_POST: function(isGroup: string) { return select(isGroup, { true: "Group", other: "Team" }) + " Workspace Post"; },
        SUBMITTING_ON_BEHALF: function(d) { return select(d.isRevise, { true: "Revising", other: "Submitting" }) + " on behalf of the " + d.teamAlias + "."; },
        COMMENT: function(commentOwner: string) { return "Comment from " + commentOwner; },
        REPLY: function(replyOwner: string) { return "Reply from " + replyOwner; },
        IMAGE: function() { return "Image"; },
      },

      NO_CONTENT: function() { return "The content has been deleted."; },
      EXPIRED: function() { return "The link is expired"; },
    },

    ALL: function() { return "All"; },
    VIEW_ALL_MESSAGES: function() { return "View All Messages"; },
    OTHER_COURSES: function() { return "Other Courses"; },
    OTHER_PROGRAMS: function() { return "Other Programs"; },
    OTHER_COURSES_AND_PROGRAMS: function() { return "Other Courses and Programs"; },
    CURRENT_COURSE: function() { return "Current Course"; },
    X_MORE: function(count: number) { return "+ " + count + " more"; },
    X_LESS: function(count: number) { return "+ " + count + " less"; },
    ACCOUNT_MENU: {
      DASHBOARD_FOR: function() { return "Dashboard for"; },
      ORG_ADMIN: function() { return "Org Dashboard"; },
      LEARNER: function() { return "Learner"; },
      ORG_ADMIN_DASHBOARD: function() { return "Org Admin Dashboard"; },
      MY_DASHBOARD: function() { return "My Dashboard"; },
      PROFILE: function() { return "Profile"; },
      ACCOUNT_SETTINGS: function() { return "Account Settings"; },
      LANGUAGE: {
        TITLE: function() { return "Language and Time Zone"; },
        PREFERENCE: function() { return "Language Preference"; },
        DROPDOWN_TEXT: function() { return "Your selection will be applied automatically upon selecting an option from this language Preference menu"; },
        INFO_TEXT: function() { return "The selected language will be used in the NovoEd platform user interface and notification emails."; },
      },

      SWITCH_INSTITUTIONS: function() { return "Switch Institutions"; },
      PRIVACY_POLICY: {
        TITLE: function() { return "Privacy Policy"; },
        NOVOED_DESCRIPTION: function(privacyPolicyLink: string) { return "Here at NovoEd, we appreciate the fact that you are taking the time to learn on our platform and want to provide the best experience possible, which includes ensuring your right to privacy and security of your data. If you are taking a course offered through another organization, your relationship may be primarily with that organization. That organization will serve as the the data controller for your personal data with NovoEd acting as a processor of your personal data. Requests related to your personal data should go to the organization providing your course first. NovoEd will at all times adhere to our privacy policy no matter what our relationship is with you. You may access NovoEd's full privacy policy at " + privacyPolicyLink + "."; },
        INSTITUTION_TITLE: function(institutionName: string) { return institutionName + "'s Privacy Policy"; },
        ALERT: {
          NOTE: function() { return "Please note:"; },
          COOKIES_1: function(cookieLink: string, privacyLink: string, tosLink: string) { return "Please review NovoEd's <a href=\"" + privacyLink + "\" target=\"_blank\" style=\"color: #0E72ED\">Privacy Policy</a> and <a href=\"" + tosLink + "\" target=\"_blank\" style=\"color: #0E72ED\">Terms of Service</a>. NovoEd uses cookies to provide you with the best experience. By continuing to use the site you consent to store cookies as described in our <a href=\"" + cookieLink + "\" target=\"_blank\" style=\"color: #0E72ED\">Cookie Policy</a>.\n"; },
          PRIVACY_UPDATED: function() { return "Please review our updated privacy policy."; },
          LEARN_MORE: function() { return "Learn more"; },
        },

      },

      SIGN_OUT: function() { return "Sign out"; },
    },

    SETTINGS_ARIA_LABEL: function() { return "Announcements"; },
    NOTIFICATIONS_ARIA_LABEL: function() { return "Notifications"; },
    MESSAGES_ARIA_LABEL: function() { return "Messages"; },
    INVITATION_ARIA_LABEL: function() { return "Invitations"; },
    PRACTICE_ROOM: function() { return "Your Practice Scenarios"; },
  },

  COURSE_HOME: {
    HEADER: {
      COURSE_HOME: function() { return "Course Home"; },
      RESOURCES: function() { return "Resources"; },
      PROGRAM_NONALIAS_HOME: function() { return "Program Home"; },
      PROGRAM_HOME: function(d) { return d.programAlias + " Home"; },
      EDIT_OUTLINE: function() { return "Edit Outline"; },
      DASHBOARD: function() { return "Dashboard"; },
      GALLERY: function() { return "Gallery"; },
      GALLERY_MENU: {
        AI_ROLEPLAYS: function() { return "Roleplays"; },
        ASSIGNMENTS: function() { return "Assignments"; },
        VIDEO_PRACTICE: function() { return "Practices"; },
      },

      DISCUSSION: function() { return "Discussion"; },
      LEADERBOARD: function() { return "Leaderboard"; },
      COMMUNITY: function() { return "Community"; },
      CHATTER: function() { return "Chatter from Courses"; },
      HELP: function() { return "Help"; },
      MORE: function() { return "More"; },
      CLICK_TO_SHOW_MORE_OPTIONS: function() { return "Click to show more options"; },
      ASSIGNMENTS_AND_LECTURES: function() { return "Activities and Resources"; },
      COURSES_IN_THIS_PROGRAM: function(offeringName: string, programCoursesName: string) { return programCoursesName + " in this " + offeringName; },
      OTHER_COURSES_IN_THIS_PROGRAM: function(offeringName: string, programCoursesName: string) { return "Other " + programCoursesName + " in this " + offeringName; },
      MY_COURSE: function(offeringName: string) { return "My " + offeringName; },
      COURSE_ACCESS_DENIED: function() { return "You do not have access to this experience."; },
    },

    LANGUAGE: {
      TITLE: function(d) { return d.CourseAlias + " Language Settings"; },
      USERS_PREFERENCE_LANGUAGE: function() { return "Set New User's Preferred Language"; },
      DESCRIPTION: function() { return "New users enrolled in the course will see the platform and receive system emails in this language. Existing users keep their current language settings. If your course language isn't supported, we recommend keeping this set to English."; },
      SUCCESS: function(language: string) { return "Your course language has been set to " + language + "."; },
      ENABLE_TRANSLATION_SUCCESS: function(d) { return "You have successfully turned on AI translation for this " + d.courseAlias + "."; },
      DISABLE_TRANSLATION_SUCCESS: function(d) { return "You have successfully turned off AI translation for this " + d.courseAlias + "."; },
      ENABLE_AI_TRANSLATION: function() { return "Enable AI Translation"; },
      ENABLE_WARNING: function() { return "Please enable AI Translations for the organization in order to use this function."; },
      AUTOMATED_TRANSLATION_DESCRIPTION: function(d) { return "NovoEd uses AI to translate " + d.courseAlias + " content, allowing users to view it in their preferred language. By enabling this setting, you can instantly offer the " + d.courseAlias + " in multiple languages. Admins also have the option to review and edit AI-generated translations to ensure accuracy."; },
      AUTOMATED_TRANSLATION_NOTE: function(d) { return "Please note: we recommend making translation edits after finalizing the " + d.courseAlias + " content."; },
      AUTOMATED_TRANSLATION_SWITCH_LABEL: function(d) { return "Enable AI Translation for this " + d.courseAlias; },
      ORIGINAL_CONTENT_LANGUAGE_NOTE: function() { return "<b>Please note:</b> Original content language is detected based on the first lesson with enough content. This is used to allow learners to revert back to original content."; },
      DETECTING_LANGUAGE_ERROR: function() { return "We ran into an error setting the appropriate language for platform UI and it has been set to English. You can update it in your account settings."; },
    },

    ARCHIVE_MODE: {
      BODY: function(d) { return "Your access to " + d.courseAlias + " content for " + d.courseName + " has ended."; },
    },

    STATEMENT_OF_ACCOMPLISHMENT: {
      HEADER: function() { return "Congratulations!"; },
      CREDENTIAL_BODY: function(d) { return "You have earned " + select(d.selectCase, { credlyAndSoa: "a <a href=\"" + d.credlyLink + "\" target=\"_blank\" data-qa=\"credly-badge-url\">Credly Badge</a> and a <a href=\"" + d.soaLink + "\" data-qa=\"soa-url\">" + d.soaText + "</a>", credly: "a <a href=\"" + d.credlyLink + "\" target=\"_blank\" data-qa=\"credly-badge-url\">Credly Badge</a>", accredibleAndSoa: "<a href=\"" + d.accredibleLink + "\" target=\"_blank\" data-qa=\"accredible-badge-url\">Accredible Credentials</a> and a <a href=\"" + d.soaLink + "\" data-qa=\"soa-url\">" + d.soaText + "</a>", accredible: "<a href=\"" + d.accredibleLink + "\" target=\"_blank\" data-qa=\"accredible-badge-url\">Accredible Credentials</a>", soa: "<a href=\"" + d.soaLink + "\" data-qa=\"soa-url\">" + d.soaText + "</a>", other: "" }) + " for this " + d.courseAlias + "."; },
      NEED_PAYMENT_BODY: function(d) { return "Make payment to view your " + d.statementNameAlias + "."; },
    },

    EXPAND: function() { return "Expand"; },
    EXPAND_ALL: function() { return "Expand All"; },
    COLLAPSE: function() { return "Collapse"; },
    WELCOME: function() { return "Welcome"; },
    CALENDAR: function() { return "Calendar"; },
    RHS: {
      ACTIVE_COMMUNITY: function(d) { return "Active in this " + d.communityAlias; },
      TEAMS_TO_EXPLORE: function(d) { return d.TeamsTitleAlias + " to Explore"; },
      TRENDING_POSTS: function() { return "Trending Posts"; },
      GROUPS_TO_EXPLORE: function(d) { return d.groupAlias + " to Explore"; },
      NUM_RECENT_POSTS_PLURAL: function(numPosts: string) { return numPosts + " Recent Posts"; },
      NUM_RECENT_POSTS_SINGULAR: function(numPosts: string) { return numPosts + " Recent Post"; },
      ACTIVITY_FEED: function() { return "Activity Feed"; },
      ACTIVITY_FEED_EXERCISE: function(title: string) { return "submitted " + title; },
      ACTIVITY_FEED_LECTUREPAGE: function(title: string) { return "viewed " + title; },
      ACTIVITY_FEED_QUIZ: function(title: string) { return "took " + title; },
      ACTIVITY_FEED_POLL: function(title: string) { return "participated in " + title; },
      ACTIVITY_FEED_QUESTIONSET: function(title: string) { return "took " + title; },
      ACTIVITY_FEED_EXTERNALTOOLQUIZ: function(title: string) { return "took " + title; },
      ACTIVITY_FEED_VIDEOQUIZ: function(title: string) { return "took " + title; },
      ACTIVITY_FEED_SURVEY: function(title: string) { return "submitted " + title; },
      ACTIVITY_FEED_LECTUREVIDEO: function(title: string) { return "reviewed " + title; },
      ACTIVITY_FEED_CUSTOMQUESTIONS: function(title: string) { return "provided feedback for " + title; },
      LOADING: function() { return "Loading..."; },
      COURSE_HAS_CONCLUDED: function() { return "Your course has concluded!"; },
      NO_ONE_ACTIVE_LATELY: function() { return "No one has been active lately."; },
      EARLY_BIRD: function() { return "You are an early bird!"; },
      ACTIVIES_WILL_SHOW_LATER: function(d) { return "Activities from your " + d.courseAlias + " will be shown as more " + d.learnersAlias + " join."; },
      YOU: function() { return "You"; },
      LOAD_MORE: function() { return "Load more"; },
      RIGHT_SIDEBAR: function() { return "Right Sidebar"; },
    },

  },

  INVITES_AND_REQUESTS: {
    NOTIFICATION_MENU_NAME: function() { return "Invitations and Requests"; },
    REQUEST_TO_JOIN_TEAM_NAME: function(teamName: string) { return "Request to Join " + teamName; },
    WITHDRAW_REQUEST_CONFIRMATION: function(teamName: string) { return "Are you sure you want to withdraw your request to join " + teamName + "?"; },
    DELETE_REQUEST: function() { return "Delete Request"; },
    ERROR: {
      INVALID_REQUEST: function() { return "Request is no longer valid."; },
      INVALID_INVITATION: function() { return "Invitation is no longer valid."; },
      NO_REQUESTS_OR_INVITES: function() { return "There are no invitations or requests here."; },
      WILL_RECEIVE_WHEN_IN_COURSE: function() { return "You will start receiving team invitations once you are enrolled in a course."; },
    },

  },

  TIMELINE: {
    NO_CONTENT: function() { return "No Content Yet"; },
    GET_STARTED: function(d) { return "Get started building your " + d.courseAlias; },
    ADD_CONTENT: function() { return "Add Content"; },
    PRESET: {
      COURSE_OUTLINE_PRESETS: function() { return "Course Outline Presets"; },
      START_FROM_PRESET: function() { return "Start from a preset"; },
      VIEW_PRESETS: function() { return "View Presets"; },
      THREE_LAYER_STRUCTURE: function() { return "3 Layer Structure"; },
      TWO_LAYER_COLLAPSIBLE_STRUCTURE: function() { return "2 Layer Collapsible Structure"; },
      TWO_LAYER_NON_COLLAPSIBLE_STRUCTURE: function() { return "2 Layer Non-Collapsible Structure"; },
      SECTION_SS_LESSONS: function(d) { return "Section, Subsection & " + d.lectureAlias; },
      SS_AND_LESSONS: function(d) { return "Subsection & " + d.lectureAlias; },
      SECTION_AND_LESSONS: function(d) { return "Section & " + d.lectureAlias; },
      SELECT_PRESET_ONE: function() { return "Select Preset 1"; },
      SELECT_PRESET_TWO: function() { return "Select Preset 2"; },
      SELECT_PRESET_THREE: function() { return "Select Preset 3"; },
    },

    EXERCISE_STATUS: {
      IN_PROGRESS: function() { return "In Progress"; },
      PENDING: function() { return "Pending"; },
      SUBMITTED: function() { return "Submitted"; },
      COMPLETED: function() { return "Completed"; },
      MISSED: function() { return "Missed"; },
      PAST_DUE: function() { return "Past Due"; },
      DRAFT: function() { return "Draft"; },
      WATCHED: function() { return "Watched"; },
      LISTENED: function() { return "Listened"; },
      NOT_STARTED: function() { return "Not Started"; },
      CONCLUDED: function() { return "Concluded"; },
      ATTENDED: function() { return "Attended"; },
    },

    EXERCISE_DUE: {
      DUE: function() { return "Due:"; },
      DUE_IN_MINUTES: function(count: number) { return "Due in " + plural(count, 0, en, { one: "1 minute", other: number("en", count, 0) + " minutes" }); },
      DUE_IN_HOURS: function(count: number) { return "Due in " + plural(count, 0, en, { one: "1 hour", other: number("en", count, 0) + " hours" }); },
      DUE_IN_DAYS: function(count: number) { return "Due in " + plural(count, 0, en, { one: "1 day", other: number("en", count, 0) + " days" }); },
      REVISE_IN_MINUTES: function(count: number) { return plural(count, 0, en, { one: "1 minute", other: number("en", count, 0) + " minutes" }) + " left to revise"; },
      REVISE_IN_HOURS: function(count: number) { return plural(count, 0, en, { one: "1 hour", other: number("en", count, 0) + " hours" }) + " left to revise"; },
      REVISE_IN_DAYS: function(count: number) { return plural(count, 0, en, { one: "1 day", other: number("en", count, 0) + " days" }) + " left to revise"; },
      SUGGESTED_DUE: function() { return "Suggested deadline:"; },
      SUBMITTED_WITH_DUE_DATE: function() { return "Submitted | Due in"; },
    },

    LINK_LESSON_POPOVER: {
      COLLECTION: function() { return "Collection:"; },
      LAST_EDITOR: function() { return "Last Edited By:"; },
      LAST_EDITED_ON: function() { return "Last Edited On:"; },
      CREATOR: function() { return "Created By:"; },
      CREATED_ON: function() { return "Created On:"; },
    },

    DUE_DEADLINE: function(deadline: string) { return "Due: " + deadline; },
    DISCUSSION_TITLE: function(title: string) { return "Discuss " + title; },
    PEER_EVALUATION_PERIOD: function() { return "Evaluation Period:"; },
    START_LEARNING: function() { return "Start Learning"; },
    RESUME_LEARNING: function() { return "Resume Learning"; },
    START_LEARNING_POPOVER: function(d) { return "First " + d.lectureAlias + ": " + d.lectureName; },
    RESUME_LEARNING_POPOVER: function(d) { return "Last Visited " + d.lectureAlias + ": " + d.lectureName; },
    COURSE_OUTLINE: function(d) { return d.courseAlias + " Outline"; },
    COURSE_TIMELINE_HEADER: function(d) { return d.courseAlias + " timeline header"; },
    RELEASE_DATE: function(releasedate: string) { return "(Release Date: " + releasedate + ")"; },
    TODOS: function() { return "To-dos"; },
    POINTS_EARNED: function(d) { return d.PointsAlias + " Earned"; },
    EARNED: function() { return "Earned"; },
    NO_TODOS: function() { return "No To-dos Yet"; },
    TODOS_MISSED: function() { return "Missed"; },
    COMPLETED: function() { return "Completed"; },
    IN_PROGRESS: function() { return "IN PROGRESS"; },
    LAST_VISITED: function() { return "Last Visited"; },
    IN_PROGRESS_TOOLTIP: function() { return "In Progress..."; },
    COURSE_RECONNECT_MESSAGE: function(d) { return "Reconnected to the Internet. Updating " + d.courseAlias + " outline now..."; },
    GENERIC_RECONNECT_MESSAGE: function() { return "Reconnected to the Internet. Updating now..."; },
    PROGRESS_FOR_USER: function(userName: string) { return "Progress for " + userName; },
    LOADING: function() { return "Loading..."; },
    LECTURE_QUIZ_TITLE: function(ownerTitle: string, titleIndex: string) { return "Quiz #" + titleIndex + " in " + ownerTitle; },
    UNRELEASED: function() { return "Unreleased"; },
    VIEW_ACTIVITIES: function() { return "View Activities"; },
    HIDE_ACTIVITIES: function() { return "Hide Activities"; },
    EDIT_OUTLINE: function() { return "Edit Outline"; },
    EDIT_ACTIVITIES_AND_RESOURCES: function() { return "Edit Resources"; },
    DELETE: function() { return "Delete"; },
    EMPTY: function() { return "Empty"; },
    NEW_SECTION_AND_SUBSECTION: function() { return "New Section or New Subsection"; },
    NEW_SUBSECTION: function() { return "New Subsection"; },
    NEW_LECTURE: function() { return "New Lecture"; },
    NEW_LESSON: function(d) { return "Add New " + d.lectureAlias; },
    NEW_LESSON_FROM_LIBRARY: function() { return "Add from Lesson Library"; },
    SECTION: function() { return "Section"; },
    SUBSECTION: function() { return "Subsection"; },
    ADDING: function() { return "Adding..."; },
    ADD_NEW_LESSON: function(d) { return "Add New " + d.lectureAlias; },
    ADD_SUBSECTION_OR_LESSON: function(d) { return "Add Subsection or " + d.lectureAlias; },
    UPDATE_ALL_ACTIVITY_DEADLINES: function() { return "Update all Activity Deadlines"; },
    NEW_DEADLINE_FOR_FOLLOWING_ACTIVITIES: function() { return "New Deadline for following activities:"; },
    CHANGE_RELEASE_DATE_TO: function(d) { return "For the following " + d.lectureAlias + ", change release date to"; },
    UPDATE_ALL: function() { return "Update All"; },
    CLICK_TO_EDIT: function() { return "Click to Edit"; },
    UNLINKED_LESSON_CARD_IMG_TOOLTIP: function() { return "Click to select an image"; },
    LINKED_LESSON_CARD_IMG_TOOLTIP: function() { return "Select an image from collection"; },
    MORE_OPTIONS: function() { return "More Options"; },
    LESSON_LINK_MODAL: {
      TITLE: function() { return "Select from Collection"; },
      DESCRIPTION: function(d) { return "Select a " + d.lectureAlias + " from the lesson library to be used in this " + d.courseAlias + ". Once added, updates done from the lesson library will reflect on this " + d.lectureAlias + "."; },
      LESSON_POPOVER: {
        LAST_EDITOR: function() { return "Last Edited By: "; },
        LAST_EDITED_ON: function() { return "Last Edited On: "; },
        CREATOR: function() { return "Created By: "; },
        CREATED_ON: function() { return "Created On: "; },
        LINKED_LESSONS: function(d) { return "Number of Linked " + d.LecturesAlias + ": "; },
        PREVIEW_LESSON: function(d) { return "Preview " + d.LectureAlias + " page"; },
      },

      SUCCESS_ALERT: {
        MESSAGE: function(d) { return "Adding " + d.lectureAlias + " from the library will take a few minutes to link to the " + d.courseAlias + "."; },
      },

    },

    ADD_TO_COLLECTION_MODAL: {
      DESCRIPTION: function(d) { return "Select a collection and folder from the Lesson Library to add the " + d.lectureAlias + "."; },
      SUCCESS_ALERT_MSG: function(collectionName: string, lessonName: string) { return lessonName + " is successfully Added to Collection " + collectionName; },
    },

    ADD_TO_COLLECTION_WARNING_MODAL: {
      SC_TITLE: function(d) { return d.lectureAlias + " will not be added to the Library"; },
      SC_DESCRIPTION_1: function() { return "The Submission Carousel has an attached Assignment, where the lesson contains components not supported by the Lesson Library yet. To add both lessons, make sure they both contain components supported by the Library."; },
      TITLE: function(d) { return "This " + d.lectureAlias + " has components that cannot be converted to the Library at this time."; },
      DESCRIPTION_1: function() { return "The Lesson Library supports the following activities today:"; },
      DESCRIPTION_NOT_SUPPORTED_TEXT: function() { return "The Lesson Library does not support the following activities today:"; },
      DESCRIPTION_2: function() { return "Additional activities will be supported soon."; },
      CONTENT: function() { return "Content"; },
      VIDEO: function() { return "Video"; },
      AUDIO: function() { return "Audio"; },
      INDIVIDUAL_ASSIGNMENT: function() { return "Individual Assignment"; },
      COURSE_DISCUSSION: function() { return "Course-Wide Discussion"; },
      THIRD_PARTY_LINKS_AND_TOOLS: function() { return "Third Party Links & Tools"; },
      QUIZ: function() { return "Quiz"; },
      SURVEY: function() { return "Survey"; },
      TIMED_QUIZ: function() { return "Timed Exam"; },
      POLL: function() { return "Poll"; },
      VIDEO_PRACTICE: function() { return "Video Practice"; },
      VIDEO_WITH_DISCUSSION: function() { return "Video with Discussion"; },
      TEAM_FORMATION: function() { return "Team Formation"; },
      GROUP_FORMATION: function() { return "Group Formation"; },
      ASSIGNMENT_FEEDBACK: function() { return "Assignment Feedback"; },
      PRACTICE_FEEDBACK: function() { return "Practice Feedback"; },
      GOT_IT: function() { return "Got it"; },
    },

    UNRELEASE_LESSON: {
      ARE_YOU_SURE: function(d) { return "Are you sure you want to unrelease this " + d.lectureAlias + ":"; },
      DELETE_ALL_ASSIGNMENTS: function(d) { return "This will delete all " + d.learnerAlias + " " + d.assignmentAlias + " submissions, quiz or survey responses, timed exams submissions, and remove any " + d.pointsAlias + " earned by learners."; },
      BULK_DELETE_ALL_ASSIGNMENTS: function(d) { return "This will delete all " + d.learnerAlias + " " + d.assignmentAlias + " submissions, quiz or survey responses, timed exams submissions, and remove any " + d.pointsAlias + " earned by learners on these lessons."; },
      ACTION_IS_FINAL: function(d) { return "This action is final and cannot be undone. Are you sure you want to unrelease this " + d.lectureAlias + " and delete submissions and " + d.pointsAlias + " earned?"; },
      BULK_ACTION_IS_FINAL: function(d) { return "This action is final and cannot be undone. Are you sure you want to update release dates and unrelease these " + d.lecturesAlias + ", deleting submissions and " + d.pointsAlias + " earned?"; },
    },

    DELETE_LESSON: {
      ARE_YOU_SURE: function(d) { return "Are you sure you want to delete the following " + d.lectureAlias + ":"; },
      ARE_YOU_SURE_LECTURE_NAME: function(d) { return "Are you sure you want to delete the following " + d.lectureAlias + ":<br/>" + d.lectureName; },
      DELETE_ALL_SUBMISSIONS: function(d) { return "This will delete all " + d.learnerAlias + " " + d.assignmentAlias + " submissions and remove any " + d.pointsAlias + " earned by " + d.learnersAlias + ". Any automated communications based on this " + d.lectureAlias + " and its activities will also be deleted. This action is final and cannot be undone.<br/><br/>Are you sure?"; },
      SUCCESS_ALERT: function(lectureName: string) { return lectureName + " has been deleted."; },
    },

    DELETE_COLLECTION_FOLDER: {
      TITLE: function() { return "Are you sure you want to delete this folder?"; },
      DESCRIPTION: function() { return "After deleting this folder and the lessons will be removed from the collection."; },
    },

    DELETE_COLLECTION_LESSON: {
      TITLE: function() { return "Are you sure you want to delete the lesson?"; },
      DESCRIPTION: function() { return "After deleting, this lesson will be removed from the collection."; },
    },

    UNLINK: {
      ARE_YOU_SURE: function(d) { return "Are you sure you want to unlink this " + d.lectureAlias + "?"; },
      DESCRIPTION: function(d) { return "After unlinking, the " + d.lectureAlias + " page will no longer receive updates pushed from the Lesson Library."; },
      FOOTER_NOTE: function() { return "*At this time, unlinking is permanent."; },
      SUCCESS_ALERT: function(lectureName: string) { return lectureName + " is no longer linked to the collection."; },
    },

    DELETE_SECTION: {
      LECTURE_SECTION_TITLE: function() { return "Are you sure you want to delete the entire section:"; },
      SUBSECTION_TITLE: function() { return "Are you sure you want to delete the entire subsection:"; },
      DESCRIPTION: function() { return "WARNING: this cannot be undone. To proceed, please check to confirm the following:"; },
      LESSON: function(d) { return plural(d.count, 0, en, { one: "1 " + d.lectureAlias, other: number("en", d.count, 0) + " " + d.lecturesAlias }) + " will be permanently deleted!"; },
      SUBMISSION: function(d) { return "Any submissions and points earned by " + d.learnersAlias + " on this " + d.lectureAlias + " will be removed!"; },
      COMMUNICATION: function(d) { return "Any automated communications based on " + d.lecturesAlias + " and its activities will be deleted!"; },
      CONFIRMATION: function() { return "Yes, Delete All"; },
    },

    NEW_EMPTY_LESSONS_ADDED: function() { return "New Empty Lessons Added"; },
    NEW_EMPTY_LESSONS_DESCRIPTION: function(d) { return "You just added some lessons to the " + d.courseAlias + ", we have made the default release date to a future date so your " + d.learnersAlias + " won't see them while you're adding content to them."; },
    COURSE_OUTLINE_UPDATED: function() { return "The course outline has been updated"; },
    COPY_IN_PROGRESS: function() { return "Copying in progress..."; },
    LINK_IN_PROGRESS: function() { return "Linking in progress..."; },
    COPY_SUCCESS: function(d) { return "<b>Success! " + d.contentName + "</b> has been copied successfully! Please go to course <b>" + d.courseName + "</b> and refresh the " + d.courseAlias + " outline."; },
    COPY_PARTIAL_SUCCESS: function(d) { return "Oops! There were some errors while copying <b>" + d.contentName + "</b> to <b>" + d.courseName + "</b>. Please check the " + d.courseAlias + " and try again."; },
    COPY_FAILURE: function(contentName: string, courseName: string) { return "Oops! <b>" + contentName + "</b> failed to copy to <b>" + courseName + "</b>. Please try again!"; },
    SIZE_LIMIT_REACHED: function(size: string) { return "<b>Oops!</b> File size is over limit of " + size + " mb, please choose a smaller file and try again!"; },
    COPY_BACKGROUND: function(contentName: string, courseName: string) { return "Copying <b>" + contentName + "</b> to <b>" + courseName + "</b> will take a few minutes. You will receive an email when copying is complete."; },
    COPY_HERE: function() { return "Copy Here"; },
    TIMELINE_ERROR: function() { return "Something went wrong! Please try again to load to the outline."; },
    RELOAD: function() { return "Reload"; },
    RETRY: function() { return "Retry"; },
    PICK_LOCATION: {
      SECTION: function() { return "Pick a Location to Copy the Section"; },
      SUBSECTION: function() { return "Pick a Location to Copy the Subsection"; },
      LESSON: function() { return "Pick a Location to Copy the Lesson"; },
    },

    DESCRIPTION: {
      SECTION: function() { return "Please pick a location on the target course outline for the section you want to copy. You can insert them between sections, to the top or bottom of the course outline. (Note: Sections cannot be inserted in between lessons or subsections)"; },
      SUBSECTION: function() { return "Please pick a location on the target course outline for the subsection you want to copy. You can insert them between subsections, add to existing sections, or create new section for the subsection. (Note: Subsections cannot be inserted in between lessons)"; },
      LESSON: function() { return "Please pick a location on the target course outline for the lesson you want to copy. You can insert them between lessons, add to existing sections and subsections (if there's any), or create a new section or subsection for the lesson"; },
    },

    FUTURE_OFFERINGS: function() { return "Future Offerings"; },
    OPEN_OFFERINGS: function() { return "Open Offerings"; },
    DEMO_OFFERINGS: function() { return "Demo Offerings"; },
    COPY_TO_ANOTHER_OFFERING: function() { return "Copy to Another Offering"; },
    COPY_TO_LAST_SELECTED: function() { return "Copy to Last Selected Offering:"; },
    NEW_SECTION_AND_SUBSECTION_COPY: function() { return "Copy to a New Section or New Subsection"; },
    NEW_SECTION_COPY: function() { return "Copy to a New Section"; },
    SECTION_OPTIONS: {
      REMOVE_SECTION_TITLE: function() { return "Remove Section Title"; },
      COPY_SECTION: function() { return "Copy Section"; },
      UPDATE_ALL_RELEASE_DATES: function() { return "Update All Release Dates in this Section"; },
      UPDATE_ALL_DEADLINES: function() { return "Update All Deadlines in this Section"; },
      ADD_LESSONS_IN_SECTION_TO_LESSON_LIBRARY: function(d) { return "Add All " + d.lectureAlias + " in this Section to Lesson Library"; },
    },

    SUBSECTION_OPTIONS: {
      REMOVE_SUBSECTION_TITLE: function() { return "Remove Subsection Title"; },
      COPY_SUBSECTION: function() { return "Copy Subsection"; },
      UPDATE_ALL_RELEASE_DATES: function() { return "Update All Release Dates in this Subsection"; },
      UPDATE_ALL_DEADLINES: function() { return "Update All Deadlines in this Subsection"; },
      ADD_LESSONS_IN_SUBSECTION_TO_LESSON_LIBRARY: function(d) { return "Add All " + d.lectureAlias + " in this Subsection to Lesson Library"; },
    },

    LESSON_OPTIONS: {
      EDIT_LESSON: function() { return "Edit Lesson"; },
      COPY: function() { return "Copy"; },
      UNLINK_FROM_COLLECTION: function() { return "Unlink from collection"; },
      ADD_TO_COLLECTION: function() { return "Add to Lesson Library"; },
      UPDATE_ALL_DEADLINE: function() { return "Update All Deadlines on this Lesson"; },
    },

    ACTIVITY_OPTIONS: {
      GO_TO_ACTIVITY: function() { return "Go To Activity"; },
      ADD_DEADLINE: function() { return "Add Deadline"; },
      REMOVE_DEADLINE: function() { return "Remove Deadline"; },
    },

    ENABLE_CARD_VIEW: {
      TITLE: function() { return "Turn On Card View"; },
      DESCRIPTION: function(d) { return "There are " + d.lecturesAlias + " already released to " + d.learnersAlias + ". If you turn on card view, " + d.learnersAlias + " who view the homepage will immediately see cards for the released " + d.lecturesAlias + ". Any " + d.lecturesAlias + " that do not already have images in the page header will show a colored bar in the cards for those pages instead of images. The bar will be the same color as the page header."; },
      DESCRIPTION_NO_LESSONS: function(d) { return "Enabling card view will display cards for all " + d.lecturesAlias + " on the " + d.courseAlias + " outline. Any " + d.lecturesAlias + " that do not already have images in the page header will show a colored bar in the cards for those pages instead of images. The bar will be the same color as the page header."; },
    },

    DISABLE_CARD_VIEW: function() { return "Turn Off Card View"; },
    WARNINGS: {
      LESSON_HAS_WARNINGS: function(d) { return "Please check warnings for the activities on this " + d.lectureAlias + "."; },
      INCOMPLETE_ACTIVITY: function() { return "This activity is not complete, please check."; },
      PEER_REVIEW: {
        PEER_REVIEW_DEADLINE_BEFORE_LESSON: function(d) { return "Peer Review deadline is before " + d.LectureAlias + " release date"; },
        ASSIGNMENT_DEADLINE_AFTER_PEER_REVIEW: function(d) { return d.AssignmentAlias + " is released after Peer Review"; },
        PEER_REVIEW_DEADLINE_BEFORE_ASSIGNMENT: function(d) { return "Peer Review is released before " + d.AssignmentAlias; },
      },

      TEAM_FORMATION: {
        FORMATION_RELEASED_BEFORE_ASSIGNMENT: function(d) { return d.TeamAlias + " Formation is released after " + d.TeamAlias + " " + d.AssignmentAlias; },
        ASSIGNMENT_DEADLINE_BEFORE_FORMATION: function(d) { return d.TeamAlias + " " + d.AssignmentAlias + " is released before " + d.TeamAlias + " Formation"; },
      },

      PREREQUISITES: {
        LESSON_BEFORE_PREREQ: function(d) { return "This " + d.lectureAlias + " appears before its prerequisite, which may cause confusion for " + d.learnersAlias + "."; },
        ACTIVITY_IS_PREREQ_FOR_LESSON_BEFORE: function(d) { return "This activity is a prerequisite for content that appears before it. It is recommended to have the dependent " + d.lectureAlias + " appear after this activity."; },
      },

      STRUCTURAL_ISSUES: {
        TEAM_FORMATION_NO_TEAMS: function(d) { return d.TeamAlias + " formation activity has no " + d.teamsAlias + " added."; },
        SURVEY_NO_QUESTIONS: function() { return "Survey has no questions."; },
        PUBLIC_PRACTICE_FEEDBACK_CRITERIA_NO_ACTIVITY: function() { return "Feedback activity needs to be associated with a video practice."; },
        EXERCISE_SKILLS_RATING_NO_ACTIVITY: function(d) { return "Skills rating activity needs to be associated with an " + d.assignmentAlias + "."; },
        VIDEO_PRACTICE_SKILLS_RATING_NO_ACTIVITY: function() { return "Skills rating activity needs to be associated with a video practice."; },
        PUBLIC_PEER_EVALUATION_NO_EXERCISE: function(d) { return "Public feedback needs to be associated with an " + d.assignmentAlias + "."; },
        PRIVATE_PEER_EVALUATION_NO_EXERCISE: function(d) { return "Private feedback needs to be associated with an " + d.assignmentAlias + "."; },
        PRIVATE_PEER_EVALUATION_NO_QUESTIONS: function() { return "Private feedback needs criteria added."; },
        QUIZ_NO_QUESTIONS: function() { return "Quiz has no questions."; },
        PROGRESSIVE_QUIZ_NO_QUESTIONS: function() { return "Quiz has no questions."; },
        TIMED_QUIZ_NO_QUESTIONS: function() { return "Timed exam has no questions."; },
        EXERCISE_NO_REPORT_TEMPLATE: function(d) { return d.AssignmentAlias + " is missing a submission format."; },
        EXERCISE_NO_REPORT_TEMPLATE_SECTIONS: function(d) { return d.AssignmentAlias + " submission format must have at least one section."; },
        SUBMISSIONS_DISCOVERY_MISSING_CRITERIA_OR_EXERCISE: function(d) { return "Submission carousel needs to be associated with an " + d.assignmentAlias + "."; },
      },

    },

    REORDER: function() { return "Reorder"; },
    CARD_VIEW: function() { return "Card View"; },
    DRAG_AND_DROP: function() { return "Drag and Drop"; },
    MOVE_UP: function() { return "Move Up"; },
    MOVE_DOWN: function() { return "Move Down"; },
    HARD_DEADLINE: function() { return "Hard Deadline"; },
    AWARDED_BY: function(fullName: string) { return "Awarded by " + fullName; },
    LL_BULK_CONVERT_LECTURE_PAGES: {
      ADD_TO_LL_TOOLTIP_TEXT: function(d) { return "Add all " + d.lecturesAlias + " in this course to the lesson library"; },
      ADD_TO_LL_DISABLED_IN_PROGRESS_TOOLTIP_TEXT: function() { return "Adding to Lesson Library…"; },
      ADD_TO_LL_DISABLED_TOOLTIP_TEXT: function(d) { return "This course has no " + d.lecturesAlias + " that can be added to the lesson library"; },
      LL_BULK_CONVERT_LECTURE_PAGES_MODAL: {
        TITLE: function(sourceType: string) { return "Add this " + sourceType + " to Lesson Library"; },
        SUB_TITLE: function(d) { return d.LecturesAlias + " will automatically be organized into folders matching their section structure."; },
        SOURCE_DETAILS: {
          SOURCE_TYPE_NAME: function(sourceType: string) { return sourceType + " Name"; },
          LESSONS_TO_BE_ADDED: function(d) { return d.LecturesAlias + " to be added"; },
          SOURCE_LESSONS_COUNT: function(d) { return d.lessonPagesCount + " " + d.lectureAlias; },
          SOURCE_LESSONS_COUNT_TOOLTIP_TEXT: function(d) { return "This number does not include already linked lessons or " + d.lecturesAlias + " that contain unsupported components."; },
        },

        SELECT_COLLECTION_DESCRIPTION: function(d) { return "Select a collection to add the " + d.lecturesAlias + "."; },
        CREATE_NEW_COLLECTION: function() { return "Create New Collection"; },
        SELECT_EXISTING_COLLECTION_BUTTON: function() { return "Select existing collection instead"; },
      },

      WARNINGS: {
        IMPORTANT_NOTE_TITLE: function(d) { return "Important note about these " + d.lecturesAlias + ":"; },
        LESSONS_WITH_DEPENDENT_ACTIVITIES_DESCRIPTION: function(d) { return d.LecturesAlias + " with attached activities will be moved together to the same folder in the Collection:"; },
        LESSONS_WITH_UNSUPPORTED_COMPONENTS_DESCRIPTION: function(d) { return "Some " + d.lecturesAlias + " in your selection contain components that cannot be added to the Library at this time:"; },
        ARE_YOU_SURE: function() { return "Are you sure you want to proceed with the rest?"; },
        ALL_LESSONS_CANNOT_BE_ADDED_TITLE: function(d) { return "All " + d.lecturesAlias + " in your selection cannot be added to the Library at this time."; },
        ALL_LESSONS_CANNOT_BE_ADDED_DESCRIPTION: function(d) { return "The " + d.lecturesAlias + " are either already linked or contain components that cannot be moved in Lesson Library at this time."; },
        SOME_LESSONS_CANNOT_BE_ADDED_TITLE: function(d) { return "Some " + d.lecturesAlias + " in your selection contain components that cannot be added to the Library at this time."; },
        SOME_LESSONS_CANNOT_BE_ADDED_DESCRIPTION: function(d) { return "The following " + d.lessonsCount + " " + d.lecturesAlias + " cannot be converted:"; },
        BACK_TO_COURSE: function(d) { return "Back to " + d.CourseAlias; },
      },

      ALERT_MESSAGES: {
        PROCESSING: function() { return "Processing..."; },
        ALL_DONE: function() { return "All Done!"; },
        PROCESSING_MESSAGE: function(d) { return "We’re working on adding your " + d.lecturesAlias + " to the Lesson Library. Small " + d.coursesAlias + " take a few minutes, while larger ones with hundreds of pages may take up to an hour."; },
        SUCCESS_MESSAGE: function(d) { return d.convertedCount + " of " + d.totalCount + " " + d.LecturesAlias + " have been added to the Lesson Library: <b>" + d.collectionName + "</b>"; },
      },

    },

  },

  VALIDATION: {
    ERROR: function() { return "Error"; },
    REQUIRED: function() { return "This field is required."; },
    IS_A_REQUIRED_FIELD: function(fieldName: string) { return fieldName + " is a required field"; },
    MIN_LENGTH: function(ngMinlength: string) { return "Needs to be at least " + ngMinlength + " characters long."; },
    MAX_LENGTH: function(ngMaxlength: string) { return "Cannot be longer than " + ngMaxlength + " characters."; },
    NUMBER: function() { return "Must be a number."; },
    MIN: function(min: string) { return "Must be at least " + min + "."; },
    MAX: function(max: string) { return "Must be no greater than " + max + "."; },
    WITHIN_MIN_MAX: function(max: string, min: string) { return "Must be within " + min + " to " + max + " characters"; },
    EMAIL: function() { return "Must be a valid email address."; },
    INVALID_EMAIL: function() { return "Invalid Email address"; },
    EMAIL_MATCH: function() { return "The entered email addresses do not match."; },
    PASSWORD: function() { return "Must have at least one lowercase, uppercase, and digit characters."; },
    PASSWORD_MATCH: function() { return "Please enter the same value again."; },
    PATTERN: function() { return "Illegal value."; },
    POSITIVE_INTEGER: function() { return "Needs to be a positive integer."; },
    POSITIVE_DECIMAL: function() { return "Needs to be a positive number."; },
    NUMBER_QUESTION: function() { return "This question requires a numeric response."; },
    URL: function() { return "Must be a valid URL."; },
    HTTP: function() { return "Please include the full web address, starting with HTTP or HTTPS."; },
    PX: function() { return "Please enter a valid pixel size."; },
    DATE: function() { return "Must be a valid date."; },
    MIN_DATE: function() { return "Date cannot be in the past."; },
    DATE_TIME_LOCAL: function() { return "Must be a valid date."; },
    TIME: function() { return "Must be a valid time."; },
    WEEK: function() { return "Must be a valid week."; },
    MONTH: function() { return "Must be a valid month."; },
    MATCH: function() { return "Not a match."; },
    MAX_SIZE: function(ngfMaxSize: string) { return "Needs to be smaller than " + ngfMaxSize + "."; },
    FILE_PATTERN: function() { return "Please enter a valid file type."; },
    LOCATION: function() { return "Please select from the location options."; },
    VALID_FILE_TYPE: function() { return "Please use one of the following file types:"; },
    HEX_CODE: function() { return "Please enter a valid hexcode."; },
    FIELD_LENGTH: function(fieldName: string, maxLength: string, minLength: string) { return fieldName + " must be between " + minLength + " and " + maxLength + " characters long"; },
    FIELD_EMAIL_INVALID: function(fieldName: string) { return fieldName + " must be a valid email address."; },
    NEED_EMAIL_OR_EXTERNAL_ID: function() { return "You must specify either an email address or an external ID"; },
    FORBIDDEN_CHARACTERS: function() { return "Must contain only numbers, letters, spaces, - and &"; },
    SELECT_FUTURE_TIME: function() { return "Please select a future time"; },
    UNDEFINED_COLUMN_NAME: function() { return "Undefined Column name"; },
    CHARACTER_LIMIT_REACHED: function(maxLength: string) { return "Character limit: " + maxLength + " reached."; },
    CHARACTER_LIMIT_POPOVER_ERROR: function(maxLength: string) { return "Your answer cannot exceed the maximum character limit of " + maxLength + " characters."; },
    INVALID_DATE: function() { return "Invalid Date"; },
    SELECT_ONE: function() { return "Please select one"; },
  },

  FORM: {
    OK: function() { return "OK"; },
    OKAY: function() { return "Okay"; },
    YES_READY: function() { return "Yes, I am Ready"; },
    BACK: function() { return "Back"; },
    NEXT: function() { return "Next"; },
    REQUIRED_TAG: function() { return "required"; },
    ADD: function() { return "Add"; },
    ADDING: function() { return "Adding..."; },
    COPY: function() { return "Copy"; },
    MOVE: function() { return "Move"; },
    CONFIRM: function() { return "Confirm"; },
    CANCEL: function() { return "Cancel"; },
    SAVING: function() { return "Saving..."; },
    UPDATE: function() { return "Update"; },
    UPDATING: function() { return "Updating..."; },
    ENABLING: function() { return "Enabling..."; },
    SAVED: function() { return "Saved"; },
    SAVE: function() { return "Save"; },
    SKIP: function() { return "Skip"; },
    CONTINUE: function() { return "Continue"; },
    DELETE: function() { return "Delete"; },
    SAVE_AS_DRAFT: function() { return "Save as Draft"; },
    SUBMIT: function() { return "Submit"; },
    CHECK: function() { return "Check"; },
    CHECKING: function() { return "Checking..."; },
    SUBMITTING: function() { return "Submitting"; },
    SUBMITTING_IN_PROGRESS: function() { return "Submitting..."; },
    REVISE: function() { return "Revise"; },
    REVISING: function() { return "Revising"; },
    CANCEL_REVISE: function() { return "Cancel Revise"; },
    CREATE: function() { return "Create"; },
    CREATING: function() { return "Creating"; },
    CREATING_LOADING_TEXT: function() { return "Creating..."; },
    POST: function() { return "Post"; },
    POSTING: function() { return "Posting..."; },
    SEND: function() { return "Send"; },
    DONE: function() { return "Done"; },
    EDIT: function() { return "Edit"; },
    DISCARD: function() { return "Discard"; },
    DISCARD_CHANGES: function() { return "Discard Changes"; },
    YES_SURE: function() { return "Yes, I'm sure"; },
    CLOSE: function() { return "Close"; },
    CLOSE_ANYWAY: function() { return "Close Anyway"; },
    DO_NOT_CLOSE: function() { return "Do not close"; },
    REQUIRED: function() { return "Required"; },
    LEAVE_ANYWAY: function() { return "Leave Anyway"; },
    TYPE_HERE: function() { return "Type here..."; },
    ARE_YOU_SURE: function() { return "Are you sure?"; },
    SAVING_CHANGES: {
      NAVIGATE_AWAY: function() { return "We are saving changes to this page. You must stay on this page to ensure your changes are saved and see the impact."; },
      OK: function() { return "Navigate Away"; },
    },

    UNSAVED_CHANGES: {
      NAVIGATE_AWAY: function() { return "Are you sure? You have unsaved responses on this page. Your responses will be lost by exiting this page."; },
      NAVIGATE_AWAY_CHANGES: function() { return "Are you sure? You have unsaved changes on this page. Your changes will be lost by exiting this page."; },
      ARE_YOU_SURE: function() { return "You have unsaved changes, are you sure?"; },
      CLOSE_WINDOW: {
        TITLE: function() { return "You have unsaved changes, are you sure you want to close this window?"; },
        DESCRIPTION: function() { return "All your changes will be lost if you close this window."; },
      },

    },

    SUCCESS_BANG: function() { return "Success!"; },
    SUCCESS: function() { return "Success"; },
    ERROR: function() { return "We encountered an error completing this action. Please try again in a few minutes."; },
    ERROR_SOMETHING_WRONG: function() { return "Something went wrong, we can't complete your request now. Please try again!"; },
    ERROR_SOMETHING_WRONG_SHORT: function() { return "Something went wrong, please try again."; },
    OOPS: function() { return "Oops!"; },
    FAILED: function() { return "Failed!"; },
    SOMETHING_WRONG: function() { return "Something went wrong!"; },
    ERROR_TRY_AGAIN: function() { return "We can't complete your request now. Please try again!"; },
    DROPDOWN: {
      SELECT_ONE: function() { return "Select one"; },
      SELECTED: function(count: number) { return count + " Selected"; },
      SELECT: function() { return "Select"; },
    },

    PLACEHOLDER: {
      NUMBER: function() { return "Enter a number"; },
      VIDEO: function() { return "YouTube or Vimeo Link"; },
      INPUT_THE_ANSWER: function() { return "Input the answer here..."; },
      INPUT_YOUR_ANSWER: function() { return "Input your answer here..."; },
    },

    WARNING: function() { return "Warning"; },
    ERRORS: {
      EMPTY_FIELDS: function() { return "Please fill out all of the required fields."; },
      UPLOADS_IN_PROGRESS: function() { return "Please wait while uploads complete or cancel uploads"; },
      DOMAIN_NOT_FOUND: function() { return "Sub-domain does not exist."; },
      SSO_NOT_ENABLED: function() { return "SSO is not enabled for this domain. Please contact your admin for further assistance."; },
    },

    ASSIGN: function() { return "Assign"; },
    SELECT_DATE: function() { return "Select a Date"; },
    SELECT_DATE_TIME: function() { return "Select a Date and Time"; },
    PICK_DATE_TIME: function() { return "Pick a Date and Time"; },
    CLICK_TO_EDIT: function() { return "Click to Edit"; },
    CLICK_TO_SELECT: function() { return "Click to Select"; },
    CLICK_TO_UNSELECT: function() { return "Click to Unselect"; },
    RETRY: function() { return "Retry"; },
    DOWNLOAD_TEMPLATE: function() { return "Download a Template"; },
    UPLOAD_NEW_CSV: function() { return "Upload New CSV"; },
    UPLOAD_CSV: function() { return "Upload CSV"; },
    UPLOADING_CSV: function() { return "Uploading CSV..."; },
    PROCEED_WITH_REST: function() { return "Proceed with the Rest"; },
    PROCEEDING_WITH_REST: function() { return "Proceeding with the Rest...."; },
    VALIDATE: function() { return "Validate"; },
    VALIDATING: function() { return "Validating..."; },
    SUBMITTED: function() { return "Submitted"; },
    PREVIEW: function() { return "Preview"; },
  },

  NAVIGATION: {
    BACK: function() { return "Back"; },
    BACK_TO_INTRODUCTION: function() { return "Back to Introduction"; },
    GO_BACK: function() { return "Go Back"; },
    SKIP_TO_CONTENT: function() { return "Skip to Content"; },
    SKIP_TO_PAGE_OUTLINE: function() { return "Skip Page Outline"; },
  },

  FILE_UPLOAD: {
    UPLOADING: function() { return "Uploading"; },
    FILE_PROCESSING: function() { return "(Processing...)"; },
    UPLOADING_WITH_ELLIPSIS: function() { return "Uploading..."; },
    UPLOADING_WITH_FILE_NAME: function(fileName: string) { return "Uploading " + fileName + "..."; },
    UPLOAD_DOCUMENT: function() { return "Upload a Document"; },
    UPLOAD_PRESENTATION: function() { return "Upload Slides"; },
    UPLOAD_IMAGE: function() { return "Upload an Image"; },
    UPLOAD_SPREADSHEET: function() { return "Upload an Excel Workbook"; },
    UPLOAD_VIDEO: function() { return "Upload a Video File"; },
    UPLOAD_AUDIO: function() { return "Upload an Audio File"; },
    UPLOAD_SUBTITLES: function() { return "Upload Captions"; },
    UPLOAD_FAVICON: function() { return "Upload a Favicon"; },
    UPLOAD_FILE: function() { return "Upload a file"; },
    UPLOAD_MULTI_MEDIA_UNDER_A_SIZE: function(maxSize: string) { return "images (.jpg, .jpeg, .png), videos (.mp4, .mpeg, .mov), audios (.mp3, .m4a), documents (.pdf, .docx, .txt), spreadsheets (.xlsx, .xlsm, .xlam), and presentations (.pptx) under " + maxSize + " may be uploaded."; },
    UPLOAD_DOCUMENT_FILE_TYPES: function() { return ".docx, or .pdf"; },
    UPLOAD_PRESENTATION_FILE_TYPES: function() { return ".ppt, .pptx, or .pdf"; },
    UPLOAD_SUBTITLES_FILE_TYPES: function() { return ".srt or .vtt"; },
    UPLOAD_IMAGE_FILE_TYPES: function() { return ".jpg, .png or .gif"; },
    UPLOAD_COVER_PHOTO_FILE_TYPES: function() { return ".jpg, .jpeg, or .png"; },
    UPLOAD_SPREADSHEET_FILE_TYPES: function() { return ".xls, .xlsm, .xlam or .xlsx"; },
    UPLOAD_VIDEO_FILE_TYPES: function() { return ".mp4, .mov, .avi, .mpeg, or .mpg"; },
    UPLOAD_AUDIO_FILE_TYPES: function() { return ".mp3 or .m4a"; },
    UPLOAD_FAVICON_FILE_TYPES: function() { return ".png, .gif, or .ico"; },
    UPLOAD_MULTI_MEDIA_FILE_TYPES: function() { return "images (.png, .jpg, .jpeg), videos (.mp4, .mpeg, .mov), audios (.mp3, .m4a), documents (.pdf, .docx), spreadsheets (.xlsx, .xlsm, .xlam), and presentations (.pptx)"; },
    UP_TO_SIZE: function(maxSize: string) { return "up to " + maxSize; },
    SIZE_LIMIT_WARNING: function(fileMaxSize: string, thumbnailMaxSize: string) { return fileMaxSize + " limit per file, " + thumbnailMaxSize + " limit for thumbnails"; },
    CONFIRM_DELETE: function() { return "Are you sure you want to delete this file?"; },
    CONFIRM_DELETE_SHORT: function() { return "Delete this file?"; },
    ARE_YOU_SURE: function() { return "Are you sure?"; },
    IMAGE_TYPES: function() { return ".jpeg, .jpg, .png, .tiff, or .gif"; },
    ADD_MEDIA: function() { return "Add Media"; },
    SIZE_EXCEEDED: function() { return "File exceeds 50MB"; },
    NOT_SUPPORTED: function() { return "File type is not supported"; },
    SIZE_EXCEEDED_ALERT: function(sizeLimit: string) { return "The file you are trying to upload exceeds the " + sizeLimit + " size limit."; },
    NOT_SUPPORTED_ALERT: function() { return "The file you are trying to upload is not supported."; },
    OR: function() { return "or"; },
    DOWNLOAD: function() { return "Download"; },
    DOWNLOAD_TO_VIEW: function() { return "Download to View"; },
    DOWNLOADING: function() { return "Downloading"; },
    VIEW_FILE: function() { return "Download File"; },
    DELETE_FILE: function() { return "Delete File"; },
    UPLOAD_IN_PROGRESS_NOT_DOWNLOADABLE: function() { return "File is not ready to preview."; },
    UPLOAD_IN_PROGRESS: function() { return "File is not ready to preview. Click on View File to download and view on your device."; },
    NO_PREVIEW: function() { return "Preview is not available. Download to view."; },
    NO_PREVIEW_LARGER_FILES: function() { return "Preview is not available for files larger than 10MB."; },
    RECORD_VIDEO: function() { return "Record a Video"; },
    RECORDING: function() { return "Recording..."; },
    START_RECORDING: function() { return "Click to Start Recording"; },
    RESTART: function() { return "Restart"; },
    STOP_RECORDING: function() { return "Stop Recording"; },
    STOP_PLAYING: function() { return "Stop Playing"; },
    LEAVE_RECORDING: function() { return "Are you sure you want to leave the recording?"; },
    APPROACHING_LIMIT: function(minLimit: number) { return "Reaching the recording limit of " + plural(minLimit, 0, en, { one: number("en", minLimit, 0) + " minute", other: number("en", minLimit, 0) + " minutes" }) + "..."; },
    TIME_LEFT: function() { return "Time Left"; },
    RESUME_RECORDING: function() { return "Resume Recording"; },
    ADD_TO_SUBMISSION: function() { return "Add to My Submission"; },
    RECORD_AUDIO: function() { return "Record an Audio"; },
    RESTART_RECORDING: function() { return "Are you sure you want to restart the recording?"; },
    CANNOT_RECORD: {
      NO_BROWSER_SUPPORT: function() { return "Your browser does not support web recording. Please switch to Chrome, Edge, or Firefox for the best recording experience."; },
      TITLE: function() { return "Not able to Record"; },
      VIDEO_NOT_FOUND: function() { return "Camera or microphone is not detected."; },
      VIDEO_NOT_ALLOWED: function(articleLink: string) { return "We do not have permission to access the microphone and camera. Please <a target=\"_blank\" href=\"" + articleLink + "\">follow these steps</a> to enable access."; },
      AUDIO_NOT_FOUND: function() { return "Microphone is not detected."; },
      AUDIO_NOT_ALLOWED: function(articleLink: string) { return "We do not have permission to access the microphone. Please <a target=\"_blank\" href=\"" + articleLink + "\">follow these steps</a> to enable access."; },
      SCREEN_NOT_ALLOWED: function() { return "We do not have permission to access the screen."; },
    },

    MIC_AND_CAMERA_CHECK: function() { return "Please check if your camera and microphone are ready"; },
    MIC_CHECK: function() { return "Please check if your microphone is ready"; },
    DO_YOU_SEE_WEBCAM_VIEW: function() { return "Do you see a webcam view above? Great! Continue when ready."; },
    CAMERA_NOT_ENABLED: function(articleLink: string) { return "Camera is not enabled, please <a target=\"_blank\" href=\"" + articleLink + "\">follow these steps</a> to grant access."; },
    CAMERA_NOT_ENABLED_ALERT_HEADER: function() { return "Camera is not enabled."; },
    CAMERA_NOT_ENABLED_ALERT_BODY: function() { return "Please follow instructions on screen to enable or proceed if you only plan to do a screen recording."; },
    FILE_EXCEEDS: function(maxSize: string) { return "We could not upload your file. Please make sure it is under " + maxSize + " in size."; },
  },

  INSTANT_INSIGHT: {
    GENERATING: function() { return "Generating insights, please wait..."; },
    PRACTICE_SUBMITTED: function() { return "Your Practice has been successfully submitted!"; },
    CALCULATING_RATE: function() { return "Calculating your Rate of Speech."; },
    IDENTIFY_KEYPHRASES: function() { return "Identifying Keyphrases."; },
    DETERMINE_WORDS: function() { return "Determining your Filler Words Usage."; },
    WAIT_INSIGHTS: function() { return "Please wait a moment to see your insights."; },
    PRACTICE_AGAIN_DESCRIPTION: function() { return "Use these insights to assess your performance. When ready, practice again to try your hand at the scenario once more."; },
  },

  FROALA: {
    FIRST_TIME_EXPERIENCE: {
      TITLE: function() { return "What's New?"; },
      SUBTITLE: function() { return "Select text to change formatting, text colors or create links."; },
      ALT: function() { return "Rich text editor demo"; },
    },

    TEXT_PLACEHOLDER: function() { return "Start typing here..."; },
    TEXT_AND_FILE_PLACEHOLDER: function() { return "Start typing here..."; },
    TEXT_ALIGNMENT: function() { return "Change Text Alignment"; },
    COLOR: {
      HIGHLIGHT: function() { return "Highlight Color"; },
      TEXT: function() { return "Text Color"; },
    },

    UPLOAD_MEDIA: {
      HEADER: function() { return "Upload Files or Media"; },
      IMAGE_HEADER: function() { return "Upload Images"; },
      IMAGE_ONLY_DESCRIPTION: function() { return "images (.png, .jpg, .jpeg) under 50MB may be uploaded."; },
      ALL_DESCRIPTION: function() { return "images (.png, .jpg, .jpeg), videos (.mp4, .mpeg, .mov), audios (.mp3, .m4a), documents (.pdf, .docx), spreadsheets (.xlsx, .xlsm, .xlam), and presentations (.pptx) under 50MB may be uploaded."; },
      INSERT_MEDIA: function() { return "Insert Media"; },
      LABEL: function() { return "Public Link"; },
      PLACEHOLDER: function() { return "Add a Public Link"; },
      HINT: function() { return "e.g., http://www.youtube.com/watch?v=3v1Ac1Wx6Co"; },
    },

    ICON_TOOLTIPS: {
      UPLOAD: function() { return "Upload Files or Media"; },
      UPLOAD_IMAGE: function() { return "Upload Images"; },
      BULLET: function() { return "Bulleted List"; },
      NUMBER: function() { return "Numbered List"; },
      ENTER_CODE: function() { return "Edit in HTML"; },
      EXIT_CODE: function() { return "Exit HTML Mode"; },
      INSERTS: function() { return "Insert Dynamic Fields"; },
    },

    INSERT_TAGS: {
      HEADER: function() { return "Insert Dynamic Fields"; },
      NAMES_HEADING: function() { return "Names:"; },
      URL_HEADING: function() { return "Links to:"; },
      DATES_HEADING: function() { return "Dates:"; },
      ACCESS_INSTRUCTION_HEADING: function() { return "Access instructions:"; },
      LEARNER_FIRST_NAME: function(d) { return d.LearnerAlias + " First Name"; },
      LEARNER_LAST_NAME: function(d) { return d.LearnerAlias + " Last Name"; },
      COURSE_NAME: function(d) { return d.CourseAlias + " Name"; },
      COURSE_HOME: function(d) { return d.CourseAlias + " Home"; },
      COURSE_OPENING_DATE: function(d) { return d.CourseAlias + " Start Date"; },
      COURSE_RELEASE_DATE: function(d) { return d.CourseAlias + " Release Date"; },
      COURSE_END_DATE: function(d) { return d.CourseAlias + " End Date"; },
      COURSE_CLOSING_DATE: function(d) { return d.CourseAlias + " Closing Date"; },
      COURSE_CLOSE_DATE: function(d) { return d.CourseAlias + " Close Date"; },
      REMAINING_DAYS_FOR_ACCESS: function() { return "Remaining Days for Access"; },
      DUE_DATE_FOR: function(activity: string) { return "Due Date For " + activity; },
      RELEASE_DATE_FOR: function(lectureName: string) { return "Release Date For " + lectureName; },
      START_DATE_FOR: function(activity: string) { return "Start Date For " + activity; },
      PICK_ANOTHER_LINK: function() { return "Pick Another Link"; },
      PICK_ANOTHER_COURSE: function() { return "Pick Link to Course"; },
      PICK_ANOTHER_DATE: function() { return "Pick Another Date"; },
      PICK_COURSE_RELATED_DATES: function() { return "Pick Course Related Dates"; },
      DUE_DATE: function(activity: string) { return activity + " Due Date"; },
      RELEASE_DATE: function(lectureName: string) { return lectureName + " Release Date"; },
      START_DATE: function(activity: string) { return activity + " Start Time"; },
      INSERT_PASSWORD_SENTENCE: function() { return "Password Sentence"; },
      MALFORMED_WARNING: function() { return "We have detected a malformed dynamic field. Use preview to ensure that the dynamic field is replaced with a relevant value before proceeding. If the dynamic field is not replaced in preview, remove it from your email and add it again."; },
      START_DATE_FOR_COURSE: function(course: string) { return "Start Date For " + course; },
      RELEASE_DATE_FOR_COURSE: function(course: string) { return "Release Date For " + course; },
      END_DATE_FOR_COURSE: function(course: string) { return "End Date For " + course; },
      CLOSE_DATE_FOR_COURSE: function(course: string) { return "Close Date For " + course; },
      MENTORSHIP_PROGRAM: {
        PARTICIPANT_FIRST_NAME: function() { return "Participant First Name"; },
        PARTICIPANT_LAST_NAME: function() { return "Participant Last Name"; },
        PROGRAM_NAME: function() { return "Program Name"; },
        MATCH_NAME: function() { return "Match Name"; },
        PROGRAM_HOME_URL: function() { return "Program Home"; },
        PROGRAM_PROFILE_URL: function() { return "Complete Your Profile"; },
        VIEW_MATCH_URL: function() { return "View Your Match"; },
        FIND_MENTOR_URL: function(d) { return "Find Your " + d.MentorAlias; },
        PROGRAM_RELEASE_DATE: function() { return "Program Release Date"; },
        PROGRAM_CLOSING_DATE: function() { return "Program Closure Date"; },
        PROGRAM_MATCH_DATE: function() { return "Match Announcement Date"; },
      },

    },

    FONT: {
      HEADER: function() { return "Font Style"; },
      TITLE: function() { return "Title"; },
      SUBTITLE: function() { return "Subtitle"; },
      TITLE_SMALL: function() { return "Small Title"; },
      BIG: function() { return "Big Text"; },
      MEDIUM: function() { return "Medium Text"; },
      REGULAR: function() { return "Regular Text"; },
      SMALL: function() { return "Small Text"; },
    },

    HTML: {
      SUPPORTED: function() { return "Supported Tags"; },
      SUPPORTED_DESCRIPTION: function() { return "Here are the list of tags and attributes you can use with this editor:<br />table, td, th, div, ul, li, ol, h1, h2, h3, href, title, class, id, name, style, span, width, src, height, type, allowfullscreen, align, alt,  colspan, rowspan,  text-align, padding, margin, scrolling, frameborder, sandbox, webkitallowfullscreen, mozallowfullscreen"; },
    },

    UPLOAD_FILES_OR_MEDIA_ARIA_LABEL: function() { return "Upload files or media"; },
    BULLETED_LIST_ARIA_LABEL: function() { return "Bulleted list"; },
    NUMBERED_LIST_ARIA_LABEL: function() { return "Numbered list"; },
    BODY_PLACEHOLDER: function() { return "Body"; },
  },

  EXERCISES: {
    HEADER: function() { return "Start an Exercise"; },
    RELEASED_ON: function(releasedate: string) { return "Released on " + releasedate; },
    RELEASING_ON: function(releasedate: string) { return "Releasing on " + releasedate; },
    START_SUBMISSION: function() { return "Start a Submission"; },
    START_NEW_SUBMISSION: function() { return "Start a New Submission"; },
    DEADLINE_PASSED: function(d) { return "The deadline for this " + d.assignmentAlias + " has passed."; },
    TEAM_NEEDED: function(d) { return d.TeamAlias + " required to complete this " + d.assignmentAlias + ". Contact the " + d.teachingTeamAlias + " to be assigned."; },
    TEAM_NEEDED_POPVER: function(d) { return "To create " + d.teamsAlias + ", go to the Edit Options and choose Edit " + d.TeamsAlias; },
    SUBMISSIONS_EXCEEDED: function(d) { return "You have already created " + d.count + " submissions for this " + d.assignmentAlias + ". That's the limit!"; },
    VIEW_SUBMISSION: function() { return "View Submission"; },
    SUBMISSION_LOAD_ERROR: {
      MESSAGE: function() { return "We couldn't load this submission. This may be due to a slow or unstable connection."; },
      RETRY: function() { return "Try again"; },
      TOAST: function() { return "We couldn't load this submission. Please check your connection and try again."; },
    },

    VIEW_SUBMISSION_DETAILS: function(title: string) { return title + ", Enter to view submission details"; },
    SUBMISSION_TITLE_DESCRIPTION: function(exercise: string, title: string) { return title + " for " + exercise + ", Enter to view submission details"; },
    VIEW_SUBMISSIONS: function() { return "View Submissions"; },
    EDIT_SUBMISSION: function() { return "Edit Submission"; },
    VIEW_INTRODUCTION: function() { return "View Introduction"; },
    HIDE_INTRODUCTION: function() { return "Hide Introduction"; },
    REVISE: function() { return "Revise"; },
    RESUME: function() { return "Resume"; },
    RESUME_OR_REVISE: function() { return "Resume or Revise"; },
    DRAFT: function() { return "Draft"; },
    SAVE_SUBMISSION_AS_DRAFT: function(exerciseTitle: string) { return "Save \"" + exerciseTitle + "\" submission as draft"; },
    CANCEL_SUBMISSION_REVISE: function(exerciseTitle: string) { return "Cancel \"" + exerciseTitle + "\" submission revise"; },
    REVISE_SUBMISSION: function(exerciseTitle: string) { return "Revise \"" + exerciseTitle + "\" submission"; },
    SUBMIT_SUBMISSION: function(exerciseTitle: string) { return "Submit \"" + exerciseTitle + "\" submission"; },
    SUBMISSION_REVISING: function(exerciseTitle: string) { return "Revising \"" + exerciseTitle + "\" submission"; },
    SUBMISSION_SUBMITTING: function(exerciseTitle: string) { return "Submitting \"" + exerciseTitle + "\" submission"; },
    VIEW_ASSIGNMENT_SUBMISSIONS: function(exerciseTitle: string) { return "View \"" + exerciseTitle + "\" submissions"; },
    VIEW_ASSIGNMENT_SUBMISSION: function(exerciseTitle: string) { return "View \"" + exerciseTitle + "\" submission"; },
    RESUME_SUBMISSION: function(exerciseTitle: string) { return "Resume \"" + exerciseTitle + "\" submission"; },
    START_NEW_ASSIGNMENT_SUBMISSION: function(exerciseTitle: string) { return "Start new \"" + exerciseTitle + "\" submission"; },
    START_ASSIGNMENT_SUBMISSION: function(exerciseTitle: string) { return "Start \"" + exerciseTitle + "\" submission"; },
    TAKE_ME_THERE: function() { return "Take Me There"; },
    DO: function() { return "Do"; },
    UNLOCK_THIS_ACTIVITY: function() { return "to unlock this activity"; },
    PENDING: function() { return "Pending"; },
    SUBMIT: function() { return "Submit"; },
    SUBMIT_AS_TEAM: function(d) { return "Submit as " + d.TeamTitleAlias; },
    ADMIN_OPTIONS: function() { return "Admin Options"; },
    SKIP: function() { return "Skip"; },
    SUBMITTING_YOUR_WORK: function() { return "Submitting your work?"; },
    APPROVAL_NO_CHANGES_ALLOWED: function() { return "Your submission will be sent for approval first. Once approved, it will be immediately available for feedback. Are you sure?'"; },
    NO_CHANGES_ALLOWED: function() { return "Your submission will be immediately available for feedback and you will not be able to make changes. Are you sure?"; },
    IMMEDIATELY_AVAILABLE_FOR_FEEDBACK: function() { return "Your submission will be immediately available for feedback. Are you sure?"; },
    IMMEDIATELY_AVAILABLE_FOR_LEARNER_VIEWING: function(d) { return "Your submission will be immediately available for other " + d.learnersAlias + " to view. Are you sure?"; },
    IMMEDIATELY_AVAILABLE_FOR_MENTOR_FEEDBACK: function(d) { return "Your submission will be immediately available for " + d.mentorsAlias + " to provide feedback. Are you sure?"; },
    FLAG_THIS_SUBMISSION: function() { return "Flag this Submission"; },
    DUE: function(deadline: string) { return "Due " + deadline; },
    USER_SUBMITTED_ON: function(name: string, submitted: string) { return name + " submitted on " + submitted + "."; },
    USER_MODIFIED_SUBMISSION_ON: function(date: string, user: string) { return user + " modified the submission on " + date + "."; },
    SUBMITTING_ON_BEHALF: function(d) { return select(d.isRevise, { true: "Revising", other: "Submitting" }) + " on behalf of the " + d.teamAlias + "."; },
    LAST_SAVED: function(submitted: string) { return "Last Saved: " + submitted; },
    ADDITIONAL_SUBMISSIONS_ALLOWED: function(d) { return "You may create up to " + d.numRemaining + " additional " + plural(d.numRemaining, 0, en, { one: "submission", other: "submissions" }) + ". The maximum number allowed for this " + d.assignmentAlias + " is " + d.numAllowed; },
    PRIVACY_SETTING: {
      PRIVACY_SETTING: function() { return "Privacy Setting"; },
      SELECT: function(hasApproval: string) { return "Select a privacy setting for your submission " + select(hasApproval, { true: "after approval", other: "" }); },
      PUBLIC: function() { return "Shared Publicly on the Web"; },
      TEACHING_TEAM: function(d) { return "Shared with the " + d.TeachingTeamAlias; },
      TEACHING_TEAM_TITLEIZED: function(d) { return "Shared with the " + d.TeachingTeamTitleAlias; },
      CLASS: function(d) { return "Shared with the " + d.CourseAlias; },
    },

    PRIVACY_HELP_TEXT: {
      SELECT: function() { return "Select a privacy setting for your submission"; },
      PUBLIC: function() { return "Please note: your submission will be publicly accessible, meaning it will be discoverable via search engines (e.g. Google) and may be shared on social media, etc with its URL."; },
      INSTRUCTOR: function(d) { return "This submission will only be viewable to " + d.teachingTeamAlias + " members with appropriate permissions."; },
      INSTRUCTOR_ONLY: function() { return "The Teaching Team has selected the privacy setting for all submissions. This submission will only be viewable to the Teaching Team."; },
      CLASS: function(d) { return "This submission will be discoverable in the submission gallery and viewable by anyone enrolled in this " + d.courseAlias + "."; },
      CLASS_ONLY: function(d) { return "The " + d.teachingTeamAlias + " has selected the privacy setting for all submissions. This submission will be viewable to " + d.teachingTeamAlias + " members with appropriate permissions and to " + d.learnersAlias + " in the " + d.offeringName + "."; },
    },

    CREATE_SUBMISSION: function() { return "Create a Submission"; },
    SUBMITTED_SUCCESSFULLY: function() { return "Submitted Successfully"; },
    SUBMITTED: function() { return "Submitted"; },
    SUBMITTED_AS_TEAM: function(d) { return "Submitted as " + d.TeamTitleAlias; },
    SUBMITTED_ON: function(d) { return select(d.date, { false: "", other: "Submitted on " + d.date + "." }) + " " + select(d.revisedAfterSubmit, { false: "", other: "Last edited on " + d.revisedDate + "." }) + " " + select(d.isPendingApproval, { true: " Pending Approval. ", other: "" }) + " " + select(d.isNeedRevision, { true: " Revision Needed. ", other: "" }) + " " + select(d.wasNeedRevision, { true: " Revision was not received before the deadline for this " + d.assignmentAlias + " has passed. ", other: "" }) + " " + select(d.isApproved, { true: " Submission has been approved! ", other: "" }); },
    SUBMITTED_ON_BEHALF: function(d) { return d.user + " submitted on behalf of the " + d.teamAlias + "."; },
    SUBMISSION_REVISED_ON: function(date: string) { return "Submission last revised on " + date + "."; },
    GET_STARTED: function() { return "Get started"; },
    PREREQUISITES_ERROR: function(exerciseName: string) { return "This " + exerciseName + " cannot be accessed because you have not completed the prerequisite for it."; },
    ERROR: function() { return "We encountered an error while saving your submission. Please try again."; },
    ALREADY_APPROVED: function() { return "This submission has already been approved."; },
    SUBMISSION_EDIT_MODE: function(d) { return d.LearnerAlias + " submissions are shown in lesson view when submitted."; },
    NO_SUBMISSIONS_YET: function(d) { return "No submissions yet for this " + d.assignmentNameAlias + ". Come back soon and check again!"; },
    SUBMISSIONS_FOR_FEEDBACK_NOT_AVAILABLE_YET: function(deadline: string) { return "Submissions aren't available for feedback yet. Please check back after " + deadline; },
    SUBMISSIONS_NOT_AVAILABLE_YET: function(deadline: string) { return "Submissions aren't available yet. Please check back after " + deadline; },
    SUBMISSION_TITLE: function() { return "Submission Title"; },
    LEARNERS_SUBMISSION: function(firstName: string, lastName: string) { return firstName + " " + lastName + "'s Submission"; },
    TEAMS_SUBMISSION: function(teamName: string) { return teamName + "'s Submission"; },
    NOT_MEMBER_OF_TEAM: function(d) { return "You had no " + d.teamAlias + " assignment during this " + d.assignmentAlias + "."; },
    NOT_ASSIGNED_A_TEAM: function(d) { return d.TeamTitleAlias + " assignment required to complete this " + d.assignmentAlias + ". Contact the " + d.teachingTeamAlias + " to be assigned."; },
    NEED_ORGANIC_TEAM: function(d) { return d.TeamTitleAlias + " membership required to complete this " + d.assignmentAlias + ". Please either join or create one."; },
    GET_STARTED_HERE: function() { return "Get started here."; },
    LEFT_TEAM: function(d) { return "You left this " + d.teamAlias; },
    ALL_SUBMISSIONS: function() { return "All Submissions"; },
    SUBMISSIONS_COMMENTED_ON: function() { return "Submissions I Commented On"; },
    SUBMISSIONS_NOT_COMMENTED_ON: function() { return "Submissions I Have Not Commented On"; },
    MOST_RELEVANT: function() { return "Most Relevant"; },
    TRENDING: function() { return "Trending"; },
    MOST_RECENT: function() { return "Most Recent"; },
    ALL_ASSIGNMENTS: function() { return "All Assignments"; },
    MOST_LIKED: function() { return "Most Liked"; },
    SUBMISSIONS_I_LIKED: function() { return "Submissions I Liked"; },
    UNTITLED: function() { return "Untitled"; },
    SUBMISSION_COPY_LINK: function() { return "Copy the public URL"; },
    SUBMISSION_LINK_COPIED: function() { return "Public URL has been copied to your clipboard."; },
    TEAM_SUBMITTED_ALREADY: function(d) { return d.teamName + " has already submitted for this " + d.assignmentAlias + "."; },
    NEW_TEAM_FOR_CREDIT: function(d) { return "In order to receive credit for this " + d.assignmentAlias + ", choose a new " + d.teamAlias + " to work with."; },
    CHOOSE_NEW_TEAM: function(d) { return "choose a new " + d.teamAlias; },
    COLLABORATORS: function(d) { return "Collaborators for this " + d.assignmentAlias; },
    SELECT_COURSE_FOR_EXERCISES: function() { return "Please select a course first"; },
    GRANT_LATE_SUBMISSION_PERMIT: {
      TITLE: function() { return "Grant Late Submission Permit"; },
      SUB_HEAD: function() { return "View Late Submission Permits"; },
      ASSIGNMENT: function(d) { return d.assignmentNameAlias; },
      SUBMITTED: function() { return "Submitted?"; },
      DUE_DATE: function() { return "Due Date"; },
      TEAM_ASSIGNMENT_TABLE_HEAD: function(d) { return "Late submission permit will be granted to the whole " + d.teamAlias + ". Here is the list of " + d.TeamAlias + " Activities with hard deadlines:"; },
      USER_ASSIGNMENT_TABLE_HEAD: function(d) { return "List of " + d.AssignmentsAlias + " with hard deadlines:"; },
      GRANT_PERMIT: function() { return "Grant Permit"; },
      STATUS_NOT_SUBMITTED: function() { return "Not Submitted"; },
      STATUS_SUBMITTED: function() { return "Submitted"; },
      STATUS_MISSED: function() { return "Missed"; },
      TEAM_ASSIGNMENT: function(d) { return d.TeamAlias + " " + d.AssignmentAlias; },
      EXTEND: function() { return "Extend"; },
      TEAM_SUBMISSION_WARNING: function(d) { return "For " + d.teamAlias + " activities, late submission permit will be granted to the whole " + d.teamAlias; },
      EXERCISE_EXTENDED_SUCCESS: function(name: string) { return "Late submission permit has been granted to " + name; },
      DUE_DATE_BEFORE_CURRENT_DATE: function() { return "New due date must be after current due date"; },
      EXTENDED_TO: function(extendedTo: string) { return "Extended to " + extendedTo; },
      EXERCISE_EXTENDED_INFO: function(extendedOn: string, userName: string) { return "Extended by " + userName + " on " + extendedOn; },
    },

    SHARE_SUBMISSION_TO_TEAM: {
      SHARE_SUBMISSION: function() { return "Share Submission"; },
      POST_TO_A_WORKSPACE: function() { return "Post to a Workspace?"; },
      PROMPT: function() { return "Need to collaborate, ask for comments, or start a discussion with other members? You may optionally post this submission to a workspace."; },
      DESCRIPTION: function() { return "Please add a message to provide context or purpose for sharing:"; },
      PRIVACY_TEXT: function(d) { return "Privacy settings will not be changed. Shared submission will be accessible only to " + d.teamOrGroupAlias + " members in the workspace and will remain private/ not discoverable in the " + d.courseAlias + "."; },
      PRIVACY_TEXT_MULTIPLE: function(d) { return "Privacy settings will not be changed. Shared submission will be accessible only to " + d.teamAlias + " or " + d.groupAlias + " members in the workspace and will remain private/ not discoverable in the " + d.courseAlias + "."; },
      SHARE_THIS_SUBMISSION: function() { return "Share this submission to the workspace:"; },
      SHARE_THIS_SUBMISSION_MULTIPLE: function() { return "Share this submission to the workspace(s):"; },
      POST_TO_WORKSPACE: function() { return "Post to Workspace"; },
      POST_TO_WORKSPACE_QUESTION: function() { return "Post to Workspace?"; },
      ALERT: function(d) { return "Submission has been shared to your " + d.teamOrGroupAlias + " workspace!"; },
      ALERT_MULTIPLE: function() { return "Your Submission has been shared to your workspaces!"; },
      VISIT_TEAM_WORKSPACE: function(d) { return "Visit " + d.teamOrGroupTitleAlias + " Workspace"; },
      NO: function() { return "No"; },
      YES: function() { return "Yes"; },
    },

    JUMP_TO_NEXT_QUESTION: function() { return "Jump to Next Question"; },
    NEXT_TO_SUBMIT: function() { return "Next to Submit"; },
    EMPTY_SUBMISSION_MODAL: {
      TITLE: function() { return "Submission is Empty"; },
      DESCRIPTION: function(d) { return "This submission appears to be empty. Please provide the necessary information to submit this " + d.assignmentAlias + "."; },
      BACK_BUTTON: function(d) { return "Back to " + d.AssignmentAlias; },
    },

  },

  TEAM_FORMATION: {
    GET_STARTED: function() { return "Get Started"; },
    JOIN_A_TEAM: function(d) { return "Find an existing " + d.TeamAlias; },
    CREATE_A_TEAM: function(d) { return "Create a new " + d.TeamAlias; },
    MEET_YOUR_TEAM: function(d) { return "Meet Your " + d.teamAlias; },
    CREATE_YOUR_TEAM: function(teamName: string) { return "Create Your " + teamName; },
    JOIN_OR_FORM_TEAM: function(d) { return "Create or Join an existing " + d.teamAlias; },
    MEMBER_OF_A_TEAM: function(d) { return d.teamAlias + " member"; },
    JOINED_A_TEAM: function(d) { return "Joined a " + d.TeamAlias; },
    CREATED_A_TEAM: function(d) { return "Created a " + d.TeamAlias; },
    CREATED_TIME: function(time: string) { return "Created " + time; },
    JOINED_TIME: function(time: string) { return "Joined " + time; },
    TEAM_FORMATION: function(d) { return d.TeamAlias + " Formation"; },
    YOUR_TEAM: function(d) { return "Your " + d.TeamAlias; },
    VISIT_WORKSPACE: function(d) { return "Visit " + d.TeamTitleAlias + " Workspace"; },
    VISIT_THE_WORKSPACE: function(d) { return "Visit " + d.TeamAlias + " Workspace"; },
    VISIT_GROUP_WORKSPACE: function(d) { return "Visit " + d.GroupAlias + " Workspace"; },
    VISIT_GROUP_PROFILE: function(groupName: string) { return "Visit the " + groupName + " Profile"; },
    INVITATIONS: function() { return "Pending Invitations"; },
    PENDING_REQUESTS: function() { return "Pending Requests"; },
    SEND_REQUEST_OR_CREATE_TEAM: function(d) { return "Send More Requests or Create Your own " + d.TeamAlias; },
    SEND_REQUEST_OR_CREATE_GROUP: function(d) { return "Join or Create More " + d.GroupsAlias + "?"; },
    I_WILL_CREATE_A_TEAM: function(d) { return "I will create a new " + d.teamAlias; },
    I_WILL_JOIN_A_TEAM: function(d) { return "I will join an existing " + d.teamAlias; },
    TEAM_EXPLANATION_FOR_CREATE: function(d) { return "You will become " + d.teamAlias + " lead once you create one. You will be able to invite others to your " + d.teamAlias + " and respond to membership requests."; },
    GROUP_EXPLANATION_FOR_CREATE: function(d) { return "You will become " + d.groupAlias + " admin in your " + d.groupAlias + " once you create one. You will be able to invite others and respond to membership requests."; },
    TEAM_EXPLANATION_FOR_JOIN: function(d) { return "You will be able to search for an existing " + d.teamAlias + " to join. Once you send a request to the " + d.teamAlias + ", the " + d.teamAlias + " lead should accept your request to join the " + d.teamAlias + "."; },
    GROUP_EXPLANATION_FOR_JOIN: function(d) { return "You will be able to search " + d.groupsAlias + " to join. Once you send a request to join one, the " + d.groupAlias + " admin should accept your request to join the " + d.groupAlias + "."; },
    FORM_TEAM: function(d) { return "Form " + d.TeamsAlias; },
    FORM_GROUP: function(d) { return "Form " + d.GroupAlias; },
    ADD: function() { return "Add"; },
    RESTRICTED_TOOLTIP: function(d) { return "Only " + d.courseAlias + " admins with Instructor permission can " + select(d.isEdit, { true: "edit", other: "add" }) + " " + select(d.isTeam, { true: d.teamsAlias, other: d.groupsAlias }); },
    ASSIGNED_NO_TEAM: function(d) { return "The " + d.teachingTeamAlias + " has not yet assigned you to your " + d.teamAlias + "."; },
    NO_TEAM_UNRELEASED: function(d) { return d.TeamAlias + " formation is not available yet"; },
    NO_TEAM_RELEASED_INSTRUCTOR_FORMED: function(d) { return "No " + d.teamAlias + " assignment yet."; },
    NO_TEAM_RELEASED_FORMED_BY_STUDENTS: function(d) { return d.TeamTitleAlias + " membership required to complete this activity. Please either <a href=" + d.teamFormationLink + ">join or form one</a>"; },
    OPEN_GROUP: function(d) { return "Open " + d.groupAlias; },
    CLOSED_GROUP: function(d) { return "Closed " + d.groupAlias; },
    EXPLANATION_FOR_OPEN_GROUP: function(d) { return "Anyone can join an open " + d.groupAlias + "."; },
    EXPLANATION_FOR_CLOSED_GROUP: function(d) { return d.learnersAlias + " must request to join a closed " + d.groupAlias + ". These requests must be approved by " + d.groupAlias + " admins in order for the " + d.learnerAlias + " to join."; },
    EXPLANATION_FOR_MENTORS_IN_TEAMS: function(d) { return d.mentorAlias + " cannot join or create new " + d.teamsAlias + "."; },
    GROUPS_CREATED_SUCCESSFULLY: function(d) { return d.groupAlias + " " + plural(d.groupCount, 0, en, { one: "is", other: "are" }) + " successfully created."; },
    ERRORS: {
      ADD_APPROVED_GROUP_MEMBER: function() { return "The user could not be added to the group."; },
    },

  },

  USERS: {
    FULL_NAME: function(firstName: string, lastName: string) { return firstName + " " + lastName; },
    FULL_NAME_TITLE: function(firstName: string, lastName: string, title: string) { return firstName + " " + lastName + ", " + title; },
    PROFILE: {
      ERROR: {
        PRIVACY_SETTING: function() { return "Profile information can not be made less private than the privacy"; },
      },

    },

    REGISTRATION: {
      SIGN_IN: function() { return "Sign In"; },
      SIGN_UP: function() { return "Sign Up"; },
      SIGN_UP_LOWER: function() { return "sign up"; },
      SIGNING_IN: function() { return "Signing In..."; },
      SIGNING_UP: function() { return "Signing Up..."; },
      ALREADY_JOINED: function() { return "You've Already Joined!"; },
      SIGN_IN_HERE_OR: function() { return "Sign in here or"; },
      WITH_A_DIFFERENT_EMAIL: function() { return "with a different email address."; },
      FORGOT_PASSWORD: function() { return "Forgot your password?"; },
      SIGN_IN_WITH_SAML_ACCOUNT: function(providerName: string) { return "Sign In with your " + providerName + " Account"; },
      SIGN_UP_WITH_SAML_ACCOUNT: function(providerName: string) { return "Sign Up with your " + providerName + " Account"; },
      SIGN_IN_WITH_NOVOED_PASSWORD: function() { return "Sign In with a NovoEd Password Instead"; },
      SIGN_IN_WITH: function() { return "Sign in with"; },
      SIGN_UP_WITH: function() { return "Sign up with"; },
      CREATE_ACCOUNT: function() { return "Create a New Account"; },
      JOIN_US: function() { return "Join Us"; },
      JOIN_AS_MENTOR: function() { return "Join as a Mentor"; },
      FIRST_NAME: function() { return "First Name"; },
      LAST_NAME: function() { return "Last Name"; },
      EMAIL_ADDRESS: function() { return "Email Address"; },
      EMAIL: function() { return "Email"; },
      CONFIRM_EMAIL_ADDRESS: function() { return "Confirm Email Address"; },
      PASSWORD: function() { return "Password"; },
      USERNAME: function() { return "Username"; },
      REMEMBER_MY_USERNAME: function() { return "Remember my username"; },
      PASSWORD_REQUIREMENT: function() { return "Password (min 8 chars with lower, uppercase and digits)"; },
      PASSWORD_EXTRA_INFO: function() { return "Min 8 characters with lower, uppercase and digits"; },
      NEW_PASSWORD: function() { return "New Password"; },
      CONFIRM_NEW_PASSWORD: function() { return "Confirm New Password"; },
      BY_SIGNING_UP_YOU_AGREE_TO: function() { return "By signing up you agree to our"; },
      TERMS_OF_SERVICE: function() { return "Terms of Service"; },
      SIGN_IN_WITH_EXISTING_ACCOUNT: function() { return "Sign in with an Existing Account"; },
      ENTER_EMAIL_PASSWORD_RESET: function() { return "Enter your registered email address. You will receive instructions for resetting your password in a few minutes."; },
      SEND: function() { return "Send"; },
      SENDING: function() { return "Sending..."; },
      UPDATE: function() { return "Update"; },
      UPDATING: function() { return "Updating..."; },
      PASSWORD_RESET: function() { return "Password Reset"; },
      PASSWORD_RESET_REQUESTED: function() { return "You will receive an email with instructions about how to reset your password in a few minutes."; },
      CHANGE_YOUR_PASSWORD: function() { return "Change your Password"; },
      CHECKING_LOADING_PROVIDERS: function() { return "Checking available options…"; },
      ERRORS: {
        ERROR: function() { return "Error!"; },
        USER_IS_NOVOED_ADMIN: function() { return "User is already a NovoEd Admin"; },
        USER_IS_ALREADY_IN_ORGANIZATION: function() { return "User is already added with an organization admin or course admin role. Find them in this list to make changes."; },
        INCORRECT_PASSWORD_LEVEL_1: function() { return "The email and password you entered don't match."; },
        INCORRECT_PASSWORD_LEVEL_2: function(numAttempts: string) { return "The email and password you entered don't match. You have " + numAttempts + " more attempts remaining."; },
        INCORRECT_PASSWORD_LEVEL_3: function() { return "The email and password you entered don't match. This is your final sign-in attempt."; },
        ACCOUNT_LOCKED: function() { return "Your account has been locked for security reasons. Please try logging in again in 12 hours."; },
        LINK_EXPIRED: function() { return "Link Expired"; },
        LINK_EXPIRED_DESCRIPTION: function() { return "This link to reset your password has expired. You may request a new one below."; },
        EMAIL_NOT_FOUND: function() { return "We coudn't find an account with that email address."; },
        GENERIC: function() { return "We encountered an error. Please try again later."; },
        RECAPTCHA: function() { return "Invalid reCAPTCHA. Please try again."; },
      },

      SELECT_IDP: {
        HEADER: function() { return "Single Sign-On Options"; },
      },

    },

  },

  QUIZZES: {
    TYPES: {
      ALL_QUESTION_VIEW: function() { return "All-Question View"; },
      SINGLE_QUESTION_VIEW: function() { return "Single Question View"; },
    },

    TYPE_FEATURES: {
      CLASSIC_VIEW: {
        ALL_QUESTION_TYPES: {
          LABEL: function() { return "All Question Types"; },
          DESCRIPTION: function() { return "Supports creation of question types: Rich Text, Likert Scale, Short Text, Number, Statement, Multiple Choice, Multiple Choice/Multiple Answer, Table Short Answer, and Table Number."; },
        },

        ALL_AT_ONCE: {
          LABEL: function() { return "All-at-Once Question View"; },
          DESCRIPTION: function(d) { return d.LearnerAlias + " is shown all questions in a list view all on one page."; },
        },

        QUIZ_ATTEMPTS: {
          LABEL: function() { return "Quiz Attempts"; },
          DESCRIPTION: function(d) { return "Course builders can specify the number of attempts " + d.learnersAlias + " have for the quiz as a whole."; },
        },

        POST_QUIZ_FEEDBACK: {
          LABEL: function() { return "Post-Quiz Feedback"; },
          DESCRIPTION: function(d) { return d.LearnerAlias + " is shown feedback on all questions after submitting the quiz."; },
        },

        STATIC_FEEDBACK: {
          LABEL: function() { return "Static Feedback"; },
          DESCRIPTION: function(d) { return d.LearnerAlias + " is shown the same feedback after each quiz attempt."; },
        },

      },

      SINGLE_QUESTION_VIEW: {
        LIMITED_QUESTION_TYPES: {
          LABEL: function() { return "Limited Question Types"; },
          DESCRIPTION: function() { return "Supports creation of Multiple Choice Questions, Multiple Choice/Multiple Answer, Statement, Short Text Answer, Number Answer, Long Answer and Matching Pairs Questions."; },
        },

        ONE_AT_A_TIME: {
          LABEL: function() { return "One-at-a-Time Question View"; },
          DESCRIPTION: function(d) { return d.LearnersAlias + " must answer the current question they're on before continuing to the next question."; },
        },

        QUIZ_AND_QUESTION_ATTEMPTS: {
          LABEL: function() { return "Quiz + Question Attempts"; },
          DESCRIPTION: function(d) { return "Course builders can specify the number of attempts " + d.learnersAlias + " have for each question as well as for the quiz as a whole."; },
        },

        IMMEDIATE_QUESTION_FEEDBACK: {
          LABEL: function() { return "Immediate Per-Question Feedback"; },
          DESCRIPTION: function(d) { return d.LearnerAlias + " is given immediate feedback each time they answer a question."; },
        },

        QUESTION_HINT: {
          LABEL: function() { return "Hint per Question"; },
          DESCRIPTION: function(d) { return "After each missed question attempt, " + d.learnersAlias + " are shown a different \"hint\" to help them try to answer correctly on their next try."; },
        },

        FRESH_CREATION_EXPERIENCE: {
          LABEL: function() { return "Fresh Creation Experience"; },
        },

      },

    },

    STATEMENT: {
      TYPE_STATEMENT: function() { return "Type your statement here..."; },
    },

    SHORT_ANSWER_QUESTION: {
      SETTING_SHORT_ANSWER_INFO: function(d) { return "Input a single answer " + d.learnersAlias + " must match to receive a correct answer (answers aren't case sensitive). Or input multiple answers that can be accepted as correct."; },
      CORRECT_ANSWER_PLACEHOLDER: function() { return "Correct Answer"; },
    },

    LONG_ANSWER_QUESTION: {
      SETTING_LONG_ANSWER_INFO: function(d) { return "All answers to Long Answer questions are marked as correct by default. You can provide feedback for " + d.learnersAlias + " to view after they've submitted a response."; },
      FEEDBACK_FOR_ANY_ANSWER: function() { return "Feedback for any answer"; },
      FEEDBACK_PLACEHOLDER: function() { return "Input your feedback here..."; },
      DEFAULT_FEEDBACK: function() { return "All answers are correct."; },
    },

    NUMBER_ANSWER_QUESTION: {
      SETTING_CORRECT_NUMBER_INFO: function() { return "Input one single number or a range of numbers that can be accepted as correct."; },
      CORRECT_NUMBER: function() { return "Correct Number"; },
      ADD_CORRECT_RANGE: function() { return "Add Correct Range"; },
      LOW_NUMBER: function() { return "Low Number"; },
      HIGH_NUMBER: function() { return "High Number"; },
    },

    LIKERT_SCALE_QUESTION: {
      SCALE_RANGE: function() { return "Scale Range:"; },
      LEFT_LABEL_PLACEHOLDER: function() { return "Left Label (Optional)"; },
      RIGHT_LABEL_PLACEHOLDER: function() { return "Right Label (Optional)"; },
      CORRECT_NUMBER_FROM: function() { return "Correct Number From"; },
      CORRECT_NUMBER_TO: function() { return "Correct Number To"; },
      LEFT_SCALE_LIMIT: function() { return "Left Scale Limit"; },
      RIGHT_SCALE_LIMIT: function() { return "Right Scale Limit"; },
      LEFT_SCALE_LIMIT_DESCRIPTION: function() { return "Left Scale Limit: Accepts whole numbers between 0-1000."; },
      RIGHT_SCALE_LIMIT_DESCRIPTION: function() { return "Right Scale Limit: Accepts whole numbers between 0-1000."; },
      OPTIONAL: function() { return "(Optional)"; },
      DEFAULT_FEEDBACK: function() { return "All answers are correct."; },
      ARIA_LABEL: {
        CURRENT_VALUE: function(maxValue: string, selectedValue: string) { return selectedValue + " of " + maxValue; },
      },

    },

    MATCHING_QUESTION: {
      CREATION_HEADER: function(d) { return "Please add the matching pairs below. The left side will be shuffled when presented to " + d.learnersAlias + "."; },
      ADD_PAIR: function() { return "Add matching pair"; },
      CANNOT_ADD_PAIR: function(maximumCount: number) { return "Maximum " + maximumCount + " pairs"; },
      DELETE_PAIR: function() { return "Delete this  Pair"; },
      CANNOT_DELETE_PAIR: function() { return "Can't delete the last pair"; },
      ANSWER_HEADER: function() { return "Match pairs together by clicking a tile on one side and selecting its corresponding tile on the other. You can also use the keyboard Tab to highlight and the Enter key to select."; },
      OPTION_CONTENT_ARIA_LABEL: function(content: string, isParent: string) { return select(isParent, { true: "Left", other: "Right" }) + " option. Content " + content + "."; },
      REVEAL_OPTION_ARIA_LABEL: function(content: string, isCorrect: string) { return select(isCorrect, { true: "correctly", other: "incorrectly" }) + " linked to option " + content + "."; },
      CORRECT_LINK_ARIA_LABEL: function(content: string) { return "The correct link's content is " + content + "."; },
      LINKED_OPTION_ARIA_LABEL: function(content: string) { return "Linked to option " + content + "."; },
      SELECT_TO_LINK_ARIA_LABEL: function(content: string) { return "Select to establish a new link to another already selected option  " + content + "."; },
    },

    TABLE_QUESTION: {
      ADD_ROW: function() { return "Add Row"; },
      ADD_COLUMN: function() { return "Add Column"; },
      DELETE_ROW: function() { return "Delete Row"; },
      DELETE_COLUMN: function() { return "Delete Column"; },
      DISABLED_TOOLTIP: function(d) { return "The quiz has been released to " + d.learnersAlias + ". so you can no longer adjust columns and rows. You can only edit the existing text."; },
      MIN_ROW_REACHED: function() { return "Tables must support at least one row at minimum."; },
      MIN_COLUMN_REACHED: function() { return "Tables must support at least 1 column at minimum."; },
      MAX_ROW_REACHED: function() { return "Tables can support up to 20 rows maximum."; },
      MAX_COLUMN_REACHED: function() { return "Tables can support up to 6 columns maximum."; },
      ADD_CORRECT_ANSWER_DESCRIPTION: function() { return "Add correct answer for this cell and add feedback if needed."; },
      ADD_CORRECT_NUMBER_DESCRIPTION: function() { return "Add correct number or range for this cell and add feedback if needed."; },
      TABLE_QUESTION_EDIT_LABEL: function() { return "Input label text or edit cells with correct answers."; },
      TABLE_HEADER_PLACEHOLDER: function() { return "Input table header (optional)"; },
      CORRECT_RANGE: function() { return "Correct Range"; },
      CELL_SWITCH_TO_ANSWER: function(d) { return "Change this cell to a " + d.learnerAlias + "-facing input cell"; },
      CELL_SWITCH_TO_READONLY: function() { return "Change this cell to a read-only text label"; },
      CLEAR_INPUT: function() { return "Clear input"; },
      READ_ONLY_INPUT_LABEL: function() { return "This is a label"; },
      INCORRECT_ANSWER_INFO: function() { return "Some of your answers were incorrect. Click on the marks in each cell for more details."; },
      CORRECT_ANSWER_INFO: function() { return "Click on the marks in each cell for more details."; },
      ANSWER_SET_INFO: function(d) { return "This is a " + d.learnerAlias + " input cell. Click to edit the correct answer."; },
      INPUT_TEXT_LABEL: function() { return "Input text label"; },
      ANSWER_INPUT_ARIA_LABEL: function(columnNumber: string, rowNumber: string) { return "input answer for row " + rowNumber + ", column " + columnNumber; },
      REQUIRED: function() { return "Required"; },
    },

    QUESTION_IMAGE: function() { return "Question Image"; },
    START: function() { return "Start Quiz"; },
    SUBMIT_ANSWER: function() { return "Submit Answer"; },
    RETRY_QUESTION: function() { return "Retry Question"; },
    FINISH_QUIZ: function() { return "Finish Quiz"; },
    CORRECT_SO_FAR: function(correctCount: number) { return "You have " + correctCount + " correct " + plural(correctCount, 0, en, { one: "answer", other: "answers" }) + "!"; },
    SELECTED_CORRECT: function() { return "You've selected the correct answer."; },
    ARE_YOU_SURE_TO_EXIT: function() { return "Are you sure you want to exit? You haven't submitted an answer to this question yet. Answers will be saved only for previously submitted questions."; },
    QUESTION_MISSED: function() { return "You missed this question. Continue to the next."; },
    QUESTION_MISSED_TITLE: function() { return "That was your last question attempt!"; },
    FIRST_MISTAKE: function() { return "The first mistake is part of the learning process."; },
    CHANCES_LEFT: function(chancesCount: number) { return "Try again! You have " + chancesCount + " more " + plural(chancesCount, 0, en, { one: "chance", other: "chances" }) + " to answer this question correctly."; },
    UNMET_PASSING_SCORE: function() { return "You have not met the minimum passing score."; },
    ANSWER_AT_LEAST: function(requiredQuestionsCount: number) { return "You must answer at least " + requiredQuestionsCount + " " + plural(requiredQuestionsCount, 0, en, { one: "question", other: "questions" }) + " correctly to pass this quiz."; },
    REVEAL_ANSWERS: function() { return "Reveal Answers"; },
    RESUME_QUIZ: function() { return "Resume Quiz"; },
    NO_ATTEMPTS_LEFT: function() { return "You have exhausted all of your attempts."; },
    REVIEW_PREVIOUS: function() { return "Review Previous Attempt"; },
    UNLIMTED_ATTEMPTS: function() { return "Unlimited Attempts"; },
    CORRECT_ANSWER: function() { return "Correct answer:"; },
    ADD_CORRECT_ANSWER: function() { return "Add Correct Answer"; },
    ADD_CORRECT_NUMBER: function() { return "Add Correct Number"; },
    FEEDBACK_DEFAULT_INFO: function(d) { return "By default, " + d.learnersAlias + " will see \"Correct!\" and \"Incorrect!\". You can customize this feedback."; },
    CORRECT_ANSWER_FEEDBACK_PLACEHOLDER: function() { return "Customize feedback for the correct answer"; },
    INCORRECT_ANSWER_FEEDBACK_PLACEHOLDER: function() { return "Feedback for any other answer"; },
    REQUIREMENT_MET: function(correctCount: number) { return "You have " + correctCount + " correct " + plural(correctCount, 0, en, { one: "answer", other: "answers" }) + "! Requirement met!"; },
    KEEP_GOING: function(correctCount: number, requiredCount: number) { return "You have " + correctCount + " correct " + plural(correctCount, 0, en, { one: "answer", other: "answers" }) + " so far! You need at least " + requiredCount + " to pass. Keep going!"; },
    SAVING: function() { return "Saving"; },
    QUIZ_SAVED: function() { return "Saved!"; },
    ERROR: function() { return "Error!"; },
    RADIO_BUTTON_SELECTED: function() { return "radio button selected"; },
    RADIO_BUTTON_UNSELECTED: function() { return "radio button unselected"; },
    CHECKBOX_CHECKED: function() { return "checkbox checked"; },
    CHECKBOX_UNCHECKED: function() { return "checkbox unchecked"; },
    PROGRESSIVE_QUIZ_BASICS: {
      SELECT_QUIZ_TYPE: function() { return "Select Quiz Type"; },
      QUIZ_BASICS: function() { return "Quiz Basics"; },
      ADD_QUIZ_DESCRIPTION: function() { return "Choose between the two different quiz types to begin creating your quiz."; },
      QUIZ_ATTEMPT_DESCRIPTION: function(d) { return "How many times " + d.learnersAlias + " can try the whole quiz."; },
      QUESTION_ATTEMPT_DESCRIPTION: function(d) { return "How many times " + d.learnersAlias + " can try each question within the quiz before automatically advancing to the next question."; },
      REDUCING_QUESTION_ATTEMPTS_WARNING: function(d) { return "Reducing question attempts will reduce the hints shown to " + d.learnersAlias + "."; },
      QUESTION_ATTEMPT_INFO: function() { return "This setting also corresponds to the number of fields available to provide a different question hint for each attempt."; },
      N_QUIZ_ATTEMPTS: function(attemptsCount: number) { return attemptsCount + " Quiz " + plural(attemptsCount, 0, en, { one: "Attempt", other: "Attempts" }); },
      N_QUESTION_ATTEMPTS: function(attemptsCount: number) { return attemptsCount + " Question " + plural(attemptsCount, 0, en, { one: "Attempt", other: "Attempts" }); },
      UNLIMITED_ATTEMPTS_INFO: function(d) { return "When set to unlimited attempts, " + d.learnersAlias + " are shown the correct answers after their first quiz submission."; },
      SELECT_QUIZ_ATTEMPTS: function() { return "Please Select Quiz Attempt(s)"; },
      SELECT_QUESTION_ATTEMPTS: function() { return "Please Select Question Attempt(s)"; },
      CREATE_QUIZ: function() { return "Next: Create Quiz"; },
      MODAL_DESCRIPTION: function(d) { return "Quiz attempt is the number of attempts that " + d.learnersAlias + " can work on for the whole quiz. Question attempt will allow " + d.learnersAlias + " to retry the same question multiple times."; },
      PICK_A_QUESTION_TYPE: function() { return "Pick a Question Type"; },
      MULTIPLE_CHOICE: function() { return "Multiple Choice"; },
      NUMBER: function() { return "Number"; },
      SHORT_ANSWER: function() { return "Short Answer"; },
      LONG_ANSWER: function() { return "Long Answer"; },
      STATEMENT: function() { return "Statement"; },
      MATCHING: function() { return "Matching Pairs"; },
    },

    ALL_QUESTION_VIEW_QUIZ_BASICS: {
      LIKERT_SCALE: function() { return "Likert Scale"; },
      TABLE_NUMBER_QUESTION: function() { return "Table Number Question"; },
      TABLE_SHORT_TEXT_QUESTION: function() { return "Table Short Text Question"; },
    },

    UNSHOWN_FEEDBACK_WARNING: function(d) { return d.LearnersAlias + " won't be shown this feedback because the quiz's question attempts have been modified. To show, increase the question attempts in Quiz Basics."; },
    CURRENT_QUESTION_INDICATOR: function(currentCount: number, totalCount: number) { return "Question " + currentCount + "/" + totalCount; },
    QUESTION_NUMBER: function(count: number) { return "Question " + count; },
    REMAINING_QUESTION_ATTEMPTS: function() { return "Remaining Question Attempts:"; },
    ADD_QUESTION: function() { return "Question"; },
    DUPLICATE_QUESTION: function() { return "Duplicate Question"; },
    SET_QUESTION_ATTEMPTS_FROM_BASICS: function() { return "Set question attempts from Quiz Basics."; },
    DELETE_QUESTION: function() { return "Delete Question"; },
    DELETE_QUESTION_CONFIRMATION: function() { return "Are you sure you want to delete this question?"; },
    INPUT_OPTION: function() { return "Input Option"; },
    MARK_CORRECT_ANSWER: function() { return "Select this option to mark it as the correct answer"; },
    ADD_FEEDBACK: function(d) { return "By default, " + d.learnersAlias + " will see \"Correct!\" and \"Incorrect!\". You can customize this feedback."; },
    EDIT_MULTIPLE_OPTION_INSTRUCTION: function(d) { return d.LearnersAlias + " will see \"Select all that apply\" or \"Select one\" depending on the number of correct answers you provide."; },
    MULTIPLE_OPTION_INSTRUCTION: function(isMultipleAnswer: string) { return "Select " + select(isMultipleAnswer, { true: "all that apply", other: "one" }) + ":"; },
    PROGRESSIVE_FEEDBACK_PLACEHOLDER: function() { return "Input a hint for this question attempt"; },
    ADD_PROGRESSIVE_FEEDBACK: function() { return "Add a hint for an additional question attempt"; },
    HINT_EXPLANATION: function(d) { return d.LearnersAlias + " will see this hint after answering the question incorrectly."; },
    HINT_EXPLANATION_AGAIN: function(d) { return d.LearnersAlias + " will see this hint after answering the question incorrectly again."; },
    SHORT_ANSWER_SETTING_VALIDATION: {
      LENGTH: function(max: string, min: string) { return "A short answer must be between " + min + " and " + max + " characters in length."; },
    },

    ALREADY_RELEASED: {
      PROGRESSIVE_QUIZ_DESCRIPTION: function(d) { return "The quiz has been released to " + d.learnersAlias + ". Questions cannot be added, deleted, or reordered. Making text edits is accepted."; },
      ALL_QUESTION_VIEW_QUIZ_DESCRIPTION: function(d) { return "The quiz has been released to " + d.learnersAlias + ". You cannot delete, add questions and options, but you can edit the text."; },
      OPTIONS: function(d) { return "The quiz has been released to " + d.learnersAlias + ". You cannot add " + select(d.isPair, { true: "matching pairs", other: "options" }) + " but you can edit the text."; },
      OPTION_DELETE: function(d) { return "The quiz has been released to " + d.learnersAlias + ". You cannot delete " + select(d.isPair, { true: "matching pairs", other: "options" }) + " but you can edit the text."; },
      QUESTION_DELETE: function(d) { return "The quiz has been released to " + d.learnersAlias + ". You cannot delete quiz questions."; },
      ADD_QUESTION: function(d) { return "The quiz has been released to " + d.learnersAlias + ". You cannot add questions but you can edit the text."; },
      DUPLICATE: function(d) { return "The quiz has been released to " + d.learnersAlias + ". You cannot duplicate quiz questions."; },
    },

    HINTS_LABEL: function() { return "Hints for Question Attempts"; },
    HINTS_INFO: function(d) { return "Create \"Hints\" to show to " + d.LearnersAlias + ". After the " + d.LearnerAlias + " misses their first question attempt, they'll be shown the first \"Hint\" provided. A second missed question attempt will show the second corresponding \"Hint\", etc."; },
    HINT: function() { return "Hint"; },
    PLEASE_NOTE: function() { return "Please note"; },
    ANSWERS: function() { return "Quiz Answers"; },
    CANNOT_MOVE_FORWARD_TOOLTIP: function() { return "Please scroll down to submit your answer before continuing through the quiz."; },
    FEEDBACK: function() { return "Quiz Feedback"; },
    START_QUIZ: function() { return "Take the Quiz"; },
    RETRY: function() { return "Retry"; },
    VIEW_MY_RESPONSES: function() { return "View My Responses"; },
    CORRECT_ANSWERS: function() { return "Correct Answers"; },
    REVEAL_CORRECT_ANSWER: function() { return "Reveal Correct Answer"; },
    REVEAL_CORRECT_ANSWERS: function() { return "Reveal Correct Answers"; },
    HIDE_CORRECT_ANSWERS: function() { return "Hide Correct Answers"; },
    CLEAR_AND_PRACTICE_AGAIN: function() { return "Clear and Practice Again"; },
    DEADLINE_PASSED: function() { return "The deadline for this quiz has passed."; },
    TAKE: function() { return "Take"; },
    PRACTICE: function() { return "Practice"; },
    MISSED: function() { return "Missed"; },
    SCORE: function(maxPossibleScore: string, submissionScore: string) { return "Score: " + submissionScore + " out of " + maxPossibleScore; },
    ANSWERED_X_CORRECT: function(submissionScore: string) { return "Answered " + submissionScore + " Correct"; },
    SCORED: function(maxPossibleScore: string, submissionScore: string) { return "Scored " + submissionScore + " out of " + maxPossibleScore; },
    ATTEMPT: function(attemptCount: number, maxAttempt: string) { return "This is attempt " + attemptCount + " of " + maxAttempt + "."; },
    ATTEMPT_PAST: function(attemptCount: number, maxAttempt: string) { return "This was attempt " + attemptCount + " of " + maxAttempt + "."; },
    ATTEMPT_UNLIMITED: function() { return "Unlimited attempts"; },
    QUESTIONS_BLANK_SUBMIT: {
      MESSAGE: function(blankCount: number) { return "You have left " + plural(blankCount, 0, en, { one: "1 question", other: number("en", blankCount, 0) + " questions" }) + " blank. Are you sure you want to submit your responses?"; },
      CANCEL: function() { return "Cancel"; },
      CONFIRM: function() { return "Submit Anyway"; },
    },

    FINAL_ATTEMPT: {
      MESSAGE: function() { return "This is your final attempt. Would you like to review your answers before submitting?"; },
      CANCEL: function() { return "Review Responses"; },
      CONFIRM: function() { return "Submit"; },
    },

    DECAYED_POINTS: {
      WARNING_TEXT: function(d) { return "You currently have " + d.pointsReceived + " " + d.pointsAlias + " for this quiz and it is only worth " + d.totalPoints + " now. Are you sure you want to attempt it again?"; },
      RETRY_QUIZ: function() { return "Retry Quiz"; },
      DECLINE: function() { return "Decline"; },
    },

    MCMA: {
      CORRECT_ANSWER_COUNT: function(correctOptions: string, correctResponses: string) { return "You selected " + correctResponses + " out of " + correctOptions + " correct " + plural(correctOptions, 0, en, { one: "answer", other: "answers" }) + "."; },
      INCORRECT_ANSWER_COUNT: function(incorrectResponses: string) { return "You selected " + incorrectResponses + " incorrect " + plural(incorrectResponses, 0, en, { one: "answer", other: "answers" }) + "."; },
    },

    TABLE: {
      INCORRECT_ANSWERS: function() { return "Some of your answers were incorrect. Click on the marks in each cell for more details."; },
    },

    MATCHING_QUESTION_SEE_CORRECT_ANSWER: function() { return "Hover over your errors to see the correct answer."; },
    CORRECT_ANSWER_RANGE: function(bottomOfRange: string, topOfRange: string) { return "Answers between " + bottomOfRange + " and " + topOfRange + " are correct, inclusively."; },
    NO_CORRECT_ANSWER_DEFINED: function() { return "There are no definitive answers for this question. Your answer is correct!"; },
    CLOSE: function() { return "Close"; },
    NOT: function() { return "not"; },
    MY_RESPONSES: function() { return "My Responses"; },
    EMPTY_RESPONSE: function() { return "You did not answer this question."; },
    SAVED: function(time: string) { return "Saved " + time; },
    VIEW_INTRO: function() { return "View Introduction"; },
    EXHAUSTED_ATTEMPTS: function() { return "You have exhausted all of your attempts."; },
    QUESTIONS: function(questions: string) { return questions + " " + plural(questions, 0, en, { one: " Question ", other: " Questions " }); },
  },

  SURVEYS: {
    THANKS_FOR_RESPONSE: function() { return "Thanks for your response!"; },
    RESPONSES_SUBMITTED_SUCCESSFULLY: function() { return "Responses submitted successfully."; },
    DEADLINE_PASSED: function() { return "The deadline for this survey has passed."; },
    SINGLE_SELECTION_CREATOR_INFO: function(d) { return d.learnerAlias + " will see “Select one”"; },
    MULTIPLE_SELECTION_CREATOR_INFO: function(d) { return d.learnerAlias + " will see “Select all that apply”"; },
    QUESTION_TYPES: {
      MULTIPLE_CHOICE_MULTIPLE_ANSWER: function() { return "Multi Choice: Multi Select"; },
      MULTIPLE_CHOICE_SINGLE_ANSWER: function() { return "Multi Choice: Single Select"; },
    },

    TABLE_QUESTION: {
      TABLE_QUESTION_EDIT_LABEL: function() { return "Input label text or mark the cell as required."; },
      ANSWER_CELL_INFO: function(d) { return "This is a " + d.learnerAlias + " input cell."; },
      DISABLED_TOOLTIP: function(d) { return "The survey has been released to " + d.learnersAlias + ". so you can no longer adjust columns and rows. You can only edit the existing text."; },
    },

    REQUIRED: function(d) { return "Required for " + d.learnerAlias + " to answer"; },
    ALREADY_RELEASED: {
      SURVEY_RELEASED_DESCRIPTION: function(d) { return "The survey has been released to " + d.learnersAlias + ". You cannot delete, add questions and options, but you can edit the text."; },
      OPTIONS: function(d) { return "The survey has been released to " + d.learnersAlias + ". You cannot add " + select(d.isPair, { true: "matching pairs", other: "options" }) + " but you can edit the text."; },
      OPTION_DELETE: function(d) { return "The survey has been released to " + d.learnersAlias + ". You cannot delete " + select(d.isPair, { true: "matching pairs", other: "options" }) + " but you can edit the text."; },
      QUESTION_DELETE: function(d) { return "The survey has been released to " + d.learnersAlias + ". You cannot delete survey questions."; },
      ADD_QUESTION: function(d) { return "The survey has been released to " + d.learnersAlias + ". You cannot add questions but you can edit the text."; },
      DUPLICATE: function(d) { return "The survey has been released to " + d.learnersAlias + ". You cannot duplicate survey questions."; },
    },

  },

  SKILLS_FEEDBACK: {
    TITLE: function() { return "Skills Feedback"; },
    ALL_FEEDBACK: function() { return "All Skills Feedback"; },
    YOUR_FEEDBACK: function() { return "Your Skills Feedback"; },
    REMOVE_RATING: function() { return "Click to remove your rating"; },
    NO_SKILLS_FEEDBACK_PROVIDED: function(skillsStr: string) { return "You can give feedback regarding these skills: " + skillsStr + ", would you like to provide your feedback for this submission?"; },
    EMPTY: function(learnerFirstName: string, skillsStr: string) { return "Let " + learnerFirstName + " know how well they demonstrated skills such as " + skillsStr + " by sharing Skills Feedback."; },
    PROVIDE_FEEDBACK: function() { return "Provide Skills Feedback"; },
    MISSED_ACTIVITY: function() { return "The deadline for this activity has passed."; },
    FEEDBACK_VISIBILITY: {
      AUTHOR: function(learner: string) { return "Your feedback is visible to " + learner + " and the teaching team."; },
      ALL: function() { return "This skills feedback is only visible to you and the teaching team."; },
    },

    VIEW_ALL_FEEDBACK: function() { return "View all Feedback"; },
  },

  LECTURE_PAGES: {
    VIEW_LECTURE: function(d) { return "View " + d.lectureAlias; },
    UPDATE_RELEASE_DATE: function() { return "Update Release Date"; },
    FUTURE_RELEASE: function(releaseDate: string) { return "To be released on " + releaseDate; },
    PAST_RELEASE: function(releaseDate: string) { return "Released on " + releaseDate; },
    LOCKED_EXPLANATION: function(d) { return "This " + d.lectureAlias + " is locked, please complete <b>" + d.itemTitle + "</b> to unlock this."; },
    OUTLINE: function() { return "OUTLINE"; },
    LESSON_NAVIGATION: function(d) { return d.LecturesAlias; },
    PREVIOUS_LECTURE: function(lectureName: string) { return "Previous: " + lectureName; },
    NEXT_LECTURE: function(lectureName: string) { return "Next: " + lectureName; },
    EDIT_OUTLINE: function(d) { return "Edit " + d.CourseAlias + " Outline"; },
    HIDE_OUTLINE: function(d) { return "Hide " + d.CourseAlias + " Outline"; },
    SHOW_OUTLINE: function(d) { return "Show " + d.CourseAlias + " Outline"; },
    OPEN_OUTLINE: function(d) { return "Open " + d.CourseAlias + " Outline"; },
    CLOSE_OUTLINE: function(d) { return "Close " + d.CourseAlias + " Outline"; },
    GO_TO_OUTLINE: function(d) { return "Go to " + d.CourseAlias + " Outline Edit"; },
    UNRELEASE_TITLE: function(d) { return "Unrelease " + d.LectureAlias; },
    UNRELEASE: function(d) { return "Unreleasing the " + d.lectureAlias + " will remove all the submission and evaluation data from " + d.learnersAlias + ", are you sure?"; },
    DATE_CONFLICT_TITLE: function() { return "Date Conflict"; },
    DATE_CONFLICT: function() { return "The deadline for some activities on this page expires before the new release date, are you sure?"; },
    RELEASE_DEADLINE_CONFLICT: function(d) { return d.LectureAlias + " release date is after activity deadline."; },
    UNRELEASE_DATE_CONFLICT: function(d) { return "Unreleasing the " + d.lectureAlias + " will remove all the submission and evaluation data from " + d.learnersAlias + ". The deadline for some activities on this page expires before the new release date, are you sure?"; },
    COMMUNICATION_EXIST: function(d) { return "Changing the " + d.lectureAlias + " release date will affect the send timing of communications based on this " + d.lectureAlias + " release date. Are you sure?"; },
    LINKING: function() { return "This might take a while"; },
    VIEW_PROFILE_ACTIONS: function() { return "View profile actions"; },
    ADMIN: {
      TOP_HEADER: {
        EXIT_EDIT: function() { return "Exit Edit Mode"; },
        EXIT_ADMIN: function() { return "Exit Admin Mode"; },
        EXIT_REORDER: function() { return "Save and Exit Reorder Mode"; },
      },

      HEADER: {
        EDIT_HEADER: {
          BUTTON: function() { return "Edit Header"; },
          COLOR: function() { return "Use Color"; },
          IMAGE: function() { return "Upload an Image"; },
          DISPLAY_HEADER: function(d) { return "Display " + d.LectureAlias + " Header"; },
          HIDE_HEADER: function(d) { return "Hide " + d.LectureAlias + " Header"; },
          SAVING: function() { return "Saving... Please wait"; },
          UPLOAD_CARD_VIEW: function() { return "Upload Card View Image"; },
        },

        TITLE_POPOVER: function(d) { return "Click to Edit " + select(d.LectureAlias, { undefined: "Lesson", other: d.LectureAlias }) + " Title"; },
        SUBMITTING_ON_BEHALF: function(d) { return select(d.isRevise, { true: "Revising", other: "Submitting" }) + " on behalf of the " + d.teamAlias + "."; },
        TITLE_TEXT_COLOR: function(d) { return d.LectureAlias + " Title Color"; },
        TITLE_TEXT_COLOR_TOOLTIP: function() { return "Change the title text color"; },
      },

      DELETE_MODAL: {
        TITLE: function(d) { return "Are you sure you want to delete the following " + d.lectureAlias + ":"; },
        DESCRIPTION: function(d) { return "This will delete all " + d.learnerAlias + " " + d.assignmentAlias + " submissions and remove any " + d.pointsAlias + " earned by " + d.learnersAlias + ". Any automated communications based on this " + d.lectureAlias + " and its activities will also be deleted. This action is final and cannot be undone."; },
      },

      LINKED_OPTIONS: {
        LINKED_LESSON_OPTIONS: function(d) { return "Linked " + d.LectureAlias + " Options"; },
        LESSON_UNDER: function(d) { return "This linked " + d.lectureAlias + " is under:"; },
        EDIT_IN_COLLECTION: function(d) { return select(d.showView, { true: "View", other: "Edit" }) + " " + d.lectureAlias + " in collection"; },
        NO_PERMISSION_TO_EDIT_IN_COLLECTION: function() { return "You don't have permission to edit in collection"; },
        NO_PERMISSION_TO_UNLINK: function() { return "You don't have permission to unlink from collection"; },
      },

      COG_OPTIONS: {
        EDIT: function() { return "Edit Content"; },
        EXIT_EDIT_MODE: function() { return "Exit Edit Mode"; },
        EXIT_ADMIN_MODE: function() { return "Exit Admin Mode"; },
        REORDER: function() { return "Reorder Content"; },
        DUPLICATE: function(d) { return "Duplicate " + d.LectureAlias; },
        DELETE: function() { return "Delete"; },
        DELETE_TOOLTIP: function() { return "Unlink all the lessons to delete this lesson"; },
        CREATE: function(d) { return "Create a New " + d.LectureAlias; },
        ADD_FROM_LESSON_LIBRARY: function() { return "Add from Lesson Library"; },
      },

      TIME_ESTIMATES: {
        ADD: function() { return "Click to Add"; },
        UPDATE: function() { return "Click to Update"; },
      },

      DUPLICATED: {
        TITLE: function(d) { return d.LectureAlias + " Duplicated"; },
        DESCRIPTION: function(d) { return "Here are the list of your components that cannot be copied to the new " + d.lectureAlias + ":"; },
      },

      EDIT_MENU_TOP_HEADER: {
        MORE_OPTIONS: function() { return "More Options"; },
        ENTER_ADMIN_MODE: function() { return "Enter Admin Mode"; },
        BACK_TO_OUTLINE: function(d) { return "Back to " + d.CourseAlias + " Outline"; },
        REORDER: function() { return "Reorder"; },
        NOVO_AI: function() { return "Create with NovoAI"; },
        DUPLICATE_LESSON: function(d) { return "Duplicate This " + d.LectureAlias; },
        ADD_NEW_LESSON: function(d) { return "Add a New " + d.LectureAlias; },
        DELETE_LESSON: function(d) { return "Delete This " + d.LectureAlias; },
        EDIT_MODE_ON: function() { return "Edit Mode On"; },
        ADMIN_MODE_ON: function() { return "Admin Mode On"; },
        ADD_BLANK_LESSON: function(d) { return "Add a Blank " + d.LectureAlias; },
        LINKED: function() { return "Linked"; },
        NOVO_AI_DISABLED_TEXT: function() { return "Suggestions for Linked lessons from the Library aren’t supported at this time."; },
        EDIT_ICON_DISABLED_TEXT: function() { return "Please wait while changes are being pushed"; },
        AI_SUGGEST_ACTIVITY_DISABLED_TEXT: function() { return "Suggestions for Linked lessons from the Library aren’t supported at this time."; },
        REORDER_DISABLED_TEXT: function(d) { return "Reorder for this " + d.lectureAlias + " must be done from the Lesson Library."; },
        ADD_TO_LL_DISABLED_TEXT: function(d) { return "Linked " + d.lectureAlias + " can’t be added to lesson library"; },
        ADD_TO_LL_NOT_SUPPORTED_DISABLED_TEXT: function(d) { return "This " + d.lectureAlias + " contains activities that are not supported in Lesson Library yet."; },
      },

    },

    LHS: {
      ADD_COMPONENT_TITLE: function() { return "Select Components"; },
      CONTENT_DESIGN: function() { return "Content Design"; },
      EVENTS: function() { return "Events"; },
      PRACTICE_AND_APPLICATION: function() { return "Practice & Application"; },
      QUIZ_AND_SURVEY: function() { return "Quiz & Survey"; },
      SOCIAL_ACTIVITIES: function() { return "Social Activities"; },
      FEEDBACK_ACTIVITIES: function() { return "Feedback Activities"; },
      THIRD_PARTY_LINKS_AND_TOOLS: function() { return "Third Party Links & Tools"; },
      UNAVAILABLE_IN_LESSON_LIBRARY: function() { return "Unavailable in the Lesson Library at this time."; },
      NOVO_AI: {
        NOVOAI_CREATION_ASSISTANT: function() { return "AI Creation Assistant"; },
        START_BUTTON: function() { return "NovoAI"; },
        COMPONENT_LIST_TITLE: function() { return "Choose from specific options:"; },
        WELCOME_TEXT: {
          WELCOME_TEXT_ONE: function(firstName: string) { return "👋 Hi " + firstName + ","; },
          WELCOME_TEXT_TWO: function(d) { return "I'm an AI Assistant that can design a " + d.courseAlias + " from your raw materials, or use your finished content as is to build a course exactly to your specifications."; },
          WELCOME_TEXT_THREE: function() { return "Upload Your Files to Start!"; },
          WELCOME_TEXT_FOUR: function(d) { return "I'll use these to help generate your " + d.courseAlias + "."; },
        },

        AI_LEARN_MORE_INFO: {
          TITLE: function(d) { return "How Does NovoAI Create and Enhance " + d.CourseAlias + " Content?"; },
          DESCRIPTION: function(d) { return "NovoAI analyzes text from uploaded files (e.g., documents, powerpoints) to generate a structured " + d.courseAlias + " aligned with the content's key concepts. It designs with NovoEd's high-impact pedagogy and incorporates engaging activities like quizzes, discussions, polls, " + d.assignmentsAlias + ", public feedback, and surveys, tailored to your " + d.courseAlias + "'s content cultivating social and collaborative-led learning. <i>Always review generated content for accuracy.</i>"; },
          LEARN_MORE: function() { return "Learn more about my approach."; },
        },

        UPLOAD_FILES: function() { return "Uploaded Files:"; },
        UPLOAD_FILES_WARNING_PAGE_LIMIT_EXCEEDED_TEXT: function() { return "Total pages of all files need to be under 400 pages"; },
        UPLOAD_TEXT_ONE: {
          DARG_AND_DROP: function() { return "Drag & drop or"; },
          BROWSE_TEXT: function() { return "browse"; },
          FILES: function() { return "files"; },
        },

        UPLOAD_TEXT_TWO: function(fileSize: string) { return "PDF, DOC, PPT, and TXT files up to " + fileSize + " in size and less than 400 total combined pages."; },
        UPLOAD_FILE_PAGE_COUNT: function(pageCount: number) { return "(" + pageCount + " pages)"; },
        FILE_ERROR_LARGE: function() { return "is too large and cannot be uploaded."; },
        FILE_ERROR_INVALID: function() { return "is not supported and cannot be uploaded."; },
        FILE_PAGE_LIMIT_EXCEEDED_ERROR: function() { return "is over the 400 page limit."; },
        FILE_PAGE_COUNT_UNAVAILABLE_ERROR: function() { return "page count could not be validated right now. Please try again later."; },
        FILE_ERROR_DEFAULT: function() { return "failed to upload."; },
        SELECT_COURSE_OUTLINE: {
          SELECT_OUTLINE_HEADER: function() { return "Identify Finished Course Content"; },
          SELECT_OUTLINE_TEXT: function() { return "Have you already created finished course content outside of NovoEd? Select that file and we'll use it as is, keeping your titles and content exactly as entered. Otherwise, we'll design the outline and content using your files as raw material."; },
          SELECT_OUTLINE_NOTE_TEXT: function(d) { return "<b>Please note:</b> " + d.lecturesAlias + " without enough content to generate will be created as blank lessons."; },
          SELECT_OUTLINE_PLACEHOLDER: function() { return "Please Select (Optional)"; },
          SELECT_OUTLINE_TOOLTIP_TEXT_FILE_UPLOADING: function() { return "Files are still uploading, please wait..."; },
          SELECT_OUTLINE_TOOLTIP_TEXT_FOR_PAGE_LIMIT_EXCEEDED: function() { return "Total pages of all files uploaded need to be less than 400 pages."; },
          SELECT_OUTLINE_TOOLTIP_FOR_DISABLED_FILES: function() { return "This file is over 100 pages, can’t be used for outline"; },
        },

        CONTENT_SEARCH: {
          SEARCH_CONTENT_INPUT_PLACEHOLDER: function(d) { return "Search by " + d.courseAlias + " name or catalog ID"; },
          NO_SEARCH_RESULT: function() { return "No search results"; },
          SHOW_MORE_COURSES: function(couseCount: number) { return "Show " + couseCount + " More Courses"; },
          REFINE_SEARCH_RESULTS: function() { return "or refine your search result"; },
        },

        COURSE_LISTING: {
          COURSE_LISTING_TEXT_ONE: function() { return "Set Visual Styling"; },
          COURSE_LISTING_TEXT_TWO: function(d) { return "Select a " + d.courseAlias + " as reference to help inspire the visual design elements and color."; },
          LEARN_MORE: function() { return "Learn More"; },
        },

        COURSE_PREVIEW_MODAL_HEADER: function(courseName: string) { return "Preview " + courseName; },
        PREVIOUSLY_VISITED: function() { return "Previously Visited:"; },
        SELECTED: function() { return "Selected:"; },
        COURSE_LENGTH_TITLE: function(d) { return "Set the " + d.CourseAlias + " Length"; },
        COURSE_REVIEW_ACCURACY: function() { return "Please review for accuracy."; },
        COURSE_LENGTH_TYPE: {
          SHORT: function() { return "Short"; },
          MEDIUM: function() { return "Medium"; },
          LONG: function() { return "Long"; },
        },

        COURSE_LENGTH: {
          SHORT: function() { return "4-5 sections at most,<br />around 3-8 lessons per section."; },
          MEDIUM: function() { return "5-6 sections at most,<br />around 3-8 lessons per section."; },
          LONG: function() { return "7-8 sections at most,<br />around 3-8 lessons per section."; },
        },

        DELETE_FILE: function() { return "Delete File"; },
        CONTENT_HEADER: function() { return "Which content shall we use?"; },
        GENERATE_NOW: function() { return "Generate Now"; },
        GENERATE: {
          ALERT_SUCCESS_MSG: function(d) { return "Your " + d.courseAlias + " is currently being mocked-up. This may take anywhere from a few minutes up to an hour depending on the files uploaded. We will send you an email when the " + d.courseAlias + " is ready."; },
          ALERT_SUCCESS_HEADER: function() { return "Design in progress!"; },
          ALERT_ERROR_MSG: function() { return "Files uploaded exceed the maximum limit. Please upload files with a combined total of 400 pages or less."; },
        },

        REGENERATE: function() { return "Regenerate"; },
        ERROR_MSG: {
          FILES_LIMIT_ERROR: function(maxFilesCount: number) { return "You can upload up to " + maxFilesCount + " files only. Please reduce the number of files."; },
        },

        SUCCESS_MODEL: {
          PARTY_EMOJI: function() { return "🎉 "; },
          GOOD_NEWS: function() { return "Good News! "; },
          COURSE_SUMMARY: function(d) { return d.CourseAlias + " Summary"; },
          QUICK_SUMMARY: function(d) { return "Your " + d.courseAlias + " is generated, here's a quick summary..."; },
          COURSE_TOPIC_TITLE: function(d) { return "This " + d.courseAlias + " includes topics in:"; },
          ABOUT_COURSE: function(d) { return "👉 This " + d.courseAlias + " engages " + d.learnersAlias + " with the content through discussions and polls, and  ensures high impact learning through submissions, practice and feedback. 📚 📚 📚 "; },
        },

        GENERATED_BY_NOVOAI: function() { return "Generated by NovoAI"; },
        GENERATING_CONTENT: function(firstName: string, lastName: string) { return firstName + " " + lastName + " is Generating content with NovoAI."; },
        COURSE_ITEMS: {
          ALT_TEXT: function(d) { return d.CourseAlias + " Image"; },
        },

        PREVIEW_COURSE_STYLE: function(d) { return "Preview " + d.courseAlias + " style"; },
        LAYOUT_HEADER: function() { return "Which layout to use?"; },
        PREFERENCES_SELECTION: {
          HEADER: function() { return "Any Preferences?"; },
          LENGTH: {
            HEADER: function() { return "Length:"; },
            SHORT: function() { return "Short"; },
            SHORT_SUMMARY_POPOVER: function() { return "3 sentences at most"; },
            SHORT_TAKEAWAYS_POPOVER: function() { return "2 bullets at most<br />1 sentence per bullet"; },
            MEDIUM: function() { return "Medium"; },
            MEDIUM_SUMMARY_POPOVER: function() { return "5 sentences at most"; },
            MEDIUM_TAKEAWAYS_POPOVER: function() { return "4 bullets at most<br />1 sentence per bullet"; },
            LONG: function() { return "Long"; },
            LONG_SUMMARY_POPOVER: function() { return "8 sentences at most"; },
            LONG_TAKEAWAYS_POPOVER: function() { return "8 bullets at most<br />1 sentence per bullet"; },
          },

          TONE: {
            HEADER: function() { return "Tone:"; },
            DEFAULT: function() { return "Default"; },
            DEFAULT_DESCRIPTION: function() { return "It will match the same tone from your content."; },
            PROFESSIONAL: function() { return "Professional"; },
            PROFESSIONAL_DESCRIPTION: function() { return "Use proper language and avoid slang or casual expressions."; },
            FRIENDLY: function() { return "Friendly"; },
            FRIENDLY_DESCRIPTION: function() { return "Use a warm, approachable, and personable style."; },
          },

        },

        AI_RESULT_WARNING: function() { return "Please review for accuracy."; },
        AI_RESULT_WARNING_TEXT: function() { return "NovoAI uses lesson text and videos when transcripts or closed caption files are present."; },
        AI_REGENERATE_WARNING: function() { return "Current text will be overwritten.<br />Please review for accuracy."; },
        CONTENT: {
          LESSON: function(d) { return "Current " + select(d.LectureAlias, { undefined: "Lesson", other: d.LectureAlias }) + " Page"; },
          SUB_SECTION: function() { return "Current Subsection"; },
          SECTION: function() { return "Current Section"; },
        },

        ITEM: {
          TITLE: {
            SUMMARY: function() { return "Summary"; },
            KEY_TAKEAWAYS: function() { return "Key Takeaways"; },
            PRE_SURVEY: function() { return "Pre Survey"; },
            POST_SURVEY: function() { return "Post Survey"; },
            POLL: function() { return "Poll"; },
            DISCUSSION: function() { return "Discussion"; },
            QUIZ: function() { return "Quiz"; },
          },

        },

        SUGGEST_ACTIVITIES: {
          CONTENT: {
            HEADER: function() { return "AI for Learning Activities"; },
            DESCRIPTION: function() { return "Let NovoAI analyze your content and suggest activities."; },
          },

          BUTTON_TEXT: function() { return "Generate Activities"; },
          GENERATING_HEADER: function(count: number) { return "Generated " + count + " activity so far..."; },
          GENERATED_HEADER: function(count: number) { return count + " activities generated for you to consider"; },
          LOADING_DESCRIPTION: function() { return "We're analyzing your content and generating suggestions of different activities for you to choose, it won’t take long..."; },
          SINGLE_SUGGEST_DESCRIPTION: function() { return "We're analyzing your content and generating the component of your choice, it won’t take long..."; },
          SINGLE_SUGGEST_SURVEY_DESCRIPTION: function() { return "Pre or post survey will use the whole course content to generate, it won’t take long..."; },
          FEEDBACK_TITLE: function(activityLink: string, activityTitle: string) { return "Feedback for <a class=\"blue-link\" href=\"" + activityLink + "\" target=\"_blank\">" + activityTitle + "</a>"; },
          ADD_TO_LESSON: function(d) { return "Add to " + d.LectureAlias; },
          ADDED_ALERT: function(d) { return d.type + " has been added to your " + d.lectureAlias + "!"; },
          MULTIPLE_ADDED_ALERT: function(d) { return d.primaryType + " and its " + d.relatedType + " have been added to your " + d.lectureAlias + "."; },
          PREVIEW_MODAL_HEADER: function() { return "Pick a Location to Add the Activity"; },
          ADDED: function() { return "Added"; },
          REQUEST_ALERT: {
            NO_ACTIVITIES: {
              FULL_SUCCESS: {
                TITLE: function() { return "AI Activity Creation Process for this lesson is Completed!"; },
                CONTENT: function() { return "It’s designed exceptionally, we don’t have any additional activities to suggest!"; },
              },

              PARTIAL_ERROR: function() { return "We couldn’t generate some activities this time. Please try again later."; },
            },

            PARTIAL_GENERATION: function() { return "We couldn’t generate some activities this time. We’ve suggested the activities that were available. Please try again later for additional suggestions."; },
          },

        },

        ALERT: {
          ERROR: {
            TITLE: function() { return "Failed!"; },
            SHORT_CONTENT: function() { return "Unable to auto-generate as there isn't enough content. Please add more content to the area you'd like to generate from."; },
          },

          SUCCESS: {
            HEADER: function() { return "Success! Please Note:"; },
            CONTENT: function() { return "AI generated content may contain errors, please review."; },
          },

          NO_ASSIGNMENT: {
            HEADER: function() { return "No assignment found!"; },
            CONTENT: function() { return "We can’t generate the public feedback activity!"; },
          },

        },

      },

    },

    COMPONENTS: {
      ERROR: function() { return "Unable to render"; },
      UNTITLED: function() { return "Untitled"; },
      ADD_COMPONENT: function(d) { return "Add " + select(d.LectureAlias, { undefined: "Lesson", other: d.LectureAlias }) + " Component"; },
      ADD: function() { return "Add"; },
      COPY_TO_ELLIPSIS: function() { return "Copy to..."; },
      COPY_TO_COLON: function() { return "Copy to:"; },
      MOVE_TO_ELLIPSIS: function() { return "Move to..."; },
      MOVE_TO_COLON: function() { return "Move to:"; },
      GENERATING: function() { return "Generating..."; },
      AI_ADD: {
        INITIAL: function() { return "Add Here"; },
        REQUESTING: function() { return "Adding..."; },
      },

      COPY: {
        INITIAL: function() { return "Copy Here"; },
        REQUESTING: function() { return "Copying..."; },
      },

      MOVE: {
        INITIAL: function() { return "Move Here"; },
        REQUESTING: function() { return "Moving..."; },
      },

      CURRENT_PAGE: function() { return "Current Page"; },
      PICK_LOCATION_TITLE: {
        COPY: function() { return "Pick a Location to Copy the Component"; },
        MOVE: function() { return "Pick a Location to Move the Component"; },
      },

      CURRENT_LECTURE_PAGE: function(lectureTitle: string) { return lectureTitle + " (Current Page)"; },
      'LECTURE_PAGE_(CURRENT)': function(isCurrentPage: string, lectureTitle: string) { return lectureTitle + " " + select(isCurrentPage, { true: "(Current Page)", other: "" }); },
      EDIT_OPTIONS: function() { return "Edit Options"; },
      AI_REGENERATE: function() { return "Regenerate"; },
      AI_REGENERATE_ARIA_LABEL: function() { return "Regenerate Button"; },
      LINKED_EDIT_OPTIONS: function(d) { return "The content of this component must be edited in the " + d.lectureAlias + " from the collection"; },
      LINKED_SUBMISSION_DISCOVERY_EDIT_OPTIONS: function() { return "Submission Carousel needs to be set up from the Lesson Library"; },
      DELETE: function() { return "Delete"; },
      NOT_AVAILABLE_YET: function() { return "Not Available Yet"; },
      NO_AVAILABLE_LESSONS: function(d) { return "No Available " + d.LecturesAlias; },
      RELEASE_DEADLINE_CONFLICT: function(d) { return "Activity deadline is before " + d.lectureAlias + " release date."; },
      SET_UP_FROM_COLLECTION_TOOLTIP: function() { return "Need to set this up on lesson from collection"; },
      AI_INSIGHTS: {
        FEEDBACK_FOR_ADMINS: function() { return "AI Feedback for Admins & Advisors"; },
        FEEDBACK_FOR_ADMINS_TOOLTIP: function() { return "Turn On to provide admins and advisors with AI-generated feedback suggestions for submissions."; },
        FEEDBACK_FOR_ADMINS_TOOLTIP_OFF: function() { return "Turn Off AI Feedback for Admins and Advisors."; },
        SETUP: function() { return "AI Insights Setup"; },
        SETUP_DISABLED: function() { return "(Disabled)"; },
        SETUP_DIRECT_TO_LEARNER: function(d) { return "(Enabled: " + d.LearnersAlias + " receive feedback directly)"; },
        SETUP_ADMINS_ONLY: function() { return "(Enabled: Admins and Advisors Only)"; },
        MODAL_TITLE: function() { return "AI Insights Setup"; },
        MODAL_DESCRIPTION: function() { return "Enable AI-powered insights to automatically provide feedback on submissions based on assignment requirements and course content."; },
        OPTION_DISABLED: function() { return "Do not enable"; },
        OPTION_DIRECT: function(d) { return d.LearnersAlias + " receive feedback directly (visible to Admins)"; },
        OPTION_ADMINS: function(d) { return "Admins and Advisors Only (to help draft feedback for " + d.learnersAlias + ")"; },
        INFO_DIRECT: function(d) { return "AI Insights enabled: " + d.learnersAlias + " will receive instant feedback after submitting."; },
        INFO_ADMINS: function() { return "AI Insights enabled: visible only by admins and advisors to help provide feedback."; },
        GENERATING: function() { return "Generating AI Insights..."; },
        GENERATED: function() { return "AI Insights Generated!"; },
        CONTENT_OPTIONS_TITLE: function() { return "Content options for AI to use:"; },
        USE_COURSE_CONTENT: function() { return "Use Course Content"; },
        USE_COURSE_CONTENT_DESCRIPTION: function() { return "AI feedback uses the content of the section/subsection the assignment is placed in, as the approach or methodology learners are expected to use in their submission."; },
        USE_CUSTOM_CONTEXT: function() { return "Use Custom Context"; },
        USE_CUSTOM_CONTEXT_DESCRIPTION: function() { return "Provide custom context below. This should include approach or methodology you expected the learner to use in their submission. AI feedback will use this custom context in place of your section/subsection content."; },
        CUSTOM_CONTEXT_PLACEHOLDER: function() { return "Add description"; },
        CUSTOM_CONTEXT_WORD_COUNT: function(count: number) { return count + " " + plural(count, 0, en, { one: "word", other: "words" }); },
        CUSTOM_CONTEXT_WORD_COUNT_MINIMUM: function() { return "(minimum 300 words required)"; },
        MODAL_CONTENT_LINKED_TOOLTIP: function() { return "Need to set this up on lesson from collection"; },
      },

      NOT_AVAILABLE_IN_COLLECTION: function() { return "Not available at this time for lessons in collections"; },
      NO_COLLECTION_EDIT_PERMISSION: function() { return "You don't have permission to edit in the collection"; },
      EDIT_IN_LIBRARY: function() { return "Edit in Lesson Library"; },
      LINKED_LESSON_NO_QUESTION: function(activity: string) { return "This activity will be shown as \"Not Available yet\" until questions are added to the " + select(activity, { quiz: "quiz", timed_quiz: "timed exam", survey: "survey", other: "" }) + " in the Lesson Library"; },
      PROFILE_COMPLETION_MODAL: {
        SELECT_QUESTIONS: function() { return "Select Required Profile Questions"; },
        INSTRUCTION: function() { return "Please select the questions that are required to be answered by your learners."; },
        ORGANIZATION_PROFILE_FIELDS: function() { return "Organization Profile Fields"; },
        IS_REQUIRED: function() { return "Required?"; },
        COURSE_QUESTIONS: function() { return "Course Profile Questions"; },
        ADD_QUESTIONS: function() { return "Add Questions"; },
        NO_COURSE_QUESTIONS: function() { return "No course profile questions setup yet."; },
      },

      DELETION_MODAL: {
        TITLE: function(componentName: string) { return "Delete " + componentName; },
        SIMPLE_DESCRIPTION: function() { return "Are you sure?"; },
        ACTIVITY_DESCRIPTION: function(componentName: string) { return "Deleting this " + componentName + " will delete the activity configuration, all the user submissions and automated communications based on this activity. Are you sure?"; },
      },

      TODO_MODAL: {
        ADDING: function(d) { return "Adding " + d.componentName + " as a to-do impacts " + d.courseAlias + " completion criteria. Are you sure?"; },
        REMOVING: function(d) { return "Removing " + d.componentName + " as a to-do impacts " + d.courseAlias + " completion criteria. Are you sure?"; },
      },

      SELECT_WITH_DIRECTION: function(isRtlEnable: string) { return "Select from the " + select(isRtlEnable, { true: "right", other: "left" }) + " panel to add component to here"; },
      MOVE_ALREADY_RELEASED: function(d) { return "This " + d.lectureAlias + " is already released, " + d.learnersAlias + " may fail to see your new content and activities."; },
      MOVE_ARE_YOU_SURE: function() { return "Are you sure?"; },
      MOVE_TITLE: function(componentName: string) { return "Move " + componentName; },
      COPY_TO_SUCCESS_MESSAGE: function(lessonTitle: string) { return "The component has been copied to <b>" + lessonTitle + "</b>."; },
      MOVE_TO_SUCCESS_MESSAGE: function(lessonTitle: string) { return "The component has been moved to <b>" + lessonTitle + "</b>."; },
      TAKE_ME_THERE: function() { return "Take Me There"; },
      DUE_DATE: {
        STUDENT_VIEW: function(deadline: string) { return "Due: " + deadline; },
        STUDENT_VIEW_WITHOUT_DUE: function(deadline: string) { return deadline; },
        EDIT_POPOVER: function() { return "Click to Update"; },
        HARD_DEADLINE_DESCRIPTION: function(d) { return "Hard Deadline doesn't allow " + d.learnerAlias + " to submit after the deadline."; },
      },

      TODO: {
        ADD: function() { return "Mark as To-do"; },
        REMOVE: function() { return "Remove To-do"; },
      },

      DROPDOWN: {
        EDIT_BASICS: function() { return "Edit Basics"; },
        EDIT_COMPONENT: function() { return "Edit"; },
        VIEW_BASICS: function() { return "View Basics"; },
        ADD_DEADLINE: function() { return "Add Deadline"; },
        REMOVE_DEADLINE: function() { return "Remove Deadline"; },
        SETUP_IN_LINKED_LESSON_TOOLTIP: function() { return "Need to set this up on each linked lesson"; },
        DELETE_IN_LINKED_LESSON_TOOLTIP: function() { return "Need to delete from collection"; },
        AVAILABLE_IN_LINKED_LESSON_TOOLTIP: function() { return "Available only in linked lessons"; },
      },

      MISSING_FORMAT: {
        DESCRIPTION: function(d) { return "(Note: this activity will be shown as \"Not Available Yet\" until " + d.assignmentAlias + " is added)"; },
        PICK: function() { return "Pick"; },
        EDIT: function() { return "Edit"; },
      },

      RICH_TEXT: {
        DESCRIPTION: function() { return "Rich Text"; },
        DESCRIPTION_LOWERCASE: function() { return "rich text"; },
      },

      COLOR_PICKER: {
        COLOR_INPUT_RIGHT_HAND_BUTTON_TOOLTIP: function() { return "Click to Pick a Color"; },
        COLOR_INPUT_RIGHT_HAND_BUTTON_ARIA: function() { return "Color input button"; },
      },

      ACCORDION: {
        TITLE_PLACEHOLDER: function() { return "Title"; },
        DESCRIPTION: function() { return "Accordion"; },
        DESCRIPTION_LOWERCASE: function() { return "accordion"; },
        DRAG_AND_DROP_TO_REORDER: function() { return "Drag and Drop to Reorder"; },
        CLICK_TO_COLLAPSE: function() { return "Click to Collapse the Section"; },
        CLICK_TO_EXPAND: function() { return "Click to Expand the Section"; },
        CLICK_TO_COLLAPSE_WITH_TITLE: function(sectionTitle: string) { return "Click to Collapse the " + sectionTitle; },
        CLICK_TO_EXPAND_WITH_TITLE: function(sectionTitle: string) { return "Click to Expand the " + sectionTitle; },
        CLICK_TO_COLLAPSE_SECTION: function(sectionName: string) { return "Click to Collapse " + sectionName; },
        CLICK_TO_EXPAND_SECTION: function(sectionName: string) { return "Click to Expand " + sectionName; },
        CLICK_TO_EDIT_STYLE: function() { return "Click to Edit Style"; },
        DELETE_ALL: function() { return "Delete All"; },
        DELETE_THIS_SECTION: function() { return "Delete this Section"; },
        DELETE_SECTION: function(sectionName: string) { return "Delete " + sectionName; },
        APPLY_TO_ALL_SECTIONS: function() { return "Apply to All Sections"; },
        ADDING_NEW_SECTION: function() { return "Adding Accordion Section…"; },
        ADD_NEW_SECTION: function() { return "Add Accordion Section"; },
        TOOLTIP: {
          HEADER_RTE: function() { return "Click to Edit the Section Title"; },
          RIGHT_HAND_TOGGLE_COLOR_PICKER: function() { return "Edit Color for this Section"; },
          LIST_EXPAND: function() { return "Expand templates for Accordion"; },
          LIST_COLLAPSE: function() { return "Collapse"; },
          INSERT_ACCORDION_STYLE_1: function() { return "Insert Accordion Style 1"; },
          INSERT_ACCORDION_STYLE_2: function() { return "Insert Accordion Style 2"; },
          INSERT_ACCORDION_STYLE_3: function() { return "Insert Accordion Style 3"; },
          INSERT_ACCORDION_STYLE_4: function() { return "Insert Accordion Style 4"; },
          INSERT_ACCORDION_STYLE_5: function() { return "Insert Accordion Style 5"; },
        },

        SECTION: {
          DESCRIPTION_WITH_INDEX: function(sectionIndex: string) { return "Accordion Section " + sectionIndex; },
        },

        HEADER_BACKGROUND_COLOR_PICKER_TOOLTIP: function() { return "Pick a color for the accordion section title area"; },
        HEADER_BACKGROUND_COLOR_PICKER_LABEL: function() { return "Title Background Color"; },
        RIGHT_HAND_ICON_COLOR_PICKER_TOOLTIP: function() { return "Pick a color for the icon that indicates open and collapse of the accordion section"; },
        RIGHT_HAND_ICON_COLOR_PICKER_LABEL: function() { return "Icon Color"; },
        CONTENT_BACKGROUND_COLOR_PICKER_TOOLTIP: function() { return "Pick a color for the body text area of this accordion section"; },
        CONTENT_BACKGROUND_COLOR_PICKER_LABEL: function() { return "Text Background Color"; },
      },

      ACCORDION_STYLE_1: {
        DESCRIPTION: function() { return "Accordion style 1"; },
        DESCRIPTION_LOWERCASE: function() { return "accordion style 1"; },
        LINE_COLOR_PICKER_LABEL: function() { return "Line Color"; },
        ICON_COLOR_PICKER_LABEL: function() { return "Icon Color"; },
      },

      ACCORDION_STYLE_2: {
        DESCRIPTION: function() { return "Accordion style 2"; },
        DESCRIPTION_LOWERCASE: function() { return "accordion style 2"; },
        BACKGROUND_COLOR_PICKER_LABEL: function() { return "Background Color"; },
        ICON_COLOR_PICKER_LABEL: function() { return "Icon Color"; },
      },

      ACCORDION_STYLE_3: {
        DESCRIPTION: function() { return "Accordion style 3"; },
        DESCRIPTION_LOWERCASE: function() { return "accordion style 3"; },
        LEFT_HAND_NUMBER_COLOR_PICKER_TOOLTIP: function() { return "Pick a color for the number"; },
        LEFT_HAND_NUMBER_COLOR_PICKER_LABEL: function() { return "Number Color"; },
        LEFT_HAND_NUMBER_BACKGROUND_COLOR_PICKER_TOOLTIP: function() { return "Pick a color for the background of the number"; },
        DISABLE_ADD_NEW_SECTION: function() { return "For this accordion style, a maximum of 9 sections can be added."; },
      },

      ACCORDION_STYLE_4: {
        DESCRIPTION: function() { return "Accordion style 4"; },
        DESCRIPTION_LOWERCASE: function() { return "accordion style 4"; },
        LEFT_HAND_LETTER_COLOR_PICKER_TOOLTIP: function() { return "Pick a color for the letter"; },
        LEFT_HAND_LETTER_COLOR_PICKER_LABEL: function() { return "Letter Color"; },
        LEFT_HAND_LETTER_BACKGROUND_COLOR_PICKER_TOOLTIP: function() { return "Pick a color for the background of the letter"; },
        DISABLE_ADD_NEW_SECTION: function() { return "For this accordion style, a maximum of 26 sections can be added."; },
      },

      ACCORDION_STYLE_5: {
        DESCRIPTION: function() { return "Accordion style 5"; },
        DESCRIPTION_LOWERCASE: function() { return "accordion style 5"; },
        LEFT_HAND_PICTURE_ALT: function() { return "Accordion Section Icon"; },
        LEFT_HAND_CIRCLE_PICTURE_BACKGROUND_COLOR_PICKER_TOOLTIP: function() { return "Only visible if the uploaded image is smaller than 45px by 45px"; },
        LEFT_HAND_SQUARE_PICTURE_BACKGROUND_COLOR_PICKER_TOOLTIP: function() { return "Only visible if the uploaded image is smaller than the header height"; },
        LEFT_HAND_ICON_BACKGROUND_COLOR_PICKER_TOOLTIP: function() { return "Pick a color for the background of the icon"; },
        LEFT_HAND_ICON_COLOR_PICKER_TOOLTIP: function() { return "Pick a color for the icon"; },
        LEFT_HAND_ICON_COLOR_PICKER_LABEL: function() { return "Icon Color"; },
        LEFT_HAND_BACKGROUND_COLOR_PICKER_LABEL: function() { return "Background Color"; },
        UPLOAD: function() { return "Upload"; },
        PICK_FROM_LIBRARY: function() { return "Pick from Library"; },
        CHANGE_COLORS_AND_STYLE: function() { return "Change Colors and Styles"; },
      },

      ABSTRACT_ORDERED_STYLE: {
        BACKGROUND_COLOR_PICKER_LABEL: function() { return "Background Color"; },
      },

      AI_ROLE_PLAY: {
        PRACTICE: function() { return "Practice"; },
        DEFAULT_TITLE: function() { return "AI Roleplay"; },
        START_AI_ROLE_PLAY: function() { return "Start Roleplay"; },
        ADD_DESCRIPTION: function() { return "Add description"; },
        LAST_COMPLETED_ON: function(date: string) { return "Last completed on " + date; },
        COMPLETED_ON: function(date: string) { return "Completed on " + date; },
        SESSION_ENDED_ON: function(date: string) { return "Session ended on " + date; },
        EDIT_DROPDOWN: {
          EDIT_ROLE_PLAY: function() { return "Edit Roleplay Details"; },
        },

        ADMIN_ONLY: function() { return "Admin Only:"; },
        VIEW_ROLEPLAY_RESULTS: function() { return "View Roleplay Results"; },
        TITLE: function() { return "AI Roleplay"; },
        DISABLED_TOOLTIP: function() { return "Please enable Generative AI Capabilities for the organization in order to use this new activity."; },
        EMPTY_FEEDBACK: function() { return "Feedback could not be generated."; },
        MODAL: {
          CREATE_TITLE: function() { return "Create Roleplay"; },
          CREATE_WITH_NOVOAI: function() { return "Create with NovoAI"; },
          LETS_CREATE_ROLE_PLAY: function() { return "👋 Let’s Create Your AI Roleplay"; },
          READING_CONTENT: function() { return "Reading your content"; },
          WRITING_CONTEXT: function() { return "Writing the context"; },
          CREATING_AI_OBJECTIONS: function() { return "Coming up with AI character's objections"; },
          CREATING_LEARNER_GOALS: function(d) { return "Coming up with " + d.learnerAlias + "’s goals"; },
          FINAL_TOUCH: function() { return "Final touches, almost done"; },
          CANNOT_GENERATE_SCENARIO: function() { return "Sorry we have encountered an issue and can’t generate the details for now."; },
          PRACTICE_AGAIN: function() { return "Practice Again"; },
          GENERATE_YOUR_ROLE_PLAY_CONTENT: function(d) { return "I'll generate your AI Roleplay based on content in your immediate section or subsection. What conversation or situation do you want " + d.learnersAlias + " to work through?"; },
          LEARN_MORE_ABOUT_APPROACH: function() { return "Learn more about my approach."; },
          LEARN_ABOUT_APPROACH_POPOVER: {
            TITLE: function() { return "How Does NovoAI Create Roleplay Scenarios?"; },
            FIRST_DESCRIPTION: function() { return "NovoAI uses content from the current section or subsection — including text, video/audio, and files (SCORM and spreadsheets not supported) — to build the scenario, drive the narrative, and provide feedback."; },
            SECOND_DESCRIPTION: function() { return "The AI is grounded in your course content (lesson materials, transcripts, and scenario setup). Where key details are missing, it draws on general real-world training knowledge to fill gaps."; },
            THIRD_DESCRIPTION: function() { return "Review the generated context, objections, and learning goals for accuracy, as these control the conversation flow."; },
            ADVANCED_DESIGN: function() { return "Advanced Design: How Experts Use Roleplays"; },
          },

          GENERATE_ROLE_PLAY: function() { return "Generate Roleplay"; },
          MANUALLY_CREATE: function() { return "Manually Create Instead"; },
          CONTENT_CRITICALLY_INSUFFICIENT: function() { return "<b>Warning</b>: Content in the immediate section/subsection was too short to generate the roleplay form. Please fill out the form manually or go back and add more content in the immediate section/subsection and create a new roleplay."; },
          CONTENT_INSUFFICIENT: function() { return "<b>Warning:</b> Content is too short and may result in inconsistent behaviors during roleplay. We recommend adding more content in the immediate section/subsection and create a new roleplay."; },
          THE_CONTEXT: function() { return "The Context"; },
          INSTRUCTION_LABEL: function(d) { return "Give the AI instructions about the scenario. Start with \"You will tell the " + d.learnerAlias + " that...\" or \"You are in a situation where...\" Include background information, why this conversation is needed, and what led to this moment:"; },
          THE_CHARACTERS: function() { return "The Characters"; },
          AI_CHARACTER: function() { return "AI Character"; },
          CUSTOMIZE_AI_CHARACTER_TEXT: function() { return "Customize your AI character's name, role, personality and image."; },
          UNNAMED_CHARACTER: function() { return "Unnamed Character *"; },
          AI_CHARACTER_PERSONALITY_TEXT: function() { return "Personality:"; },
          AI_BACK_TO_ROLEPLAY: function() { return "Back to Roleplay Details"; },
          AI_PROFILE_PHOTO: function() { return "AI Profile Photo"; },
          AI_PROFILE_PHOTO_UPLOAD_TEXT: function() { return "Select or upload a static image to represent your AI character."; },
          AI_VOICE: {
            AI_CHARACTER_VOICE: function() { return "AI Character’s Voice"; },
            AI_COMING_SOON: function() { return "COMING SOON"; },
            AI_VOICE_COMING_SOON: function() { return "AI-generated voices are coming soon, bringing your roleplay experiences to life with more realistic conversations."; },
          },

          LEARNER_ROLE: function(d) { return d.LearnerAlias + "'s Role"; },
          DEFAULT_AI_CHARACTER_NAME: function() { return "Jamie"; },
          WHAT_ROLE_PLAYING: function() { return "What role the learner is playing."; },
          AI_CHARACTER_PROFILE: {
            AVATAR: function() { return "AI avatar"; },
            SELECT: function() { return "Select"; },
            SELECT_CUSTOM_IMAGE: function() { return "Click to select a custom image"; },
          },

          AI_CHARACTER_DETAILS: {
            AI_CHARACTER_ROLE: function() { return "Role"; },
            AI_CHARACTER_NAME: function() { return "Name"; },
            AI_CHARACTER_PERSONALITY: function() { return "Personality"; },
          },

          AI_CHARACTER_ROLE_UPDATED: function() { return "AI Character’s Role has been updated."; },
          AI_CHARACTER_NAME_UPDATED: function() { return "AI Character’s Name has been updated."; },
          AI_CHARACTER_PERSONALITY_TOOLTIP_TEXT: function() { return "Additional details around the personality and tone can be provided in the context"; },
          TELL_AI_TO_BEHAVE: function() { return "Tell the AI how to behave."; },
          AI_CHARACTER_OBJECTIONS: function() { return "AI Character’s Objections"; },
          TELL_AI_TO_SAY: function() { return "Tell the AI what to say. Write specific things the AI character should say during the conversation - questions, concerns, pushback, or emotional reactions:"; },
          THE_LEARNER_GOALS: function(d) { return "The " + d.LearnerAlias + "'s Goals"; },
          WRITE_LEARNER_OBJECTIVES: function(d) { return "What are the goals the " + d.learnerAlias + " needs to achieve during this conversation?"; },
          ADD_MORE: function() { return "Add More"; },
          DISABLED_ADD_MORE_TOOLTIP: function(count: number) { return "Maximum of " + count; },
          ADD_OBJECTIONS: function() { return "Add Objections"; },
          DELETE_FIELD: function() { return "Delete field"; },
          PERSONALITIES: {
            IRRITABLE: function() { return "Irritable"; },
            NEUTRAL: function() { return "Neutral"; },
            DISINTERESTED: function() { return "Disinterested"; },
          },

        },

        CONVERSATION_MODAL: {
          ROLE_PLAY: function() { return "Roleplay:"; },
          AI_CHARACTER_AVATAR: function() { return "AI character avatar"; },
          YOU: function() { return "You"; },
          THE_SCENARIO: function() { return "The Scenario"; },
          YOUR_ROLE: function() { return "Your Role"; },
          THE_SITUATION: function() { return "The Situation"; },
          YOUR_GOAL: function() { return "Your Goal"; },
          BEGIN: function() { return "Begin"; },
          START_OVER: function() { return "Start Over"; },
          EXIT_CHAT: function() { return "Exit Chat"; },
          EXIT: function() { return "Exit"; },
          HIDE_SCENARIO: function() { return "Hide Scenario"; },
          SHOW_SCENARIO: function() { return "Show Scenario"; },
          SEND_MESSAGE_PLACEHOLDER: function() { return "Write a message..."; },
          SEND_MESSAGE: function() { return "Send message"; },
          SESSION_ENDED: function() { return "Session has ended."; },
          INACTIVE_SESSION: function() { return "You’ve been inactive for more than 5 minutes."; },
          SOMETHING_WENT_WRONG: function() { return "Something went wrong, try again."; },
          FINISHED_ROLE_PLAY: function() { return "You’ve finished the roleplay!"; },
          ROLE_PLAY_ENDED_DUE_TO_RESPONSE: function() { return "Roleplay has ended due to your recent response."; },
          LOOK_ON_FEEDBACK: function() { return "Take a look at your feedback."; },
          REVIEWING_CONVERSATION: function() { return "Reviewing your conversation"; },
          COMPARING_LEARNER_GOALS: function() { return "Comparing it to your learning goals"; },
          PREPARING_FEEDBACK: function() { return "Preparing your feedback"; },
          NEEDS_WORK: function() { return "Needs Work"; },
          EXCELLENT: function() { return "Excellent!"; },
          DID_WELL: function() { return "Where You Did Well"; },
          YOU_NEED_GROW: function() { return "Where You Can Grow"; },
          AI_HOST_URL_MISSING_ERROR: function() { return "Missing required AI host URL"; },
          START_AUDIO_RECORDING: function() { return "Start Audio Recording"; },
          STOP_AND_DICTATE_AUDIO_RECORDING: function() { return "Stop and Dictate Audio Recording"; },
          ABORT_RECORDING: function() { return "Abort Recording"; },
          DICTATION_NOT_ENABLED: function() { return "Dictation is not enabled in your organization."; },
          MIC_PERMISSION_DENIED: function() { return "We do not have permission to access the microphone."; },
          DICTATE: function() { return "Dictate"; },
          START_OVER_CONFIRMATION: {
            MESSAGE: function() { return "You will restart the conversation and won’t receive any feedback."; },
            CONFIRM: function() { return "Yes, Start Over"; },
          },

          EXIT_CHAT_CONFIRMATION: {
            MESSAGE: function() { return "You will exit the conversation and won’t receive any feedback."; },
            CONFIRM: function() { return "Yes, Exit Chat"; },
          },

        },

        SUBMISSION_LIST: {
          FILTER: {
            ALL: function(count: number) { return "All (" + count + ")"; },
            EXCELLENT: function(count: number) { return "Excellent (" + count + ")"; },
            GOOD_JOB: function(count: number) { return "Good Job (" + count + ")"; },
            NEEDS_WORK: function(count: number) { return "Needs Work (" + count + ")"; },
          },

          SEARCH_PLACEHOLDER: function() { return "Search by name or email"; },
          SORTED_BY_RECENT: function() { return "Sorted by most recent practice"; },
          NO_SUBMISSIONS: function() { return "No submissions found"; },
          ARIA_LABEL: {
            SEARCH: function() { return "Search submissions by name or email"; },
            FILTER: function() { return "Filter submissions"; },
          },

        },

        FEEDBACK_FOR: function() { return "Feedback for:"; },
        BACK_TO_ALL_RESULTS: function() { return "Back to All Results"; },
      },

      POLLS: {
        DESCRIPTION: function() { return "Poll"; },
        DEFAULT_TITLE: function() { return "Poll"; },
        TITLE_PLACEHOLDER: function() { return "Type your question here..."; },
        OPTION_INPUT_PLACEHOLDER: function(displayIndex: string) { return "Option " + displayIndex; },
        ADD_OPTION: function() { return "Add Option"; },
        SUBMIT_VOTE: function() { return "Submit"; },
        HEADER_TAKE_TITLE: function() { return "Participate"; },
        TITLE_ARIA_LABEL: function(title: string) { return "Participate in the poll - " + title; },
        VIEW_POLL_RESULTS: function() { return "View Poll Result"; },
        HIDE_POLL_RESULTS: function() { return "Hide Poll Result"; },
        VIEW_RESULTS_ADMINS_ONLY: function(d) { return "Admins can view results at anytime. " + d.learnerAlias + " see results when they participate in the poll or poll deadline expires."; },
        ADMINS_CANNOT_VOTE: function() { return "Course admins cannot participate in polls"; },
        SELECT_ALL_THAT_APPLY: function() { return "Select all that apply:"; },
        SELECT_ONE: function() { return "Select one:"; },
        SINGLE_SELECTION_CREATOR_INFO: function(d) { return d.learnerAlias + " will see \"Select one\" for the single selection"; },
        MULTIPLE_SELECTION_CREATOR_INFO: function(d) { return d.learnerAlias + " will see \"Select all that apply\" for the multiple selection"; },
        POLL_RELEASED: function(d) { return "The poll has been released to " + d.learnersAlias + ". You cannot change the poll type."; },
        EDIT_DROPDOWN: {
          ADD_DEADLINE: function() { return "Add Deadline"; },
          REMOVE_DEADLINE: function() { return "Remove Deadline"; },
          SOCIAL_POLL: function() { return "Social Poll"; },
          SOCIAL_POLL_INFO_TOOLTIP: function() { return "Learners see profile pictures of those who recently voted for each option. You can download learner responses from Data Downloads."; },
          ANONYMOUS_POLL: function() { return "Anonymous Poll"; },
          ANONYMOUS_POLL_INFO_TOOLTIP: function() { return "Learners see the percentage of learners who chose each option. You can download learner responses from Data Downloads."; },
          SINGLE_SELECTION: function() { return "Single Selection"; },
          SINGLE_SELECTION_INFO_TOOLTIP: function(d) { return d.learnerAlias + " can select one poll option."; },
          MULTIPLE_SELECTION: function() { return "Multiple Selection"; },
          MULTIPLE_SELECTION_INFO_TOOLTIP: function(d) { return d.learnerAlias + " can select more than one poll option."; },
          DELETE_WARNING: function() { return "Deleting this poll will delete the activity configuration, all the user submissions and automated communications based on this activity. Are you sure?"; },
        },

      },

      HTML: {
        DESCRIPTION: function() { return "HTML"; },
        TOOLTIP: function() { return "Insert a Rich Text component with HTML"; },
      },

      TEXT: {
        DESCRIPTION: function() { return "Text"; },
        TOOLTIP: function() { return "Insert Simple Text component"; },
      },

      HEADER: {
        TEXT_COLOR: function() { return "Text Color"; },
        BACKGROUND_COLOR: function() { return "Background Color"; },
        BORDER_COLOR: function() { return "Border Color"; },
        ICON_COLOR: function() { return "Icon Color"; },
        PICK_FROM_LIBRARY: function() { return "Pick From Library"; },
        CHANGE_COLORS: function() { return "Change Colors and Styles"; },
        UPLOAD: function() { return "Upload"; },
      },

      UPDATE_COURSE_COLOR: {
        COLOR: function() { return "Color"; },
        UPDATE_COLORS: function() { return "Update Colors"; },
        UPDATE_COLOR_FOR: function() { return "Update Colors for:"; },
        FIND_THIS_COLOR: function() { return "Find this color:"; },
        REPLACE_WITH_NEW_COLOR: function() { return "Replace with new color:"; },
        UPDATE_COLORS_BUTTON: function() { return "Update Colors"; },
        PLACEHOLDER_VALUE: function() { return "#Hex code"; },
        DROPDOWN_SECTION: {
          CURRENT_LESSON: function(d) { return "Current " + d.LectureAlias; },
          CURRENT_SUB_SECTION: function() { return "Current Subsection"; },
          CURRENT_SECTION: function() { return "Current Section"; },
          ALL_LESSONS: function(d) { return "All " + d.LecturesAlias; },
        },

        ALERT_MESSAGES: {
          ALERT_INFO_HEADER: function() { return "Updating colors in progress..."; },
          ALERT_INFO_DESCRIPTION: function() { return "Please wait on making additional color changes to prevent errors."; },
          ALERT_SUCCESS_HEADER: function() { return "Success!"; },
          ALERT_SUCCESS_MSG: function(findColor: string, replaceColor: string) { return "Color updates have completed! We've replaced colors using " + findColor + " with " + replaceColor + ". Please reload your browser to see the updates."; },
          ALERT_ERROR_HEADER: function() { return "Colors haven't been updated."; },
          ALERT_ERROR_MSG: function(findColor: string) { return "The " + findColor + " was not found in the area you wanted to update."; },
        },

        TOOLTIP_TEXT: {
          TOOLTIP_TEXT_FOR_LINKED_LESSON: function(d) { return "Color changes for this " + d.lectureAlias + " must be done from the Lesson Library"; },
          TOOLTIP_TEXT_UPDATING_IN_PROGRESS: function() { return "Updating in progress"; },
        },

      },

      IMAGE: {
        DESCRIPTION: function() { return "Image"; },
        TOOLTIP: function() { return "Insert Image component"; },
        RESIZE_TOOLTIP: function() { return "Resize Image"; },
        ALIGN_TOOLTIP: function() { return "Adjust Alignment"; },
        ROTATE_TOOLTIP: function() { return "Rotate"; },
        CROPT_IMAGE: function() { return "Crop"; },
        ALT_TEXT_TOOLTIP: function() { return "Alt"; },
        UPLOAD_TOOLTIP: function() { return "Replace With a New Image"; },
        CLICK_TO_VIEW: function() { return "Click to View Full Image"; },
        FULL_SCREEN_IMAGE: function() { return "Full Screen Image"; },
        EDIT: function() { return "Edit Image"; },
        CAPTION_PLACEHOLDER: function() { return "Add Image Caption (Optional)"; },
        FULL_WIDTH: function() { return "Full"; },
        CROP_MODAL: {
          HEADER: function() { return "Crop Image"; },
          RESET: function() { return "Reset"; },
        },

        ALT_TEXT_MODAL: {
          HEADER: function() { return "Alt Text"; },
          PROMPT: function() { return "Write a brief description for screen readers."; },
          DESCRIPTION: function() { return "This description will not be shown on the UI and is for the purpose of accessibility compliance."; },
          PLACEHOLDER: function() { return "E.g., A cat is resting on the road taking a nap."; },
        },

      },

      PROFILE_COMPLETION: {
        VIEW_PROFILE: function() { return "View Profile"; },
        DESCRIPTION: function() { return "Profile Completion"; },
        DEFAULT_TITLE: function() { return "Complete Your Profile"; },
        COMPLETE_PROFILE: function() { return "Complete Your Profile"; },
        EDIT_COURSE_PROFILE_QUESTIONS: function() { return "Edit Course Profile Questions"; },
        SELECT_REQUIRED_QUESTIONS: function() { return "Select Required Profile Questions"; },
        UNAVAILABLE: function(lectureName: string) { return "Profile Completion is already added to " + lectureName + "."; },
        NOTE: function(editMode: string) { return "Note: To complete this activity, please complete questions with " + select(editMode, { true: "(*)", other: "<span class=\"label text-danger\">*</span>" }); },
        PROFILE_COMPLETION_WARNING: function() { return "Finish filling in all the required questions in the linked lesson for the course related to this activity."; },
      },

      CONTENT_TEMPLATES: {
        EDIT_STYLE: function() { return "Edit Style"; },
        UPLOAD_IMAGE: function() { return "Upload an Image"; },
        UPDATE_IMAGE: function() { return "Update Image"; },
        UPLOAD_BACKGROUND_IMAGE: function() { return "Upload a Background Image"; },
        UPDATE_BACKGROUND_IMAGE: function() { return "Update Background Image"; },
        REMOVE_BACKGROUND_IMAGE: function() { return "Remove Background Image"; },
        HEADER_SAMPLE_CONTENT: function() { return "Title"; },
        HEADER_PLACEHOLDER: function() { return "Title"; },
        LINE_LABEL: function() { return "Line"; },
        WHITE_SPACE_LABEL: function() { return "Spacer"; },
        BLURB_SAMPLE_CONTENT: function() { return "Not just a great valley, but a shrine to human foresight, the strength of granite, the power of glaciers, the persistence of life."; },
        BLURB_BACKGROUND_IMAGE_SAMPLE_CONTENT: function() { return "Not just a great valley, but a shrine to human foresight, the strength of granite, the power of glaciers."; },
        ACCORDION_LABEL: {
          HEADER: function() { return "Title"; },
          BLURB: function() { return "Text with Image"; },
        },

        LABELS: {
          COMPONENT_WIDTH: function() { return "Component Width"; },
          FULL_SCREEN: function() { return "Full Screen"; },
          LINE_COLOR: function() { return "Line Color"; },
          LINE_THICKNESS: function() { return "Thickness"; },
          COLOR_BAR: function() { return "Color Bar"; },
          IMAGE_BACKGROUND: function() { return "Image Background Color"; },
          FIXED_IMAGE_WIDTH: function() { return "Fixed Image Width"; },
          IMAGE_WIDTH: function() { return "Image Width"; },
          IMAGE_STYLE: function() { return "Image Style"; },
          SHAPE: {
            SQUARE: function() { return "Square"; },
            ORIGINAL: function() { return "Original Photo Ratio"; },
            CIRCLE: function() { return "Circle"; },
          },

          IMAGE_PLACEMENT: function() { return "Image Placement"; },
          ALIGN: {
            LEFT: function() { return "Align to Left"; },
            CENTER: function() { return "Align to Center"; },
            RIGHT: function() { return "Align to Right"; },
            TOP: function() { return "Align to Top"; },
            MIDDLE: function() { return "Align to Center"; },
            BOTTOM: function() { return "Align to Bottom"; },
          },

          IMAGE_ALT: function() { return "Image Alt Text (Optional)"; },
          TITLE_COLOR: function() { return "Title Color"; },
          TITLE_BACKGROUND: function() { return "Title Background"; },
          TEXT_COLOR: function() { return "Text Color"; },
          TEXT_STYLE: function() { return "Text Style"; },
          TEXT_BACKGROUND: function() { return "Background Color"; },
          TEXT_POSITION: function() { return "Text Position"; },
          TEXT_ALIGNMENT: function() { return "Text Alignment"; },
          TEXT_WIDTH: function() { return "Text Content Width"; },
          MINIMUM_HEIGHT: function() { return "Minimum Height"; },
          DROPDOWN_VALUES: {
            '10%': function() { return "10%"; },
            '20%': function() { return "20%"; },
            '30%': function() { return "30%"; },
            '40%': function() { return "40%"; },
            '50%': function() { return "50%"; },
            '60%': function() { return "60%"; },
            '70%': function() { return "70%"; },
            '80%': function() { return "80%"; },
            '90%': function() { return "90%"; },
            '100%': function() { return "100%"; },
            FULL_WIDTH: function() { return "Full Screen"; },
            TITLE: function() { return "Title"; },
            SMALL_TITLE: function() { return "Small Title"; },
            SUBTITLE: function() { return "Subtitle"; },
            BIG_TEXT: function() { return "Big Text"; },
            MEDIUM_TEXT: function() { return "Medium Text"; },
            REGULAR_TEXT: function() { return "Regular Text"; },
            SMALL_TEXT: function() { return "Small Text"; },
          },

        },

        BURB_BACKGROUND_IMAGE: {
          PLACEHOLDER: function() { return "Type in your text here"; },
        },

        TOOLTIP: {
          LIST_COLLAPSE: function() { return "Collapse"; },
          HEADER_LIST: function() { return "Expand templates for Title"; },
          BLURB_IMAGE_LIST: function() { return "Expand templates for Text with Image"; },
          LINE: function() { return "Insert a Line"; },
          HEADER: function() { return "Insert Title Style 1"; },
          HEADER_TAB: function() { return "Insert Title Style 2"; },
          HEADER_IMAGE: function() { return "Insert Title Style 3"; },
          BLURB_SIDE_IMAGE: function() { return "Insert template: Image Next to Text"; },
          BLURB_BACKGROUND_IMAGE: function() { return "Insert template: Text with Background"; },
          BLURB_TOP_IMAGE: function() { return "Insert template: Image Above Text"; },
          STYLED_LINK_LIST: function() { return "Expand templates for Styled Link"; },
          CARD_STYLED_LINK: function() { return "Insert Card Styled Link"; },
          BUTTON_STYLED_LINK: function() { return "Insert Button Styled Link"; },
          WHITE_SPACE: function() { return "Insert a Spacer"; },
        },

      },

      VIDEO_LIST: {
        DESCRIPTION: function() { return "Video"; },
        DESCRIPTION_LOWERCASE: function() { return "video"; },
        DELETE: function() { return "Delete Playlist"; },
      },

      AUDIO_LIST: {
        DESCRIPTION: function() { return "Audio"; },
        DESCRIPTION_LOWERCASE: function() { return "audio"; },
      },

      FLIP_CARD: {
        DESCRIPTION: function() { return "Flip Card"; },
        DESCRIPTION_LOWERCASE: function() { return "flip card"; },
        TOOLTIP: function() { return "Insert a Flip Card"; },
        EDIT: {
          INSTRUCTIONS: function() { return "Add text to the cards below. The left side displays the front, and the right side displays the back."; },
          FRONT: function() { return "Front"; },
          BACK: function() { return "Back"; },
          ADD_CARD: function() { return "Add Card"; },
          REMOVE_CARD: function() { return "Remove card"; },
          MIN_CARDS: function() { return "Minimum 3 cards required"; },
          MAX_CARDS: function() { return "Maximum 6 cards reached"; },
          REORDER_CARD: function() { return "Drag to reorder card"; },
          DRAG_AND_DROP_TO_REORDER: function() { return "Drag and Drop to Reorder"; },
          CHARACTER_COUNT: function(count: number, maxCount: number) { return count + "/" + maxCount; },
          SAVING: function() { return "Saving"; },
          SAVED: function() { return "Saved"; },
          ERROR: function() { return "Error"; },
        },

        A11Y: {
          VIEW_BACK: function() { return "Activate to view the back of the card"; },
          VIEW_FRONT: function() { return "Activate to view the front of the card"; },
        },

      },

      ATTACHMENT_LIST: {
        DESCRIPTION: function() { return "Files"; },
        TOOLTIP: function() { return "Upload a File"; },
        DESCRIPTION_LOWERCASE: function() { return "files"; },
        OPEN_IN_LIGHTBOX: function() { return "Open in Lightbox"; },
        EMBED_ON_LECTURE_PAGE: function(d) { return "Embed on " + d.lectureAlias; },
        BIG_FILE_EMBED_TOOLTIP: function() { return "Files must be less than 10 MB for the preview to appear."; },
        ZIP_EMBED_TOOLTIP: function() { return "Zip files cannot be embedded."; },
        ALLOW_FILE_DOWNLOAD: function() { return "Allow File Download"; },
        ZIP_DOWNLOAD_TOOLTIP: function(d) { return "Zip files are supported as a download on " + d.lecturesAlias + "."; },
        EMBEDDING_STYLE: {
          HEADER: function() { return "Adjust Size"; },
          '4BY3': function() { return "4:3"; },
          '16BY9': function() { return "16:9"; },
          '21BY9': function() { return "21:9"; },
          '1BY1': function() { return "1:1"; },
          A4: function() { return "A4"; },
          LETTER: function() { return "Letter"; },
          MANUALLY_SET_SIZE: function() { return "Manually Set Size"; },
        },

      },

      EXERCISE: {
        DESCRIPTION: function(d) { return d.AssignmentAlias; },
        DESCRIPTION_LOWERCASE: function(d) { return d.assignmentAlias; },
        TEAM_FORMATION_AND_ASSIGNMENT_ADDING: function(d) { return "We are adding the " + d.teamAlias + " formation " + d.assignmentAlias + " and the new " + d.assignmentAlias + " that will be using it to your " + d.lectureAlias + ". Please wait..."; },
        TEAM_FORMATION_AND_ASSIGNMENT_ADDED_HEADER: function(d) { return d.TeamAlias + " Formation Activity and " + d.TeamAlias + " " + d.AssignmentAlias + " Activity have been added to the " + d.LectureAlias; },
        TEAM_FORMATION_AND_ASSIGNMENT_ADDED_DESCRIPTION: function(d) { return "You can move the " + d.teamAlias + " formation activity to any " + d.lectureAlias + ". Preferably, one that will be released before the current " + d.lectureAlias + "."; },
        VIEW_RELATED_FEEDBACK: function() { return "View Related Feedback Activity"; },
        DONE: function() { return "Done"; },
        TEAM_TYPE_MODAL: {
          COURSE_ADD: function(d) { return "Add course-long teams and use them for this " + d.assignmentAlias; },
          ASSIGNMENT: function(d) { return "Introduce new teams to be used in this " + d.assignmentAlias + " only"; },
        },

        DROPDOWN: {
          EDIT_BASICS: function() { return "Edit Basics"; },
          EDIT_TEAMS: function(d) { return "Edit " + d.TeamsAlias; },
          ADD_RESOURCES: function() { return "Add Resources"; },
          SUBMISSION_PRIVACY: function() { return "Submission Privacy"; },
          CHANGE_TO_TEAM_ASSIGNMENT: function(d) { return "Change to " + d.TeamAlias + " " + d.AssignmentAlias; },
          CHANGE_TO_INDIVIDUAL_ASSIGNMENT: function(d) { return "Change to Individual " + d.AssignmentAlias; },
          ADVANCED_OPTIONS: function() { return "Advanced Options"; },
        },

        EDIT_SUBMISSION_FORMAT: function() { return "Edit Submission Format"; },
        SYSTEM_GENERATED: function() { return "System generated, can not be edited"; },
        MODAL: {
          INDIVIDUAL_TEAM: {
            TITLE: function(d) { return "Add " + d.AssignmentAlias; },
            INDIVIDUAL: function(d) { return "Individual " + d.AssignmentAlias; },
            TEAM: function(d) { return d.TeamAlias + " " + d.AssignmentAlias; },
            INDIVIDUAL_NEXT: function() { return "Next: Add Submission Format"; },
            ADVANCED_OPTIONS: function() { return "Advanced Options"; },
          },

          TEAM_TYPE: {
            TITLE: {
              ADD: function(d) { return "Add " + d.TeamAlias + " " + d.AssignmentAlias; },
              CHANGE: function(d) { return "Change to " + d.TeamAlias + " " + d.AssignmentAlias; },
              EDIT: function() { return "Edit Basics"; },
              ADD_TEAM_FORMATION: function(d) { return "Add " + d.TeamAlias + " Formation"; },
            },

            COURSE_TEAM_ADD: function(d) { return "Add " + d.courseAlias + "-long " + d.teamsAlias + " and use them for this " + d.assignmentAlias; },
            COURSE_TEAM_EXISTING: function(d) { return "Use " + d.courseAlias + "-long " + d.teamsAlias; },
            ASSIGNMENT_TEAM: function(d) { return "Introduce new " + d.teamsAlias + " to be used in this " + d.assignmentAlias + " only"; },
            ADD: function() { return "Add"; },
            SIZE: function(d) { return d.TeamOrGroupTitleAlias + " Size Limit:"; },
          },

        },

        PRIVACY_MODAL: {
          TITLE: function() { return "Submission Privacy"; },
          DESCRIPTION: function(d) { return "Submissions for this " + d.assignmentAlias + " are"; },
          SHARABLE_WITH_INSTRUCTOR: function(d) { return "Submission is private between " + d.learnerAlias + "/" + d.teamAlias + " and " + d.teachingTeamAlias + " members with appropriate permissions"; },
          SHARABLE_WITH_INSTRUCTOR_AND_TEAM: function(d) { return "Allow sharing private submissions with " + d.teamsAlias + "/" + d.groupsAlias + " after submission"; },
          SHARABLE_WITH_INSTRUCTOR_OR_CLASS: function(d) { return "Submission is shared with the " + d.courseAlias + " and can be shared privately between " + d.learnerAlias + "/" + d.teamAlias + " and " + d.teachingTeamAlias + " members with appropriate permissions"; },
          SHARABLE_WITH_CLASS_ONLY: function(d) { return "Submission is shared with the " + d.courseAlias; },
          SHARABLE_WITH_PUBLIC: function(d) { return "Submission is shared with the " + d.courseAlias + " and can be shared privately between " + d.learnerAlias + "/" + d.teamAlias + " and " + d.teachingTeamAlias + " members with appropriate permissions or shared publicly on the web"; },
          SHARABLE_WITH_PUBLIC_ONLY: function() { return "Submission is shared publicly on the web"; },
        },

        ADVANCED_MODAL: {
          TITLE: function() { return "Advanced Options"; },
          NUMBER_OF_SUBMISSIONS: function() { return "Number of Submissions"; },
          NUMBER_OF_SUBMISSIONS_DISABLED: {
            TEAM_ASSIGNMENT: function(d) { return d.TeamAlias + " " + d.assignmentsAlias + " allow only one submission."; },
            SUBMISSION_APPROVAL: function(d) { return "Submission approval is enabled for this " + d.assignmentAlias + ". Multiple submissions are not allowed."; },
            PRIVATE_FEEDBACK: function() { return "Enabling evaluations changes the number of allowed submissions to one."; },
          },

          IS_VOTABLE: function(d) { return d.LearnersAlias + " can vote up the submissions they like"; },
          SUBMISSIONS_VIEWABLE_BEFORE_DEALINE: function(d) { return d.LearnersAlias + " can view all submissions before the deadline expires"; },
          ALLOW_SHARE_TO_WORKSPACE: function(d) { return "Prompt " + d.learnersAlias + " to optionally post to workspace after submission"; },
          ALLOW_SHARE_TO_WORKSPACE_NOTE: function(d) { return "Please Note: In addition to the above config, the prompt will be displayed only if the submission is shareable based on its settings and user is in a " + d.courseAlias + "-long " + d.teamAlias + "/" + d.groupAlias + "."; },
        },

        ADD_EXPECTATIONS: function() { return "Add Expectations"; },
        MISSING_FORMAT: {
          TITLE: function() { return "Add Submission Format"; },
          DESCRIPTION: function() { return "(Note: this activity will be shown as \"Not Available Yet\" until submission format is added)"; },
        },

        MOVE: {
          UNRELEASE: function(d) { return "Moving this " + d.assignmentAlias + " will unrelease the " + d.assignmentAlias + " and delete existing submissions."; },
          DEADLINE: function(d) { return "The deadline for this " + d.assignmentAlias + " expires before the release of the new " + d.lectureAlias + "."; },
          COURSE_LONG_TEAM: function(d) { return "This " + d.assignmentAlias + " uses " + d.courseAlias + "-long " + d.teamsAlias + ". " + d.CourseAlias + "-long " + d.teamsAlias + " are not yet released before the release of the new " + d.lectureAlias + ". Your " + d.assignmentAlias + " will be automatically changed to use " + d.assignmentAlias + "-long " + d.teamsAlias + " and you will need to assign " + d.learnersAlias + " to new " + d.teamsAlias + "."; },
        },

        COURSE_LONG_TEAM_RELEASED_AFTER: {
          TITLE: function(d) { return "Course-long " + d.teamsAlias + " are not available when this " + d.assignmentAlias + " is released."; },
          DESCRIPTION: function(d) { return "(Note: Your " + d.learnersAlias + " won't be able to complete this " + d.assignmentAlias + " before the " + d.courseAlias + "-long " + d.teamsAlias + " are released.)"; },
          LEARNER_WARNING: function(d) { return d.TeamAlias + " membership required to complete this " + d.assignmentAlias + ". " + d.TeamAlias + " formation is not available yet."; },
        },

      },

      QUIZ: {
        DESCRIPTION: function() { return "Quiz"; },
        DESCRIPTION_LOWERCASE: function() { return "quiz"; },
        MODAL: {
          TITLE: {
            ADD: function() { return "Add Quiz"; },
            EDIT: function() { return "Edit Quiz"; },
          },

          TYPE: {
            DECRIPTION: function() { return "This quiz is for:"; },
            ASSESSMENT: {
              TITLE: function() { return "Assessment"; },
              DESCRIPTION: function(d) { return d.learnerAlias + " receives feedback after attempt and sees correct answers after exhausting their attempts or entering all correct answers."; },
            },

            PRACTICE: {
              TITLE: function() { return "Practice"; },
              DESCRIPTION: function(d) { return d.learnerAlias + " has infinite attempts and receives feedback after attempt and may choose to see correct answers after each attempt as well."; },
            },

          },

          MAXMIMUM_ATTEMPTS: function() { return "Maximum Attempts"; },
          NEXT: function() { return "Next: Add Questions"; },
        },

        DROPDOWN: {
          EDIT_BASICS: function() { return "Edit Basics"; },
          EDIT_QUESTIONS: function() { return "Edit Questions"; },
          ADD_DEADLINE: function() { return "Add Deadline"; },
          REMOVE_DEADLINE: function() { return "Remove Deadline"; },
        },

        HARD_DEADLINE: function() { return "Hard Deadline"; },
        MOVE: {
          UNRELEASE: function() { return "Moving this quiz will unrelease the quiz and delete existing submissions."; },
          DEADLINE: function(d) { return "The deadline for this quiz expires before the release of the new " + d.lectureAlias + "."; },
        },

        ADD_QUESTIONS: {
          TITLE: function() { return "Add Questions"; },
          DESCRIPTION: function() { return "(Note: this activity will be shown as \"Not Available yet\" until submission format is added)"; },
          ADD: function() { return "Add"; },
        },

        REGENERATE_WITH_AI: function() { return "Generate more questions for this quiz."; },
        REGENERATE_WITH_AI_DISABLE: function(d) { return "This " + d.lectureAlias + " has been released. You cannot generate more questions."; },
        AI_QUESTIONS: {
          AI_GENERATED_QUESTION: function() { return "AI Generated Question"; },
          QUIZ_QUESTIONS: function() { return "Quiz Questions"; },
          GENERATING_MORE: function() { return "Generating more..."; },
          LOADER_DESCRIPTION: function() { return "We're generating suggestions for different multiple choice type questions. Please note at this time, content like media, files, and links won't be included in the content used to generate these questions."; },
          LARGE_ERROR: function() { return "Failed! Sorry, unable to auto-generate as the content is too large to process."; },
          SHORT_ERROR: function() { return "Failed! Unable to auto-generate as there isn't enough content given to create a sufficient quiz. Please add more content to the area you'd like to generate from."; },
          QUESTIONS_CHOICE: function(displayQuestionCount: number, totalCount: number) { return "1-" + displayQuestionCount + " of " + totalCount + " Questions for your choice:"; },
          GENERATED_SO_FAR: function(totalCount: number) { return "Generated " + totalCount + " questions so far..."; },
          SELECTED_QUESTIONS: function(count: number) { return count + " Selected"; },
          MORE_SHOW: function(count: number) { return "Show " + count + " More " + plural(count, 0, en, { one: "Question", other: "Questions" }); },
          EXPLANATION: function() { return "Explanation & Feedback"; },
          CREATE_QUIZ: function() { return "Create Quiz"; },
          ADD_TO_QUIZ: function() { return "Add to Quiz"; },
          NO_MORE_QUESTIONS: function() { return "No More Questions to show"; },
        },

        LINKED_CONFIGURE: {
          DESCRIPTION: function() { return "Configure <b>Date Time to release scores, feedback, and responses for learners</b>"; },
          NOTE: function() { return "(Note: this event will be shown as \"Not Available Yet\" until you configure it)"; },
          CONFIGURE: function() { return "Configure"; },
        },

      },

      TIMED_QUIZ: {
        DESCRIPTION: function() { return "Timed Exam"; },
        DESCRIPTION_LOWERCASE: function() { return "timed exam"; },
        MODAL: {
          TITLE: {
            ADD: function() { return "Add Timed Exam"; },
            EDIT: function() { return "Edit Timed Exam"; },
          },

          TIME_LIMIT: function() { return "Time Limit"; },
          TIME_LIMIT_ERROR: function() { return "Please enter a value less than 72 hours."; },
          MINUTES: function() { return "Minutes"; },
          HOURS: function() { return "Hours"; },
          RELEASE_FEEDBACK_DATE: function(d) { return "Date/time to release scores, feedback, and responses for " + d.learnerAlias + " who have submitted"; },
        },

        HARD_DEADLINE_DESCRIPTION: function(feedbackReleaseDate: string) { return "Recommend to set the deadline same as the score and feedback release date, currently set as " + feedbackReleaseDate + "."; },
        PREVIEW: {
          TITLE: function(isPreview: string, title: string) { return select(isPreview, { true: "Preview ", other: "" }) + title; },
        },

        DROPDOWN: {
          PREVIEW: function() { return "Preview Questions"; },
        },

        MOVE: {
          UNRELEASE: function() { return "Moving this exam will unrelease the exam and delete existing submissions."; },
          DEADLINE: function(d) { return "The deadline for this exam expires before the release of the new " + d.lectureAlias + "."; },
        },

      },

      SURVEY: {
        DESCRIPTION: function() { return "Survey"; },
        DESCRIPTION_LOWERCASE: function() { return "survey"; },
        MOVE: {
          UNRELEASE: function() { return "Moving this survey will unrelease the survey and delete existing submissions?"; },
          DEADLINE: function(d) { return "The deadline for this survey expires before the release of the new " + d.lectureAlias; },
          UNRELEASE_AND_DEADLINE: function(d) { return "Moving this survey will unrelease the survey and delete existing submissions. The deadline for this survey expires before the release of the new " + d.lectureAlias; },
        },

        DEADLINE_POPOVER: function() { return "Survey deadlines are soft - a survey may be completed at any time. Click to change the date."; },
        VIEW_RESULT: function() { return "View Result"; },
      },

      DISCUSSION: {
        ADD: function() { return "Add"; },
        DESCRIPTION: function() { return "Discussion"; },
        DESCRIPTION_LOWERCASE: function() { return "discussion"; },
        LETS_DISCUSS: function() { return "Let's Discuss"; },
        EDIT_BASICS: function() { return "Edit Discussion"; },
        DISCUSS: function() { return "Discuss"; },
        CREATE_DISCUSSION: function() { return "Create Discussion"; },
        UPDATE_DISCUSSION: function() { return "Update Discussion"; },
        ADD_DISCUSSION: function() { return "Add Discussion"; },
        EDIT_DISCUSSION: function() { return "Edit Discussion"; },
        TOPIC: function() { return "Topic"; },
        EDIT_TOPIC: function() { return "After creating the topic here, you can go to the Discussion to edit the topic there."; },
        COLLAPSE_DISCUSSION: function() { return "Collapse this discussion (The prompt will be shown, comments will appear on click.)"; },
        SHOW_DISCUSSION: function() { return "Show this discussion (The prompt and comments will show without an extra click.)"; },
        GENERATED_PROMPTS: function() { return "We have generated following prompts for you to choose:"; },
        GENERATED_MESSAGES: {
          TOO_SHORT: function() { return "Unable to auto-generate as there isn't enough content. Please add more content to the area you'd like to generate from."; },
          TOO_LONG: function() { return "Unable to auto-generate as the content is too large to process. Please reduce the content in the area you'd like to generate from."; },
        },

        REGENERATE_WITH_AI: function() { return "Regenerate Prompt"; },
        INSIGHTS: {
          PLACEHOLDER: {
            ADMIN: function() { return "AI insights will be shown after a few contributions from participants."; },
            ADMIN_ONLY_BADGE: function() { return "Admin Only"; },
            ADMIN_ONLY_TOOLTIP: function(d) { return "Key Themes are visible only to admins; " + d.learnersAlias + " cannot access them. To make them visible to " + d.learnersAlias + ", please edit the setting."; },
            LEARNER: function() { return "We need a few more comments to come up with meaningful insights. Check back soon!"; },
          },

          SETTINGS: {
            TOOLTIP: function() { return "Need to set this up on each linked lesson"; },
            ENABLE_TO_LEARNERS: function(d) { return "Show AI Insights to " + d.learnersAlias; },
            SUCCESS_ENABLE: function(d) { return "AI Insights for the discussion will be displayed to " + d.learnersAlias + "."; },
            SUCCESS_DISABLE: function(d) { return "AI Insights for the discussion will not be displayed to " + d.learnersAlias + "."; },
          },

          GENERATE: function() { return "Generate AI Insights"; },
          TITLE: function() { return "AI Insights"; },
          ADMIN_ONLY: function() { return "Admin Only"; },
          ADMIN_ONLY_TOOLTIP: function(d) { return "Key Themes are visible only to admins; " + d.learnersAlias + " cannot access them. To make them visible to " + d.learnersAlias + ", please edit the setting."; },
          NOT_ADMIN_ONLY: function(d) { return "*" + d.LearnersAlias + " are shown both a similar and contrasting perspective in addition to the key themes after participating in this discussion."; },
          KEY_THEMES: function() { return "Key Themes"; },
          LEARNER_SUBTITLE: function() { return "Check out what others said in this summary generated by AI."; },
          SIMILAR_PERSPECTIVE: function() { return "Similar Perspective"; },
          DIFFERENT_PERSPECTIVE: function() { return "Different Perspective"; },
          ERROR_PERSPECTIVE: function() { return "*Your comment is too short. AI is unable to share similar and different perspectives with you."; },
        },

      },

      TEAM_DISCUSSION: {
        TEAM_DISCUSSION_NEXT: function(d) { return "Next: Add " + d.TeamAlias + " Discussion"; },
        TEAM_FORMATION_AND_TEAM_DISCUSSION_ADDING: function(d) { return "We are adding the " + d.teamAlias + " formation activity and the " + d.teamAlias + " discussion activity that will be using it to your " + d.lectureAlias + ". Please wait..."; },
        TEAM_FORMATION_AND_TEAM_DISCUSSION_ADDED_HEADER: function(d) { return d.TeamAlias + " Formation Activity and " + d.TeamAlias + " Discussion Activity have been added to the " + d.LectureAlias; },
        TO: function() { return "TO"; },
        MODAL_TITLE: {
          CREATE: function(d) { return "Add " + d.TeamAlias + " Discussion"; },
          EDIT: function(d) { return "Edit " + d.TeamAlias + " Discussion"; },
        },

        DESCRIPTION: function(d) { return d.TeamAlias + " Discussion"; },
        DESCRIPTION_LOWERCASE: function(d) { return d.teamAlias + " discussion"; },
        DETAILED: function(d) { return d.TeamAlias + " discussion for " + d.courseAlias + " long " + d.teamsAlias + ". Discussion will appear on the " + d.lectureAlias + " page and in " + d.teamAlias + " workspaces. Comments and replies are visible to only " + d.teamAlias + " members and facilitators accessing through the " + d.teamAlias + " workspace."; },
        TITLE: function() { return "Title"; },
        DISCUSSION_PROMPT: function() { return "Discussion Prompt"; },
        HIGHLIGHT_IN_TEAM_WORKSPACE: function(d) { return "Highlight Post in " + d.TeamAlias + " Workspace"; },
        TIME_PERIOD: function() { return "Please define the time period you would like to highlight this post:"; },
        MORE_MEMBERS: function(d) { return d.memberCount + " more " + d.teamAlias + " members"; },
        JOIN_DISCUSSION: function() { return "Join the Discussion"; },
        START_DISCUSSION: function() { return "Start the Discussion"; },
        GOOD_JOB_PARTICIPATING: function() { return "Good job participating!"; },
        FIRST: function() { return "You are the FIRST!"; },
        INFO: function() { return "Highlighting this post will pin it above other posts in the workspace during the selected period."; },
      },

      COURSE_DISCUSSION: {
        MODAL_TITLE: {
          CREATE: function(d) { return "Add " + d.CourseAlias + "-wide Discussion"; },
          EDIT: function(d) { return "Edit " + d.CourseAlias + "-wide Discussion"; },
        },

        DESCRIPTION: function(d) { return d.CourseAlias + "-wide Discussion"; },
        DESCRIPTION_LOWERCASE: function(d) { return d.courseAlias + "-wide Discussion"; },
        LOADING_DESCRIPTION: function() { return "We're analyzing your content and generating the component of your choice, it won’t take long..."; },
        DETAILED: function(d) { return "A single " + d.courseAlias + "-wide discussion. Comments and replies are visible to everyone in the " + d.courseAlias + " and it is also visible in the Discussion Forums."; },
        STARTER_TOOLTIP: function() { return "In the linked lesson the discussion starter will default to show as a course builder, where they can change it at any time without breaking the link."; },
        DISCUSSION_PROMPT: function() { return "Discussion Prompt"; },
        TOPIC_TOOLTIP: function() { return "The discussion topic can be setup on each linked lesson."; },
        GEN_AI: {
          DISCUSSION_PROMPTS: function() { return "Discussion Prompts"; },
        },

      },

      SUBMISSIONS_DISCOVERY: {
        DESCRIPTION: function() { return "Submission Carousel"; },
        DESCRIPTION_LOWERCASE: function() { return "submission carousel"; },
        UNAVAILABLE: function(d) { return "No " + d.assignmentsAlias + " with sharable submissions are available."; },
        MISSING_FORMAT_TITLE: function(d) { return "Pick " + d.assignmentAlias + " for Submission Carousel"; },
        ADD: function() { return "Add"; },
        MODAL: {
          ADD_TITLE: function() { return "Add Submission Carousel"; },
          EDIT_TITLE: function() { return "Edit Submission Carousel"; },
          ASSIGNMENT_SELECTION_DESCRIPTION: function() { return "Which submissions should we choose"; },
          ASSIGNMENT_SELECTION_SUBTEXT: function(d) { return "Submissions will be picked from this " + d.assingmentAlias; },
          SUBMISSION_COUNT: function() { return "How many submissions to show?"; },
          ASSIGNMENT_POPOVER_HEADING: function() { return "Assignments in Linked Lessons"; },
          ASSIGNMENT_POPOVER_CONTENT: function() { return "All Assignments created in this collection are shown in this list. If there is no Assignment attached, the Submission Carousel will show as not available on linked lessons."; },
          SORT: {
            RECENT: function() { return "Most Recent"; },
            TRENDING: function() { return "Most Trending"; },
          },

        },

        MOVE_WARNING: function(d) { return "The submissions for this " + d.assignmentAlias + " will not be available for viewing at the release of the new " + d.lectureAlias + "."; },
        LESSON_LIBRARY_ACTIVITY_SETUP: function() { return "The <b>assignment related to this activity</b> will need to be set in each linked lesson, otherwise they will show up as not yet available."; },
        LESSON_LIBRARY_ACTIVITY_SETUP_MESSAGE: function() { return "The <b>assignment related to this submission carousel</b> will be displayed in linked lessons."; },
        UPDATE_ASSIGNMENT_CONFIRMATION: {
          ARE_YOU_SURE: function() { return "Are you sure you want to update the Assignment?"; },
          DESCRIPTION: function() { return "It's recommended to double-check the new Assignment the Submission Carousel attaches to is present in the course. After pushing updates, if the Assignment is not present, the Submission Carousel will be shown as not available on the "; },
          LINKED_LESSON: function() { return "<u>Linked Lesson</u>."; },
          DESCRIPTION2: function() { return "Check the Linked Lessons and unlink them if you do not wish for this update."; },
        },

        ADD_FROM_COURSE_TO_LL: {
          MODAL: {
            TITLE: function() { return "The Submission Carousel Activity and its attached Assignment have been added to the Collection"; },
            DESCRIPTION: function() { return "Both lessons containing the activities have been added to the Collection. You can attach a different Assignment to the Submission Carousel inside the Collection, if you would like."; },
          },

        },

        ADD_TO_COURSE_FROM_LL: {
          MODAL: {
            TITLE: function() { return "The Submission Carousel Activity and its attached Assignment have been added to the course"; },
            DESCRIPTION: function() { return "Both lessons containing the activities have been added to the course."; },
          },

        },

      },

      FEEDBACK_SHARED: {
        PICK_ASSIGNMENT: function(d) { return "Pick an " + d.assignmentAlias; },
        SELECT_ASSIGNMENT: function(d) { return "- Select " + d.assignmentAlias + " -"; },
        ASSIGNMENT_HAS_HARD_DEADLINE: function(d) { return "This " + d.assignmentAlias + " has a hard deadline of " + d.deadline + "."; },
        LECTURE_RELEASED_BEFORE_ASSIGNMENT: function(d) { return "This lecture is released before " + d.assignmentAlias + " deadline of " + d.deadline + ". Learners may not be able to start providing feedback when lecture is released."; },
        FEEDBACK_TITLE: function(assignmentName: string) { return "Feedback for " + assignmentName; },
        MOVE_WARNING: function(d) { return "The submissions for this " + d.assignmentAlias + " will not be available for feedback at the release of the new " + d.lectureAlias + "."; },
        VIEW_RELATED_ASSIGNMENT: function(d) { return "View Related " + d.AssignmentAlias; },
      },

      PRIVATE_PEER_EVALUATION: {
        DESCRIPTION: function() { return "Private Feedback"; },
        DESCRIPTION_LOWERCASE: function() { return "private feedback"; },
        UNAVAILABLE: function(d) { return "No " + d.assignmentsAlias + " are available for feedback to be configured."; },
        ADD_FEEDBACK: function() { return "Add Private Feedback"; },
        EDIT_FEEDBACK: function() { return "Edit Private Feedback"; },
        TARGET_NUM_OF_EVALUATIONS: function() { return "What is the required number of submissions to provide feedback on for every participant?"; },
        ADD_EVALUATION_CRITERIA_AND_RUBRICS: function() { return "Next: Add Evaluation Criteria and Rubrics"; },
        DROPDOWN: {
          EDIT_EVALUATION_CRITERIA: function() { return "Edit Evaluation Criteria and Rubrics"; },
        },

        FEEDBACK_DESCRIPTION: function(d) { return "This activity gives you the chance to evaluate the work of other " + d.learnersAlias + " in the " + d.courseAlias + " by following a rubric created by the " + d.teachingTeamAlias + ". To provide feedback, please follow the rubrics provided by the " + d.teachingTeamAlias + ". Remember that detailed and honest feedback is most helpful to you and to your peers. Please note: your name will appear next to any written feedback you provide, but all numeric scores will remain anonymous and be shared only as an average across all evaluators."; },
        MISSING_FORMAT_TITLE: function(d) { return "Pick " + d.assignmentAlias + " for Private Feedback"; },
      },

      PUBLIC_PEER_EVALUATION: {
        DESCRIPTION: function() { return "Public Feedback"; },
        EDIT_FEEDBACK: function() { return "Edit Public Feedback"; },
        DESCRIPTION_LOWERCASE: function() { return "public feedback"; },
        UNAVAILABLE: function(d) { return "No " + d.assignmentsAlias + " are available for feedback to be configured."; },
        ADD_FEEDBACK: function() { return "Add Public Feedback"; },
        TARGET_NUM_OF_EVALUATIONS: function() { return "What is the required number of submissions to provide feedback on for every participant?"; },
        FEEDBACK_DESCRIPTION: function(d) { return "This activity gives you the chance to give feedback on the work of other " + d.learnersAlias + " in the " + d.courseAlias + ". Remember that detailed and honest feedback is most helpful to you and to your peers. Please note: all your comments are public and will be viewable by all viewers."; },
        ADD: function() { return "Add"; },
        MISSING_FORMAT_TITLE: function(d) { return "Pick " + d.assignmentAlias + " for Public Feedback"; },
      },

      PEER_EVALUATION: {
        ASSIGNMENT: {
          DESCRIPTION: function(d) { return d.AssignmentAlias + " Feedback"; },
          DESCRIPTION_LOWERCASE: function(d) { return d.assignmentAlias + " feedback"; },
          PRIVATE: function() { return "Private Feedback"; },
          PUBLIC: function() { return "Public Feedback"; },
          SKILL: function() { return "Skills Feedback"; },
          UNAVAILABLE: function(d) { return "No " + d.assignmentsAlias + " are available for feedback to be configured."; },
          ADD: function(d) { return "Add " + d.AssignmentAlias + " Feedback"; },
          EDIT: function() { return "Edit Basics"; },
          FEEDBACK_TYPE: function(d) { return "Choose the type of feedback you would like " + d.learnersAlias + " to provide."; },
          TARGET_NUM_OF_EVALUATIONS: function() { return "What is the required number of submissions to provide feedback on for every participant?"; },
          SKILLS_FEEDBACK: {
            FEEDBACK_DESCRIPTION: function(d) { return "This activity gives you the chance to give feedback on the work of other " + d.learnersAlias + " in the " + d.courseAlias + ". Remember that detailed and honest feedback is most helpful to you and your peers."; },
            PROVIDE_FEEDBACK_DESCRIPTION: {
              NOT_STARTED: function(count: number) { return "Provide Feedback for " + plural(count, 0, en, { one: number("en", count, 0) + " Submission", other: number("en", count, 0) + " Submissions" }); },
              IN_PROGRESS: function(pendingEvaluationCount: number, submittedEvaluationCount: number) { return "Give feedback to " + pendingEvaluationCount + " more (Submitted for " + submittedEvaluationCount + ")"; },
              COMPLETED: function(requiredCount: number) { return "Gave feedback for " + requiredCount; },
              MISSED: function(pendingEvaluationCount: number, requiredCount: number) { return "Missed " + pendingEvaluationCount + " of " + requiredCount; },
            },

            GOTO_ASSINMENT: function(d) { return "Go to " + d.AssignmentAlias; },
            NOT_COMPLETED: function(assignmentTitle: string) { return "You must first complete " + assignmentTitle + " in order to give feedback."; },
            SKILLS_INFO: function() { return "You will provide feedback on these skills:"; },
            VIDEO_PRACTICE_SKILLS_INFO: function() { return "You will provide feedback on these skills:"; },
            SKILLS_FOR: function(assignmentTitle: string) { return "Skills for: " + assignmentTitle; },
            DISABLED: {
              DESCRIPTION_1: function() { return "You do not have any skills defined for your institution. Contact an Org Admin to add skills for your institution."; },
              DESCRIPTION_2: function(instructionsLink: string) { return "You do not have any skills defined for your institution. Before adding this activity, be sure to add skills to your institution in the <a class=\"blue-link\" href=\"" + instructionsLink + "\" target=\"_self\">Skill Tags</a> page."; },
            },

            NOT_AVAILABLE: {
              ACTIVITY: function(d) { return "Pick " + d.AssignmentAlias; },
              SKILLS: function(d) { return "Select Skills for the " + d.AssignmentAlias; },
              VIDEO_PRACTICE_FEEDBACK: function() { return "Select Skills for the Practice activity"; },
              VIDEO_PRACTICE_FEEDBACK_BUTTON: function() { return "Select Skills for the Practice"; },
              DESCRIPTION: function() { return "(Note: this activity will be shown as \"Not Available Yet\" until you configure it)"; },
            },

            SUBMISSION: {
              SUBMITTED_ON: function(submittedDate: string) { return "Submitted on " + submittedDate + "."; },
              OWNER: function(learnerName: string) { return learnerName + "'s Submission"; },
              GIVE_FEEDBACK: function(pendingEvaluationCount: number) { return "Give Feedback (review " + pendingEvaluationCount + " more submissions)"; },
              DELETE: {
                AUTHOR: function() { return "Are you sure you want to delete your feedback?"; },
                ADMIN: {
                  TITLE: function() { return "Are you sure you want to delete all ratings by this user?"; },
                  DESC: function() { return "All skill ratings given by this user for this submission will be removed."; },
                },

              },

            },

            RATING_DESCRIPTION: function(d) { return "Provide a rating that reflects how well the " + d.learnerAlias + " demonstrated each skill within their submission. This rating will only be visible to " + d.learnerName + " and the teaching team."; },
            VIEW_RELATED_ASSIGNMENT: function() { return "View Related Assignment"; },
            DELETE: {
              TITLE: function() { return "Delete Skills Feedback activity"; },
              DESCRIPTION: function() { return "Deleting this skills feedback activity will delete the activity configuration, all existing skills feedback, and automated communications based on this activity. Are you sure?"; },
            },

            SUCCESS: {
              BEYOND: function() { return "Your feedback has been submitted."; },
              COMPLETED: function(submittedCount: number) { return "You have given feedback on all " + submittedCount + " submissions."; },
              NOT_COMPLETED: function(pendingCount: number) { return "Your feedback has been submitted successfully, " + pendingCount + " remain to complete the activity"; },
            },

          },

        },

        VIDEO_PRACTICE: {
          DESCRIPTION: function() { return "Practice Feedback"; },
          UNAVAILABLE: function() { return "No practice activities are available for feedback to be configured."; },
          MODAL: {
            TITLE: function() { return "Add Feedback to Practice"; },
            PICK_VIDEO_PRACTICE: function() { return "Pick a practice activity"; },
            SELECT_VIDEO_PRACTICE: function() { return "-Select a Practice Activity-"; },
            COUNT_DESCRIPTION: function() { return "What is  the required number of practices to provide feedback on for every participant?"; },
            ACTIVITY_DISABLED: function(d) { return "When the " + d.lectureAlias + " is released, you cannot change the Practice Activity"; },
            ACTIVITY_COMPLETED: function(requiredCount: number) { return "You have given feedback on all " + plural(requiredCount, 0, en, { one: "required practice", other: number("en", requiredCount, 0) + " required practices" }) + "."; },
            SUCCESS_MSG: function() { return "Your comment has been submitted."; },
            PEER_FEEDBACK: function() { return "Peer Feedback"; },
            SKILLS_FEEDBACK: function() { return "Skills Feedback"; },
            CHOOSE_TYPE_OF_FEEDBACK: function() { return "Choose the type of feedback you would like learners to provide."; },
          },

          FEEDBACK_DESCRIPTION: function(d) { return "This activity gives you the chance to give feedback on the work of other " + d.learnersAlias + " in the " + d.courseAlias + ". Remember that detailed and honest feedback is most helpful to you and your peers. Please note: all your comments are public and will be viewable by all " + d.learnersAlias + "."; },
          FEEDBACK_TITLE: function(activityTitle: string) { return "Feedback for " + activityTitle; },
          SKILLS_FEEDBACK_TITLE: function(activityTitle: string) { return "Skills Feedback for " + activityTitle; },
          PROVIDE_FEEDBACK: function() { return "Provide Feedback"; },
          PROVIDE_FEEDBACK_DESCRIPTION: {
            NOT_STARTED: function(count: number) { return "Provide Feedback for " + plural(count, 0, en, { one: number("en", count, 0) + " Practice", other: number("en", count, 0) + " Practices" }); },
            IN_PROGRESS: function(pendingEvaluationCount: number, submittedEvaluationCount: number) { return "Give feedback to " + pendingEvaluationCount + " more (Submitted for " + submittedEvaluationCount + ")"; },
            COMPLETED: function(requiredCount: number) { return "Gave feedback for " + requiredCount; },
            MISSED: function(pendingEvaluationCount: number, requiredCount: number) { return "Missed " + pendingEvaluationCount + " of " + requiredCount; },
          },

          FOR_ACTIVITY: function() { return "For Practice Activity:"; },
          NOT_AVAILABLE: {
            BEFORE_ASSIGNMENT_RELEASE_DATE: function(releaseDate: string) { return "Submissions aren't available for feedback yet. Please check back after " + releaseDate; },
            EMPTY: function() { return "No submissions yet. Come back soon and check again!"; },
            LEANER_NOT_COMPLETED_ASSIGNMENT: function(practiceActivityTitle: string) { return "You must first complete " + practiceActivityTitle + " in order to give feedback"; },
            DESCRIPTION: function() { return "(Note: this activity will be shown as \"Not Available Yet\" until practice activity is added)"; },
            PICK_ACTIVITY: function() { return "Pick Practice Activity for Peer Feedback"; },
            PICK: function() { return "Pick Practice Activity"; },
          },

          GO_TO_PRACTICE: function() { return "Go to Practice"; },
          VIEW_PRACTICE: function() { return "View Related Practice"; },
          INSTRUCTION: {
            POPOVER_TITLE: function() { return "Leaving Feedback"; },
            POPOVER_DESC: function(activityTitle: string) { return "Your text or video comment on this practice will be considered as feedback in response to \"" + activityTitle + "\""; },
            SEE_INSTRUCTIONS: function() { return "See instructions here >>"; },
            VIEW_IN_LECTURE: function(d) { return "View in " + d.LectureAlias; },
            NEXT: function() { return "Proceed to the next practice when you're ready to give feedback."; },
          },

          SUBMISSION_FEEDBACK_TAG: {
            PEER_FFEDBACK_SUBMISSION: function() { return "Peer Feedback Submission"; },
            SKILLS_FEEDBACK_SUBMISSION: function() { return "Skills Feedback"; },
            TOOLTIP: function(activityTitle: string) { return "Comment counts towards \"" + activityTitle + "\""; },
          },

          DELETE_CONFIRMATION: {
            TITLE: function() { return "Delete Peer Feedback?"; },
            DESCRIPTION: function() { return "Deleting this peer feedback will delete the activity configuration, all the user submissions and automated communications based on this activity. Are you sure?"; },
          },

          FEEDBACK_SUBMITTED: function() { return "feedback submitted"; },
        },

        PRACTICE_SKILLS_FEEDBACK: {
          DESCRIPTION: function() { return "Practice Skills Feedback"; },
        },

      },

      TEAM_FORMATION: {
        DESCRIPTION: function(d) { return d.TeamAlias + " Formation"; },
        DESCRIPTION_LOWERCASE: function(d) { return d.teamAlias + " formation"; },
        UNAVAILABLE: function(d) { return d.TeamAlias + " Formation is already added to " + d.teamLectureName + "."; },
        MODAL: {
          ADD: function(d) { return "Add " + d.TeamAlias + " Formation"; },
          EDIT: function(d) { return "Edit " + d.TeamAlias + " Formation"; },
          DESCRIPTION: function(d) { return d.TeamsAlias + " allow " + d.learnersAlias + " to collaborate and submit their " + d.assignmentsAlias + " together. " + d.LearnersAlias + " can be part of one " + d.teamAlias + " at a time. Choose an option to start:"; },
          FORMED_BY_STUDENT: function(d) { return "Formed by " + d.learnerAlias; },
          FORMED_BY_INSTRUCTOR: function(d) { return "Formed by " + d.teachingTeamAlias; },
          NAME: function(d) { return "Name to be used for " + d.teamsAlias + ":"; },
        },

        DELETION_DESCRIPTION: function(d) { return "Deleting this " + d.teamAlias + " formation will make all " + d.assignmentsAlias + " that use " + d.courseAlias + "-long " + d.teamsAlias + " to require creating " + d.teamsAlias + " for that " + d.assignmentAlias + ". It will also delete all created " + d.teamsAlias + ", " + d.teamAlias + " discussion activity,  and " + d.teamAlias + " workspace data. Are you sure?"; },
        MOVE: function(d) { return plural(d.count, 0, en, { one: "1 " + d.assignmentAlias, other: number("en", d.count, 0) + " " + d.assignmentsAlias }) + " that use " + d.courseAlias + "-long " + d.teamsAlias + " will be released before the " + d.courseAlias + "-long " + d.teamsAlias + " after this move."; },
      },

      GROUP_FORMATION: {
        DESCRIPTION: function(d) { return d.GroupAlias + " Formation"; },
        DESCRIPTION_LOWERCASE: function(d) { return d.GroupAlias + " formation"; },
        UNAVAILABLE: function(d) { return d.GroupAlias + " Formation is already added to " + d.groupLectureName + "."; },
        MODAL: {
          ADD: function(d) { return "Add " + d.GroupAlias + " Formation"; },
          EDIT: function(d) { return "Edit " + d.GroupAlias + " Formation"; },
          DESCRIPTION: function(d) { return d.GroupsAlias + " allow " + d.learnersAlias + " to collaborate and share their submissions. Any " + d.learnerAlias + " can be a member of more than one " + d.groupAlias + ". Please choose your " + d.groupAlias + " creation option to start:"; },
          NAME: function(d) { return "Name to be used for " + d.groupAlias + ":"; },
          DEFAULT_NAME: function() { return "Groups"; },
        },

        JOIN_OR_FORM_GROUP: function(d) { return "Create your own " + d.groupAlias + " or Join one"; },
        MEET_YOUR_GROUP: function(d) { return "Meet Your " + d.groupAlias; },
        JOINED_GROUP: function(d) { return "Joined " + d.groupAlias; },
        CREATED_GROUP: function(d) { return "Created " + d.groupAlias; },
        CREATE_GROUP: function(d) { return "I will create my own " + d.groupAlias; },
        JOIN_GROUP: function(d) { return "I will join an existing " + d.groupAlias; },
        CREATE_GROUP_DESCRIPTION: function() { return "You will become "; },
        EDIT_PROFILE_QUESTIONS: function() { return "Edit Profile Questions"; },
        UPLOAD_GROUPS: function(d) { return "Edit " + d.GroupAlias; },
        DELETION_DESCRIPTION: function(d) { return "Deleting this " + d.groupAlias + " formation will delete all " + d.groupsAlias + " and their workspace data. Are you sure?"; },
        ENABLE_PROGRESS_DASHBOARD: function(d) { return "Enable " + d.TeamAlias + " Progress Dashboard"; },
        DISABLE_PROGRESS_DASHBOARD: function(d) { return "Disable " + d.TeamAlias + " Progress Dashboard"; },
      },

      TEMPLATES: {
        DESCRIPTION: function() { return "Templates"; },
        DESCRIPTION_LOWERCASE: function() { return "templates"; },
      },

      CONTENTS: {
        DESCRIPTION: function() { return "Content"; },
        DESCRIPTION_LOWERCASE: function() { return "content"; },
        CONTENTS_TOOLTIP: function() { return "Create content with images, text, visual templates, and files"; },
      },

      THIRD_PARTY_ACTIVITIES: {
        CHANGE_ACTIVITY_TYPE: function() { return "Change Activity Type"; },
        PICK: function() { return "Pick an Activity Type"; },
        QUIZ: function() { return "Quiz"; },
        SURVEY: function() { return "Survey"; },
        ASSIGNMENT: function(d) { return d.assignmentAlias; },
        FEEDBACK: function() { return "Feedback"; },
        VIDEO: function() { return "Video"; },
        READING: function() { return "Reading"; },
        DISCUSSION: function() { return "Discussion"; },
        AUDIO: function() { return "Audio"; },
        MARK_AS_DONE: function() { return "Mark as Done"; },
        MARKED_AS_DONE: function() { return "Marked as Done"; },
        CHECK_MY_PROGRESS: function() { return "Check My Progress"; },
        ERROR_CHECKING_PROGRESS: function() { return "The linked activity is not being reported as Completed yet. Please make sure to complete the activity or reach out to your admin if you think this is an error."; },
        ERROR_CHECKING_SCORM_PROGRESS: function() { return "This activity is not being reported as completed yet. Please make sure to complete the activity or reach out to your admin if you think this is an error."; },
        SUMTOTAL_DESCRIPTION: function() { return "You must complete the linked learning activity to be granted completion for this activity. You may use the Check My Progress button to check for completion and update status if you have completed it."; },
        MARK_AS_DONE_CONFIRMATION: function() { return "Yes, Mark it as Done"; },
        READING_VERB: function() { return "Read"; },
        AUDIO_VERB: function() { return "Listen"; },
      },

      WEB_LINK: {
        DESCRIPTION: function() { return "Web Embed"; },
        DESCRIPTION_LOWERCASE: function() { return "web embed"; },
        MODAL: {
          ADD_TITLE: function() { return "Add Embed"; },
          DESCRIPTION: function() { return "Use this component to put an embed of a Web page directly on your lecture page. You can mark this as a to-do for your learners."; },
          COLLECTION_DESCRIPTION: function() { return "Use this component to put an embed of a Web page on your lecture page. You can mark this as a to-do for your learners."; },
          LINK_LABEL: function() { return "Link:"; },
          DISPLAY_TEXT: function() { return "Display Text:"; },
          DISPLAY_TEXT_PLACEHOLDER: function() { return "Display Text"; },
          LINK_EXAMPLE: function() { return "https://"; },
          LINK_DESCRIPTION: function(d) { return "You can pass the id, full name, email, and the preferred language of the " + d.learnerAlias + ", catalog id of the " + d.courseAlias + " and activity id in the URL dynamically by using %%USER_ID%%, %%FULL_NAME%%, %%EMAIL%%, %%LANG%%, %%CATALOG_ID%% and %%ACTIVITY_ID%% parameters."; },
          COLLECTION_LINK_DESCRIPTION: function(d) { return "You can pass the id and email of the " + d.learnerAlias + " and catalog id of the " + d.courseAlias + " in the URL dynamically by using %%USER_ID%%CATALOG_ID%% parameters"; },
        },

        MARK_DONE_DESCRIPTION: function() { return "Are you sure you want to mark this as done?"; },
        TEXT_COLOR: function() { return "Text Color"; },
        BACKGROUND_COLOR: function() { return "Background Color"; },
        BORDER_COLOR: function() { return "Border Color"; },
        ICON_COLOR: function() { return "Icon Color"; },
        PICK_FROM_LIBRARY: function() { return "Pick From Library"; },
        CHANGE_COLORS: function() { return "Change Colors and Styles"; },
        UPLOAD: function() { return "Upload"; },
        EDIT_COLORS: function() { return "Edit Colors for this Web Link"; },
        AUTO_COMPLETION_ON_TOOLTIP: function() { return "Enable if you plan to push completion status to NovoEd via API. Learners will not be able to manually mark the activity as completed"; },
        AUTO_COMPLETION_OFF_TOOLTIP: function() { return "Disable if you want to allow learners to manually mark the activity as completed."; },
        API_COMPLETION: function() { return "API-based Completion"; },
      },

      NON_EMBEDDED_WEB_LINK: {
        DESCRIPTION: function() { return "Web Link"; },
        DESCRIPTION_LOWERCASE: function() { return "web link"; },
        MODAL: {
          ADD_TITLE: function() { return "Add Web Link"; },
          DESCRIPTION: function() { return "Use this component to put a Web Link directly on your lecture page. You can mark this as a to-do for your learners."; },
          COLLECTION_DESCRIPTION: function() { return "Use this component to put an embed of a Web page on your lecture page. You can mark this as a to-do for your learners"; },
          LINK_LABEL: function() { return "Link:"; },
          DISPLAY_TEXT: function() { return "Display Text:"; },
          DISPLAY_TEXT_PLACEHOLDER: function() { return "Display Text"; },
          LINK_EXAMPLE: function() { return "https://"; },
          LINK_DESCRIPTION: function(d) { return "You can pass the id, full name, email, and the preferred language of the " + d.learnerAlias + ", catalog id of the " + d.courseAlias + " and activity id in the URL dynamically by using %%USER_ID%%, %%FULL_NAME%%, %%EMAIL%%, %%LANG%%, %%CATALOG_ID%% and %%ACTIVITY_ID%% parameters."; },
          COLLECTION_LINK_DESCRIPTION: function(d) { return "You can pass the id and email of the " + d.learnerAlias + " and catalog id of the " + d.courseAlias + " in the URL dynamically by using %%USER_ID%%CATALOG_ID%% parameters"; },
        },

        MARK_DONE_DESCRIPTION: function() { return "Are you sure you want to mark this as done?"; },
      },

      SCORM: {
        DESCRIPTION: function() { return "SCORM or AICC Files"; },
        DESCRIPTION_LOWERCASE: function() { return "SCORM or AICC files"; },
        EXIT_FULL_SCREEN: function() { return "Exit Full Screen Mode"; },
        UPLOAD_ERROR: function() { return "There was an error uploading your package."; },
        IMPORT_IN_PROGRESS: function() { return "Your SCORM package is being imported. This may take a few minutes. Package will be available to view after import is completed."; },
        IMPORT_FAILED: function() { return "There was a transient error importing the SCORM package."; },
        PROGRESS_DESCRIPTION: function() { return "Completion information will be automatically pulled in when this activity is completed. If you do not see your completion reflected here yet, you may click the button below to check your progress."; },
        CHECK_MY_PROGRESS: function() { return "Check My Progress"; },
        CHECKING: function() { return "Checking..."; },
        AUTO_COMPLETION_HEADER: function() { return "Select how completion works for activity"; },
        AUTO_COMPLETION: function() { return "Auto Completion"; },
        AUTO_COMPLETION_ON_TOOLTIP: function() { return "Click here to turn on auto completion for this activity. Learners will have the option to manually check their progress."; },
        AUTO_COMPLETION_OFF_TOOLTIP: function() { return "Click here to turn off auto completion for this activity. Learners will have the option to manually Mark as Done."; },
        RESIZE_INSTRUCTIONS: function() { return "Drag this handle to manually set the height, then click on the Done button"; },
        DONE: function() { return "Done"; },
        FULL_SCREEN_VIEW: function() { return "Full Screen View"; },
      },

      LTI: {
        DESCRIPTION: function() { return "LTI Tools"; },
        DESCRIPTION_LOWERCASE: function() { return "LTI tools"; },
        MODAL: {
          ADD_TITLE: function() { return "Add LTI Tool"; },
          URL_LABEL: function() { return "URL"; },
          CONSUMER_KEY_LABEL: function() { return "Consumer Key"; },
          CONSUMER_SECRET_LABEL: function() { return "Consumer Secret"; },
          ENABLE_GRADE_PASSPACK: function() { return "Enable Grade Passback"; },
          SEND_USER_EMAIL: function(d) { return "Send " + d.LearnerAlias + " Email"; },
        },

      },

      LIVE_VIDEO_EVENTS: {
        DESCRIPTION: function() { return "Live Video Events"; },
        DESCRIPTION_LOWERCASE: function() { return "live video events"; },
        CONFIGURE: function() { return "Configure"; },
        COLLECTION_SET_START_TIME_EDIT_TEXT: function() { return "The <b>Start Time</b>, <b>Duration</b> and <b>Link to Join the Event</b> will need to be set in each linked lesson, otherwise this event will be shown as <b>\"Not Available Yet\"</b>"; },
        NILL_START_TIME_AND_DURATION: function() { return "Date: N/A| Time: N/A | Duration: N/A"; },
        SETUP_START_TIME_IN_LINKED_LESSON: function() { return "Date, Time, and Duration needed to be setup in linked lesson."; },
        ADD_EXPECTATIONS: function() { return "Add Expectations"; },
        STATUS: {
          JOIN: function() { return "Join"; },
          IN_PROGRESS: function() { return "In Progress"; },
          PENDING: function() { return "Pending"; },
          MISSED: function() { return "Missed"; },
          JOINED: function() { return "Joined"; },
        },

        DURATION: function(numMins: string) { return numMins + " mins"; },
        SESSIONS_AVAILABLE: function(numSessions: string) { return numSessions + " Sessions Available"; },
        NO_SESSIONS_AVAILABLE: function() { return "No Sessions Available"; },
        LIVE_EVENT_TITLE: function() { return "Live Event"; },
        LOCAL_TIME: function() { return "local time"; },
        JOIN: function() { return "Join Now"; },
        ABOUT_TO_START: function() { return "Join when meeting is about to start."; },
        JOIN_USING_APP: function() { return "Must join using Zoom App instead of the Zoom web client to allow tracking attendance"; },
        STATUS_PENDING: function() { return "Attendance status will be updated soon after meeting completion."; },
        SESSION_ENDED_RECORDING: function(d) { return "Session has ended. " + select(d.hasRecording, { true: "You can still watch the recording below to earn " + d.pointsAlias, other: "" }); },
        SESSION_ENDED_RECORDING_POINTS_DISABLED: function(hasRecording: string) { return "Session has ended. " + select(hasRecording, { true: "View the recording below", other: "" }); },
        MODAL: {
          ADD_TITLE: function() { return "Add Title"; },
          TITLE: function(isEdit: string, isView: string) { return select(isEdit, { true: select(isView, { true: "View", other: "Edit" }), other: "Add" }) + " Live Video Events"; },
          AUTH_TITLE: function() { return "New OAUTH Request"; },
          CONFIGURE_TITLE: function(sessionType: string) { return "Configure " + select(sessionType, { ZoomLiveSession: "Zoom Meeting", TeamsLiveSession: "Microsoft Teams Meeting", LiveSession: "External Link", other: "External Link" }); },
          DESCRIPTION_1: function(msTeamEnabled: string, zoomEnabled: string) { return "Your organization has the " + select(zoomEnabled, { true: select(msTeamEnabled, { true: "Zoom and Microsoft Teams integrations", other: "Zoom integration" }), other: "Microsoft Teams integration" }) + " enabled."; },
          DESCRIPTION_2: function(d) { return "You can " + select(d.zoomAndTeamsDisabled, { true: "", other: "also" }) + " add an external link to the event for your " + d.learnersAlias + " to join for all other video conference platforms. " + select(d.zoomEnabled, { true: select(d.msTeamEnabled, { true: "<br /><br />For completion, you can upload the attendance manually after the event for this activity. You can also upload a recording of the event after it's done. The Zoom integration will do these automatically for Zoom meetings created via the integration.", other: "<br /><br />For completion, you can upload the attendance manually after the event for this activity. You can also upload a recording of the event after it's done. The Zoom integration will do these automatically for Zoom meetings created via the integration." }), other: "<br /><br />For completion, you can upload the attendance manually after the event for this activity. You can also upload a recording of the event after it's done." }); },
          WORKSPACE_MEETING: function(teamsDisabled: string) { return "You can " + select(teamsDisabled, { true: "", other: "also" }) + " add an external link to the event for your team members to join for all other video conference platforms."; },
          SELECT_SESSION: function() { return "Please select one:"; },
          ZOOM: function() { return "Zoom Meeting"; },
          MS_TEAM: function() { return "Microsoft Teams Meeting"; },
          EXTERNAL: function() { return "External Link"; },
          NEXT: function() { return "Next"; },
          ADD_ZOOM_HOST_DESCRIPTION: function() { return "Please enter the <b>email</b> for the Zoom user account that you want to be the meeting owner/host."; },
          EMAIL: function() { return "Email"; },
          ZOOM_HOST_SAVED: function() { return "Zoom account has been saved."; },
          HOST_VALIDATED: function() { return "Validated"; },
          ZOOM_HOST_ERROR: {
            ACCOUNT_LEVEL: {
              HOST: function() { return "Email not found. Please enter the email address associated with the Zoom Account."; },
              SINGLE: function(email: string) { return "Email is not a licensed user: " + email + "."; },
              MULTIPLE: function(emails: string) { return "Following Emails are not licensed users: " + emails + "."; },
            },

            USER_LEVEL: function(count: number, emails: string, extraCount: number, secondEmail: string) { return plural(count, 0, en, { "1": emails + " is not valid", "2": emails + " and " + secondEmail + " are not valid", other: emails + " +" + extraCount + " more are not valid" }) + ", we have removed " + plural(count, 0, en, { "1": "it", other: "them" }) + " from your alt host list."; },
          },

          VIEW_EDIT_ZOOM_ACCOUNT: function() { return "View/Edit Zoom Account"; },
          OAUTH_DESCRIPTION: {
            ZOOM: function(d) { return "In order to add a Zoom Meeting, you must first authenticate the NovoEd Zoom app. This enables NovoEd to access your Zoom account to create and manage meetings, access recordings, and pull in participant information. The link below will take you to complete that step. Once you have authenticated the Zoom app, you will return to the " + d.LectureAlias + " Edit page and can click to add the live video event component again to set up a Zoom meeting."; },
            MS_TEAMS: {
              OLD_AUTH: function() { return "You must authenticate the NovoEd Microsoft Teams Meeting for Live Events app in order to create a Microsoft Teams online meeting for your Live Event. This enables NovoEd to access your account to create and manage meetings. The option below will take you to complete the Authentication step. Once you have authenticated the Microsoft Teams Meeting integration you will return to the Lesson Edit page and can click to add the live video event again to set up a Teams Meeting."; },
              DESCRIPTION_1: function(d) { return "You need to re-authenticate the NovoEd Microsoft Teams Meeting for Live Events app to have full access create and manage Microsoft Teams online meetings for your Live Event. This allows NovoEd to access your calendar for scheduling meetings and retrieve meeting recordings. Please complete the authentication step using the option below. After authentication, you will return to the " + d.LectureAlias + " Edit page, where you can add the live video event and set up your Teams Meeting."; },
              DESCRIPTION_2: function() { return "This step can be skipped if previously authenticated, but will not have access to meeting recordings or calendar event creation"; },
              WORKSPACE: function() { return "Authenticate NovoEd with your Microsoft Teams account to set up a Microsoft Teams online meeting for your Team Workspace. This will enable us to create and manage online meetings on your behalf when you initiate them from your workspace."; },
            },

          },

          OAUTH_AUTHENTICATE: {
            ZOOM: function() { return "Authenticate the Zoom app"; },
            MS_TEAMS: function() { return "Authenticate Microsoft Teams"; },
            AUTHENTICATE: function() { return "Authenticate"; },
          },

          SKIP: function() { return "Skip for Now"; },
          INVALID_OAUTH: {
            AUTHENTICATE_NOW: function() { return "Go authenticate it now."; },
            CREATE: function() { return "Your OAUTH token is not up to date, you won't be able to retrieve an uploaded recording until you enable the new OAUTH."; },
            EDIT: function() { return "This meeting was created before your OAUTH token was validated. In order to retrieve an uploaded recording, please recreate this live event and delete this old one."; },
          },

          INVALID_OAUTH_TOOLTIP: function() { return "This feature is currently unavailable. Please re-authenticate your Microsoft Teams account to grant the required permissions."; },
          TOPIC: function() { return "Topic"; },
          ADD_DESCRIPTION: function() { return "Add Description (Optional)"; },
          LINKED_LESSON_SETUP_TOPIC_AND_DESCRIPTION: function() { return "The content of this component must be edited in the lesson from the collection"; },
          START_TIME: function() { return "Start Time"; },
          TIME_ZONE: function() { return "Time Zone"; },
          DURATION: function() { return "Duration"; },
          MINUTES: function(minutes: number) { return plural(minutes, 0, en, { one: number("en", minutes, 0) + " min", other: number("en", minutes, 0) + " mins" }); },
          HOURS: function(hours: number) { return plural(hours, 0, en, { one: number("en", hours, 0) + " hr", other: number("en", hours, 0) + " hrs" }); },
          ALTERNATIVE_HOSTS: function() { return "Alternative Hosts"; },
          ALTERNATIVE_HOSTS_EXAMPLE: function() { return "Example: john@company.com, peter@school.edu."; },
          ALTERNATIVE_HOSTS_DESCRIPTION: function() { return "Alternative host need to be a licensed user under the authenticated Zoom account."; },
          SETUP_IN_COURSE_PLACEHOLDER: function() { return "Set up in course"; },
          SETUP_IN_COURSE_TOOLTIP: function() { return "Need to set this up on lesson in course"; },
          SETUP_IN_LESSON_LIBRARY_TOOLTIP: function() { return "This needs to be edited in the lesson from the collection"; },
          DELETE_TOOLTIP: function() { return "Linked session can't be deleted"; },
          PARTICIPANT_VIDEO: function() { return "Start Participant Video"; },
          JOIN_BEFORE_HOST: function() { return "Allow Join Before Host"; },
          MUTE_PARTICIPANTS: function() { return "Mute Participants Upon Entry"; },
          ENABLE_EMAIL_CONFIRMATION: function() { return "Send Notification Emails from Zoom"; },
          TRACK_ATTENDANCE: function() { return "Track attendance"; },
          TRACK_ATTENDANCE_INFO: function(d) { return "Registration is enabled on Zoom meetings to track attendance and award points/completion. This will prevent users from joining via Zoom's web client. To enable joining via the web client, the host may manually disable registration for the Zoom meeting. " + d.learnersAlias + " must then provide their name matching NovoEd profile to record their attendance."; },
          AUTORECORD: function() { return "Auto-record the meeting on Cloud"; },
          AUTOMATICALLY_UPLOAD_RECORDING: function() { return "Automatically upload the cloud recording to the lesson page"; },
          LINK_TO_JOIN: function() { return "Link to Join Event"; },
          LINK_TO_JOIN_PLACEHOLDER: function() { return "Example: https://bluejeans.com/92942984"; },
          LOBBY_BY_PASS: {
            LABEL: function() { return "LobbyByPass"; },
            ORGANIZER: function() { return "Organizer"; },
            ORGANIZATION: function() { return "Organization"; },
            ORGANIZATION_AND_FEDERATED: function() { return "OrganizationAndFederated"; },
            EVERYONE: function() { return "Everyone"; },
          },

          MS_TEAMS_ORGANIZER: function(email: string) { return "Teams Meeting Organizer: " + email; },
          CO_ORGANIZERS: function() { return "Co-organizers"; },
          CO_ORGANIZERS_DESCRIPTION: function() { return "Co-organizers need to be a licensed user under the authenticated Microsoft Teams account."; },
          MS_TEAMS_CO_ORGANIZER_ERROR: {
            SINGLE: function(email: string) { return "Email is not a licensed user: " + email + "."; },
            MULTIPLE: function(emails: string) { return "Following Emails are not licensed users: " + emails + "."; },
          },

          ADD_SESSION: function() { return "Add Session"; },
          REMOVE_SESSION: function() { return "Delete"; },
          MULTI_SESSION_SETTINGS: function() { return "Multi-session Settings"; },
          ZOOM_MEETING_HOST: function() { return "Zoom Meeting Host/Owner"; },
          SETTINGS: {
            MS_TEAMS: function() { return "Microsoft Teams Settings"; },
            ZOOM: function() { return "Zoom Settings"; },
          },

          SESSION_CARD: {
            ACTION: {
              REGISTER: function() { return "Register"; },
              JOIN_NOW: function() { return "Join Now"; },
              REGISTERING: function() { return "Registering..."; },
            },

            STATE: {
              REGISTER: function() { return ""; },
              UNREGISTER: function() { return "Unregister"; },
              UNREGISTERING: function() { return "Unregistering..."; },
              STARTS_SOON: function() { return "Meeting starts soon"; },
              IN_PROGRESS: function() { return "Meeting is in progress"; },
            },

            BADGE: {
              REGISTERED: function() { return "Registered"; },
              ATTENDED: function() { return "Attended"; },
              VIEWED: function() { return "Viewed"; },
              PENDING: function() { return "Meeting Concluded, Status Pending"; },
              MISSED: function() { return "Registered (Missed)"; },
            },

          },

        },

        REGISTRATION: {
          TITLE: function() { return "Registration Details"; },
          COUNT: function(count: number) { return count + " registered"; },
          SUCCESS_REGISTRATION: function() { return "You have successfully registered to this live event session!"; },
          NOTIFICATION: function(eventName: string) { return eventName + " starting in 10 minutes, register now to join"; },
          NOTIFICATION_CTA: function() { return "Go to Sessions"; },
          MULTISESSION_WARNING: {
            TITLE: function() { return "Update Live Event Session"; },
            DESCRIPTION: function() { return "You just changed your live event to a multi session event, would you like to keep the learner registration to the original event or remove everyone so learners can select which session to join?"; },
            KEEP_ORIGINAL: function() { return "Keep the original registration"; },
            UNREGISTER: function() { return "Unregister everyone"; },
          },

          UNREGISTER: {
            TITLE: function() { return "Unregister Live Event"; },
            DESCRIPTION: function() { return "Are you sure you are to unregister from this live event?"; },
            SUCCESS: function() { return "Done! You have successfully unregistered to this live event session!"; },
          },

          LIMIT: {
            DISABLED: function() { return "Registration Limit"; },
            ENABLED: function(input: string) { return "Registration Limit to " + input + " participants per session"; },
            FULL: function() { return "(Full)"; },
            ERROR_MESSAGE: function() { return "Registration Limit has been reached. Please refresh the page."; },
          },

        },

        NOT_AUTHENTICATED_TOOLTIP: function() { return "Only the creator of the meeting can pick a date"; },
        USER_NOT_AUTHENTICATED_TOOLTIP: function(session: string) { return "Please authenticate your " + select(session, { ZoomLiveSession: "Zoom", other: "Microsoft Teams" }) + " account to continue configuration."; },
        OPTIONS_AFTER_EVENT: function() { return "Options Available after the Event"; },
        UPLOAD_ATTENDEE_LIST: function() { return "Upload Attendee List"; },
        UPLOAD_ATTENDEE_LIST_DESCRIPTION: function(d) { return "You can upload a CSV of " + d.learnersAlias + " who have attended the live event. Download a template of the CSV to see the format."; },
        UPLOAD_A_CSV: function() { return "Upload a CSV"; },
        DOWNLOAD_A_TEMPLATE: function() { return "Download a Template"; },
        PROCEED_WITH_THE_REST: function() { return "Proceed with the Rest"; },
        UPLOAD_NEW_CSV: function() { return "Upload New CSV"; },
        SOME_ERRORS_FOUND_IN_YOUR_CSV: function() { return "Some errors found in your CSV:"; },
        USERS_MATCH_LEARNERS: function(d) { return plural(d.numberOfValidEmails, 0, en, { one: "<b>1 email</b>", other: "<b>" + number("en", d.numberOfValidEmails, 0) + " emails</b>" }) + " from the CSV " + plural(d.numberOfValidEmails, 0, en, { one: "matches a " + d.learnerAlias, other: "match " + d.learnersAlias }) + " in the " + d.courseAlias + ". Please select one of the following options:"; },
        USERS_NOT_FOUND: function(d) { return plural(d.numberOfInvalidEmails, 0, en, { one: "1 email does not match a " + d.learnerAlias, other: number("en", d.numberOfInvalidEmails, 0) + " emails do not match " + d.learnersAlias }) + " in this " + d.courseAlias + " and will not be added to the attendee list."; },
        OVERWRITE_LIST: function(d) { return "Overwrite the current list of " + d.learnersAlias + " who attended this session"; },
        ADD_TO_LIST: function(d) { return "Add to the current list of " + d.learnersAlias + " who attended this session"; },
        SUCCESS: function() { return "Attendee list has been uploaded successfully!"; },
        UPLOAD_RECORDING: function() { return "Upload Recording"; },
        REPLACE_RECORDING: function() { return "Replace Recording File"; },
        EDIT_RECORDING: function() { return "Edit Recording"; },
        REMOVE_RECORDING: function() { return "Remove Recording"; },
        LEARNERS_CAN_DOWNLOAD: function(d) { return d.LearnersAlias + " can also download this recording"; },
        HAS_STARTED: function(courseName: string, eventName: string) { return eventName + " from " + courseName + " has started!"; },
        MISSING_START_TIME: function() { return "Pick a Start Time for this Event"; },
        MISSING_START_TIME_DESCRIPTION: function() { return "(Note: this event will be shown as \"Not Available Yet\" until a start time is added)"; },
        MISSING_START_TIME_LINKED_LESSON: function() { return "Configure Start Time, Duration and Link to Join the Event"; },
        MISSING_START_TIME_DESCRIPTION_LINKED_LESSON: function() { return "(Note: this event will be shown as \"Not Available Yet\" until you configure it)"; },
        EXTERNAL_ERROR: function() { return "Encountered an Error Creating this Event"; },
        AUTHENTICATION_ERROR: {
          ZOOM_CURRENT_USER: function() { return "Zoom needs to be re-authenticated in order to manage meetings, get attendance, or recordings. Please authenticate your Zoom account here"; },
          ZOOM_OTHER_USER: function() { return "Zoom needs to be re-authenticated in order to manage meetings, get attendance, or recordings. Please ask the meeting owner to authenticate their Zoom account."; },
          ZOOM_ACCOUNT_LEVEL: function() { return "Zoom needs to be re-authenticated in order to manage meetings, get attendance, or recordings. Please ask your administrator to re-authenticate Zoom."; },
          TEAMS_CURRENT_USER: function() { return "Microsoft Teams needs to be re-authenticated in order to manage meetings and get attendance. Please authenticate your Teams account here"; },
          TEAMS_OTHER_USER: function() { return "Microsoft Teams needs to be re-authenticated in order to manage meetings and get attendance. Please ask the meeting owner to authenticate their Teams account."; },
          TEAMS_AUTHENTICATE_ERROR: function(accountEmail: number) { return "Microsoft Calendar needs to be re-authenticated with " + accountEmail + " for calendar events to be created."; },
          AUTHENTICATE: function() { return "Authenticate"; },
        },

        DELETE_SESSION_SUCCESS: function() { return "The Live Event has been successfully deleted."; },
        DELETION_OVERLAY: {
          TITLE: function() { return "Delete Live Event Session"; },
          DESCRIPTION: function() { return "Deleting this live event session will delete the activity configuration, all the user submissions and automated communications based on this activity. Are you sure?"; },
        },

        COMPLETED_SESSIONS: function() { return "Sessions Completed"; },
        OTHER_SESSIONS: function() { return "Other Sessions"; },
      },

      IN_PERSON_EVENTS: {
        DESCRIPTION: function() { return "In-Person Events"; },
        DESCRIPTION_LOWERCASE: function() { return "in-person events"; },
        DEFAULT_TITLE: function() { return "In-Person Event"; },
        STATUS: {
          ATTEND: function() { return "Attend"; },
          ATTENDED: function() { return "Attended"; },
          IN_PROGRESS: function() { return "In Progress"; },
          CHECKED_IN: function() { return "Checked In"; },
          MISSED: function() { return "Missed"; },
        },

        ADD_EXPECTATIONS: function() { return "Add Expectations (Optional)"; },
        EVENT_TITLE: function() { return "Event Title"; },
        EVENT_DESCRIPTION: function() { return "Event Description (optional)"; },
        FROM: function() { return "From"; },
        TO: function() { return "To"; },
        DATE_DISABLED: function() { return "Event already started, can’t change the date"; },
        LOWERCASE_TO: function() { return "to"; },
        LOCATION: function() { return "Location"; },
        TIME_ZONE: function() { return "Time Zone"; },
        TIMEZONE_DISABLED: function() { return "Event already started, can’t change the time zone"; },
        WILL_ATTEND: function() { return "Will Attend"; },
        CONFIRMING: function() { return "Confirming..."; },
        ADMIN_ONLY: function() { return "Admin Only"; },
        CONFIRMATIONS: function(count: number) { return count + " " + plural(count, 0, en, { one: "Confirmation", other: "Confirmations" }); },
        VIEW_CONFIRMATION: function() { return "View Confirmation"; },
        LEARNER_CHECK_IN: function() { return "Learner Check-In"; },
        CHECK_IN_QR_DESCRIPTION_1: function() { return "Use the QR code below to check in"; },
        CHECK_IN_QR_DESCRIPTION_2: function() { return "or search learners to manually check in:"; },
        CHECK_IN_SEARCH_PLACEHOLDER: function() { return "Search by name, email, or external ID"; },
        ATTENDANCE_CONFIRMED: function() { return "Great! You are on the list!"; },
        CHECK_IN_BUTTON: function() { return "Check In"; },
        CHECKING_IN: function() { return "Checking In..."; },
        CHECKED_IN: function() { return "Checked In"; },
        QR_CHECK_IN_SUCCESS: function(eventName: string) { return "Thank you for checking in to " + eventName; },
        ALREADY_CHECKED_IN: function() { return "You have already checked in to this event."; },
        QR_CHECK_IN_ERROR: function() { return "Unable to check in. Please try again"; },
        CHECK_IN_QR: function() { return "Check-In QR Code"; },
      },

      VIDEO_PRACTICE: {
        PRACTICE: function() { return "Practice"; },
        DESCRIPTION: function() { return "Practice"; },
        CHOOSE_VIDEO_PRACTICE_OPTION: function() { return "Choose Practice Option"; },
        PRACTICE_NOW: function() { return "Practice Now"; },
        VIEW_PRACTICE: function() { return "View Practice"; },
        TOTAL_TIME_TO_COMPLETE: function(minsCount: number) { return "This activity must be completed in the same session once you start it. It will take ~" + minsCount + " minutes to complete"; },
        TOTAL_TIME_BREAKDOWN: function(recordTimeCount: number, reviewTimeCount: number, totalTimeCount: number, viewTimeCount: number) { return "This activity will take approximately " + viewTimeCount + " " + plural(viewTimeCount, 0, en, { one: "minute", other: "minutes" }) + " to view prompt, " + recordTimeCount + " " + plural(recordTimeCount, 0, en, { one: "minute", other: "minutes" }) + " to record your response, and " + reviewTimeCount + " " + plural(reviewTimeCount, 0, en, { one: "minute", other: "minutes" }) + " to review, for a total of " + totalTimeCount + " minutes of your time. You must finish the practice when you open it."; },
        TAKE_INDEX: function(maxTriesCount: number, takeCount: number) { return "Take " + takeCount + " out of " + maxTriesCount; },
        LAST_TAKE: function() { return "Last Take"; },
        MISSED: {
          DEADLINE: function() { return "You did not submit your response by the deadline."; },
          LEFT_ACTIVITY: function() { return "You did not submit your response upon review of practice scenario."; },
        },

        RETRY: {
          TITLE: function() { return "Retry"; },
          DETAILS: function() { return "Retry will discard your current recording. It will take you back to start over, review the scenario, and record your response."; },
          ARE_YOU_SURE: function() { return "Are you sure?"; },
          ON_SPOT: function(takesCount: number) { return "This will discard your current recording if you retry. You have " + takesCount + " more " + plural(takesCount, 0, en, { one: "take", other: "takes" }) + "."; },
          WHEN_READY: function() { return "This will discard your current recording."; },
          CANCEL: {
            TITLE: function() { return "Upload Cancelled"; },
            WHEN_READY: function() { return "You have cancelled your recording upload. Please retry from the Scenario."; },
            ON_SPOT: function(takesCount: number) { return "You have cancelled your recording upload. Please retry from the Scenario. You have " + takesCount + " more " + plural(takesCount, 0, en, { one: "take", other: "takes" }) + "."; },
            TAKE_ME_THERE: function() { return "Take Me There"; },
          },

        },

        LEAVE: {
          ARE_YOU_SURE: function() { return "Are you sure?"; },
          WHEN_READY: function() { return "Your current recording will be discarded."; },
          ON_SPOT: function() { return "This activity would be marked as missed. You will not be able to complete this activity"; },
          CANCELLED: function() { return "You have cancelled your recording uploading. This activity will be marked as missed. You will not be able to complete this activity."; },
        },

        MAX_TRIES: {
          LABEL: function(input: string, takesCount: number) { return input + " " + plural(takesCount, 0, en, { one: "take", other: "takes" }) + " allowed"; },
          ARIA_LABEL: function() { return "X takes allowed"; },
          ERROR_LABEL: function() { return "Takes allowed"; },
        },

        CREATE_PRACTICE_SCENARIO: {
          DESCRIPTION: function() { return "Create Practice Scenario"; },
          TITLE_PLACEHOLDER: function() { return "Practice Scenario Title"; },
          PROMPT_PLACEHOLDER: function() { return "Add a text prompt"; },
          ADD_PROMPT_DESCRIPTION: function(d) { return "Add a text and/or video prompt to help " + d.learnersAlias + " get ready for this practice:"; },
          ADD_TO_PRACTICE_SCENARIO: function() { return "Add to Practice Scenario"; },
          SIZE_EXCEEDED: function() { return "Video file size may not exceed 50 MB"; },
          MINS: function() { return "Mins"; },
          SECS: function() { return "Secs"; },
        },

        RECORDING_LIMIT: {
          DESCRIPTION: function() { return "Recording Limit:"; },
          MINS_TEXT: function(minsCount: number) { return minsCount + " " + plural(minsCount, 0, en, { one: "min", other: "mins" }); },
          SECS_TEXT: function(secsCount: number) { return secsCount + " " + plural(secsCount, 0, en, { one: "sec", other: "secs" }); },
          MAX_MINS: function() { return "Maximum length is 30 minutes."; },
          SEC_INVALID_FORMAT: function() { return "Invalid value for Seconds."; },
        },

        ALLOWED_SUBMISSION_TYPE_SETTING: {
          TITLE: function() { return "Practice Format"; },
          TITLE_HELP_TEXT: function() { return "The practice submission format is fixed and cannot be changed after creating the scenario."; },
          VIDEO: function() { return "Video (Camera Recording or Screen Recording)"; },
          AUDIO: function() { return "Voice Only"; },
          SUBMISSION_TYPE_VIDEO: function() { return "Submission Type: <b>Video/Screen Recording</b>"; },
          SUBMISSION_TYPE_AUDIO: function() { return "Submission Type: <b>Voice Only</b>"; },
          HELP_TEXT: function() { return "The submission type selected for this scenario cannot be changed."; },
        },

        REQUEST_REVIEWS: {
          TITLE: function() { return "Request Reviews"; },
          ENABLED: function() { return "Request review is enabled"; },
          NOT_ENABLED: function() { return "Request review is not enabled"; },
          NOTE: function(d) { return "When enabled, " + d.learnersAlias + " with an advisor can request skills feedback from their advisors, provided that skills are tagged in the practice scenario. Advisors will be notified through daily digest when a request is made."; },
          NOTE_FOR_REQUIREMENTS: function() { return "Note: Skills must be tagged to activate this feature. If skills aren't tagged, this option should not be available."; },
          WARNING_NOTE: function() { return "The Request Review option will only be available if Skills are enabled and configured in your organization."; },
          ENABLED_PRACTICE_OVERVIEW: function() { return "Request Reviews Enabled"; },
          DISABLE_REQUEST_REVIEW: function() { return "Request Reviews Disabled"; },
        },

        INSIGHTS: {
          TITLE: function() { return "Insights"; },
          ENABLED: function() { return "Insights is enabled"; },
          NOT_ENABLED: function() { return "Insights is not enabled"; },
          DESCRIPTION: function(d) { return "When enabled, Insights will automatically provide " + d.learnersAlias + " with valuable information about their practice submissions shortly after they submit. Insights will include rate of speech metrics, filler word analysis, and can automatically detect up to 25 key phrases that should or should not be mentioned in the " + d.learnerAlias + "'s submission."; },
          NOTE: function() { return "Note: Insights will not be automatically generated for the previous submissions."; },
          KEY_PHRASES_TO_MENTION: function() { return "Key phrases to mention"; },
          KEY_PHRASES_TO_AVOID: function() { return "Key phrases to avoid"; },
          ADD_KEY_PHRASE: function() { return "Add Key phrase"; },
          PHRASE_VALIDATION: {
            LENGTH: function(max: string, min: string) { return "A key phrase must be at least " + min + " and no greater than " + max + " characters in length."; },
            FORBIDDEN_CHARACTERS: function() { return "A key phase may only include letters and spaces."; },
            ERROR: function() { return "Error"; },
            MAXIMUM_REACHED: function(phraseLimit: string) { return "No more than " + phraseLimit + " total key phrases can be defined."; },
          },

          DETAILS: {
            PHRASES_TO_MENTION: function() { return "Key Phrases to mention:"; },
            PHRASES_TO_AVOID: function() { return "Key Phrases to avoid:"; },
            ENABLED: function() { return "Insights Enabled"; },
            DISABLED: function() { return "Insights Disabled"; },
          },

        },

        SUBMISSION_PRIVACY_SETTING: {
          DESCRIPTION: function() { return "Submission Privacy Setting:"; },
          SHARED: function() { return "Shared with anyone who can see the practice scenario."; },
          SHARED_TOOLTIP: function(d) { return "Any " + d.learnerAlias + " enrolled in a " + d.courseAlias + " including this practice scenario may discover and view submissions by other " + d.learnersAlias + ". This may include " + d.learnersAlias + " in multiple " + d.coursesAlias + " depending on Scenario Reusability Setting."; },
          RESTRICTED: function(d) { return "Private to " + d.teachingTeamAlias + " and advisors."; },
          RESTRICTED_TOOLTIP: function(d) { return "Only " + d.courseAlias + " admins with Instructor or Teaching Assistant permissions or users with advisor roles will be able to discover submissions by other " + d.learnersAlias + ". Featured practices will be visible to other " + d.learnersAlias + " using the practice scenario."; },
        },

        SUBMISSION_GALLERY_SETTING: {
          DESCRIPTION: function() { return "Submission Gallery Setting:"; },
          SHARED: function(d) { return "Allow " + d.learnersAlias + " to browse practice submissions within the practice room and other galleries."; },
          SHARED_TOOLTIP: function(d) { return "Any " + d.learnerAlias + " enrolled in a " + d.courseAlias + " including this practice scenario may discover and view submissions by other " + d.learnersAlias + ". This may include " + d.learnersAlias + " in multiple " + d.coursesAlias + " depending on Scenario Reusability Setting."; },
          RESTRICTED: function(d) { return "Limit browsing within the practice room and other galleries to the " + d.teachingTeamAlias + " and mentors."; },
          RESTRICTED_TOOLTIP: function(d) { return "Only " + d.courseAlias + " admins with Instructor or Teaching Assistant permissions or users with advisor roles will be able to discover submissions by other " + d.learnersAlias + ". Featured practices will be visible to other " + d.learnersAlias + " using the practice scenario."; },
        },

        SCENARIO_REUSABILITY_SETTING: {
          DESCRIPTION: function() { return "Scenario Reusability Settings:"; },
          REUSABLE: function(d) { return "Scenario can be shared in " + d.coursesAlias + " and collections."; },
          REUSABLE_TOOLTIP: function(d) { return "Display all submissions from " + d.coursesAlias + " in the practice gallery, provided they are viewable according to privacy settings. This facilitates social learning by enabling users to give feedback and learn from featured practice across different " + d.coursesAlias + "."; },
          NOT_REUSABLE: function(d) { return "Duplicate this scenario to be used in " + d.coursesAlias + " and collections"; },
          NOT_REUSABLE_TOOLTIP: function() { return "Create a new scenario with the same name in your organization's collection, each featuring its own distinct gallery."; },
          WARNING_MESSAGE: function(d) { return "<b>Note: </b>When used inside the " + d.LectureAlias + " Library and needing to make edits to the scenario they must be done in each scenario within each linked " + d.lectureAlias + " (updates to the scenario will not push changes from the Library)"; },
        },

        RESPOND_ON_SPOT: {
          DESCRIPTION: function() { return "Respond on the Spot"; },
          DETAILED: function(d) { return d.LearnersAlias + " will have limited time to review the prompt and get ready to record (1.5x the length of a video prompt or 3 minutes for text only prompts). They will also have a limited number of takes for their recording."; },
        },

        RESPOND_WHEN_READY: {
          DESCRIPTION: function() { return "Respond when Ready"; },
          DETAILED: function(d) { return d.LearnersAlias + " can take as much time as they need to review the prompt and record. There will be no limits on the number of times they can record."; },
        },

        SELECT: {
          TITLE: function() { return "Create or Choose from Existing Practice Scenarios"; },
          CREATE_NEW: function() { return "Create New"; },
          CREATE_A_NEW_PRACTICE_SCENARIO: function() { return "Create a New Practice Scenario"; },
          CREATE_NEW_INFO: function(d) { return "A practice scenario creates an ongoing opportunity for " + d.learnersAlias + " to record their response to a prompt. A scenario has to be added as an activity to a course to invite " + d.learnersAlias + " to it. Once " + d.learnersAlias + " complete the activity they will have access to a practice room, where they can re-practice on an ongoing basis, see submissions featured by an admin as a best practice, and submissions by other " + d.learnersAlias + " to explore depending on the submission privacy settings."; },
          OR: function() { return "OR"; },
          SELECT_FROM_EXISTING: function() { return "Select from existing practice scenarios"; },
          ADD_TO_MY_COURSE: function(d) { return "Add to my " + d.courseAlias; },
          COPY_SCENARIO_AND_ADD: function() { return "Copy Scenario & Add"; },
          ADD_TO_MY_LESSON: function() { return "Add to my Lesson"; },
          DUPLICATE_SCENARIO_AND_ADD: function() { return "Duplicate Scenario & Add"; },
          VIEW_DETAILS: function() { return "View Details"; },
          CREATED_ON_DATE_IN: function(date: string) { return "Created on " + date + " in"; },
          CREATED_ON_DATE: function(date: string) { return "Created on " + date; },
          USED_IN: function() { return "Used in"; },
          USED_ONLY_FOR: function() { return "Used only for"; },
          NUM_COURSES: function(d) { return d.courseNum + " " + plural(d.courseNum, 0, en, { one: d.courseAlias, other: d.coursesAlias }); },
          NUM_COLLECTIONS: function(collectionNum: string) { return collectionNum + " " + plural(collectionNum, 0, en, { one: "collection", other: "collections" }); },
          SEARCH_PLACEHOLDER: function() { return "Search with keyword"; },
          NO_EXISTING_SCENARIOS: function() { return "No existing practice scenarios"; },
          COLLECTION: function() { return "Collection"; },
        },

        VIEW_PRACTICE_SCENARIO: {
          TITLE: function() { return "View Practice Scenario"; },
          BACK_TO_LIST: function() { return "Back to the List"; },
          SELECT: function() { return "Select"; },
          PLUS_X_MORE_COURSES: function(d) { return "+ " + d.num + " more " + plural(d.num, 0, en, { one: d.courseAlias, other: d.coursesAlias }); },
          PLUS_X_MORE_COLLECTIONS: function(num: string) { return "+ " + num + " more " + plural(num, 0, en, { one: "Collection", other: "Collections" }); },
        },

        VIEW: {
          NAME: function() { return "The Scenario"; },
          START_RECORDING: function() { return "Start Recording"; },
          TITLE: {
            ON_SPOT: function(viewTimeCount: number) { return "Review this scenario and get ready to record in " + viewTimeCount + " " + plural(viewTimeCount, 0, en, { one: "minute", other: "minutes" }) + "."; },
            WHEN_READY: function() { return "Review this scenario and get ready to record"; },
          },

        },

        RECORD: {
          NAME: function() { return "Record"; },
          STARTS_IN: {
            CAMERA: function() { return "Recording starts in"; },
            SCREEN: function() { return "The recording will begin in 3 seconds. You will hear a beep when it begins. Get ready by going to the screen you have shared for recording."; },
          },

          RUNNING: function() { return "Your screen is being recorded. You can stop recording when ready. You will hear a beep 3 seconds before reaching the recording limit."; },
          WHEN_READY: function() { return "Click to record when you are ready"; },
          TITLE: function(recordTimeCount: number) { return "Record your response. You have " + recordTimeCount + " " + plural(recordTimeCount, 0, en, { one: "minute", other: "minutes" }) + "."; },
          END_RECORDING: function() { return "End Recording"; },
          SHOW_PROMPT: function() { return "Show Prompt"; },
          HIDE_PROMPT: function() { return "Hide Prompt"; },
        },

        REVIEW: {
          NAME: function() { return "Review & Submit"; },
          AUTO_SUBMIT_MSG: function() { return "Your recording will be automatically submitted when the time is up."; },
          VIEWABLE_BY: function() { return "Your recording will be viewable by learners who have access to practice scenario, advisors, and the teaching team."; },
          TITLE: {
            ON_SPOT: function(reviewTimeCount: number) { return "You have " + reviewTimeCount + " " + plural(reviewTimeCount, 0, en, { one: "minute", other: "minutes" }) + " to decide."; },
            WHEN_READY: function() { return "Review your recording and submit."; },
          },

        },

        EDIT: {
          BASICS: function() { return "Edit Basics"; },
          PRACTICE_SCENARIO: function() { return "Edit Practice Scenario"; },
          SHARED_WARNING: function(d) { return "This will make practice submissions that are currently private to the " + d.learnerAlias + ", advisor, and " + d.teachingTeamAlias + " visible to all " + d.learnersAlias + " who have access to the practice scenario."; },
          PRIVATE_WARNING: function(d) { return "This will remove " + d.learnerAlias + "'s access to  the practice gallery. " + d.LearnersAlias + " will no longer be able to see each other's practice. Featured practices will still be viewable by all " + d.learnersAlias + "."; },
          UPDATE_FOR_ALL: function() { return "Update For All"; },
          CONFIRMATION: function(d) { return "Once updates are applied the following collections and " + d.coursesAlias + " where this scenario is shared will be impacted. These changes are reflected to the scenario without having to push changes from the Lesson Library. Changes cannot be undone, so please review carefully."; },
        },

        DELETE_MESSAGE: function() { return "Are you sure you want to delete? This action would potentially delete all submissions associated with this activity"; },
        GALLERY: {
          EDIT_MSG: {
            SHARED: function() { return "A gallery featuring responses to the scenario will be shown here after the activity is completed (or missed)."; },
            PRIVATE: function() { return "A gallery of highlighted submissions will be shown here after the activity is completed (or missed)."; },
          },

          MY_PRACTICE: function() { return "My Practice"; },
          EXPLORE_OTHERS: function() { return "Explore others' practice"; },
          NO_SUBMISSIONS: function() { return "Please come back later to see more submissions"; },
          MORE_SUBMISSIONS: function() { return "Explore more in the Practice Room"; },
        },

        SCREEN_RECORDING: {
          STATES: {
            TEST_PERMISSION: function() { return "Test screen recording permissions"; },
            NO_PERMISSION: function() { return "Your browser does not have permission to record your screen."; },
            NOT_SUPPORTED: function() { return "Your browser is not compatible with screen recording."; },
            SUCCESS: function() { return "Your browser is compatible with screen recording"; },
          },

          WARNING_TEXT: {
            NO_PERMISSION: function() { return "Please grant your browser permission to record your screen."; },
            NOT_SUPPORTED: function() { return "Ensure you are using the latest version of Google Chrome or Mozilla Firefox."; },
          },

          RECORDING_MODE: {
            SELECT_TITLE: function() { return "Select What to Record."; },
            CAMERA: function() { return "Camera"; },
            SCREEN: function() { return "Screen"; },
            CAMERA_DISABLED: {
              NOT_AVAILABLE: function() { return "Not Available"; },
              TROUBLESHOOT_WHY: function() { return "Troubleshoot why?"; },
              CHECK_AGAIN: function() { return "Have you enabled the camera access? <span class=\"clickable\">Check Again</span>"; },
              CHECKING: function() { return "Checking..."; },
            },

          },

        },

      },

      MEET_AND_GREET: {
        DESCRIPTION: function() { return "Meet and Greet"; },
        MODAL: {
          DESCRIPTION: function(d) { return "Select a profile question from the org and " + d.courseAlias + " profile questions, the answers will be displayed with the " + d.learnerAlias + " names on top of the " + d.learnerAlias + " profile photos:"; },
          DISPLAY_ADDITIONAL_INFORMATION: function() { return "Display Additional Information"; },
          PICK_PROFILE_QUESTION: function() { return "Pick a Profile Question (optional)"; },
          LOCATION: function() { return "Location"; },
          SNIPPET_OF_HEADLINE: function() { return "Snippet of headline"; },
          SNIPPET_OF_SHORT_BIO: function() { return "Snippet of short bio"; },
          SET_DISPLAY_ORDER: function() { return "Set the display order of the photos:"; },
          MOST_RECENTLY_ENROLLED: function() { return "By Most Recently Enrolled"; },
          MOST_RECENTLY_ACTIVE: function(d) { return "By Most Recently Active in " + d.CourseAlias; },
          PROFILE_IMAGE_CHECKBOX: function() { return "Only display users that have uploaded a profile image"; },
        },

        NUM_COLUMNS: function(columnsCount: number) { return columnsCount + " Columns"; },
        NUM_ROWS: function(rowsCount: number) { return rowsCount + " Rows"; },
        NO_LEARNERS_TO_SHOW: function(d) { return "No " + d.learnersAlias + " to show yet, please come back later."; },
        NO_LEARNERS_IN_COLLECTION_LESSON: function(d) { return d.LearnersAlias + " are shown in the linked lesson from the course."; },
        VIEW_ALL_LEARNERS: function(d) { return "View All " + d.LearnersAlias; },
      },

      ACTIVITY: {
        POINTS: function(d) { return d.pointsCount + " " + plural(d.pointsCount, 0, en, { one: d.pointAlias, other: d.pointsAlias }); },
        X_POINTS_EACH: function(d) { return d.pointsCount + " " + plural(d.pointsCount, 0, en, { one: d.pointAlias, other: d.pointsAlias }) + " each, up to " + d.totalPoints + " " + plural(d.totalPoints, 0, en, { one: d.pointAlias, other: d.pointsAlias }); },
        STATUSES: {
          DONE: function() { return "Done"; },
          SUBMIT: function() { return "Submit"; },
          IN_PROGRESS: function() { return "In Progress"; },
          MISSED: function() { return "Missed"; },
        },

      },

      STYLED_LINK: {
        DESCRIPTION: function() { return "Styled Links"; },
        ENTER_URL_MODAL_TITLE: function() { return "Enter URL"; },
        EDIT_URL: function() { return "Edit URL"; },
        ICON_COLOR: function() { return "Icon Color"; },
        BACKGROUND_COLOR: function() { return "Background Color"; },
        TEXT_COLOR: function() { return "Text Color"; },
        EDIT_TEXT_DROP_DOWN_OPTION: function() { return "Edit Text"; },
        EDIT_COLOR_DROP_DOWN_OPTION: function() { return "Edit Color"; },
        EDIT_ICON_DROP_DOWN_OPTION: function() { return "Pick From Icon Library"; },
        REMOVE_ICON_DROP_DOWN_OPTION: function() { return "Remove Icon"; },
      },

      STYLED_LINK_BUTTON: {
        BLURB: function() { return "View Page"; },
        TOOLTIP: function() { return "Edit Button"; },
      },

      STYLED_LINK_CARD: {
        BLURB: function() { return "Article Resources on Omnichannel"; },
        TOOLTIP: function() { return "Edit Icon"; },
        UPLOAD_IMAGE_DESCRIPTION: function() { return "Upload Image"; },
      },

    },

    PROGRESS_BAR_READ_ONLY: function() { return "Progress bar"; },
    TABLE_CELL_READ_ONLY: function() { return "Table cell"; },
    DOWNLOAD_FILE_SCREEN_READ_ONLY: function() { return "Download File"; },
    TRANSLATE_FILE: {
      SCREEN_READ_ONLY: function() { return "Translate File"; },
      TOOLTIP: {
        AI_TRANSLATION: function() { return "AI Translation"; },
        TRANSLATING: function() { return "Translating..."; },
        TURN_OFF: function() { return "Turn off Translation"; },
      },

      BADGE: {
        TRANSLATING: function() { return "Translating..."; },
        TRANSLATED: function() { return "AI Translated"; },
        FAILED: function() { return "Failed to Translate!"; },
        TRY_AGAIN: function() { return "Try again?"; },
      },

    },

    VIDEO_THUMBNAIL_ALT: function() { return "Video Thumbnail"; },
    COURSE_OUTLINE_BUTTON_ARIA_LABEL: function() { return "Course outline button"; },
    PROFILE_PICTURE_SCREEN_READ_ONLY: function() { return "Profile picture"; },
    INPUT_NUMBER_SCREEN_READ_ONLY: function() { return "Numeric input"; },
  },

  SELF_PACED: {
    VISITED_RECENTLY: function() { return "People who visited this page recently"; },
    WATCHED_RECENTLY: function() { return "People who watched recently"; },
    COMPLETED_RECENTLY: function() { return "People who completed recently"; },
  },

  ACTIVITY: {
    LOCKED_EXPLANATION: function(itemTitle: string) { return "This activity is locked, please complete <b>" + itemTitle + "</b> to unlock this."; },
    LOCKED_POPOVER_SINGLE: function(d) { return "This " + d.activityAlias + " is locked to " + d.learnersAlias + ". They will need to " + select(d.action, { view: "view", other: "complete" }) + " <a class=\"blue-link\" href=\"" + d.activityLink + "\" target=\"_self\">" + d.activityName + "</a> in order to gain access to this page."; },
    LOCKED_POPOVER_MULTIPLE_SAME: function(d) { return "This " + d.activityAlias + " is locked to " + d.learnersAlias + ". They will need to " + select(d.action, { view: "view", other: "complete" }) + " <a class=\"blue-link\" href=\"" + d.activityFirstLink + "\" target=\"_self\">" + d.activityFirstName + "</a> and <a class=\"blue-link\" href=\"" + d.activitySecondLink + "\" target=\"_self\">" + d.activitySecondName + "</a> in order to gain access to this page."; },
    LOCKED_POPOVER_MULTIPLE_DIFFERENT: function(d) { return "This " + d.activityAlias + " is locked to " + d.learnersAlias + ". They will need to " + select(d.action, { view: "view", other: "complete" }) + " <a class=\"blue-link\" href=\"" + d.activityFirstLink + "\" target=\"_self\">" + d.activityFirstName + "</a> and " + select(d.action1, { view: "view", other: "complete" }) + " <a class=\"blue-link\" href=\"" + d.activitySecondLink + "\" target=\"_self\">" + d.activitySecondName + "</a> in order to gain access to this page."; },
    TAKE_ME_THERE: function() { return "Take Me There"; },
    EDIT_PREREQUISITES: function() { return "Edit Prerequisites"; },
    WARNING_TITLE_DUE_DATE_REMOVING: function() { return "Remove Deadline?"; },
    WARNING_DUE_DATE_REMOVING: function(scheduledCommunicationCount: number) { return scheduledCommunicationCount + " automated communications that are based on this due date will be marked as invalid and will not be sent. Are you sure you want to proceed?"; },
    WARNING_DUE_DATE_CHANGING: function() { return "Changing the due date will affect the send timing of communications based on this activity due date. Are you sure?"; },
    SHOW_POPOVER: function() { return "Show prerequisites information"; },
  },

  TIMED_QUIZZES: {
    TIME_LIMIT_MINUTES: function(timeLimit: string) { return timeLimit + " " + plural(timeLimit, 0, en, { one: "Minute", other: "Minutes" }) + " Limit"; },
    TIME_LIMIT_HOURS: function(timeLimit: string) { return timeLimit + " " + plural(timeLimit, 0, en, { one: "Hour", other: "Hours" }) + " Limit"; },
    TIME_REMAINING: function(min: string, sec: string) { return min + ":" + sec + " remaining"; },
    MINUTES_REMAINING: function(min: string) { return min + " " + plural(min, 0, en, { one: "Minute", other: "Minutes" }) + " Remaining"; },
    HOURS_MINUTES_REMAINING: function(hr: string, min: string) { return hr + " " + plural(hr, 0, en, { one: "Hour", other: "Hours" }) + " " + min + " " + plural(min, 0, en, { one: "Minute", other: "Minutes" }) + " Remaining"; },
    LESS_THAN_ONE_MINUTE_REMAINING: function() { return "Less than 1 minute remaining"; },
    START_EXAM: function() { return "Start the Exam"; },
    OPEN_EXAM: function() { return "Open the Exam"; },
    VIEW_FEEDBACK: function() { return "View Feedback"; },
    ANSWERED_X_CORRECT: function(correctCount: number, totalCount: number) { return "Answered " + correctCount + " out of " + totalCount + " correct"; },
    ANSWERED_ALL_CORRECT: function() { return "Answered all correct!"; },
    ONLY_ONE_ATTEMPT: function() { return "You have only one attempt"; },
    ONLY_ONE_ATTEMPT_OFFLINE: function() { return "You have only one attempt. Cannot submit while offline."; },
    FEEDBACK_AVAILABLE_AFTER: function(releaseResultsAt: string) { return "Feedback will be available after " + releaseResultsAt; },
    TIME_LIMIT_EXPIRED: function() { return "The time limit expired."; },
    EXAM_MISSED: function() { return "Your submission did not receive a passing score"; },
    DEADLINE_PASSED: function() { return "The deadline for this exam has passed."; },
    LIBRARY_DESCRIPTION: function() { return "The <b>Date/Time to release scores, feedback, and responses for learners</b> will need to be set in each linked lesson, otherwise this event will be shown as <b>\"Not Available Yet\"</b>"; },
    CONFIRM_START: {
      LIMITED_TIME_WARNING: function() { return "This is an Exam with Limited Time"; },
      HOURS_TO_FINISH_EXAM: function(timeLimit: string) { return "You only have " + timeLimit + " " + plural(timeLimit, 0, en, { one: "hour", other: "hours" }) + " to finish the exam."; },
      MINUTES_TO_FINISH_EXAM: function(timeLimit: string) { return "You only have " + timeLimit + " " + plural(timeLimit, 0, en, { one: "minute", other: "minutes" }) + " to finish the exam."; },
      LESS_THAN_X_HOURS_MINUTES_TO_FINISH_EXAM: function(hours: string, minutes: string) { return "You only have less than " + hours + " " + plural(hours, 0, en, { one: "hour", other: "hours" }) + " " + minutes + " " + plural(minutes, 0, en, { one: "minute", other: "minutes" }) + " to finish this exam."; },
      LESS_THAN_X_MINUTES_TO_FINISH_EXAM: function(minutes: string) { return "You only have less than " + minutes + " " + plural(minutes, 0, en, { one: "minute", other: "minutes" }) + " to finish this exam."; },
      ONLY_ONE_ATTEMPT: function() { return "You only have 1 attempt at this exam."; },
      ANSWER_AUTO_SAVED: function() { return "During the exam, your answer will be auto saved."; },
      ANSWER_AUTO_SUBMITTED: function() { return "When the limited time is up, your answers will be automatically submitted."; },
      ARE_YOU_READY: function() { return "Are you ready?"; },
      YES_IM_READY: function() { return "Yes, I'm Ready"; },
    },

    SUBMITTING_EXAM: function() { return "Submitting Exam"; },
    QUESTIONS_BLANK_SUBMIT: function(blankCount: number) { return "This is your only attempt at this exam. You have left " + plural(blankCount, 0, en, { one: "1 question", other: number("en", blankCount, 0) + " questions" }) + " blank. Are you sure you want to submit your responses?"; },
    SUBMISSION_CONFIRMATION: function() { return "This is your only attempt at this exam. Are you sure you want to submit your responses?"; },
    TIME_UP: function() { return "Time's Up"; },
    AUTOMATICALLY_SUBMITTED: function() { return "Your answers have been submitted."; },
    AUTOMATICALLY_SUBMITTING: function() { return "Please wait, we are submitting your answers..."; },
    VIEW_RESPONSES_ON: function(releaseResultsAt: string) { return "You will be able to view responses to this exam after " + releaseResultsAt; },
    SUBMITTED_ALREADY: function() { return "You have submitted already"; },
    MISSED_TIME_LIMIT: function() { return "You have missed the window to take this exam."; },
    LEAVE_WITHOUT_SUBMITTING: {
      TITLE: function() { return "Leaving Exam without Submitting"; },
      MSG: function() { return "You may return to the exam within the time limit and continue with your last auto-saved responses. If you do not come back before the time limit is up, your last auto-saved responses will be automatically submitted."; },
    },

    OFFLINE: {
      TITLE: function() { return "You are Offline"; },
      MSG: function() { return "Please go online to complete the exam before the time limit expires."; },
      LAST_SAVED_REPONSES: function() { return "Your last successfully saved answers while you were online have been submitted."; },
      RESPONSES_WONT_BE_SAVED: function() { return "You are offline. Responses will not be saved unless your internet connection is restored within the time limit."; },
    },

    MULTIPLE_SESSIONS: {
      TITLE: function() { return "Exam is already in progress"; },
      MSG: function() { return "You have opened this exam in another window/session. You may continue the exam in the other window or re-open the exam in this window to continue here until the time limit expires. Resuming will bring in any previously saved responses."; },
    },

    TIMER: {
      HOUR: function() { return "hour"; },
      MINUTE: function() { return "min"; },
      SECOND: function() { return "sec"; },
    },

  },

  LECTURE_VIDEO: {
    HEADER: function() { return "Lecture Video"; },
    WATCH: function() { return "Watch"; },
    WATCH_AND_ANSWER: function() { return "Watch & Answer"; },
    WATCH_AND_PRACTICE: function() { return "Watch & Practice"; },
    VIDEO: function() { return "Video"; },
    TRANSCRIPTS: function() { return "Transcripts"; },
    DOWNLOAD: function() { return "Download"; },
    VIDEO_INDEX: function(videoCount: number, videoIndex: string) { return "Video " + videoIndex + " of " + videoCount; },
    VIDEO_INDEX_WITH_TITLE: function(videoCount: number, videoIndex: string, videoTitle: string) { return "Video " + videoIndex + " of " + videoCount + ": " + videoTitle; },
    DISPLAY_TIME: function(min: number) { return plural(min, 0, en, { "0": "~1 min", one: "1 min", other: number("en", min, 0) + " mins" }) + " watch"; },
    DISPLAY_TIME_WITH_QUIZ: function(d) { return plural(d.min, 0, en, { "0": "~1 min", one: "1 min", other: number("en", d.min, 0) + " mins" }) + " watch with " + d.count + " " + plural(d.count, 0, en, { one: d.questionAlias, other: d.questionsAlias }); },
    DISPLAY_TIME_WITH_DISCUSSION: function(min: number) { return plural(min, 0, en, { "0": "~1 min", one: "1 min", other: number("en", min, 0) + " mins" }) + " watch with discussion"; },
    DISPLAY_TIME_WITH_QUIZ_AND_DISCUSSION: function(d) { return plural(d.min, 0, en, { "0": "~1 min", one: "1 min", other: number("en", d.min, 0) + " mins" }) + " watch with " + d.count + " " + plural(d.count, 0, en, { one: d.questionAlias, other: d.questionsAlias }) + " and discussion"; },
    QUESTION_SINGULAR: function() { return "question"; },
    QUESTION_PLURAL: function() { return "questions"; },
    AT: function() { return "at"; },
    VIDEO_LIST: function() { return "Video List"; },
    ADD_VIDEO: function() { return "Add Video"; },
    EDIT_VIDEO: function() { return "Edit Video"; },
    DELETE_VIDEO: function() { return "Delete Video"; },
    REORDER_VIDEOS: function() { return "Reorder Videos"; },
    ADD_VIDEO_TO_PLAYLIST: function() { return "Add Video to Playlist"; },
    ADD_VIDEO_TO_CREATE_PLAYLIST: function() { return "Add Video to Create a Playlist"; },
    ADD_QUIZ: function() { return "Add a Quiz"; },
    EDIT_QUIZ: function() { return "Edit Quiz"; },
    ADD_DISCUSSION: function() { return "Add a Discussion"; },
    UPLOAD_FILE: function() { return "Upload File"; },
    UPLOAD_A_DOCUMENT: function() { return "Upload a Document"; },
    UPLOAD_FILE_DISABLED_TOOLTIP: function() { return "You must first select the type of document"; },
    ADD_SLIDES: function() { return "Add Slides"; },
    ADD_TRANSCRIPTS: function() { return "Add Transcripts"; },
    ADD_CAPTIONS: function() { return "Add Captions"; },
    CLOSED_CAPTIONS: function() { return "Closed Captions"; },
    ADD_CUSTOM_THUMBNAILS: function() { return "Add Custom Thumbnails"; },
    REPLACE_VIDEO_FILE: function() { return "Replace Video File"; },
    DOCUMENT_TYPE: function() { return "Document Type"; },
    VIDEO_POPOVER_HEADING: function() { return "Captions and Transcripts for Videos"; },
    VIDEO_POPOVER_CONTENT: function() { return "NovoAI tools (e.g., AI Quiz, AI Discussion, etc.) must have transcripts or closed caption files present (either AI generated or manually uploaded) in order to include video material in the content it generates."; },
    PLEASE_SELECT_DOCUMENT_TYPE: function() { return "Please Select Document Type"; },
    DOCUMENT_TYPE_SLIDES: function() { return "Slides (.ppt, .pptx or .pdf)"; },
    DOCUMENT_TYPE_TRANSCRIPT: function() { return "Transcript (.doc, .docx or .pdf)"; },
    DOCUMENT_TYPE_CUSTOM_THUMBNAIL: function() { return "Custom Thumbnail (.jpg, .png or .gif)"; },
    DOCUMENT_TYPE_CAPTIONS: function() { return "Captions (.vtt or .srt)"; },
    SLIDES: function() { return "Slides"; },
    TRANSCRIPT: function() { return "Transcript"; },
    CUSTOM_THUMBNAIL: function() { return "Custom Thumbnail"; },
    CAPTIONS: function() { return "Captions"; },
    PLEASE_SELECT_LANGUAGE: function() { return "Please Select Language"; },
    ARE_YOU_SURE_YOU_WANT_TO_DELETE: function() { return "Are you sure you want to delete?"; },
    RECOMMENDED_FILETYPES: function() { return ".mp4, .mov, .avi"; },
    AUTO_GENERATED_TRANSCRIPT_AND_CAPTIONS: {
      LABEL: function() { return "AI Captions and Transcript for Videos"; },
      POPOVER: function() { return "AI captions and transcript is disabled in your organization. Please contact your Org admin to enable."; },
      INFO_DETAILS: {
        TITLE: function() { return "AI Captions and Transcript for Videos"; },
        DESCRIPTION: function() { return "If enabled, transcripts will be included in the data used to generate content made with NovoAI tools (e.g., AI Quiz, AI Discussions, etc.)."; },
      },

      INFO: {
        TITLE: {
          BOTH: function() { return "Generating Captions and Transcript"; },
          TRANSCRIPT: function() { return "Generating Transcript"; },
          CAPTIONS: function() { return "Generating Captions"; },
          ERROR_GENERAL: function() { return "Auto generation failed!"; },
          ERROR_DUPLICATED_LANGUAGE: function() { return "Cannot overwrite manually uploaded captions"; },
        },

        MESSAGE: {
          EMAIL: function() { return "We will send you an email when it is done."; },
          UPDATE: function() { return "We will automatically update the video and send you an email when it is done."; },
          UNSUPPORTED_LANGUAGE: function() { return "Language of the video is not supported. Please refer to our help articles to learn more."; },
          LANGUAGE_LOW_CONFIDENCE: function() { return "Language of the video could not be detected. Please refer to our help articles to learn more."; },
          DUPLICATED_LANGUAGE: function() { return "A captions file in the same language already exists, please delete and retry to add auto-generated captions."; },
        },

      },

      AUTO_GENERATE: function() { return "Auto Generate"; },
      AUTO_GENERATED: function() { return "Auto-Generated"; },
      AUTO_TRANSLATED: function() { return "Auto-Translated"; },
      GENERATING: function() { return "Generating..."; },
      AI_GENERATED: function() { return "AI Generated"; },
      WILL_REGENERATE: {
        LABEL: function() { return "Will regenerate"; },
        TOOLTIP: function() { return "The file will be regenerated after you click Update"; },
      },

      TOOLTIP: {
        TRANSCRIPT: function() { return "Transcript already exists. To add again, please delete the existing transcript first"; },
        UNSUPPORTED_LANGUAGE: function() { return "Video Language is not Supported"; },
        LANGUAGE_LOW_CONFIDENCE: function() { return "Cannot detect the Video Language"; },
        DUPLICATED_LANGUAGE: function() { return "Captions in the video language already exists"; },
        REPLACED_VIDEO: function() { return "Please update the video to enable auto-generation"; },
      },

      FORM: {
        ARE_YOU_SURE_YOU_WANT_TO_CANCEL: function() { return "Are you sure you want to stop auto-generating?"; },
        STOP: function() { return "Stop"; },
      },

      OVERLAY: {
        TITLE: function() { return "Replace Auto Generated Captions?"; },
        DESCRIPTION: function() { return "An auto-generated captions file in the same language already exists. On proceed, the auto-generated file will be replaced with the captions you have uploaded. <br/> <span class=\"bold\">Are you sure you want to continue?</span>"; },
      },

      IS_IN_PROGRESS: function() { return "AI captions/transcript generation is in progress, you may push changes after it is complete."; },
    },

    PICK_FROM_LIBRARY: function() { return "Or, Pick from the library"; },
    VIDEO_LIBRARY: function() { return "Video library"; },
    EMPTY_LIBRARY: function() { return "Library is empty"; },
    LIBRARY_LOADING: function() { return "Loading..."; },
    DELETE_VIDEO_FROM_COURSE: function(d) { return "Delete Video from the " + d.courseAlias; },
    DELETE_SHARED_MEDIA_FROM_LIBRARY: {
      TITLE: function(isAudio: string) { return "Delete Shared " + select(isAudio, { true: "Audio", other: "Video" }) + " from the library?"; },
      BODY: function(isAudio: string, numCoursesUsing: number) { return "WARNING: This is a shared " + select(isAudio, { true: "audio", other: "video" }) + " and used in " + plural(numCoursesUsing, 0, en, { one: "another offering", other: number("en", numCoursesUsing, 0) + " offerings" }) + ". To proceed, please check to confirm the following:"; },
      DELETE_FROM_LESSONS: function(d) { return "Delete the " + select(d.isAudio, { true: "audio", other: "video" }) + " from all " + d.lecturesAlias + " across all offerings it is used"; },
      DELETE_ALL_ASSOCIATED: function() { return "Delete all associated content, activities, and user data in all offerings"; },
      YES_DELETE_ALL: function() { return "Yes, Delete All"; },
    },

    EDIT_SHARED_MEDIA: {
      TITLE: function() { return "Are you sure?"; },
      FIRST_BODY: function(isAudio: string, numCoursesUsing: number) { return "This shared " + select(isAudio, { true: "audio", other: "video" }) + " file is used in " + plural(numCoursesUsing, 0, en, { one: number("en", numCoursesUsing, 0) + " other offering:", other: number("en", numCoursesUsing, 0) + " offerings including:" }); },
      SECOND_BODY: function(isAudio: string, isProgram: string, numOthers: number) { return plural(numOthers, 0, en, { "0": "", one: "and 1 other. ", other: "and " + number("en", numOthers, 0) + " others. " }) + "Changing the " + select(isAudio, { true: "audio", other: "video" }) + " file will change it in all these offerings. To change only in this offering, disable audio/video sharing in " + select(isProgram, { true: "program", other: "course" }) + " basics first."; },
      SECOND_BODY_ONE_COURSE: function(isAudio: string, isProgram: string) { return "Changing the " + select(isAudio, { true: "audio", other: "video" }) + " file will change it in the above offering as well. To change only in this offering, disable audio/video sharing in " + select(isProgram, { true: "program", other: "course" }) + " basics first."; },
    },

    DELETE_VIDEO_CONFIRMATION_MSG: function(d) { return "Deleting this video will remove it from all " + d.lectureAlias + " pages that are using it. If discussion or quiz has been added to the video, this action will also delete all the content, activities and any existing user data for the discussion or quiz. Are you sure?"; },
    LEARNERS_CAN_DOWNLOAD: function() { return "Learners can also download this video"; },
    USED_IN_OTHER_COURSES: function(isAudio: string) { return "This " + select(isAudio, { true: "audio", other: "video" }) + " is being used in other offerings, any changes made will change the " + select(isAudio, { true: "audio", other: "video" }) + " in other places."; },
    DOWNLOAD_ORIGINAL: function() { return "Download the original"; },
    DISCUSSIONS: {
      DISCUSSION_PROMPT: function() { return "Discussion Prompt"; },
      DISCUSSION_PROMPT_PLACEHOLDER: function() { return "Add a discussion prompt here"; },
      ADD_DISCUSSION_TO_VIDEO: function(videoName: string) { return "Add Discussion to " + videoName; },
      EDIT_DISCUSSION: function() { return "Edit Discussion"; },
      EDIT_DISCUSSION_TO_VIDEO: function(videoName: string) { return "Edit Discussion  to " + videoName; },
      DELETE_DISCUSSION: function() { return "Delete Discussion"; },
    },

    QUIZZES: {
      QUESTION_INDEX: function(index: string) { return "Question " + index; },
      QUESTION_INDEX_ALIASED: function(d) { return d.questionAlias + " " + d.index; },
      SKIP_TO_QUESTION: function() { return "Skip to Question"; },
      SKIP_TO_QUESTION_ALIASED: function(d) { return "Skip to " + d.questionAlias; },
      REVIEW: function() { return "Review Video"; },
      CONTINUE: function() { return "Continue"; },
      VIEW_MY_RESPONSE: function() { return "View My Response"; },
    },

  },

  LECTURE_AUDIO: {
    AUDIO: function() { return "Audio"; },
    ADD_AUDIO: function() { return "Add Audio"; },
    LISTEN: function() { return "Listen"; },
    X_MIN: function(min: number) { return plural(min, 0, en, { one: "1 min", other: number("en", min, 0) + " mins" }); },
    DISPLAY_TIME: function(min: number) { return plural(min, 0, en, { "0": "~1 min", one: "1 min", other: number("en", min, 0) + " mins" }) + " audio"; },
    AUDIO_LIST: function() { return "Audio List"; },
    EDIT_AUDIO: function() { return "Edit Audio"; },
    DELETE_AUDIO: function() { return "Delete Audio"; },
    REORDER_PLAYLIST: function() { return "Reorder Playlist"; },
    REPLACE_AUDIO_FILE: function() { return "Replace Audio File"; },
    PICK_FROM_LIBRARY: function() { return "Or, Pick from the audio library"; },
    RECOMMENDED_FILETYPES: function() { return ".mp3"; },
    LEARNERS_CAN_DOWNLOAD: function() { return "Learners can also download this audio"; },
    ADD_AUDIO_TO_PLAYLIST: function() { return "Add Audio to Playlist"; },
    ADD_AUDIO_TO_CREATE_PLAYLIST: function() { return "Add Audio to Create a Playlist"; },
    DELETE_AUDIO_FROM_COURSE: function(d) { return "Delete Audio from the " + d.courseAlias; },
    DELETE_AUDIO_CONFIRMATION_MSG: function(d) { return "Deleting this audio will remove it from all " + d.lectureAlias + " pages that are using it. Are you sure?"; },
  },

  VIDEO: {
    SPEED: function(speed: string) { return speed + "x"; },
    GENERATING_PREVIEW_ONLY: function() { return "Video preview generation may take several minutes. You may still watch the video."; },
    PREVIEW_NOT_AVAILABLE: function() { return "Preview Not Available Yet"; },
    GENERATING_THUMBNAIL: function() { return "Generating Thumbnail..."; },
  },

  COURSES: {
    HEADER: function() { return "Course Header"; },
    NEW_COURSE: function() { return "New Course"; },
    COURSE_TEMPLATES: {
      START_FROM_SCRATCH: function() { return "Start from Scratch"; },
      START_FROM_A_TEMPLATE: function() { return "Start from a Template"; },
      TEMPLATE: function() { return "Template"; },
      USE_THIS_TEMPLATE: function() { return "Use This Template"; },
      DESCRIPTION: function() { return "Description"; },
      COURSE_NAME: function() { return "Course Name"; },
      CATALOG_ID_UNIQUE: function() { return "Catalog ID (uniqueness required)"; },
      TYPE_HERE: function() { return "Type here..."; },
      JUST_A_MOMENT: function() { return "Just a moment..."; },
      CREATING_COURSE: function() { return "Creating Course"; },
      CREATE_FROM_TEMPLATE: function() { return "Create from Template"; },
      CREATING_TEMPLATE: function() { return "Creating from the template, keep an eye on your email if you close this screen."; },
    },

    EDIT: function(isProgram: string) { return "Edit " + select(isProgram, { true: "Program", other: "Course" }); },
    FLYER: function(isProgram: string) { return select(isProgram, { true: "Program", other: "Course" }) + " Flyer"; },
    BASICS: function() { return "Basics"; },
    ANALYTICS: function() { return "Analytics"; },
    COHORTS_ANALYTICS: function() { return "Cohorts Analytics"; },
    TEACHING_TEAM: function() { return "Teaching Team"; },
    FLYER_AND_CONTENT: function(isProgram: string) { return select(isProgram, { true: "Program", other: "Course" }) + " Flyer and Content"; },
    PRIMARY_COURSE: function() { return "Primary Course"; },
    REGISTRATION_TYPE: {
      TYPE_0: function() { return "Free and Open to the Public"; },
      TYPE_1: function() { return "Paid"; },
      TYPE_2: function() { return "Free with Paid Certificate"; },
      TYPE_3: function() { return "Closed Enrollment"; },
      TYPE_4: function() { return "Open within your Organization"; },
      TYPE_5: function() { return "Open based on Entitlements"; },
      TYPE_ALL: function() { return "All"; },
      DESCRIPTION_0: function() { return "Anyone can register"; },
      DESCRIPTION_1: function(isProgram: string) { return "Anyone can register, registrants should pay to access the " + select(isProgram, { true: "program", other: "course" }) + " environment"; },
      DESCRIPTION_2: function() { return "Offered for free with option to pay for Statements of Accomplishment"; },
      DESCRIPTION_3: function(isProgram: string) { return "Private " + select(isProgram, { true: "program", other: "course" }) + " students can only be registered manually by an admin with configuration/registration permission and cannot register themselves."; },
      DESCRIPTION_4: function() { return "Anyone who belongs to the organization can discover and self-enroll."; },
      DESCRIPTION_5: function() { return "Anyone who has matching entitlement and belongs to the organization can discover and self-enroll."; },
    },

    TABS: {
      TAB_MY_VIEW: function() { return "My View"; },
      TAB_ACTIVE: function() { return "Active"; },
      TAB_FUTURE: function() { return "Future"; },
      TAB_PAST: function() { return "Past"; },
      TAB_DEMO: function() { return "Demo"; },
      TAB_TOTAL: function() { return "Total"; },
      TAB_PRIMARY: function() { return "Primary"; },
      TAB_RESULTS: function() { return "Results"; },
      TAB_TOOLTIP_ACTIVE: function() { return "List of Active Offerings"; },
      TAB_TOOLTIP_FUTURE: function() { return "List of Future Offerings"; },
      TAB_TOOLTIP_PAST: function() { return "List of Past Offerings"; },
      TAB_TOOLTIP_DEMO: function() { return "List of Demo Offerings"; },
      TAB_TOOLTIP_TOTAL: function() { return "List of All Offerings"; },
      TAB_TOOLTIP_PRIMARY: function() { return "List of Primary Courses"; },
    },

    SEARCH: {
      TITLE: function() { return "Search"; },
      PLACEHOLDER: function() { return "Search All Offering Titles"; },
      COHORTS_PLACEHOLDER: function() { return "Search within cohorts"; },
    },

    FILTER: {
      TITLE: function() { return "Filters"; },
      FILTER_BY: function() { return "Filter By:"; },
      RESET_FILTERS: function() { return "Reset Filters"; },
      APPLY_FILTERS: function() { return "Apply Filters"; },
      ARCHIVED_STATUS: function() { return "Archived Status"; },
      NOT_ARCHIVED_COURSES: function() { return "Not-Archived Courses (Default)"; },
      ARCHIVED_COURSES_ONLY: function() { return "Archived Courses Only"; },
      INCLUDE_ARCHIVED_COURSES: function() { return "Archived & Not-Archived Courses"; },
      KEYWORD: function() { return "Keyword"; },
      REGISTRATION_TYPE: {
        HEADER: function() { return "Registration Type"; },
      },

      PACE_TYPE: {
        HEADER: function() { return "Course Pace"; },
        SELF_PACED: function() { return "Self Paced"; },
        DEADLINE_BASED: function() { return "Deadline Based"; },
        ALL: function() { return "All"; },
      },

      USED_FOR: {
        HEADER: function() { return "Course Type"; },
        TYPE_0: function() { return "Production Offering"; },
        TYPE_1: function() { return "Sandbox or Demo"; },
        TYPE_2: function() { return "Primary Offering"; },
        TYPE_ALL: function() { return "All"; },
      },

      PRIMARY: {
        HEADER: function() { return "Primary Course"; },
      },

      COHORTS: {
        HEADER: function() { return "Cohorts of"; },
      },

    },

    EXPORT: function() { return "Export"; },
    DASHBOARD_TABLE: {
      OFFERING_NAME: function() { return "Name"; },
      NUM_OF_COURSES: function() { return "# of Courses"; },
      COURSE_NAME: function() { return "Course Name"; },
      GENERAL_OFFERING_NAME: function() { return "Offering Name"; },
      RELEASE_DATE: function() { return "Release Date"; },
      START_DATE: function() { return "Start Date"; },
      END_DATE: function() { return "End Date"; },
      CLOSE_DATE: function() { return "Close Date"; },
      PACE: function() { return "Pace"; },
      DEADLINE_BASED: function() { return "Deadline Based"; },
      SELF_PACE_BASED: function() { return "Self Paced"; },
      DAYS_ACCESS: function(number: string) { return "(" + number + " day access)"; },
      NUM_ENROLLEES: function() { return "Enrollment"; },
      COMPLETION_RATE: function() { return "Completion Rate"; },
      NUM_UNENROLLED_BY_TEACHING_TEAM: function() { return "# unenrolled by teaching team"; },
      NUM_WITHDRAWN: function() { return "# withdrawn"; },
      NUM_UNPAID: function() { return "# enrolled but unpaid"; },
      REGISTRATION_TYPE: function() { return "Registration Type"; },
      DETAILS: function() { return "Details"; },
      CREATED_BY: function(creator: string) { return "Created By: " + creator; },
      RATE: function(rate: string) { return "Rate: $" + rate; },
      CLONING_IN_PROGRESS: function() { return "Cloning in Progress..."; },
      CLONING_IN_PROGRESS_DESCRIPTION: function() { return "Course cloning in progress. You will be able to edit the course once it's done"; },
      RELEASE_DATE_TOOLTIP: function() { return "On this date, learners will be able to access the course environment."; },
      LISTED: function() { return "Listed"; },
      DELETION_IN_PROGRESS: function() { return "Deletion in Progress..."; },
      DELETION_IN_PROGRESS_DESCRIPTION: function() { return "Deletion is in progress. You can no longer make changes to this course."; },
      CLICK_TO_EXPAND: function() { return "Click to expand for more details"; },
      CLICK_TO_HIDE: function() { return "Click to hide details"; },
      RELEASING_IN_X_DAYS: function(dayCount: number) { return "Releasing in " + plural(dayCount, 0, en, { one: number("en", dayCount, 0) + " day", other: number("en", dayCount, 0) + " days" }); },
      RELEASING_IN_X_HOURS: function(hourCount: number) { return "Releasing in " + plural(hourCount, 0, en, { one: number("en", hourCount, 0) + " hour", other: number("en", hourCount, 0) + " hours" }); },
      RELEASING_IN_HOUR: function() { return "Releasing in less than an hour..."; },
      IN_PROGRESS: function() { return "In Progress"; },
      CLOSED: function() { return "Closed"; },
      COMPLETE: function() { return "Complete"; },
      USERS: function(count: number) { return plural(count, 0, en, { one: "User", other: "Users" }); },
      ACTIVE_IN_7_DAYS: function() { return "Active within the last 7 days"; },
      CLOSING_IN_X_DAYS: function(dayCount: number) { return "Closing in " + plural(dayCount, 0, en, { one: number("en", dayCount, 0) + " day", other: number("en", dayCount, 0) + " days" }); },
      CLOSING_IN_X_HOURS: function(hourCount: number) { return "Closing in " + plural(hourCount, 0, en, { one: number("en", hourCount, 0) + " hour", other: number("en", hourCount, 0) + " hours" }); },
      CLOSING_IN_HOUR: function() { return "Closing in less than an hour..."; },
    },

    OPTIONS: {
      AUDIT: function() { return "Audit"; },
      REVERSE_AUDITING_STATUS: function() { return "Reverse Auditing Status"; },
      MAKE_PAYMENT: function() { return "Make Payment"; },
      WITHDRAW: function() { return "Withdraw"; },
    },

    LISTED: function() { return "Listed"; },
    NOT_LISTED: function() { return "Not Listed"; },
    FORM: {
      HEADER: {
        UPDATE_LOGO: function() { return "Update Course Logo"; },
        UPLOAD_LOGO: function() { return "Upload your course logo"; },
        LOGO_TOOLTIP: function() { return "Click to update your course logo"; },
        BACKGROUND_IMAGE_TOOLTIP: function() { return "Give your course header a beautiful image background"; },
      },

      BASICS: function() { return "Basics"; },
      SELECTION_FROZEN: function() { return "This selection cannot be changed after the course is created."; },
      CATALOG_ID: function() { return "Catalog ID"; },
      COURSE_TYPE_DESCRIPTION: function() { return "This offering is a:"; },
      COHORT_DESCRIPTION: function() { return "This offering is a cohort of:"; },
      COURSE_TYPE_COURSE: function() { return "Course"; },
      COURSE_TYPE_PROGRAM: function() { return "Program"; },
      COURSE_TYPE_PROGRAM_DETAILS: function() { return "Community discussion space for a collection of courses."; },
      USED_FOR_DESCRIPTION: function(isProgram: string) { return "This " + select(isProgram, { true: "program", other: "course" }) + " is created for:"; },
      USED_FOR_PRODUCTION: function() { return "Production Offering"; },
      USED_FOR_DEMO: function() { return "Demo Offering"; },
      USED_FOR_DEMO_DESCRIPTION: function(isProgram: string) { return "A demo offering cannot be found by anyone who is not registered for the " + select(isProgram, { true: "program", other: "course" }) + "."; },
      USED_FOR_PRIMARY: function() { return "Primary Course"; },
      USED_FOR_PRIMARY_DESCRIPTION: function() { return "This course is a blueprint for creating new cohort sessions. Primary courses are by default closed enrollment, not discoverable and do not integrate with LMS/LXP."; },
      PRIMARY_COURSE_INVALID_REGISTRATION_TYPE: function() { return "Registration type not available for primary courses"; },
      SHORT_TITLE_EXAMPLE_DESCRIPTION: function(isProgram: string) { return "This is a shorter title for the " + select(isProgram, { true: "program", other: "course" }) + " card. Please try to keep this title under 60 characters."; },
      COVER_PHOTO_EXAMPLE_DESCRIPTION: function(isProgram: string) { return "This is the cover picture for a sample " + select(isProgram, { true: "program", other: "course" }) + "."; },
      TIME_BASED_DESCRIPTION: function(isProgram: string) { return "Activities in this " + select(isProgram, { true: "program", other: "course" }) + ":"; },
      TIME_BASED: {
        HEADER: function() { return "May have deadlines"; },
        CHANGE_MESSAGE: function() { return "Changing to deadline based will remove self paced format specific configurations."; },
        CONFIRMATION_MESSAGE: function() { return "You have selected to change a self paced course to deadline based. This will remove any self paced format specific configurations such as limited time enrollment and recent activity display on lessons and activities. Are you sure?"; },
      },

      SELF_PACED: {
        HEADER: function() { return "Are self-paced with no deadlines"; },
        CHANGE_MESSAGE: function() { return "Changing to self paced will remove any existing deadlines in the course"; },
        CONFIRMATION_MESSAGE: function() { return "You have selected to change a deadline based course to self paced. This will remove any existing deadlines from activities. Are you sure?"; },
      },

      ENROLLMENT_LIMIT_DESCRIPTION: function() { return "Close Access After"; },
      ENROLLMENT_DAYS: function() { return "days enrolled"; },
      NOTE: function(isProgram: string) { return "This selection cannot be changed after the " + select(isProgram, { true: "program", other: "course" }) + " is created."; },
      REGISTRATION: function() { return "Registration"; },
      OPEN_IN_JOURNEY: function() { return "Open enrollment within a learning journey"; },
      CLOSE: function() { return "Close"; },
      CREATED_SUCCESSFULLY: function(isProgram: string) { return select(isProgram, { true: "Program", other: "Course" }) + " Created Successfully"; },
      UPDATED_SUCCESSFULLY_WITH_VIDEO_SHARING_DECOUPLING: function(isProgram: string, isVideoSharingDecoupling: string) { return select(isProgram, { true: "Program", other: "Course" }) + " Updated Successfully. " + select(isVideoSharingDecoupling, { true: "Video sharing update is in progress and may take a few minutes. You will receive an email when complete.", other: "" }); },
      CONFIRMATION_TEXT: function(isProgram: string) { return "You can find your new " + select(isProgram, { true: "program", other: "course" }) + " on your dashboard."; },
      COURSE_TITLE: function(isProgram: string) { return "Enter " + select(isProgram, { true: "Program", other: "Course" }) + " Title Here*"; },
      PROGRAM_TITLE: function() { return "Program Title *"; },
      COURSE_DATES: {
        TITLE: function(isProgram: string) { return select(isProgram, { true: "Program", other: "Course" }) + " Dates"; },
        RELEASE_DATE: function() { return "Release Date"; },
        START_DATE: function() { return "Start Date"; },
        REGISTRATION_CLOSE_DATE: function() { return "Registration Close Date"; },
        PAYMENT_START_DATE: function() { return "Payment Start Date"; },
        PAYMENT_END_DATE: function() { return "Payment End Date"; },
        END_DATE: function() { return "End Date"; },
        CLOSE_DATE: function() { return "Closure Date"; },
        ARCHIVED_TOOLTIP: function() { return "Course is archived! To change the close date, please unarchive the course first."; },
        CLOSE_DATE_OPTIONS: {
          APPLY_TO_ALL: function() { return "Apply close date to all learners"; },
          APPLY_ONLY_TO_NO_COMPLETION: function() { return "Apply close date only to learners who did not complete"; },
          APPLY_ONLY_TO_NO_COMPLETION_DESCRIPTION: function() { return "Learners who have not completed the course will lose access to the content, while those who have completed it will still be able to access it."; },
        },

      },

      COVER_PHOTO_UPLOAD_TEXT: function(isProgram: string) { return "Upload a Cover Picture for this " + select(isProgram, { true: "program", other: "course" }); },
      COVER_PHOTO: {
        MAX_SIZE: function(maxSize: string) { return "Please make sure your image is under " + maxSize + " in size."; },
      },

      VIDEO_SHARING: {
        TITLE: function() { return "Audio and Video Sharing"; },
        DESCRIPTION: function(isProgram: string) { return "Make audio and video library shared via this " + select(isProgram, { true: "program", other: "course" }) + " available to another " + select(isProgram, { true: "program", other: "course" }) + " and vice versa."; },
        INFORMATION: function() { return "Note: Any updates to shared audio/video files will be reflected across all the offerings where they are used. Uncheck to stop sharing."; },
        SELECT_A_COURSE: function(isProgram: string) { return "Select a " + select(isProgram, { true: "Program", other: "Course" }); },
        SOURCE_OF_SHARING: function(isProgram: string) { return "One or more " + select(isProgram, { true: "programs", other: "courses" }) + " share audio and video library via this " + select(isProgram, { true: "program", other: "course" }) + ". They may stop sharing on Edit Basics page."; },
      },

      MICROSOFT_CALENDAR_COURSE_INTEGRATION: {
        TITLE: function() { return "Microsoft 365 Calendar Integration"; },
        DESCRIPTION: function() { return "Automatically create Outlook Calendar events for course live events and activities with deadlines for enrolled learners."; },
        UNAVAILABLE_TOOLTIP: function() { return "This option is only available for courses created as production offerings."; },
        ADVICE: function(associatedEmail: string) { return "Events will originate from " + associatedEmail + ". When deactivating the integration, no future events will be added to learners' calendars and previously created events will be deleted as long as the event has not occurred."; },
      },

      ENROLLMENT_LIMIT: {
        TITLE: function() { return "Enrollment Limit"; },
        LIMIT: {
          DESCRIPTION: function() { return "Enable self-enrollment limit by entering a number below."; },
          PLACEHOLDER: function() { return "Set the limit here..."; },
        },

        WAITLIST: {
          ENABLE: function() { return "Enable Waitlist"; },
          DESCRIPTION: function() { return "Enable the waitlist option so learners can add themselves to it if enrollment limit is reached."; },
        },

      },

      ADDITIONAL_METADATA: {
        TITLE: function() { return "Additional Metadata"; },
        COURSE_DURATION: function() { return "Course Duration"; },
        PLEASE_SELECT_METADATA_TAG: function() { return "Please Select"; },
        REQUIRED: function() { return "(*Required)"; },
      },

      WORKDAY_INTEGRATION: {
        TITLE: function() { return "Workday Learning Integration"; },
        CONTENT_ID: function() { return "ContentID"; },
        DESCRIPTION: function() { return "ContentID from Workday Learning will be assigned after the course is created and released, please make sure you have the release date filled in."; },
        TOPIC: function() { return "Topic"; },
        SELECT: function() { return "Select Topic"; },
        SELECTED: function() { return "Selected"; },
        REQUIRED: function() { return "(*Required)"; },
        REQUIRED_DESCRIPTION: function() { return "Topic is required, please select at least one."; },
        DISABLED_TOOLTIP: function() { return "Default Topic can’t be unchecked"; },
      },

      SUMTOTAL_INTEGRATION: {
        TITLE: function() { return "SumTotal Integration"; },
        ACTIVITY_CODE: function() { return "Activity Code"; },
        ACTIVITY_ID: function() { return "Activity ID"; },
        VALIDATE: function() { return "Validate"; },
        VALIDATING: function() { return "Checking..."; },
        ACTIVITY_NOT_FOUND: function() { return "Activity not found!"; },
        SUCCESS_VALIDATION: function() { return "Successful validation"; },
        VALIDATION_ERROR: function() { return "Activity Code needs to be validated"; },
        INDICATIONS: function() { return "Enter the SumTotal Activity Code for this course in order to enable syncing of enrollments and completions with SumTotal. Only production courses will sync with SumTotal, not demo/sandbox courses. Once the course is released, the activity will not be editable."; },
        LEARNING_JOURNEYS: {
          INDICATIONS: function() { return "Enter the SumTotal Activity Code for this Learning Journey in order to enable syncing of enrollments and completions with SumTotal. Once the journey is released, the activity code will not be editable."; },
        },

      },

      EDCAST: {
        TITLE: function() { return "EdCast Integration"; },
        LAST_SYNC_UP_AT: function() { return "Last Synced to EdCast"; },
      },

      LMS: {
        TITLE: function() { return "LMS"; },
        EXTERNAL_COURSE_NUMBER: function() { return "Course Number"; },
        EXTERNAL_COURSE_ID: function() { return "Course ID"; },
        EXTERNAL_CLASS_NUMBER: function() { return "Class Number"; },
        EXTERNAL_CLASS_ID: function() { return "Class ID"; },
      },

      LXP: {
        TITLE: function() { return "LXP"; },
        EXTERNAL_COURSE_ID: function() { return "ID"; },
      },

      LISTING: {
        TITLE: function() { return "Listing"; },
        REQUEST_TO_LIST: function() { return "Request to List on NovoEd"; },
        LIST_ON_NOVOED: function() { return "List on NovoEd"; },
        DATE: function() { return "Listing Date"; },
        SUMMARY: function() { return "Executive Summary"; },
        REQUEST_SENT: function() { return "Request sent"; },
        REQUEST_APPROVED: function() { return "Request approved"; },
      },

      NOVOED_ADMIN: function() { return "NovoEd Admin"; },
      SET_OF_FEATURES: {
        DESCRIPTION: function(isProgram: string) { return "This " + select(isProgram, { true: "program", other: "course" }) + " has:"; },
        STANDARD_FEATURES: function() { return "Standard features"; },
        PREMIUM_FEATURES: function() { return "Premium features"; },
        PREMIUM_FEATURES_DESCRIPTION: function(isProgram: string) { return "Note: Only use for small " + select(isProgram, { true: "programs", other: "courses" }) + "."; },
      },

      RATE: function() { return "Rate"; },
      WHAT_YOU_GET: function() { return "What you get"; },
      SEE_AN_EXAMPLE: function() { return "See an example"; },
      VALIDATION_TEXT: {
        CATALOG_ID_PATTERN: function() { return "Can only contain letters, dashes, underscores, and numbers"; },
        END_DATE_BEFORE_RELEASE_DATE: function(isProgram: string) { return select(isProgram, { true: "Program", other: "Course" }) + " end date cannot be before the " + select(isProgram, { true: "program", other: "course" }) + " release date."; },
        END_DATE_BEFORE_START_DATE: function(isProgram: string) { return select(isProgram, { true: "Program", other: "Course" }) + " end date cannot be before the " + select(isProgram, { true: "program", other: "course" }) + " start date."; },
        PAYMENT_START_DATE_AFTER_COURSE_END_DATE: function(isProgram: string) { return "Payment start date cannot be later than the " + select(isProgram, { true: "program", other: "course" }) + " end date."; },
        PAYMENT_END_DATE_BEFORE_PAYMENT_START_DATE: function() { return "Payment end date cannot be before the payment start date."; },
        PAYMENT_END_DATE_BEFORE_COURSE_END_DATE: function(isProgram: string) { return "Payment end date cannot be after the " + select(isProgram, { true: "program", other: "course" }) + " end date."; },
        ENROLLMENT_LIMIT_IN_DAYS_PATTERN: function() { return "Enrollment limit should be a positive number"; },
      },

      HELP_TEXT: {
        CATALOG_ID: function() { return "Uniqueness required, use hyphens to connect words."; },
        CATALOG_NAME: function(isProgram: string) { return "This title will be used in the " + select(isProgram, { true: "program", other: "course" }) + " catalog should you choose to list the " + select(isProgram, { true: "program", other: "course" }) + "."; },
        COVER_PHOTO: function(isProgram: string) { return "This image will be used to represent your " + select(isProgram, { true: "program", other: "course" }) + " on learner and admin dashboards and the NovoEd mobile app. Please upload an image no larger than 5MB, but smaller is recommended. We recommend using an image with a wide 3:1 aspect ratio and a minimum height of 300px. If you want to put in your logo, please keep it in the middle of the image so it won't get cropped when trying to fit for different sizes.<br/><br/>If using Degreed Integration this image will also be sent to Degreed as a cover photo, and it is recommended to upload an image with dimensions w: 1128px, h: 350px."; },
        HOW_PHOTO_IS_USED: function() { return "See an example of how it's used in NovoEd"; },
        WHAT_YOU_GET: function(isProgram: string) { return "Tell your learners the benefits of taking this " + select(isProgram, { true: "program", other: "course" }) + ". This will be displayed on the checkout page when paying for a " + select(isProgram, { true: "program", other: "course" }) + "."; },
        RELEASE_DATE: function(isProgram: string) { return "On this date, students will be able to access the " + select(isProgram, { true: "program", other: "course" }) + " environment."; },
        PAYMENTS_START_AT: function(isProgram: string) { return "Before this date, students will be able to access the " + select(isProgram, { true: "program", other: "course" }) + " environment without having paid."; },
        START_DATE: function() { return "This is the official start of the course instruction."; },
        END_DATE: function() { return "This is the end of course instruction, learner can continue to access the course."; },
        CLOSE_DATE: function() { return "After this date, learners will not have access to content."; },
        CLOSE_DATE_SECONDARY: function() { return "After this date, learners who have not completed the course will not have access to content."; },
        EXTERNAL_NUMBER: function() { return "If set by NovoEd or Saba should store this to make it easy for Saba customer to cross reference."; },
        EXTERNAL_COURSE_ID: function() { return "Any other ID, eg. DB ID to identify course from API and for making API calls."; },
        EXTERNAL_CLASS_ID: function() { return "Any other ID, eg. DB ID to identify class from API and for making API calls."; },
        EXTERNAL_COURSE_ID_LEARNUPON: function() { return "The course id of the LearnUpon course created by NovoEd integration."; },
        LXP: {
          EXTERNAL_COURSE_ID: function() { return "This is the ID assigned by the LXP to your offering when it was sync-ed to the LXP."; },
        },

      },

      ERRORS: {
        CATALOG_ID_TAKEN: function() { return "This Catalog Id has been taken. Please select a unique Catalog Id."; },
        EMPTY_FIELDS: function() { return "Please fill out all of the required fields."; },
        UPLOADS_IN_PROGRESS: function() { return "Please wait while uploads complete or cancel uploads"; },
        FIELD_MISSING_MESSAGE: function(isPendingField: string, missingCourseField: string) { return "Please provide a " + missingCourseField + " to finish creating" + select(isPendingField, { true: ", as well as any required Metadata information.", other: "." }); },
        MANDATORY_FIELD_MISSING_MESSAGE: function() { return "Please provide any required Metadata information to finish creating."; },
        EMPTY_FIELDS_AND_ERRORS: function() { return "Please check all required fields and the errors on the page."; },
      },

      REMOVE_VIDEO_SHARING: {
        TITLE: function(courseName: string) { return "Update " + courseName; },
        DESCRIPTION: function() { return "Are you sure you want to stop sharing? By doing this, these offerings will no longer have a shared audio/video library and updates to audio/video files will not be reflected across these offerings."; },
      },

      ENTITLEMENTS: {
        CONFIGURE: function() { return "Configure Entitlements"; },
        EMPTY: function() { return "No Entitlements set yet, will not be open to anyone"; },
        MODAL: {
          DESCRIPTION: function() { return "You can set up entitlements based on profile fields that are managed by the organization."; },
          OR_LABEL: function() { return "OR"; },
          ADD_DIVIDER_TEXT: function() { return "And"; },
          ADD: function() { return "Add Entitlement Field"; },
          SELECT_PROFILE_FIELD: function() { return "Please Select Profile Field"; },
          INPUT_ENTITLEMENT_VALUE: function() { return "Input the Entitlement Value"; },
          ADD_ENTITLEMENT_VALUE: function() { return "Add Another Value"; },
        },

        NONE: function() { return "No Entitlement Set Yet, will not be open to anyone"; },
      },

    },

    CLONE: {
      NAME: function() { return "Clone"; },
      CLONE_COURSE: function(d) { return "Clone " + d.CourseAlias; },
      CLONE_NEW_COURSE: function() { return "Clone New Course"; },
      CLONE_NEW_PRIMARY: function() { return "Create a New Primary Clone"; },
      CLONE_NEW_PRIMARY_WITH_CLONE: function() { return "Create a New Primary with Clone"; },
      CLONE_NEW_COHORT: function() { return "Create a New Cohort Clone"; },
      CLONE_NEW_COHORT_WITH_CLONE: function() { return "Create New Cohort with Clone"; },
      SUCCESS_HEADER: function() { return "Cloning Request Received!"; },
      SUCCESS_BODY: function() { return "Your course is being cloned. This may take anywhere from a few minutes to an hour or more depending on course size. We will send you an email when the clone is ready."; },
      CLONE_IN_PROGRESS: {
        TITLE: function() { return "Cloning in progress!"; },
        BODY: function() { return "Small courses take minutes, while larger ones with hundreds of pages may take up to an hour. We will send you an email once it's ready."; },
      },

      CLONE_FINISHED: {
        SUCCESS: function(courseName: string) { return "Your clone is completed: <b>" + courseName + "</b>"; },
        COPY_COURSE_URL: function() { return "Copy URL"; },
        OPEN_COURSE: function() { return "Open in a new Tab"; },
        URL_COPIED: function() { return "URL Copied!"; },
      },

      FORM_TITLE: {
        NORMAL: function() { return "New Course"; },
        COHORT: function(index: string) { return "Cohort Clone " + index; },
        PRIMARY: function() { return "New Primary Course"; },
      },

      STEPS: {
        STEP_ONE: {
          NAME: function() { return "Course Information"; },
          TITLE: function() { return "Enter New Course Basics"; },
          DESCRIPTION: function() { return "You are cloning the following course:"; },
          NOT_SET: function() { return "Not Set"; },
          FORM: {
            NEW_NAME: function() { return "New Name"; },
            NEW_CATALOG_ID: function() { return "New Catalog ID (uniqueness required)"; },
            NEW_START_DATE: function() { return "New Start Date"; },
            DUPLICATE_CATALOG_ID: function(catalogId: string) { return "This Catalog Id \"" + catalogId + "\" has been taken. Please select a unique Catalog Id."; },
            DUPLICATE_MULTIPLE_CATALOG_IDS: function(catalogIds: string) { return "These Catalog Ids have been taken: \"" + catalogIds + "\". Please select uniques Catalog Ids."; },
            TOOLTIP: {
              TEXT: function() { return "All course and lesson page release dates will be offset according to the difference between the original course start date (and time) and the new start date (and time)."; },
              LINK: function() { return "Learn about course date best practices"; },
            },

            ADD_ANOTHER_COHORT: function() { return "Add another cohort"; },
            DELETE_COHORT: function() { return "Delete"; },
          },

          MEDIA_AND_REGISTRATION_TYPE: {
            TITLE: function() { return "Media and Registration Type Settings"; },
            REGISTRATION_TYPE: {
              TITLE: function() { return "Registration Type"; },
              OPEN_IN_JOURNEY: function() { return "Open enrollment for learning journey"; },
              NOT_PRIMARY_OPTIONS_TOOLTIP: function() { return "Disabled because this is a primary course"; },
            },

            MEDIA_SETTINGS: {
              TITLE: function() { return "Media Settings"; },
              COPY_AUDIO_AND_VIDEO: {
                LABEL: function() { return "Create New Copies of Audio and Video"; },
                DESCRIPTION: function() { return "All audio and video assets will be copied over and future changes <b>will not</b> be applied between the clone(s) and the original course."; },
              },

              SHARE_AUDIO_AND_VIDEO: {
                LABEL: function() { return "Keep Audio and Video Shared"; },
                DESCRIPTION: function() { return "All audio and video assets will be shared with the original course and any future changes <b>will</b> be reflected in both the clone(s) and the original course."; },
              },

            },

          },

        },

        STEP_TWO: {
          NAME: function() { return "User Management"; },
          TITLE: function() { return "Review Admin Users"; },
          DESCRIPTION: function() { return "Update admin users for this clone."; },
          DESCRIPTION_COHORT: function() { return "Admin users apply to all cohorts."; },
          COUNTER: function(selected: string, total: string) { return selected + " of " + total + " selected"; },
          FILTER: {
            FILTER_BY_ROLE: function() { return "Filter by role"; },
            ALL_ROLES: function() { return "All Roles"; },
          },

          SELECT_ALL: function() { return "Select All"; },
          UNSELECT_ALL: function() { return "Unselect All"; },
          NO_ADMINS: function() { return "No Admin Users"; },
        },

        STEP_THREE: {
          NAME: function() { return "Review"; },
          TITLE: function() { return "Review Clone Information"; },
          DESCRIPTION: function() { return "Please note all course and lesson page release dates will be offset according to the difference between the original course start date (and time) and the new start date (and time)."; },
          COURSE_INFORMATION: function() { return "Course Information"; },
          ClONED_COURSE_INFORMATION: function() { return "Cloned Course Information"; },
          EDIT: function() { return "Edit"; },
          COURSES_LIST: {
            HEADERS: {
              NEW_COURSE_NAME: function() { return "New Course Name"; },
              NEW_CATALOG_ID: function() { return "New Catalog ID"; },
              NEW_REGISTRATION_DATE: function() { return "New Registration Close Date"; },
              NEW_START_DATE: function() { return "New Start Date"; },
              ADMIN_USERS: function() { return "Admin Users"; },
            },

          },

        },

      },

      BUTTONS: {
        BACK: function() { return "Back"; },
        NEXT: function() { return "Next"; },
        SUBMIT: function() { return "Start Clone"; },
      },

      COURSE_DETAILS: {
        COURSE_NAME: function() { return "Course Name"; },
        CATALOG_ID: function() { return "Catalog ID"; },
        START_DATE: function() { return "Start Date"; },
        ADMIN_USERS: function() { return "Admin Users"; },
        TOOLTIP: {
          TITLE: function() { return "Course Details"; },
          RELEASE_DATE: function() { return "Release Date"; },
          START_DATE: function() { return "Start Date"; },
          REGISTRATION_DATE: function() { return "Registration Close Date"; },
          END_DATE: function() { return "End Date"; },
          CLOSURE_DATE: function() { return "Closure Date"; },
        },

      },

    },

    ARCHIVE: {
      ARCHIVE_COURSE: function() { return "Archive Course"; },
      UNARCHIVE_COURSE: function() { return "Unarchive Course"; },
      MODAL: {
        TITLE: function() { return "Are you sure you want to archive this course?"; },
        BODY: function() { return "Upon confirmation, the course will close (if open) and will no longer appear in the Org Admin Dashboard. You can still access archived courses by selecting the 'Archived Status' filter in the Filter panel."; },
      },

      SUCCESS_MESSAGE: function(courseName: string, toArchive: string) { return "You have successfully " + select(toArchive, { true: "archived", other: "unarchived" }) + " " + courseName + "."; },
      BADGE: function() { return "Archived"; },
      WARNING_MESSAGE: function() { return "Course has been archived by your organization admin and it is not in active use!"; },
      CLONING_COURSE_WARNING_TOOLTIP: function() { return "Archived courses cannot be cloned."; },
    },

  },

  SEARCH: {
    RESULTS: function() { return "Results"; },
    SIMPLE_CLEAR: function() { return "Clear"; },
    SEARCH_RESULTS: function() { return "Search Results"; },
    SEARCH_RESULTS_NUM: function(resultCount: number) { return "Search Results (" + resultCount + ")"; },
    SEARCH_RESULTS_FOR_NUM: function(resultCount: number, searchQuery: string) { return "Search Results for " + searchQuery + " (" + resultCount + ")"; },
    SEARCH_RESULTS_FOR_NUM_QUERY_HIGHLIGHT: function(resultCount: number, searchQuery: string) { return "Search Results for <b>" + searchQuery + "</b> (" + resultCount + ")"; },
    SEARCH_RESULTS_FOR_QUERY: function(searchQuery: string) { return "Search Results for " + searchQuery; },
    NO_USERS_OF_TYPE: function() { return "No users of this type"; },
    NO_RESULTS_FOUND: function() { return "No Results Found"; },
    NO_USERS_ADDED_YET: function() { return "No users added yet"; },
    LOADING_RESULTS: function() { return "Loading: Search Results"; },
    SEARCH: function() { return "Search"; },
    CLEAR: function() { return "Clear Search"; },
    CLEAR_FILTER: function() { return "Clear Filter"; },
    CLEAR_FILTERS: function() { return "Clear Filters"; },
    CLEAR_X_FILTERS: function(filterCount: number) { return "Clear " + plural(filterCount, 0, en, { one: "Filter", other: "Filters" }); },
    CLEAR_ALL: function() { return "Clear All"; },
    CLEAR_ALL_FILTERS: function() { return "Clear All Filters"; },
    TRY_AGAIN_IN_FEW_MINUTES: function() { return "Please try again in a few minutes."; },
    MOMENTARILY_DOWN: function() { return "Oops! Search is momentarily down."; },
    FILTERS_SELECTED: function(filterCount: number) { return plural(filterCount, 0, en, { one: "1 filter", other: number("en", filterCount, 0) + " filters" }) + " selected"; },
    SEARCH_ALL_TOPICS: function() { return "Search All Topics"; },
    SEARCH_ALL_ASSIGNMENTS: function() { return "Search All Assignments"; },
    SAVE_AS_MY_VIEW: function() { return "Save as My View"; },
    SAVE_AND_REPLACE_MY_VIEW: function() { return "Save and Replace My View"; },
    ALL_ASSIGNMENTS: function() { return "All Assignments"; },
    ALL_LOADED: function() { return "All Loaded"; },
  },

  INSTITUTIONS: {
    NONE: function() { return "This email address is not associated with a NovoEd account that is enrolled in an active learning experience."; },
    SELECT: function() { return "Please Select an Institution:"; },
    ACCOUNT_HELP_HEADER: function() { return "Why are you encountering this error?"; },
    ACCOUNT_HELP_1: function() { return "Your email address is not enrolled in an active learning experience. A NovoEd administrator at your organization needs to ensure that you are enrolled with the correct email address. Please contact your organization's NovoEd administrator for assistance."; },
    ACCOUNT_HELP_2: function(articleLink: string) { return "If you are an administrator on NovoEd, please <a target=\"_blank\" href=\"" + articleLink + "\" class=\"trouble-shooting-link\">click here</a> for more guidance to troubleshoot the error."; },
    ACCOUNT_INFORMATION: function() { return "Does this look like a mistake? Contact hello@novoed.com with the following information for troubleshooting:"; },
    SIGN_OUT: function() { return "Sign Out"; },
    CLICK_TO_VISIT_COURSE: function() { return "Click to visit course"; },
    CLICK_TO_VISIT_PROGRAM: function() { return "Click to visit program"; },
    USER_ENROLLMENT_DETAILS: function() { return "User Enrollment Details"; },
    FORM: {
      UPDATE_BRAND_COLOR: function() { return "Update your brand color"; },
      UPDATE_LOGO: function() { return "Click to update your organization logo"; },
      LOGO_MENU: {
        NEW_LOGO: function() { return "Upload a New Logo"; },
        DELETE: function() { return "Delete Logo"; },
        SIZE: {
          HEADER: function() { return "Pick the Logo Size"; },
          SMALL: function() { return "Small"; },
          MEDIUM: function() { return "Medium"; },
          LARGE: function() { return "Large"; },
        },

      },

      DELETE_LOGO: function() { return "Delete organization logo"; },
      EDIT_INSTITUION_NAME: function() { return "Click to edit the institution name"; },
      TITLE_TEXT_WHITE: function() { return "Change the title text to white"; },
      TITLE_TEXT_BLACK: function() { return "Change the title text to black"; },
      DRAG_AND_DROP_LOGO: function() { return "Drag and drop your organization logo here"; },
      UPDATE_NAME: function() { return "Update your organization name"; },
      EDIT_BRANDING: function() { return "Edit Branding"; },
      EDIT_INSTITUTION_BRANDING: function() { return "Edit Institution Branding"; },
      UPLOAD_LOGO: function() { return "Upload your organization logo"; },
      FAILED_SAVING_HEADER: function() { return "Oops!"; },
      FAILED_SAVING_MESSAGE: function() { return "Failed saving. Please try again."; },
      UPDATE_ALL: function() { return "Update All"; },
      CONFIRMATION_MESSAGE: function() { return "The changes you have made will update the branding of your admin dashboard, all courses, and course flyers. Are you sure?"; },
    },

    LICENSES: {
      SUCCESS: function() { return "Success"; },
      LICENSE_AND_ENROLLMENT: function() { return "License and Enrollment"; },
      SEARCH_FOR_USER: function() { return "Search for User"; },
      ENROLLED_COURSES_COUNT: function(count: number) { return plural(count, 0, en, { one: "1 Offering", other: count + " Offerings" }); },
      EXPORT_ENROLLMENT_DETAILS: function() { return "Export Enrollment Details"; },
      REGISTRATION_DATE: function() { return "Registration Date"; },
      FIRST_LOGIN: function() { return "First Login"; },
      NOT_RELEASED: function() { return "Not Released"; },
      NEVER_LOGGED_IN: function() { return "Never Logged In"; },
      VISIT_COURSE: function() { return "Visit Course"; },
      VIEW_ENGAGEMENT: function() { return "View Engagement"; },
      VIEW_USER_COURSE_PROFILE: function() { return "View User Course Profile"; },
      VIEW_COURSE_PROFILE: function() { return "View Course Profile"; },
      IN_PROGRESS: function() { return "In Progress"; },
      COMPLETED: function() { return "Completed"; },
      INCOMPLETE: function() { return "Incomplete"; },
      WITHDRAWN: function(date: string) { return "Unenrolled (Withdrawn) on " + date; },
      REMOVED: function(date: string) { return "Unenrolled (Removed) on " + date; },
      PERCOURSE: function() { return "Per-Course Licensed"; },
      NOVOED_ADMINS_ONLY: function() { return "For NovoEd Admin Only"; },
      CLICK_TO_VIEW_DETAILS: function() { return "Click to view details"; },
      VIEW_PROGRESS_DETAILS: function() { return "View Progress Details"; },
      USAGE_OFF: function() { return "License usage in this course is counted in the institution license model"; },
      USAGE_ON: function() { return "Enables the course to be billed at a fixed rate and excludes it from the institution license counting. Note: Billing adjustments are handled in contracts."; },
      DASHBOARD: {
        PREVIOUS_DATA_DOWNLOADS: function() { return "Previous Data Downloads"; },
        NO_PREVIOUS_DATA_DOWNLOADS: function() { return "No Previous Data Downloads Yet"; },
        DOWNLOAD: function() { return "Download"; },
        PLEASE_SELECT: function() { return "Please select:"; },
        DATA_EXPORTS_MODAL: {
          FROM_PAST_MONTHS: function(monthCount: number) { return "Previously Generated \"Past " + plural(monthCount, 0, en, { one: "1 Month", other: number("en", monthCount, 0) + " Months" }) + "\" Reports"; },
          FROM_PAST_DAYS: function(dayCount: number) { return "Previously Generated \"Past " + plural(dayCount, 0, en, { one: "1 Day", other: number("en", dayCount, 0) + " Days" }) + "\" Reports"; },
          CURRENT_CONTRACT_PERIOD: function() { return "Previously Generated \"Current Contract Period\" Reports"; },
          ALL_DATA_SINCE: function() { return "Previously Generated \"Org Creation Date\" Reports"; },
          WITHIN_A_DATE_RANGE: function() { return "Previously Generated \"Within a Date Range\" Reports"; },
          DESCRIPTION: function() { return "Here are the most recent data exports generated for your organization:"; },
          DATA_TYPE: function() { return "Data Type"; },
          DATE_RANGE: function() { return "Date Range"; },
          GENERATED_AT: function() { return "Generated at"; },
          NO_EXPORTS: function() { return "There are no previous data exports"; },
          ERRORS: function() { return "There were errors loading previous data exports"; },
        },

        EXPORT: {
          EXPORTED: function(date: string) { return "Exported on " + date; },
          REFRESH: function() { return "Refresh"; },
          USER_DATA: {
            DOWNLOAD: function() { return "Download User Data"; },
            NAME: function() { return "User Data"; },
            ACTIVE: function() { return "Exporting User Data..."; },
            READY: function() { return "Export User Data"; },
            DISABLED_DOWNLOAD_INFO: function() { return "This option is available for production offerings"; },
            SUCCESS: {
              HEADER_CURRENT_CONTRACT_PERIOD: function() { return "Exporting user data for the current contract period."; },
              HEADER_PAST_MONTHS: function(monthCount: number) { return "Exporting user data from the past " + plural(monthCount, 0, en, { one: "1 month", other: number("en", monthCount, 0) + " months" }) + "."; },
              HEADER_PAST_DAYS: function(dayCount: number) { return "Exporting user data from the past " + plural(dayCount, 0, en, { one: "1 day", other: number("en", dayCount, 0) + " days" }) + "."; },
              HEADER_ORG_CREATION_DATE: function(creationDate: string) { return "Exporting user data since org creation date (" + creationDate + ")."; },
              HEADER_DATE_RANGE: function(endDate: string, startDate: string) { return "Exporting user data from " + startDate + " to " + endDate + "."; },
              MESSAGE: function() { return "You will receive an email when the file is generated.<br /><span style='font-style: italic'><b>Note:</b> The export process can take anywhere from a few minutes to a few hours, depending on the requested export date range and your account's volume of learner activity. If you have concerns about a particular export that you're waiting for, contact the NovoEd Support Team (hello@novoed.com).</span>"; },
            },

            FAILURE: {
              MESSAGE: function() { return "There was an error in exporting user data."; },
            },

          },

          ENROLLMENT_DATA: {
            DOWNLOAD: function() { return "Download Enrollment Data"; },
            NAME: function() { return "Enrollment Data"; },
            ACTIVE: function() { return "Exporting Enrollment Data..."; },
            READY: function() { return "Export Enrollment Data"; },
            SUCCESS: {
              HEADER: function() { return "Exporting Enrollment Data."; },
              HEADER_CURRENT_CONTRACT_PERIOD: function() { return "Exporting enrollment data for the current contract period."; },
              HEADER_PAST_MONTHS: function(monthCount: number) { return "Exporting enrollment data from the past " + plural(monthCount, 0, en, { one: "1 month", other: number("en", monthCount, 0) + " months" }) + "."; },
              HEADER_PAST_DAYS: function(dayCount: number) { return "Exporting enrollment data from the past " + plural(dayCount, 0, en, { one: "1 day", other: number("en", dayCount, 0) + " days" }) + "."; },
              HEADER_ORG_CREATION_DATE: function(creationDate: string) { return "Exporting enrollment data since org creation date (" + creationDate + ")."; },
              HEADER_DATE_RANGE: function(endDate: string, startDate: string) { return "Exporting enrollment data from " + startDate + " to " + endDate + "."; },
              MESSAGE: function() { return "You will receive an email when the file is generated.<br /><span style='font-style: italic'><b>Note:</b> The export process can take anywhere from a few minutes to a few hours, depending on the requested export date range and your account's volume of learner activity. If you have concerns about a particular export that you're waiting for, contact the NovoEd Support Team (hello@novoed.com).</span>"; },
            },

            FAILURE: {
              MESSAGE: function() { return "There was an error in exporting enrollment data."; },
            },

          },

          COURSE_ENROLLMENT_DATA: {
            SUCCESS: {
              HEADER: function(courseName: string) { return "Exporting user data for " + courseName + "."; },
              MESSAGE: function() { return "You will receive an email when the file is generated.<br /><span style='font-style: italic'><b>Note:</b> The export process can take anywhere from a few minutes to a few hours, depending on the requested export date range and your account's volume of learner activity. If you have concerns about a particular export that you're waiting for, contact the NovoEd Support Team (hello@novoed.com).</span>"; },
            },

            FAILURE: {
              MESSAGE: function(courseName: string) { return "There was an error exporting data for <b>" + courseName + "</b>."; },
            },

          },

          FROM_PAST_MONTHS: function(monthCount: number) { return "Export Data from Past " + plural(monthCount, 0, en, { one: "1 Month", other: number("en", monthCount, 0) + " Months" }); },
          FROM_PAST_DAYS: function(dayCount: number) { return "Export Data from Past " + plural(dayCount, 0, en, { one: "1 Day", other: number("en", dayCount, 0) + " Days" }); },
          CURRENT_CONTRACT_PERIOD: function() { return "Export Data for Current Contract Period"; },
          ALL_DATA_SINCE: function(date: string) { return "Export All Data since " + date + " (Org Creation Date)"; },
          ALL_DATA_SINCE_DEFAULT: function() { return "Export All Data since Org Creation Date"; },
          WITHIN_A_DATE_RANGE: function() { return "Export Data from the Date Range"; },
        },

        LICENSE_USAGE: function() { return "License Usage"; },
        FOR_CURRENT_CONTRACT_PERIOD: function(endDate: string, startDate: string) { return "For current contract period: " + startDate + " - " + endDate; },
        LICENSES_USED: function(count: number) { return plural(count, 0, en, { one: "License Used", other: "Licenses Used" }); },
        ENROLLMENT: function() { return "Enrollment"; },
        CURRENT_CONTRACT_PERIOD: function() { return "Current Contract Period"; },
        FROM_PAST_MONTHS: function(monthCount: number) { return "From Past " + plural(monthCount, 0, en, { one: "1 Month", other: number("en", monthCount, 0) + " Months" }); },
        FROM_PAST_DAYS: function(monthCount: number) { return "From Past " + plural(monthCount, 0, en, { one: "1 Day", other: number("en", monthCount, 0) + " Days" }); },
        FROM_TO: function(endDate: string, startDate: string) { return "From " + startDate + " to " + endDate; },
        EXPORT_FROM_PAST_MONTHS: function(monthCount: number) { return "Export Data from Past " + plural(monthCount, 0, en, { one: "1 Month", other: number("en", monthCount, 0) + " Months" }); },
        ALL_DATA_SINCE: function(date: string) { return "All Data Since " + date + " (Org Creation Date)"; },
        WITHIN_A_DATE_RANGE: function() { return "Within a Date Range"; },
        TOTAL: function() { return "Total"; },
        NEW: function() { return "New"; },
        HAS_LOGGED_IN: function(count: number) { return count + " " + plural(count, 0, en, { one: "has", other: "have" }) + " logged in"; },
        HAS_NOT_LOGGED_IN: function(count: number) { return count + " not logged in"; },
        TOTAL_ENROLLMENTS: function(count: number) { return plural(count, 0, en, { one: number("en", count, 0) + " Total Enrollment", other: number("en", count, 0) + " Total Enrollments" }); },
        NEW_ENROLLMENTS: function(count: number) { return plural(count, 0, en, { one: number("en", count, 0) + " New Enrollment", other: number("en", count, 0) + " New Enrollments" }); },
        TOP_ENROLLED: function() { return "Top Enrolled"; },
        LOGGED_IN: function() { return "Logged in"; },
        TOTAL_ENROLLED: function() { return "Total Enrolled"; },
        PCT_LOGGED_IN: function(count: number) { return count + "% logged in"; },
      },

    },

    ORG_MENTORS: {
      EMPTY_MENTOR_DASHBOARD: function(d) { return "No " + d.MenteesAlias + " Assigned Yet"; },
      EMPTY_ENROLLMENT_MODAL: function() { return "No Enrolled Courses Yet"; },
      CHANGE_ROLE_ALIAS: function() { return "Change Role Alias"; },
      ADD_MANAGERS: function(d) { return "Add " + d.MentorsTitleAlias; },
      MANUALLY_ADD_MENTORS: function() { return "Manually Add"; },
      BULK_UPLOAD_MENTORS: function() { return "Bulk Upload"; },
      MENTOR_LIST_DESC: function(d) { return "You can introduce a " + d.mentorAlias + " role who can watch learner's progress across learning experiences they are added to."; },
      ADD_MANAGER: function(d) { return "Add " + d.MentorTitleAlias; },
      MANUALLY_ADD_MANAGER_DESC: function(d) { return "Manually add a " + d.mentorAlias + ":"; },
      MANUALLY_ADD_SEARCH_LABEL: function() { return "Or search for users within the organization and add:"; },
      SEARCH_PLACEHOLDER: function() { return "Search by name, email, or external ID"; },
      NO_MENTOR_ADDED_YET: function(d) { return "No " + d.mentorsAlias + " added yet"; },
      REMOVE_MANAGER_TITLE: function(d) { return "Remove a " + d.MentorTitleAlias; },
      REMOVE_MANAGER_DESC: function(d) { return "Remove " + d.mentorAlias + "? You have selected to remove " + d.name + ". This action will prevent " + d.name + " from accessing the " + d.mentorAlias + " dashboard. This will also remove the relationships with assigned " + d.menteesAlias + " in the organization. Are you sure you want to proceed?"; },
      ADD_MENTOR_SUCCESS: function(d) { return "<b>" + d.name + "</b> has been added as a " + d.mentorAlias + "."; },
      CHANGE_ROLE_ALIAS_MODAL_DETAIL: function() { return "You can define how you would like to call the org level mentor and their mentees here."; },
      FOUND_USERS_WHILE_SEARCH: function() { return "We found the following users in your organization:"; },
      ADD_MENTEE: function(d) { return "Add " + d.MenteeAlias; },
      VIEW_MENTEE: function(d) { return "View " + d.MenteeAlias; },
      MANUALLY_ADD_MENTEE: function() { return "Manually add a learner:"; },
      ADD_MENTEE_SUCCESS: function(d) { return "<b>" + d.name + "</b> has been added as a " + d.menteeAlias + "."; },
      ADD_MENTEE_ALREADY_EXISTS: function(d) { return "<b>" + d.name + "</b> is already added as a " + d.menteeAlias + "."; },
      PROGRESS: function() { return "Progress"; },
      REMOVE_MENTEE_TITLE: function(d) { return "Remove a " + d.MenteeTitleAlias; },
      REMOVE_MENTEE_DESC: function(menteeName: string, mentorName: string) { return "Are you sure? By removing, " + menteeName + " will no longer be assigned to " + mentorName + ". Are you sure you want to proceed?"; },
      ALL_LOADED: function() { return "All Loaded"; },
      USER_IS_ALREADY_IN_ORGANIZATION: function(d) { return "User is already added as a " + d.mentorAlias + ". Find them in this list to make changes."; },
      POPOVER_MORE_ITEMS: function(remainingCount: number) { return "And " + remainingCount + " More"; },
      CLICK_TO_VISIT_COURSE: function() { return "Click to Visit Course"; },
      CLICK_TO_VISIT_JOURNEY: function() { return "Click to Visit Journey"; },
      CLICK_TO_VISIT_PROGRAM: function() { return "Click to Visit Program"; },
      FILTER: {
        TITLE: {
          TOTAL_MENTEES: function(d) { return "Total " + d.MenteesAlias; },
          NEVER_LOGGED_IN: function() { return "Never Logged in"; },
          MISSED_DEADLINE: function() { return "With Missed Deadline"; },
          NOT_ACTIVE: function() { return "Not Active"; },
          RECENTLY_COMPLETED: function() { return "Recently Completed"; },
        },

        DESCRIPTION: {
          NEVER_LOGGED_IN: function() { return "Enrolled but never active"; },
          MISSED_DEADLINE: function() { return "in the last 30 days"; },
          NOT_ACTIVE: function() { return "for more than 7 days"; },
          RECENTLY_COMPLETED: function() { return "in the past 30 days"; },
        },

        NOTE_POPOVER_TEXT: {
          NEVER_LOGGED_IN: function() { return "Never Logged In:"; },
          MISSED_DEADLINE: function(count: number) { return "Missed " + count + " " + plural(count, 0, en, { one: " Deadline ", other: " Deadlines " }); },
          NOT_ACTIVE: function() { return "Inactive for more than 7 days in the following:"; },
          RECENTLY_COMPLETED: function() { return "Recently Completed:"; },
        },

        FLAG_NAME: {
          NEVER_LOGGED_IN: function() { return "Never Active"; },
          MISSED_DEADLINE: function(count: number) { return "Missed " + count + " " + plural(count, 0, en, { one: " Deadline ", other: " Deadlines " }); },
          NOT_ACTIVE: function() { return "Inactive for more than 7 days"; },
          RECENTLY_COMPLETED: function() { return "Recently Completed"; },
        },

        TOOLTIP_TEXT: {
          TOTAL_MENTEES: function() { return "Total Mentees"; },
          NEVER_LOGGED_IN: function() { return "Enrolled but never active"; },
          MISSED_DEADLINE: function() { return "With missed deadline in the last 30 days"; },
          NOT_ACTIVE: function() { return "Not active for more than 7 days"; },
          RECENTLY_COMPLETED: function() { return "Recently completed in the last 30 days"; },
        },

      },

      BULK_UPLOAD_MODAL: {
        HEADER: function(d) { return "Bulk Upload " + d.MentorsTitleAlias + " and " + d.MenteesTitleAlias; },
        DESCRIPTION: function(d) { return "You can upload a CSV to bulk add " + d.MentorAlias + " and their " + d.MenteeAlias + ". Download a template of the CSV to see the format. Please note that the header row is required in your CSV and External ID column should ONLY be used if using SSO with external ID configured."; },
        INVALID_EMAIL: function() { return "Invalid Email address"; },
        DOWNLOAD_TEMPLATE: function() { return "Download a Template"; },
        UPLOAD_CSV: function() { return "Upload CSV"; },
        PROCEED_WITH_THE_REST: function() { return "Proceed with the Rest"; },
        WARNING_HEADER: function() { return "Users are being assigned."; },
        WARNING_MESSAGE: function() { return "You will be notified via email when the operation is complete."; },
        ERROR_DESCRIPTION: function(errorCount: number) { return plural(errorCount, 0, en, { one: "An error is", other: "Some errors" }) + " found in your CSV:"; },
        SUCCESS_ALERT: {
          ONLY_SKIP: function(d) { return d.existingMenteeCount + " " + plural(d.existingMenteeCount, 0, en, { one: d.menteeAlias + " was", other: d.menteesAlias + " were" }) + " skipped as they were already assigned to the same " + d.mentorAlias + "."; },
          ONLY_ADDED: function(d) { return d.newMentorsCount + " " + plural(d.newMentorsCount, 0, en, { one: "user", other: "users" }) + " have been assigned " + d.mentorAlias + " role and " + d.menteesAlias + "."; },
          ONLY_EXISTING: function(d) { return d.existingMentorsCount + " " + plural(d.existingMentorsCount, 0, en, { one: "user", other: "users" }) + " have new " + d.menteesAlias + " added."; },
          ADDED_WITH_EXISTING_AND_SKIP: function(d) { return d.newMentorsCount + " " + plural(d.newMentorsCount, 0, en, { one: "user", other: "users" }) + " have been assigned " + d.mentorAlias + " role and " + d.menteesAlias + ", " + d.existingMentorsCount + " " + plural(d.existingMentorsCount, 0, en, { one: "user", other: "users" }) + " have new " + d.menteesAlias + " added, " + d.existingMenteeCount + " " + plural(d.existingMenteeCount, 0, en, { one: d.menteeAlias + " was", other: d.menteesAlias + " were" }) + " skipped as they were already assigned to the same " + d.mentorAlias + "."; },
          ADDED_WITH_EXISTING: function(d) { return d.newMentorsCount + " " + plural(d.newMentorsCount, 0, en, { one: "user", other: "users" }) + " have been assigned " + d.mentorAlias + " role and " + d.menteesAlias + ", " + d.existingMentorsCount + " " + plural(d.existingMentorsCount, 0, en, { one: "user", other: "users" }) + " have new " + d.menteesAlias + " added."; },
          ADDED_WITH_SKIP: function(d) { return d.newMentorsCount + " " + plural(d.newMentorsCount, 0, en, { one: "user", other: "users" }) + " have been assigned " + d.mentorAlias + " role and " + d.menteesAlias + ", " + d.existingMenteeCount + " " + plural(d.existingMenteeCount, 0, en, { one: d.menteeAlias + " was", other: d.menteesAlias + " were" }) + " skipped as they were already assigned to the same " + d.mentorAlias + "."; },
          EXISTING_WITH_SKIP: function(d) { return d.existingMentorsCount + " " + plural(d.existingMentorsCount, 0, en, { one: "user", other: "users" }) + " have new " + d.menteesAlias + " added, " + d.existingMenteeCount + " " + plural(d.existingMenteeCount, 0, en, { one: d.menteeAlias + " was", other: d.menteesAlias + " were" }) + " skipped as they were already assigned to the same " + d.mentorAlias + "."; },
          DEFAULT: function() { return "Successfully Updated"; },
        },

      },

    },

    ROLES: {
      ALL_USERS: {
        TITLE: function() { return "All Users"; },
        BULK_UPLOAD: function() { return "Bulk Upload Learner Profile data"; },
        CONFIGURE_ORG_PROFILE: function() { return "Configure Org Profile"; },
        BULK_UPLOAD_MODAL: {
          HEADER: function() { return "Bulk Upload Org Profile Data"; },
          DESCRIPTION_1: function() { return "You can upload a CSV to update profile data for users in your organization. You also have the option to add any new users who are currently not in this organization and send them an email. Download a template to see the format of the CSV. The header row, first name, last name, and email columns are required in the CSV and should include columns for profile fields that need updating."; },
          DESCRIPTION_2: function() { return "<b>Please Note:</b> First and last name for existing users will not be updated as editing is disabled in the SSO settings."; },
          REMOVE_BLANK_CELL: function() { return "Remove profile value if cell in CSV is blank"; },
          ADD_NEW_USER: function() { return "Automatically Add New Users who are not part of the Organization"; },
          SEND_WELCOME_EMAIL: function() { return "Send the Welcome Email after new users are added"; },
          NOT_SEND_WELCOME_EMAIL: function() { return "Do Not Send the Welcome Email after new users are added"; },
          COLUMN_NAME: function(columnNumber: string) { return "Column Name " + columnNumber; },
          ERROR: {
            EMPTY_OR_INVALID_FILE: function() { return "Invalid file / Empty file"; },
            REQUIRED_COLUMNS_MISSING: function() { return "Required columns are missing (First Name, Last Name and Email columns are required)"; },
            INVALID_COLUMN: function() { return "Invalid columns found in your CSV"; },
            DUPLICATE_COLUMNS: function() { return "Duplicate/repeated columns found in your CSV"; },
            VALIDATION_WITHOUT_DATA: function() { return "The following errors were encountered while processing the provided .csv"; },
            VALIDATION_WITH_DATA: function() { return "Some errors found in your CSV:"; },
            EMPTY_SSO: function() { return "CSV has SSO integrated columns that cannot be updated"; },
            EMPTY_EMAIL: function() { return "No valid emails were found"; },
            NOT_FOUND_USERS: function(userCount: number) { return userCount + " " + plural(userCount, 0, en, { one: "User", other: "Users" }) + " can not be added:"; },
            EXCEEDS_LENGTH: function() { return "Value exceeds max length"; },
            INVALID_PROFILE_SETTING: function() { return "Invalid Profile Setting"; },
            INVALID_OPTION: function() { return "Invalid Option in CSV"; },
            EMPTY_CELL: function() { return "Empty Cell in CSV"; },
            TRANSIENT_ERROR: function() { return "Transient Error"; },
            NOT_FOUND: function() { return "User not found in the organization"; },
            INVALID_PHOTO_URL: function() { return "Unsupported image file in CSV"; },
          },

          DESCRIPTION: {
            INVALID_FILE: function() { return "Please check your CSV file or download a template to see the correct format for uploading."; },
            EMPTY_EMAIL: function() { return "Can't find users to upload from your CSV. Please check your CSV file or download a template to see the correct format for uploading."; },
            NOT_FOUND_USERS: function() { return "If you would like to add new users, please make sure to check the option to \"Automatically Add New Users from the CSV\" before uploading your CSV"; },
          },

          THRESHOLD_ALERT: {
            HEADER: function() { return "Profile data upload is in progress."; },
            MESSAGE: function() { return "You will receive an email when it is complete."; },
          },

          SUCCESS_ALERT: {
            ADDED_WITH_EXIST: function(addedCount: number, existingCount: number) { return existingCount + " " + plural(existingCount, 0, en, { one: "user", other: "users" }) + " have their Information updated successfully, " + addedCount + " new " + plural(addedCount, 0, en, { one: "user", other: "users" }) + " were added."; },
            ONLY_ADDED: function(addedCount: number) { return addedCount + " new " + plural(addedCount, 0, en, { one: "user", other: "users" }) + " who were added newly to the institution."; },
            ONLY_EXIST: function(existingCount: number) { return existingCount + " " + plural(existingCount, 0, en, { one: "user", other: "users" }) + " have their Information updated successfully."; },
          },

        },

        REMOVE_USER: function() { return "Remove From My Organization"; },
        REMOVE_USER_WARNING: function(name: string) { return "You have selected to remove " + name + " from this organization. Are you sure you want to proceed?"; },
      },

      USER_MANAGEMENT: function() { return "User Management"; },
      ADD_ADMIN: function() { return "Add Organization Admin"; },
      ADD: function() { return "Add"; },
      ADDING: function() { return "Adding..."; },
      NAME: function() { return "Name"; },
      EMAIL: function() { return "Email"; },
      EXTERNAL_ID: function() { return "External ID"; },
      ENROLLMENT: function() { return "Enrollment"; },
      ENROLLED_COURSE: function(enrollmentCount: number) { return enrollmentCount + " " + plural(enrollmentCount, 0, en, { one: "Offering", other: "Offerings" }); },
      ORG_ROLE: function() { return "Org Level Role"; },
      ACTIONS: function() { return "Actions"; },
      IS_ADMIN_ERROR: function(email: string) { return email + " is a NovoEd admin. They cannot be added as an org admin here."; },
      ORG_ADMINS: function() { return "Org Admins"; },
      ORG_MENTORS: function(d) { return d.MentorsTitleAlias; },
      MANAGE_COURSE_ROLES: function() { return "Course Roles"; },
      MANAGE_COURSE_ROLES_DESC: function() { return "Add course roles here with different settings of permissions. You can add as many roles as you want and customize the name to best describe the responsibilities. "; },
      UNIQUE_ROLE_NAME: function() { return "Role names must be unique and a role with this name already exists."; },
      MENTEE_DESC: function() { return "Learners can be assigned to be advised by a user with \"Advisor\" role. Please give them a name, e.g. Learner for user assigned to a advisor"; },
      NEW_ORG_ADMIN: function() { return "Add Org Admins"; },
      COURSE_ROLE: function(d) { return d.CourseAlias + " Role"; },
      LAST_ACTIVE: function() { return "Last Active"; },
      TEXT_ON_BADGE: function() { return "Initials For Badge"; },
      PERMISSIONS: function() { return "Permissions"; },
      NO_PERMISSIONS: function() { return "No Permissions"; },
      CONFIGURATION_AND_REGISTRATION: function() { return "Configuration and Registration"; },
      INSTRUCTOR_FACILITATOR: function() { return "Instructor/Facilitator"; },
      TA_FACILITATOR: function() { return "TA/Facilitator"; },
      COURSE_BUILDER: function() { return "Course Builder"; },
      REPORT_ADMIN: function() { return "Report Admin"; },
      MENTOR: function() { return "Advisor"; },
      MENTORS: function() { return "Advisors"; },
      MENTOR_PLACEHOLDER: function() { return "Advisor"; },
      MENTEE_PLACEHOLDER: function() { return "Learner"; },
      LEARNER_REGISTRATION: function(d) { return d.LearnerAlias + " Registration"; },
      LEARNER_ROLE_DESC: function() { return "This is a role with no special admin permissions."; },
      CONFIGURATION_AND_REGISTRATION_DESC: function(d) { return "Has permission to modify various configuration options on a " + d.courseAlias + " and register " + d.learnerAlias + "."; },
      INSTRUCTOR_FACILITATOR_DESC: function(d) { return "Has permissions for capabilities required to run a " + d.courseAlias + " but not to modify content or configurations."; },
      TA_FACILITATOR_DESC: function(d) { return "Limited subset of Instructor to view and give feedback on " + d.assignmentsAlias + " and moderate discussions."; },
      COURSE_BUILDER_DESC: function(d) { return "Editing content and other settings tied to creating a " + d.courseAlias + " (e.g. branding, completion criteria)."; },
      REPORT_ADMIN_DESC: function() { return "Ability to access analytics and downloads."; },
      MENTOR_DESC: function(isJourney: string) { return "Users with this permission can monitor learner progress, give feedback on their assignments, approve assignment submission, or provide general advising for the learner." + select(isJourney, { true: "<br/>The advisor role will apply to all the courses inside this journey.", other: "" }); },
      LEARNER_REGISTRATION_DESC: function(d) { return "Limited permission to manage " + d.learnerAlias + " enrollments to a " + d.courseAlias; },
      NEW_COURSE_ROLE: function() { return "Add Course Roles"; },
      NO_COURSE_ADDED_YET: function() { return "No course roles added yet"; },
      COURSE_ROLE_NAME: function() { return "Course Role Name"; },
      BADGE: function() { return "Badge"; },
      VIEW_DETAILS: function() { return "View Details"; },
      SELECTED_COUNT: function(count: number) { return count + " Selected"; },
      COURSE_ROLE_ASSIGNED: function(courseRole: string) { return "Course role '" + courseRole + "' has been assigned to users in courses."; },
      REMOVE_ROLE_WARNING: function() { return "Removing this course role will affect permissions for those users in courses. Are you sure you want to proceed?"; },
      REMOVE_MENTOR_PERMISSION: function() { return "Removing this permission will delete the user's Mentor capabilities and remove assigned learners. Are you sure you want to proceed?"; },
      REMOVE_ROLE_MENTOR: function(courseRole: string) { return "Removing this course role will delete user's " + courseRole + " status, delete their learner relationships and affect their permissions in courses. Are you sure you want to proceed?"; },
      ORG_ADMIN_ROLES: {
        ORG_ADMIN: function() { return "Org Admin"; },
        COURSE_MANAGER: function() { return "Course Manager"; },
      },

      EDIT_ORG_ADMIN_ROLE: function() { return "Edit Role"; },
      REMOVE_ORG_ADMIN_WARNING: {
        TITLE: function(name: string) { return "Remove " + name + "?"; },
        TEXT: function(name: string, role: string) { return "You have selected to remove " + name + " as " + role + ". They will no longer have access to the Org Admin dashboard. Are you sure you want to proceed?"; },
      },

    },

    ADMIN_CONTROLS: {
      TITLE: function() { return "Admin Controls"; },
      COURSES: function() { return "Courses"; },
      LEARNING_JOURNEYS: function() { return "Learning Journeys"; },
      CONTENT_LIBRARY: function() { return "Lesson Library"; },
      LEARNING_ANALYTICS: function() { return "Learning Analytics"; },
      LICENSE_AND_ENROLLMENT: function() { return "License and Enrollment"; },
      LICENSE_ANALYTICS: function() { return "License Dashboard"; },
      USER_ENROLLMENT_DATA_DOWNLOADS: function() { return "User and Enrollment Data Downloads"; },
      SKILL_TAGS: function() { return "Skill Tags"; },
      USER_MANAGEMENT: function() { return "User Management"; },
      MANAGING_ROLES: function() { return "User Management"; },
      EMAIL_PREFERENCES: function() { return "Email Preferences"; },
      DISCOUNT_CODES: function() { return "Discount Codes"; },
      MARKETING_TRACKERS: function() { return "Marketing Trackers"; },
      EMAIL_TEMPLATE: function() { return "Email Template"; },
      ADVANCED_SETTINGS: function() { return "Advanced Settings"; },
    },

    DASHBOARD: {
      LICENSE_DASHBOARD: {
        HEADER: function() { return "License Dashboard"; },
        LICENSE_PERIOD: function() { return "License Period"; },
        LICENSE_PURCHASED: function() { return "# of License Purchased"; },
        ACTIVE_USERS_MONTH_PURCHASED: function() { return "# of Active Users Months Purchased"; },
        COURSES_PURCHASED: function() { return "# of Courses Purchased"; },
        GRACE_PERIOD: function() { return "Unenrollment Grace Period"; },
        NOTES: function() { return "Notes"; },
      },

      ADMIN_DASHBOARD: function() { return "Admin Dashboard"; },
      LEARNER_DASHBOARD: function() { return "Learner Dashboard"; },
      LOADING_COURSES: function() { return "Loading: Courses"; },
      FIRST_TIME_BRANDING_DESCRIPTION: function() { return "Edit your organization's brand color, logo, and name here."; },
      NO_COURSE_YET: function() { return "No Courses Yet"; },
      NO_MY_VIEW_FILTERS_YET: function() { return "Use the Filters FILTER_ICON and/or Search SEARCH_ICON to save a custom view with your courses"; },
      CREATE_NEW_COURSE: function() { return "Create a New Course"; },
      NO_RESULTS_FOUND: function() { return "No Results Found"; },
      NO_MY_VIEW_RESULTS_FOUND: function() { return "No courses match the My View Filter and/or Search criteria"; },
      MY_VIEW_TOOLTIP_TITLE: function() { return "Filtered based on:"; },
      COURSE_STARTED: function() { return "Started"; },
      COURSE_STARTING: function() { return "Starting"; },
      DOWNLOAD_AICC: function() { return "Download AICC Archive"; },
      DOWNLOAD_AICC_DISABLED_TOOLTIP: function(isPrimary: string) { return "AICC Archive is not available for " + select(isPrimary, { true: "primary", other: "demo" }) + " courses."; },
      DELETE: function() { return "Delete"; },
      DELETION: {
        WARNING: function(type: string) { return "You are about to delete a " + select(type, { journey: "journey", course: "course", other: "program" }) + ". This operation is not reversible."; },
        CANNOT_DELETE_HEADER: function() { return "Oops!"; },
        CANNOT_DELETE_MESSAGE: function() { return "This offering cannot be deleted as it has videos that are being used by other courses. Disable video sharing to delete this offering."; },
        ARE_YOU_SURE: function() { return "Are you sure?"; },
        YES_SURE: function() { return "Yes, I am sure."; },
      },

      PRIMARY_DELETION: {
        TITLE: function() { return "Delete Primary Course"; },
        DESCRIPTION: function(catalogId: string, cohortsCount: number, courseName: string) { return courseName + " (" + catalogId + ") has " + cohortsCount + " " + plural(cohortsCount, 0, en, { one: "cohort", other: "cohorts" }) + ". On deleting the primary, " + plural(cohortsCount, 0, en, { one: "it", other: "they" }) + " will no longer be marked as " + plural(cohortsCount, 0, en, { one: "cohort", other: "cohorts" }) + ". Are you sure you want to delete this Primary Course?"; },
      },

      CONFIGURATIONS: function() { return "Configurations"; },
    },

    EMAIL_TEMPLATE: {
      HEADER: function() { return "Email Template"; },
      CUSTOMIZE: function() { return "Customize"; },
      PREVIEW: function() { return "Preview with Sample Text"; },
      PREVIEW_HEADER: function() { return "Preview"; },
      EMAIL_HEADER: function() { return "Email Header"; },
      EMAIL_HEADER_STYLE: function() { return "Style for email header (No nesting allowed)"; },
      PREVIEW_TEXT: function() { return "Hello Learner,<br /><br />Thank you for signing up for this course. Please stay tuned for more information from your teaching team upon the start of this course.<br /><br /><br />Cheers,<br /><br />Your Teaching Team"; },
    },

    ANALYTICS_DASHBOARD: {
      HEADER: function() { return "Learning Analytics"; },
    },

    COURSE_ANALYTICS: {
      HEADER: function() { return "Course Analytics"; },
    },

    COHORT_ANALYTICS: {
      HEADER: function() { return "Cohort Analytics"; },
    },

    SKILL_TAGS: {
      HEADER: function() { return "Skill Tags"; },
      DESCRIPTION: function() { return "Define and manage a set of tags for skills at the organization level, then assign them to the activities inside a course, so your activities can be designed to target certain skills."; },
      ADD_SKILL: function() { return "Add Skill Tags"; },
      PLACEHOLDER: function() { return "New Tag"; },
      ALREADY_EXISTS_ERROR: function() { return "This tag already exists"; },
      DELETE: function() { return "Delete"; },
      DELETE_TITLE: function() { return "Are You Sure?"; },
      DELETE_CONFIRMATION: {
        INSTITUTION: function() { return "Deleting a skill will remove the skill from any tagged courses or activities. Any feedback given to learners for this skill will also be deleted. Are you sure you want to delete this skill?"; },
        COURSE: function() { return "Deleting this skill will delete any feedback given for this skill. Are you sure you want to delete this skill?"; },
      },

      CONFIRMATION: function(tag: string) { return "\"" + tag + "\" Successfully Saved"; },
      SKILL_NAME: function() { return "Skill Name"; },
      ACTIVITIES_TAGGED: function() { return "Activities Tagged"; },
      COURSES_TAGGED: function() { return "Courses Tagged"; },
      OPTIONS: function() { return "Options"; },
      FULL_LIST: function() { return "Full list of Skills"; },
      VIEW_FULL_LIST: function() { return "View full list of skills"; },
      MODAL_DESCRIPTION: function() { return "Skill tags are managed at the orgnization level, you can assign them to the activities inside a course, so your activities can be designed to target certain skills."; },
      RELATED_SKILLS: function() { return "Related Skills"; },
      COPY_CLIPBOARD: function() { return "Copy to clipboard"; },
      COPIED: function() { return "Copied!"; },
      ADD_SKILL_BUTTON: function() { return "Add Skill"; },
      SUGGESTIONS: function() { return "Suggestions"; },
      NO_MATCHES: function() { return "0 Matches found"; },
      NO_PERMISSIONS: function() { return "You do not have the permission to modify the practice scenario."; },
      COURSE_PROMPT: function() { return "Select Skill Tags"; },
      COURSE_NO_TAGS: function() { return "No tags defined for your organization"; },
      ACTIVITY_DUPLICATED: function() { return "Note: This practice scenario is included in multiple courses. If the skills associated with this scenario are modified, the changes will be reflected in all courses featuring the scenario."; },
      PLACEHOLDER_SKILL: function() { return "Skill"; },
      BULK_UPLOAD_MODAL: {
        TITLE: function() { return "Bulk Upload Skills"; },
        STEP_ONE: function() { return "Step 1"; },
        STEP_TWO: function() { return "Step 2"; },
        DOWNLOAD_DESCRIPTION: function() { return "Download your current list of skills below. To add new skills, please add a new row with all fields completed. To update existing skills, modify only the skill name. To delete skills, set the 'delete' value to True."; },
        PLEASE_SELECT_CSV: function() { return "Please select the CSV file to upload:"; },
        DOWNLOAD: function() { return "Download"; },
        UPLOAD_CSV: function() { return "Upload CSV"; },
        FOUND_IN_CSV: function() { return "We found the following in the CSV"; },
        NO_CHANGES_IN_CSV: function() { return "No changes were found in your CSV."; },
        NEW_SKILLS_FOUND: function() { return "New Skills Found"; },
        NUM_NEW_SKILLS: function(skillsCount: number) { return "<b>" + skillsCount + "</b> New " + plural(skillsCount, 0, en, { one: "Skill", other: "Skills" }) + ". Review in the next page."; },
        SKILLS_TO_UPDATE: function() { return "Skills to Update"; },
        NUM_SKILLS_UPDATED: function(skillsCount: number) { return "<b>" + skillsCount + "</b> " + plural(skillsCount, 0, en, { one: "Skill", other: "Skills" }) + " will be updated. Review in the next page."; },
        SKILLS_TO_DELETE: function() { return "Skills to Delete"; },
        NUM_SKILLS_DELETED: function(skillsCount: number) { return "<b>" + skillsCount + "</b> " + plural(skillsCount, 0, en, { one: "Skill", other: "Skills" }) + " will be deleted."; },
        DELETE_MESSAGE: function() { return "Deleting a skill will remove the skill from any tagged courses or activities. Any feedback given to learners for this skill will also be deleted."; },
        SKILLS_WITH_ERRORS: function() { return "Skills with errors"; },
        ERROR_MESSAGE: function() { return "You can proceed but these skills won't be added."; },
        ROW: function() { return "Row"; },
        UPLOAD_NEW_CSV: function() { return "Upload New CSV"; },
        CONFIRM: function() { return "Confirm"; },
        DELETE_CONFIRMATION_TITLE: function() { return "Are you sure you want to delete skills?"; },
        DELETE_CONFIRMATION_DESCRIPTION: function() { return "Deleting a skill will remove the skill from any tagged courses or activities. Any feedback given to learners for this skill will also be deleted. Are you sure you want to proceed?"; },
        SKILLS_TO_BE_DELETED: function() { return "Skills to be Deleted:"; },
        PROCESSING_UPLOADED_CSV_FILE: function() { return "Processing uploaded CSV file"; },
        WE_WILL_SEND_EMAIL: function() { return "We will send an email when it is done."; },
        AN_ERROR_OCCURRED_IN_THE_PROCESS: function() { return "An error occurred in the process"; },
        THE_DETAILS_HAVE_BEEN_SENT_VIA_EMAIL: function() { return "the details have been sent via email."; },
      },

      SKILL_VIEW_FOR_LEARNERS: {
        PRACTICING: function(count: number) { return "Practicing " + plural(count, 0, en, { one: "1 Skill", other: number("en", count, 0) + " Skills" }); },
        VIEW_ALL: function() { return "View All Skills Related"; },
        SKILLS_RELATED: function() { return "Skills Related"; },
        SKILLS_AND_METADATA: function() { return "Skills and Metadata"; },
        GOOD_JOB: function() { return "Good Job!"; },
        PRACTICED_SKILLS: function(count: number) { return "You Practiced " + plural(count, 0, en, { one: "1 Skill", other: number("en", count, 0) + " Skills" }); },
        VIEW_SKILLS_IN_FLYER: function() { return "View all skills in Flyer Page"; },
      },

    },

    CONTENT_LIBRARY: {
      COLLECTION_NAME: {
        DOWNCASED_SINGULARIZED: function() { return "collection"; },
      },

      HEADER: function() { return "Lesson Library"; },
      ALL_COLLECTIONS: function() { return "All Collections"; },
      NEW_COLLECTION: function() { return "New Collection"; },
      NO_COLLECTION_YET: function() { return "No Collections yet"; },
      NEW_COLLECTION_FORM: {
        TITLE: function() { return "New Collection"; },
        TITLE_ARIA_LABEL: function() { return "Title for the new collection"; },
        UNTITLED_COLLECTION: function() { return "Untitled collection"; },
        ADD_DESCRIPTION: function() { return "Add Description (Maximum 255 characters)"; },
        SUCCESS_ALERT: function() { return "Collection Created Successfully"; },
        EDIT_SUCCESS_ALERT: function() { return "Collection Edited Successfully"; },
      },

      EDIT_COLLECTION_FORM: {
        TITLE: function() { return "Edit Collection"; },
      },

      DELETE_COLLECTION: {
        TITLE: function(lessonPagesCount: number) { return "You are deleting a collection with " + lessonPagesCount + " lesson " + plural(lessonPagesCount, 0, en, { one: "page", other: "pages" }) + "."; },
        BODY_TEXT: function() { return "This cannot be undone."; },
        SUCCESS_ALERT: function() { return "Collection Deleted Successfully"; },
      },

      COLLECTIONS_TABLE: {
        NAME: function() { return "Name"; },
        CREATOR: function() { return "Created By"; },
        CREATED_TIME: function() { return "Created Time"; },
        LAST_EDITOR: function() { return "Last Edited By"; },
        LAST_EDITED: function() { return "Last Edited"; },
        ROLE: function() { return "Your Role"; },
      },

      COLLECTION_ACTION: {
        EDIT: function() { return "Edit Name and Description"; },
        USER_MANAGEMENT: function() { return "User Management"; },
        DELETE: function() { return "Delete Collection"; },
        DELETE_TOOLTIP: function() { return "Unlink all the lessons in this collection to enable delete option."; },
      },

      COLLECTIONS_HOME: {
        DRAG_AND_DROP: function() { return "Drag and Drop to Reorder"; },
        NO_FOLDERS: function() { return "No Folders Yet"; },
        NEW_FOLDER_BUTTON: function() { return "New Folder"; },
        NO_LESSONS: function() { return "No Lessons Yet"; },
        ADD_LESSON: function() { return "Add Lesson"; },
        COPY_LESSON_HEADER: function() { return "Pick a Collection to Copy the Lesson"; },
        MOVE_LESSON_HEADER: function() { return "Pick a Collection to Move the Lesson"; },
        COPY_LESSON_DESCRIPTION: function() { return "Select a folder in a collection to copy the lesson."; },
        MOVE_LESSON_DESCRIPTION: function() { return "Select a folder in a collection to move the lesson."; },
        COPY_FOLDER_HEADER: function() { return "Pick a Collection to Copy the Folder"; },
        MOVE_FOLDER_HEADER: function() { return "Pick a Collection to Move the Folder"; },
        COPY_FOLDER_DESCRIPTION: function() { return "Select a collection to copy the folder."; },
        MOVE_FOLDER_DESCRIPTION: function() { return "Select a collection to move the folder."; },
        DELETE_FOLDER: function() { return "Delete Folder"; },
        DUPLICATE_FOLDER: function() { return "Duplicate"; },
        COPY_FOLDER: function() { return "Copy to..."; },
        MOVE_FOLDER: function() { return "Move to..."; },
        GO_TO_COLLECTION: function() { return "Go to Collection"; },
        COPY_LESSON_SUCCESS_MSG: function(lessonTitle: string) { return "<b>Success! " + lessonTitle + "</b> has been copied."; },
        MOVE_LESSON_SUCCESS_MSG: function(lessonTitle: string) { return "<b>Success! " + lessonTitle + "</b> has been moved."; },
        FOLDER_CREATED_AND_COPIED_LESSON: function() { return "A new folder is created successfully and the lesson has been copied."; },
        FOLDER_CREATED_AND_MOVED_LESSON: function() { return "A new folder is created successfully and the lesson has been moved."; },
        COPY_FOLDER_SUCCESS_MSG: function(folderTitle: string) { return "<b>Success! " + folderTitle + "</b> has been copied."; },
        MOVE_FOLDER_SUCCESS_MSG: function(folderTitle: string) { return "<b>Success! " + folderTitle + "</b> has been moved."; },
        DUPLICATE_SUCCESS_MSG: function(title: string) { return "<b>Success! " + title + "</b> has been duplicated."; },
        COPY_FOLDER_STARTED: function(collection: string, folderTitle: string) { return "Copying <b>" + folderTitle + "</b> to <b>" + collection + "</b> will take a few minutes. Please wait."; },
        COPY_LESSON_STARTED: function(collection: string, lessonTitle: string) { return "Copying <b>" + lessonTitle + "</b> to <b>" + collection + "</b> will take a few minutes. Please wait."; },
        DUPLICATE_STARTED: function(title: string) { return "Duplicating <b>" + title + "</b> will take a few minutes. Please wait."; },
        GOT_IT: function() { return "Got it"; },
        SUBMISSION_CAROUSAL_LESSON_TRANSFER_INFO_HEADER: function() { return "The Submission Carousel Activity and its attached Assignment have been added into the Collection"; },
        SUBMISSION_CAROUSAL_LESSON_TRANSFER_INFO_DESCRIPTION: function() { return "Both lessons containing the activities have been added to the Collection. You can attach a different Assignment to the Submission Carousal inside the Collection, if you would like."; },
        SUBMISSION_CAROUSAL_FOLDER_TRANSFER_INFO_HEADER: function() { return "The Submission Carousel Activity and its attached Assignment have been moved into the Collection"; },
        SUBMISSION_CAROUSAL_FOLDER_TRANSFER_INFO_DESCRIPTION: function() { return "The folder contains an assignment or submission carousel with it's attached activity located outside of the folder you're moving. We'll include the lesson with the attached activity so you don't leave it out."; },
        DELETE_FOLDER_DISABLED_TOOLTIP: function() { return "Unlink all the lessons to delete this folder"; },
        LECTURE_LIST: {
          LESSONS: function() { return "Lessons"; },
          LINKS: function() { return "Linked Lessons"; },
          EDITOR: function() { return "Last Edited By"; },
          EDITED_ON: function() { return "Last Edited Time"; },
          STATUS: function() { return "Linked Lesson Status"; },
          STATUSES: {
            NO_LINKS: function() { return "No Links Yet"; },
            UP_TO_DATE: function() { return "Up to Date"; },
            PUSH_CHANGES: function() { return "Push Changes"; },
          },

          PUSH_CHANGES: {
            PUSHING: function() { return "Pushing Changes..."; },
            SUCCESS: function() { return "We will send you an email when it is done."; },
            CONFIRMATION: {
              TITLE: function() { return "Are you sure you want to push changes?"; },
              DESCRIPTION: function() { return "<b>Updates will be made to all Linked Lesson pages.</b> If there are Linked Lessons you do not want receiving these updates, make sure to unlink those before confirming your changes."; },
              CHECK_LINKED_LESSONS: function() { return "Check linked lessons >"; },
            },

          },

          LESSON_ACTION: {
            EDIT_LESSON: function() { return "Edit Lesson"; },
            COPY_TO: function() { return "Copy to..."; },
            MOVE_TO: function() { return "Move to..."; },
            DUPLICATE: function() { return "Duplicate"; },
            DELETE: function() { return "Delete"; },
            NEW_LESSON: function() { return "Create New Collection Lesson"; },
          },

          ADD_DESCRIPTION: function() { return "Add description"; },
          DESCRIPTION_TOOLTIP: function() { return "Click to edit optional description. Description will not display in courses when push."; },
          COPYING: function() { return "Copying in Progress..."; },
          VIEW_LINKED_LESSON: function() { return "View Linked Lessons"; },
          DISABLE_ROW_TOOLTIP: function(lessonTitle: string) { return lessonTitle + " is updating. Editing the lesson is temporarily disabled."; },
          CARD_IMAGE_TOOLTIP: function() { return "Click to select an image"; },
        },

      },

      LECTURE_PAGE: {
        BACK_TO_COLLECTION: function() { return "Back to Collection"; },
        LINKED_LESSONS: function() { return "Linked Lessons:"; },
        DONE_EDITING: function() { return "Done Editing"; },
        LINKS_UP_TO_DATE: function() { return "All links are up to date"; },
      },

      USER_MANAGEMENT: {
        TAB: function() { return "User Management"; },
        ROLE_DETAIL: {
          VIEWER: function() { return "Limited permission to view the lessons in the collection and use them in courses."; },
          COLLECTION_MANAGER: function() { return "Has permission to modify various configuration options on a collection and manage admin enrollments."; },
          COLLECTION_BUILDER: function() { return "Permission to edit content and other settings tied to creating lessons, and pushing changes to linked lessons."; },
          COLLECTION_ADMIN: function() { return "Permissions to add, edit, delete lesson pages and manage admin enrollments for the collection."; },
        },

        MANAGE_USERS: {
          BUTTON_TEXT: function() { return "Manage Users"; },
          MANUALLY_ADD: function() { return "Manually Add Users"; },
          BULK_ADD: function() { return "Bulk add by Uploading CSV"; },
          BULK_REMOVE: function() { return "Bulk Remove Users"; },
        },

        MANAGE_ACCESS_MODAL: {
          TITLE: function() { return "Manage Collection Access"; },
          DESCRIPTION: function() { return "If you would like to be added to the collection, join as a Collection Admin."; },
          DISABLED_ROLE_TOOLTIP: function() { return "As an Org Admin or Course Manager, you can only join the collection as a collection admin."; },
          JOIN_COLLECTION: function() { return "Join Collection"; },
          GOTO_USER_MANAGEMENT: function(userManagementLink: string) { return "If you would like to enroll course builders or other roles in the collection, please go to <a class=\"text-primary bold\" href=\"" + userManagementLink + "\" target=\"_self\">User Management</a>."; },
        },

        ADD_USER_MODAL: {
          HEADER: function() { return "Manually Add User to Collection"; },
          FOUND_USERS_WHILE_SEARCH: function() { return "We found the following users in your organization:"; },
          MANUALLY_ADD_SEARCH_LABEL: function() { return "Or search for users within the organization and add them to this collection:"; },
          SEARCH_PLACEHOLDER: function() { return "Search by name, email, or external ID"; },
          LABEL: function() { return "You can add a user manually:"; },
          VIEWER: function() { return "Viewer"; },
          COLLECTION_ADMIN: function() { return "Collection Admin"; },
          COLLECTION_MANAGER: function() { return "Collection Manager"; },
          COLLECTION_BUILDER: function() { return "Collection Builder"; },
          VIEWER_POPOVER: function() { return "Viewer can only view the lessons in collection and use them in courses"; },
          SUCCESS_ALERT: function(count: number) { return count + " " + plural(count, 0, en, { one: "user", other: "users" }) + " has been added to the collection"; },
        },

        ADD_USER_BULK_MODAL: {
          DESCRIPTION: function() { return "You can upload a CSV to add users to the collection and assign roles in bulk. Download a template of the CSV to see the format. Please note that the header row is required in your CSV and External ID column should ONLY be used if using SSO with external ID configured."; },
          SUCCESS_ALERT: function(count: number) { return count + " " + plural(count, 0, en, { one: "user", other: "users" }) + " has been added to the collection"; },
        },

        USER_TABLE: {
          NAME: function() { return "Name"; },
          EMAIL: function() { return "Email"; },
          ROLE: function() { return "Your Role"; },
          NO_USER_YET: function() { return "No User Yet"; },
          ROW_ACTIONS: {
            EDIT_NAME: function() { return "Edit Name"; },
            EDIT_ROLE: function() { return "Edit Collection Role"; },
            REMOVE: function() { return "Remove"; },
          },

          REMOVE_USER: {
            TITLE: function() { return "Remove user"; },
            DESCRIPTION: function(firstName: string, fullName: string) { return "You have selected to remove " + fullName + ". This action will prevent " + firstName + " from entering the collection. You can always re-register " + firstName + " on the collection's User Management page."; },
          },

        },

      },

      LINKED_COURSE_MODAL: {
        BELONGS_TO_COURSE: function() { return "Belongs to Course"; },
        CATALOGUE_ID: function() { return "Catalogue ID"; },
        VIEW_IN_COURSE: function() { return "View in Course"; },
        BODY_TEXT: function() { return "These are the courses that currently share a linked lesson page from this collection. Any updates done on the collection lesson will be reflected in these courses."; },
        HEADER: function() { return "Linked Lessons"; },
        VIEW_LESSON: function() { return "View Lesson"; },
      },

    },

    ADVANCED_SETTINGS: {
      HEADER: function() { return "Advanced Settings"; },
      BRANDING: function() { return "Branding"; },
      DATA_CONFIGURATION: function() { return "Data Configuration"; },
      PRIVACY_SECURITY: function() { return "Privacy and Security"; },
      INTEGRATIONS: function() { return "Integrations"; },
      AI_HUB: function() { return "AI Hub"; },
      CONFIGURE: function() { return "Configure"; },
      VIEW_IDP: function() { return "View IDP"; },
      BRANDED_HEADER: {
        TITLE: function() { return "Institution Branded Header Setup"; },
        DESCRIPTION: function() { return "You can set up the institution's name, add a logo, choose the size, and customize the background color. This will be visible in dashboards, courses, and course flyers. Note: In each course, these options can be changed and customized. If they have already been changed previously, they will not be modified."; },
        EDIT: function() { return "Edit in dashboard"; },
      },

      COLOR_PALETTE: {
        TITLE: function() { return "Color Palette"; },
        DESCRIPTION: function() { return "Create a cohesive and on-brand learning environment by setting your organization's branding colors. The colors you add will appear as the default color palette options for your Course Builders, allowing them to quickly incorporate approved colors in their courses."; },
        MODAL: {
          TITLE: function() { return "Color Palette"; },
          BODY_HEADER: function() { return "Color set displayed in color picker"; },
          DESCRIPTION: function() { return "Customize default color palette with your branding colors for color pickers using across the institution. This setting will display for Text, Background, and Icon color picker selections."; },
          DEFAULT_COLOR: function() { return "Default Color"; },
          HIGHLIGHT_COLOR: function() { return "Highlight Color"; },
          CLICK_TO_EDIT: function() { return "Click to edit"; },
          ARIA_LABEL: {
            RECENTLY_USED_COLOR: function(color: string) { return "Click to select recently usecolor " + color; },
          },

        },

      },

      FAVICON_TITLE: function() { return "Favicon"; },
      FAVICON_DESCRIPTION: function() { return "You can set up a favicon to represent your organization which will appear on all course pages. If no favicon is provided, we will show the NovoEd favicon. Please choose a 16x16 or 32x32 image that uses either 8-bit or 16-bit colors. Accepted file types include png, gif, or ico."; },
      SSO_TITLE: function() { return "Single Sign-On Configuration"; },
      SSO_DESCRIPTION: function() { return "You may view your Identity Provider (IDP) and other Single Sign-On (SSO) details here. If multiple IdPs are set up, users will be redirected to the appropriate source based on their email domain."; },
      SSO_THROUGH_EXTERNAL_ID_SWITCH_LABEL: function() { return "Allow SSO logins if SSO provides an external ID and not an email address."; },
      SSO_THROUGH_EXTERNAL_ID_NOTE: function() { return "<b>Note: </b>NovoEd will create a placeholder email address for users in the platform. Users with placeholder email addresses will be prompted to update their email address in Account Settings so they can receive course communications."; },
      SSO_NOT_NOVOED_ADMIN_TOOLTIP: function() { return "NovoEd Admin Only, please contact your CSM to make changes"; },
      SSO_MULTIPLE_IDP_TOOLTIP: function() { return "Cannot be enabled for organizations with multiple IDPs"; },
      SSO_MODAL: {
        TITLE: function() { return "Configure Single Sign-On"; },
        DESCRIPTION: function() { return "The Name and Descriptions provided below will help the user select the correct IDP."; },
        ENTITY_ID: function() { return "Entity ID"; },
        IDP_MANAGEMENT_URL: function() { return "(Optional) URL to manage account information and password for this IDP"; },
        NAME: function() { return "Name"; },
        DESCRIPTION_LABEL: function() { return "Description"; },
        DESCRIPTION_PLACEHOLDER: function() { return "Add a description"; },
        IDP_SSO_TARGET_URL: function() { return "Service Sign In Target URL"; },
        IDP_SLO_TARGET_URL: function() { return "Service Log Out Target URL"; },
        ID_CERT: function() { return "Identity Provider Public Certificate"; },
      },

      WELCOME_EMAIL_TITLE: function() { return "Welcome Email"; },
      WELCOME_EMAIL_DESCRIPTION: function() { return "Course welcome email is sent when learners are enrolled in a course and contains a temporary password if the password macro is used. You can disable the welcome email if you are sending your welcome emails from a different system for all enrollments. This option must be used in conjunction with SSO for the best experience and is only applicable to organization who have their first email sent elsewhere in a payment system or an LMS. Our recommended practice is to send these emails from NovoEd."; },
      DISABLE_WELCOME_EMAIL: function() { return "Disable Welcome Email"; },
      ENABLE_WELCOME_EMAIL: function() { return "Enable Welcome Email"; },
      EDITING_IN_ORGANIZATIONS: function() { return "Editing Name and Email"; },
      EDITING_DESCRIPTION_1: function() { return "Organizations with SSO allow users to edit their own First and Last name (not email address) and organizations without SSO allow learners to additionally edit their own email address."; },
      EDITING_DESCRIPTION_2: function() { return "You may prevent users from editing their First name, Last name, and email in your organization. This allows ensuring this information stays in sync with external systems."; },
      PREVENT_EDITING_IN_THIS_ORGANIZATION: function() { return "Selecting this configuration will remove the ability for users to change this information in the NovoEd Account settings/profile. For non-SSO enabled organizations, Org admins and Course Admins with permissions will be able to manually change a user's name or email in the User Management Dashboard at the Org or course level."; },
      TOS_TITLE: function() { return "Privacy Policy"; },
      TOS_DESCRIPTION: function() { return "You may specify privacy information that is available to users. Users will be notified of changes to the information defined here when signing in. This enables you to put a summary of your privacy policy information and/or a link to your privacy information to make it accessible to users in your organization for GDPR and other privacy laws. If not specified users will only see NovoEd's privacy information."; },
      ADD_TOS: function() { return "Add"; },
      UPDATE_TOS: function() { return "Update"; },
      TOS_MODAL: {
        TITLE: function() { return "Privacy Policy"; },
        DESCRIPTION: function() { return "Type your organization's privacy info here..."; },
        ARE_YOU_SURE: function() { return "Are you sure?"; },
        WARNING: function() { return "All users will receive a notification about changes you made to privacy policy next time they login."; },
        YES_SURE: function() { return "Yes, Update Privacy Information"; },
      },

      SEARCH_PRIVACY_TITLE: function() { return "User Search Privacy Setting"; },
      SEARCH_PRIVACY_DESCRIPTION: function() { return "This setting controls what users a course admin with Configuration and Registration permissions may search for to add to a course. You may allow them to search for any user in your organization, or restrict the search to users who have course admin roles in one or more courses in your organization. This will prevent the user from searching for learners to add to a course. Learners may still be added by entering full information."; },
      ENABLE_SEARCH_ALL: function() { return "Enable search for <b>ALL</b> users in the entire organization"; },
      ENABLE_SEARCH_ONLY: function() { return "Enable search for <b>ONLY</b> course admin users in the entire organization"; },
      ZOOM_INTEGRATION_TITLE: function() { return "Zoom Integration for Live Events"; },
      ZOOM_INTEGRATION_DESCRIPTION: function() { return "This setting enables Zoom integration to your courses. By enabling it, your course admins will be able to add a live event using Zoom."; },
      ZOOM_ACCOUNT_OAUTH_DESCRIPTION: function(articleLink: string) { return "Disabling/Installing the NovoEd Zoom integration may be done in Zoom by a Zoom account owner or administrator. Please follow the instructions on the  <a class=\"hovered text-regular\" href=\"" + articleLink + "\">helpdesk article</a>."; },
      ZOOM_INVALID: {
        ACCOUNT_OAUTH_MESSSAGE: function(email: string) { return "The Administrator needs to re-authenticate for Zoom account " + email + "."; },
        OAUTH_MESSAGE: function(user: string) { return "The facilitator for this event " + user + " needs to re-authenticate their Zoom account."; },
        OAUTH_MESSAGE_CLONE_COURSE_ONLY: function(user: string) { return "Please re-authenticate if " + user + " is to remain the host or authenticate with a different user who will become the new host."; },
        BUTTON: function() { return "Re-Authenticate"; },
        ADMIN_VIEW: function() { return "Admin View Only"; },
      },

      ZOOM_MODAL: {
        ENABLE_ZOOM_FAILURE: function() { return "Either the key or secret was incorrect. Please try again."; },
        OAUTH: function() { return "Enable users to authenticate their Zoom account with OAUTH"; },
        JWT: function() { return "Enable with JWT using client key and secret"; },
        ACCOUNT_OAUTH: function() { return "Enable Account-Level Integration with Zoom"; },
        ACCOUNT_OAUTH_PROMPT: function() { return "Enabling the Account Level NovoEd Connector for Zoom requires a paid Zoom meetings account and must be authenticated/installed by the Zoom account owner or an admin on the Zoom account. Installing this integration enables NovoEd to access your Zoom account to create and manage meetings, access recordings, and pull in participant information. The button below will take you to complete that step. Once you have authenticated the NovoEd Connector, course builders in your organization will be able to create Live Events with Zoom meetings in lesson pages."; },
        PROMPT: function() { return "Please enter the key and secret from the master Zoom Account :"; },
        KEY: function() { return "Key"; },
        SECRET: function() { return "Secret"; },
        ENABLE_ZOOM: function() { return "Enable Zoom"; },
        ACCOUNT_OAUTH_CONNECTOR: function() { return "Authenticate NovoEd Connector"; },
      },

      DISABLE_ZOOM: function() { return "Disable Zoom"; },
      EDIT_ZOOM: function() { return "Edit Zoom Key and Secret"; },
      DISABLE_INTEGRATION: function() { return "Disable Zoom API Integration"; },
      DISABLE_ZOOM_DESCRIPTION: function() { return "All your existing Zoom meetings will be converted to Live Events with links and will lose all automatic Zoom API features such as automatic attendance tracking, importing of recordings, and automatically reflecting meeting updates. This action cannot be undone. Are you sure?"; },
      DISABLE_ZOOM_SUCCESS: function() { return "Zoom API Integration has been disabled"; },
      ENABLE_ZOOM_SUCCESS: function() { return "Zoom API Integration has been enabled"; },
      MICROSOFT_INTEGRATION: {
        TITLE: function() { return "Microsoft Teams Meeting Integration for Live Events"; },
        DESCRIPTION: function() { return "This setting enables the NovoEd Teams Meeting Integration for Live Events. When enabled, individual course builders are able to authenticate with their Microsoft 365 Account in order to create Teams Online meetings for Live Events."; },
        ENABLE: function() { return "Enable"; },
        DISABLE: function() { return "Disable Microsoft Teams"; },
        ENABLE_SUCCESS: function() { return "Microsoft Teams API Integration has been enabled"; },
        DISABLE_SUCCESS: function() { return "Microsoft Teams API Integration has been disabled"; },
        DISABLE_TITLE: function() { return "Disable Microsoft Teams API Integration"; },
        DISABLE_DESCRIPTION: function() { return "All your existing Microsoft Teams Meeting Live Events will be converted to Live Events with links and will lose all automatic Teams API features such as automatically reflecting meeting updates. This action can not be undone. Are you sure?"; },
      },

      DISABLE_LMS_DESCRIPTION: function(provider: string) { return "You are about to disable the " + provider + " integration."; },
      DEGREED_INTEGRATION: {
        TITLE: function() { return "Degreed LXP Integration"; },
        DESCRIPTION: function() { return "This setting enables NovoEd integration to your LXP provider. By enabling it, NovoEd will be able to send course listings and updates of listing/metadata to your LXP."; },
        DISABLE: function() { return "Disable Degreed LXP Integration"; },
        EDIT: function() { return "Edit Degreed Client ID and Secret"; },
        MODAL_PROMPT: function() { return "Please provide the client ID and secret from Degreed:"; },
        CLIENT_ID: function() { return "Client ID"; },
        SECRET: function() { return "Secret"; },
        SUCCESS: function() { return "Degreed LXP Integration has been enabled."; },
        DISABLE_CONFIRM_TITLE: function() { return "Disable Degreed LXP Integration"; },
        DISABLE_DESCRIPTION: function() { return "Are you sure you wish to disable syncing of courses and completions with Degreed? Courses already synced to Degreed will be marked as obsolete and will not get any more updates or completions synced."; },
        DISABLE_SUCCESS: function() { return "Degreed LXP Integration has been disabled"; },
        SYNC_CLOSED_REG_COURSES: function() { return "Sync closed registration courses to Degreed"; },
        ENABLE: function() { return "Enable Degreed Integration"; },
      },

      HELP_OPTIONS: {
        BADGE_TITLE: function() { return "Configure Help Options"; },
        SEE_AN_EXAMPLE: function() { return "See an Example"; },
        CANCEL_BUTTON: function() { return "Cancel"; },
        CONFIRM_BUTTON: function() { return "Save"; },
        LEARNING_ASSISTANT: function() { return "AI Learning Assistant"; },
        LEARNING_ASSISTANT_BUTTON: function() { return "Ask NovoAI"; },
        ASK_NOVO_AI_DRAWER: {
          DESCRIPTION: function(d) { return "I'm your Learning Assistant. Ask me " + d.CourseAlias + " related questions and I'll help find answers!"; },
          EMBEDDING: function() { return "I'm your AI Learning Assistant! Your content is currently being processed. I'll be available once it's complete. Thanks for your patience."; },
          WELCOME_BACK_DESCRIPTION: function() { return "Welcome back! How can I help you today?"; },
          GREETING: function() { return "Hi"; },
          PLACEHOLDER: function() { return "Type your question here..."; },
          NEED_HELP_MESSAGE: function() { return "Need Help"; },
          ASK_ANOTHER_BUTTON: function() { return "Ask Another"; },
          TRY_AGAIN_BUTTON: function() { return "Try Again"; },
          MESSAGE_TEACHING: function(d) { return "Message your " + d.TeachingTeamAlias + " instead?"; },
          BUTTON: function() { return "Ask Now"; },
          TITLE: function() { return "Ask NovoAI"; },
          THANK_YOU_FEEDBACK: function() { return "Thank you!"; },
          IS_HELPFUL: function() { return "AI can make mistakes. Is this helpful?"; },
          HELPFUL: function() { return "Helpful"; },
          NOT_HELPFUL: function() { return "Not Helpful"; },
          RECENT_QUESTIONS: function() { return "Recent questions:"; },
          HERE_ARE_INFO: function() { return "Here are some help information that might be helpful to you:"; },
          SHOW_MORE: function() { return "Show More"; },
          SHOW_LESS: function() { return "Show Less"; },
          NETWORK_ERROR_MESSAGE: function() { return "Sorry, I can't find an answer for you due to an unexpected error."; },
          ERROR_DEFAULT_MESSAGE: function() { return "This seems to be outside the scope I can help with. I can answer questions about the content, using the platform, completion requirements and live events."; },
          SEE_HELP_OPTIONS: function() { return "Here are the help options available to you in this course."; },
          TALK_TO_TEAM: function(d) { return "You can reach out to your " + d.TeachingTeamAlias + " to get help."; },
          CONTACT_TEACHING_TEAM: function(d) { return "Please contact the " + d.TeachingTeamAlias + "."; },
          CERTIFICATE_LINK: function() { return "Certificate of Completion"; },
        },

        AI_ASSISTANT: {
          TITLE: function() { return "AI Learning Assistant"; },
          DESCRIPTION: function(d) { return "The AI Learning Assistant instantly answers learner questions about " + d.courseAlias + " logistics like completion requirements, to-do items, and how to navigate the platform. It can also respond to questions based on your specific learning content."; },
          SWITCH_LABEL: function() { return "Enable AI Learning Assistant."; },
          ANSWER_DESCRIPTION: function(d) { return "If a question cannot be answered by the AI Learning Assistant, provide a direct next step for learners to send a direct message to designated " + d.TeachingTeamAlias + " members (up to 5)."; },
          ALERT_AI_CAPABILITIES: function() { return "Please enable the AI Learning Assistant for the Organization to use this function"; },
          ADD_BUTTON: function() { return "Add"; },
          SEARCH_RECIPIENT: function() { return "Name"; },
          LIMITED_TEACHING_TEAM_DISABLED: function() { return "Please enable AI Learning Assistant."; },
          LIMITED_TEACHING_TEAM: function(d) { return "Limited to 5 " + d.teachingTeamAlias + " members"; },
          NO_MATCHES_FOUND: function() { return "0 Matches found"; },
          PROCESSING: function() { return "Processing..."; },
          ADDITIONAL_RESOURCES: {
            TITLE: function() { return "Additional Resources:"; },
            DRAG_DROP_AREA: function() { return "Upload File"; },
            DESCRIPTION: function() { return "Upload resources for AI to process and provide answers for your learners. (Up of 10 files, PDF, DOC, and DOCX files up to 50MB in size and less than 400 pages each.)"; },
            DELETE_POPOVER: function() { return "Are you sure you want to delete this resource?"; },
            INVALID_FILE: function() { return "Files uploaded exceed the maximum limit. Please upload files with total of 400 pages or less each. Please remove the files with error from the list."; },
            FILE_IS_TOO_LARGE: function() { return "Files uploaded exceed the maximum limit. Maximum file size is 50MB."; },
            PAGES_LIMIT_EXCEEDED: function() { return "File exceeds the 400-page limit."; },
            MULTIPLE_INVALID_FILE_TYPE: function() { return "One or more of your files are unsupported. Please select only PDF, DOC, or DOCX files."; },
            GENERAL_ERROR_MESSAGE: function() { return "Please select up to 10 files (PDF, DOC, or DOCX) up to 50MB and fewer than 400 pages each."; },
            INVALID_FILE_TYPE: function() { return "The file you are trying to upload is not supported."; },
            UNABLE_TO_UPLOAD: function() { return "Unable to upload the file due to internal error. Please reload and try again later."; },
            PROCESSING_UPLOADS_DISCLAIMER: function() { return "Newly uploaded sources are not yet processed. The answer may change once processing completes."; },
          },

        },

        HELP_RESOURCES: {
          TITLE: function() { return "Help Resources"; },
          DESCRIPTION: function() { return "You can customize the help menu to direct users to your preferred support resources, such as an email address, help desk, or website."; },
          SWITCH_LABEL: function() { return "Enable Help Resources."; },
          TITLE_FORM: function() { return "Title:"; },
          TYPE_HERE: function() { return "Type here..."; },
          START_TYPING: function() { return "Start typing here..."; },
          BODY_FORM: function() { return "Body:"; },
          COPY_EXAMPLE: function() { return "Copy this example"; },
          ENABLE_LABEL: function() { return "ON"; },
          DISABLED_LABEL: function() { return "OFF"; },
          TEMPLATE_TITLE: function() { return "Need help?"; },
          TEMPLATE_CONTACT_TEXT: function(d) { return "Contact Your " + d.TeachingTeamAlias + " at:"; },
          TEMPLATE_PLATFORM_TEXT: function() { return "For platform guidance, please check:"; },
          TEMPLATE_HELP_ARTICLES: function() { return "NovoEd Help Articles"; },
        },

      },

      DIGITAL_CREDENTIAL_INTEGRATIONS: {
        TITLE: function() { return "Digital Credential Integrations"; },
        DESCRIPTION: function() { return "This setting allows Course Builders to issue verified badges and certificates to be issued to learners upon successful completion of a NovoEd course or learning journey"; },
        DIGITAL_CREDENTIAL_MODAL: {
          MESSAGE: function() { return "Automatically issue verified badges and certificates to learners by integrating with your digital credential platform."; },
          SELECT_PROVIDER: function() { return "Select Digital Credential Provider"; },
        },

      },

      ACCREDIBLE: {
        TITLE: function() { return "Accredible Credentials Integration"; },
        DESCRIPTION: function() { return "Automatically issue Accredible certificates and badges to learners upon course completion."; },
        API_TOKEN: function() { return "API Token"; },
        DOMAIN: function() { return "Domain"; },
        EDIT_ACCREDIBLE_INTEGRATION: function() { return "Edit Accredible Integration"; },
        ENABLE_ACCREDIBLE_INTEGRATION: function() { return "Enable Accredible Integration"; },
        DISABLE_ACCREDIBLE_INTEGRATION: function() { return "Disable Accredible Integration"; },
        DISABLE_DESCRIPTION: function() { return "By disabling the Accredible Integration, NovoEd will no longer issue Accredible Credentials to learners. Credentials that have already been issued will not be impacted."; },
        SUCCESS_MESSAGE: function() { return "Accredible Integration has been enabled."; },
        UPDATE_MESSAGE: function() { return "Accredible Integration has been updated."; },
        DISABLE_SUCCESS: function() { return "Accredible Integration has been successfully disabled"; },
        COURSE: {
          DESCRIPTION: function(d) { return "Enter the Group ID of the Accredible Credentials to be issued to " + d.learnersAlias + " upon completion."; },
          GROUP_ID: function() { return "Group ID"; },
          GROUP_FOUND: function() { return "Group found"; },
          GROUP_NOT_FOUND: function() { return "Group ID not found"; },
          ENABLE_SUCCESS: function(d) { return "Accredible Integration is Enabled for this " + d.courseAlias + "."; },
          UPDATE_SUCCESS: function() { return "Accredible Integration has been updated."; },
          VIEW_IN_ACCREDIBLE: function() { return "View in Accredible"; },
          REMOVE_FROM_COURSE: function(d) { return "Remove from " + d.CourseAlias; },
          REMOVE_DESCRIPTION: function(d) { return "By removing this, NovoEd will no longer issue Accredible Credentials to " + d.learnersAlias + ". Credentials that have already been issued will not be impacted."; },
        },

      },

      CREDLY: {
        TITLE: function() { return "Credly Integration"; },
        DESCRIPTION: function() { return "This setting allows Course Builders to define a Credly badge to be issued to learners upon successful completion of a NovoEd course or learning journey."; },
        EDIT: function() { return "Edit Credly ID and Token"; },
        EDIT_CREDLY_INTEGRATION: function() { return "Edit Credly Integration"; },
        DISABLE: function() { return "Disable Credly Integration"; },
        DISABLE_DESCRIPTION: function() { return "By disabling the Credly Integration, NovoEd will no longer issue Credly badges to learners. Badges that have already been issued will not be impacted."; },
        DISABLE_SUCCESS: function() { return "Credly Integration has been successfully disabled"; },
        BADGE_TITLE: function() { return "Credly Badge"; },
        BADGE_REMOVE_DESCRIPTION: function() { return "By removing the Credly Badge, NovoEd will no longer issue Credly badges to learners. Badges that have already been issued will not be impacted."; },
        BADGE_REMOVE_SUCCESS: function() { return "Credly Badge has been successfully removed"; },
        SETTINGS_MODAL: {
          MESSAGE: function() { return "Please provide the Organization ID and Authorization Token from Credly."; },
          BADGE_MESSAGE: function() { return "Enter the Template ID of the Credly badge to be issued to learners upon completion."; },
          ORGANIZATION_ID: function() { return "Organization ID"; },
          AUTHORIZATION_TOKEN: function() { return "Authorization Token"; },
          TEMPLATE_ID: function() { return "Template ID"; },
          ENABLE: function() { return "Enable Credly Integration"; },
          SUCCESS_TITLE: function() { return "Success!"; },
          SUCCESS_MESSAGE: function() { return "Credly Integration has been enabled."; },
          UPDATE_MESSAGE: function() { return "Credly Integration has been updated."; },
          BADGE_ENABLE_SUCCESS_MESSAGE: function() { return "Credly Badge has been enabled."; },
          BADGE_UPDATE_SUCCESS_MESSAGE: function() { return "Credly Badge has been updated."; },
          ERROR_TITLE: function() { return "Authentication failed!"; },
          ERROR_MESSAGE: function() { return "Please check the information and try again."; },
          BADGE_SUCCESS_MESSAGE: function() { return "Template found"; },
          BADGE_ERROR_MESSAGE: function() { return "Template ID not found!"; },
          BADGE_NOTE: function() { return "Note: "; },
          BADGE_NOTE_MESSAGE: function() { return "The badge template must be in an active state before badges may be issued."; },
          VIEW_IN_CREDLY: function() { return "View in Credly"; },
          REMOVE_CREDLY_BADGE: function() { return "Remove Credly Badge"; },
        },

      },

      WORKERA: {
        TITLE: function() { return "Workera Integration"; },
        DESCRIPTION: function() { return "The Workera integration enables organizations to link out to skills assessments directly from NovoEd course activities. By configuring a Web Link activity with a Workera Program URL, course builders can seamlessly direct learners to complete assessments on the Workera platform. The integration is built to support a single Workera program containing a single assessment, ensuring that all completions and scores are correctly collected. Upon completion, the integration automatically marks the activity as complete within NovoEd, eliminating the need for manual tracking."; },
        ENABLE: function() { return "Enable Integration"; },
        ENABLE_SUCCESS: function() { return "Workera Integration is enabled! Please go to Workera to finish it up."; },
        DISABLE: function() { return "Disable Integration"; },
        DISABLE_SUCCESS: function() { return "Workera Integration has been disabled."; },
        DISABLE_DESCRIPTION: function() { return "You are about to disable the Workera Integration."; },
        ENABLING: function() { return "Enabling..."; },
        DISABLING: function() { return "Disabling..."; },
        MODAL: {
          DESCRIPTION: function() { return "To complete the Workera Skills integration setup, use the provided <b>Webhook URL and Secret</b>, and share them with your Workera Customer Success Manager (CSM) to activate the connection."; },
          WEBHOOK_URL: function() { return "Webhook URL"; },
          WEBHOOK_SECRET: function() { return "Webhook Secret"; },
          PLEASE_NOTE: function() { return "Please Note:"; },
          NOTE_1: function() { return "Once the webhook is enabled, be sure to copy your Webhook URL and Secret immediately, as they will not be visible after you click \"Done.\""; },
          NOTE_2: function() { return "If you need to view or update them later, you will need to disable and re-enable the integration to generate new credentials."; },
        },

      },

      EDCAST: {
        TITLE: function() { return "EdCast LXP Integration"; },
        DESCRIPTION: function() { return "This setting enables NovoEd integration with EdCast. By enabling it, NovoEd will be able to send course listings and updates of listing/metadata to EdCast."; },
        EDIT: function() { return "View Connection Details"; },
        DISABLE: function() { return "Disable EdCast LXP"; },
        DISABLE_EDCAST: function() { return "Disable EdCast LXP Integration"; },
        DISABLE_DESCRIPTION: function() { return "Disabling the EdCast LXP integration will stop synchronization of courses, enrollments, and completion data to EdCast. Are you sure?"; },
        CONFIGURE_TOOLTIP: function() { return "Please reach out to the NovoEd support team for more information on integration with your EDCast platform"; },
        SETTINGS_MODAL: {
          OAUTH2: {
            TITLE: function() { return "Enter OAuth2 Credentials"; },
            MESSAGE: function() { return "You will need to create an LMS API Integration Connector and OAuth2 App in EdCast for this integration."; },
            CLIENT_ID: function() { return "Client Id"; },
            CLIENT_SECRET: function() { return "Client Secret"; },
            LMS_HOST: function() { return "LMS Host"; },
          },

          DEVELOPER: {
            TITLE: function() { return "Enter Developer API Credentials"; },
            MESSAGE: function() { return "Generate Developer API credentials and provide an EdCast system user that is assigned a role having developer permissions."; },
            API_KEY: function() { return "API Key"; },
            API_SECRET: function() { return "API Secret"; },
            EDCAST_USER: function() { return "EdCast User"; },
            EDCAST_URL: function() { return "EdCast URL"; },
          },

          ENABLE: function() { return "Enable EdCast Integration"; },
          ENABLING: function() { return "Enabling..."; },
          SUCCESS_HEADER: function() { return "Success"; },
          SUCCESS_MESSAGE: function() { return "EdCast LXP Integration has been enabled"; },
          SUCCESS_UPDATE_MESSAGE: function() { return "EdCast LXP Integration has been enabled"; },
          SUCCESS_DISABLE_MESSAGE: function() { return "EdCast LXP Integration has been disabled"; },
          ERROR_HEADER: function() { return "Authentication failed!"; },
          ERROR_MESSAGE: function() { return "Please check the information and try again."; },
          LXP_ERROR_MESSAGE: function() { return "Check your OAuth2 information and try again."; },
          DEV_ERROR_MESSAGE: function() { return "Check your Dev API information and try again."; },
          UPDATE: function() { return "Edit EdCast Integration"; },
        },

      },

      HCM: {
        TITLE: function() { return "HCM Integration"; },
        DESCRIPTION: function() { return "Synchronize users and user metadata from your HCM / HRIS platform to NovoEd."; },
        CSV_DESCRIPTION: function() { return "If you want to download a template or upload a CSV"; },
        CLICK_HERE: function() { return "click here."; },
        DISPLAY_DETAILS: function() { return "Display Details"; },
        EDIT: function() { return "Edit Connection"; },
        DISABLE: function() { return "Disable HCM Integration"; },
        DISABLE_DESCRIPTION: function() { return "Disabling the HCM integration will stop synchronization of users and user metadata from your HCM to NovoEd. Are you sure?"; },
        CONFIGURE_TOOLTIP: function() { return "Please reach out to the NovoEd support team for more information on integration with your HCM / HRIS platform."; },
        SETTINGS_MODAL: {
          CHOOSE_INTEGRATION_TYPE: function() { return "Choose integration type"; },
          CSV_SFTP: function() { return "CSV/SFTP"; },
          WORKDAY_API: function() { return "Workday (API)"; },
          SFTP_DESCRIPTION: function() { return "NovoEd will provide a secure location for you to upload user data as CSV files."; },
          WORKDAY_DESCRIPTION: function() { return "Please provide your Workday Endpoint URL, username, and password."; },
          ENDPOINT_URL: function() { return "Endpoint URL"; },
          USERNAME: function() { return "Username"; },
          PASSWORD: function() { return "Password"; },
          SFTP_ADDRESS: function() { return "SFTP Address"; },
          PUBLIC_KEY: function() { return "Public Key"; },
          ENABLE: function() { return "Enable HCM Integration"; },
          SUCCESS_HEADER: function() { return "Success!"; },
          SUCCESS_MESSAGE: function() { return "HCM Integration has been enabled."; },
          SUCCESS_DISABLE_MESSAGE: function() { return "HCM Integration has been disabled."; },
          SUCCESS_UPDATE_MESSAGE: function() { return "HCM Integration has been updated."; },
          ERROR_HEADER: function() { return "Authentication failed!"; },
          ERROR_MESSAGE: function() { return "Please check the information and try again."; },
          ENABLING: function() { return "Enabling..."; },
          COPY_TO_CLIPBOARD: function() { return "Copy to Clipboard"; },
          COPIED: function() { return "Copied!"; },
        },

        ORG_ADMIN: {
          LAST_SYNCED: function(date: string) { return "Last Synced: " + date + ", via HCM"; },
        },

        DATA_MAPPING_MODAL: {
          TITLE: function() { return "Data Mapping"; },
          DOWNLOAD_TEMPLATE: function() { return "Download a CSV to define the relationship between fields from NovoEd and fields in your HCM."; },
          DOWNLOAD: function() { return "Download"; },
          DOWNLOADING: function() { return "Downloading..."; },
          UPLOAD_CSV: function() { return "Please select the CSV file to upload:"; },
          UPLOAD: function() { return "Upload CSV"; },
          UPLOADING: function() { return "Uploading..."; },
          SUCCESS_HEADER: function() { return "Success!"; },
          SUCCESS_MESSAGE: function() { return "File uploaded successfully"; },
        },

      },

      MICROSOFT_CALENDAR_INSTITUTION_INTEGRATION: {
        ADVICE: function(associatedEmail: string) { return "Events will originate from " + associatedEmail; },
        SECTION_TITLE_ADMIN_LEVEL: function() { return "Microsoft 365 Calendar Integration (Admin-Level)"; },
        SECTION_DESCRIPTION: function() { return "This setting integrates NovoEd with learners' Microsoft 365 Outlook Calendar.  Courses created after the integration is enabled will create Outlook Calendar events for course live events and activities with deadlines for enrolled learners.  This integration may also be enabled or disabled at the course level."; },
        SUCCESS: function() { return "Microsoft Calendar Integration has been enabled"; },
        MAILBOX_FAILURE: function() { return "Unable to enable Microsoft 365 calendar integration with the account provided."; },
        DISABLE: function() { return "Disable Calendar Integration"; },
        DISABLE_TITLE: function() { return "Disable Microsoft Calendar Integration"; },
        DISABLE_DESCRIPTION: function() { return "When deactivating the integration, all courses will be affected and no future events will be added to the learners' calendars. Previously created events will be deleted as long as the event has not ocurred. <br/> Are you sure?"; },
        DISABLE_SUCCESS: function() { return "Microsoft Calendar Integration has been disabled"; },
      },

      MICROSOFT_CALENDAR_USER_LEVEL: {
        TITLE: function() { return "Microsoft 365 Calendar Integration (User-Level)"; },
        DESCRIPTION: function() { return "This setting allows mentors and mentees within Mentor+ programs to connect their Microsoft 365 calendars so that their mentoring sessions appear as calendar events."; },
        DISABLE: {
          TITLE: function() { return "Disable Microsoft 365 Calendar Integration (User-Level)"; },
          DESCRIPTION: function() { return "By disabling this integration, users will no longer be able to create new calendar events and will not be able to connect their Microsoft 365 accounts. Existing events will not be impacted. This action can not be undone. Are you sure?"; },
          BUTTON: function() { return "Disable Calendar Integration"; },
          SUCCESS: function() { return "Microsoft 365 Calendar Integration (User-Level) has been disabled"; },
        },

        ENABLE: {
          BUTTON: function() { return "Enable"; },
          SUCCESS: function() { return "Microsoft 365 Calendar Integration (User-Level) has been enabled."; },
          ERROR_TITLE: function() { return "Authentication failed!"; },
          FAILURE: function() { return "Please check the information and try again."; },
        },

        MODAL: {
          DESCRIPTION: function() { return "Please enter your Microsoft Teams Tenant Name or Tenant ID to authorize:"; },
          INPUT_LABEL: function() { return "Microsoft Teams Tenant Name or Tenant ID:"; },
          SUBMIT: function() { return "Enable MS Teams Bot Integration"; },
        },

      },

      MICROSOFT_TEAMS_BOT_INTEGRATION: {
        SECTION_TITLE: function() { return "MS Teams Bot Integration"; },
        DESCRIPTION: function() { return "This setting authorizes and enables learners in this organization to use the MS Teams Bot. With the bot, learners can receive key NovoEd notifications, like/reply to comments, and Search NovoEd Content in MS Teams."; },
        DISABLE: {
          BUTTON: function() { return "Disable MS Teams Bot"; },
          TITLE: function() { return "Disable MS Teams Bot Integration"; },
          DESCRIPTION: function() { return "By disabling this integration, learners in your organization will no longer receive notifications or be able to engage with the MS Teams Bot. <br/> Are you sure?"; },
          SUCCESS: function() { return "MS Teams Bot Integration has been disabled"; },
        },

        ENABLE: {
          BUTTON: function() { return "Enable MS Teams Bot"; },
          SUCCESS: function() { return "MS Teams Bot has been enabled."; },
          ERROR_TITLE: function() { return "Authentication failed!"; },
          FAILURE: function() { return "Please check the information and try again."; },
        },

        MODAL: {
          DESCRIPTION: function() { return "Please enter your Microsoft Teams Tenant Name or Tenant ID to authorize:"; },
          INPUT_LABEL: function() { return "Microsoft Teams Tenant Name or Tenant ID:"; },
          SUBMIT: function() { return "Enable MS Teams Bot Integration"; },
        },

      },

      LMS_INTEGRATION: {
        SECTION_TITLE: function() { return "LMS Integration"; },
        SECTION_DESCRIPTION_ENABLED: function() { return "You can enable a programatic integration with your LMS to sync your NovoEd courses and learner completions into the LMS automatically."; },
        SECTION_DESCRIPTION: function() { return "Please reach out to the NovoEd support team for more information on integration with your LMS."; },
        LMS_ENABLED: function() { return "LMS Integration has been enabled"; },
        LMS_DISABLED: function() { return "LMS Integration has been disabled"; },
        ENABLED_SECTION: {
          SABA_DESCRIPTION: function() { return "You have configured integration with Saba."; },
          SUMTOTAL_DESCRIPTION: function() { return "You have configured integration with SumTotal LMS. This integration allows NovoEd to get completion information for SumTotal activities linked as Web Link third-party tool activities in a lesson."; },
          CSOD_DESCRIPTION: function() { return "You have configured the Cornerstone LMS Online Content Connector integration."; },
          LEARNUPON_DESCRIPTION: function() { return "You have Connected the LearnUpon integration."; },
          WORKDAY_LEARN_DESCRIPTION: function() { return "You have configured integration with Workday Learning."; },
          API_ENDPOINT: function() { return "API endpoint: "; },
          DOMAIN: function() { return "Domain used for NovoEd courses: "; },
          COURSE_NUMBER_CONFIGURATION: function() { return "Course Number configuration option: "; },
        },

        DISABLE_CTA: function() { return "Disable SABA Integration"; },
        DISABLE_CTA_SUM_TOTAL: function() { return "Disable SumTotal Integration"; },
        DISABLE_CTA_CSOD: function() { return "Disable Cornerstone Integration"; },
        DISABLE_CTA_LEARNUPON: function() { return "Disable LearnUpon Integration"; },
        DISABLE_CTA_WORKDAY_LEARN: function() { return "Disable Workday Learning Integration"; },
        DISABLING: function() { return "Disabling..."; },
        MANAGE_TOPICS: function() { return "Manage Workday Topics"; },
        MODAL: {
          TITLE: function() { return "Configure LMS Integration"; },
          SABA_TITLE: function() { return "Saba Integration Settings"; },
          SUM_TOTAL_TITLE: function() { return "SumTotal Integration Settings"; },
          PROVIDER_TYPE: {
            SABA: function() { return "Saba Cloud"; },
            SUMTOTAL: function() { return "SumTotal"; },
            CSOD: function() { return "Cornerstone"; },
            LEARNUPON: function() { return "LearnUpon"; },
            WORKDAY_LEARN: function() { return "Workday Learning"; },
          },

          SELECT_PROVIDER: function() { return "Select LMS Provider"; },
          ERROR_TITLE: function() { return "Authentication failed!"; },
          ERROR: function() { return "Please check the information and try again."; },
          SABA: {
            STEP_1: {
              INTEGRATION_DESCRIPTION: function() { return "To configure integration with Saba Cloud LMS you must provide your API Endpoint, Client ID, and Secret."; },
              API_ENDPOINT: function() { return "API Endpoint"; },
              CLIENT_ID: function() { return "Client ID"; },
              CLIENT_SECRET: function() { return "Client Secret"; },
              AUTHENTICATION_DESCRIPTION: function() { return "Please enter a Saba username and password to authenticate. This password will not be stored in NovoEd. It is recommended that this user be dedicated to the integration and you should refrain from regularly modifying this account in order to avoid adverse effects to the NovoEd-Saba integration behavior."; },
              USERNAME: function() { return "Saba username"; },
              PASSWORD: function() { return "Saba password"; },
              CTA: function() { return "Authorize"; },
            },

            STEP_2: {
              LABEL: {
                DOMAIN: function() { return "Please select a Domain in Saba to sync NovoEd course. All NovoEd courses will go in this domain:"; },
                AUTO_ASSIGN: function() { return "Please select if your Saba cloud site is configured to auto-assign course and class numbers:"; },
                USERNAME_TYPE: function() { return "Please select the field that will have users' Saba Username."; },
              },

              SELECT_DOMAIN: function() { return "Select Domain"; },
              SELECT_USERNAME_TYPE: function() { return "Select Username Type"; },
              ENABLE_AUTO_ASSIGN: function() { return "Saba will assign course/class numbers"; },
              DISABLE_AUTO_ASSIGN: function() { return "NovoEd will set a unique course number for each course"; },
              USERNAME_TYPE_EMAIL: function() { return "Email"; },
              USERNAME_TYPE_EXTERNAL: function() { return "External ID"; },
              CTA: function() { return "Save"; },
            },

          },

          SUMTOTAL: {
            STEP_1: {
              INTEGRATION_DESCRIPTION: function() { return "To configure integration with SumTotal LMS you must create an OAuth Client and share the API Endpoint, Client ID, and Secret."; },
              API_ENDPOINT: function() { return "API Endpoint"; },
              CLIENT_ID: function() { return "Client ID"; },
              CLIENT_SECRET: function() { return "Client Secret"; },
              CTA: function() { return "Authorize"; },
            },

            STEP_2: {
              LABEL: {
                ORG_PROFILE: function() { return "Please select the field that will have users' SumTotal Username. The SumTotal username must be synced into each learner's profile in order to sync enrollments and completions."; },
              },

              SELECT_ORG_PROFILE: function() { return "Please select..."; },
              CTA: function() { return "Save"; },
            },

          },

          CSOD: {
            INTEGRATION_DESCRIPTION: function() { return "To configure integration with Cornerstone, first reach out to Cornerstone to configure the Online Content Connector. Afterwards, provide your Cornerstone URL and API Credentials."; },
            TENANT_URL: function() { return "Cornerstone Tenant URL"; },
            TENANT_URL_PLACEHOLDER: function() { return "https://customer.csod.com"; },
            CLIENT_ID: function() { return "Client ID"; },
            CLIENT_SECRET: function() { return "Client Secret"; },
            NOVOED_PROFILE_SELECT: function() { return "Please select the NovoEd profile field that will have users' Cornerstone User ID"; },
            PLEASE_SELECT: function() { return "Please Select"; },
            CTA: function() { return "Authorize"; },
          },

          LEARN_UPON: {
            DESCRIPTION: function() { return "To create an integration with LearnUpon, provide us with your LearnUpon URL, API Key and API Secret."; },
            DOMAIN_URL: function() { return "LearnUpon Domain URL:"; },
            MODULE_ID: function(moduleIdHelpLink: string) { return "Content Module ID (<a href=" + moduleIdHelpLink + " target=\"_blank\" class=\"text-primary\">Where to find this?</a>)"; },
            COURSE_ID: function() { return "Course Id"; },
            MODULE_ID_PLACEHOLDER: function() { return "Content Module ID"; },
            COURSE_OWNER: function() { return "Course Owner's Email"; },
            API_KEY: function() { return "API Key"; },
            API_SECRET: function() { return "API Secret"; },
            CTA: function() { return "Authorize"; },
          },

          WORKDAY_LEARN: {
            DESCRIPTION: function() { return "To configure integration with Workday Learning you must create an OAuth Client and share the Base CCL Endpoint (e.g., https://pss.play.megaleomedia.com/v1/...), Client ID, and Secret."; },
            CLIENT_ID: function() { return "Client ID"; },
            CLIENT_SECRET: function() { return "Client Secret"; },
            AUTH_URL: function() { return "Auth URL"; },
            TRACKING_URL: function() { return "Tracking URL"; },
            CONTENT_URL: function() { return "Content URL"; },
            AUTHORIZE: function() { return "Authorize"; },
            AUTHORIZING: function() { return "Authorizing..."; },
            STEP_1: function() { return "Step 1: Authorize"; },
            STEP_2: function() { return "Step 2: Upload Topics"; },
            UPLOAD_CSV: function() { return "Upload Workday Topic CSV"; },
            PROCESSING: function() { return "Processing CSV..."; },
            ADD_TOPICS: function() { return "Add Workday Topics"; },
            FOUND: function() { return "We found the following in the CSV."; },
            TOPICS_DESCRIPTION: function(articleLink: string) { return "Topics are used for domain security and enable discoverability in Workday Learning. You can bulk Upload a CSV of Workday Learn Topics to use during course creation. See our <a href=\"" + articleLink + "\" target=\"_blank\" class=\"text-primary\">help article</a> on how to download Topics as a CSV file."; },
            MANAGE_TOPICS_DESCRIPTION: function() { return "Manage your workday topics below. Add more topics or set default topics to automatically apply them to open and future Production courses"; },
            TOTAL_TOPICS: function(count: number) { return "Total of " + count + " workday topics"; },
            ADD_MORE: function() { return "Add More Topics"; },
            AUTHENTICATE_SUCCESS: function() { return "Workday authentication is successful!"; },
            ENABLE_WITH_TOPICS: function() { return "Enable Workday Learning Integration"; },
            ENABLING: function() { return "Enabling..."; },
            MARK_DEFAULT: function() { return "Mark as Default"; },
            REMOVE_DEFAULT: function() { return "Remove as Default"; },
            DEFAULT: function() { return "Default"; },
            TOOLTIP: {
              MARK_AS: function() { return "New courses will automatically use this topic by default. It can be changed during course creation."; },
              REMOVE_AS: function() { return "Remove this as the default topic. New courses will have no topic preselected."; },
            },

            TOPICS_UPDATED: function() { return "Workday Learning Topics are updated!"; },
            ENABLE_SUCCESS: function() { return "Workday Learning Integration is enabled!"; },
            CANCEL_CONFIRMATION: function() { return "You are about to cancel the Workday Learning integration."; },
            UPLOAD_ERROR: function(articleLink: string) { return "Your Topics CSV has one or more formatting errors. Please review the required template in our <a href=\"" + articleLink + "\" target=\"_blank\" class=\"text-primary\">help article</a> and try again. If the issue persists, contact Support."; },
          },

        },

      },

      SFTP: {
        TITLE: function() { return "Course Downloads Daily SFTP"; },
        DESCRIPTION_1: function() { return "Course Downloads Daily SFTP is an automated data export integration that enables organizations to receive scheduled course report downloads from NovoEd directly to a designated SFTP location each night."; },
        DESCRIPTION_2: function() { return "This functionality is configurable on a per-report basis within the Course Data Downloads section. Once enabled for a specific report, the latest data will be securely transmitted nightly."; },
        DESCRIPTION_3: function() { return "To activate this integration or request setup assistance, please contact our support team at <a href=\"mailto:hello@novoed.com\" target=\"_blank\" class=\"text-primary\">hello@novoed.com</a>."; },
        ENABLED_DESCRIPTION: function() { return "To modify this integration, please contact our support team at <a href=\"mailto:hello@novoed.com\" target=\"_blank\" class=\"text-primary\">hello@novoed.com</a>."; },
        TOOLTIP: function() { return "Please reach out to the NovoEd Support team to modify this integration"; },
      },

      CAPABILITY_TAGS: {
        TITLE: function() { return "Setup Capability Tags"; },
        DESCRIPTION: function() { return "Define and manage a set of tags for capabilities at the org level, then assign them on the course level."; },
        ADD_A_TAG: function() { return "Add a Tag"; },
        DUPLICATE_TAG: function() { return "This tag already exists"; },
        PROMPT: function() { return "Select Capability Tags"; },
        NO_TAGS: function() { return "No Capability tags defined for your organization"; },
      },

      ORG_LEVEL_PROFILE: {
        TITLE: function() { return "Organization Profile"; },
        DESCRIPTION: function(profileLink: string) { return "Setup basic questions for your organization level profile so your learner will have consistent information when enrolled in your organization. Information listed on organization profile will also show on learner's course and program profiles. (<a href=\"" + profileLink + "\" class=\"hovered text-regular\">View Your Profile</a>)"; },
        SETTINGS_MODAL: {
          ADD_FIELD: function() { return "Add Field"; },
          FIELD_NAME: function() { return "Field Name"; },
          INPUT_TYPE: function() { return "Input Type"; },
          NOT_EDITABLE: function() { return "(Not Editable)"; },
          ACCOUNT_LEVEL_INFO: function() { return "Account Level Information"; },
          TITLE: function() { return "Configure Organization Profile Questions"; },
          MESSAGE: function() { return "The following fields are included in a user's organization level profile. Any changes will be applied to all user profiles in the organization."; },
        },

        ALERT_OVERLAY: {
          TITLE: function() { return "This change will affect all courses within your organization"; },
          DESCRIPTION: function() { return "Org level profile and all course profiles will be updated based on this change. Are you sure?"; },
        },

      },

      FILE_RESOURCE_DOWNLOAD: {
        TITLE: function() { return "File Resource Download"; },
        DESCRIPTION: function() { return "This setting controls the default setting for the \"Enable File Downloads\" option for file resources components added to lessons. This setting will be applied to any new file resource components added to lessons. Changing this setting does not impact existing file components. The Course builder can always control this setting for individual files independent of the default."; },
        LABEL_TEXT: function() { return "File download enabled by default"; },
      },

      VIDEO_PRACTICE_INSIGHTS: {
        TITLE: function() { return "Practice Insights"; },
        DESCRIPTION_1: function() { return "Insights provides learners with valuable information about their practice submissions, including automated detection of keywords or phrases, filler word analysis, and rate of speech analysis."; },
        DESCRIPTION_2: function() { return "Enabling Insights for your institution will allow admins to configure Insights for Practice Scenarios. Disabling this feature will remove it from Practice Scenarios and delete any existing Insights from learners' practice submissions."; },
        ENABLED_TEXT: function() { return "Insights enabled by default"; },
        DISABLED_TEXT: function() { return "Insights disabled"; },
        DISABLE_INSIGHTS: function() { return "Disable Insights"; },
        DISABLE_INFO: function() { return "Disabling Insights will delete any existing Insights generated for practice videos. This cannot be reversed."; },
      },

      GENERATIVE_AI_CAPABILITIES: {
        TITLE: function() { return "Generative AI Capabilities"; },
        DESCRIPTION: function(learnMoreLink: string) { return "NovoAI uses Anthropic models on AWS and Microsoft Azure OpenAI services to unlock a growing world of possibilities for your L&D organization. <a href=\"" + learnMoreLink + "\" target=\"_blank\" class=\"text-primary\">Learn More</a>"; },
        LEARN_MORE: function() { return "Learn More"; },
        AI_LEARNING_ASSISTANT_TOGGLE: function() { return "AI Learning Assistant Toggle"; },
        ENABLE_AI_LEARNING_ASSISTANT: function(learnMoreLink: string) { return "Enable AI Learning Assistant to answer common learner questions using course content, additional resources you configure, logistics data, and curated platform information. <a href=\"" + learnMoreLink + "\" target=\"_blank\" class=\"text-primary\">Learn More</a>"; },
        PLEASE_NOTE: function() { return "<b>Please note:</b> This is optional and can be disabled for compliance reasons while maintaining access to other Generative AI capabilities."; },
      },

      APP_PROMOTION: {
        TITLE: function() { return "Promote Native Mobile Apps"; },
        DESCRIPTION_1: function() { return "NovoEd offers iOS and Android apps for learners to be able to engage with learning experiences with the device of their choice."; },
        DESCRIPTION_2: function() { return "When this option is enabled, NovoEd mobile website and desktop, will show a message to end users to inform them about the native mobile apps and make it easier to download."; },
        DESCRIPTION_3: function() { return "If your organization's Single-Sign-On does not allow mobile use or you do not want exposure to native apps for any reason, please feel free to disable this option."; },
        DISABLE: function() { return "Disable Native App Promotion"; },
        DISABLE_INFO: function() { return "Disabling native app promotion will remove the ways your users learn about NovoEd mobile apps on NovoEd. They can still discover apps on respective app stores on their own."; },
      },

      METADATA: {
        TITLE: function() { return "Learning Experience Metadata"; },
        DESCRIPTION: function() { return "Set up additional metadata for your learning experiences such as Departments, Business Units, or Regions to match your organization's needs. This metadata enables you to organize your learning experiences and filter your organizations' offerings based on these values."; },
        BUTTON: function() { return "Configure Metadata"; },
        SUCCESS_MESSAGE: function() { return "Learning Experience Metadata Updated!"; },
        SETTINGS_MODAL: {
          ADD_FIELD: function() { return "Add New Metadata"; },
          ADD_FIELD_LABEL: function() { return "Metadata Display Name"; },
          ADD_VALUE: function() { return "Add a Value"; },
          TYPE_HERE: function() { return "Type here..."; },
          EXISTING_METADATA_NAME: function() { return "This name already exists"; },
          EXISTING_METADATA_VALUE: function() { return "This value already exists"; },
          TITLE: function() { return "Configure Metadata"; },
          MESSAGE: function() { return "Each metadata field includes a display name and values. Mark metadata as required to ensure course creators select an option when creating courses. You can also mark it as learner-facing to display it on course flyer pages and as Learning Catalog filters (if enabled)."; },
          HOVER_REQUIRED: function() { return "This metadata is a required to pick an value when creating a new course in your organization."; },
          HOVER_NOT_REQUIRED: function() { return "Mark this as a required field when creating a new course in your organization so it is required to pick an value for that metadata."; },
          HOVER_EYE_ON: function() { return "Click to hide this from course flyer pages and Learning Catalog filters."; },
          HOVER_EYE_OFF: function() { return "Click to make this learner-facing. It will display on course flyer pages and in Learning Catalog filters (if enabled)."; },
          ARE_YOU_SURE: function() { return "Are You Sure?"; },
          DROPDOWN: {
            DELETE: function() { return "Delete Metadata"; },
            EDIT: function() { return "Edit Display Name"; },
            METADATA_DISPLAY_NAME: function() { return "Metadata Display Name"; },
            CONFIRMATION_MESSAGE: function() { return "This change will affect all learning experiences in your Organization. Are you sure you want to proceed?"; },
          },

          TOOLTIP: {
            CONFIRMATION_MESSAGE: function() { return "This change will affect all learning experiences in your Organization. Are you sure you want to proceed?"; },
          },

        },

        LEARNING_CATALOG: {
          TITLE: function() { return "Learning Catalog"; },
          DESCRIPTION: function() { return "Enable Learning Catalog so learners can discover all organizational offerings from their dashboard."; },
          LINK_LABEL_TEXT: function() { return "Configure Learning Experience Metadata"; },
          LABEL_TEXT: function() { return "to mark certain metadata as learner-facing so they appear as filters in Learning Catalog."; },
        },

      },

      AUTOMATED_TRANSLATION: {
        TITLE: function() { return "AI Translation"; },
        DESCRIPTION: function() { return "NovoEd utilizes Microsoft Azure AI services to provide AI Translation of the course content with so that learners can choose to view the content in their preferred language. Enabling this feature will allow Course builders to configure AI Translation for their courses."; },
      },

      SPEECH_TO_TEXT_CAPABILITIES: {
        TITLE: function() { return "Speech to Text Capabilities"; },
        SPEECH_TO_TEXT_DESCRIPTION: function(sttLearnMore: string) { return "NovoEd uses DeepGram Voice AI APIs for enabling speech to text transcription capabilities that power our features such as AI insights for Practice, AI Roleplays with voice dictation, and AI Captions and Transcripts for lesson videos. <a href=\"" + sttLearnMore + "\" class=\"text-primary\" target=\"_blank\">Learn More</a>"; },
      },

      WITHDRAW_FROM_CLOSED_ENROLLMENT_COURSES: {
        TITLE: function() { return "Withdraw from Closed Enrollment Courses"; },
        DESCRIPTION: function() { return "You may prevent learners from withdrawing from closed enrollment courses. On disabling this setting, learners will not have the option to withdraw from closed enrollment courses (including Open in Journey courses). Admins will be able to unenroll learners from the course manually."; },
        LABEL_TEXT: function() { return "Allow learners to withdraw from closed enrollment courses"; },
      },

    },

    BRANDING: {
      HEADER: {
        DELETE_LOGO: function() { return "Delete Logo"; },
        NEW_BACKGROUND_IMAGE: function() { return "Upload a New Image"; },
        REPLACE_LOGO: function() { return "Replace with Institution Logo"; },
        EDIT_BACKGROUND_IMAGE: function() { return "Edit Background Image"; },
        REMOVE_BACKGROUND_IMAGE: function() { return "Remove Image Background"; },
        TITLE_TEXT_BLACK: function() { return "Change the title text to black"; },
        TITLE_TEXT_WHITE: function() { return "Change the title text to white"; },
        UPLOAD_BACKGROUND_IMAGE: function() { return "Upload a Background Image"; },
        EDIT_BACKGROUND_IMAGE_TOOLTIP: function() { return "Edit image background"; },
      },

    },

    MANAGE_COURSE_ACCESS_MODAL: {
      TITLE: function(type: string) { return "Manage " + select(type, { course: "Course", other: "Program" }) + " Access"; },
      SELECT_ROLE_PLACEHOLDER: function() { return "Select a Role"; },
      SELECT_ROLE_DROPDOWN_MESSAGE: function(type: string) { return "If you would like to be added to the " + select(type, { course: "Course", other: "Program" }) + ", select the role that aligns with the level of access you need."; },
      USER_MANAGEMENT_LINK: function(targetBlank: string, type: string, userManagementLink: string) { return "If you would like to enroll " + select(type, { course: "learners or manage access for other administrative users", other: "mentor program admins or other roles in the program" }) + ", please go to <a href=\"" + userManagementLink + "\"" + select(targetBlank, { true: " target=\"_blank\" ", other: "" }) + ">User Management.</a>"; },
      JOIN_COURSE: function(type: string) { return "Join " + select(type, { course: "Course", other: "Program" }); },
    },

  },

  REPORT_FLAGGINGS: {
    ABUSE: function() { return "Report as Abusive"; },
    NO_CONTENT: function() { return "Cannot View Content"; },
    FORGERY: function() { return "Report as Forgery"; },
    SPAM: function() { return "Report as Spam"; },
  },

  DISCUSSIONS: {
    TITLE: function() { return "Discussions"; },
    ROLES: {
      INSTRUCTOR: function() { return "Instructor"; },
      MENTOR: function() { return "Mentor"; },
      TEACHING_ASSISTANT: function() { return "Teaching Assistant"; },
    },

    SORT_OPTIONS: {
      TRENDING: function() { return "Trending"; },
      RECENT: function() { return "Most Recent"; },
      LIKE: function() { return "Most Liked"; },
      COMMENT: function() { return "Most Commented"; },
    },

    FILTER_OPTIONS: {
      ALL: function() { return "All Posts"; },
      ALL_TOPICS: function() { return "All Topics"; },
      POST: function() { return "Posts by me"; },
      SUBSCRIBE: function() { return "Posts I'm Following"; },
      COMMENT: function() { return "Posts I've Commented On"; },
      LIKE: function() { return "Posts I've Liked"; },
    },

    MOBILE_FILTERS: {
      FILTERS_TEXT: function() { return "Filters"; },
      TOPICS_TEXT: function() { return "Topics"; },
      SORTING_TEXT: function() { return "Sorting"; },
    },

    ADMIN_OPTIONS: function() { return "Admin Options"; },
    CREATE_NEW_TOPIC: function() { return "Create a New Topic"; },
    CREATE_NEW_POST: function() { return "Create a New Post"; },
    NO_TOPICS_YET: function() { return "No Topics Yet"; },
    NO_POSTS_YET: function() { return "No Posts Yet"; },
    QUESTION_ARIA_LABEL: function() { return "Question"; },
    DROPDOWN: {
      EDIT: function() { return "Edit"; },
      EDIT_DISABLE_TOOLTIP: function() { return "Need to set this up on lesson from the Library"; },
      DELETE: function() { return "Delete"; },
      DELETE_DISABLE_LINKED_TOOLTIP: function() { return "Need to delete from the Library"; },
      DELETE_DISABLE_TOOLTIP: function() { return "This topic contains one or more discussion posts. In order to delete, first change the topic for the associated discussion post(s)."; },
      FOLLOW: function() { return "Follow"; },
      UNFOLLOW: function() { return "Stop Following"; },
      DIRECT_LINK: function() { return "Direct link"; },
      COPY_LINK: function() { return "Copy Link"; },
      FLAG: function() { return "Flag as Inappropriate"; },
      HIGHLIGHT: function() { return "Highlight"; },
      UNHIGHLIGHT: function() { return "Un-Highlight"; },
      EDIT_HIGHLIGHT_OPTIONS: function() { return "Edit Highlight Options"; },
      LOCK_TOPIC: function() { return "Lock Topic"; },
      UNLOCK_TOPIC: function() { return "Unlock Topic"; },
      FOLLOW_THIS_TOPIC: function() { return "Follow this Topic"; },
      UNFOLLOW_THIS_TOPIC: function() { return "Stop Following this Topic"; },
      ARIA_LABEL: {
        EDIT: function(isComment: string, isDiscussion: string) { return "Click to edit this " + select(isDiscussion, { true: "discussion", other: select(isComment, { true: "comment", other: "reply" }) }); },
        DELETE: function(isComment: string, isDiscussion: string) { return "Click to delete this " + select(isDiscussion, { true: "discussion", other: select(isComment, { true: "comment", other: "reply" }) }); },
        FOLLOW: function(isComment: string, isDiscussion: string) { return "Click to follow this " + select(isDiscussion, { true: "discussion", other: select(isComment, { true: "comment", other: "reply" }) }); },
        UNFOLLOW: function(isComment: string, isDiscussion: string) { return "Click to stop following this " + select(isDiscussion, { true: "discussion", other: select(isComment, { true: "comment", other: "reply" }) }); },
        COPY_LINK: function(isComment: string, isDiscussion: string) { return "Click to copy a link to this " + select(isDiscussion, { true: "discussion", other: select(isComment, { true: "comment", other: "reply" }) }); },
        HIGHLIGHT: function(isComment: string, isDiscussion: string) { return "Click to highlight this " + select(isDiscussion, { true: "discussion", other: select(isComment, { true: "comment", other: "reply" }) }); },
        UNHIGHLIGHT: function(isComment: string, isDiscussion: string) { return "Click to un-highlight this " + select(isDiscussion, { true: "discussion", other: select(isComment, { true: "comment", other: "reply" }) }); },
        FLAG: function(isComment: string, isDiscussion: string) { return "Click to flag this " + select(isDiscussion, { true: "discussion", other: select(isComment, { true: "comment", other: "reply" }) }) + " as inappropriate"; },
      },

    },

    NEW: function() { return "New"; },
    LOADING: function() { return "Loading: Discussion"; },
    LOAD_PREVIOUS_COMMENTS: function(additionalCommentsCount: number) { return "Load previous comments (" + additionalCommentsCount + " remaining)"; },
    LOAD_PREVIOUS_COMMENTS_WITH_NEW: function(additionalCommentsCount: number, additionalNewCommentsCount: number) { return "Load previous comments (" + additionalCommentsCount + " remaining, " + additionalNewCommentsCount + " new)"; },
    LOAD_MORE_COMMENTS: function(additionalCommentsCount: number) { return "Load more comments (" + additionalCommentsCount + " remaining)"; },
    LOAD_MORE_COMMENTS_WITH_NEW: function(additionalCommentsCount: number, additionalNewCommentsCount: number) { return "Load more comments (" + additionalCommentsCount + " remaining, " + additionalNewCommentsCount + " new)"; },
    LOAD_PREVIOUS_REPLIES: function(additionalRepliesCount: number) { return "Load previous replies (" + additionalRepliesCount + " remaining)"; },
    LOAD_PREVIOUS_REPLIES_WITH_NEW: function(additionalNewRepliesCount: number, additionalRepliesCount: number) { return "Load previous replies (" + additionalRepliesCount + " remaining, " + additionalNewRepliesCount + " new)"; },
    LOAD_NEXT_REPLIES: function(additionalRepliesCount: number) { return "Load next replies (" + additionalRepliesCount + " remaining)"; },
    LOAD_MORE_REPLIES: function(additionalRepliesCount: number) { return "Load more replies (" + additionalRepliesCount + " remaining)"; },
    COMMENT_NOT_FOUND: function() { return "Comment not found!"; },
    ADD_NEW: function() { return "Add New"; },
    VIEW_ALL_POSTS: function() { return "View All Posts"; },
    ACTIONS: function() { return "Actions"; },
    LIKE: function() { return "Like"; },
    LIKE_THE_COMMENT: function(comment: string) { return "Do like " + comment; },
    LIKES: function() { return "Likes"; },
    UNLIKE: function() { return "Unlike"; },
    COMMENT: function() { return "Comment"; },
    COMMENTS: function() { return "Comments"; },
    COMMENTING: function() { return "Commenting..."; },
    COMMENT_POSTED_SUCCESS: function() { return "Your comment has been posted successfully"; },
    COMMENT_UPDATED_SUCCESS: function() { return "Your comment has been updated successfully"; },
    REPLY: function() { return "Reply"; },
    REPLY_TO_COMMENT: function(comment: string) { return "Do reply to " + comment; },
    REPLIES: function() { return "Replies"; },
    REPLYING: function() { return "Replying..."; },
    COMMENTS_COUNT_TOOLTIP: function(isExpanded: string) { return select(isExpanded, { true: "Collapse", other: "Expand" }) + " comments"; },
    REPLY_COUNT_TOOLTIP: function(isExpanded: string) { return select(isExpanded, { true: "Collapse", other: "Expand" }) + " replies"; },
    EDIT: function() { return "Edit"; },
    UPDATE: function() { return "Update"; },
    UPDATING: function() { return "Updating..."; },
    DECLINE: function() { return "Decline"; },
    PLACEHOLDER: function() { return "What's your thought?"; },
    BY_DATE: function() { return "By Date"; },
    BY_LIKES: function() { return "By Likes"; },
    POST_COMMENT: function() { return "Post a comment"; },
    LEAD_THE_WAY: function(d) { return "Lead the way, be the first one to start a discussion on your " + d.teamAlias + "!"; },
    HIGHLIGHT: {
      POST_HIGHLIGHT: function() { return "Post Highlighted. Click To Edit Options"; },
      POST: function() { return "Highlight Post"; },
      TIMEFRAME: function() { return "During what timeframe would you like to highlight this post? Please Note: You can edit this at any time by clicking on the \"Highlighted\" ribbon."; },
      FROM: function() { return "From"; },
      TO: function() { return "To"; },
    },

    NEW_POST: {
      EDIT_POST: function() { return "Edit Post"; },
      CREATE_NEW_POST: function() { return "Create a New Post"; },
      SELECT_ADMIN_AS_STARTER: function() { return "Select a Discussion Starter:"; },
      SELECT_TOPIC: function() { return "Select a Topic"; },
      TITLE: function() { return "Post Title"; },
      SCHEDULE_FOR_LATER: function() { return "Schedule for later"; },
      SCHEDULE_FOR: function() { return "Schedule for:"; },
      SCHEDULING_NOTE: function(releaseDate: string) { return "The release date for this post can only be scheduled on or after topic release date (" + releaseDate + ")"; },
      SUBMITTING: function() { return "Submitting.."; },
    },

    NEW_TOPIC: {
      EDIT_TOPIC: function() { return "Edit Topic"; },
      CREATE_NEW_TOPIC: function() { return "Create a New Topic"; },
      TITLE: function() { return "Title"; },
      DESCRIPTION: function() { return "Description"; },
      INSERT_TO_TOP: function() { return "Insert to the Top"; },
      INSERT_AFTER: function() { return "Insert After:"; },
    },

    FETCH_COMMENTS: {
      ERROR: {
      },

    },

    BULK_STARTER_UPDATE: {
      TITLE: function() { return "Bulk update discussion starter?"; },
      SUBTITLE: function() { return "We noticed that you are updating the discussion starter. We can apply this change to all discussions for you, should we?"; },
      YES_CHECKBOX: function(NAME: string) { return "Yes, apply " + NAME + " as discussion starter for every discussion."; },
      NO_CHECKBOX: function() { return "No, only update discussion starter in this discussion."; },
      OK_BUTTON: function() { return "Update"; },
      CANCEL_BUTTON: function() { return "Cancel"; },
    },

    BE_THE_FIRST_TO_POST: function() { return "Be the first to post!"; },
    BE_THE_FIRST_TO_POST_HERE: function() { return "Be the first one to post here!"; },
    BE_THE_FIRST_TO_PARTICIPATE: function() { return "Be the first to participate!"; },
    DELETE_TOPIC_MSG: function() { return "Are you sure you want to delete this topic?"; },
    DELETE_TOPIC_WITH_POSTS_MSG: function() { return "Deleting this topic will delete all of its posts as well. Are you sure you want to delete it?"; },
    DELETE_POST_MSG: function() { return "Are you sure you want to delete this post?"; },
    DELETE_POST_WITH_COMMENTS_MSG: function() { return "This action will delete the discussion thread, including all learner comments, as well as all replies. Are you sure you want to delete it?"; },
    DELETE_REPLY_MSG: function() { return "Are you sure you want to delete this reply?"; },
    DELETE_REPLY_WITH_POINTS_MSG: function() { return "Deleting this reply will remove the points you may have received. Are you sure?"; },
    DELETE_COMMENT_MSG: function() { return "Are you sure you want to delete this comment?"; },
    DELETE_COMMENT_WITH_REPLIES_MSG: function() { return "Deleting this comment will remove all of its replies as well. Are you sure?"; },
    DELETE_COMMENT_WITH_POINTS_MSG: function() { return "Deleting this comment will remove the points you may have received. Are you sure?"; },
    DELETE_COMMENT_WITH_POINTS_AND_REPLIES_MSG: function() { return "Deleting this comment will remove the points you may have received, as well as all of its replies. Are you sure?"; },
    DISCUSSION_IS_CLOSED: function() { return "This discussion is now closed"; },
    TOPIC_SCHEDULED_TO_RELEASE: function(releasedate: string) { return "This discussion topic is scheduled to be released on " + releasedate; },
    COMMENT_INPUT_INFO: function() { return "Editing mode activated. Use Tab to navigate controls, Escape to cancel, Enter to save changes."; },
    RHS: {
      POPULAR_TOPICS: function() { return "Popular Topics"; },
      SHOW_MORE: function() { return "Show More"; },
      SHOW_FEWER: function() { return "Show Fewer"; },
      SHOW_MORE_ARIA_LABEL: function() { return "Show more discussion topics"; },
      SHOW_FEWER_ARIA_LABEL: function() { return "Show less discussion topics"; },
      ACTIVE_IN_DISCUSSIONS: function() { return "Active in Discussions"; },
      OPEN_EDIT_OPTIONS: function() { return "Open Edit Options"; },
      X_TOTAL_POSTS: function(postCount: number) { return postCount + " total"; },
      X_NEW_POSTS: function(postCount: number) { return postCount + " new"; },
    },

    INCLUDE_CURRENT_VIDEO_TIME: function() { return "Include current video time"; },
    SUBMISSIONS: {
      LOG_IN_TO_COMMENT: function() { return "Please sign in to comment."; },
      ENROLL_TO_COMMENT: function() { return "Please enroll to comment."; },
    },

  },

  EVALUATIONS: {
    START_HEADER: function() { return "Start an Evaluation"; },
    EVALUATIONS: function() { return "Evaluations"; },
    MISSED: function(missedCount: number, totalCount: number) { return "Missed " + missedCount + " of " + totalCount + " Evaluations"; },
    EVALUATE_SUBMISSIONS: function(targetGoal: number) { return "Evaluate " + plural(targetGoal, 0, en, { one: "1 Submission", other: number("en", targetGoal, 0) + " Submissions" }); },
    EVALUATE_MORE_SUBMISSIONS: function(remainingCount: number, submittedCount: number) { return "Evaluate " + remainingCount + " More Submissions (" + submittedCount + " evaluated)"; },
    EVALUATE_ONE_MORE_SUBMISSION: function(submittedCount: number) { return "Evaluate 1 More Submission (" + submittedCount + " evaluated)"; },
    EVALUATED_SUBMISSIONS: function(submittedCount: number) { return "Evaluated " + plural(submittedCount, 0, en, { one: "1 Submission", other: number("en", submittedCount, 0) + " Submissions" }); },
    EVALUATED_SUBMISSIONS_W_REQUIRED: function(submittedCount: number, targetGoal: string) { return "Evaluated " + submittedCount + " Submissions (" + targetGoal + " Required)"; },
    COMMENT_ON_SUBMISSIONS: function(targetGoal: number) { return "Comment on " + plural(targetGoal, 0, en, { one: "1 Submission", other: number("en", targetGoal, 0) + " Submissions" }); },
    COMMENT_ON_MORE_SUBMISSIONS: function(remainingCount: number, submittedCount: number) { return "Comment on " + remainingCount + " More Submissions (commented on " + submittedCount + ")"; },
    COMMENT_ON_ONE_MORE_SUBMISSION: function(submittedCount: number) { return "Comment on 1 More Submission (commented on " + submittedCount + ")"; },
    COMMENTED_SUBMISSIONS: function(submittedCount: number) { return "Commented on " + plural(submittedCount, 0, en, { one: "1 Submission", other: number("en", submittedCount, 0) + " Submissions" }); },
    COMMENTED_SUBMISSIONS_W_REQUIRED: function(submittedCount: number, targetGoal: string) { return "Commented on " + submittedCount + " Submissions (" + targetGoal + " Required)"; },
    NO_MORE_SUBMISSIONS: function() { return "There are no submissions to evaluate at this point."; },
    DEADLINE_PASSED: function() { return "The deadline for this activity has passed."; },
    NONE_RECEIVED: function() { return "You have not received any evaluations yet."; },
    NO_FEEDBACK_RECEIVED: function() { return "You have not received any feedback yet."; },
    NO_MORE_SUBMISSIIONS: function() { return "There are no more submissions to evaluate."; },
    START: function() { return "Start a New Evaluation"; },
    REVISE: function() { return "Revise Evaluation"; },
    RESUME: function() { return "Resume"; },
    RESUME_AND_REVISE: function() { return "Resume or Revise"; },
    EVALUATE: function() { return "Evaluate"; },
    YOUR_SUBMISSION: function() { return "Your Submission"; },
    FEEDBACK: function() { return "Feedback"; },
    VIEW_OVERALL_SCORE: function() { return "View Overall Score"; },
    VIEW_DETAILED_OVERALL_SCORE: function() { return "View Detailed Overall Score"; },
    VIEW_EVALS: function() { return "View Evaluations"; },
    VIEW_EVAL: function() { return "View Evaluation"; },
    VIEW_FEEDBACK: function() { return "View Feedback"; },
    WILL_RECEIVE_FEEDBACK_TEACHING_TEAM: function() { return "You will receive feedback from the teaching team. See evaluation criteria in the rubric below."; },
    WILL_RECEIVE_FEEDBACK_LEARNER: function(startDate: string) { return "You will receive feedback from peers starting on " + startDate + ". See evaluation criteria in the rubric below."; },
    CRITERIA_HEADER: function() { return "Evaluation Rubric"; },
    DRAFT: function() { return "Draft"; },
    FEEDBACK_GRID: {
      TITLE: function() { return "Feedback Capture Grid"; },
      WHAT_WORKED: function() { return "What worked?"; },
      IMPROVEMENTS: function() { return "What could be improved?"; },
      QUESTIONS: function() { return "What was unclear?"; },
      IDEAS: function() { return "What other ideas should be considered?"; },
    },

    EVALUATIONS_FOOTER: {
      VIEW_INSTRUCTION: function() { return "View Instructions"; },
      REVISE: function() { return "Revise"; },
      EVALUATE: function() { return "Evaluate"; },
      BACK_TO_TOP: function() { return "Back to Top"; },
    },

    EVALUATE_INDEX: function(index: string, total: string) { return "Evaluate " + index + " of " + total; },
    EVALUATING_INDEX: function(index: string) { return "Evaluating Submission " + index; },
    EVALUATION_INDEX: function(index: string) { return "Evaluation " + index; },
    RESUME_EVALUATION: function() { return "Resume Evaluation"; },
    REVISE_EVALUATION: function() { return "Revise Evaluation"; },
    EVALUATE_SUBMISSION: function() { return "Evaluate Submission"; },
    EVALUATION_FORM: function() { return "Evaluation Form"; },
    SCORE_CHANGE_WARNING: function() { return "Scores are subject to change until the peer evaluation period ends."; },
    OVERALL_SCORE: function() { return "Overall Score"; },
    OVERALL_SCORE_DETAILED: function() { return "Overall Score Detailed View"; },
    ADMIN_ONLY: function() { return "Admin Only"; },
    OVERALL_SCORES: function() { return "Overall Scores"; },
    FEEBACK_INDEX: function(index: string, total: string) { return "Evaluation " + index + " of " + total; },
    FEEBACK_COUNT: function(count: number) { return plural(count, 0, en, { one: "1 Evaluation", other: number("en", count, 0) + " Evaluations" }); },
    FEEBACK_HELPFUL_QUESTION: function() { return "Was this feedback helpful?"; },
    FEEDBACK_MARKED_HELPFULL: function() { return "Your review was marked as helpful!"; },
    FEEDBACK_MARKED_NOT_HELPFULL: function() { return "Your review was marked as not helpful!"; },
    SEE_RUBRIC: function() { return "See Rubric"; },
    SUBMITTED_SUCCESSFULLY: function() { return "Your evaluation has been submitted successfully!"; },
    VIEW_YOUR_EVALUATION: function() { return "View Your Evaluation"; },
    EVALUATIONS_RECIEVED: function(count: number) { return plural(count, 0, en, { one: "1 Evaluation", other: number("en", count, 0) + " Evaluations" }) + " Received!"; },
    VIEW_STATUS: function(teachingTeamDowncasedSingularized: string) { return "Viewable only to you and the " + teachingTeamDowncasedSingularized + "."; },
    GRADED_TOOLTIP: function() { return "We will not show the score you give as part of your feedback. The submitter will only see an aggregate score calculated from all evaluators."; },
    LEAVING_FEEDBACK: function() { return "Leaving Feedback"; },
    FIRST_COMMENT_ON_SUBMISSION: function(assignmentName: string) { return "Your first comment on this submission will be considered as feedback provided in response to \"Submission Feedback for: " + assignmentName + "\" "; },
    SEE_INSTRUCTIONS_HERE: function() { return "See instructions here >>"; },
    PRIVATE_AND_SHARING_ALLOWED_MESSAGE: function(d) { return "Your comments will only be visible to the " + d.teachingTeamAlias + ", yourself, or " + d.teamAlias + "/" + d.groupAlias + " members with whom you share the submission as it is designed to be private to the " + d.teachingTeamAlias + " only."; },
    PRIVATE_AND_SHARING_NOT_ALLOWED_MESSAGE: function(d) { return "Your comments will only be visible to " + d.teachingTeamAlias + ", yourself or your " + d.teamAlias + " members as this submission is designed to be shared with the " + d.teachingTeamAlias + " only."; },
    PRIVATE_AND_SHARABLE_MESSAGE: function(d) { return "Your comments will only be visible to the " + d.teachingTeamAlias + ", yourself, or " + d.teamAlias + "/" + d.groupAlias + " members with whom you share the submission. Change your submission privacy setting from the settings menu to share more broadly."; },
    PRIVACY_TITLE: function() { return "Please Note"; },
  },

  LEARNER_DIRECTORY: {
    HEADER: function() { return "Learners"; },
    NUM_TEAM_MEMBERS: function(number: string) { return number + " " + plural(number, 0, en, { one: " member ", other: " members " }); },
    FILTER_MY_TEAM_AND_GROUP: function(groupTerm: string, teamTerm: string) { return "My " + teamTerm + " and " + groupTerm + " members"; },
    FILTER_MY_TEAM: function(teamTerm: string) { return "My " + teamTerm + " members"; },
    FILTER_MY_GROUP: function(groupTerm: string) { return "My " + groupTerm + " members"; },
    FILTER_ALL_LEARNERS: function(learnersTermPlural: string) { return "All " + learnersTermPlural; },
    FILTER_NO_TEAM: function(learnersTermPlural: string, teamTerm: string) { return learnersTermPlural + " with no " + teamTerm; },
    LOADING_SEARCHABLES: function(searchables: string) { return "Loading " + searchables; },
    SEARCH_SEARCHABLES: function(searchables: string) { return "Search " + searchables; },
    PEOPLE_NEAR_YOU: function() { return "People Near You"; },
    ALL_FILTERS: function() { return "All Filters"; },
    FEWER_FILTER: function() { return "Fewer Filters"; },
    SEARCH_ICON_SCREEN_READ_ONLY: function() { return "Open search bar"; },
    CLOSE_ICON_SCREEN_READ_ONLY: function() { return "Close search bar"; },
    SEARCH_SCREEN_READ_ONLY: function() { return "Search"; },
    SEARCH_LABEL_READ_ONLY: function() { return "Type search query"; },
  },

  TEACHING_TEAM_DIRECTORY: {
    HEADER: function() { return "Teaching Team Directory"; },
    FILTER_ALL_TEACHING_TEAM: function(teachingTeamTerm: string) { return "All " + teachingTeamTerm; },
  },

  TEAM_DIRECTORY: {
    HEADER: function() { return "Teams"; },
    FILTER_ALL: function(teamsTerm: string) { return "All " + teamsTerm; },
    FILTER_ACCEPTING_MEMBERS: function(teamsTermCapitalPlural: string) { return teamsTermCapitalPlural + " accepting membership requests"; },
    NEAR_YOU: function(teamsTerm: string) { return teamsTerm + " Near You"; },
    SUBMISSIONS: function() { return "Submissions"; },
  },

  GROUP_DIRECTORY: {
    HEADER: function() { return "Groups"; },
    FILTER_ALL: function(groupsTerm: string) { return "All " + groupsTerm; },
    GROUPS_YOU_CAN_JOIN: function(groupsTermCapitalPlural: string) { return groupsTermCapitalPlural + " you can join"; },
    EMPTY: function() { return "The Directory is empty!"; },
    CHECK_BACK_LATER: function() { return "Check back later"; },
    CREATE_NEW_GROUP: function(d) { return "Create New " + d.groupAlias; },
    BE_FIRST_TO_CREATE_A_GROUP: function(d) { return "Be the first to create your " + d.groupAlias + "!"; },
    ACTIVE_TIME: function(time: string) { return "Active " + time; },
  },

  TEAMS: {
    JOIN_OR_FORM_TEAM: function(d) { return "Create or Join an existing " + d.teamAlias; },
    JOINED_A_TEAM: function(d) { return "Joined a " + d.TeamAlias; },
    CREATED_A_TEAM: function(d) { return "Created a " + d.TeamAlias; },
    VISIT_A_TEAM_PROFILE: function(d) { return "View " + d.TeamAlias + " Profile"; },
    TEAM_NOT_EXISTS_ERROR: function() { return "You don't have access to this page."; },
    CREATE_FROM: {
      NAME: function(type: string) { return type + " Name"; },
      TAGLINE: function() { return "Tagline"; },
    },

    PROFILE: {
      MY_TEAM_WORKSPACE: function(wordForTeamSingularizedTitleized: string) { return "My " + wordForTeamSingularizedTitleized + " Workspace"; },
      MY_GROUP_SPACE: function(wordForTeamSingularizedTitleized: string) { return "My " + wordForTeamSingularizedTitleized + " Space"; },
      VIEW_TEAM_WORKSPACE: function(d) { return "View " + d.TeamAlias + " Workspace"; },
      VIEW_GROUP_SPACE: function(d) { return "View " + d.GroupAlias + " Workspace"; },
      ADMIN: function() { return "Admin"; },
      ADMIN_OPTIONS: {
        ADD_MEMBER: function() { return "Add Member"; },
        CONTACT_TEAM: function(nameForTeam: string) { return "Contact " + nameForTeam; },
        DELETE_TEAM: function(nameForTeam: string) { return "Delete this " + nameForTeam; },
        ENABLE_PROGRESS_DASHBOARD: function(nameForTeam: string) { return "Enable " + nameForTeam + " Progress Dashboard"; },
        DISABLE_PROGRESS_DASHBOARD: function(nameForTeam: string) { return "Disable " + nameForTeam + " Progress Dashboard"; },
        ADD_TO_TEAM: function(wordForTeamSingularizedTitleized: string) { return "Add to " + wordForTeamSingularizedTitleized; },
        DELETE_TEAM_CONFIRMATION: function(wordForTeamDowncasedSingularized: string) { return "Are you sure you want to delete this " + wordForTeamDowncasedSingularized + "? Deleting will remove all posts, documents, and meetings in the workspace."; },
        DELETE_TEAM_SUCCESS: function(teamName: string) { return teamName + " has been deleted."; },
        TYPE_NAMES_HERE: function() { return "Type in names here..."; },
        GRANT_LATE_SUBMISSION_PERMIT: function() { return "Grant Late Submission Permit"; },
      },

      MEMBERSHIP_REQUEST: {
        REQUEST_TO_JOIN: function() { return "Request to Join"; },
        REQUESTED_TO_JOIN: function() { return "Requested to Join"; },
        REQUEST_SENT_ON: function(sent: string) { return "Request sent on " + sent; },
        VIEW_REQUEST: function() { return "View Request"; },
        WITHDRAW_REQUEST: function() { return "Withdraw Request"; },
        WITHDRAW_REQUEST_CONFIRMATION: function(teamName: string) { return "Are you sure you want to withdraw your request to join " + teamName + "?"; },
        REQUEST_PENDING: function(wordForTeamDowncasedSingularized: string) { return "Your membership request is pending approval from the " + wordForTeamDowncasedSingularized + " lead."; },
        INVITATION_PENDING: function(wordForTeamDowncasedSingularized: string) { return "You have already been invited to join this " + wordForTeamDowncasedSingularized + "."; },
        TEAM_FULL: function(wordForTeamDowncasedSingularized: string) { return "This " + wordForTeamDowncasedSingularized + " is already full, please find a different " + wordForTeamDowncasedSingularized + " to join."; },
        ALREADY_JOINED_TEAM: function(teamName: string, wordForTeamDowncasedSingularized: string) { return "You cannot join this " + wordForTeamDowncasedSingularized + " because you are already a member of " + teamName + "."; },
        JOIN_GROUP: function(wordForTeamSingularizedTitleized: string) { return "Join This " + wordForTeamSingularizedTitleized; },
        GROUP_REQUEST_PENDING: function(wordForTeamDowncasedSingularized: string) { return "Your join request is pending approval from the " + wordForTeamDowncasedSingularized + " admins."; },
        GROUP_INVITATION_PENDING: function(wordForTeamDowncasedSingularized: string) { return "You have already been invited to join this " + wordForTeamDowncasedSingularized + "."; },
        PERSONAL_MESSAGE_PLACEHOLDER: function(wordForTeamDowncasedSingularized: string) { return "Please write a personal message to the " + wordForTeamDowncasedSingularized + " leader explaining why you are a good fit."; },
      },

      LEAVE_TEAM: {
        TITLE: function(wordForTeamSingularizedTitleized: string) { return "Leave " + wordForTeamSingularizedTitleized; },
        SUBMISSION_ATTRIBUTION_PROMPT: function(teamName: string, wordForTeamDowncasedSingularized: string) { return "You have submitted with your " + wordForTeamDowncasedSingularized + " " + teamName + ". What do you want to do with your submission credit?"; },
        KEEP_CREDIT: function(wordForTeamDowncasedSingularized: string) { return "I would like to keep the credit I received submitting with this " + wordForTeamDowncasedSingularized; },
        LEAVE_CREDIT: function(wordForTeamDowncasedSingularized: string) { return "I would like to submit with my new " + wordForTeamDowncasedSingularized; },
        CONFIRMATION_PROMPT: function(teamName: string, wordForTeamDowncasedSingularized: string) { return "Are you sure you want to leave your " + wordForTeamDowncasedSingularized + " " + teamName + "?"; },
      },

      ACTIVITY: {
        TITLE: function() { return "Activity"; },
        SUBMITTED_TOGETHER: function() { return "Submitted together"; },
        NUM_COMMENTS_RECEIVED: function(numComments: string) { return numComments + " " + plural(numComments, 0, en, { one: " comment ", other: " comments " }) + " received"; },
        POSTS_IN_SPACE: function(numPosts: number) { return plural(numPosts, 0, en, { one: " Message ", other: " Messages " }) + " to each other"; },
        NUM_RECENT_POSTS: function(numPosts: string) { return numPosts + " sent in last 48 hours"; },
        DOCUMENTS_SHARED: function(numDocuments: number) { return plural(numDocuments, 0, en, { one: " Document ", other: " Documents " }) + " shared"; },
        NUM_RECENT_DOCUMENTS: function(numDocuments: string) { return numDocuments + " shared in last 48 hours"; },
        SCHEDULED_MEETINGS: function(numScheduled: number) { return "Scheduled " + plural(numScheduled, 0, en, { one: " Meeting ", other: "Meetings " }); },
        NUM_RECENTLY_SCHEDULED: function(numScheduled: string) { return numScheduled + " scheduled in last 48 hours"; },
        RECENT_ACTIVITY: function() { return "Recent Activity: "; },
        RECENT_TEAM_ACTIVITY: function(d) { return "Recent " + d.TeamAlias + " Activity: "; },
        RECENT_ACTIVITY_WROTE_TO_EACH_OTHER: function() { return "Wrote to each other"; },
        RECENT_ACTIVITY_CREATED_MEETING: function() { return "Created a meeting"; },
        RECENT_ACTIVITY_UPLOADED_DOCUMENT: function() { return "Uploaded a document"; },
        RECENT_ACTIVITY_SUBMITTED_ASSIGNMENT: function(d) { return "Submitted " + d.teamAlias + " " + d.assignmentAlias; },
        RECENT_ACTIVITY_CREATED_NEW_POST: function() { return "Created a new post"; },
        RECENT_ACTIVITY_SHARED_SUBMISSION: function() { return "Shared a submission"; },
        RECENT_ACTIVITY_COMMENTED_SUBMISSION: function() { return "Commented on a shared submission"; },
        RECENT_ACTIVITY_MADE_COMMENT: function() { return "Made a comment"; },
      },

      TEAM_MEMBERS: {
        TITLE: function(numMembers: number, wordForTeam: string) { return wordForTeam + " " + plural(numMembers, 0, en, { one: " Member ", other: " Members " }); },
        ADD_MEMBER: function() { return "Add Member"; },
        LEAD: function(wordForTeamSingularizedTitleized: string) { return wordForTeamSingularizedTitleized + " Lead"; },
        LEAVE: function(wordForTeamSingularizedTitleized: string) { return "Leave this " + wordForTeamSingularizedTitleized; },
        REMOVE: function(wordForTeamSingularizedTitleized: string) { return "Remove " + wordForTeamSingularizedTitleized + " Member"; },
        MAKE_LEAD: function(wordForTeamSingularizedTitleized: string) { return "Make " + wordForTeamSingularizedTitleized + " Lead"; },
        STEP_DOWN: function() { return "Step Down as Admin"; },
        MAKE_ADMIN: function() { return "Make Admin"; },
        REMOVE_ADMIN: function() { return "Remove Admin"; },
        REMOVE_MEMBER_CONFIRMATION: function(firstName: string, wordForTeam: string) { return "Are you sure you want to remove member " + firstName + " from your " + wordForTeam + "? In doing so they will lose access to your workspace and will not be able to participate in any " + wordForTeam + " discussions or work."; },
        MAKE_LEAD_CONFIRMATION: function(firstName: string, wordForTeam: string) { return "Are you sure you want to make " + firstName + " the " + wordForTeam + " lead?"; },
        MAKE_LEAD_CONFIRMATION_DESCRIPTION: function(d) { return "In doing so you will be stepping down as the " + d.teamAlias + " lead."; },
        MAKE_GROUP_LEAD_CONFIRMATION: function(firstName: string) { return "Are you sure you want to make " + firstName + " an admin? In doing so they will be able to approve or reject membership requests."; },
        REMOVE_GROUP_LEAD_CONFIRMATION: function(firstName: string) { return "Are you sure you want to remove " + firstName + " as an admin?"; },
        STEP_DOWN_AS_GROUP_ADMIN_CONFIRMATION: function(wordForTeamDowncasedSingularized: string) { return "Are you sure you want to step down as an admin for this " + wordForTeamDowncasedSingularized + "?"; },
      },

      SUBMISSIONS: {
        TITLE: function(numSubmissions: number) { return plural(numSubmissions, 0, en, { one: "Submission", other: "Submissions" }) + " to Explore"; },
      },

      MESSAGE: {
        SUBJECT: function() { return "Subject"; },
        MESSAGE: function() { return "Message"; },
        MESSAGE_SENT: function(wordForTeam: string) { return "Your message has been sent to this " + wordForTeam; },
      },

      TAGLINE: {
        PLACEHOLDER: function() { return "Add a Tagline"; },
      },

    },

    SHOW_ALL: function() { return "Show All"; },
    SHOW_LESS: function() { return "Show Less"; },
    WORKSPACE: {
      VISIT: function(d) { return "Visit " + d.teamAlias + " Workspace"; },
      TEAM_WORKSPACE: function(d) { return d.TeamAlias + " Workspace"; },
      ACCESS_DENIED: function(d) { return "You cannot access this page because you are not a member of this " + d.teamAlias + "."; },
      NUMBER_MEMBERS: function(d) { return d.numberMembers + " " + d.teamAlias + " Members"; },
      CONTRIBUTIONS_TO_TEAM: function(d) { return "Contributions to the " + d.teamAlias + " (" + d.contributionsCount + ")"; },
      DASHBOARD_LABEL: function(d) { return d.teamAlias + " Dashboard"; },
      LOADING_ACTIVITIES: function() { return "Loading: Activities"; },
      ADD_A_MESSAGE: function() { return "Add a message to provide context or state your purpose for sharing"; },
      WRITE_SOMETHING: function() { return "Write something..."; },
      CREATE_NEW_POST: function() { return "Create a New Post"; },
      TEAM: function(d) { return d.teamAlias; },
      EVERYONE: function() { return "everyone"; },
      FILTER_WORKSPACE_POSTS: function() { return "Filter Workspace Posts"; },
      FILTER_OPTIONS: {
        ALL_POSTS: function() { return "All Posts"; },
        MEETINGS: function() { return "Meetings"; },
        SHARED_WORK: function() { return "Shared Work"; },
        UPLOADED_DOCUMENTS: function() { return "Uploaded Documents"; },
        TEAM_DISCUSSIONS: function(d) { return d.TeamAlias + " Discussions"; },
      },

      MEETING: {
        CREATE: function() { return "Create a Meeting"; },
        EDIT: function() { return "Edit Meeting"; },
        TITLE: function() { return "Meeting Title"; },
        GOAL: function() { return "Meeting Goal"; },
        LOCATION: function() { return "Location"; },
        DATE: function() { return "Date"; },
        TIME: function() { return "Time"; },
        MEETING_TIME: function() { return "Meeting Time"; },
        LOCAL_TIME: function() { return "local time"; },
        SCHEDULE: function() { return "Schedule"; },
        OPEN_MEETING_MODAL: function(title: string) { return "See details for " + title + " meeting"; },
        MS_TEAMS: {
          CREATE: function() { return "Add Microsoft Teams Meeting"; },
          EDIT: function() { return "Edit Microsoft Teams Meeting"; },
          TITLE: function() { return "Add Title..."; },
          DESCRIPTION: function() { return "Add description (optional)"; },
          LOCATION: function() { return "This is a Microsoft Team Event"; },
          VIEW: {
            DESCRIPTION: function() { return "Description"; },
            JOIN: function() { return "Join Now"; },
            CONCLUDED: function() { return "Meeting Concluded"; },
          },

          HAS_STARTED: function(eventName: string) { return eventName + " has started, join now!"; },
        },

      },

      RSVP: {
        TITLE: function() { return "RSVP"; },
        WILL_ATTEND: function() { return "I will attend"; },
        NOT_SURE_YET: function() { return "Not sure yet"; },
        CANT_MAKE_IT: function() { return "Sorry can't make it"; },
      },

      SHARE_SUBMISSIONS: {
        SHARE_WORK: function() { return "Share Your Work"; },
        LOADING: function() { return "Loading: Submissions"; },
        NONE_FOUND: function() { return "No Submissions Found"; },
        PICK_ONE: function() { return "Please pick which submission you would like to add to your post:"; },
        NO_LONGER_ACCESSIBLE: function(d) { return "The submission you previously shared is no longer accessible to the " + d.teamAlias + ". Please pick another submission to share:"; },
        SHARE_WITH_TEAM_FOR_FEEDBACK: function(d) { return "Once you have submitted your submission, come back and share it with your " + d.teamAlias + " members for feedback."; },
        PRIVATE_SUBMISSION: function() { return "Private Submission"; },
        ACCESS_RESTRICTED: function() { return "You do not have access to this submission because access has been restricted to teaching team members."; },
        CANNOT_SHARE: function(d) { return "Submission cannot be shared because it is not viewable by your " + d.teamOrGroupAlias + " members"; },
      },

      RHS: {
        PRIVATE: function() { return "Private"; },
        PRIVATE_TOOLTIP: function(d) { return "This is a private workspace for your " + d.teamAlias + " members only."; },
        OPEN_GROUP: function(d) { return "Open " + d.teamAlias; },
        OPEN_GROUP_TOOLTIP: function(d) { return "Anyone can join this " + d.teamAlias + " and access this workspace."; },
        CLOSED_GROUP: function(d) { return "Closed " + d.teamAlias; },
        CLOSED_GROUP_TOOLTIP: function(d) { return "This is a private workspace for your " + d.teamAlias + " members only."; },
        ADMIN_SETTINGS_TOOLTIP: function(d) { return "Go to " + d.teamAlias + " profile to edit membership for " + d.teamAlias; },
        MEMBER_SETTINGS_TOOLTIP: function(d) { return "Go to " + d.teamAlias + " profile to change your membership in this " + d.teamAlias; },
        MEMBERS: function(d) { return d.teamAlias + " " + plural(d.count, 0, en, { one: " Member ", other: " Members " }); },
        TODO: function(d) { return plural(d.count, 0, en, { one: " To-do ", other: " To-dos " }) + " for the " + d.teamAlias; },
        DRAFTS: function(count: number) { return plural(count, 0, en, { one: " Draft ", other: " Drafts " }); },
        SUBMISSIONS: function(d) { return d.teamAlias + " " + plural(d.count, 0, en, { one: " Submission ", other: " Submissions " }); },
        TEAM_PROGRESS: function(d) { return d.teamAlias + " Progress"; },
      },

      NOT_A_TEAM_MEMBER_ERROR: {
        TITLE: function(d) { return d.TeamAlias + " Workspace Not Accessible"; },
        MESSAGE: function(d) { return "You do not have access to this " + d.teamAlias + " workspace because access has been restricted to " + d.teamAlias + " members only."; },
      },

      TEAM_NOT_EXISTS_ERROR: function() { return "You don't have access to this workspace."; },
    },

    TEAM_NAME_PLACEHOLDER: function(d) { return select(d.isGroup, { true: d.GroupAlias, other: d.TeamAlias }) + " Name"; },
    TEAM_DESCRIPTION_PLACEHOLDER: function() { return "Add a Tagline"; },
    MANAGE_TEAM_GROUP: {
      SEARCH_MEMBER: function() { return "Search for member by name, email"; },
      ADD_MEMBERS: function() { return "Add Members"; },
      TEAM_LEAD: function(d) { return select(d.isTeam, { true: d.TeamTitleAlias + " Lead", other: d.GroupTitleAlias + " Admin" }); },
      MEMBER_DROPDOWN_OPTIONS: {
        MAKE_LEAD: function(d) { return "Make " + select(d.isTeam, { true: d.TeamTitleAlias + " Lead", other: d.GroupTitleAlias + " Admin" }); },
        REMOVE_LEAD: function(d) { return "Remove " + select(d.isTeam, { true: d.TeamTitleAlias + " Lead", other: d.GroupTitleAlias + " Admin" }); },
        SUCCESS_MAKE_TEAM_LEAD: function(d) { return d.name + " is the " + select(d.isTeam, { true: d.teamAlias + " lead", other: d.groupAlias + " admin" }) + " now."; },
        SUCCESS_REMOVING_TEAM_LEAD: function(d) { return d.name + " has been removed as " + select(d.isTeam, { true: "the " + d.teamAlias + " lead", other: "a " + d.groupAlias + " admin" }) + "."; },
        SUCCESS_REMOVING_TEAM_MEMBER: function(name: string, team: string) { return name + " has been removed from " + team + "."; },
        MOVE_TO_DIFFERENT_TEAM: function(d) { return "Move to a Different " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }); },
        REMOVE_FROM_DIFFERENT_TEAM: function(d) { return "Remove From " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }); },
      },

      MEMBERS_TABLE: {
        NAME: function() { return "Name"; },
        EMAIL: function() { return "Email"; },
        LAST_WORKSPACE_VISIT: function() { return "Last Workspace Visit"; },
        ACTIONS: function() { return "Actions"; },
      },

      MODAL: {
        ADDING: {
          TITLE: function() { return "Add Members"; },
          DESCRIPTION: function(d) { return "Type in the names or email of the " + d.learnersAlias + " you want to add to this " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + "." + select(d.isTeam, { true: " By adding members from other " + d.teamsAlias + ", they will be removed from their original " + d.teamAlias + ".", other: "" }); },
          CANCEL: function() { return "Cancel"; },
          ADD_TO_TEAM: function(d) { return "Add to " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }); },
          PLACEHOLDER: function() { return "Type in names / email here..."; },
          RESULTS_NOT_FOUND: function() { return "No Results Found"; },
          SUCCESS_ADD_MEMBERS_MESSAGE: function(d) { return d.count + " " + plural(d.count, 0, en, { one: " user was ", other: " users were " }) + " added to the " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + "."; },
        },

        MOVING: {
          TITLE: function(d) { return "Move to " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }); },
          DESCRIPTION: function(d) { return "Move " + d.name + " to a different " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " by searching the " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + "'s name:"; },
          CANCEL: function() { return "Cancel"; },
          MOVE_TO_TEAM: function(d) { return "Add to " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }); },
          PLACEHOLDER: function(d) { return "Search for a " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }) + " by name"; },
          RESULTS_NOT_FOUND: function() { return "No Results Found"; },
          SUCCESS_MOVE_MEMBER_MESSAGE: function(name: string, team: string) { return name + " has been moved to " + team + "."; },
          WARNING_MESSAGE_TITLE: function(name: string, team: string) { return "Are you sure you want to move " + name + " to " + team + "?"; },
          WARNING_MESSAGE_DESCRIPTION: function(name: string, originalTeam: string, team: string) { return "In doing so, " + name + " will be removed from " + originalTeam + " and added to " + team + " as a member."; },
        },

        REMOVING: {
          TITLE: function(name: string, team: string) { return "Are you sure to remove " + name + " from " + team + "?"; },
          DESCRIPTION: function(d) { return "In doing so they will lose access to your workspace and will not be able to participate in any " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " discussions or work."; },
          CANCEL: function() { return "Cancel"; },
          CONFIRM: function() { return "Yes I'm sure"; },
        },

        REMOVING_LAST_MEMBER: {
          TITLE: function(name: string, team: string) { return "Are you sure to remove " + name + " and Delete " + team + "?"; },
          DESCRIPTION: function(d) { return "On doing so, they will lose access to this workspace and will not be able to participate in any " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " discussion or work. Additionally, this " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " will be deleted. Please select the checkboxes to confirm and proceed."; },
          REMOVE_MEMBER: function(name: string) { return "Remove " + name; },
          REMOVE_TEAM: function(team: string) { return "Delete " + team; },
        },

      },

    },

  },

  SHARED: {
    OK: function() { return "OK"; },
    OR: function() { return "OR"; },
    YES: function() { return "YES"; },
    NO: function() { return "NO"; },
    CLOSE_WINDOW: function() { return "Close Window"; },
    VIEW_ALL: function() { return "View All"; },
    VIEW_MORE: function() { return "View More"; },
    VIEW_LESS: function() { return "View Less"; },
    COUNT_MORE: function(count: number) { return "+" + count + " More"; },
    TITLE_COLOR_POPOVER: function(color: string) { return "Change Text to " + color; },
    SHOW_ALL: function() { return "Show All"; },
    SHOW_LESS: function() { return "Show Less"; },
    TABS_NAVIGATION_MOBILE: function(count: number, title: string) { return title + " (" + count + ")"; },
    CLEAR: function() { return "Clear"; },
    PREVIOUS: function() { return "Previous"; },
    NEXT: function() { return "Next"; },
    LOG_IN_WITH_SSO: function() { return "Log in with SSO"; },
    ENTER_PASSWORD: function() { return "Enter Password"; },
    SIGNING_WITH_EMAIL: function(email: string) { return "Sign in with " + email; },
    USE_SINGLE_SIGN_ON: function() { return "Use Single Sign On"; },
    ENTER_YOUR_SUB_DOMAIN: function() { return "Enter Your Sub-domain"; },
    DOMAIN: function() { return "Sub-domain"; },
    ENABLED: function() { return "Enabled"; },
    DISABLED: function() { return "Disabled"; },
    ON: function() { return "On"; },
    OFF: function() { return "Off"; },
    USE: function() { return "Use"; },
    MOST_RECENTLY_USED: function() { return "Most Recently Used"; },
    SELECT_SHAPE: function() { return "Select Shape"; },
    SET_BACKGROUND_COLOR: function() { return "Set Background Color"; },
    RESET: function() { return "Reset"; },
    APPLY_FILTERS: function() { return "Apply Filters"; },
    UNLIMITED: function() { return "Unlimited"; },
    DELETE_IMAGE_CONFIRMATION: function() { return "Are you sure you want to delete this image?"; },
    IRRECOVERABLE: function() { return "This will be irrecoverable. There will be no going back."; },
    CORRECT: function() { return "Correct!"; },
    INCORRECT: function() { return "Incorrect!"; },
    GOOD_JOB: function() { return "Good Job!"; },
    GREAT: function() { return "Great!"; },
    CLICK_TO_EXPAND: function(name: string) { return "Click to expand " + name; },
    CLICK_TO_COLLAPSE: function(name: string) { return "Click to collapse " + name; },
    NUMBER_INPUT: {
      ARIA_LABEL: {
        INCREASE_NUMBER: function() { return "Increase Number"; },
        DECREASE_NUMBER: function() { return "Decrease Number"; },
      },

    },

  },

  RECENT_ACTIVITY: {
    ACTIVITY_LABEL: function() { return "Recent activity: "; },
    LECTURE_VIDEO: {
      DAYS_AGO: function(lastUpdated: string) { return "Watched a video about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Watched a video about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Watched a video about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Watched a video less than a minute ago"; },
    },

    LECTURE_AUDIO: {
      DAYS_AGO: function(lastUpdated: string) { return "Listened to an audio about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Listened to an audio about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Listened to an audio about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Listened to an audio less than a minute ago"; },
    },

    DISCUSSION: {
      DAYS_AGO: function(lastUpdated: string) { return "Participated in a discussion about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Participated in a discussion about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Participated in a discussion about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Participated in a discussion less than a minute ago"; },
    },

    SURVEY: {
      DAYS_AGO: function(lastUpdated: string) { return "Completed a survey about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Completed a survey about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Completed a survey about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Completed a survey less than a minute ago"; },
    },

    ASSIGNMENT: {
      DAYS_AGO: function(lastUpdated: string) { return "Worked on a submission about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Worked on on a submission about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Worked on a submission about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Worked on a submission less than a minute ago"; },
    },

    QUIZ: {
      DAYS_AGO: function(lastUpdated: string) { return "Took a Quiz about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Took a Quiz about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Took a Quiz about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Took a Quiz less than a minute ago"; },
    },

    POLL: {
      DAYS_AGO: function(lastUpdated: string) { return "Participated in a poll about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Participated in a poll about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Participated in a poll about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Participated in a poll less than a minute ago"; },
    },

    AI_ROLE_PLAY: {
      DAYS_AGO: function(lastUpdated: string) { return "Participated in an AI roleplay about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Participated in an AI roleplay about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Participated in an AI roleplay about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Participated in an AI roleplay less than a minute ago"; },
    },

    FEEDBACK: {
      DAYS_AGO: function(lastUpdated: string) { return "Provided feedback about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Provided feedback about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Provided feedback about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Provided feedback less than a minute ago"; },
    },

    WORKSPACE: {
      DAYS_AGO: function(lastUpdated: string) { return "Viewed a workspace about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Viewed a workspace about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Viewed a workspace about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Viewed a workspace less than a minute ago"; },
    },

    VIEW: {
      DAYS_AGO: function(lastUpdated: string) { return "Viewed content about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Viewed content about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Viewed content about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Viewed content less than a minute ago"; },
    },

    MENTEES: {
      DAYS_AGO: function(lastUpdated: string) { return "Reviewed progress about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " day ", other: " days " }) + " ago"; },
      HOURS_AGO: function(lastUpdated: string) { return "Reviewed progress about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " hour ", other: " hours " }) + " ago"; },
      MINUTES_AGO: function(lastUpdated: string) { return "Reviewed progress about " + lastUpdated + " " + plural(lastUpdated, 0, en, { one: " minute ", other: " minutes " }) + " ago"; },
      LESS_THAN_MINUTE_AGO: function() { return "Reviewed progress less than a minute ago"; },
    },

  },

  PROFILE: {
    PROFILE_IMAGE: function() { return "Profile image"; },
    HEADER: function() { return "Learner Profile"; },
    LOADING: function() { return "Loading Profile"; },
    FIRST_NAME: function() { return "First Name"; },
    LAST_NAME: function() { return "Last Name"; },
    HEADLINE: function() { return "Add a headline"; },
    BIO: function() { return "Add a short bio of yourself"; },
    BIO_QUESTIONS: {
      LOCATION: function() { return "What's your location?"; },
      EMPLOYER: function() { return "Where do you work?"; },
      JOB_TITLE: function() { return "What's your job title?"; },
      SCHOOL: function() { return "Where did you go to school?"; },
      SCHOOL_PLACEHOLDER: function() { return "e.g. Stanford University, The University of Iowa"; },
      TIME_ZONE: function() { return "Time Zone"; },
    },

    IMPORT_IMAGE_FROM_LINKEDIN: function() { return "Import Your Image from LinkedIn"; },
    LOCATION_PLACEHOLDER: function() { return "Enter your location"; },
    UPLOADING: function() { return "Uploading.."; },
    IMAGE_UPLOAD_TEXT: function() { return "Update Image"; },
    DRAG_AND_DROP_TEXT: function() { return "Drag & drop an image here, or click to select an image."; },
    INVALID_FILE: function() { return "We could not upload your image. Please make sure it is a valid image file that is jpg, jpeg, or png format and under 5MB in size."; },
    METRICS: {
      COMMENTS: function(commentsCount: number) { return commentsCount + " " + plural(commentsCount, 0, en, { one: " comment ", other: " comments " }) + " received"; },
      LIKES: function(likesCount: number) { return likesCount + " " + plural(likesCount, 0, en, { one: " like ", other: " likes " }) + " received"; },
      HELPFUL_REVIEWS: function(helpfulReviewsCount: number) { return helpfulReviewsCount + " marked helpful"; },
    },

    ADMIN_OPTIONS: {
      VIEW_POINTS: function(d) { return "View " + d.pointsAlias; },
      VIEW_PROGRESS: function() { return "View Progress"; },
      UNENROLL: function() { return "Unenroll"; },
      DELETE_ACCOUNT: function() { return "Delete Account"; },
    },

    FB_IMPORT_SUCCESS: function() { return "Your Facebook profile has been imported."; },
    LINKEDIN_IMPORT_SUCCESS: function() { return "Your Linkedin profile has been imported."; },
    SOA_SUCCESS: function(awardee: string, soaCustomname: string) { return awardee + " has been awarded a " + soaCustomname + "."; },
    SOA_ERROR: function(soaCustomname: string) { return "We encountered an error awarding the " + soaCustomname + " to this user. Please try again later."; },
    REVOKE_SUCCESS: function(awardee: string, soaCustomname: string) { return soaCustomname + " for " + awardee + " has been revoked."; },
    REVOKE_ERROR: function(soaCustomname: string) { return "We encountered an error revoking the " + soaCustomname + " to this user. Please try again later."; },
    CONFIRMATION_UNENROLL_MSG: function(name: string) { return "By unenrolling " + name + ", they will be unable to enter the course and will be removed from any teams or groups they are a part of. You can always re-register " + name + " in the registrations dashboard."; },
    CONFIRMATION_DELETE_MSG: function() { return "Deleting this account will clear account private information but will keep data created by this user on the NovoEd Platform. Are you sure?"; },
    UNENROLL_SUCCESS: function(name: string) { return name + " has been unenrolled from the course"; },
    UNENROLL_SUCCESS_ALIAS: function(d) { return d.name + " has been unenrolled from the " + select(d.isJourney, { true: "journey", other: d.courseAlias }); },
    DELETE_SUCCESS: function(name: string) { return name + " has been deleted."; },
    ACCOUNT_UPDATE_SUCCESS: function() { return "The user's details have been successfully updated."; },
    RESET_PASSWORD_SUCCESS: function(newPassword: string) { return "The user's details have been successfully updated. The user's password has been set to " + newPassword + ". Please notify the user of this password and have them change the password after logging in."; },
    SEND_MESSAGE: function() { return "Send Message"; },
    SEND_A_MESSAGE: function() { return "Send a Message"; },
    COURSE_NAME: function(d) { return d.courseAlias + " name"; },
    TO: function() { return "To"; },
    MEMBER_OF: function(name: string) { return name + " is a member of:"; },
    TEAM: function(d) { return d.TeamAlias; },
    ONE_MEMBER: function() { return "1 Member"; },
    SEND_MESSAGE_SUCCESS: function() { return "Your message has been sent."; },
    DISCUSSION_CONTRIBUTIONS: function(discussionsCount: number) { return "Discussion Contributions (" + discussionsCount + ")"; },
    SUBMISSIONS_TO_EXPLORE: function(count: number) { return plural(count, 0, en, { one: " Submission ", other: " Submissions " }) + " to Explore"; },
    ONLY_PUBLIC_SUBMISSIONS: function(d) { return "These are only the submissions the user has chosen to share with the entire " + d.courseAlias; },
    ONLY_PUBLIC_SUBMISSIONS_SHARED_WITH_CLASS: function() { return "These are only the submissions the user has chosen to share with the entire class"; },
    VISIBLE_TO_TEACHING_TEAM_ONLY: function(d) { return "Only the " + d.teachingTeamAlias + " can view these submissions"; },
    PRIVATE_TO_TEACHING_TEAM: function(d) { return "Private to " + d.teachingTeamAlias; },
    COMPLETION_ACTIVITY: {
      REQUIRED_FIELDS_MODAL: {
        TITLE: function() { return "Required Fields Left Blank"; },
        DESCRIPTION: function() { return "This activity will not be marked as complete until all required fields are filled."; },
      },

    },

    RUSSIA_COMPLIANCE_WARNING: function() { return "Users connecting from Russia cannot edit this information for compliance reasons."; },
    PRACTICE_VIDEOS: function(count: number) { return "Practice " + plural(count, 0, en, { one: " Video ", other: " Videos " }); },
    GALLERY_CARD_TITLE: function(practiceNumber: number, scenario: string) { return scenario + " - " + plural(practiceNumber, 0, en, { one: number("en", practiceNumber, 0) + "st", two: number("en", practiceNumber, 0) + "nd", few: number("en", practiceNumber, 0) + "rd", other: number("en", practiceNumber, 0) + "th" }, 1) + " Practice"; },
    NOT_FOUND: {
      TITLE: function() { return "User Profile not Found!"; },
      DESCRIPTION: function() { return "The user has been unenrolled from this course and you can no longer view their profile."; },
      CTA: function() { return "Go to Course Home"; },
    },

  },

  MEMBERSHIPS: {
    ACCEPT: function() { return "Accept"; },
    DECLINE: function() { return "Decline"; },
    REQUESTED_ON: function(date: string) { return "Requested on " + date; },
    RECEIVED_ON: function(date: string) { return "Received on " + date; },
    TEAM: {
      INVITE_TO_JOIN: function(d) { return "Invite to join your " + d.teamAlias; },
      ALREADY_IN_A_TEAM: function(d) { return "Existing " + d.teamAlias + " membership found"; },
      ALREADY_IN_YOUR_TEAM: function(d) { return "Already in your " + d.teamAlias; },
      CANCEL_INVITATION: function(d) { return "Cancel the invitation to join your " + d.teamAlias; },
      CANCEL_INVITATION_CONFIRMATION: function() { return "Are you sure you want to cancel this invitation?"; },
      TEAM_FULL: function(d) { return "Your " + d.teamAlias + " is already full"; },
      INVITED_TO_JOIN: function(teamName: string) { return "You have been invited to join <b>" + teamName + "</b>"; },
      YOU_HAVE_JOINED: function(teamName: string) { return "You have joined <b>" + teamName + "</b>"; },
      NOW_A_MEMBER_OF_TEAM: function(firstName: string, lastName: string, team: string) { return firstName + " " + lastName + " is now a member of " + team; },
      REQUESTING_TO_JOIN_TEAM: function(firstName: string, lastName: string, team: string) { return "<b>" + firstName + " " + lastName + "</b> is requesting to join <b>" + team + "</b>"; },
      NOW_A_MENTOR_OF_TEAM: function(firstName: string, lastName: string, team: string) { return firstName + " " + lastName + " is now mentoring " + team; },
      REQUESTING_TO_MENTOR_TEAM: function(firstName: string, lastName: string, team: string) { return "<b>" + firstName + " " + lastName + "</b> is requesting to mentor <b>" + team + "</b>"; },
      YOU_ARE_MENTORING_TEAM: function(team: string) { return "You are now mentoring " + team; },
      INVITED_TO_MENTOR_TEAM: function(team: string) { return "You have been invited to mentor <b>" + team + "</b>"; },
    },

    GROUP: {
      INVITE_TO_JOIN: function(d) { return "Invite to join your " + d.groupAlias; },
      ALREADY_IN_YOUR_GROUPS: function(d) { return "Already in your " + d.groupAlias; },
      CANCEL_INVITATION: function(d) { return "Cancel the invitation to join your " + d.groupAlias; },
      INVITE_TO_GROUP: function(d) { return "Invite to join " + d.groupAlias + ": " + d.teamName; },
      CANCEL_INVITE_TO_GROUP: function(d) { return "Cancel invitation to join the " + d.groupAlias + ": " + d.teamName; },
    },

  },

  GAMIFICATION: {
    CONGRATULATIONS: function() { return "Congratulations!"; },
    WOW: function() { return "Wow!"; },
    PARTICIPATE: function() { return "Participate"; },
    PARTICIPATED: function() { return "Participated"; },
    LEADERBOARD: function() { return "Leaderboard"; },
    TOO_CLOSE_TO_CALL: function() { return "It's too close to call!"; },
    ME: function() { return "Me"; },
    WORK_ON_EARNING_POINTS: function(d) { return "Work on earning " + d.pointsAlias + " and come back later to view the results."; },
    NO_POINTS_YET: function(d) { return "No " + d.pointsAlias + " yet!"; },
    JUST_EARNED_POINTS: function(d) { return "You just earned " + d.pointsReceived + " " + plural(d.pointsReceived, 0, en, { one: d.pointsAliasSingularized, other: d.pointsAliasPluralized }) + "."; },
    POINT_TOTAL_FOR_QUIZ_NOW: function(d) { return "Your " + d.pointsAlias + " total for this quiz is now " + d.pointsReceived + "."; },
    MADE_IT_TO_LEADERBOARD: function(d) { return "You just earned " + d.scoredPoints + " " + d.pointsAlias + " and made it on the leaderboard!"; },
    RANK_NO: function(rank: string) { return "No. " + rank; },
    POINTS_BELONG_TO: function(d) { return d.name + "'s " + d.pointsAlias; },
    TOTAL_POINTS: function(d) { return "Total " + d.pointsAlias + ": " + d.leaderboardPoints; },
    TOTAL_OUTLINE_POINTS: function(d) { return "Total: " + d.pointsIncludingCredits + " " + plural(d.pointsIncludingCredits, 0, en, { one: d.pointAlias, other: d.pointsAlias }); },
    EVALUATION_COUNT: function(count: number) { return "Evaluation " + count; },
    COURSE_HOME_MODAL: {
      TITLE: function(d) { return "Earning " + d.pointsAlias; },
      DESCRIPTION: function(d) { return "To earn full " + d.pointsAlias + ", complete each activity on time."; },
      DETAILED_DESCRIPTION: function(d) { return d.pointsAlias + " will be halved one week after they become available, and will be be unavailable one week after that."; },
      CLOSE_TEXT: function() { return "Got It!"; },
    },

  },

  POINTS: {
    HEADER: function() { return "Points Breakdown"; },
    X_POINTS_EACH: function(d) { return d.individualPoints + " " + d.pointsAliasPluralized + " each, up to " + d.points + " " + plural(d.points, 0, en, { one: d.pointsAliasSingularized, other: d.pointsAliasPluralized }); },
    X_POINTS: function(d) { return " " + d.points + " " + plural(d.points, 0, en, { one: d.pointsAliasSingularized, other: d.pointsAliasPluralized }); },
    X_POINTS_ASTERIX: function(d) { return d.points + " " + d.pointsAlias + "*"; },
    UP_TO_X_POINTS: function(d) { return "Up to " + d.maxPoints + " " + plural(d.maxPoints, 0, en, { one: d.pointsAliasSingularized, other: d.pointsAliasPluralized }); },
    GET_X_OR_MORE_CORRECT_ANSWERS: function(minCorrect: number) { return "Get at least " + plural(minCorrect, 0, en, { one: " " + number("en", minCorrect, 0) + " correct answer ", other: " " + number("en", minCorrect, 0) + " correct answers" }); },
    GET_X_CORRECT_ANSWERS: function(minCorrect: string) { return "Get " + minCorrect + " correct answers"; },
    NEED_MORE_FOR_POINTS: function(minCorrect: string, numCorrect: string) { return "Answered " + numCorrect + " correct, need " + minCorrect; },
    REQUIRED_MORE_CORRECT_ANSWERS: function(minCorrect: string, numCorrect: string) { return "Answered " + numCorrect + " correct out of " + minCorrect + " needed "; },
    GOT_POINTS: function(includeExclamation: string, maxCorrect: string, numCorrect: string) { return "Answered " + numCorrect + " out of " + maxCorrect + " correct" + select(includeExclamation, { true: "!", other: "" }); },
    MISSED_TO_GET_REQUIRED_POINTS: function(maxCorrect: string, minCorrect: string, numCorrect: string) { return numCorrect + " out of " + maxCorrect + " correct (" + minCorrect + " required to pass)"; },
    ALL_CORRECT: function() { return "All correct!"; },
    SCORE: function(score: string) { return "Score: " + score + "%"; },
    DIFFERENT_SCORE: function(score: string) { return "Answered " + score + " Correct"; },
    EARNED_POINTS: function(d) { return "You earned " + d.points + " " + plural(d.points, 0, en, { one: d.pointsAliasSingularized, other: d.pointsAliasPluralized }); },
    EARNED_POINTS_NOW: function(d) { return "Your earned " + plural(d.points, 0, en, { one: d.pointsAliasSingularized, other: d.pointsAliasPluralized }) + " is now " + d.points; },
    TOTAL_POINTS: function(d) { return "Total " + plural(d.points, 0, en, { one: d.pointsAliasSingularized, other: d.pointsAliasPluralized }) + ": " + d.points; },
    OTHER: function(d) { return "Up to " + d.maxPoints + " " + plural(d.maxPoints, 0, en, { one: d.pointsAliasSingularized, other: d.pointsAliasPluralized }); },
  },

  TIME_ESTIMATES: {
    ADD: function() { return "Add Time Estimate"; },
    ADD_POPOVER: function() { return "Click to Add Time Estimate"; },
    EFFORT_MEASURE: {
      MIN: function() { return "Min"; },
      HOUR: function() { return "Hour"; },
      DAY: function() { return "Day"; },
    },

    EFFORT_TYPE: {
      READ: function() { return "Read"; },
      WATCH: function() { return "Watch"; },
      WORK: function() { return "Work"; },
      LISTEN: function() { return "Listen"; },
    },

    MIN_WORK: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 min", other: number("en", estimatedEffort, 0) + " mins" }) + " of work"; },
    HOUR_WORK: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 hour", other: number("en", estimatedEffort, 0) + " hours" }) + " of work"; },
    DAY_WORK: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 day", other: number("en", estimatedEffort, 0) + " days" }) + " of work"; },
    MIN_READ: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 min", other: number("en", estimatedEffort, 0) + " mins" }) + " read"; },
    HOUR_READ: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 hour", other: number("en", estimatedEffort, 0) + " hours" }) + " read"; },
    DAY_READ: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 day", other: number("en", estimatedEffort, 0) + " days" }) + " read"; },
    MIN_WATCH: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 min", other: number("en", estimatedEffort, 0) + " mins" }) + " watch"; },
    HOUR_WATCH: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 hour", other: number("en", estimatedEffort, 0) + " hours" }) + " watch"; },
    DAY_WATCH: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 day", other: number("en", estimatedEffort, 0) + " days" }) + " watch"; },
    MIN_LISTEN: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 min", other: number("en", estimatedEffort, 0) + " mins" }) + " listen"; },
    HOUR_LISTEN: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 hour", other: number("en", estimatedEffort, 0) + " hours" }) + " listen"; },
    DAY_LISTEN: function(estimatedEffort: number) { return plural(estimatedEffort, 0, en, { one: "1 day", other: number("en", estimatedEffort, 0) + " days" }) + " listen"; },
  },

  SUBMISSIONS: {
    GALLERY_IS_EMPTY: function() { return "The gallery is empty!"; },
    SEE_MORE_IN_SUBMISSIONS_GALLERY: function() { return "See More in the Submission Gallery"; },
    TITLE: function() { return "Submissions"; },
    NO_MORE_SUBMISSIONS: function() { return "No More Submissions. Come back later."; },
    TRENDING_SUBMISSIONS: function() { return "Trending submissions"; },
    SEE_TRENDING_SUBMISSIONS: function() { return "See trending submissions"; },
    CHECK_BACK_LATER_TO_BROWSE_SUBMISSIONS: function() { return "Check back later to browse submissions."; },
    VIEW_ASSIGNMENT: function(d) { return "View " + d.AssignmentAlias; },
    SEE_INSTRUCTIONS: function() { return "See Instructions"; },
    LOADING_SUBMISSION: function() { return "Loading Submission"; },
    SORTING: function() { return "Sorting"; },
    FILTER_ASSIGNMENT: function() { return "Filter By Assignment"; },
    FILTER_ACTIVITY: function() { return "Filter by My Activity"; },
    AI_ASSIGNMENT: {
      TITLE: function() { return "AI Feedback Assistant"; },
      TITLE_INSIGHT: function() { return "AI Insights"; },
      TAG_TOOLTIP: function(d) { return "AI feedback is visible only to admins and advisors. It is intended to assist with providing feedback and is not visible to " + d.learnerAlias + "."; },
      TAG_TOOLTIP_LEARNER: function(d) { return "This AI insight is only visible to the submission owner(s) and " + d.teachingTeamAlias + ", including learning advisors."; },
      TAG: function() { return "Admin and Advisors Only"; },
      TAG_LEARNER: function(d) { return "Only visible to submission owner and " + d.teachingTeamAlias; },
      FEEDBACK: function() { return "Feedback"; },
      SUGGESTED_FEEDBACK: function() { return "Draft Feedback"; },
      IMPROVED: function() { return "What can be improved"; },
      WORKED: function() { return "What worked"; },
      DID_WELL: function() { return "What You Did Well"; },
      CAN_GROW: function() { return "Where You Can Grow"; },
      OVERALL: function() { return "Overall"; },
      COPY: function() { return "Copy"; },
      COPIED: function() { return "Copied!"; },
      GENERATING: function() { return "Generating..."; },
      LACK_OF_COURSE_CONTENT: function() { return "Unable to generate feedback due to insufficient course content prior to the assignment."; },
      LACK_OF_CONTENT: function() { return "Unable to generate due to lack of submission content or unsupported input."; },
      AI_INSIGHT: {
        LACK_OF_CONTENT: function() { return "We can't generate AI Insights due to lack of content. Submissions should have at least 100 words to receive AI Insights."; },
        INVALID_TYPE: function() { return "We can't generate AI Insights for this submission as the input type is not supported."; },
      },

      UNABLE_TO_GENERATE: function() { return "Unable to generate due to internal error. Please reload the submission or try again later."; },
      BOTTOM_NOTE: function() { return "Note"; },
      EXCEL_BOTTOM_NOTE: function() { return "Excel Inputs are not supported and were not included in generating this feedback."; },
      REVISE_SUBMISSION: function() { return "Revise this submission?"; },
      RATING: {
        GOOD: function() { return "👍️ Good Job"; },
        AMAZING: function() { return "🏆️ Excellent"; },
        NEEDS_IMPROVEMENT: function() { return "🔄️ Needs Work"; },
        MEETS_EXPECTATIONS: function() { return "Shows self-awareness but lacks depth and specificity required for the assignment."; },
        EXCEEDS_EXPECTATIONS: function() { return "Great work meeting all expectations and beyond!"; },
        NEEDS_IMPROVEMENT_DESC: function() { return "Lacks depth and specificity required for the assignment."; },
      },

    },

  },

  SUBMISSION_APPROVAL: {
    SUBMISSION_APPROVAL: function() { return "Submission Approval"; },
    SUBMISSION_APPROVAL_STATUS: function() { return "Submission Approval"; },
    ENABLED_DISABLED: function(isEnabled: string) { return "(" + select(isEnabled, { true: "Enabled", other: "Disabled" }) + ")"; },
    ENABLE_MODAL: {
      DESCRIPTION: function(d) { return "Enabling " + d.assignmentAlias + " submission approval provides a formal process to both assess the quality of submissions and provide a workflow to send back for revision before granting credit for completion and awarding " + d.pointsAlias + "."; },
      HARD_DEADLINE_HEADER: function(d) { return "<b>Please note</b> that if your " + d.assignmentAlias + " has a hard deadline:"; },
      HARD_DEADLINE_BLURB: function(d) { return "Submissions may still be approved or rejected after the hard deadline, however if rejected the " + d.learnerAlias + " will not be able to revise and resubmit after the hard deadline unless an extension is granted. Please remind your " + d.learnersAlias + " to submit the " + d.assignmentAlias + " with enough of time left for potential revisions if rejected so that they earn credit."; },
      ENABLE: function(d) { return "Enable " + d.AssignmentAlias + " Submissions Approval"; },
      ENABLED_DISABLED: function(d) { return "(Submission approval cannot be " + select(d.isEnabled, { true: "disabled", other: "enabled" }) + " on a released " + d.lectureAlias + ".)"; },
      DISABLE_RELEASED: function(d) { return "Disabling Submission Approval on a released " + d.AssignmentAlias + " will remove all approval data including comments and status, and all submitted " + d.AssignmentsAlias + " will be marked as completed, even submissions that were sent back for revision."; },
      SELECT_ROLE_INSTRUCTION: function(d) { return d.CourseAlias + " Roles that can approve submissions:"; },
      SELECT: function() { return "Select"; },
      ROLE_APPROVE_ALL_SUBMISSIONS: function() { return "Roles that can approve all submissions:"; },
      ROLE_APPROVE_SPECIFIC_SUBMISSIONS: function(d) { return "Roles that can only approve  submissions from assigned " + d.learnersAlias + ":"; },
      MENTOR: function() { return "Mentor"; },
    },

    ENABLE_ERROR: {
      HEADER: function() { return "Can't Enable Submission Approval"; },
      MULTIPLE_SUBMISSION_DESCRIPTION: function(d) { return "This " + d.assignmentAlias + " allows multiple submissions. To enable submission approval, please change this " + d.assignmentAlias + " to only allow one submission."; },
      RELEASED_DESCRIPTION: function(d) { return "Submission approval cannot be enabled on a released " + d.lectureAlias + "."; },
    },

    TAB: {
      SUBMISSIONS_ONLY: function(count: number) { return plural(count, 0, en, { one: number("en", count, 0) + " Submission Needs", other: number("en", count, 0) + " Submissions  Need" }) + " Approval"; },
      SUBMISSIONS_FROM_COURSES: function(count: number, coursesCount: number) { return plural(count, 0, en, { one: number("en", count, 0) + " Submission", other: number("en", count, 0) + " Submissions" }) + " from " + plural(coursesCount, 0, en, { one: "Course Needs", other: "Courses  Need" }) + " Approval"; },
    },

    PENDING: {
      DAYS: function(count: number) { return "Pending for " + plural(count, 0, en, { one: number("en", count, 0) + " day", other: number("en", count, 0) + " days" }); },
      HOURS: function(count: number) { return "Pending for " + plural(count, 0, en, { one: number("en", count, 0) + " hour", other: number("en", count, 0) + " hours" }); },
      MINUTES: function(count: number) { return "Pending for " + plural(count, 0, en, { one: number("en", count, 0) + " minute", other: number("en", count, 0) + " minutes" }); },
    },

    APPROVAL_PROCESS: {
      SHARE_COMMENT_PLACEHOLDER: function() { return "Share a comment (optional)"; },
      SHARE_TO_OTHERS: function() { return "Share as a submission comment viewable to all who can view approved submission"; },
      REJECTION_DISABLED_TOOLTIP: function() { return "Unable to send back for revision when share as a submission comment option is selected"; },
      REJECT: function() { return "Send Back for Revision"; },
      APPROVE: function() { return "Approve"; },
    },

    REJECTION_COMMENT: function(firstName: string, isOwner: string, lastName: string) { return firstName + " " + lastName + " has sent back " + select(isOwner, { true: "your", other: "this" }) + " submission for revision with following comment:"; },
    REJECTION_NO_COMMENT: function(firstName: string, isOwner: string, lastName: string) { return firstName + " " + lastName + " has sent back " + select(isOwner, { true: "your", other: "this" }) + " submission for revision."; },
    APPROVAL_COMMENT: function(firstName: string, isOwner: string, lastName: string) { return firstName + " " + lastName + " has approved " + select(isOwner, { true: "your", other: "this" }) + " submission with following comment:"; },
    APPROVAL_NO_COMMENT: function(firstName: string, isOwner: string, lastName: string) { return firstName + " " + lastName + " has approved " + select(isOwner, { true: "your", other: "this" }) + " submission."; },
    SUBMISSION_ALERT_SUCCESS: function() { return "Success!"; },
    SUBMISSION_APPROVED_ALERT: function() { return "Submission has been approved!"; },
    SUBMISSION_REJECTED_ALERT: function() { return "Submission has been sent back for revision!"; },
    SUBMISSION_ALERT_FAILURE: function() { return "Oops!"; },
    SUBMISSION_ALREADY_REVIEWED: function() { return "Submission has already been approved or rejected."; },
    SUSMISSION_REVISED: function() { return "Submission has recently been revised. Please review revised submission and try again."; },
    NOT_AVAILABLE: function() { return "Previous submission is not available anymore!"; },
    SUBMISSION_STATUS: {
      APPROVAL_NEEDED: function() { return "Approval Needed"; },
      PENDING: function() { return "Pending Approval"; },
      REJECTED: function() { return "Revision Needed"; },
      REJECTED_PAST: function() { return "Revision was Needed"; },
      APPROVED: function() { return "Approved"; },
    },

    LEARNER_ASSIGNMENT: {
      NEEDS_APPROVAL_DESCRIPTION: function(d) { return "This " + d.assignmentAlias + " requires approval to receive credit for completion and applicable " + d.pointsAlias + ". It may be sent back for revision. After approval, no further revision is allowed."; },
      PENDING_APPROVAL_POINTS: function(d) { return "Your submission is pending approval. You will receive credit for completion and " + d.pointsAlias + " for this submission after it is approved. The reviewer may also send it back for revision."; },
      PENDING_APPROVAL_NO_POINTS: function() { return "Your submission is pending approval. You will receive credit for completion after it is approved. The reviewer may also send it back for revision."; },
      NO_FURTHER_REVISION: function() { return "No revision after submission has been approved."; },
    },

    DASHBOARD: {
      TITLE: function(count: number) { return plural(count, 0, en, { one: number("en", count, 0) + " Submission", other: number("en", count, 0) + " Submissions" }) + " Pending Approval From:"; },
      ALL_COURSES: function() { return "All Courses"; },
      EMPTY: function() { return "No Submission Needs Approval"; },
      EMPTY_LINK: function() { return "Back to Dashboard"; },
      LINK_TO: function() { return "Submissions Pending Approval"; },
    },

    COURSE_HOME: {
      N_NEEDS_APPROVAL: function(courseCount: number, submissionCount: number) { return plural(submissionCount, 0, en, { one: " 1 Submission ", other: " " + number("en", submissionCount, 0) + " Submissions " }) + " " + plural(courseCount, 0, en, { one: "", other: " from " + number("en", courseCount, 0) + " Courses " }) + " " + plural(submissionCount, 0, en, { one: " Needs ", other: " Need " }) + "  Approval"; },
    },

  },

  MENTEES: {
    MY_MENTEES: function(mentees: string) { return "My " + mentees; },
    MY_TEAM_GROUP_MEMBERS: function(d) { return "My " + d.teamAlias + " Members"; },
    LOADING: function() { return "Loading"; },
    NOT_YET: function() { return "Not Yet"; },
    SUBMITTED_COMMENTED: function() { return "Submitted, Commented"; },
    SUBMITTED_EVALUATED: function() { return "Submitted, Evaluated"; },
    SUBMITTED_APPROVED: function() { return "Submitted, Approved"; },
    NEEDS_REVISION: function() { return "Needs Revision"; },
    SUBMITTED_ON: function(submitted: string) { return "Submitted on " + submitted + "."; },
    SEE_MY_MENTEES: function(mentees: string) { return "See My " + mentees; },
    SEE_MY_MENTORS: function(mentors: string) { return "See My " + mentors; },
    SEE_MY_MENTORS_AND: function(mentorsOne: string, mentorsTwo: string) { return "See My " + mentorsOne + " and " + mentorsTwo; },
    SEE_MY_MENTORS_COMMA_AND: function(mentorsOne: string, mentorsThree: string, mentorsTwo: string) { return "See My " + mentorsOne + ", " + mentorsTwo + " and " + mentorsThree; },
    SEE_MY_MENTORS_AND_OTHERS: function(mentorsOne: string, mentorsTwo: string, othersCount: number) { return "See My " + mentorsOne + ", " + mentorsTwo + " and " + othersCount + " others"; },
    EARNED_POINTS: function(d) { return "Earned " + d.PointsAlias + ":"; },
    RANKING: function() { return "Ranking:"; },
    COMPLETED_REQUIRED_ASSIGNMENTS: function(d) { return "Completed Required " + d.AssignmentsAlias + ":"; },
    COMPLETED_TODOS: function() { return "Completed To-dos:"; },
    COMPLETED_REQUIRED_TODOS: function() { return "Completed Required To-dos:"; },
    EARNED_OUT_OF_TOTAL: function(earned: string, total: string) { return earned + " out of " + total; },
    EARNED_OUT_OF_TOTAL_COMPLETED: function(earned: string, total: string) { return earned + " out of " + total + " Completed"; },
    PROGRESS: function() { return "Progress"; },
    ALL: function() { return "All"; },
    SORT: function() { return "Sort"; },
    SORT_BY: {
      STUDENT_A_TO_Z: function(d) { return d.LearnerAlias + " A to Z"; },
      STUDENT_Z_TO_A: function(d) { return d.LearnerAlias + " Z to A"; },
      PROGRESS_BY_ASCENDING: function() { return "Progress Ascending"; },
      PROGRESS_BY_DESCENDING: function() { return "Progress Descending"; },
    },

    FILTER_BY: function(filterName: string) { return "Filter By " + filterName; },
    ALL_ASSIGNMENTS: function(d) { return "All " + d.assignmentNameAlias; },
    TABS: {
      TOTAL: function() { return "Total"; },
      NEEDS_APPROVAL: function() { return "Needs Approval"; },
      NEEDS_PRIVATE_FEEDBACK: function() { return "Needs Evaluation"; },
      NEEDS_COMMENTS: function() { return "Needs Comments"; },
      LOGGED_IN: function() { return "Logged In"; },
      NOT_LOGGED_IN: function() { return "Not Logged In"; },
      COMPLETED: function() { return "Completed"; },
    },

    EMPTY_STATE: {
      MEMBER_TITLEIZED: function() { return "Members"; },
      MEMBER_LOWERCASE: function() { return "members"; },
      NONE_YET: function(d) { return "No " + d.menteeAlias + " Yet"; },
      NONE_NEED_APPROVAL: function(d) { return "None of your " + d.menteeAlias + " need submission approval at this moment"; },
      NONE_NEED_EVALUATION: function(d) { return "None of your " + d.menteeAlias + " has submissions that need your evaluation at this moment"; },
      NONE_NEED_FEEDBACK: function(d) { return "None of your " + d.menteeAlias + " has submissions that need your feedback at this moment"; },
      ALL_LOGGED_IN: function(d) { return "All of your " + d.menteeAlias + " have logged in!"; },
      NONE_LOGGED_IN: function(d) { return "None of your " + d.menteeAlias + " have logged in yet"; },
      NONE_HAVE_COMPLETED: function(d) { return " None of your " + d.menteeAlias + " have completed yet"; },
    },

  },

  INFORMAL_FEEDBACK: {
    SUBMISSION_FEEDBACK_FOR_ASSIGNMENT: function(assignmentName: string) { return "Submission Feedback for assignment: " + assignmentName; },
    SUBMISSION_FEEDBACK: function() { return "Submission Feedback"; },
    FOR_ASSIGNMENT: function(d) { return "For " + d.assignmentNameAlias + ":"; },
    VIEW_IN_LECTURE: function() { return "View in Lecture"; },
    NO_MORE_SUBMISSIONS: function() { return "No More Submissions.<br >Come back later to finish this task."; },
    SUBMISSION_SUCCESS: function() { return "Success! Your comment has been submitted."; },
    ALL_SUBMISSIONS_SUCCESS: function(targetGoal: number) { return "Success! You have evaluated " + plural(targetGoal, 0, en, { one: " the required submission", other: " all " + number("en", targetGoal, 0) + " required submissions" }) + "."; },
  },

  COMPLETION_CRITERIA: {
    CLICK_FOR_DETAILS: function() { return "Click for Details"; },
    CLICK_TO_CLOSE: function() { return "Click to Close Details"; },
    PROGRESS_TOWARDS_SOA: function(certificateName: string) { return "Your progress towards the " + certificateName; },
    PROGRESS_TOWARDS_COURSE_COMPLETION: function() { return "Your Progress Towards Completion"; },
    EARN_POINTS: function(d) { return "Receive " + d.requiredPoints + " " + d.pointsAlias; },
    COMPLETE_ASSIGNMENTS: function(d) { return "Complete total of " + d.requiredAssignmentsCount + " " + plural(d.requiredAssignmentsCount, 0, en, { one: d.assignmentAliasSingularized, other: d.assignmentAliasPluralized }); },
    COMPLETE_REQUIRED_TODOS: function(todosCount: number) { return "Complete total of " + todosCount + " " + plural(todosCount, 0, en, { one: " To-do ", other: " To-dos " }); },
    POINTS: function(d) { return d.requiredPoints + " " + d.pointsAlias; },
    RECEIVED_POINTS_SHORT: function(d) { return d.receivedPoints + " " + d.pointsAlias; },
    REQUIRED_ASSIGNMENTS: function(d) { return d.requiredAssignmentsCount + " " + plural(d.requiredAssignmentsCount, 0, en, { one: d.assignmentAliasSingularized, other: d.assignmentAliasPluralized }); },
    REQUIRED_TODOS: function(todosCount: number) { return todosCount + " Required " + plural(todosCount, 0, en, { one: " To-do ", other: " To-dos " }); },
    VIEW_ALL_TODOS: function() { return "View All To-dos"; },
    X_UNRELEASED_TODOS: function(count: number) { return count + " " + plural(count, 0, en, { one: " to-do ", other: " to-dos " }) + " will be released in the future"; },
    X_UNRELEASED_ASSIGNMENTS: function(d) { return d.count + " " + plural(d.count, 0, en, { one: d.assignmentAliasSingularized, other: d.assignmentAliasPluralized }) + " will be released in the future"; },
    COMPLETE_X_REQUIRED_TODOS: function(todosCount: number) { return "Complete " + todosCount + " required " + plural(todosCount, 0, en, { one: " to-do ", other: " to-dos " }); },
    COMPLETE_X_OUT_OF_Y_ASSIGNMENTS: function(d) { return "Complete " + d.requiredCount + " out of " + d.assignmentCount + " " + d.assignmentNameAlias; },
    ALL_TODOS: function() { return "All To-dos"; },
    ALL_DONE: function() { return "All Done"; },
    FINISHED_ALL_REQUIREMENTS: function(d) { return "You have finished all the requirements for this " + d.courseAlias + "."; },
    RECEIVED_POINTS: function(d) { return "Received " + d.receivedPoints + " of required " + d.requiredPoints + " " + d.pointsAlias + ". Click to see details"; },
    COMPLETED_ASSIGNMENTS: function(d) { return "Completed " + d.completedAssignmentsCount + " of " + d.requiredAssignmentsCount + " required " + plural(d.requiredAssignmentsCount, 0, en, { one: d.assignmentAliasSingularized, other: d.assignmentAliasPluralized }) + ". Click to see details"; },
    COMPLETED_REQUIRED_TODOS: function(completedTodosCount: number, todosCount: number) { return "Completed " + completedTodosCount + " of " + todosCount + " required " + plural(todosCount, 0, en, { one: "to-do", other: "to-dos" }) + ". Click to see details"; },
  },

  ANNOUNCEMENTS: {
    MENU_NAME: function() { return "Announcements"; },
    CREATE_NEW: function() { return "Create New"; },
    TYPE: {
      ANNOUNCEMENT_ONLY: function() { return "Announcement Only"; },
      ANNOUNCEMENT_AND_EMAIL: function() { return "Announcement and Email to Everyone"; },
    },

    FORM: {
      CREATE: function() { return "Create New Announcement"; },
      TITLE: function() { return "Announcement Title"; },
      SCHEDULE_FOR_LATER: function() { return "Schedule for Later"; },
      BODY_PLACEHOLDER: function() { return "Start typing your announcement here..."; },
      PREVIEW: function() { return "Next: Preview Email"; },
      POST: function() { return "Post"; },
      POSTING: function() { return "Posting..."; },
      NOTE_FOR_EXTRA_TERMS: function() { return "Extra terms are enabled. Those who have logged in and accepted them will receive your email."; },
    },

    POST_CONFIRMATION: {
      TITLE: function() { return "Post Announcement"; },
      ANNOUNCEMENT_ONLY: function() { return "You are about to post an announcement to all users. Are you sure?"; },
      ANNOUNCEMENT_AND_EMAIL: function() { return "You are about to post an announcement and send an email to all users. Are you sure?"; },
    },

    PREVIEW_MODAL: {
      TITLE: function() { return "Preview Email"; },
      SUBJECT: function(subject: string) { return "Subject: " + subject; },
      TO: function(count: number) { return "To: All Users (" + plural(count, 0, en, { one: number("en", count, 0) + " recipient", other: number("en", count, 0) + " recipients" }) + ")"; },
      FROM: function(from: string) { return "From: " + from; },
      SCHEDULED_FOR: function(date: string) { return "Scheduled for " + date; },
      BACK: function() { return "Back to Edit"; },
    },

    EDIT: {
      TITLE: function() { return "Edit Announcement"; },
      BODY: function(d) { return "You can edit the announcement in the " + d.courseAlias + ", however the email was already sent and cannot be modified."; },
      CONFIRM: function() { return "Edit Announcement Only"; },
    },

    DELETE: {
      TITLE: function() { return "Delete Announcement"; },
      DESCRIPTION: {
        SCHEDULED_OR_EMAIL_ONLY: function() { return "Are you sure you want to delete this scheduled announcement?"; },
        ANNOUNCEMENT_ALREADY_POSTED: function(d) { return "Are you sure you want to delete the announcement from the " + d.courseAlias + "?"; },
        EMAIL_ALREADY_SENT: function(d) { return "You can delete the announcement from the " + d.courseAlias + ", however the email was already sent and can not be deleted."; },
      },

      DELETE_ANNOUNCEMENT_ONLY: function() { return "Delete Announcement Only"; },
    },

    PREVIOUS_ANNOUNCEMENTS: {
      NONE_YET: function() { return "No Announcements Yet"; },
      TITLE: function() { return "Announcements"; },
      NEW: function() { return "New"; },
      UPDATED: function() { return "Updated"; },
      SCHEDULED: function() { return "Scheduled"; },
      DROPDOWN_OPTIONS: {
        EDIT: function() { return "Edit"; },
        PREVIEW: function() { return "Preview Email"; },
        DELETE: function() { return "Delete"; },
      },

    },

  },

  STATEMENT_OF_ACCOMPLISHMENT: {
    DOWNLOAD_AND_SHARE: {
      MAKE_PUBLIC_DESCRIPTION: function(d) { return "Make your " + d.statementAlias + " public to share on social media?"; },
      SHARE_PUBLICLY: function() { return "Share Publicly"; },
      TITLE: function(d) { return "Share your " + d.statementAlias; },
      ADD_LINKEDIN: function() { return "Add your accomplishment on LinkedIn"; },
      LINKEDIN_INSTRUCTIONS: function(d) { return "Please enter <b>" + d.credentialId + "</b> as your Credential ID. Please refer to the " + d.courseAlias + " instructions to determine your certificate name and certifying organization."; },
      SOCIAL_INSTRUCTIONS: function() { return "Post about your accomplishment on one of these social media sites:"; },
      SHARE_TEXT: function(d) { return d.firstName + "'s " + d.statementAlias; },
    },

    STATEMENT: {
      PASSED_HONORS_CEO: function(d) { return "has successfully completed, serving as " + d.teamAlias + " leader and with distinction, " + select(d.isFree, { true: "a free", other: "an" }) + " online offering of " + d.courseName + " provided by " + d.institutionName + " through NovoEd."; },
      PASSED_CEO: function(d) { return "has successfully completed as " + d.teamAlias + " leader, " + select(d.isFree, { true: "a free", other: "an" }) + " online offering of " + d.courseName + " provided by " + d.institutionName + " through NovoEd."; },
      PASSED_HONORS: function(courseName: string, institutionName: string, isFree: string) { return "has successfully completed and with distinction, " + select(isFree, { true: "a free", other: "an" }) + " online offering of " + courseName + " provided by " + institutionName + " through NovoEd."; },
      PASSED: function(courseName: string, institutionName: string, isFree: string) { return "has successfully completed " + select(isFree, { true: "a free", other: "an" }) + " online offering of " + courseName + " provided by " + institutionName + " through NovoEd."; },
    },

  },

  FLYER: {
    ADMIN_DROPDOWN: {
      EDIT: function() { return "Edit"; },
      COURSE_FLYER: function(d) { return d.courseAlias + " Flyer"; },
      BASICS: function() { return "Basics"; },
      ORG_ADMIN_DASHBOARD: function(orgName: string) { return "Dashboard for " + orgName; },
      DELETE: function(d) { return "Delete " + d.courseAlias; },
    },

    COURSE: {
      INSTRUCTOR: function() { return "Instructor:"; },
      INSTRUCTORS: function() { return "Instructors:"; },
      TIMELINE: {
        START_END_DATES: function(endDate: string, startDate: string) { return startDate + " - " + endDate; },
        START_DATE: function(isPast: string, startDate: string) { return select(isPast, { true: "Started", other: "Starting" }) + " " + startDate; },
        END_DATE: function(endDate: string, isPast: string) { return select(isPast, { true: "Ended", other: "Ending" }) + " " + endDate; },
        PRICING: {
          PAID_OPEN: function(d) { return "You can take this " + d.courseAlias + " for " + d.price + "."; },
          INSTITUTION_OPEN: function(institutionName: string) { return "Available to " + institutionName + "."; },
          FREE_OPEN: function(d) { return "A free " + d.courseAlias + " from " + d.institutionName + "."; },
          OPTIONALLY_PAID_OPEN: function(d) { return "A free " + d.courseAlias + " from " + d.institutionName + "<br/>You have the opportunity to sign up for a " + d.statementName + " for " + d.price + "."; },
        },

      },

      ACTION: {
        BANNED: function(d) { return "You have been unenrolled by the " + d.teamingTeamAlias + "."; },
        JOIN_AGAIN: function() { return "Join Again"; },
        ENROLL: function() { return "Enroll"; },
        RE_ENROLL: function() { return "Re-enroll"; },
        CANNOT_RE_ENROLL: function(d) { return "You have withdrawn from this " + d.courseAlias + ", the " + d.courseAlias + " has concluded."; },
        ENTER_COURSE: function(d) { return "Enter " + d.courseAlias; },
        NOT_STARTED: function(d) { return "This " + d.courseAlias + " has not yet begun. Come back " + select(d.hasOfficialReleaseDate, { true: "after", other: "later" }) + " " + d.officialReleaseDate + " to access the " + d.courseAlias + "."; },
        FEE_REQUIRED_NOW: function(d) { return d.courseAlias + " fee is due prior to entry."; },
        FEE_REQUIRED_LATER: function(d) { return d.courseAlias + " fee is due by " + d.dueDate + "."; },
        PAY_NOW: function() { return "Pay Now"; },
        ENROLLED_STATUS: function(enrolledStudentsCount: number, enrollmentLimit: string) { return enrolledStudentsCount + "/" + enrollmentLimit + " Enrolled."; },
        REGISTRATION_LIMIT_REACHED: function() { return "This offering has reached it's registration limit."; },
        WAITLIST_PROMPT: function() { return "Please join the waitlist."; },
        JOIN_WAITLIST: function() { return "Join Waitlist"; },
        YOU_JOINED_WAITLIST: function() { return "You are on the waitlist."; },
        ABANDON_WAITLIST: function() { return "(Remove)"; },
        YOU_ARE_WAITLISTED: function() { return "You have been added to the waitlist."; },
        YOU_ARE_REMOVED_FROM_WAITLIST: function() { return "You have been removed from the waitlist."; },
        PRIVATE: function(d) { return "This is a private " + d.courseAlias + "."; },
        ENTITLEMENTS_NO_MATCH: function(d) { return d.CourseAlias + " entitlements do not match. You must be added by the teaching team."; },
        ADD_BY_TEACHING_TEAM: function(d) { return "You must be added by the " + d.teamingTeamAlias + "."; },
        COURSE_ENDED: function(d) { return "This " + d.courseAlias + " has concluded."; },
        REGISTRATION_ENDED: function(d) { return "Registration for this " + d.courseAlias + " has ended."; },
        IDP_SIGN_IN: function(idpName: string) { return "Sign in via " + idpName; },
        UNMET_JOURNEY_REQUIREMENT: function(journeyHomeLink: string, journeyName: string) { return "You have not met the requirements to self-enroll yet. Please complete the required learning prior to this as defined in <a href=" + journeyHomeLink + ">" + journeyName + "</a>"; },
        MANAGE_ACCESS: function() { return "Manage Access"; },
        YOU_NEED_TO_JOIN_COURSE: function() { return "You need to join the course to view content"; },
      },

      COURSE_DESRIPTION: function() { return "Course Description"; },
      MORE_INFORMATION: function() { return "More Information"; },
      THE_INSTRUCTORS: function() { return "The Instructors"; },
      OFFERINGS: {
        COURSE_NAME: function() { return "Course Name"; },
        CATALOG_ID: function() { return "Catalog ID"; },
        RELEASE_DATE: function() { return "Official Release Date"; },
      },

      SHARE: function(courseName: string, free: string, institutionName: string, isProgram: string) { return "I just enrolled in " + courseName + ", a" + select(free, { true: " free", other: "" }) + " " + select(isProgram, { true: "program", other: "course" }) + " on NovoEd offered by " + institutionName + "."; },
    },

    PROGRAM: {
      ENROLL: function() { return "Enroll Now"; },
      ENTER: function() { return "Enter Program"; },
      EDIT_FLYER: function() { return "Edit the Program Flyer Page"; },
    },

    LOGO_ALT: function() { return "Course logo"; },
    BUTTON_ARIA_LABEL: function() { return "Open settings menu"; },
  },

  CUSTOM_DOWNLOADS: {
    DATA_DOWNLOADS: function() { return "Data Downloads"; },
    DATA_DOWNLOADS_DESCRIPTION: function(d) { return "Data Downloads allows defining custom data files for " + d.learnerAlias + ", " + d.teachingTeamAlias + ", advisors, " + d.teamAlias + ", and " + d.groupAlias + "."; },
    DATA_DOWNLOADS_DESCRIPTION_WITHOUT_GROUPS: function(d) { return "Data Downloads allows defining custom data files for " + d.learnerAlias + ", " + d.teachingTeamAlias + ", advisors, " + d.teamAlias + ", and groups."; },
    CONTENT_DOWNLOADS: function() { return "User Generated Content Download"; },
    CONTENT_DOWNLOADS_DESCRIPTION: function(d) { return "User Generated Content Download allow downloading user generated content from Submissions, Evaluation, Feedback, Discussions, and " + d.teamAlias + "/" + d.groupAlias + " Workspace activities."; },
    CONTENT_DOWNLOADS_DESCRIPTION_WITHOUT_GROUPS: function(d) { return "User Generated Content Download allow downloading user generated content from Submissions, Evaluation, Feedback, Discussions, and " + d.teamAlias + "/" + d.groupAlias + " Workspace activities."; },
    COURSE_INSIGHTS: function() { return "Course Insights"; },
    VIEW_DOWNLOADS: function() { return "View Downloads"; },
    CREATE_NEW: function() { return "Create New"; },
    CREATE_NEW_DATA_DOWNLOAD: function() { return "Create a New Data Download"; },
    CREATE_NEW_CONTENT_DOWNLOAD: function() { return "Create a New Download"; },
    DEFINE_WHO: function() { return "Define Who"; },
    DEFINE_WHAT: function() { return "Define What to Show"; },
    NAME_DOWNLOAD: function() { return "Name the Download"; },
    NEW: function() { return "New"; },
    UPDATED: function() { return "Updated"; },
    PREPARING_DOWNLOAD: function() { return "Preparing Download..."; },
    DUPLICATING: function() { return "Duplicating..."; },
    RECEIVE_EMAIL_WHEN_READY: function() { return "You will receive an email when download is ready."; },
    GENERATED_ON: function(date: string) { return "Generated on " + date; },
    FAILED_TO_GENERATE: function() { return "Last Download Failed to Generate"; },
    UPDATE_DATA_DOWNLOAD_TITLE: function() { return "Update Data Download?"; },
    UPDATE_CONFIRMATION_MSG: function() { return "Are you sure you want to update the existing data download settings and lose all the previous versions?"; },
    CREATE_NEW_DOWNLOAD: function() { return "Create a New Download"; },
    UPDATE_DATA_DOWNLOAD: function() { return "Update Data Download"; },
    BACK_TO_EDIT: function() { return "Back to Edit"; },
    NOT_RELEASED: function() { return "(Not Released)"; },
    DISABLED: function() { return "(Disabled)"; },
    CONTENT_DOWNLOAD_ALREADY_CREATED: function() { return "(Content download already created)"; },
    REQUIRED_ACCOUNT_DATA: function() { return "It is required to select an option in the Account Data menu."; },
    DAILY_SFTP: function() { return "Daily SFTP"; },
    SFTP_INFO: function() { return "Edit is disabled when Daily SFTP is enabled to avoid errors."; },
    SFTP_ENABLED: function() { return "Daily SFTP Enabled"; },
    ENABLING: function() { return "Enabling..."; },
    DISABLING: function() { return "Disabling..."; },
    DAILY_REPORT: {
      OPTION_LABEL: function() { return "Daily Report"; },
      MODAL: {
        TITLE: function() { return "Configure Daily Email"; },
        DESCRIPTION: function() { return "Configure daily report to your data download, an email will be send to you after the report is generated."; },
        TIME: function() { return "Report Time (Local Time)"; },
        SELECT_ADMINS: function() { return "Select admins who will be receiving this email"; },
      },

    },

    SETTINGS: function() { return "Settings"; },
    ROLES: {
      LEARNERS: function() { return "Learners"; },
      ADVISORS: function(d) { return d.CourseTitleAlias + " Advisors"; },
      TEACHING_TEAM: function() { return "Teaching Team"; },
      TEAMS: function() { return "Teams"; },
      GROUPS: function() { return "Groups"; },
    },

    ACTIVITIES: {
      SURVEYS: function() { return "Surveys"; },
      ASSIGNMENTS: function() { return "Assignments"; },
      ASSIGNMENT_SKILLS_FEEDBACK: function() { return "Assignment Skills Feedback"; },
      QUIZZES: function() { return "Quizzes"; },
      LECTURE_QUIZZES: function() { return "Lecture Quizzes"; },
      TIMED_EXAM: function() { return "Timed Exams"; },
      LECTURE_DISCUSSIONS: function() { return "Lecture Discussions"; },
      FEEDBACK_TASKS: function() { return "Assignments Feedback"; },
      AUDIO: function() { return "Audio"; },
      VIDEOS: function() { return "Audios & Videos"; },
      POLLS: function() { return "Polls"; },
      THIRD_PARTY_ACTIVITIES: function() { return "Third-party Activities"; },
      LIVE_SESSIONS: function() { return "Live Video Events"; },
      IN_PERSON_EVENTS: function() { return "In-person Events"; },
      PROFILE_COMPLETIONS: function() { return "Profile Completions"; },
      PEER_EVALUATIONS: function() { return "Assignment Feedback"; },
      SELECT_TYPE: function() { return "Activity Type"; },
      SUBMISSIONS: function() { return "Submissions"; },
      GROUP_WORKSPACE_ACTIVITY: function(d) { return d.aliasedGroupName + " Workspace Activity"; },
      TEAM_WORKSPACE_ACTIVITY: function(d) { return d.aliasedTeamName + " Workspace Activity"; },
      GROUP_WORKSPACE_MEETING_ACTIVITY: function(d) { return d.aliasedGroupName + " Workspace Meeting Data"; },
      TEAM_WORKSPACE_MEETING_ACTIVITY: function(d) { return d.aliasedTeamName + " Workspace Meeting Data"; },
      PRACTICE: function() { return "Practice"; },
      PRACTICE_FEEDBACK: function() { return "Practice Feedback"; },
      PRACTICE_SKILLS_FEEDBACK: function() { return "Practice Skills Feedback"; },
      AI_ROLE_PLAYS: function() { return "AI Roleplays"; },
      AI_ROLE_PLAY: function() { return "AI Roleplay"; },
      AI_INSIGHTS_FOR_SUBMISSIONS: function() { return "AI Insights for Submissions"; },
    },

    ONE: function() { return "1"; },
    TWO: function() { return "2"; },
    THREE: function() { return "3"; },
    DUPLICATE: function() { return "Duplicate"; },
    DELETE_DATA_DOWNLOAD: function() { return "Delete Data Download?"; },
    DELETE_CONTENT_DOWNLOAD: function() { return "Delete Content Download?"; },
    DELETE_DATA_REPORT_CONFIRMATION_MSG: function() { return "Are you sure you want to delete this data download and lose all the previous downloads?"; },
    DELETE_CONTENT_REPORT_CONFIRMATION_MSG: function() { return "Are you sure you want to delete this content download?"; },
    ASSIGNMENTS_PARTICIPATION: function(d) { return d.assignmentAlias + " Participation"; },
    NUM_LEARNERS_SUBMITTED_ASSIGNMENTS: function(d) { return "Number of " + d.learnerAlias + " who Submitted each " + d.assignmentAlias; },
    ACTIVITY_IN_DISCUSSIONS: function() { return "Activity in Discussions"; },
    NUM_POSTS_COMMENTS_BY_LEARNERS: function(d) { return "Posts & Comments Created by " + d.learnerAlias; },
    NUM_LEARNERS_COMPLETED_QUIZ: function(d) { return "Number of " + d.learnerAlias + " who Completed each Quiz"; },
    NUM_LEARNERS_COMPLETED_SURVEY: function(d) { return "Number of " + d.learnerAlias + " who Completed each Survey"; },
    DEMOGRAPHICS: function() { return "Demographics"; },
    ALL_PROFILE_QUESTIONS: function() { return "All Profile Questions"; },
    PREVIOUS: function() { return "Previous"; },
    NEXT: function() { return "Next"; },
    GENERATED_AT: function() { return "Generated at"; },
    FAILED: function() { return "Failed"; },
    GENERATE: function() { return "Generate"; },
    GENERATE_DOWNLOAD: function() { return "Generate Download"; },
    GENERATE_LATEST_VERSION: function() { return "Generate Latest Version"; },
    NO_DOWNLOAD_GENERATED: function() { return "No download has been generated"; },
    GENERATING: function() { return "Generating..."; },
    END_DATE_BEFORE_START_DATE: function() { return "End date cannot be before the start date."; },
    DOWNLOAD_CONTENT: function() { return "Download Content"; },
    REFRESH_TO_GET_LATEST_CONTENT: function() { return "Refresh to get the latest content"; },
    BY: function() { return "By"; },
    CREATE_REPORT: {
      INCLUDE_DATA_FROM_LEARNER_PROFILE_AND_PROGRESS: function(d) { return "Include Data from " + d.learnerAlias + " Profile and Progress"; },
      INCLUDE_DATA_FROM_ADVISOR_PROFILE: function(d) { return "Include Data from " + d.CourseTitleAlias + " Advisors Profile"; },
      INCLUDE_DATA_FROM_TEACHING_TEAM_PROFILE: function(d) { return "Include Data from " + d.teachingTeamAlias + " Profile"; },
      LEARNER_ENROLLED: function(d) { return d.learnerAlias + " Enrolled:"; },
      ENROLLMENT_DATE: function() { return "Enrollment Date"; },
      FROM: function() { return "From"; },
      TO: function() { return "To"; },
      ENROLLMENT_STATUS: function() { return "Enrollment Status"; },
      ENROLLMENT_STATUS_TITLE: function() { return "Enrollment Status:"; },
      CHOOSE_BASED_ON_PROFILE_QUESTIONS: function() { return "Choose Based on Profile Questions:"; },
      ACCOUNT_DATA: function() { return "Account Data"; },
      ACCOUNT_DATA_TITLE: function() { return "Account Data:"; },
      ROLE: function() { return "Role"; },
      ROLE_TITLE: function() { return "Role:"; },
      TEAM_TYPES: function(d) { return d.TeamTitleAlias + " Types"; },
      TEAM_TYPES_TITLE: function(d) { return d.TeamTitleAlias + " Types:"; },
      ASSIGNMENT_LONG_TEAMS: function(d) { return "Assignment-long " + d.TeamsAlias; },
      PROFILE_DETAILS: function() { return "Profile Details"; },
      PROFILE_DETAILS_TITLE: function() { return "Profile Details:"; },
      PROGRESS: function() { return "Progress"; },
      PROGRESS_TITLE: function() { return "Progress:"; },
      SOCIAL_ACTIVITY: function() { return "Social Activity"; },
      SOCIAL_ACTIVITY_TITLE: function() { return "Social Activity:"; },
      TEAM_DETAILS: function(d) { return d.alias + " Details"; },
      TEAM_DETAILS_TITLE: function(d) { return d.alias + " Details:"; },
      TEAM_ACTIVITY_DATA: function(d) { return d.alias + " Activity Data"; },
      TEAM_ACTIVITY_DATA_TITLE: function(d) { return d.alias + " Activity Data:"; },
      ASSIGNMENT_SUBMISSION_COMMENTS: function(d) { return d.assignmentAlias + " Submission Comments"; },
      MENTEE_MENTOR_ENGAGEMENT: function(d) { return "Engagement with Assigned " + d.learnersAlias; },
      SUBMISSION_APROVALS: function() { return "Submission Approvals"; },
      INCLUDE_DATA_FROM_ACTIVITIES: function(d) { return "Include Data from " + d.learnerAlias + " Activities"; },
      INCLUDE_DATA_FROM_TEACHING_TEAM_COURSE_ACTIVITIES: function(d) { return "Include Data from " + d.teachingTeamAlias + " Course Activities"; },
      INCLUDE_FROM_TEAM_DATA: function(d) { return "Include from " + d.alias + " Data"; },
      MENTEES: function(d) { return "Assigned " + d.learnersAlias; },
      MENTEE_AND_COURSE_ENGAGEMENT_DATA: function(d) { return "Assigned " + d.learnerAlias + " and " + d.courseAlias + " Engagement Data"; },
      MENTEE_AND_COURSE_ENGAGEMENT_DATA_TITLE: function(d) { return "Assigned " + d.learnerAlias + " and " + d.courseAlias + " Engagement Data:"; },
      NAME_YOUR_DOWNLOAD: function() { return "Name Your Download:"; },
      ALL_SELECTED: function() { return "All Selected"; },
      X_SELECTED: function(count: number) { return count + " Selected"; },
      SELECT: function() { return "Select"; },
      ALL: function() { return "All"; },
      FILTER_BY: function() { return "Filter By:"; },
      DATA_DOWNLOAD_SUCCESS_TITLE: function() { return "Your data download request has been submitted."; },
      CONTENT_DOWNLOAD_SUCCESS_TITLE: function() { return "Your content download request has been submitted."; },
      SUCCESS_MESSAGE: function() { return "You will receive an email when the report is generated.<br /><span style='font-style: italic'><b>Note:</b> The report generation process can take anywhere from a few minutes to a few hours, depending on the volume of learner activity included. If you have concerns about a particular export that you're waiting for, contact the NovoEd Support Team (hello@novoed.com).</span>"; },
    },

    DROPDOWN: {
      ANY_TIME: function() { return "Any Time"; },
      SINCE: function() { return "Since"; },
      BETWEEN: function() { return "Between"; },
      ENROLLED: function() { return "Enrolled"; },
      UNENROLLED: function() { return "Unenrolled"; },
      WITHDRAWN: function() { return "Withdrawn"; },
      REMOVED_BY_TEACHING_TEAM: function(d) { return "Removed By " + d.TeachingTeamTitleAlias; },
      AUDITING: function() { return "Auditing"; },
      HAS_ACCESS: function() { return "Has Content Access?"; },
      NOVOED_USER_ID: function() { return "NovoEd User ID"; },
      EXTERNAL_ID: function() { return "External ID"; },
      USER_EMAIL: function() { return "User's Email"; },
      NAME: function() { return "Name"; },
      ENROLLMENT_DATE: function() { return "Enrollment Date"; },
      UNENROLLMENT_DATE: function() { return "Unenrollment Date"; },
      ACCOUNT_CREATION_DATE: function() { return "Account Creation Date"; },
      ENROLLMENT_STATUS: function() { return "Enrollment Status"; },
      LAST_ACTIVITY_DATE: function() { return "Last Activity Date"; },
      FIRST_VISIT_TO_COURSE_HOME_DATE: function() { return "First Visit To Course Home Date"; },
      CONTENT_ACCESS_END_DATE: function() { return "Content Access End Date"; },
      PAYMENT_STATUS: function() { return "Payment Status"; },
      PROFILE_QUESTIONS: function(d) { return d.CourseAlias + " Profile Questions"; },
      HEADLINE: function() { return "Headline"; },
      BIO: function() { return "Bio"; },
      LOCATION: function() { return "Location"; },
      CUSTOM_ROLE: function() { return "Course Role"; },
      ADVISOR_INFORMATION: function() { return "Advisor Information"; },
      COMPLETION_STATUS: function() { return "Completion Status"; },
      COMPLETED_TODOS: function() { return "No. of Completed To-dos"; },
      PERCENT_OF_LECTURES_VIEWED: function() { return "% of Lectures Viewed"; },
      ASSIGNMENT_TODOS: function() { return "No. of Assignment To-dos Completed"; },
      REQUIRED_TODOS: function() { return "No. of Required To-dos Completed"; },
      LEADERBOARD_RANK: function() { return "Leaderboard Rank"; },
      POINTS_EARNED: function(d) { return d.PointsAlias + " Earned"; },
      DISCUSSION_CONTRIBUTIONS: function() { return "Discussion Contributions"; },
      GROUP_PARTICIPATION: function(d) { return d.GroupAlias + " Participation"; },
      TEAM_PARTICIPATION: function(d) { return d.TeamAlias + " Participation"; },
      SUBMIT_STATUS: function() { return "Submit Status"; },
      SUBMIT_DATE: function() { return "Submit Date"; },
      NUMBER_OF_AI_ROLE_PLAY_ATTEMPTS: function() { return "No. of Attempts"; },
      DURATION_MM_SS: function() { return "Duration of Role-play (MM:SS)"; },
      REVISED_DATE: function() { return "Last Revised Date"; },
      SUBMITTED_AFTER_DEADLINE: function() { return "Submitted After Deadline?"; },
      PRIVACY_LEVEL: function() { return "Privacy Level"; },
      EXTENSION_GRANTED: function() { return "Extension Granted?"; },
      SUBMISSION_COMMENTS_RECEIVED: function() { return "No. of Submission Comments Received"; },
      NO_COMMENTS: function() { return "No. of Approve/Reject Comments"; },
      ASSIGNMENT_SUBMISSION_LINK: function(d) { return d.AssignmentAlias + " Submission link"; },
      SUBMISSION_APPROVAL_STATUS: function() { return "Submission approval status"; },
      SUBMISSION_STATUS_DATE: function() { return "Approve/Reject Date"; },
      SUBMISSION_REVIEWER: function() { return "Approver/Rejecter"; },
      LAST_COMMENT: function() { return "Last Approval Process Comment"; },
      PRIVATE_EVAL_SCORE: function() { return "Private Evaluation Score"; },
      TEAM_NAME: function(d) { return d.TeamAlias + " Name"; },
      TEAM_ID: function(d) { return d.TeamAlias + " ID"; },
      TEAM_DESCRIPTION: function(d) { return d.TeamAlias + " Description"; },
      TEAM_CREATED_DATE: function(d) { return d.TeamAlias + " Created Date"; },
      TEAM_LEAD: function(d) { return d.TeamAlias + " Lead"; },
      COURSE_LONG_OR_ASSIGNMENT_TEAM: function(d) { return "Course-long or Assignment-long " + d.TeamAlias; },
      ASSIGNMENT: function() { return "Assignment"; },
      TEAM_MEMBERS_COUNT: function(d) { return "No. of " + d.TeamAlias + " Members"; },
      TEAM_MEMBER_NAME: function(d) { return d.TeamAlias + " Member Name"; },
      INCLUDE_TEAM_MEMBERS: function(d) { return "Include " + d.TeamAlias + " Members"; },
      DATE_JOINED_TEAM: function(d) { return "Date Joined " + d.TeamAlias; },
      DATE_JOINED_GROUP: function() { return "Date Joined Group"; },
      TEAM_LEAD_STATUS: function(d) { return d.TeamAlias + " Lead Status"; },
      ROLE: function() { return "Role"; },
      GROUP_ADMIN: function() { return "Group Admin?"; },
      SUBMITTED_ANSWERS: function() { return "Submitted Answers"; },
      SUBMISSION_ANSWERS: function() { return "Submission Answers"; },
      NUMBER_OF_CORRECT_ANSWERS: function() { return "No. of Correct Answers"; },
      NUMBER_OF_ATTEMPTS: function() { return "No. of Quiz Attempts"; },
      NUMBER_OF_QUESTION_ATTEMPTS: function() { return "No. of Question Attempts"; },
      PROGRESSIVE_FEEDBACK: function() { return "Hints"; },
      PERCENT_CORRECT: function() { return "% Correct"; },
      COMMENT_STATUS: function() { return "Comment Status"; },
      LATEST_COMMENT_DATE: function() { return "Latest Comment Date"; },
      NUMBER_OF_COMMENTS_MADE: function() { return "No. of Comments Made"; },
      SUCCESS_STATUS: function() { return "Success Status"; },
      STATUS: function() { return "Status"; },
      PERCENTAGE_OF_VIDEO_WATCHED: function() { return "Percentage Watched"; },
      FEEDBACK_COUNT: function() { return "Feedback Count"; },
      HELPFUL_COUNT: function() { return "Helpful Count"; },
      INSTRUCTORS: function() { return "Instructors"; },
      TEACHING_ASSISTANTS: function() { return "Teaching Assistants"; },
      COURSE_LONG_TEAM: function(d) { return "Course-long " + d.TeamAlias; },
      COURSE_LONG_TEAMS: function(d) { return "Course-long " + d.TeamsAlias; },
      GROUP_NAME: function(d) { return d.groupAlias + " Name"; },
      GROUP_ID: function(d) { return d.groupAlias + " ID"; },
      GROUP_DESCRIPTION: function(d) { return d.groupAlias + " Description"; },
      GROUP_CREATED_DATE: function(d) { return d.groupAlias + " Created Date"; },
      GROUP_MEMBERS_COUNT: function(d) { return "No. of " + d.GroupsAlias + " Members"; },
      GROUP_MEMBER_NAME: function(d) { return d.groupAlias + " Member Name"; },
      INCLUDE_GROUP_MEMBERS: function(d) { return "Include " + d.groupAlias + " Members"; },
      SUBMISSIONS: function() { return "Submissions"; },
      POSTS_SHARED: function() { return "Posts Shared"; },
      DOCUMENTS_CREATED: function() { return "Documents Created"; },
      SCHEDULED_MEETINGS: function() { return "Scheduled Meetings"; },
      SUBMISSIONS_SHARED: function() { return "Submissions Shared"; },
      MENTEE_NAME: function(d) { return "Assigned " + d.learnerAlias + " Name"; },
      MENTEE_EMAIL_ADDRESS: function(d) { return "Assigned " + d.learnerAlias + " Email"; },
      MENTEE_ROLE: function(d) { return "Assigned " + d.learnerAlias + " Role"; },
      MENTEE_USER_ID: function(d) { return "Assigned " + d.learnerAlias + " ID"; },
      SUBMISSION_STATUS: function() { return "Submission Status"; },
      NO_OF_COMMENTS: function() { return "No. of Advisor User Comments"; },
      NO_OF_LIKES: function() { return "No. of Likes on Comments"; },
      NO_OF_COMMENTS_BY_MENTOR: function() { return "No. of Submissions Commented on by Advisor User"; },
      TOTAL_MESSAGES_SENT: function() { return "Total Messages Sent Between Users"; },
      TOTAL_DISCUSSION_POSTS: function(d) { return "Total Comment/Replies to Assigned " + d.learnerAlias + " Discussion Posts/Comments"; },
      NO_SUBMITTED_ASSIGNMENTS: function(d) { return "No. of Assignments Submitted by Assigned " + d.learnerAlias; },
      NO_OF_COMMENTS_2: function() { return "No. of Submissions Commented on by Advisor User"; },
      AWARDED_POINTS: function() { return "Extra Point Award Details"; },
      TOTAL_POINTS_AWARDED: function() { return "Total Extra Points Awarded"; },
      MARKED_COMPLETED_ON: function() { return "Marked Completed On"; },
      EXTERNAL_TOOL_COMPLETED_ON: function() { return "External Tool Completed On"; },
      SCORE: function() { return "External Tool Score"; },
      PROFILE_URL: function() { return "Profile URL"; },
      NO_SUBMISSIONS_APPROVED: function() { return "No. of Submissions approved"; },
      NO_SUBMISSIONS_REJECTED: function() { return "No. of Submissions rejected"; },
      TODOS_COMPLETED: function() { return "To-dos Completed"; },
      LIVE_ATTENDANCE_STATUS: function() { return "Live Attendance Status"; },
      RECORDING_WATCHED: function() { return "Recording Watched"; },
      ATTENDANCE_DURATION: function() { return "Attendance Duration"; },
      WEB_LINK_OPENED_ON: function() { return "Web Link Opened On"; },
      ATTENDANCE_STATUS: function() { return "Status"; },
      CHECK_IN_TIME: function() { return "Check In Time"; },
    },

    DETAILS: {
      WHO: function() { return "Who"; },
      WHAT: function() { return "What"; },
      ENROLLED_BETWEEN: function(endDate: string, startDate: string) { return "Between " + startDate + " to " + endDate; },
    },

  },

  ACCOUNT_SETTINGS: {
    ACCOUNT_BASICS_TAB: function() { return "Account Basics"; },
    EMAIL_PREFERENCES_TAB: function() { return "Email Preferences"; },
    LANGUAGE_AND_TIMEZONE_TAB: function() { return "Language and Time Zone"; },
    ACCOUNT_BASICS: {
      MY_INFORMATION: function() { return "My Information"; },
      SSO_EXTERNALLY_MANAGED: function(link: string) { return "Your account is managed externally by your organization and may not be modified here. You may update your information at " + link; },
      SSO_READONLY: function() { return "Your account is managed externally by your organization and may not be modified here."; },
      SSO_NAMEONLY: function(link: string) { return "Your account is managed externally by your organization and you may update your password at " + link; },
      SSO_NAMEONLY_NO_LINK: function() { return "Your account is managed externally by your organization."; },
      EMAIL: function() { return "Email Address"; },
      UPDATE_PASSWORD: function() { return "Update Password"; },
      CURRENT_PASSWORD: function() { return "Current Password"; },
      NOT_VERIFIED: function() { return "This email has not been verified."; },
      RESEND_VERIFICATION: function() { return "Resend verification email"; },
      EMAIL_READONLY: function() { return "Email address may only be modified by your organization."; },
      NAME_AND_EMAIL_READONLY: function() { return "Name and email address may only be modified by your organization."; },
      VERIFICATION_LINK_SENT: function() { return "Verification email sent!"; },
      UPDATE_SUCCESS: function() { return "You have successfully updated your account."; },
      CURRENT_PASSWORD_WRONG: function() { return "Please check your current password."; },
      EMAIL_UPDATED: function() { return "Email Updated!"; },
      CHANGED_EMAIL_VERIFY: function() { return "Please check your email and follow the instructions to verify this email address."; },
      FIRST_NAME_NOT_UPDATED: function() { return "Could not update first name."; },
      LAST_NAME_NOT_UPDATED: function() { return "Could not update first name."; },
      EMAIL_NOT_UPDATED: function() { return "Could not update email address."; },
      UNKNOWN_ERROR: function() { return "Could not update account basics information."; },
    },

    EMAIL: {
      EMAIL_PREFERENCES: function() { return "Email Preferences"; },
      EMAIL_PREFERENCES_FOR: function() { return "Email Preferences For"; },
      ALL_COURSES: function() { return "All"; },
      SELECT_ALL: function() { return "Select All"; },
      ENABLED_COUNT: function(numberEnabled: string, total: string) { return "(" + numberEnabled + " of " + total + " courses enabled)"; },
      INSTRUCTION: {
        HEADER: function() { return "Instruction"; },
        ANNOUNCEMENTS: function() { return "Receive course communications from the teaching team"; },
        EVALUATIONS: function() { return "Evaluations and skills feedback for my submissions"; },
        APPROVAL: function() { return "Submissions approved or sent back for revision"; },
      },

      MENTIONS: {
        HEADER: function() { return "Mentions and Direct Communication"; },
        AT_MENTIONS: function() { return "@Mentions"; },
        DIRECT_MESSAGES: function() { return "Direct messages sent to me"; },
      },

      MY_TEAMS: {
        HEADER: function() { return "My Teams & Groups"; },
        MESSAGES: function() { return "Posts, documents, meetings, and submissions shared in my workspaces"; },
      },

      FOLLOWING: {
        HEADER: function() { return "Teams, Groups, and Discussions I am following"; },
        UPDATES: function() { return "Updates on discussions I am following or have participated in"; },
        COMMENTS: function() { return "Comments added after mine on any submission, or workspace post"; },
      },

      INVITATIONS: {
        HEADER: function() { return "Invitations & Requests"; },
        TEAM: function() { return "Team invitations"; },
        GROUP: function() { return "Group invitations"; },
        MEMBERSHIP_REQUESTS: function() { return "Membership requests in teams/groups"; },
      },

      COURSE_DIGEST: {
        HEADER: function() { return "Daily Digest"; },
        DEADLINES: function() { return "Deadlines and teams/group activity for learners, submissions needing feedback for advisors"; },
      },

      ADMIN: {
        HEADER: function() { return "Admin"; },
        DIGEST: function() { return "Course completion email digest"; },
        APPROVAL_DIGEST: function() { return "Submission Approval Digest - new submissions pending approval in last 24 hours (for All courses)"; },
      },

      GUIDANCE: {
        HEADER: function() { return "Guidance"; },
        GUIDES_AND_RESOURCES_EMAIL_SETTING: function() { return "Send me guides and resources for all mentoring programs"; },
      },

      PRACTICE: {
        HEADER: function() { return "Practice"; },
        NEW_COMMENT: function() { return "New comment on my practice videos"; },
        AT_MENTIONS: function() { return "@Mention in practice comments"; },
        NEW_FEATURED: function() { return "New Featured Practice"; },
        NEW_SKILLS_FEEDBACK: function() { return "New Skills Feedback"; },
      },

    },

    LANGS_AND_TZ: {
      LANGUAGE_HEADER: function() { return "Language Preference"; },
      TIME_ZONE_HEADER: function() { return "Time Zone Preference"; },
      TIME_ZONE_DESCRIPTION: function() { return "Setting the time zone will show all dates and times in the platform to display in the time zone of your choice."; },
      AUTO_UPDATE_TZ: function() { return "Automatically update my time zone based on my computer's clock (recommended)"; },
      MANUAL_TZ: function() { return "Or set a different time zone that won't be automatically updated:"; },
      SELECT_A_TIME_ZONE: function() { return "Select a Time Zone"; },
      DISPLAY_TIME_IN_NAV: function() { return "Display the time zone selector in my navigation bar."; },
      DISPLAY_TIME_IN_NAV_INFO: function() { return "From the selector you can easily adjust the time zone without navigating back to this page."; },
      DISPLAY_TIME_IN_NAV_PREVIEW: function() { return "Preview how it works."; },
      MORE_SETTINGS: function() { return "More Settings"; },
    },

  },

  SSO_UPDATE_EMAIL: {
    EMAIL_NEEDED: function() { return "<b>Email Address Needed! </b>Please provide an email address for receiving important course communications."; },
    ADD_EMAIL_ADDRESS: function() { return "Add Email Address"; },
    UPDATE_EMAIL_ADDRESS_MODAL: {
      HEADER: function() { return "Update Email"; },
      BODY: function() { return "Please provide a valid email address to receive course communications. Once set, this can only be changed by your admins."; },
      EMAIL_ALREADY_EXISTS: function() { return "Email address already exists and belongs to a different account."; },
      UPDATE_EMAIL_SUCCESS: function() { return "Your email address has been updated successfully!"; },
    },

  },

  USER_MANAGEMENT: {
    HEADER: function() { return "User Management"; },
    COURSE_ADMINS: function(d) { return d.CourseAlias + " Admins"; },
    FOR_MENTOR_MONITOR_USERS: function() { return "For Mentor Users Only"; },
    MENTOR_MONITOR_USERS: function(d) { return d.CourseTitleAlias + " Advisors"; },
    JOURNEY_MENTOR_MONITOR_USERS: function() { return "Course Advisors"; },
    NEVER_ACTIVE: function() { return "Never Active"; },
    SEARCH_FOR_ALL_USERS: function() { return "Search for All Users"; },
    SEARCH_TOOLTIP: function() { return "Search by name, email, external ID, or NovoEd ID"; },
    MANAGE_USERS: function() { return "Manage Users"; },
    NO_ROLE: function() { return "No Role"; },
    LEARNER_ROLES: function(d) { return d.LearnerAlias + " Roles"; },
    COURSE_ADMIN_PERMS_ONLY: function(d) { return "Roles with " + d.CourseAlias + " Admin Permissions Only"; },
    COURSE_ADMIN_AND_ADVISOR_PERMISSIONS: function(d) { return "Roles with " + d.CourseAlias + " Admin Permissions & Advisor Permissions"; },
    ADVISOR_PERMISSIONS_ONLY: function() { return "Roles with Advisor Permissions Only"; },
    ADMIN_ROLES: function() { return "Admin Roles"; },
    EDIT_COURSE_ROLE: function(d) { return "Edit " + d.CourseAlias + " Role"; },
    CHANGE_ROLE_CONFIRM: {
      HEADER: function() { return "Are you sure you want to change this user's role?"; },
      NO_LOSS_DESC: function(d) { return "This will change the user's role from " + d.currentRoleName + " to " + d.newRoleName + " and may affect their permissions in the " + d.courseAlias + ". Are you sure you want to proceed?"; },
      LOSS_DESC: function(d) { return "This will change the user's role from " + d.currentRoleName + " to " + d.newRoleName + " and delete their " + d.learnerAlias + " relationships in the " + d.courseAlias + ". Are you sure you want to proceed?"; },
    },

    RESET_ATTEMPTS: function() { return "Reset Attempts"; },
    RESET_ATTEMPTS_MODAL: {
      HISTORY: {
        VIEW: function() { return "View Reset Attempt History"; },
        HIDE: function() { return "HIde Reset Attempt History"; },
      },

      NO_ACTIVITIES: function(firstName: string) { return firstName + " does not have any submissions to reset"; },
      LIST_HEADER: function(firstName: string) { return "List of Activities " + firstName + " has completed that can be reset:"; },
      ACTIVITY: function() { return "Activity"; },
      RESET_BY: function() { return "Reset By"; },
      DATE: function() { return "Date"; },
      ACTIVITIES: function() { return "Activites"; },
      QUIZ: function() { return "Quiz - All-Question View"; },
      POLL: function() { return "Poll"; },
      SURVEY: function() { return "Survey"; },
      TIMED_EXAM: function() { return "Timed Exam"; },
      VIDEO_QUIZ: function() { return "Video Quiz"; },
      PROGRESSIVE_QUIZ: function() { return "Quiz - Single Question View"; },
      PRACTICE: function() { return "Practice"; },
      CANCEL: function() { return "Cancel"; },
      RESET: function() { return "Reset"; },
      RESET_ATTEMPTS_CONFIRM: function(d) { return "By resetting attempts, this " + d.learnerAlias + " will lose all responses, scores, and " + d.pointsAlias + " from previous attempts for the selected activity. Are you sure?"; },
      RESET_ATTEMPTS_SUCCESS: function() { return "Attempts reset successfully!"; },
    },

    MODIFY_CONTENT_ACCESS_END_DATE: function() { return "Modify Content Access Close Date"; },
    MODIFY_CONTENT_ACCESS_CLOSE_DATE_DISABLED_TOOLTIP: function() { return "This learner has completed the course and will have access to the course content."; },
    MODIFY: function() { return "Modify"; },
    CONTENT_ACCESS_ENDS_AT: function() { return "Content access ends at:"; },
    MODIFY_CONTENT_ACCESS_END_DATE_SUCCESS: function(fullName: string) { return fullName + "'s content access end date has been modified."; },
    REASON_OPTIONAL: function() { return "Reason (optional)"; },
    REASON: function() { return "Reason"; },
    ISSUED_BY: function() { return "Issued by"; },
    DATE: function() { return "Date"; },
    AWARD: function() { return "Award"; },
    AWARD_EXTRA_POINTS_SUCCESS: function(d) { return "Extra " + d.pointsAlias + " awarded to " + d.fullName + "!"; },
    DELETE_EXTRA_POINTS_SUCCESS: function(d) { return "Extra " + d.pointsAlias + " removed from " + d.fullName + "!"; },
    UPDATE_EXTRA_POINTS_SUCCESS: function(d) { return d.fullName + "'s extra " + d.pointsAlias + " were updated!"; },
    AWARD_MORE_POINTS: function(d) { return "Award More " + d.pointsAlias; },
    USER_LISTED_TOOLTIP: function(d) { return "User Listed on " + d.teachingTeamAlias + " Directory"; },
    LIST_ON_TEACHING_TEAM_DIRECTORY: function(d) { return "List on " + d.teachingTeamAlias + " Directory"; },
    UNLIST_ON_TEACHING_TEAM_DIRECTORY: function(d) { return "Unlist from " + d.teachingTeamAlias + " Directory"; },
    RESET_PASSWORD: function() { return "Reset Password"; },
    RESET_PASSWORD_EMAIL_SENT: function(email: string) { return "A password reset email has been sent to " + email; },
    RESEND_WELCOME_EMAIL: function() { return "Resend Welcome Email"; },
    WELCOME_EMAIL_SENT: function(email: string) { return "A welcome email will be resent to " + email; },
    ADD_MENTEES: function(d) { return "Add " + d.menteesAlias; },
    MANAGE_MENTEES: function(d) { return "Manage " + d.menteesAlias; },
    MANUALLY_ASSIGN: function() { return "Manually Assign"; },
    BULK_ASSIGN: function() { return "Bulk Assign by Uploading CSV"; },
    BULK_ASSIGN_LEARNERS: function(d) { return "Bulk Assign " + d.LearnersAlias; },
    MANUALLY_ADD: function() { return "Manually Add Users"; },
    UPLOAD_CSV: function() { return "Upload CSV"; },
    BULK_ADD: function() { return "Bulk add by Uploading CSV"; },
    BULK_UNENROLL: function() { return "Bulk Unenroll"; },
    ADD_MENTORS: function(d) { return "Add " + d.mentorsAlias; },
    UNENROLL_USER: function() { return "Unenroll user"; },
    MODIFY_OWN_USER_CONFIRM: function() { return "You are modifying permissions on your own account and you may lose access to this page if you continue. Are you sure you want to continue?"; },
    UNENROLL_EXPLANATION: function(d) { return "You have selected to unenroll " + d.firstName + " " + d.lastName + ". This action will prevent " + d.firstName + " from entering the " + d.courseAlias + " and will remove " + d.firstName + " from any " + d.teamAlias + " or " + d.groupsAlias + " they might have joined in the " + d.courseAlias + ". You can always re-register " + d.firstName + " in the User Management page."; },
    UNENROLL_EXPLANATION_RELATIONSHIP: function(d) { return "You have selected to unenroll " + d.firstName + " " + d.lastName + ". This action will prevent " + d.firstName + " from entering the " + d.courseAlias + " and will remove " + d.firstName + " from any " + d.teamAlias + " or " + d.groupsAlias + " they might have joined in the " + d.courseAlias + ". This will also remove the relationships with assigned " + d.learnersAlias + " in the " + d.courseAlias + ". Are you sure you want to proceed?"; },
    LOADING_USERS: function() { return "Loading: Users"; },
    VIEW_USER_UNAVAILABLE: function(d) { return "Please enroll in the " + d.courseAlias + " to view user's " + d.courseAlias + " profile."; },
    ASSIGN_MENTEES: function(d) { return "Assign " + d.menteesAlias; },
    ERROR_ASSIGN_MENTEE: function(d) { return "Cannot assign user to " + d.mentorAlias; },
    ASSIGNED_MENTEE_TO: function(d) { return "One user has been assigned to this " + d.mentorAlias; },
    REMOVED_MENTEE_FROM: function(d) { return "One user has been unassigned from this " + d.mentorAlias; },
    NUM_MENTEES_ASSIGNED: function(d) { return d.menteesCount + " " + plural(d.menteesCount, 0, en, { one: d.menteeAlias, other: d.menteesAlias }); },
    MANAGE_MENTEES_MODAL: {
      HEADER: {
        VIEW_ALL: function(d) { return "All " + d.menteesAlias; },
        MANUAL_ASSIGN: function(d) { return "Manually Assign " + d.menteesAlias; },
        BULK_ASSIGN: function(d) { return "Bulk Assign " + d.menteesAlias; },
      },

      REMOVE_MENTEE: function(d) { return "Remove " + d.menteeAlias; },
      REMOVE_MENTEE_CONFIRM: function(menteeName: string, mentorName: string) { return "By removing, " + menteeName + " will no longer be assigned to " + mentorName + ". Are you sure you want to proceed?"; },
    },

    MANUAL_ADD_MODAL: {
      COURSE_USER_ADD: {
        HEADER: function(d) { return "Manually Add User to " + d.CourseAlias; },
        LABEL: function() { return "You can add a user manually:"; },
        SSO_LOGIN_WITH_EXTERNALID_WARNING: function() { return "<b>SSO login with External ID only</b> is enabled for this organization. Manual enrollment with an email address can be used only for enrolling existing users, or for users who do not need to login via SSO. <b>Please use CSV upload to add new users who must login via SSO using External ID.</b>"; },
      },

      MENTEE_ADD: {
        HEADER: function(d) { return "Manually Assign " + d.MenteesAlias; },
        LABEL: function(d) { return "Search for a " + d.learnerAlias + " with the " + d.courseAlias + " to assign:"; },
      },

      SEARCH_LABEL: function(d) { return "Or search for users within the organization and add them to this " + d.courseAlias + ":"; },
      SEARCH_PLACEHOLDER_NOVOEDID: function() { return "Search by name, email, external ID, or NovoEd ID"; },
      SEARCH_PLACEHOLDER_NO_NOVOEDID: function() { return "Search by name, email, or external ID"; },
      FOUND_USERS: function(d) { return "We found the following users in your organization that are not in this " + d.courseAlias + ":"; },
      NO_RESULTS: function() { return "No Results Found!"; },
      LOADING_RESULTS: function() { return "Loading search results…"; },
    },

    CSV_UPLOAD_MODAL: {
      COURSE_USERS: {
        HEADER: function() { return "Upload CSV"; },
        DESCRIPTION: function(d) { return "You can upload a CSV to add users to the " + d.courseAlias + " and assign roles in bulk. Download a template of the CSV to see the format. Please note that the header row is required in your CSV and External ID column should ONLY be used if using SSO with external ID configured."; },
        SSO_LOGIN_WITH_EXTERNALID_DESCRIPTION: function() { return "To enroll new users who do not already have an account, please include both External ID and Email address. Please make sure to use accurate External ID's during upload. Using incorrect External IDs can result in inability to login, user accessing accounts that belong to other people or even double account creation."; },
      },

      BULK_UNENROLL: {
        HEADER: function() { return "Upload CSV"; },
        DESCRIPTION: function() { return "You can upload a CSV to unenroll users in bulk. Download a template of the CSV to see the format. Please note that the header row is required in your CSV and External ID column should ONLY be used if using SSO with external ID configured."; },
      },

      MENTEES_SINGLE_MENTOR: {
        HEADER: function(MenteeNames: string) { return "Bulk Assign " + MenteeNames + " by Uploading CSV"; },
        DESCRIPTION: function(menteeNames: string, mentorName: string) { return "You can upload a CSV to assign " + menteeNames + " to " + mentorName + ". Download a template of the CSV to see the format. Please note that the header row is required in your CSV and External ID column should ONLY be used if using SSO with external ID configured."; },
      },

      MENTEES_MULTI_MENTOR: {
        HEADER: function() { return "Upload CSV to Bulk Assign Learners"; },
        DESCRIPTION: function(d) { return "You can upload a CSV to bulk assign " + d.learnersAlias + " to all users who have the Learner Relationship Roles. Download a template of the CSV to see the format. Please note that the header row is required in your CSV and External ID column should ONLY be used if using SSO with external ID configured."; },
      },

      SCHEDULE_WELCOME_EMAIL: {
        HEADER: function() { return "Welcome Email"; },
        DESCRIPTION: function() { return "Would you like to schedule the welcome email for the users from this bulk upload?"; },
        DISMISS_MODAL: function() { return "No, Send Now"; },
        SCHEDULE: function() { return "Schedule"; },
        SEND_ON: function(date: string) { return "Send on " + date; },
        WILL_SEND: function() { return "Welcome Email will "; },
        RELEASE_DATE: function() { return " (Current Course Release Date)"; },
        START_DATE: function() { return " (Current Course Start Date)"; },
        SCHEDULE_FOR_LATER: function() { return "Schedule for Later"; },
        SEND_WHEN_ENROLLED: function() { return "Send When Enrolled"; },
        SCHEDULING: function() { return "Scheduling"; },
      },

      FRONTEND_VALIDATION_FAILED: function() { return "The following errors were encountered when processing the provided .csv file:"; },
      ERRORS: {
        ADMIN_OR_MENTOR: function() { return "This user has an admin or mentor role and cannot be assigned to a mentor"; },
        NOT_FOUND: function(d) { return "User does not exist in this " + d.courseAlias; },
        MENTOR_NOT_ASSIGNED: function() { return "Mentor not assigned"; },
        ROLE_NOT_CHANGED: function() { return "Role was not changed"; },
        USER_NOT_AUTHORIZED: function() { return "You are not authorized for this action"; },
        USER_NOT_A_MENTOR: function(mentor: string) { return "User " + mentor + " is not a mentor in this course"; },
        NOT_ENROLLED: function() { return "User is not enrolled"; },
        EXTERNAL_ID_REQUIRED: function() { return "External ID is required to add new users"; },
        EMAIL_REQUIRED: function() { return "Email Address is required to add new users"; },
        REQUIRED_FIELDS_MISSING: function() { return "Required fields External ID and Email Address are missing"; },
        REQUIRED_FIELDS_MISMATCH: function() { return "Email address does not match the External ID"; },
        HAS_EXTERNAL_ID: function() { return "Email address is assigned to a different user"; },
        TOO_FEW_COLUMNS: function() { return "Too few columns given in CSV"; },
        TOO_MANY_COLUMNS: function() { return "Too many columns given in CSV"; },
        TRANSIENT_ERROR: function() { return "Could not create account/enroll user"; },
      },

      ROW: function(number: string) { return "Row " + number; },
      COLUMN: function(number: string) { return "Column " + number; },
      UPLOAD_NEW_CSV: function() { return "Upload New CSV"; },
      PROCEED: function() { return "Ignore and Continue"; },
      REPLACE_MENTEES: function(d) { return "Replace the current list of assigned " + d.menteesAlias; },
      DOWNLOAD_TEMPLATE: function() { return "Download a Template"; },
      LIST_OF_USERS: function() { return "Here are the list of users from the CSV"; },
      LIST_OF_USERS_SELECT_ROLES: function() { return "Here are the list of users from the CSV, please select their roles and schedule the Welcome Email:"; },
      LIST_OF_ASSIGNED_USERS: function() { return "Here are the list of assigned users from the CSV:"; },
      ROLE_SELECT_NOTE: function() { return "<span class=\"warning\">Note:</span> Adding existing users with a different role will result in a role change. Please make sure that the user and role selection is accurate before adding."; },
      COLLECTION_ROLE_SELECT_NOTE: function() { return "Adding existing users with a different role will result in a role change (with the exception of Org Admins). Please make sure that the user and role selection is accurate before adding."; },
      APPLY_SAME_ROLE_AS: function() { return "Apply same role as:"; },
      ADD_ALL: function() { return "Add All"; },
      ADDING_ALL: function() { return "Adding"; },
      REMOVE_ALL: function() { return "Remove All"; },
      REMOVING_ALL: function() { return "Removing"; },
      TOTAL_USERS: function(count: number) { return "Total: " + count; },
      USERS_BEING_ADDED: function() { return "Users are being added. You will be notified via email when the operation is complete."; },
      USERS_BEING_ASSIGNED: function() { return "Users are being assigned. You will be notified via email when the operation is complete."; },
      USERS_BEING_UNENROLLED: function() { return "Users are being unenrolled. You will be notified via email when the operation is complete."; },
      USERS_REMOVED: function(d) { return d.unenrolledCount + " " + plural(d.unenrolledCount, 0, en, { one: " user ", other: "users" }) + " " + plural(d.unenrolledCount, 0, en, { one: " has ", other: " have " }) + " been unenrolled from the " + d.courseAlias; },
      SOME_ALREADY_REMOVED: function(d) { return d.unenrolledCount + " " + plural(d.unenrolledCount, 0, en, { one: "user", other: "users" }) + " " + plural(d.unenrolledCount, 0, en, { one: "has", other: "have" }) + " been unenrolled from the " + d.courseAlias + ", " + d.existingCount + " " + plural(d.existingCount, 0, en, { one: "user", other: "users" }) + " already unenrolled from the " + d.courseAlias; },
      USERS_EXIST: function(d) { return d.existingCount + " " + plural(d.existingCount, 0, en, { one: " User ", other: " Users " }) + " already " + plural(d.existingCount, 0, en, { one: " exists ", other: " exist " }) + " in the " + d.courseAlias; },
      USERS_ADDED: function(d) { return d.addedCount + " " + plural(d.addedCount, 0, en, { one: " user ", other: "users" }) + " " + plural(d.addedCount, 0, en, { one: " has ", other: " have " }) + " been added to the " + d.courseAlias; },
      USERS_ADDED_SOME_EXIST: function(d) { return d.addedCount + " " + plural(d.addedCount, 0, en, { one: "user", other: "users" }) + " " + plural(d.addedCount, 0, en, { one: "has", other: "have" }) + " been added to the " + d.courseAlias + ", " + d.existingCount + " " + plural(d.existingCount, 0, en, { one: "user", other: "users" }) + " already " + plural(d.existingCount, 0, en, { one: "exists", other: "exist" }) + " in the " + d.courseAlias; },
      USERS_ADDED_ROLE_CHANGES: function(d) { return d.addedCount + " " + plural(d.addedCount, 0, en, { one: "user", other: "users" }) + " " + plural(d.addedCount, 0, en, { one: "has", other: "have" }) + " been added to the " + d.courseAlias + ", " + d.rolesChangedCount + " " + plural(d.rolesChangedCount, 0, en, { one: "user", other: "users" }) + " " + plural(d.rolesChangedCount, 0, en, { one: "has", other: "have" }) + " had " + plural(d.rolesChangedCount, 0, en, { one: "a role", other: "roles" }) + " changed"; },
      USERS_ADDED_EXIST_ROLE_CHANGES: function(d) { return d.addedCount + " " + plural(d.addedCount, 0, en, { one: "user", other: "users" }) + " " + plural(d.addedCount, 0, en, { one: "has", other: "have" }) + " been added to the " + d.courseAlias + ", " + d.rolesChangedCount + " " + plural(d.rolesChangedCount, 0, en, { one: "user", other: "users" }) + " " + plural(d.rolesChangedCount, 0, en, { one: "has", other: "have" }) + " had " + plural(d.rolesChangedCount, 0, en, { one: "a role", other: "roles" }) + " changed, " + d.existingCount + " " + plural(d.existingCount, 0, en, { one: "user", other: "users" }) + " already " + plural(d.existingCount, 0, en, { one: "exists", other: "exist" }) + " in the " + d.courseAlias; },
      LEARNERS_ADDED: function(d) { return "You have enrolled " + d.addedCount + " " + plural(d.addedCount, 0, en, { one: d.learnerAlias, other: d.learnersAlias }); },
      USERS_ROLES_CHANGED: function(rolesChangedCount: number) { return rolesChangedCount + " " + plural(rolesChangedCount, 0, en, { one: "user", other: "users" }) + " " + plural(rolesChangedCount, 0, en, { one: "has", other: "have" }) + " had " + plural(rolesChangedCount, 0, en, { one: "a role", other: "roles" }) + " changed"; },
      USERS_ROLES_CHANGED_SOME_EXIST: function(d) { return d.rolesChangedCount + " " + plural(d.rolesChangedCount, 0, en, { one: "user", other: "users" }) + " " + plural(d.rolesChangedCount, 0, en, { one: "has", other: "have" }) + " had " + plural(d.rolesChangedCount, 0, en, { one: "a role", other: "roles" }) + " changed, " + d.existingCount + " " + plural(d.existingCount, 0, en, { one: " User ", other: " Users " }) + " already " + plural(d.existingCount, 0, en, { one: " exists ", other: " exist " }) + " in the " + d.courseAlias; },
      SINGLE_MENTOR: {
        MENTEES_ASSIGNED: function(assignedCount: number, mentorName: string) { return assignedCount + " new " + plural(assignedCount, 0, en, { one: "user", other: "users" }) + " " + plural(assignedCount, 0, en, { one: "has", other: "have" }) + " been assigned to " + mentorName + "."; },
        MENTEES_ASSIGNED_ALREADY_ASSIGNED: function(assignedCount: number, existingCount: number, mentorName: string) { return assignedCount + " new " + plural(assignedCount, 0, en, { one: "user", other: "users" }) + " " + plural(assignedCount, 0, en, { one: "has", other: "have" }) + " been assigned to " + mentorName + ", " + existingCount + " " + plural(existingCount, 0, en, { one: "user", other: "users" }) + " " + plural(existingCount, 0, en, { one: "was", other: "were" }) + " already assigned."; },
        MENTEES_EXISTED: function(existingCount: number, mentorName: string) { return existingCount + " " + plural(existingCount, 0, en, { one: "user", other: "users" }) + " " + plural(existingCount, 0, en, { one: "was", other: "were" }) + " already assigned to " + mentorName + "."; },
      },

      MULTI_MENTOR: {
        MENTEES_ASSIGNED: function(assignedCount: number) { return assignedCount + " new " + plural(assignedCount, 0, en, { one: "user", other: "users" }) + " " + plural(assignedCount, 0, en, { one: "has", other: "have" }) + " been assigned."; },
        MENTEES_ASSIGNED_ALREADY_ASSIGNED: function(assignedCount: number, existingCount: number) { return assignedCount + " new " + plural(assignedCount, 0, en, { one: "user", other: "users" }) + " " + plural(assignedCount, 0, en, { one: "has", other: "have" }) + " been assigned, " + existingCount + " " + plural(existingCount, 0, en, { one: "user", other: "users" }) + " " + plural(existingCount, 0, en, { one: "was", other: "were" }) + " already assigned."; },
        MENTEES_EXISTED: function(existingCount: number) { return existingCount + " " + plural(existingCount, 0, en, { one: "user", other: "users" }) + " " + plural(existingCount, 0, en, { one: "was", other: "were" }) + " already assigned."; },
      },

      ADDED_SUCCESS: function(d) { return d.count + " users " + plural(d.count, 0, en, { one: " has ", other: " have " }) + " been added to the " + d.courseAlias + "."; },
      REMOVED_SUCCESS: function(d) { return d.count + " users " + plural(d.count, 0, en, { one: " has ", other: " have " }) + " been added to the " + d.courseAlias + "."; },
      NO_USERS: function() { return "Can't find any user to upload from your CSV. Please check your CSV file again or download a template to see the correct format for uploading."; },
      CANT_MODIFY_OWN_USER: function() { return "Your account {email} is in the CSV upload. Modifying your own account via CSV upload is not supported. Please remove this entry and try again."; },
      INVALID_FORMAT: function(rowNumber: string) { return "The CSV file has an invalid format on row " + rowNumber + " for user with email {email}"; },
      CANNOT_BE_ENROLLED: function(count: number) { return count + " " + plural(count, 0, en, { one: " user ", other: " users " }) + " can not be enrolled:"; },
      CANNOT_BE_ASSIGNED: function(count: number) { return count + " " + plural(count, 0, en, { one: " user ", other: " users " }) + " can not be assigned:"; },
      CANNOT_BE_UNENROLLED: function(count: number) { return count + " " + plural(count, 0, en, { one: " user ", other: " users " }) + " can not be unenrolled:"; },
    },

    PROFILE_PICTURE_READ_ONLY: function() { return "Profile picture"; },
    EDIT_NAME_AND_EMAIL: {
      EDIT_NAME: function() { return "Edit User Name"; },
      OPTION: function() { return "Edit Name and Email"; },
      DISABLED: function() { return "Name and Email is managed via SSO Integration and cannot be edited"; },
      SSO_WARNING: {
        NOTE: function() { return "Please note:"; },
        WARNING: function() { return "Please ensure the new email matches the primary email provided by your federated login system. If not, a user attempt to log into NovoEd will automatically create an account for them based on the email provided by the federated login system."; },
      },

      DELETE_CONFIRMATION: {
        TITLE: function() { return "Email is associated with an empty account"; },
        CONTENT: function() { return "An empty account with no enrollments and no participation already exists. Would you like to delete the empty account and proceed with the email update?"; },
        YES_DELETE_UPDATE: function() { return "Yes, Delete and Update"; },
      },

      ALERTS: {
        ACCOUNT_ALREADY_EXISTS: function(courseCount: number, email: string) { return "Cannot update email as another' account with '" + email + "' already exists and is enrolled in " + courseCount + " " + plural(courseCount, 0, en, { one: "offering", other: "offerings" }) + " in the platform."; },
        ACCOUNT_ALREADY_EXISTS_INFO: function(email: string, newEmail: string) { return "If '" + email + "' is the correct email address, please consider unenrolling '" + newEmail + "' and enrolling '" + email + "' to this offering."; },
        CANNOT_DELETE: function() { return "Cannot update email as another account with this email address already exists."; },
        SUCCESS: function(firstName: string) { return "Information has been updated for " + firstName; },
      },

      DISABLED_TOOLTIP: function(d) { return d.LearnerAlias + " has other enrollments, Configuration and Registration permission is required to edit Name and Email."; },
    },

    ENROLLMENT_ACCORDION: {
      HEADER: function() { return "Enrollment Behavior by Roles"; },
      ADMINS: function() { return "Admins: Auto enrolled to all courses in the Journey"; },
      LEARNERS_AUTOENROLL_ENABLED: function() { return "Learners: Auto enrollment to first, and next courses after completion"; },
      LEARNERS_AUTOENROLL_DISABLED: function() { return "Learners: Must self-enroll in the first and subsequent courses"; },
      ADVISORS: function() { return "Advisors: Auto enrolled when their assigned learners enroll in courses"; },
    },

    ENROLLMENT: {
      BUTTON: function(count: number) { return "View Waitlist (" + count + ")"; },
      WAITLIST: function() { return "Waitlist"; },
      COUNTER: function(selected: string, total: string) { return selected + " of " + total + " selected"; },
      NAME_AND_EMAIL: function() { return "Name and Email"; },
      JOINED_WAITLIST_ON: function() { return "Joined Waitlist on"; },
    },

  },

  TEAM_FACILITATION: {
    HEADER: function(d) { return d.TeamTitleAlias + "/" + d.GroupTitleAlias + " Facilitation"; },
    MANAGE_ALL_TEAMS: function(d) { return "Manage All " + d.TeamsTitleAlias; },
    MANAGE_ALL_GROUPS: function(d) { return "Manage All " + d.GroupsTitleAlias; },
    MANAGE_TEAMS: {
      BULK_CREATE_VIA_CSV_UPLOAD: function(target: string) { return "Bulk Create " + target + " via CSV Upload"; },
      BULK_UPDATE_VIA_CSV_UPLOAD: function(target: string) { return "Bulk Update " + target + " via CSV Upload"; },
      DOWNLOAD_CSV: function(target: string) { return "Download " + target + " CSV"; },
      DOWNLOADING_CSV: function(target: string) { return "Downloading " + target + " CSV..."; },
      OTHER_TEAM_FORMATION_OPTIONS: function(teamName: string) { return "Other " + teamName + " Formation Options"; },
      POST_MESSAGE_TO_ALL_WORKSPACES: function(target: string) { return "Post Message to All " + target + " Workspaces"; },
      DELETE_ALL: function(target: string) { return "Delete All " + target; },
      DELETE_ALL_WARNING_TITLE: function(d) { return "Are you sure you want to Delete All " + select(d.isTeam, { true: d.TeamsTitleAlias, other: d.GroupsTitleAlias }); },
      DELETE_ALL_WARNING_DESCRIPTION: function(d) { return "This will delete all the " + select(d.isTeam, { true: d.teamsAlias, other: d.groupsAlias }) + ", their " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " submissions, discussions and the " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " workspace data. This action is final and cannot be undone. Are you sure?"; },
      DELETE_ALL_FLASH_HEADER: function(d) { return "Deletion of All " + select(d.isTeam, { true: d.TeamsTitleAlias, other: d.GroupsTitleAlias }) + " has started and can take a few seconds."; },
      DELETE_ALL_FLASH_MESSAGE: function(d) { return "Refreshing this page before completion may show you " + select(d.isTeam, { true: d.teamsAlias, other: d.groupsAlias }) + " that are not deleted yet. Please stay on the screen until deletion completes."; },
    },

    COLUMN_HEADERS: {
      TEAM_NAME: function(target: string) { return target + " Name"; },
      LAST_ACTIVITY: function() { return "Last Activity"; },
      LAST_ADMIN_VISITED: function() { return "Last Admin Visited"; },
      RECENT_POSTS: function() { return "Recent Posts"; },
      RECENT_ACTIVE_MEMBERS: function() { return "Recent Active Members"; },
      TEAM_ASSIGNMENTS: function(d) { return d.TeamTitleAlias + " " + d.AssignmentsAlias; },
    },

    OPTIONS: {
      MANAGE_TEAM: function(d) { return "Manage " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }); },
      POST_MESSAGE_TO_WORKSPACE: function(target: string) { return "Post Message to " + target + " Workspace"; },
      VIEW_TEAM_WORKSPACE: function(d) { return "View " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }) + " Workspace"; },
      VISIT_TEAM_PROFILE: function(d) { return "Visit " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }) + " Profile"; },
      CONTACT_TEAM: function(d) { return "Contact " + select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }); },
      ADD_MEMBERS: function() { return "Add Members"; },
      ADD_MEMBERS_DESCRIPTION: function(d) { return "Type in the names of the " + d.learnersAlias + " you want to add to this " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + ":"; },
      DELETE: function(target: string) { return "Delete " + target; },
    },

    BULK_UPLOAD: {
      CREATE_TITLE: function(target: string) { return "Bulk Create " + target; },
      UPDATE_TITLE: function(target: string) { return "Bulk Update " + target; },
      CREATE_DESCRIPTION: function(d) { return "Please download the template below with sample data and your " + d.learnerAlias + " information. Update it according to the instructions and proceed to upload."; },
      UPDATE_DESCRIPTION: function(d) { return "Please download your current list of " + select(d.isTeam, { true: d.TeamsAlias, other: d.GroupsAlias }) + " below. Update it according to the instructions and upload the file."; },
      SEE_INSTRUCTIONS: function() { return "See Instructions"; },
      HIDE_INSTRUCTIONS: function() { return "Hide Instructions"; },
      PLEASE_SELECT_CSV: function() { return "Please Select the CSV file to upload:"; },
      INSTRUCTIONS: {
        TITLE: function() { return "Instructions to update the CSV:"; },
        TO_CREATE: function(d) { return "To create a new " + select(d.isTeam, { true: d.teamsAlias, other: d.groupAlias }) + " and assign " + d.learnersAlias + " to it, type " + d.createNew + " (case sensitive) in the " + d.teamId + " column for each " + d.learnerAlias + "'s row."; },
        PROVIDE_NAME: function(teamName: string) { return "Provide the " + teamName + " and other information as shown in the CSV sample data."; },
        EXISTING_TEAMS: function(d) { return "Existing " + select(d.isTeam, { true: d.teamsAlias, other: d.groupsAlias }) + " in your CSV include a system generated " + d.teamId + "."; },
        TO_ASSIGN_TO_EXISTING: function(d) { return "To assign a " + d.learnerAlias + " to an existing " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + ", update the row to include the target " + d.teamId + " and " + d.teamName + "."; },
        TO_REMOVE: function(d) { return "To remove " + d.learnerAlias + " from " + select(d.isTeam, { true: "a " + d.teamAlias, other: "all " + d.groupsAlias }) + ", set the " + d.teamId + " as " + d.noTeam + " (case sensitive)."; },
        TO_ASSIGN_TO_NEW: function(d) { return "To assign " + d.learnerAlias + " to a newly created " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + ", include " + d.createNew + " (case sensitive) as " + d.teamId + "."; },
        PROVIDE_INFORMATION: function(d) { return "Provide information for other columns and make sure to include all " + select(d.isTeam, { true: d.teamsAlias, other: d.groupsAlias }) + " in the CSV."; },
        REFER_TO_HELPDESK: function(helpdeskLink: string) { return "Please refer to the <a href=\"" + helpdeskLink + "\" target=\"_blank\" style=\"color: #0E72ED\">helpdesk</a> for more information."; },
      },

      ERRORS_FOUND_DESCRIPTION: function() { return "The following errors were found in your CSV and corresponding rows be excluded. Please correct the errors and re-upload the CSV or confirm the changes to proceed."; },
      TEAMS_WITH_ERRORS: function(d) { return select(d.isTeam, { true: d.TeamsAlias, other: d.GroupsAlias }) + " with Errors"; },
      TEAM_ERROR_ROW: function(column: string, message: string, row: string) { return "Row " + row + "<pre>&#9</pre>Column " + column + "<pre>&#9</pre>" + message; },
      ROW: function(row: string) { return "Row " + row; },
      COLUMN: function() { return "Column"; },
      NEW_TEAMS_FOUND_DESCRIPTION: function(d) { return "We have found " + d.newTeamsCount + " new " + plural(d.newTeamsCount, 0, en, { one: select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }), other: select(d.isTeam, { true: d.teamsAlias, other: d.groupsAlias }) }) + " to create. Please Review:"; },
      CHANGES_FOUND_DESCRIPTION: function() { return "We have found the following changes in your CSV. Please review:"; },
      NEW_TEAMS_FOUND: function(d) { return "New " + select(d.isTeam, { true: d.TeamsAlias, other: d.GroupsAlias }) + " Found"; },
      NEW_TEAM_ROW: function(d) { return "<b>" + d.teamName + ":</b> " + d.totalMembers + " " + plural(d.totalMembers, 0, en, { one: "member", other: "members" }) + select(d.hasTeamLead, { true: ", " + select(d.isTeam, { true: d.teamAlias + " leader: ", other: d.groupAlias + " admins:" }) + "<b>" + d.teamLeadName + "</b>", other: "" }); },
      TEAMS_TO_UPDATE: function(d) { return select(d.isTeam, { true: d.TeamsAlias, other: d.GroupsAlias }) + " to Update"; },
      ADD_MEMBERS: function(membersAdded: string) { return "add " + membersAdded + " new " + plural(membersAdded, 0, en, { one: "member", other: "members" }); },
      REMOVE_MEMBERS: function(membersRemoved: string) { return "remove " + membersRemoved + " " + plural(membersRemoved, 0, en, { one: "member", other: "members" }); },
      TEAM_LEADS: function(d) { return select(d.isTeam, { true: d.teamAlias + " leader:", other: d.groupAlias + " admins:" }) + " <b>" + select(d.hasAdmins, { true: d.listOfAdmins, other: "No " + select(d.isTeam, { true: d.teamAlias + " leader", other: d.groupAlias + " admins" }) }) + "</b>"; },
      TEAMS_TO_DELETE: function(d) { return select(d.isTeam, { true: d.TeamsAlias, other: d.GroupsAlias }) + " to Delete"; },
      TEAM_DELETE_ROW: function(teamName: string) { return "<b>" + teamName + ":</b> will be deleted"; },
      ERROR_MESSAGE: function(fieldName: string) { return fieldName + " not found"; },
      BLOCKING_ERROR: {
        INVALID_COLUMN: function() { return "Invalid Columns found in your CSV"; },
        EMPTY_FILE: function() { return "Invalid file / Empty file"; },
        REQUIRED_COLUMNS_MISSING: function() { return "Invalid Format: Required columns are missing."; },
        DUPLICATE_COLUMNS: function() { return "Duplicate/repeated columns found in your CSV"; },
        NO_VALID_ROWS: function() { return "No valid rows found"; },
        NO_CHANGES_FOUND: function() { return "No changes were found in your CSV."; },
        CHECK_YOUR_CSV: function() { return "Please check your CSV file or download a template to see the correct format for uploading."; },
        CANT_FIND_USERS: function() { return "Can't find users to upload from your CSV. "; },
        NOT_VALID_MESSAGE: function(fieldName: string, validValues: string) { return fieldName + " must be one the following values: " + validValues; },
      },

      NUM_TEAMS_WERE_CREATED: function(d) { return d.teamCount + " " + plural(d.teamCount, 0, en, { one: select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " was", other: select(d.isTeam, { true: d.teamsAlias, other: d.groupsAlias }) + " were" }) + " created."; },
      NUM_TEAMS_WERE_UPDATED: function(d) { return d.teamCount + " " + plural(d.teamCount, 0, en, { one: select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " was", other: select(d.isTeam, { true: d.teamsAlias, other: d.groupsAlias }) + " were" }) + " updated."; },
      PROCESSING_UPLOADED_CSV_FILE: function() { return "Processing uploaded CSV file"; },
      WE_WILL_SEND_AN_EMAIL_WHEN_DONE: function() { return "We will send you an email when it is done"; },
      UPDATING_IN_PROGRESS: function() { return "Updating in Progress"; },
    },

    POST_MESSAGES: {
      POST_TO_WORKSPACE: function() { return "Post to Workspace"; },
      POST_TO_ALL_WORKSPACES: function() { return "Post to All Workspaces"; },
      MESSAGE_PLACEHOLDER: function() { return "Type your message here..."; },
      HIGHLIGHT_POST: function() { return "Highlight Post"; },
      HIGHLIGHT_POST_INFO: function() { return "Highlighted post will be pinned to the top of the workspace for the time period you defined."; },
      HIGHLIGHT_POST_DESCRIPTION: function() { return "Please define the time period you would like to highlight this post:"; },
      SUCCESS_MESSAGE_ALL: function(d) { return "Your message has been posted to all " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " workspaces."; },
      SUCCESS_MESSAGE_SINGLE: function() { return "Your message has been posted to the workspace."; },
    },

    PROGRESS_DASHBOARD: {
      TITLE: function(d) { return select(d.isTeam, { true: d.TeamTitleAlias + " Lead", other: d.GroupTitleAlias + " Admin" }) + " Dashboard"; },
      ENABLE: function(target: string) { return "Enable " + target + " Progress Dashboard"; },
      DISABLE: function(target: string) { return "Disable " + target + " Progress Dashboard"; },
      ENABLE_FOR_ALL: function(d) { return "Enable for All " + select(d.isTeam, { true: d.TeamTitleAlias + " Leads", other: d.GroupTitleAlias + " Admins" }); },
      DISABLE_FOR_ALL: function(d) { return "Disable for All " + select(d.isTeam, { true: d.TeamTitleAlias + " Leads", other: d.GroupTitleAlias + " Admins" }); },
      ENABLE_FOR_SINGLE_TEAM: function(d) { return "Enable for " + select(d.isTeam, { true: d.TeamTitleAlias + " Lead", other: d.GroupTitleAlias + " Admin" }); },
      DISABLE_FOR_SINGLE_TEAM: function(d) { return "Disable for " + select(d.isTeam, { true: d.TeamTitleAlias + " Lead", other: d.GroupTitleAlias + " Admin" }); },
      SINGLE_TEAM_DASBOARD_ENABLED: function(d) { return select(d.isTeam, { true: d.TeamTitleAlias + " Lead", other: d.GroupTitleAlias + " Admin" }) + " Dashboard is now enabled for the " + select(d.isTeam, { true: d.teamAlias + " lead", other: d.groupAlias + " admin" }) + " for this " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + "."; },
      ALL_TEAMS_DASBOARD_ENABLED: function(d) { return select(d.isTeam, { true: d.TeamTitleAlias + " Lead", other: d.GroupTitleAlias + " Admin" }) + " Dashboard is now enabled for all " + select(d.isTeam, { true: d.teamAlias + " leads", other: d.groupAlias + " admins" }) + " in this " + d.courseAlias + "."; },
      SINGLE_TEAM_DESCRIPTION: function(d) { return "When enabled, the " + select(d.isTeam, { true: d.teamAlias + " lead", other: d.groupAlias + " admin" }) + " will have mentor-role capabilities for the members of their " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + ". This will give the access to " + select(d.isTeam, { true: d.teamAlias + " leads", other: d.groupAlias + " admins" }) + " a " + select(d.isTeam, { true: d.teamAlias + " lead", other: d.groupAlias + " admin" }) + " dashboard (similar to mentor dashboard) and ability to viewing and commenting on all " + d.assignmentAlias + " submissions for " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " members (even those with private to teaching team sharing settings). If you prefer to enable this capability for all " + select(d.isTeam, { true: d.courseAlias + " long " + d.teamsAlias, other: d.groupsAlias }) + " instead, please select that option from the Manage " + select(d.isTeam, { true: d.TeamsTitleAlias, other: d.GroupsTitleAlias }) + " button menu."; },
      ALL_TEAMS_DESCRIPTION: function(d) { return "When enabled, " + select(d.isTeam, { true: d.teamAlias + " leads", other: d.groupAlias + " admins" }) + " for <b>all</b> " + select(d.isTeam, { true: d.courseAlias + " long " + d.teamsAlias, other: d.groupsAlias }) + " will have mentor-role capabilities for the members of their " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + ". This will give them access to a " + select(d.isTeam, { true: d.teamAlias + " lead", other: d.groupAlias + " admin" }) + " dashboard (similar to mentor dashboard) and ability to viewing and commenting on all " + d.assignmentAlias + " submissions for " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + " members (even those with private to teaching team sharing settings). If you prefer to enable this capability for a specific " + select(d.isTeam, { true: d.courseAlias + " long " + d.teamAlias, other: d.groupAlias }) + " instead, please select this option from the menu for the desired " + select(d.isTeam, { true: d.teamAlias, other: d.groupAlias }) + "."; },
      PROGRESS_DASHBOARD_HAS_BEEN_ENABLED_SINGLE_TEAM: function(d) { return select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }) + " Progress Dashboard has been enabled for the " + select(d.isTeam, { true: d.teamAlias + " lead", other: d.groupAlias + " admin" }) + " of " + d.teamName; },
      PROGRESS_DASHBOARD_HAS_BEEN_DISABLED_SINGLE_TEAM: function(d) { return select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }) + " Progress Dashboard has been disabled for the " + select(d.isTeam, { true: d.teamAlias + " lead", other: d.groupAlias + " admin" }) + " of " + d.teamName; },
      PROGRESS_DASHBOARD_HAS_BEEN_ENABLED_ALL_TEAMS: function(d) { return select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }) + " Progress Dashboard has been enabled for all " + select(d.isTeam, { true: d.teamAlias + " leads", other: d.groupAlias + " admins" }); },
      PROGRESS_DASHBOARD_HAS_BEEN_DISABLED_ALL_TEAMS: function(d) { return select(d.isTeam, { true: d.TeamTitleAlias, other: d.GroupTitleAlias }) + " Progress Dashboard has been disabled for all " + select(d.isTeam, { true: d.teamAlias + " leads", other: d.groupAlias + " admins" }); },
    },

    LAST_ACTIVTY: {
      CLICK_TO_VIEW_POST: function() { return "Click to View Post"; },
      CLICK_TO_VIEW_SUBMISSION: function() { return "Click to View Submission"; },
    },

    RECENT_POSTS: {
      TOTAL_POSTS: function(count: number) { return "Total Posts: <b>" + count + "</b>"; },
      POSTED_IN_PAST_7_DAYS: function(count: number) { return "Posted in Past 7 Days: <b>" + count + "</b>"; },
      CLICK_TO_VIEW: function() { return "Click on the number to view all posts"; },
      MODAL_TITLE: function(target: string) { return target + " Workspace Details"; },
    },

    RECENT_ACTIVE_MEMBERS: {
      TOTAL_MEMBERS: function(count: number) { return "Total Members: <b>" + count + "</b>"; },
      ACTIVE_IN_PAST_7_DAYS: function(count: number) { return "Active in Past 7 Days: <b>" + count + "</b>"; },
      CLICK_TO_VIEW: function(target: string) { return "Click on the number to view member details in " + target + " workspace"; },
    },

    TEAM_ASSIGNMENTS: {
      NOT_SUBMITTED: function() { return "Not Submitted"; },
      SUBMITTED_ON: function(date: string) { return "<b><span class=\"text-success\">Submitted</span> on " + date + "</b>"; },
      CLICK_TO_VIEW: function(submissionCount: number) { return "Click on the number to view " + plural(submissionCount, 0, en, { one: "submission", other: "all submissions" }); },
    },

    NO_TEAMS: function(d) { return "No " + select(d.isTeam, { true: d.teamsAlias, other: d.groupsAlias }) + " in the " + d.offeringName; },
    NO_RESULTS_FOUND: function(target: string) { return "No Results Found in " + target; },
    CLICK_TO_VISIT_WORKSPACE: function(target: string) { return "Click to Visit " + target + " Workspace"; },
    SEARCH: {
      PLACEHOLDER: function(target: string) { return "Search for " + target; },
    },

  },

  PRACTICE_ROOM: {
    TITLE: function() { return "Practice Room"; },
    PLAY_VIDEO: function() { return "Play Video"; },
    SCENARIOS: {
      IN_CURRENT_COURSE: function(d) { return "In Current " + d.courseAlias; },
      STATS: {
        LAST_PRACTICED: function(date: string) { return "Last Practiced on " + date; },
        FEATURED: function(count: number) { return count + " featured"; },
        GALLERY: function(count: number) { return count + " in gallery"; },
        NO_VIDEOS: function() { return "No Practices Yet"; },
      },

    },

    PRACTICE_ROOM_MODAL: {
      TABS: {
        MY_PRACTICE: function() { return "My Practice"; },
        FEATURED: function() { return "Featured"; },
        GALLERY: function() { return "Gallery"; },
        ANALYTICS: function() { return "Analytics"; },
        NO_CONTENT: {
          DEFAULT: function() { return "No practices yet."; },
          FEATURED: function() { return "No featured practices yet."; },
        },

      },

      VIEW_PROMPT: function() { return "View Prompt"; },
      PRACTICE_AGAIN: function() { return "Practice Again"; },
      PRACTICE_AGAIN_DESCRIPTION: function() { return "Practice the Scenario Again"; },
      PRACTICE_ROOM_FOR: function() { return "Practice Room For"; },
      FEATURED_TAB: {
        INTRO: function() { return "Featured practices have been highlighted by teaching team or mentors as high quality examples for this practice scenario."; },
      },

    },

    SUBMISSION: {
      TABS: {
        COMMENTS: function() { return "Comments"; },
        YOUR_SKILLS_FEEDBACK: function() { return "Your Skills Feedback"; },
        ALL_SKILLS_FEEDBACK: function() { return "All Skills Feedback"; },
        INSIGHTS: function() { return "Insights"; },
      },

      TITLE: function(recordedDate: string, recordedHash: number) { return plural(recordedHash, 0, en, { one: number("en", recordedHash, 0) + "st", two: number("en", recordedHash, 0) + "nd", few: number("en", recordedHash, 0) + "rd", other: number("en", recordedHash, 0) + "th" }, 1) + " Practice Recorded on " + recordedDate; },
      PRACTICED_IN: function() { return "Practiced in"; },
      FEATURE: {
        HEADER: function() { return "Admin Option"; },
        FEATURE_SUBMISSION: function() { return "Highlight This Practice as Featured"; },
        STOP_FEATURING: function() { return "Stop Featuring This Practice"; },
        FEATURE_SUCCESS_MSG: function(user: string) { return user + "'s Practice has been featured."; },
        STOP_FEATURE_SUCCESS_MSG: function(user: string) { return user + "'s Practice has been removed from the Featured Practices."; },
      },

      DELETE: {
        DISABLED: {
          FEATURED: function() { return "Cannot delete a feature Practice. Please contact your teaching team."; },
          ACTIVITY_ADMIN: function() { return "This Practice is the learner's response to a practice activity and cannot be deleted from the Practice Room. To remove the Practice, reset the activity for the learner in the Learner Progress Dashboard."; },
          OTHERS: function() { return "This Practice can't be deleted. Please contact your teaching team."; },
        },

        CONFIRM: {
          TITLE: function() { return "Delete Submission"; },
          TEXT: function() { return "Are you sure you want to delete this submission?"; },
        },

        SUCCESS: function() { return "Submission has been deleted."; },
      },

    },

    TOOLTIP: {
      COMMENT: {
        TEXT: function() { return "Leave a Text Comment"; },
        VIDEO: function() { return "Record a Video Comment"; },
      },

      FEATURE_SUBMISSION: {
        SHARED: function() { return "Featuring this practice will notify learners of the new featured practice and make it visible under Featured practices in the practice room."; },
        PRIVATE: function() { return "Featuring this practice will make it viewable by other learners in Featured tab in the practice room and in the mini-gallery and will notify learners of the new featured practice."; },
      },

      TEAM_MEMBER: function(team: string) { return "You are part of " + team + " together"; },
    },

    BACK_TO_COMPONENT: {
      GALLERY: function() { return "Back to gallery"; },
      FEATURED: function() { return "Back to featured"; },
    },

    ARIA_LABEL: {
      COMMENT_TIMESTAMP: function() { return "Video comment time"; },
    },

    COMMENTS: {
      TIMESTAMP_POPOVER: function() { return "This comment will be linked to a specific moment in the practice."; },
      NO_COMMENTS: {
        DEFAULT: function() { return "Use the comment button to leave the first comment"; },
        MY_PRACTICE: function() { return "No Comment Yet"; },
      },

      ALL_COMMENTS: function() { return "View All Comments"; },
      VIEW_MORE: function(count: number) { return "View More Comments (" + count + " More)"; },
      ADD_COMMENT: function() { return "Add Comment"; },
      VIDEO_COMMENT: function() { return "Record Your Comment"; },
      TRANSCODING_IN_PROGRESS: {
        FIRST_LINE: function() { return "Thumbnail will be available shortly."; },
        SECOND_LINE: function() { return "You can play the video meanwhile."; },
      },

    },

    STATS: {
      FEATURED: function(count: number) { return count + " " + plural(count, 0, en, { one: "Featured", other: "Featured" }); },
      COMMENT: function(count: number) { return count + " " + plural(count, 0, en, { one: "Comment", other: "Comments" }); },
      LIKE: function(count: number) { return count + " " + plural(count, 0, en, { one: "Like", other: "Likes" }); },
      VIEW: function(count: number) { return count + " " + plural(count, 0, en, { one: "View", other: "Views" }); },
      PRACTICE: function(count: number) { return count + " " + plural(count, 0, en, { one: "Practice", other: "Practices" }); },
    },

    SORT_AND_FILTER_OPTIONS: {
      LABEL: {
        RECENCY: function() { return "Recency"; },
        MY_COMMUNITY: function() { return "My Community"; },
        POPULARITY: function() { return "Popularity"; },
        NO_ADMIN_COMMENTS: function() { return "No Admin Comments"; },
      },

      TOOLTIP: {
        RECENCY: function() { return "Sort by Recency"; },
        MY_COMMUNITY: function() { return "Only show practices submitted by learners team or group members"; },
        POPULARITY: function() { return "Sort by Popularity"; },
        NO_ADMIN_COMMENTS: function() { return "Only show practices that do not have comments from an admin or mentor user with access to the practice room"; },
      },

    },

    SKILL_FEEDBACK: {
      TOOLTIP: function() { return "Give Skills Feedback"; },
      HEADER: function() { return "Skills Feedback"; },
      PRACTICE_ROOM_HEADER: function() { return "Your Skills Feedback"; },
      DESCRIPTION: function() { return "Provide a rating that reflects how well the learner demonstrated the skill within their practice. This rating will be visible to you, the learner who submitted this practice, and the instructional team."; },
      SUBMIT_CONFIRMATION: {
        TITLE: function() { return "Do you want to submit this feedback?"; },
        DESCRIPTION: function() { return "Feedback cannot be edited once submitted. Feedback will only be visible to you, the learner, and the instructional team."; },
      },

      TOTAL_RATINGS: function(ratingsCount: number) { return ratingsCount + " " + plural(ratingsCount, 0, en, { one: "Rating", other: "Ratings" }); },
      EMPTY_FEEDBACK: function() { return "You have not provided skills feedback yet. Click \"Give Skills Feedback\" button to provide your feedback."; },
      DELETE_AS_AUTHOR: function() { return "Are you sure you want to delete your feedback?"; },
      DELETE_AS_ADMIN: {
        TITLE: function() { return "Are you sure you want to delete all ratings by this user on this practice?"; },
        DESCRIPTION: function() { return "Ratings by this user on all skill tags on this practice will be removed."; },
      },

      RATING_TOOLTIP: function(rating: string, total: string) { return rating + " of " + total; },
      VIEW_ALL_FEEDBACK: function() { return "View all Feedback"; },
      VIEWING_FEEDBACK_FROM: function(userName: string) { return "Viewing feedback from <b>" + userName + "</b>"; },
      SUCCESS_ALERT: function(requiredCount: number) { return "Skills Feedback has been submitted successfully, " + plural(requiredCount, 0, en, { one: number("en", requiredCount, 0), other: number("en", requiredCount, 0) }) + " remain to complete the activity"; },
      ACTIVITY_COMPLETED: function(requiredCount: number) { return "You have given feedback on all " + plural(requiredCount, 0, en, { one: number("en", requiredCount, 0) + " required submission", other: number("en", requiredCount, 0) + " required submissions" }) + "."; },
      ACTIVITY_COMPLETED_BEYOND: function() { return "Your feedback has been submitted"; },
    },

    INSIGHTS: {
      LOADING: function() { return "We're processing your practice"; },
      DESCRIPTION: function() { return "Use these insights to assess your performance. When ready, practice again to try your hand at the scenario once more."; },
      REQUEST_REVIEW: {
        SUBMIT_REVIEW_CTA: function() { return "Request Review"; },
        PENDING_REVIEW_CTA: function() { return "Pending Review"; },
        REVIEW_RECEIVED_CTA: function() { return "Review Received"; },
        REQUEST_SUCCESS_TITLE: function() { return "Success!"; },
        REQUEST_CTA_TOOLTIP: function() { return "Click here to request review."; },
        RECEIVED_CTA_TOOLTIP: function() { return "Click to view received review."; },
        PENDING_CTA_TOOLTIP: function() { return "Review has been requested."; },
        REQUEST_SUCCESS_DESCRIPTION: function() { return "You have submitted your practice for review! You will receive the notification when the review is in."; },
      },

      GENERATE_INSIGHTS: {
        CTA: function() { return "Generate Insights"; },
        INFO: function() { return "Please click here to generate your Practice Insights."; },
        SUCCESS: function() { return "We have started generating the insights."; },
      },

      WPM: {
        LABEL: function() { return "WPM <br /> Rate of Speech"; },
        DESCRIPTION: function(fastRate: string, slowRate: string, wordsPerMinute: string) { return "Your overall rate of speech is " + wordsPerMinute + " words per minute (WPM). Generally, a WPM value of " + slowRate + " or below would be considered slow; " + fastRate + " WPM or above would be considered fast."; },
        CHART: function() { return "The chart below details how your rate of speech varied in your practice."; },
        FAST: function() { return "Fast"; },
        SLOW: function() { return "Slow"; },
        NO_DATA: function() { return "Your practice is too short and we don't have enough data to show you valuable insights."; },
      },

      MENTIONED: {
        LABEL: function() { return "Key Phrases <br /> Mentioned"; },
        INCLUDED: function(phraseCount: number) { return "You included " + phraseCount + " " + plural(phraseCount, 0, en, { one: "key phrase", other: "key phrases" }) + " expected to be mentioned in your practice."; },
        NOT_INCLUDED: function() { return "You did not include any key phrases that should have been mentioned in your submission. Try to include these from your practice next time."; },
        MENTIONED: function() { return "Mentioned:"; },
        NOT_MENTIONED: function() { return "Not mentioned:"; },
      },

      AVOIDED: {
        LABEL: function() { return "Key Phrases <br /> To be avoided"; },
        INCLUDED: function(phraseCount: number) { return "You included " + phraseCount + " " + plural(phraseCount, 0, en, { one: "key phrase", other: "key phrases" }) + " that should have been avoided in your submission. Try to omit these from your practice next time."; },
        NOT_INCLUDED: function() { return "Congratulations, you did not mention any of the key phrases to avoid in your practice."; },
        FORGOT_TO_AVOID: function() { return "You forgot to avoid:"; },
      },

      FILLER_WORDS: {
        LABEL: function() { return "Filler Words"; },
        LOADING: function() { return "We're processing your filler words"; },
        NO_FILLER_WORDS: function() { return "Congratulations, you did not mention any filler words in your practice. <span>&#128079;&#127996;&#127881;</span>"; },
        PEER_COMPARISON: {
          ABOVE: function(fillerPercentage: string, peerComparison: string) { return "Your practice contains <b>" + fillerPercentage + "% filler words</b>, exceeding the <b>peer average of " + peerComparison + "%.</b>"; },
          BELOW: function(fillerPercentage: string, peerComparison: string) { return "Your practice contains <b>" + fillerPercentage + "% filler words</b>, which is below the <b>peer average of " + peerComparison + "%.</b> &#128079;&#127996;"; },
          EQUAL: function(fillerPercentage: string, peerComparison: string) { return "Your practice contains <b>" + fillerPercentage + "% filler words</b>, which is equal the <b>peer average of " + peerComparison + "%.</b> &#128077;&#127996;"; },
          NO_PEERS: function() { return "Congratulations on being the trailblazer! <span>&#128079;&#127996;</span> Circle back later to see your performance relative to peers."; },
        },

        PRIOR_ATTEMPT_COMPARISON: {
          ABOVE: function(fillerPercentageDiff: string) { return "This list details your filler word usage, showing a <b>" + fillerPercentageDiff + "% increase</b> compared to your previous attempt."; },
          BELOW: function(fillerPercentageDiff: string) { return "This list details your filler word usage, showing a <b>" + fillerPercentageDiff + "% reduction</b> compared to your previous attempt. &#128079;&#127996;"; },
          EQUAL: function(fillerPercentageDiff: string) { return "This list details your filler word usage, showing you maintained a <b>steady performance at " + fillerPercentageDiff + "%.</b> &#128077;&#127996;"; },
          NO_PRIOR_ATTEMPT: function() { return "This list details your filler word usage, practice again and observe your progress."; },
        },

        VOCALIZED_PAUSES: function() { return "Vocalized Pauses"; },
        SHOW_ALL: function() { return "Show All Filler Words"; },
        SHOW_LESS: function() { return "Show Less Filler Words"; },
        CURRENT_ATTEMPT: function() { return "Current attempt"; },
        PRIOR_ATTEMPT: function() { return "Prior attempt"; },
        FOOT_NOTE: function() { return "*Vocalized pauses are interruptions in the flow of speech that are filled with sounds like \"uh,\" \"um,\" \"er,\" \"ah,\" or similar noises."; },
        CTA: function(input: string) { return "Please " + input + " to see your Filler Words Usage."; },
        CLICK_HERE: function() { return "click here"; },
      },

    },

  },

  COURSE_COMMUNICATIONS: {
    ALERT_MESSAGES: {
      CREATE: {
        TRIGGERS: {
          SUCCESS: {
            CREATE: function() { return "New communication trigger has been setup successfully!"; },
            DUPLICATE: function() { return "New communication trigger has been duplicated successfully!"; },
          },

          ERROR: function() { return "Could not create communication trigger."; },
        },

        SCHEDULED: {
          SUCCESS: {
            CREATE: function() { return "New communication has been scheduled successfully!"; },
            DUPLICATE: function() { return "New communication has been duplicated successfully!"; },
          },

          ERROR: function() { return "Could not schedule communication."; },
        },

        ANNOUNCEMENT: {
          SUCCESS: {
            CREATE: function() { return "New announcement has been scheduled successfully!"; },
            DUPLICATE: function() { return "New announcement has been duplicated successfully!"; },
          },

          ERROR: function() { return "Could not schedule announcement."; },
        },

        WELCOME_EMAIL: {
          SUCCESS: function() { return "Welcome Email has been enabled successfully!"; },
          ERROR: function() { return "Could not enable Welcome Email."; },
        },

      },

      ADD: {
        WELCOME_EMAIL: {
          SUCCESS: function() { return "Advisor welcome email was created successfully. Advisors will receive this welcome email with a link to advisor dashboard."; },
          DELETE: function() { return "The advisor welcome email has been deleted. Advisors will now receive the default welcome email instead."; },
        },

      },

      SEND_EMAIL: {
        SUCCESS: function() { return "Test email has been successfully sent to your registered email account!"; },
      },

      UPDATE: {
        TRIGGERS: {
          SUCCESS: function() { return "Communication trigger has been updated successfully."; },
          ERROR: function() { return "Could not update communication trigger."; },
        },

        SCHEDULED: {
          SUCCESS: function() { return "Communication has been updated successfully."; },
          ERROR: function() { return "Could not update communication."; },
        },

        ANNOUNCEMENT: {
          SUCCESS: function() { return "Announcement has been updated successfully."; },
          ERROR: function() { return "Could not update announcement."; },
        },

        WELCOME_EMAIL: {
          SUCCESS: function() { return "Welcome Email has been updated successfully!"; },
          ERROR: function() { return "Could not update Welcome Email."; },
        },

      },

      SEND_NOW: {
        SCHEDULED: {
          SUCCESS: function() { return "New email has been sent successfully!"; },
          ERROR: function() { return "Could not send email."; },
        },

        ANNOUNCEMENT: {
          SUCCESS: function() { return "New announcement has been sent successfully!"; },
          ERROR: function() { return "Could not send announcement."; },
        },

      },

    },

    NO_CONTENT: {
      AUTOMATED: function(d) { return "No Content Yet. Please create your " + d.courseAlias + " content first."; },
      DRAFTS: function() { return "No Drafts Yet"; },
      SCHEDULED: function() { return "No Date based Emails or Announcements yet"; },
      SCHEDULED_FUTURE: function() { return "No upcoming Date based Emails or Announcements yet"; },
      FILTER: function() { return "No Communications Found"; },
    },

    SCHEDULED_TAB: {
      DUE_DATE: function() { return "Due date for"; },
      RELEASE_DATE: function() { return "Release date for"; },
      ACTIVITY: function(activitiesCount: number) { return " " + activitiesCount + " " + plural(activitiesCount, 0, en, { one: "activity", other: "activities" }); },
      LESSON: function(d) { return " " + d.lessonsCount + " " + plural(d.lessonsCount, 0, en, { one: d.lectureAlias, other: d.lecturesAlias }); },
      YESTERDAY: function() { return "Yesterday"; },
      TODAY: function() { return "Today"; },
      TOMORROW: function() { return "Tomorrow"; },
      TITLE_WITH_COLON: function(title: string) { return title + ":"; },
      DUE_DATE_MODAL_HEADER: function(activitiesCount: number) { return "Due date for " + activitiesCount + " " + plural(activitiesCount, 0, en, { one: "activity", other: "activities" }); },
      RELEASE_DATE_MODAL_HEADER: function(d) { return "Release date for " + d.lessonsCount + " " + plural(d.lessonsCount, 0, en, { one: d.lectureAlias, other: d.lecturesAlias }); },
      VIEW_MORE: {
        PAST: function(count: number) { return "View Past Communications (" + count + ")"; },
        HIDE_PAST: function() { return "Hide Past Communications"; },
        FUTURE: function() { return "View More Communications"; },
      },

    },

    ITEM_STATES: {
      NORMAL: function() { return "NORMAL"; },
      SENT: function() { return "SENT"; },
      ACTIVATED: function() { return "ACTIVATED"; },
      ERROR: function() { return "ERROR"; },
      DRAFT_WILL_NOT_SENT: function() { return "DRAFT - WILL NOT BE SENT"; },
      DRAFT_WILL_NOT_TRIGGER: function() { return "DRAFT - WILL NOT BE TRIGGERED"; },
    },

    NOTE_FOR_EXTRA_TERMS: function() { return "Extra terms are enabled. Those who have logged in and accepted them will receive the communication."; },
    SAVE_AS_DRAFT: function() { return "Save as Draft"; },
    SAVING: function() { return "Saving..."; },
    SENDING: function() { return "Sending..."; },
    DRAFT_SAVED: function(time: string) { return "Draft saved on " + time; },
    ACTIVITIES: {
      QUIZ: function() { return "Quiz - All-Question View"; },
      TIMED_EXAM: function() { return "Timed Exam"; },
      SURVEY: function() { return "Survey"; },
      ASSIGNMENT: function() { return "Assignment"; },
      ASSIGNMENT_SKILLS_FEEDBACK: function() { return "Assignment Skills Feedback"; },
      ASSIGNMENT_SKILLS_FEEDBACK_WITH_ALIAS: function(d) { return d.AssignmentTitleAlias + " Skills Feedback"; },
      PEER_EVALUATION: function() { return "Peer Evaluation"; },
      DISCUSSION: function() { return "Discussion"; },
      TEAM_DISCUSSION: function() { return "Team Discussion"; },
      EXTERNAL_TOOL: function() { return "External Tool"; },
      TEAM_FORMATION: function() { return "Team Formation"; },
      GROUP_FORMATION: function() { return "Group Formation"; },
      LIVE_EVENT: function() { return "Live Events"; },
      IN_PERSON_EVENT: function() { return "In-Person Events"; },
      LECTURE_VIDEO: function() { return "Audio or Video"; },
      VIDEO: function() { return "Video"; },
      AUDIO: function() { return "Audio"; },
      PROFILE_COMPLETION: function() { return "Profile Completion"; },
      POLL: function() { return "Poll"; },
      PROGRESSIVE_QUIZ: function() { return "Quiz - Single Question View"; },
      PRACTICE: function() { return "Practice"; },
      PRACTICE_FEEDBACK: function() { return "Practice Feedback"; },
      PRACTICE_SKILLS_RATING: function() { return "Practice Skills Feedback"; },
      AI_ROLE_PLAY: function() { return "AI Roleplay"; },
    },

    ACTIVITY_TITLE: function(activity: string, title: string) { return activity + ": " + title; },
    SAMPLE_NOTIFICATION: {
      NOVOED: function() { return "NovoEd"; },
      NOW: function() { return "now"; },
      NOVOED_LOGO: function() { return "NovoEd Logo"; },
    },

    EMAIL: {
      SUBJECT_PLACEHOLDER: function() { return "Subject"; },
      BODY_PLACEHOLDER: function() { return "Type your email here"; },
    },

    SAMPLE_EMAIL: {
      SEND_TEST_EMAIL: function() { return "Send a Test Email"; },
      TITLE: function() { return "Email:"; },
      SUBJECT: function() { return "Subject:"; },
      FROM: function() { return "From:"; },
      ERROR: function() { return "Could not fetch email preview"; },
      LOADING: function() { return "Loading Preview..."; },
    },

    PUSH_NOTIFICATION: {
      TITLE: function() { return "Push Notification:"; },
      LABEL: function() { return "Include push notification to NovoEd mobile app"; },
      ARIA_LABEL: function() { return "Push Notification Message"; },
      CHAR_LIMITS: function() { return "Learn more about the character limits"; },
      PLACEHOLDER: function() { return "Type notification here..."; },
      POSTSCRIPT: function() { return "Note: Preview is for reference only. Actual appearance of push notification may vary by device and OS."; },
    },

    HEADER: function(d) { return d.CourseAlias + " Communications"; },
    CREATED_BY: function(createdDate: string, fullName: string) { return "Created by " + fullName + " on " + createdDate; },
    EDITED_BY: function(createdDate: string, fullName: string) { return "Last Edited by " + fullName + " on " + createdDate; },
    CREATED_BY_SYSTEM: function() { return "Created by system"; },
    ANNOUNCEMENT_BY: function(fullName: string) { return "Announcement by " + fullName; },
    FILTER: {
      HEADER: function() { return "Filter by"; },
      ANNOUNCEMENTS: function() { return "Announcements"; },
      DATE_BASED_EMAILS: function() { return "Date based Emails"; },
      COMPLETION_TRIGGERED_EMAILS: function() { return "Completion Triggered Emails"; },
    },

    TABS: {
      AUTOMATED: function() { return "Automated"; },
      SCHEDULED: function() { return "Scheduled"; },
      DRAFTS: function() { return "Drafts"; },
      TITLE: {
        AUTOMATED: function() { return "Automated Communications"; },
        SCHEDULED: function() { return "Scheduled Communications"; },
        DRAFTS: function() { return "Draft Communications"; },
      },

      DESCRIPTION: {
        AUTOMATED: {
          INTRO_FIRST: function(d) { return "Automated Communications allow you to define communications based on activity due dates, " + d.lectureAlias + " release dates, and activity triggered communications to target participants who have or have not completed a specific activity and meet other trigger criteria."; },
          INTRO_SECOND: function(d) { return "You can add these automated communications by clicking the SQUARE_ICON on the desired " + d.lectureAlias + " or activity in the " + d.courseAlias + " outline view below."; },
        },

        SCHEDULED: {
          INTRO_FIRST: function(d) { return "Scheduled Communications lists all the communications that are based on a date, including based on " + d.lectureAlias + " release dates, activity due dates, or any other date that was used to send/schedule a communication."; },
          INTRO_SECOND: function(d) { return "To send a new communication immediately or schedule it on a specific calendar date, please use the Create New button above. To create " + d.lectureAlias + " release date or activity due date based communications, please use the Automated tab."; },
          INTRO_THIRD: function() { return "You can find any previously created Contact Learners emails in the LEGACY_EMAILS_LINK page."; },
          PLEASE_NOTE: function() { return "Please note: "; },
          LEGACY_EMAILS: function() { return "Legacy Emails"; },
        },

        DRAFTS: function() { return "All saved draft communications are here and will not be sent or triggered until completed."; },
      },

    },

    TOOLTIP: {
      ITEM: function() { return "Click to view this communication"; },
      CREATE: function() { return "Click to Create New"; },
      CREATE_DISABLED: function(d) { return "Please mark this activity as a To-do or assign " + d.pointsAlias; },
      CREATE_DISABLED_NO_POINTS: function() { return "Please mark this activity as a To-do"; },
      CREATE_DISABLED_INSTRUCTOR_CREATED: function(team: string) { return "Cannot create communication for instructor formed " + team; },
      CREATE_DISABLED_TEACHING_TEAM_EVAL: function(d) { return "Cannot create communication for " + d.teachingTeamAlias + " only evaluation"; },
      CREATE_TRIGGER: function() { return "Click to Create New Trigger"; },
      CLICK_TO_VIEW_COMMUNICATIONS: function() { return "Click to View Communications"; },
      CLICK_TO_HIDE_COMMUNICATIONS: function() { return "Click to Hide Communications"; },
      ACTIONS: function() { return "Actions"; },
      DISABLED_EDIT: function() { return "Cannot edit communication after it has been sent"; },
      ERROR_STATE_DISABLED_EDIT: function() { return "Cannot Edit as this communication is no longer valid"; },
      DUE_DATE_MISSING_DISABLED_DUPLICATE: function() { return "Cannot Duplicate as this communication is no longer valid"; },
      CREATE_DISABLED_NO_REQUIRED_QUESTIONS: function() { return "Cannot create communication as activity has no required fields"; },
    },

    WARNINGS: {
      PAGE_COMMUNICATION: function(d) { return "Please check warnings for the triggers set on this " + d.lectureAlias + " and its activities."; },
      ACTIVITY_COMMUNICATION: function() { return "Please check warnings for the communications set on this activity."; },
      ACTIVITY_MISSING: function() { return "The activity used in this condition has been removed."; },
      POINTS_DISABLED: function(d) { return d.PointsAlias + " have been disabled."; },
      ROLE_MISSING: function() { return "Role used in this condition has been removed."; },
      NO_TODO_EXERCISES: function(d) { return "There are no " + d.assignmentsAlias + " that are marked as to-dos."; },
      DUE_DATE_MISSING: function() { return "Communication is no longer valid as Due date was removed. Please re-create the communication to set it up again."; },
      UNABLE_TO_TRACK_COMPLETION: function(d) { return "Communication is no longer valid as " + d.learnerAlias + " completion cannot be determined."; },
      REQUIRED_QUESTIONS_MISSING: function() { return "Communication is no longer valid as required questions was removed."; },
    },

    CREATE_DROPDOWN: {
      ADD_TRIGGER: function() { return "Add trigger"; },
      TO_THOSE_WHO_COMPLETED: function() { return "To those who completed"; },
      TO_THOSE_WHO_DID_NOT_COMPLETE: function() { return "To those who did NOT complete"; },
      SCHEDULE: function() { return "Schedule"; },
      NEW_EMAIL_BASED_ON_DUE_DATE: function() { return "New email based on the due date"; },
      NEW_ANNOUNCEMENT_BASED_ON_DUE_DATE: function() { return "New announcement based on the due date"; },
      NEW_EMAIL_BASED_ON_RELEASE_DATE: function() { return "New email based on the release date"; },
      NEW_ANNOUNCEMENT_BASED_ON_RELEASE_DATE: function() { return "New announcement based on the release date"; },
      NEW_EMAIL: function() { return "New Email"; },
      NEW_ANNOUNCEMENT: function() { return "New Announcement"; },
    },

    ACTIONS_DROPDOWN: {
      EDIT: function() { return "Edit"; },
      EDIT_ANNOUNCEMENT_ONLY: function() { return "Edit Announcement Only"; },
      VIEW: function() { return "View"; },
      DUPLICATE: function() { return "Duplicate"; },
      DELETE: function() { return "Delete"; },
      DISABLE: function() { return "Disable"; },
      ENABLE: function() { return "Enable"; },
    },

    ON_COMPLETE: {
      SEND_TO: function(d) { return "To: Any " + d.learnerAlias + " who has completed"; },
    },

    ON_NOT_COMPLETE: {
      SEND_TO: function(d) { return "To: Any " + d.learnerAlias + " who has NOT completed"; },
    },

    SCHEDULED_EMAIL: {
      TO: function() { return "To: "; },
    },

    TRIGGERS: {
      TITLE: {
        STEP_1: function() { return "Who Shall Receive This?"; },
        STEP_2: function() { return "Write the Message"; },
        STEP_3: function() { return "Preview"; },
      },

      CREATE: {
        NAME: function() { return "Create"; },
        SUBMITTING: function() { return "Creating"; },
        TITLE: function() { return "Create New Trigger"; },
        NEXT_BUTTON: {
          STEP_1: function() { return "Next: Write the Message"; },
          STEP_2: function() { return "Next: Preview"; },
        },

      },

      EDIT: {
        NAME: function() { return "Update"; },
        SUBMITTING: function() { return "Updating"; },
        TITLE: function() { return "Edit Trigger"; },
        NEXT_BUTTON: {
          STEP_1: function() { return "Next: Edit the Message"; },
          STEP_2: function() { return "Next: Preview"; },
        },

      },

      DUPLICATE: {
        NAME: function() { return "Duplicate"; },
        SUBMITTING: function() { return "Duplicating"; },
        TITLE: function() { return "Duplicate Trigger"; },
      },

      VIEW: {
        TITLE: function() { return "View Communication"; },
      },

    },

    SCHEDULED: {
      CREATE_NEW: function() { return "Create New"; },
      CREATE_NEW_EMAIL: function() { return "Create New Email"; },
      TITLE: {
        STEP_1: function() { return "Who shall receive this email?"; },
      },

      CREATE: {
        NAME: function() { return "Schedule"; },
        SUBMITTING: function() { return "Scheduling"; },
        TITLE: function() { return "Create New Email"; },
        SEND_NOW: function() { return "Send Now"; },
      },

      EDIT: {
        TITLE: function() { return "Edit Email"; },
      },

      DUPLICATE: {
        TITLE: function() { return "Duplicate Email"; },
      },

      VIEW: {
        TITLE: function() { return "View Communication"; },
      },

    },

    ANNOUNCEMENT: {
      CREATE: {
        NAME: function() { return "Schedule"; },
        SUBMITTING: function() { return "Scheduling"; },
        TITLE: function() { return "Create New Announcement"; },
        SEND_NOW: function() { return "Send Now"; },
      },

      EDIT: {
        TITLE: function() { return "Edit Announcement"; },
      },

      EDIT_ANNOUNCEMENT_ONLY: function() { return "Edit Announcement Only"; },
      DUPLICATE: {
        TITLE: function() { return "Duplicate Announcement"; },
      },

      VIEW: {
        TITLE: function() { return "View Communication"; },
      },

      FORM: {
        ANNOUNCEMENT: function() { return "Announcement:"; },
        HAS_EMAIL: function() { return "Also send as an email to everyone"; },
        PREVIEW_EMAIL: function() { return "Preview Email"; },
        CHANGE_USER: function() { return "Change"; },
        ANNOUNCEMENT_TITLE: function() { return "Announcement Title"; },
        ANNOUNCEMENT_BODY: function() { return "Type your announcement here..."; },
        PUSH_NOTIFICATION_LABEL: function() { return "A push notification to NovoEd Mobile App will be automatically included."; },
        PUSH_NOTIFICATION_PREVIEW: function() { return "Preview"; },
        PREVIEW_BACK: function() { return "Back to Edit"; },
        EMAIL_PREVIEW: function() { return "Preview Email"; },
        NOTIFICATION_PREVIEW: function() { return "Preview Push Notification"; },
        CHOOSE_ANNOUNCER: function() { return "Choose an Announcer"; },
      },

    },

    RECIPIENTS: {
      DEFAULT: {
        TRIGGER_LEARNER: function(d) { return d.LearnersAlias; },
        LEARNERS: function(d) { return d.LearnersAlias; },
        ADVISORS: function(d) { return d.CourseTitleAlias + " Advisors"; },
        COURSE_ADMINS: function(d) { return d.CourseAlias + " Admins"; },
        TEAM_LEADS: function(d) { return d.TeamAlias + " Leads"; },
        GROUP_ADMINS: function(d) { return d.GroupAlias + " Admins"; },
      },

      ALL: {
        TRIGGER_LEARNER: function(d) { return "All " + d.LearnersAlias; },
        LEARNERS: function(d) { return "All " + d.LearnersAlias; },
        ADVISORS: function(d) { return "All " + d.CourseTitleAlias + " Advisors"; },
        COURSE_ADMINS: function(d) { return "All " + d.CourseAlias + " Admins"; },
        TEAM_LEADS: function(d) { return "All " + d.TeamAlias + " Leads"; },
        GROUP_ADMINS: function(d) { return "All " + d.GroupAlias + " Admins"; },
      },

    },

    FILTERS: {
      DESCRIPTION: function() { return "Immediately after learner completes the condition you have set above, send the communication to those who meet all conditions"; },
      SCHEDULED_DESCRIPTION: function() { return "Immediately after the date you have setup above, send the communication to those who meet all conditions"; },
      MULTIPLE_SELECTIONS: function() { return "Multiple Selections"; },
      OPTIONAL: function() { return "(Optional)"; },
      ADD_MORE: function(d) { return "Add more filters to better target your " + d.learnersAlias; },
      FILTER_ROW_DESCRIPTION: function(recipientTitle: string) { return recipientTitle + " who meet the following criteria:"; },
      COMPLETED_COURSE: {
        HAS: function(d) { return "Has completed the " + d.courseAlias; },
        HAS_NOT: function(d) { return "Has NOT completed the " + d.courseAlias; },
        DEFAULT: function(d) { return "Has or Has NOT completed the " + d.courseAlias; },
        INFO: function(d) { return "For self-paced " + d.coursesAlias + ", this option is checked by default so emails won't go to those who have completed the " + d.courseAlias + " already. If you still want to email those " + d.learnersAlias + ", you can simply uncheck this filter."; },
        PLEASE_NOTE: function() { return "Please note: "; },
      },

      COMPLETED_ACTIVITY: {
        HAS: function() { return "Has completed a specific activity"; },
        HAS_WITH_ACTIVITY: function(activity: string) { return "Has completed " + activity; },
        HAS_WITH_ACTIVITY_QUESTION_MISSING: function(activity: string) { return "Has completed " + activity + " WARNING_ICON required questions missing"; },
        HAS_NOT: function() { return "Has NOT completed a specific activity"; },
        HAS_NOT_WITH_ACTIVITY: function(activity: string) { return "Has NOT completed " + activity; },
        HAS_NOT_WITH_ACTIVITY_QUESTION_MISSING: function(activity: string) { return "Has NOT completed " + activity + " WARNING_ICON required questions missing"; },
        VIDEO: function() { return "Video"; },
        QUIZ: function() { return "Quiz"; },
        SURVEY: function() { return "Survey"; },
        TEAM_FORMATION: function(d) { return d.TeamAlias + " Formation"; },
        DISCUSSION: function() { return "Discussion"; },
        SELECT_TYPE: function() { return "Select Type"; },
        SELECT_ACTIVITY: function() { return "Select the Activity"; },
        NO_ACTIVITIES: function() { return "No activities"; },
        THIS_ACTIVITY: function() { return "this activity"; },
        THIS_LESSON: function() { return "this lesson"; },
        ACTIVITY_MISSING: function() { return "activity missing"; },
      },

      COMPLETED_ASSIGNMENTS: {
        AT_LEAST: {
          DEFAULT: function(d) { return "Completed at least X number of " + d.assignmentsAlias + " that are marked as to-dos"; },
          LABEL: function(d) { return "Completed at least " + select(d.warningIcon, { ICON: "ICON", other: "" }) + d.input + " " + plural(d.input, 0, en, { one: d.assignmentAlias, other: d.assignmentsAlias }) + " that " + plural(d.input, 0, en, { one: "is", other: "are" }) + " marked as " + plural(d.input, 0, en, { one: "to-do", other: "to-dos" }); },
        },

        DEFAULT: function(d) { return "Completed less than X number of " + d.assignmentsAlias + " that are marked as to-dos"; },
        LABEL: function(d) { return "Completed less than " + select(d.warningIcon, { ICON: "ICON", other: "" }) + d.input + " " + plural(d.input, 0, en, { one: d.assignmentAlias, other: d.assignmentsAlias }) + " that " + plural(d.input, 0, en, { one: "is", other: "are" }) + " marked as " + plural(d.input, 0, en, { one: "to-do", other: "to-dos" }); },
        TOTAL: function(count: number) { return "(" + count + " total)"; },
        NO_ASSIGNMENTS: function(d) { return "No " + d.assignmentsAlias; },
        ARIA_LABEL: function(d) { return "Completed " + d.assignmentAlias + " Count"; },
      },

      ROLES: {
        BY_ROLE: function() { return "Filter by role"; },
        NO_ROLES: function() { return "No Roles"; },
        TITLE: function(role: string) { return role + " Roles"; },
        DISPLAY: function(roleTitles: string) { return "Has " + roleTitles; },
        CATALYST: function() { return "Catalyst"; },
        ALUMNI_COACH: function() { return "Alumni Coach"; },
        TEAM_CAPTAIN: function(d) { return d.TeamAlias + " Captain"; },
        ROLE_MISSING: function() { return "role missing"; },
        GROUPS: {
          LEARNER: function(d) { return d.LearnerAlias + " Roles"; },
          COURSE_ADMIN: function(d) { return "Roles with " + d.CourseAlias + " Admin Permissions Only"; },
          COURSE_ADMIN_AND_ADVISOR: function(d) { return "Roles with " + d.CourseAlias + " Admin Permissions & Advisor/Monitor Permissions"; },
          ADVISOR: function() { return "Roles with Advisor/Monitor Permissions Only"; },
        },

      },

      ACTIVE_DAYS: {
        ACTIVE: {
          DEFAULT: function() { return "Has been active at least once in the last X days"; },
          LABEL: function(input: string) { return "Has been active at least once in the last " + input + " " + plural(input, 0, en, { one: " day ", other: " days " }); },
          ARIA_LABEL: function() { return "Has been active at least once in the last X days"; },
        },

        INACTIVE: {
          DEFAULT: function() { return "Has been inactive for more than X days"; },
          LABEL: function(input: string) { return "Has been inactive for more than " + input + " " + plural(input, 0, en, { one: " day ", other: " days " }); },
          ARIA_LABEL: function() { return "Inactive days count"; },
        },

      },

      EARNED_POINTS: {
        AT_LEAST: {
          DEFAULT: function(d) { return "Earned at least X " + d.pointsAlias; },
          LABEL: function(d) { return "Earned at least " + select(d.warningIcon, { ICON: "ICON", other: "" }) + d.input + " " + plural(d.input, 0, en, { one: d.pointAlias, other: d.pointsAlias }); },
          ARIA_LABEL: function(d) { return "Earned at least X " + d.pointsAlias; },
        },

        MORE_THAN: {
          DEFAULT: function(d) { return "Has earned more than X " + d.pointsAlias; },
          LABEL: function(d) { return "Has earned more than " + select(d.warningIcon, { ICON: "ICON", other: "" }) + d.input + " " + plural(d.input, 0, en, { one: d.pointAlias, other: d.pointsAlias }); },
          ARIA_LABEL: function(d) { return "Earned more " + d.pointsAlias; },
        },

        LESS_THAN: {
          DEFAULT: function(d) { return "Has earned fewer than X " + d.pointsAlias; },
          LABEL: function(d) { return "Has earned fewer than " + select(d.warningIcon, { ICON: "ICON", other: "" }) + d.input + " " + plural(d.input, 0, en, { one: d.pointAlias, other: d.pointsAlias }); },
          ARIA_LABEL: function(d) { return "Earned fewer " + d.pointsAlias; },
        },

        TOTAL: function(d) { return "(" + d.count + " " + plural(d.count, 0, en, { one: d.pointAlias, other: d.pointsAlias }) + " total)"; },
        NOT_ENABLED: function(d) { return d.PointsAlias + " are not enabled"; },
      },

      ENROLLED_LAST_DAYS: {
        DEFAULT: function() { return "Enrolled in the last X days"; },
        LABEL: function(input: string) { return "Enrolled in the last " + input + " " + plural(input, 0, en, { one: " day ", other: " days " }); },
        ARIA_LABEL: function() { return "Enrolled in the last days"; },
      },

      LOGGED_IN: {
        DEFAULT: function() { return "Has logged in / NOT logged in"; },
        HAS: function() { return "Has logged in"; },
        HAS_NOT_COURSE_DATE: function(d) { return "Has NOT logged in since " + d.courseAlias + " start date"; },
        HAS_NOT_RELEASE_DATE: function(d) { return "Has NOT logged in since " + d.courseAlias + " release date"; },
      },

      ENROLLED_IN_COURSE: function(d) { return "Enrolled in " + d.CourseAlias; },
      VISITS_COURSE_HOME: function(d) { return "Visits " + d.courseAlias + " home for the first time"; },
      LIVE_EVENT_SESSION: {
        HAS_REGISTERED: function() { return "Has registered to specific live event session"; },
        HAS_NOT_REGISTERED: function() { return "Has NOT registered to specific live event"; },
        SELECT_EVENT: function() { return "Select Live Event"; },
        SELECT_SESSION: function() { return "Select Session"; },
        NO_MULTI_SESSION: function() { return "No Multi-Session Live Events"; },
        REGISTERED_TO_EVENT: function() { return "Has registered to live event"; },
      },

    },

    SEND_ON: {
      SCHEDULED_INFO: {
        DEFAULT: function(scheduledDate: string) { return "will be sent on " + scheduledDate; },
        PAST: function(scheduledDate: string) { return "was sent on " + scheduledDate; },
        ERROR_PAST: function(scheduledDate: string) { return scheduledDate; },
        PAST_DATE_WARNING: function() { return "Send date is in the past, this communication will be sent immediately"; },
      },

      ARIA_LABEL: function() { return "Send X Days Count"; },
      DUE_DATE: {
        LABEL: function(deadline: string, prefixedTitle: string) { return prefixedTitle + " EDIT_ICON (Due date: " + deadline + ")"; },
        ON: {
          TITLE: function() { return "Send on due date"; },
          OPTION: function() { return "Send on"; },
          DISPLAY_ACTIVITY: function(activity: string, info: string) { return "On due date of " + activity + " (" + info + ")"; },
          ERROR: function(activity: string) { return "On due date of " + activity + " WARNING_ICON due date missing"; },
        },

        BEFORE: {
          TITLE: function(input: string) { return "Send " + input + " " + plural(input, 0, en, { one: " day ", other: " days " }) + " before due date"; },
          OPTION: function() { return "Send X days before"; },
          DISPLAY_ACTIVITY: function(activity: string, days: string, info: string) { return days + " " + plural(days, 0, en, { one: " day ", other: " days " }) + " before due date of " + activity + " (" + info + ")"; },
          ERROR: function(activity: string, days: string) { return days + " " + plural(days, 0, en, { one: " day ", other: " days " }) + " before due date of " + activity + " WARNING_ICON due date missing"; },
        },

        AFTER: {
          TITLE: function(input: string) { return "Send " + input + " " + plural(input, 0, en, { one: " day ", other: " days " }) + " after due date"; },
          OPTION: function() { return "Send X days after"; },
          DISPLAY_ACTIVITY: function(activity: string, days: string, info: string) { return days + " " + plural(days, 0, en, { one: " day ", other: " days " }) + " after due date of " + activity + " (" + info + ")"; },
          ERROR: function(activity: string, days: string) { return days + " " + plural(days, 0, en, { one: " day ", other: " days " }) + " after due date of " + activity + " WARNING_ICON due date missing"; },
        },

        SEND_NOW: {
          DISPLAY_ACTIVITY: function(activity: string, info: string) { return "Send Now " + activity + " (" + info + ")"; },
        },

      },

      RELEASE_DATE: {
        LABEL: function(releaseDate: string, title: string) { return title + " EDIT_ICON (Release on " + releaseDate + ")"; },
        ON: {
          TITLE: function() { return "Send on release date"; },
          OPTION: function() { return "Send on"; },
          DISPLAY_ACTIVITY: function(activity: string, info: string) { return "Send on release date of " + activity + " (" + info + ")"; },
        },

        AFTER: {
          TITLE: function(input: string) { return "Send " + input + " " + plural(input, 0, en, { one: " day ", other: " days " }) + " after release date"; },
          OPTION: function() { return "Send X days after"; },
          DISPLAY_ACTIVITY: function(activity: string, days: string, info: string) { return days + " " + plural(days, 0, en, { one: " day ", other: " days " }) + " after release date of " + activity + " (" + info + ")"; },
        },

        SEND_NOW: {
          DISPLAY_ACTIVITY: function(activity: string, info: string) { return "Send Now " + activity + " (" + info + ")"; },
        },

      },

      COMPLETE_ACTIVITY: {
        IMMEDIATELY: {
          TITLE: function(d) { return "Send immediately after " + d.learnerAlias + " completed this activity"; },
          OPTION: function() { return "Send immediately after"; },
          DISPLAY_ACTIVITY: function(d) { return "Immediately after " + d.learnerAlias + " completed " + d.activity; },
          ERROR: function(d) { return "Immediately after " + d.learnerAlias + " completed " + d.activity + " WARNING_ICON required questions missing"; },
        },

        DAYS_AFTER: {
          TITLE: function(d) { return "Send " + d.input + " " + plural(d.input, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " completed this activity"; },
          OPTION: function() { return "Send X days after"; },
          DISPLAY_ACTIVITY: function(d) { return d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " completed " + d.activity; },
          ERROR: function(d) { return d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " completed " + d.activity + " WARNING_ICON required questions missing"; },
        },

      },

      DONE_FOLLOWING: {
        IMMEDIATELY: {
          TITLE: function(d) { return "Send immediately after " + d.learnerAlias + " has done one of the following:"; },
          OPTION: function() { return "Send immediately after"; },
          EVENT: {
            ENROLLED_IN_COURSE: function(d) { return "Immediately after " + d.learnerAlias + " enrolled in " + d.courseAlias; },
            VISITS_HOME_PAGE: function(d) { return "Immediately after " + d.learnerAlias + " visits " + d.courseAlias + " home for the first time"; },
            HAS_COMPLETED: function(d) { return "Immediately after " + d.learnerAlias + " completed " + d.activity; },
            HAS_COMPLETED_QUESTION_MISSING: function(d) { return "Immediately after " + d.learnerAlias + " completed " + d.activity + " WARNING_ICON required questions missing"; },
            ATLEAST_X_POINTS: function(d) { return "Immediately after " + d.learnerAlias + " earned at least " + select(d.warningIcon, { ICON: "ICON", other: "" }) + d.input + " " + plural(d.input, 0, en, { one: d.pointAlias, other: d.pointsAlias }); },
            COMPLETED_X_ASGMT_AS_TODO: function(d) { return "Immediately after " + d.learnerAlias + " completed at least " + select(d.warningIcon, { ICON: "ICON", other: "" }) + d.input + " " + plural(d.input, 0, en, { one: d.assignmentAlias, other: d.assignmentsAlias }) + " that " + plural(d.input, 0, en, { one: "is", other: "are" }) + " marked as " + plural(d.input, 0, en, { one: "to-do", other: "to-dos" }); },
            COMPLETED_COURSE: function(d) { return "Immediately after " + d.learnerAlias + " completed the " + d.courseAlias; },
            REGISTERED_TO_LIVE_EVENT: function(d) { return "Immediately after " + d.learnerAlias + " registers for a session in Live Event: " + d.activity; },
          },

        },

        DAYS_AFTER: {
          TITLE: function(d) { return "Send " + d.input + " " + plural(d.input, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " has done one of the following"; },
          OPTION: function() { return "Send X days after"; },
          EVENT: {
            ENROLLED_IN_COURSE: function(d) { return "Send " + d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " enrolled in " + d.courseAlias; },
            VISITS_HOME_PAGE: function(d) { return "Send " + d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " visits " + d.courseAlias + " home for the first time"; },
            HAS_COMPLETED: function(d) { return "Send " + d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " completed " + d.activity; },
            HAS_COMPLETED_QUESTION_MISSING: function(d) { return "Send " + d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " completed " + d.activity + " WARNING_ICON required questions missing"; },
            ATLEAST_X_POINTS: function(d) { return "Send " + d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " earned at least " + select(d.warningIcon, { ICON: "ICON", other: "" }) + d.input + " " + plural(d.input, 0, en, { one: d.pointAlias, other: d.pointsAlias }); },
            COMPLETED_X_ASGMT_AS_TODO: function(d) { return "Send " + d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " completed at least " + select(d.warningIcon, { ICON: "ICON", other: "" }) + d.input + " " + plural(d.input, 0, en, { one: d.assignmentAlias, other: d.assignmentsAlias }) + " that " + plural(d.input, 0, en, { one: "is", other: "are" }) + " marked as " + plural(d.input, 0, en, { one: "to-do", other: "to-dos" }); },
            COMPLETED_COURSE: function(d) { return "Send " + d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " completed the " + d.courseAlias; },
            REGISTERED_TO_LIVE_EVENT: function(d) { return "Send " + d.days + " " + plural(d.days, 0, en, { one: " day ", other: " days " }) + " after " + d.learnerAlias + " registers for a session in Live Event: " + d.activity; },
          },

        },

      },

      CUSTOM: {
        NOW: {
          TITLE: function() { return "Send Now"; },
          OPTION: function() { return "Send Now"; },
          DISPLAY_ACTIVITY: {
            DEFAULT: function() { return "Send Now"; },
            SENT: function(activity: string, scheduledDate: string) { return "Manually sent on " + activity + " " + scheduledDate; },
          },

        },

        LATER: {
          TITLE: function() { return "Schedule for Later"; },
          OPTION: function() { return "Schedule for Later"; },
          DISPLAY_ACTIVITY: {
            DEFAULT: function(activity: string, scheduledDate: string) { return "Manually scheduled for " + activity + " " + scheduledDate; },
            SENT: function(activity: string, scheduledDate: string) { return "Manually sent on " + activity + " " + scheduledDate; },
          },

        },

      },

      WARNING: {
        TITLE: function() { return "Please note:"; },
        NOTE: function() { return "Users who already met the trigger criteria will have the message sent on the original timing. Send timing changes will only apply to people who meet the trigger criteria after you save this change."; },
      },

      PAST_DATE: {
        TITLE: function() { return "Warning"; },
        NOTE: function() { return "Please note: scheduled sent date is in the past, this communication will be sent immediately"; },
      },

    },

    STEPS: {
      PLEASE_COMPLETE: function(stepCount: number) { return "Please complete step " + stepCount + " first"; },
      GO_BACK: function(stepCount: number) { return "Go back to step " + stepCount; },
      GO_TO: function(stepCount: number) { return "Go to step " + stepCount; },
    },

    UPDATION: {
      ALREADY_ACTIVATED: {
        TITLE: function() { return "Are you sure?"; },
        WARNING: function(d) { return "Are you sure you want to save the changes? Communication will not be resent to " + d.learnersAlias + " who have received it previously."; },
      },

    },

    DELETION: {
      TITLE: {
        DEFAULT: function() { return "Delete Communication"; },
        ANNOUNCEMENT: function() { return "Delete Announcement"; },
      },

      WARNING: {
        DEFAULT: function() { return "Are you sure you want to delete this communication?"; },
        ANNOUNCEMENT: {
          SCHEDULED_OR_EMAIL_ONLY: function() { return "Are you sure you want to delete this scheduled announcement?"; },
          ANNOUNCEMENT_ALREADY_POSTED: function(d) { return "Are you sure you want to delete the announcement from the " + d.courseAlias + "?"; },
          EMAIL_ALREADY_SENT: function(d) { return "You can delete the announcement from the " + d.courseAlias + " , however the email was already sent and can not be deleted."; },
        },

      },

      DELETE_ANNOUNCEMENT_ONLY: function() { return "Delete Announcement Only"; },
    },

    SUBMIT_CONFIRMATION: {
      TITLE: {
        EMAIL: function() { return "Send Email Now"; },
        ANNOUNCEMENT: function() { return "Post Announcement"; },
      },

      WARNING: {
        EMAIL: function() { return "You are about to send an email to everyone who met the condition. Are you sure?"; },
        ANNOUNCEMENT_ONLY: function() { return "You are about to post an announcement to all users. Are you sure?"; },
        ANNOUNCEMENT_AND_EMAIL: function() { return "You are about to post an announcement and send an email to all users. Are you sure?"; },
      },

    },

    WELCOME_EMAIL: {
      TRIGGER: function() { return "Send When Enrolled"; },
      ENABLE: function() { return "Enable Welcome Email"; },
      ENABLING: function() { return "Enabling Welcome Email..."; },
      DISABLE: {
        WARNING_TITLE: function() { return "Disable Welcome Email"; },
        WARNING_TEXT: function() { return "Are you sure you want to disable the welcome email? If disabled newly enrolled user will no longer receive a welcome email."; },
      },

      CREATE: {
        TITLE: function() { return "Create Welcome Email"; },
      },

      EDIT: {
        TITLE: function() { return "Edit Welcome Email"; },
      },

      VIEW: {
        TITLE: function() { return "Preview Welcome Email"; },
      },

      ADD: {
        TITLE: function() { return "Add Welcome Email"; },
        ADVISOR: function() { return "Add advisor email"; },
      },

      DELETE: {
        MENTOR: {
          WARNING_TITLE: function() { return "Delete Welcome Email for Advisors"; },
          WARNING_TEXT: function(d) { return "Are you sure you want to delete the welcome email for advisors? If deleted, newly enrolled advisors will no longer receive this welcome email. Instead, advisors will receive the welcome email sent to " + d.learnersAlias + "."; },
        },

      },

      RECIPIENT: {
        ALL: function() { return "Everyone When Enrolled"; },
        ADVISORS: function() { return "Advisors When Enrolled"; },
        LEARNERS_COURSE_ADMINS: function() { return "Learners and Course Admins"; },
        LEARNERS_COURSE_ADMINS_WHEN_ENROLLED: function() { return "Learners and Course admins When Enrolled"; },
        ALL_ADVISORS: function() { return "All Advisors"; },
      },

      PREVIEW_EMAIL: function() { return "Preview Email"; },
    },

  },

  JOURNEY_COMMUNICATIONS: {
    NO_CONTENT: {
      AUTOMATED: function() { return "No automated communications yet, use the <span class=\"bold\">Create New Automated Email</span> button to get started."; },
      DRAFTS: function() { return "No Drafts Yet"; },
      SCHEDULED: function() { return "No scheduled communications yet, use the <span class=\"bold\">New Scheduled Email</span> button to get started."; },
      SCHEDULED_FUTURE: function() { return "No upcoming Date based Emails yet"; },
    },

    HEADER: function() { return "Journey Communications"; },
    TABS: {
      AUTOMATED: function() { return "Automated"; },
      SCHEDULED: function() { return "Scheduled"; },
      DRAFTS: function() { return "Drafts"; },
      TITLE: {
        AUTOMATED: function() { return "Automated Communications"; },
        SCHEDULED: function() { return "Scheduled Communications"; },
        DRAFTS: function() { return "Draft Communications"; },
      },

      DESCRIPTION: {
        AUTOMATED: {
          ENABLE: function() { return "Enable Welcome Email"; },
          INTRO_FIRST: function() { return "Automated Communications allow you to define communications based on journey enrollment date to send personalized communications to your learners based on the conditions you have set."; },
          TEMPORARY_MESSAGE: function() { return "<b>Coming soon:</b> you will be able to define communications based on Journey enrollment date to send personalized communications to learners based on the conditions you have set."; },
        },

        SCHEDULED: {
          INTRO_FIRST: function() { return "To send a new communication immediately or schedule it on a specific calendar date, please use the New Scheduled Email button above. All your scheduled communications for this learning journey will be listed here."; },
        },

      },

    },

    SCHEDULED: {
      CREATE_NEW: function() { return "New Scheduled Email"; },
      TITLE: {
        STEP_1: function() { return "Who shall receive this email?"; },
      },

      CREATE: {
        TITLE: function() { return "Create New Scheduled Communication"; },
      },

      EDIT: {
        TITLE: function() { return "Edit Email"; },
      },

      DUPLICATE: {
        TITLE: function() { return "Duplicate Email"; },
      },

      VIEW: {
        TITLE: function() { return "View Communication"; },
      },

    },

    AUTOMATED: {
      CREATE_NEW: function() { return "Create New Automated Email"; },
      SEND_TO: {
        LABEL: function() { return "To: <b>Any Learners who have met following conditions:</b>"; },
      },

      SEND_ON: {
        LABEL: function(input: string) { return "Send " + input + " " + plural(input, 0, en, { one: " day ", other: " days " }) + " after learner's journey enrollment date"; },
        ARIA_LABEL: function() { return "Send on X days after enrollment"; },
      },

      TITLE: {
        STEP_1: function() { return "Who shall receive this email?"; },
      },

      CREATE: {
        TITLE: function() { return "Create New Automated Email"; },
      },

      EDIT: {
        TITLE: function() { return "Edit Email"; },
      },

      DUPLICATE: {
        TITLE: function() { return "Duplicate Email"; },
      },

      VIEW: {
        TITLE: function() { return "View Communication"; },
      },

    },

    RECIPIENTS: {
      ALL: {
        LEARNERS: function(d) { return "All " + d.LearnersAlias; },
        JOURNEY_ADMINS: function(d) { return "All " + d.CourseAlias + " Admins"; },
      },

    },

    FILTERS: {
      SCHEDULED_DESCRIPTION: function() { return "Immediately after the date you have setup above, send the communication to those who meet all conditions"; },
      MULTIPLE_SELECTIONS: function() { return "Multiple Selections"; },
      OPTIONAL: function() { return "(Optional)"; },
      ADD_MORE: function(d) { return "Add more filters to better target your " + d.learnersAlias; },
      COMPLETED_JOURNEY: {
        HAS: function(d) { return "Has completed the " + d.CourseAlias; },
        HAS_NOT: function(d) { return "Has NOT completed the " + d.CourseAlias; },
        DEFAULT: function(d) { return "Has or Has NOT completed the " + d.CourseAlias; },
      },

      ACTIVE_DAYS: {
        INACTIVE: {
          DEFAULT: function() { return "Has been inactive in the Journey for more than X days"; },
          LABEL: function(input: string) { return "Has been inactive in the Journey for more than " + input + " " + plural(input, 0, en, { one: " day ", other: " days " }); },
          NOTE: function() { return "Please note: learners must have been active in the Journey at least once in order to receive this email."; },
          ARIA_LABEL: function() { return "Inactive days count"; },
        },

        NEVER_ACTIVE: {
          DEFAULT: function() { return "Never active in Journey"; },
          ARIA_LABEL: function() { return "Never active in Journey"; },
        },

      },

      ENROLLED_LAST_DAYS: {
        DEFAULT: function() { return "Enrolled in the Journey in the last X days"; },
        LABEL: function(input: string) { return "Enrolled in the Journey in the last " + input + " " + plural(input, 0, en, { one: " day ", other: " days " }); },
        ARIA_LABEL: function() { return "Enrolled in the Journey in the last days"; },
      },

      COURSE_ENROLLMENT: {
        ENROLLED: {
          DEFAULT: function() { return "Has enrolled in a specific course"; },
          LABEL: function(course: string) { return "Enrolled in " + course; },
          ARIA_LABEL: function() { return "Has enrolled in a course"; },
        },

        NOT_ENROLLED: {
          DEFAULT: function() { return "Has NOT enrolled in a specific course"; },
          LABEL: function(course: string) { return "Not enrolled in " + course; },
          ARIA_LABEL: function() { return "Has not enrolled in a course"; },
        },

        COURSE_MISSING: function() { return "course missing"; },
      },

      COMPLETED_COURSE: {
        COMPLETED: {
          DEFAULT: function() { return "Has completed a specific course"; },
          LABEL: function(course: string) { return "Has completed " + course; },
          ARIA_LABEL: function() { return "Has completed a course"; },
        },

        NOT_COMPLETED: {
          DEFAULT: function() { return "Has NOT completed a specific course"; },
          LABEL: function(course: string) { return "Has not completed " + course; },
          ARIA_LABEL: function() { return "Has not completed a course"; },
        },

        COURSE_MISSING: function() { return "course missing"; },
      },

      COMPLETED_COLLECTION: {
        COMPLETED: {
          DEFAULT: function() { return "Has completed a specific collection"; },
          LABEL: function(collection: string) { return "Has completed " + collection; },
          ARIA_LABEL: function() { return "Has completed a collection"; },
        },

        NOT_COMPLETED: {
          DEFAULT: function() { return "Has NOT completed a specific collection"; },
          LABEL: function(collection: string) { return "Has not completed " + collection; },
          ARIA_LABEL: function() { return "Has not completed a collection"; },
        },

        COLLECTION_MISSING: function() { return "collection missing"; },
        COLLECTION_GENERIC_NAME: function() { return "Untitled Collection"; },
      },

      NOT_ENROLLED_IN_ANY_COURSE: {
        DEFAULT: function() { return "Has not enrolled in any course in the Journey"; },
        LABEL: function() { return "Has not enrolled in any course in the Journey"; },
        ARIA_LABEL: function() { return "Has not enrolled in any course in the Journey"; },
      },

    },

    SEND_ON: {
      DUE_DATE: {
        LABEL: function(deadline: string, prefixedTitle: string) { return prefixedTitle + " EDIT_ICON (Due date: " + deadline + ")"; },
      },

      RELEASE_DATE: {
        LABEL: function(releaseDate: string, title: string) { return title + " EDIT_ICON (Release on " + releaseDate + ")"; },
      },

    },

    WELCOME_EMAIL: {
      CREATE: {
        TITLE: function() { return "Create Welcome Email"; },
      },

      EDIT: {
        TITLE: function() { return "Edit Welcome Email"; },
      },

      VIEW: {
        TITLE: function() { return "Preview Welcome Email"; },
      },

      ADD: {
        TITLE: function() { return "Add Welcome Email"; },
      },

    },

    SELECTOR: {
      PLEASE_SELECT: function() { return "Please Select"; },
    },

    WARNINGS: {
      COURSE_MISSING: function() { return "The course used in this condition has been removed."; },
      COLLECTION_MISSING: function() { return "The collection used in this condition has been removed."; },
    },

  },

  LEARNER_PROGRESS: {
    HEADER: function(d) { return d.LearnerAlias + " Progress"; },
    TABS: {
      TOTAL_LEARNERS: function(d) { return "Total " + d.LearnersAlias; },
      COMPLETED: function() { return "Completed"; },
      IN_PROGRESS: function() { return "In Progress"; },
      MISSED_DEADLINES: function() { return "Missed Deadlines"; },
      EARNED_FEWER_THAN: function() { return "Has earned fewer than X points:"; },
      EARNED_FEWER_THAN_SUFFIX: function(minPoints: string) { return minPoints + " points"; },
      INACTIVE_HOVER_DESCRIPTION: function() { return "Has been inactive for more than:"; },
      INACTIVE_HOVER_DAYS: function(days: string) { return days + " days"; },
      MENU_EDIT_FILTERS: function() { return "Edit Filters"; },
      MENU_DELETE: function() { return "Delete"; },
      DELETE_CONFIRM_HEADER: function() { return "Remove Saved View"; },
      DELETE_CONFIRM_CANCEL: function() { return "Cancel"; },
      DELETE_CONFIRM_YES: function() { return "Yes"; },
      NEVER_ACTIVE: function() { return "Never Active"; },
      SCROLL_LEFT: function() { return "Scroll tabs left"; },
      SCROLL_RIGHT: function() { return "Scroll tabs right"; },
    },

    COLUMN_HEADERS: {
      LEARNER_NAME: function(d) { return d.LearnerAlias + " Name"; },
      LAST_ACTIVE_DATE: function() { return "Last Active Date"; },
      PROGRESS: function() { return "Progress"; },
      CUSTOMIZE_THIS_TABLE: function() { return "Customize This Table"; },
      PROGRESS_DISABLED: function(max: string) { return "Sort by progress is available for " + max + " or less users"; },
    },

    LAST_ACTIVE_DATE: {
      VISITED_COURSE_HOME: function(d) { return "Visited " + d.CourseAlias + " Home"; },
      ENROLLMENT_DATE: function() { return "Enrollment Date:"; },
      FIRST_COURSE_HOME_VISIT: function(d) { return "First " + d.courseAlias + " home visit:"; },
    },

    PROGRESS: {
      COMPLETED: function() { return "Completed"; },
      COMPLETED_TOOLTIP: function(date: string) { return "Manually Granted Completion on " + date; },
      REQUIRED_TODOS: function() { return "Required To-dos"; },
    },

    SECTIONS: {
      NOT_STARTED: function() { return "Not Started"; },
      COMPLETED: function() { return "Completed"; },
      NO_PROGRESS_TOOLTIP: function() { return "No Progress"; },
      NO_COMPLETED_TOOLTIP: function(d) { return "No " + d.lectureAlias + " pages completed."; },
      SOME_COMPLETED_TOOLTIP: function(d) { return "Some " + d.lectureAlias + " pages completed."; },
      ALL_COMPLETED_TOOLTIP: function(d) { return "All " + d.lectureAlias + " pages completed."; },
    },

    OPTIONS: {
      EMAIL_USER: function() { return "Email User"; },
      SEND_A_MESSAGE: function() { return "Send a Message"; },
      GRANT_MANUAL_COMPLETION: function() { return "Grant Manual Completion"; },
      AUTOMATED_COMPLETION_GRANTED: function() { return "(Automated Completion Granted)"; },
      REVOKE_MANUAL_COMPLETION: function() { return "Revoke Manual Completion"; },
      GRANT_MANUAL_COMPLETION_SUCCESS: function(fullName: string) { return fullName + " has been granted manual completion."; },
      REVOKE_MANUAL_COMPLETION_SUCCESS: function(fullName: string) { return fullName + "'s completion status has been revoked."; },
      AWARD_EXTRA_POINTS: function(d) { return "Award Extra " + d.PointsAlias; },
      GRANT_LATE_SUBMISSION_PERMIT: function() { return "Grant Late Submission Permit"; },
      RESET_ATTEMPTS: function() { return "Reset Attempts"; },
    },

    CUSTOMIZE_TABLE: {
      CUSTOMIZE: function() { return "Customize"; },
      RESET_TO_DEFAULT: function() { return "Reset to Default"; },
      RESET_TOOLTIP: function() { return "By default, 5 most recently released sections/subsections are displaying."; },
      APPLY_FILTERS: function() { return "Apply"; },
      DESCRIPTION: function(d) { return "Please select the section/sub-section to display the " + d.learnerAlias + " progress. Select less than 10 for best experience."; },
    },

    SEARCH_BY: function() { return "Search by name or email"; },
    FILTERS: {
      BUTTON: function() { return "Filters"; },
      TITLE: function() { return "Filters"; },
      RESET_FILTERS: function() { return "Reset Filters"; },
      APPLY_FILTERS: function() { return "Apply Filters"; },
      DESCRIPTION: function() { return "Please select filters below to find the learners who need your attention:"; },
      INACTIVE_FOR_MORE_THAN: function() { return "Has been inactive for more than"; },
      INACTIVE_FOR_MORE_THAN_X_DAYS: function() { return "Has been inactive for more than X days"; },
      NAME_OF_VIEW: function() { return "Name of this View"; },
      DAYS: function() { return "days"; },
      HAS_NOT_COMPLETED: function() { return "Has NOT completed:"; },
      HAS_NOT_COMPLETED_SPECIFIC: function() { return "Has NOT completed a specific assignment"; },
      NO_ASSIGNMENTS: function(d) { return "No " + d.assignmentsAlias; },
      HAS_EARNED_FEWER_THAN: function() { return "Has earned fewer than"; },
      HAS_EARNED_FEWER_THAN_X_POINTS: function() { return "Has earned fewer than X points"; },
      POINTS: function() { return "points"; },
      POINTS_TOTAL: function(totalPoints: string) { return "(" + totalPoints + " points total)"; },
      POINTS_NOT_ENABLED: function() { return "Points are not enabled"; },
      EARNED_FEWER_DETAIL: function(minPoints: string) { return "has earned fewer than " + minPoints + " points"; },
      EARNED_FEWER_DETAIL_STANDALONE: function(minPoints: string) { return "Learner has earned fewer than " + minPoints + " points"; },
      PLEASE_SELECT: function() { return "Please Select"; },
      FILTERED_RESULTS_FOR: function() { return "Filtered Results for"; },
      CLEAR: function() { return "Clear"; },
      SAVE_THIS_VIEW: function() { return "Save This View"; },
      HAS_NOT_COMPLETED_PREFIX: function() { return "Learner has not completed"; },
      INACTIVE_DETAIL: function(days: string) { return "has been inactive for more than " + days + " days"; },
      INACTIVE_DETAIL_STANDALONE: function(days: string) { return "Learner has been inactive for more than " + days + " days"; },
      BUTTON_WITH_COUNT: function(count: number) { return "Filters (" + count + ")"; },
      DEFAULT_VIEW_NAME: function() { return "Needs Attention"; },
    },

    SAVED_VIEWS: {
      SAVE_VIEW_TITLE: function() { return "Save This View"; },
      SAVE_VIEW_DESCRIPTION: function() { return "Name this view for quick access on the Learner Progress Dashboard:"; },
      VIEW_NAME_PLACEHOLDER: function() { return "Enter view name"; },
      SAVE: function() { return "Save"; },
      DELETE_SUCCESS_HEADER: function(viewName: string) { return "Success! \"" + viewName + "\""; },
      DELETE_SUCCESS_MESSAGE: function() { return "View has been deleted."; },
    },

  },

  ICON_LIBRARY: {
    HEADER: function() { return "Icon Library"; },
    TOOLTIP: function() { return "Click to Insert"; },
  },

  ORG_LEVEL_PROFILE: {
    PROFILE: function() { return "Profile"; },
    LOADING_PROFILE: function() { return "Loading Profile..."; },
    VIEW_PROFILE: function() { return "View Org Level Profile"; },
    FIELD_MODIFIER: {
      REMOVE: function() { return "Remove"; },
      UPLOAD: function() { return "Upload"; },
      HIDDEN: function() { return "(Hidden)"; },
      DROPDOWN: function() { return "Dropdown"; },
      LOCATION: function() { return "Location"; },
      LONG_TEXT: function() { return "Long Text"; },
      HIDE: function() { return "Hide in Profile"; },
      SHOW: function() { return "Show in Profile"; },
      ICON_COLOR: function() { return "Icon Color"; },
      SHORT_TEXT: function() { return "Short Text"; },
      NOT_EDITABLE: function() { return "Not Editable"; },
      FORM_TYPE_TITLE: function() { return "Please Select"; },
      PICK_FROM_LIBRARY: function() { return "Pick from Library"; },
      CHANGE_ICON_COLOR: function() { return "Change Icon Color"; },
      SELECT_OPTIONS_PLACEHOLDER: function() { return "Type list of options here, use comma to separate each option"; },
      INVALID_FILE: function() { return "We could not upload your image. Please make sure it is a valid image file that is jpg, jpeg, or png format and under 2MB in size."; },
      CSV_MANAGED: function(isCsvManaged: string) { return "Mark as Managed by " + select(isCsvManaged, { true: "Learners", other: "CSV or Integration" }); },
      CSV_MANAGED_AND_DISABLED: function() { return "Cannot be Managed by Learner as Profile field is used in Entitlement settings. To Mark as Managed by Learner, please clear the entitlements using  this profile field first."; },
      CSV_MANAGE_WARNING: function(isCsvManaged: string) { return "Org level profile and all course profiles will be\tupdated based on this change." + select(isCsvManaged, { true: "<br />Please note: profile fields that are no longer managed by Org cannot be used in entitlement settings and will be editable in the profile.", other: "" }); },
      MANAGED_VIA_SSO: function(attrName: string) { return "Managed via SSO attribute: " + attrName; },
      MANAGED_VIA_CSV: function() { return "Managed via CSV"; },
    },

    ORG_FIELDS_DEFAULT_TEXTS: {
      JOB_TITLE: function() { return "What's your job title?"; },
      EDUCATION: function() { return "Where did you go to school?"; },
      WORK: function() { return "Which department do you work for?"; },
    },

  },

  ANALYTICS: {
    FOR: function(journeyName: string) { return "Analytics For " + journeyName; },
  },

  LEARNING_JOURNEYS: {
    TITLE: function() { return "Learning Journeys"; },
    NEW_JOURNEY: function() { return "New Journey"; },
    ACCESS_DENIED: function() { return "You do not have access to this learning experience."; },
    FORMS: {
      CREATED_SUCCESSFULLY: function() { return "Journey Created Successfully"; },
      UPDATED_SUCCESSFULLY: function() { return "Journey Updated Successfully"; },
    },

    DASHBOARD: {
      LANGUAGE_MODAL: {
        SUCCESS: function(language: string) { return "Your journey language has been set to " + language + "."; },
        AUTOMATED_TRANSLATION_DESCRIPTION: function() { return "NovoEd is able to provide learners with AI Translation of Journey Home and Courses in it. By enabling the feature, learners can choose to view the Journey and its courses in their preferred language."; },
        AUTOMATED_TRANSLATION_SWITCH_LABEL: function() { return "Enable AI Translation for this Learning Journey and its Courses"; },
        AUTOMATED_TRANSLATION_SUCCESS: function(isOn: string) { return "You have successfully turned " + select(isOn, { true: "on", other: "off" }) + " AI translation for this journey and its courses."; },
      },

      JOURNEY_CELLS: {
        VISIT_JOURNEY: function() { return "Click to visit journey"; },
        NUM_OF_COURSES: function(coursesCount: number) { return coursesCount + " " + plural(coursesCount, 0, en, { one: "Course", other: "Courses" }) + " Total"; },
        NUM_OF_COLLECTIONS: function(collectionsCount: number) { return collectionsCount + " " + plural(collectionsCount, 0, en, { one: "Collection", other: "Collections" }); },
      },

      JOURNEY_OPTIONS: {
        EDIT_BASICS: function() { return "Edit Basics"; },
        EDIT_JOURNEY: function() { return "Edit Journey"; },
        JOURNEY_COMMUNICATIONS: function() { return "Journey Communications"; },
        CLONE_JOURNEY: function() { return "Clone Journey"; },
        ANALYTICS: function() { return "Analytics"; },
        WELCOME_EMAIL: function() { return "Welcome Email"; },
        USER_MANAGEMENT: function() { return "User Management"; },
        JOURNEY_LANGUAGE_SETTINGS: function() { return "Journey Language Settings"; },
        COMPLETION_EMAIL: function() { return "Completion Email"; },
        CERTIFICATE_OF_COMPLETION: function() { return "Certificate of Completion"; },
        CLONE_MODAL: {
          TITLE: function() { return "Clone Journey"; },
          SUBTITLE: function() { return "New Journey Information"; },
          DESCRIPTION: function() { return "Please provide the information needed for the new cloned journey, only a <b>new catalog ID</b> is required to be different from the original journey."; },
          NEXT: function() { return "Next: Review Course Information"; },
          NAME: function() { return "Name"; },
          NAME_PLACEHOLDER: function() { return "New Name (you can keep it the same as existing one)"; },
          CATALOG_ID: function() { return "Catalog ID"; },
          CATALOG_ID_PLACEHOLDER: function() { return "New Catalog ID (uniqueness required)"; },
          RELEASE_DATE: function() { return "Release Date"; },
          RELEASE_DATE_PLACEHOLDER: function() { return "New Release Date"; },
          START_DATE_PLACEHOLDER: function() { return "Please select..."; },
          COURSE_START_DATES: {
            LABEL: function() { return "Course Start Dates*"; },
            OPTION_1: function() { return "Automatically offset the start dates for new cloned courses relative to the new journey release date"; },
            OPTION_2: function() { return "Manually set start dates for new cloned courses"; },
          },

          SHARING_RESOURCES: {
            LABEL: function() { return "Videos and Audios Sharing Option for All New Cloned Courses"; },
            OPTION_1: {
              LABEL: function() { return "Shared Audio and Video Library"; },
              PLACEHOLDER: function() { return "Recommended if the cloned course is the same as the original course without any updates to uploaded video or audio files."; },
            },

            OPTION_2: {
              LABEL: function() { return "Copy Audio and Video Files"; },
              PLACEHOLDER: function() { return "Recommended if the cloned course will be in a new language or needs updates to video and audio assets that are specific to the clone."; },
            },

          },

          NOTE: function() { return "*You can still manually adjust this option in the next screen"; },
          COURSE_INFORMATION: {
            TITLE: function() { return "New Course Information"; },
            DESCRIPTION: function() { return "Please click on each <b>Catalog ID</b> to update. Uniqueness is required. Editing all other fields is optional."; },
            GO_BACK: function() { return "Back to New Journey Information"; },
            START_CLONING: function() { return "Start Cloning"; },
            BULK_APPLY: function() { return "Bulk apply to all courses to be cloned:"; },
            APPLY: function() { return "Apply to All Courses"; },
            COLLECTION: function() { return "Collection"; },
            COURSE_NAME: function() { return "Course Name"; },
            CATALOG_ID_REQUIRED: function() { return "New Catalog ID Required"; },
            CATALOG_ID_REQUIRED_TOOLTIP: function() { return "Uniqueness Required"; },
            START_DATE: function() { return "Start Date"; },
            ERROR: function() { return "Error: the following catalog id are already taken"; },
          },

        },

      },

      SEARCH_PLACEHOLDER: function() { return "Search Journey by name or catalog id"; },
    },

    BASICS: {
      HEADER: {
        INVALID_TITLE: function() { return "Invalid Title"; },
        UPDATE_LOGO: function() { return "Update Journey Logo"; },
        NAME_PLACEHOLDER: function() { return "Journey Name *"; },
        UPLOAD_LOGO: function() { return "Upload your journey logo"; },
        LOGO_TOOLTIP: function() { return "Click to update your journey logo"; },
        BACKGROUND_IMAGE_TOOLTIP: function() { return "Give your journey header a beautiful image background"; },
      },

      DATES: function() { return "Dates"; },
      BASICS: function() { return "Basics"; },
      CATALOG_ID: function() { return "Catalog ID"; },
      CLOSURE_DATE: function() { return "Closure Date"; },
      REGISTRATION: function() { return "Registration"; },
      RELEASE_DATE: function() { return "Release Date"; },
      CREATE_JOURNEY: function() { return "Create Journey"; },
      UPDATE_JOURNEY: function() { return "Update Journey"; },
      CATALOG_ID_HELP_TEXT: function() { return "Uniqueness required, use hyphens to connect words."; },
      CLOSURE_DATE_INFO: function() { return "After this date, learners will not be able to self-enroll in this journey. Already enrolled learners can still complete the journey and courses in it."; },
      REGISTRATION_OPTIONS: {
        OPEN_WITHIN_ORGANIZATION: {
          LABEL: function() { return "Open within your Organization"; },
          DESCRIPTION: function() { return "Anyone who belongs to the organization can discover and self-enroll."; },
        },

        CLOSED: {
          LABEL: function() { return "Closed Enrollment"; },
          DESCRIPTION: function() { return "Private journey students can only be registered manually by an admin with configuration/registration permission and cannot register themselves."; },
        },

        ENTITLEMENT_BASED: {
          CTA: function() { return "Configure Entitlements"; },
          LABEL: function() { return "Open based on Entitlements"; },
          ADVICE: function() { return "No Entitlement Set Yet, will not be open to anyone"; },
          DESCRIPTION: function() { return "Anyone who has matching entitlement and belongs to the organization can discover and self-enroll."; },
        },

      },

      ADDITIONAL_METADATA: {
        TITLE: function() { return "Additional Metadata"; },
        PLEASE_SELECT_METADATA_TAG: function() { return "Please Select"; },
        REQUIRED: function() { return "(*Required)"; },
      },

      ENROLLMENT_LIMIT: {
        TITLE: function() { return "Enrollment Limit"; },
        LIMIT: {
          DESCRIPTION: function() { return "Enable self-enrollment limit by entering a number below."; },
          PLACEHOLDER: function() { return "Set the limit here..."; },
        },

        WAITLIST: {
          DESCRIPTION: function() { return "Enable the waitlist option so learners can add themselves to it if enrollment limit is reached."; },
        },

      },

    },

    DETAILS: {
      OFFERED_TO: function() { return "Offered to:"; },
      PAST_RELEASE: function(releaseDate: string) { return "Released on " + releaseDate; },
      FUTURE_RELEASE: function(releaseDate: string) { return "To be released on " + releaseDate; },
      JOURNEY_DESCRIPTION_PLACEHOLDER: function() { return "Add a Description of the Journey"; },
      CREDENTIAL_STATEMENT_OF_ACCOMPLISHMENT: function(accredibleLink: string, credlyLink: string, selectCase: string) { return "You will earn " + select(selectCase, { credlyAndSoa: "a <a href=\"" + credlyLink + "\" target=\"_blank\" data-qa=\"credly-badge-url\">Credly Badge</a> and a certificate of accomplishment", credly: "a <a href=\"" + credlyLink + "\" target=\"_blank\" data-qa=\"credly-badge-url\">Credly Badge</a>", accredibleAndSoa: "<a href=\"" + accredibleLink + "\" target=\"_blank\" data-qa=\"accredible-badge-url\">Accredible Credentials</a> and a certificate of accomplishment", accredible: "<a href=\"" + accredibleLink + "\" target=\"_blank\" data-qa=\"accredible-badge-url\">Accredible Credentials</a>", soa: "certificate of accomplishment", other: "" }) + " after completing this journey"; },
      END_OF_JOURNEY: function() { return "End of the journey"; },
      CUSTOM_TOGGLE: {
        COMPLETE_AT_LEAST: function() { return "Complete at Least"; },
      },

      COMPLETION_CRITERIA_OPTIONS: {
        ALL_IN_ORDER: function() { return "Must Complete All in Order"; },
        ALL_IN_ANY_ORDER: function() { return "Complete All in Any Order"; },
        AT_LEAST_X_COURSES: function() { return "Complete at Least X Courses"; },
        OPTIONAL: function() { return "Completion is Optional"; },
      },

      COMPLETED_CRITERIA_OPTIONS: {
        ALL_IN_ORDER: function() { return "Completed All in Order"; },
        ALL_IN_ANY_ORDER: function() { return "Completed All in Any Order"; },
        AT_LEAST: function() { return "Completed at Least"; },
        OPTIONAL: function() { return "Completion is Optional"; },
      },

      COLLECTIONS: {
        EDIT_OPTIONS: function() { return "Edit Options"; },
        NEW_COLLECTION: function() { return "New Collection"; },
        ADD_TO_COLLECTION: function() { return "Add to Collection"; },
        COLLECTION_NAME_PLACEHOLDER: function() { return "New Collection Name"; },
        LOCKED_TOOLTIP: function() { return "Complete Previous Collection to Unlock this Collection"; },
        OPTIONAL_INFO_TOOLTIP: function() { return "Collection will be unlocked, making it available to learners at all times."; },
        COLLECTION_DESCRIPTION_PLACEHOLDER: function() { return "Add a Description of the Collection"; },
        COLLECTION_ORDER_TITLE: function() { return "Collection Order"; },
        COLLECTION_ORDER_LOCKED: function() { return "Locked"; },
        COLLECTION_ORDER_UNLOCKED: function() { return "Unlocked"; },
        COLLECTION_ORDER_LOCKED_TOOLTIP: function() { return "Click to unlock all collections so learner can start from any collection"; },
        COLLECTION_ORDER_UNLOCKED_TOOLTIP: function() { return "Click to lock all collections except the first collection"; },
        COLLECTION_ORDER_LOCKED_DESCRIPTION: function() { return "Learners must complete the prior collection to access courses in the next collection."; },
        COLLECTION_ORDER_UNLOCKED_DESCRIPTION: function() { return "Learners can access and complete any collection."; },
        AUTO_ENROLLMENT: {
          TITLE: function(d) { return "Enable Auto enrollment for " + d.learnersAlias + " in this journey"; },
          TOOLTIP: {
            NOT_LOCKED: function(d) { return "Auto enrollment in " + d.coursesAlias + " can be enabled only if the collection order is Locked."; },
            LOCKED: function() { return "Please update collections to be 'Must Complete All In Order' to enable Auto enrollment."; },
          },

          WARNING: {
            TITLE: function() { return "Disable Auto Enrollment"; },
            MESSAGE: function() { return "Learners will no longer be automatically enrolled into courses in this Journey. Are you sure you want to disable auto-enrollment?"; },
          },

        },

        OPTIONAL: function() { return "Optional"; },
      },

      COURSES: {
        SEARCHING: function() { return "Searching"; },
        CLOSED_COURSE: function() { return "Closed course"; },
        EMPTY_RESULTS: function() { return "No Results Found"; },
        UNRELEASED_COURSE: function() { return "Unreleased course"; },
        NO_ENTITLEMENTS: function() { return "No entitlements are configured"; },
        SEARCH_PLACEHOLDER: function() { return "Input Course Name or Catalog ID"; },
        ALREADY_ADDED: function() { return "Course has been added to this journey already"; },
        DATES: {
          TO: function() { return "to"; },
          CLOSED_ON: function() { return "Closed on"; },
          RELEASE_ON: function() { return "Release on"; },
          CLOSURE_ON: function() { return "Closure on"; },
          RELEASE_DATE: function() { return "Release Date"; },
          CLOSURE_DATE: function() { return "Closure Date"; },
          SELF_PACED: function() { return "Self Paced"; },
          RELEASED_ON: function() { return "Released on"; },
          DAYS_ACCESS: function(number: string) { return "(" + number + " day access)"; },
        },

        EDIT_OPTIONS: function() { return "Edit Options"; },
        OFFERED_TO: {
          OPEN_IN_JOURNEY: function() { return "Open in journey"; },
          OPEN_ENROLLMENT: function() { return "Open Enrollment"; },
          CLOSED_ENROLLMENT: function() { return "Closed Enrollment"; },
          OPEN_BASED_ON_ENTITLEMENTS: function() { return "Based on Entitlements"; },
          OPEN_TO_WHOLE_ORGANIZATION: function() { return "Open to the whole organization"; },
          ENTITLEMENT_BASED: {
            OR: function() { return "or"; },
            MORE: function() { return "More"; },
          },

        },

      },

      STATUS: {
        START_JOURNEY: function() { return "Start My Journey"; },
        PROGRESS_TOWARDS_COURSE_COMPLETION: function() { return "Your Progress Towards Completion"; },
        JOURNEY_COMPLETION: function(completedCount: number, totalCount: number) { return completedCount + " out of " + totalCount + " complete"; },
        COMPLETION_CELEBRATION_WITH_CREDENTIAL: function(accredibleLink: string, credlyLink: string, selectCase: string, soaLink: string) { return "Congratulations! You have earned a " + select(selectCase, { credlyAndSoa: "<a href=\"" + credlyLink + "\" target=\"_blank\" data-qa=\"credly-badge-url\">Credly Badge</a> and a <a href=\"" + soaLink + "\" data-qa=\"soa-url\">Certificate of Accomplishment</a>", credly: "<a href=\"" + credlyLink + "\" target=\"_blank\" data-qa=\"credly-badge-url\">Credly Badge</a>", accredibleAndSoa: "<a href=\"" + accredibleLink + "\" target=\"_blank\" data-qa=\"accredible-badge-url\">Accredible Credentials</a> and a <a href=\"" + soaLink + "\" data-qa=\"soa-url\">Certificate of Accomplishment</a>", accredible: "<a href=\"" + accredibleLink + "\" target=\"_blank\" data-qa=\"accredible-badge-url\">Accredible Credentials</a>", soa: "<a href=\"" + soaLink + "\" data-qa=\"soa-url\">Certificate of Accomplishment</a>", other: "" }) + " for completing this journey"; },
        COMPLETION_CELEBRATION_WITHOUT_CERTIFICATE: function() { return "Congratulations! You have completed this journey!"; },
        ENTITLEMENTS_NO_MATCH: function() { return "You do not have the required entitlements to self register. Please contact the teaching team to enroll in the journey."; },
        JOURNEY_CONCLUDED: function() { return "This journey has concluded."; },
        CLOSED_ENROLLMENT: function() { return "This journey has closed enrollment. You must be added by the teaching team."; },
        WAITLIST_PROMPT: function(link: string) { return "Please " + link + "."; },
        WAITLIST_PROMPT_LINK: function() { return "join the waitlist"; },
      },

      ENROLLMENT_DATA: {
        SUCCESS: {
          HEADER: function() { return "Success"; },
          MESSAGE: function() { return "You have successfully joined this journey! Get started now!"; },
        },

      },

    },

    COURSE_HOME: {
      MODAL: {
        CONGRATULATIONS: function() { return "Congratulations!"; },
        YOU_ARE_ONE_STEP_CLOSER: function() { return "You are one step closer to the completion of:"; },
        CONTINUE_WITH_JOURNEY: function() { return "Continue with your journey:"; },
        CONTINUE_WITH_JOURNEYS: function() { return "Continue with your journeys:"; },
        YOUR_NEXT_COURSE_IN_JOURNEY: function(d) { return "Here is your next " + d.courseAlias + " in this journey:"; },
        YOU_HAVE_COMPLETED_THE_JOURNEY: function() { return "You have completed the journey!"; },
        YOU_HAVE_COMPLETED_THIS_COURSE: function(d) { return "You have completed this " + d.courseAlias + "!"; },
        YOU_HAVE_COMPLETED_THIS_COURSE_AND_JOURNEY: function(d) { return "You have completed this " + d.courseAlias + " and the journey!"; },
        YOU_HAVE_REACHED_AVAILABLE_LESSONS: function(d) { return "You have reached the end of available " + d.lecturesAlias; },
        CHECK_YOUR_COURSE_PROGRESS: function(d) { return "Looks like you still have some items to complete. Please check your progress on the " + d.courseAlias + " home."; },
        NO_LECTURES_AVAILABLE: function(d) { return "No " + d.lecturesAlias + " available"; },
        COURSE_BELONGS_TO_OTHER_JOURNEYS: function(d) { return "This " + d.courseAlias + " belongs to " + d.journeysCount + " other " + plural(d.journeysCount, 0, en, { one: "journey", other: "journeys" }) + ", go back to your <a href=" + d.learnerDashboardLink + ">learner dashboard</a> to access other journeys"; },
        BACK_TO_JOURNEY_HOME: function() { return "Back to Journey Home"; },
        BACK_TO_COURSE_HOME: function(d) { return "Back to " + d.CourseTitleAlias + " Home"; },
      },

      JOURNEY_NAVIGATION: {
        TO: function() { return "To"; },
        VIEW_LEARNING_JOURNEYS: function() { return "View Learning Journeys"; },
        VIEW_JOURNEY_HOME: function() { return "View Journey Home"; },
        MULTIPLE_JOURNEYS: function() { return "This course belongs to multiple journeys:"; },
        MORE_JOURNEYS: function(number: number) { return "more " + plural(number, 0, en, { one: " journey ", other: " journeys " }); },
      },

    },

    CLONE: {
      SUCCESS_HEADER: function() { return "Cloning Request Received!"; },
      SUCCESS_BODY: function() { return "Your learning journey is being cloned. This may take anywhere from a few minutes to an hour or more depending on learning journey size. We will send you an email when the clone is ready."; },
      CLONE_COURSE: function() { return "Clone"; },
      KEEP_COURSE: function() { return "Keep"; },
      KEEP_COURSE_ON_SELECTED: function() { return "Keep Original, Skip Cloning"; },
      EXCLUDE_COURSE: function() { return "Exclude"; },
      NOTE: function() { return "*You can still manually adjust this option in the next screen"; },
      CLONE_COURSE_TOOLTIP: function() { return "Course will be cloned"; },
      KEEP_COURSE_TOOLTIP: function() { return "The original course will be kept"; },
      EXCLUDE_COURSE_TOOLTIP: function() { return "Course will be excluded from the new journey"; },
      ARCHIVED_COURSE: function(courseName: string) { return courseName + " is Archived"; },
      CLONE_IN_PROGRESS: {
        TITLE: function() { return "Cloning in progress!"; },
        BODY: function() { return "Cloning in progress! Small journeys take minutes, while larger ones may take up to an hour. We will send you an email once it's ready."; },
      },

    },

  },

  OFFERINGS: {
    CARD: {
      AUDIT: function() { return "Audit"; },
      ENROLLED: function() { return "Enrolled"; },
      WITHDRAW: function() { return "Withdraw"; },
      COMPLETED: function() { return "Completed"; },
      INCOMPLETE: function() { return "Incomplete"; },
      LEARN_MORE: function() { return "Learn More"; },
      OFFERED_TO: function() { return "Offered to:"; },
      IN_PROGRESS: function() { return "In Progress"; },
      OPEN_TO_ALL: function() { return "Open to All"; },
      MAKE_PAYMENT: function() { return "Make Payment"; },
      VIEW_DETAILS: function() { return "View Details"; },
      PROGRAM_OFFERING_NAME: function() { return "Program"; },
      RESUME_LEARNING: function() { return "Resume Learning"; },
      CONGRATULATIONS: function() { return "Congratulations!"; },
      START_LEARNING: function() { return "Start Learning Now"; },
      CERTIFICATE: function() { return "Certificate"; },
      VIEW_CERTIFICATE: function(certificateName: string) { return "View " + certificateName; },
      JOURNEY_COMPLETED: function() { return "Journey Completed"; },
      REVERSE_AUDITING_STATUS: function() { return "Reverse Auditing Status"; },
      JOURNEY_PROGRESS: function(completedCount: number, totalCount: number) { return completedCount + " out of " + totalCount + " Complete"; },
      UNMET_REQUIREMENT: function() { return "You have not met the requirement to self enroll"; },
      COMPLETE_IN: function(days: number) { return "Complete in " + plural(days, 0, en, { one: " 1 day ", other: " " + number("en", days, 0) + " days " }); },
      ENROLLED_COUNT: function(enrolledCount: number) { return enrolledCount + " " + plural(enrolledCount, 0, en, { one: "learner", other: "learners" }) + " enrolled"; },
      X_DAYS_ACCESS_REMAINING: function(daysCount: number) { return daysCount + " " + plural(daysCount, 0, en, { one: "day", other: "days" }) + " access remaining"; },
      VIEW_JOURNEY_HOME: function() { return "View Journey Home"; },
      START_YOUR_JOURNEY_NOW: function() { return "Start Your Journey Now"; },
      START_DATE: function(startDate: string) { return "Start Date: " + startDate; },
      X_OUT_OF_Y_COMPLETED: function(completedCount: number, totalCount: number) { return completedCount + " out of " + totalCount + " Completed"; },
      VISIT_JOURNEY_HOME_TO_GET_STARTED: function() { return "Visit the Journey home to get started."; },
      GOOD_PROGRESS_SO_FAR_N_MORE_TO_GO: function(coursesCount: number) { return "Good progress so far, " + coursesCount + " more to go!"; },
      BADGE: {
        LEARNING_JOURNEY: function() { return "Learning Journey"; },
      },

      MORE_OPTIONS: function() { return "More Options"; },
      ENTER_COURSE: function(courseName: string) { return "Enter " + courseName; },
      VIEW_MENTORSHIP_PROGRAM: function() { return "View Program"; },
    },

  },

  AUTOMATED_TRANSLATION: {
    AUTO_TRANSLATE: function() { return "AI Translation"; },
    CLICK_TO_TURN_OFF_THE_TRANSLATION: function() { return "Click to turn off the translation"; },
    TURN_ON: function() { return "Turn on AI translation"; },
    PLEASE_SELECT_A_LANGUAGE_FIRST: function() { return "Please select a language first"; },
    SELECT_A_LANGUAGE_FOR_AUTO_TRANSLATION: function() { return "Select a language for AI translation:"; },
    VIEW_CONTENT_IN: function() { return "View Content in:"; },
    REVERT_TO_ORIGINAL: function(originalLanguage: string) { return "Revert to Original (" + originalLanguage + ")"; },
    PLEASE_SELECT: function() { return "Please Select"; },
    AUTO_TRANSLATION_NOT_AVAILABLE: function() { return "AI Translation is not available for this page."; },
    ERROR: function() { return "Unable to display translation."; },
    RETRY: function() { return "Please try again by refreshing this page."; },
    UPDATE: function() { return "Update"; },
    ALERT_MESSAGES: {
      SUCCESS_CHANGING_LANGUAGE: function(d) { return "You're viewing the " + d.courseAlias + " content in " + d.language + ", translated by AI. Your NovoEd language preference is also set to " + d.language + "."; },
      SUCCESS_RESET_TO_ORIGINAL: function(d) { return "You are viewing the " + d.courseAlias + " content in its original language, " + d.language + ". Your NovoEd language preference is also set to " + d.language + "."; },
      SUCCESS_VIETNAMESE_LANGUAGE: function(d) { return "You are now viewing the " + d.courseAlias + " content in Vietnamese, translated by AI."; },
    },

    LANGUAGE_WARNING: function() { return "AI will translate your content and update your language preferences for a seamless experience."; },
    VIETNAMESE_WARNING: function(d) { return d.CourseAlias + " content will be translated by AI. Your language preferences remains in " + d.language + " as Vietnamese is not yet supported"; },
    TRANSLATION_WARNING: function() { return "AI translations may contain small errors."; },
    OPTION_BAR: {
      EDIT_TRANSLATION_TOOLTIP: function() { return "Edit Translation"; },
      TRANSLATION_EDITED_TOOLTIP: function() { return "Translation Edited"; },
    },

    EDIT_TRANSLATION: {
      SECTION_TITLE: function() { return "Section Title:"; },
      SECTION_CONTENT: function() { return "Section Content:"; },
      SECTION_HEADING: function() { return "Section Heading:"; },
      SECTION_INSTRUCTIONS: function() { return "Instructions:"; },
      TITLE: function() { return "Title:"; },
      DESCRIPTION: function() { return "Description:"; },
      EXPECTATIONS: function() { return "Expectations:"; },
      POST_TITLE: function() { return "Post title:"; },
      POST_CONTENT: function() { return "Post content:"; },
      QUESTION: function() { return "Question:"; },
      QUESTION_NUMBER: function(number: string) { return "Question " + number; },
      STATEMENT: function() { return "Statement"; },
      OPTIONS: function() { return "Options:"; },
      OPTION: function(number: string) { return "Option " + number + ":"; },
      DISPLAY_TEXT: function() { return "Display Text:"; },
      VIDEO_NAME: function() { return "Video name:"; },
      VIDEO_NUMBER_NAME: function(number: string) { return "Video " + number + " Name:"; },
      AUDIO_NAME: function() { return "Audio Name:"; },
      AUDIO_NUMBER_NAME: function(number: string) { return "Audio " + number + " Name:"; },
      FEEDBACK: function(number: string) { return "Feedback for Option " + number + ":"; },
      FEEDBACK_CORRECT: function() { return "Feedback for the Correct Answer:"; },
      FEEDBACK_INCORRECT: function() { return "Feedback for Any Other Answers:"; },
      FEEDBACK_FOR_ANY_ANSWER: function() { return "Feedback for Any Answers:"; },
      LEFT_LABEL: function() { return "Left Label:"; },
      RIGHT_LABEL: function() { return "Right Label:"; },
      TABLE_HEADER: function() { return "Table Header:"; },
      TABLE_CELL: function(cell: string, isCorrect: string) { return "Cell " + cell + " Input: Feedback for the " + select(isCorrect, { true: "Correct", other: "Incorrect" }) + " Answer:"; },
      TABLE_LABEL: function(cell: string) { return "Cell " + cell + ": Label:"; },
      HINT_NUMBER: function(number: string) { return "Hint " + number + " for Question Attempts:"; },
      PAIR: function(isLeft: string, number: string) { return "Pair " + number + ": " + select(isLeft, { true: "Left", other: "Right" }) + ":"; },
      EDITABLE_FILE_DESCRIPTION: function() { return "Upload a file to replace the auto-translated version for this language:"; },
      ATTACHMENTS: {
        DESCRIPTION: function() { return "For your uploaded resource files, upload a file to replace the auto-translated version for this language:"; },
      },

    },

  },

  TIMEZONE: {
    TITLE: function() { return "Timezone"; },
    BROWSER_DEFAULT: function() { return "Browser Default"; },
    AMERICAN_SAMOA: function() { return "American Samoa"; },
    INTERNATIONAL_DATE_LINE_WEST: function() { return "International Date Line West"; },
    MIDWAY_ISLAND: function() { return "Midway Island"; },
    HAWAII: function() { return "Hawaii"; },
    ALASKA: function() { return "Alaska"; },
    'PACIFIC_TIME_(US_&_CANADA)': function() { return "Pacific Time (US & Canada)"; },
    TIJUANA: function() { return "Tijuana"; },
    ARIZONA: function() { return "Arizona"; },
    CHIHUAHUA: function() { return "Chihuahua"; },
    MAZATLAN: function() { return "Mazatlan"; },
    'MOUNTAIN_TIME_(US_&_CANADA)': function() { return "Mountain Time (US & Canada)"; },
    CENTRAL_AMERICA: function() { return "Central America"; },
    'CENTRAL_TIME_(US_&_CANADA)': function() { return "Central Time (US & Canada)"; },
    GUADALAJARA: function() { return "Guadalajara"; },
    MEXICO_CITY: function() { return "Mexico City"; },
    MONTERREY: function() { return "Monterrey"; },
    SASKATCHEWAN: function() { return "Saskatchewan"; },
    BOGOTA: function() { return "Bogota"; },
    'EASTERN_TIME_(US_&_CANADA)': function() { return "Eastern Time (US & Canada)"; },
    'INDIANA_(EAST)': function() { return "Indiana (East)"; },
    LIMA: function() { return "Lima"; },
    QUITO: function() { return "Quito"; },
    'ATLANTIC_TIME_(CANADA)': function() { return "Atlantic Time (Canada)"; },
    CARACAS: function() { return "Caracas"; },
    GEORGETOWN: function() { return "Georgetown"; },
    LA_PAZ: function() { return "La Paz"; },
    SANTIAGO: function() { return "Santiago"; },
    NEWFOUNDLAND: function() { return "Newfoundland"; },
    BRASILIA: function() { return "Brasilia"; },
    BUENOS_AIRES: function() { return "Buenos Aires"; },
    GREENLAND: function() { return "Greenland"; },
    MONTEVIDEO: function() { return "Montevideo"; },
    'MID-ATLANTIC': function() { return "Mid-Atlantic"; },
    AZORES: function() { return "Azores"; },
    CAPE_VERDE_IS: function() { return "Cape Verde Is."; },
    CASABLANCA: function() { return "Casablanca"; },
    DUBLIN: function() { return "Dublin"; },
    EDINBURGH: function() { return "Edinburgh"; },
    LISBON: function() { return "Lisbon"; },
    LONDON: function() { return "London"; },
    MONROVIA: function() { return "Monrovia"; },
    UTC: function() { return "UTC"; },
    AMSTERDAM: function() { return "Amsterdam"; },
    BELGRADE: function() { return "Belgrade"; },
    BERLIN: function() { return "Berlin"; },
    BERN: function() { return "Bern"; },
    BRATISLAVA: function() { return "Bratislava"; },
    BRUSSELS: function() { return "Brussels"; },
    BUDAPEST: function() { return "Budapest"; },
    COPENHAGEN: function() { return "Copenhagen"; },
    LJUBLJANA: function() { return "Ljubljana"; },
    MADRID: function() { return "Madrid"; },
    PARIS: function() { return "Paris"; },
    PRAGUE: function() { return "Prague"; },
    ROME: function() { return "Rome"; },
    SARAJEVO: function() { return "Sarajevo"; },
    SKOPJE: function() { return "Skopje"; },
    STOCKHOLM: function() { return "Stockholm"; },
    VIENNA: function() { return "Vienna"; },
    WARSAW: function() { return "Warsaw"; },
    WEST_CENTRAL_AFRICA: function() { return "West Central Africa"; },
    ZAGREB: function() { return "Zagreb"; },
    ATHENS: function() { return "Athens"; },
    BUCHAREST: function() { return "Bucharest"; },
    CAIRO: function() { return "Cairo"; },
    HARARE: function() { return "Harare"; },
    HELSINKI: function() { return "Helsinki"; },
    JERUSALEM: function() { return "Jerusalem"; },
    KALININGRAD: function() { return "Kaliningrad"; },
    KYIV: function() { return "Kyiv"; },
    PRETORIA: function() { return "Pretoria"; },
    RIGA: function() { return "Riga"; },
    SOFIA: function() { return "Sofia"; },
    TALLINN: function() { return "Tallinn"; },
    VILNIUS: function() { return "Vilnius"; },
    BAGHDAD: function() { return "Baghdad"; },
    ISTANBUL: function() { return "Istanbul"; },
    KUWAIT: function() { return "Kuwait"; },
    MINSK: function() { return "Minsk"; },
    MOSCOW: function() { return "Moscow"; },
    NAIROBI: function() { return "Nairobi"; },
    RIYADH: function() { return "Riyadh"; },
    ST_PETERSBURG: function() { return "St. Petersburg"; },
    VOLGOGRAD: function() { return "Volgograd"; },
    TEHRAN: function() { return "Tehran"; },
    ABU_DHABI: function() { return "Abu Dhabi"; },
    BAKU: function() { return "Baku"; },
    MUSCAT: function() { return "Muscat"; },
    SAMARA: function() { return "Samara"; },
    TBILISI: function() { return "Tbilisi"; },
    YEREVAN: function() { return "Yerevan"; },
    KABUL: function() { return "Kabul"; },
    EKATERINBURG: function() { return "Ekaterinburg"; },
    ISLAMABAD: function() { return "Islamabad"; },
    KARACHI: function() { return "Karachi"; },
    TASHKENT: function() { return "Tashkent"; },
    CHENNAI: function() { return "Chennai"; },
    KOLKATA: function() { return "Kolkata"; },
    MUMBAI: function() { return "Mumbai"; },
    NEW_DELHI: function() { return "New Delhi"; },
    SRI_JAYAWARDENEPURA: function() { return "Sri Jayawardenepura"; },
    KATHMANDU: function() { return "Kathmandu"; },
    ALMATY: function() { return "Almaty"; },
    ASTANA: function() { return "Astana"; },
    DHAKA: function() { return "Dhaka"; },
    URUMQI: function() { return "Urumqi"; },
    RANGOON: function() { return "Rangoon"; },
    BANGKOK: function() { return "Bangkok"; },
    HANOI: function() { return "Hanoi"; },
    JAKARTA: function() { return "Jakarta"; },
    KRASNOYARSK: function() { return "Krasnoyarsk"; },
    NOVOSIBIRSK: function() { return "Novosibirsk"; },
    BEIJING: function() { return "Beijing"; },
    CHONGQING: function() { return "Chongqing"; },
    HONG_KONG: function() { return "Hong Kong"; },
    IRKUTSK: function() { return "Irkutsk"; },
    KUALA_LUMPUR: function() { return "Kuala Lumpur"; },
    PERTH: function() { return "Perth"; },
    SINGAPORE: function() { return "Singapore"; },
    TAIPEI: function() { return "Taipei"; },
    ULAANBAATAR: function() { return "Ulaanbaatar"; },
    OSAKA: function() { return "Osaka"; },
    SAPPORO: function() { return "Sapporo"; },
    SEOUL: function() { return "Seoul"; },
    TOKYO: function() { return "Tokyo"; },
    YAKUTSK: function() { return "Yakutsk"; },
    ADELAIDE: function() { return "Adelaide"; },
    DARWIN: function() { return "Darwin"; },
    BRISBANE: function() { return "Brisbane"; },
    CANBERRA: function() { return "Canberra"; },
    GUAM: function() { return "Guam"; },
    HOBART: function() { return "Hobart"; },
    MELBOURNE: function() { return "Melbourne"; },
    PORT_MORESBY: function() { return "Port Moresby"; },
    SYDNEY: function() { return "Sydney"; },
    VLADIVOSTOK: function() { return "Vladivostok"; },
    MAGADAN: function() { return "Magadan"; },
    NEW_CALEDONIA: function() { return "New Caledonia"; },
    SOLOMON_IS: function() { return "Solomon Is."; },
    SREDNEKOLYMSK: function() { return "Srednekolymsk"; },
    AUCKLAND: function() { return "Auckland"; },
    FIJI: function() { return "Fiji"; },
    KAMCHATKA: function() { return "Kamchatka"; },
    MARSHALL_IS: function() { return "Marshall Is."; },
    WELLINGTON: function() { return "Wellington"; },
    CHATHAM_IS: function() { return "Chatham Is."; },
    NUKUALOFA: function() { return "Nuku'alofa"; },
    SAMOA: function() { return "Samoa"; },
    TOKELAU_IS: function() { return "Tokelau Is."; },
  },

  LEARNER_PROFILE: {
    UPLOAD_IMAGE: function() { return "Upload an Image <span>*</span>"; },
    UPLOAD_YOUR_PROFILE_PICTURE: function() { return "Upload Your Profile Picture"; },
  },

  COURSE_ADMIN_MEGA_MENU: {
    TOOLTIP: function() { return "Admin Options"; },
    EXPERIENCE_DESIGN: function() { return "Experience Design"; },
    COURSE_COMPLETION: function(offeringName: string) { return offeringName + " Completion"; },
    COURSE_FACILITATION: function(offeringName: string) { return offeringName + " Facilitation"; },
    DATA_ANALYTICS: function() { return "Data Analytics"; },
    CONTENT_EXPORTS: function() { return "Content Exports"; },
    TEAMS_AND_GROUPS: function() { return "Teams and Groups"; },
    CONFIGURATIONS: function() { return "Configurations"; },
    COURSE_OUTLINE: {
      LABEL: function(offeringName: string) { return offeringName + " Outline"; },
      TOOLTIP: function() { return "Create/edit/copy/reorder sections, subsections, and lessons. You can also choose to enable/disable card view and update lesson release dates and activity deadlines."; },
    },

    COURSE_BASICS: {
      LABEL: function(offeringName: string) { return offeringName + " Basics"; },
      TOOLTIP: function(offeringName: string) { return "Define " + offeringName + " basics, key dates, registration types, audio/video sharing, and additional metadata."; },
    },

    HELP_OPTIONS: {
      LABEL: function() { return "Help Options"; },
      TOOLTIP: function() { return "Enable an AI Learning Assistant to help answer learner questions and configure custom resources to support learners."; },
    },

    HELP_MENU: {
      LABEL: function() { return "Help Menu"; },
      TOOLTIP: function() { return "Add a help menu to the top right-hand side menu to instruct learners where to go for support."; },
    },

    GOOGLE_CALENDAR: {
      LABEL: function() { return "Google Calendar"; },
      TOOLTIP: function() { return "Embed public Google calendar. If you're using Outlook calendar, reach out to your org admin to enable it."; },
    },

    COURSE_HOME_WIDGETS: {
      LABEL: function(offeringName: string) { return offeringName + " Home Widgets"; },
      TOOLTIP: function(offeringName: string) { return "Add text widgets on the " + offeringName + " homepage."; },
    },

    HOMEPAGE_GREETING: {
      LABEL: function() { return "Homepage Greeting"; },
      TOOLTIP: function(offeringName: string) { return "Add a greeting on the learner's homepage that will be visible on top during their first visit and under the " + offeringName + " outline afterward."; },
    },

    PREREQUISITES: {
      LABEL: function() { return "Prerequisites"; },
      TOOLTIP: function() { return "Restrict access to lessons to only the learners who have completed a certain activity."; },
    },

    COURSE_FLYER: {
      LABEL: function(offeringName: string) { return offeringName + " Flyer"; },
      TOOLTIP: function(offeringName: string) { return "Create/edit the " + offeringName + " flyer page content, add Google Analytics, instructor bio, and terms & conditions."; },
    },

    POINTS_AND_LEADERBOARD: {
      LABEL: function() { return "Points and Leaderboard"; },
      TOOLTIP: function() { return "Implement gamification by enabling points to reward learners for completion of activities."; },
    },

    AUTOMATIC_COMPLETION_CRITERIA: {
      LABEL: function() { return "Automatic Completion Criteria"; },
      TOOLTIP: function(offeringName: string) { return "Define what constitutes completion in this " + offeringName + "."; },
    },

    COMPLETION_EMAIL: {
      LABEL: function() { return "Completion Email"; },
      TOOLTIP: function(offeringName: string) { return "Configure an automated completion email to be sent to learners when they complete the " + offeringName + "."; },
    },

    STATEMENT_OF_ACCOMPLISHMENT: {
      LABEL: function() { return "Statement of Accomplishment"; },
      TOOLTIP: function() { return "Enable and customize the statement of accomplishment that is awarded to learners as a shareable certificate."; },
    },

    CREDLY_BADGE: {
      LABEL: function() { return "Credly Badge"; },
      TOOLTIP: function(offeringName: string) { return "Configure a Credly badge to be issued upon " + offeringName + " completion."; },
    },

    ACCREDIBLE_CREDENTIALS: {
      LABEL: function() { return "Accredible Credentials"; },
      TOOLTIP: function(offeringName: string) { return "Configure Accredible credentials to be issued upon " + offeringName + " completion."; },
    },

    BULK_UPLOAD_COMPLETION: {
      LABEL: function() { return "Bulk Upload Completion"; },
      TOOLTIP: function() { return "Upload CSV file to grant \"Complete\" status for a set of learners."; },
    },

    USER_MANAGEMENT: {
      LABEL: function() { return "User Management"; },
      TOOLTIP: function() { return "Manage users, roles, resend welcome emails, & reset passwords."; },
    },

    LEARNER_PROGRESS: {
      LABEL: function(d) { return d.LearnerAlias + " Progress"; },
      TOOLTIP: function(d) { return "Track " + d.learnerAlias + " progress & engagement, and send targeted interventions when necessary."; },
    },

    COURSE_COMMUNICATIONS: {
      LABEL: function(offeringName: string) { return offeringName + " Communications"; },
      TOOLTIP: function(offeringName: string) { return "Send announcements or emails to your audience on a specific date, or based on their progress in the " + offeringName + "."; },
    },

    CONTENT_FLAGS: {
      LABEL: function() { return "Content Flags"; },
      TOOLTIP: function() { return "Manage user-generated content that has been marked as spam or inappropriate by your learners."; },
    },

    ANALYTICS: {
      LABEL: function() { return "Course Analytics"; },
      TOOLTIP: function(offeringName: string) { return "View " + offeringName + " activity trends."; },
    },

    SKILLS_ANALYTICS: {
      LABEL: function() { return "Skills Analytics"; },
      TOOLTIP: function(offeringName: string) { return "Monitor skill distribution, gauge engagement, and assess skill progression within a " + offeringName + "."; },
    },

    COHORTS_ANALYTICS: {
      LABEL: function() { return "Compare Cohorts"; },
      TOOLTIP: function() { return "Analyze cohort(s) engagement & performance here."; },
    },

    DATA_DOWNLOADS: {
      LABEL: function() { return "Data Downloads"; },
      TOOLTIP: function() { return "Download data based on user role, profile, and activities."; },
    },

    USER_GENERATED_CONTENT_DOWNLOADS: {
      LABEL: function() { return "Export User Generated Content"; },
      TOOLTIP: function() { return "Download user-generated content for Submissions, Feedback, Discussions, and Teams/Groups."; },
    },

    EXPORT_COURSE_CONTENT: {
      TOOLTIP: function(d) { return "Export " + d.courseAlias + " content as a PDF."; },
      IN_PROGRESS_TOOLTIP: function(d) { return "Exporting " + d.courseAlias + " content in progress."; },
    },

    TEAM_FORMATION_ACTIVITY_MANAGE_TEAMS: {
      LABEL: function() { return "Team Formation Activity (Manage Teams)"; },
      TOOLTIP: function(offeringName: string) { return "Manage team configurations in the " + offeringName + "."; },
    },

    GROUP_FORMATION_ACTIVITY_MANAGE_GROUPS: {
      LABEL: function() { return "Group Formation Activity (Manage Groups)"; },
      TOOLTIP: function(offeringName: string) { return "Manage group configurations in the " + offeringName + "."; },
    },

    FACILITATION_DASHBOARD: {
      LABEL: function() { return "Facilitation Dashboard"; },
      TOOLTIP: function() { return "Create and manage teams/groups, view all team/group activity at a glance, access workspaces, enable/disable team progress dashboard and update memberships."; },
    },

    DEFAULT_COURSE_LANGUAGE: {
      LABEL: function(offeringName: string) { return offeringName + " Language Settings"; },
      TOOLTIP: function(offeringName: string) { return "Allows users to set their default " + offeringName + " language."; },
    },

    USER_PROFILE_QUESTIONS: {
      LABEL: function() { return "User Profile Questions"; },
      TOOLTIP: function(offeringName: string) { return "Ask questions to users and enrich their " + offeringName + " profile."; },
    },

    ALIASES: {
      LABEL: function() { return "Aliases"; },
      TOOLTIP: function(offeringName: string) { return "Customize feature names or use aliases for " + offeringName + " content & activities."; },
    },

    CONFIGURE_COMMUNITY_PANEL: {
      LABEL: function() { return "Configure Community Panel"; },
      TOOLTIP: function(offeringName: string) { return "Configure what social activities learners can see on a self-paced " + offeringName + " homepage community panel and lecture pages."; },
    },

    ADVANCED_SETTINGS: {
      LABEL: function() { return "Advanced Settings"; },
      TOOLTIP: function(offeringName: string) { return "Manage alias, " + offeringName + " specific branding, " + offeringName + " home settings, shopify integration and API key access."; },
    },

  },

  CONTENT_EXPORT: {
    EXPORT_COURSE_CONTENT: function(d) { return "Export " + d.CourseAlias + " Content"; },
    EXPORTING_COURSE_CONTENT: function(d) { return "Exporting " + d.CourseAlias + " Content..."; },
    EXPORTING_TITLE: function(d) { return "Exporting " + d.courseAlias + " content for " + d.courseName + "."; },
    EXPORTING_DESCRIPTION: function(d) { return "You will receive an email when the file is generated. Small " + d.coursesAlias + " take a few minutes, while larger ones with hundreds of pages may take up to an hour."; },
    SUCCESS_DESCRIPTION: function(courseName: string) { return "Your PDF export is ready to be downloaded: <b>" + courseName + "</b>"; },
    DOWNLOAD_PDF: function() { return "Download PDF"; },
  },

  COURSE_ANALYTICS: {
    OVERVIEW: function() { return "Overview"; },
    ACTIVITIES: function() { return "Activities"; },
    SURVEY_AND_QUIZ: function() { return "Quiz and Survey"; },
    SKILLS: function() { return "Skills"; },
    ANALYTICS: function() { return "Analytics"; },
    COHORTS: function() { return "Cohorts"; },
    PRACTICE: function() { return "Practice"; },
    QUIZ: function() { return "Quiz"; },
    SURVEY: function() { return "Survey"; },
    TIMED_EXAM: function() { return "Timed Exam"; },
    PRE_POST: {
      TAB_HEADER: function() { return "Pre/Post Survey"; },
      NO_ACCESS: function(d) { return "This page uses a survey from <b>" + d.courseName + " (" + d.catalogId + ")</b>. You don't have the right permissions to see " + d.learnerAlias + " data. You can ask your colleagues to add you as an admin to <b>" + d.courseName + " (" + d.catalogId + ")</b> or if this is a mistake, adjust configuration for this page."; },
      PAGE_TITLE: {
        COHORT: function(cohortsCount: number) { return "Pre/Post Survey Analysis Across " + cohortsCount + " " + plural(cohortsCount, 0, en, { one: "Cohort", other: "Cohorts" }); },
        COURSE: function() { return "Pre/Post Survey Analysis"; },
      },

      EDIT: function() { return "Edit Configuration"; },
      SUMMARY: {
        COHORT: function(d) { return d.respondersPercentage + "% (" + d.respondersCount + " " + plural(d.respondersCount, 0, en, { one: "responder", other: "responders" }) + ") submitted both surveys among " + d.totalCount + " " + d.learnersAlias + " from all cohorts"; },
        COURSE: function(d) { return d.respondersPercentage + "% (" + d.respondersCount + " " + plural(d.respondersCount, 0, en, { one: "responder", other: "responders" }) + ") submitted both surveys among " + d.totalCount + " " + d.learnersAlias + " " + plural(d.courseCount, 0, en, { one: "", other: "from the two " + d.coursesAlias }); },
      },

      EMPTY: function(link: string) { return "Please " + link + " to compare."; },
      LINK: function() { return "select two surveys"; },
      MODAL: {
        TITLE: function() { return "Pre/Post Survey Setup"; },
        SELECT: function() { return "Select Two Surveys to Compare:"; },
        DESCRIPTION_1: function(d) { return "Pre and post surveys are conducted in the beginning and at the end of a learning experience to measure " + d.learnerAlias + "'s self-reported confidence. Did you use such a survey in your " + d.courseAlias + "?"; },
        DESCRIPTION_2: function() { return "<b>Please note:</b> in order to compare results among cohorts, only surveys from the primary course can be selected here."; },
        PRE: function() { return "<b>Pre</b> survey in"; },
        POST: function() { return "<b>Post</b> survey in"; },
        MAP_QUESTIONS: function() { return "Now let’s map the questions (please select at least 1)"; },
        MAPPING_INFO: function() { return "<b>Please note:</b> only Likert and Multiple Choice Questions will be compared."; },
        MAPPING_HEADER_1: function() { return "Map questions from <b>Pre</b> survey:"; },
        MAPPING_HEADER_2: function() { return "To questions in <b>Post</b> survey:"; },
        QUESTIONS_LOADING: function() { return "Loading questions for mapping..."; },
        DISABLED_TOOLTIP: function() { return "No matching question type to select in this survey"; },
        ANALYZE: function() { return "Analyze"; },
        ANALYZING: function() { return "Analyzing..."; },
        SEARCH_PLACEHOLDER: function() { return "Search by"; },
        SELECT_PLACEHOLDER: function() { return "Please Select"; },
        VALIDATION: function() { return "At least one question mapping is required"; },
        SURVEY_QUESTIONS: function() { return "Does one of your pre or post survey questions is for NPS or CSAT?"; },
        SURVEY_SELECT_PLACEHOLDER: function() { return "Please Select Survey"; },
        SURVEY_QUESTION_SELECT_PLACEHOLDER: function() { return "Please Select a Question"; },
      },

      REPORT: {
        AVERAGE_CHANGE: {
          TITLE: function() { return "Average Change"; },
          QUESTIONS: function() { return "Questions"; },
          PRE_COURSE: function() { return "Pre Survey Average"; },
          POST_COURSE: function() { return "Post Survey Average"; },
          CHANGE: function() { return "Change"; },
        },

        QUANTILES: {
          TITLE: function() { return "Distribution of Answers"; },
          DISTRIBUTION: function() { return "Distribution"; },
          LOW: function() { return "Low Comfort"; },
          MEDIUM: function() { return "Medium Comfort"; },
          HIGH: function() { return "High Comfort"; },
          PRE_COURSE: function() { return "Pre Survey:"; },
          POST_COURSE: function() { return "Post Survey:"; },
          RATING_OF: function(value: string) { return "Rating of " + value; },
          RATING_BETWEEN: function(max: string, min: string) { return "Rating between " + min + "-" + max; },
        },

      },

    },

    NPS_CSAT_SURVEY: {
      NPS: function() { return "NPS"; },
      CSAT: function() { return "CSAT"; },
      CONFIGURE: function() { return "Configure NPS/CSAT"; },
      EDIT_CONFIGURATION: function() { return "Edit Configuration"; },
      MODAL_TITLE: function() { return "Survey Setup"; },
      MODAL_DESCRIPTION: function() { return "Do you have a survey question that is for NPS or CSAT?"; },
      NPS_QUESTION: function() { return "Question for NPS"; },
      NPS_QUESTION_PLACEHOLDER: function() { return "Select a question for NPS"; },
      CSAT_QUESTION: function() { return "Question for CSAT"; },
      CSAT_QUESTION_PLACEHOLDER: function() { return "Select a question for CSAT"; },
      NPS_SCORE_RATING: {
        DETRACTORS: function(count: number) { return "Detractors: Rating between 0-6: " + count; },
        PASSIVES: function(count: number) { return "Passives: Rating between 7-8: " + count; },
        PROMOTERS: function(count: number) { return "Promoters: Rating between 9-10: " + count; },
      },

      CSAT_SCORE_RATING: function(count: number, rating: string) { return "Rating " + rating + ": " + count; },
    },

  },

  COHORT_ANALYTICS: {
    FILTER: function() { return "Filter by cohorts"; },
    QUIZ_SURVEY_TITLE: function(count: number, questionSetType: string) { return questionSetType + " Analysis in " + count + " " + plural(count, 0, en, { one: "cohort", other: "cohorts" }); },
  },

  LICENSE_DASHBOARD: {
    MAIN: function(Institution: string) { return Institution + " Org License Usage"; },
    DEPENDENT: function() { return "Aggregated Orgs License Usage"; },
  },

  QRVEY: {
    CONFIG_ERROR: function() { return "Analytics widget URL is not configured. Please contact your novoed admin."; },
    DOWNLOAD_BOX: function() { return "We are preparing the requested download. You can request a new one once this file is downloaded to your computer."; },
    COMPARE_RESULTS: function() { return "Compare Results"; },
    ALL_QUESTIONS: function() { return "Responses to All Questions Across Attempts"; },
    SURVEY_ALL: function() { return "Response details"; },
    PRE_SURVEY: function() { return "Pre Survey"; },
    POST_SURVEY: function() { return "Post Survey"; },
  },

  COHORT_MANAGEMENT: {
    COHORT: function() { return "Cohort"; },
    PRIMARY: function() { return "Primary"; },
    VIEW_PRIMARY: function() { return "View Primary"; },
    VIEW_COHORTS: function(cohortsCount: number) { return cohortsCount + " " + plural(cohortsCount, 0, en, { one: "Cohort", other: "Cohorts" }); },
    PRIMARY_COURSE: function() { return "Primary Course"; },
    MAKE_PRIMARY: function() { return "Make this a Primary Course"; },
    MAKE_PRIMARY_SUCCESS: function(courseName: string) { return "You have successfully made <span class=\"bold\">" + courseName + "</span> a primary course."; },
    REMOVE_AS_PRIMARY: function() { return "Remove as Primary Course"; },
    REMOVE_AS_PRIMARY_SUCCESS: function(courseName: string) { return "<span class=\"bold\">" + courseName + "</span> is no longer a primary course."; },
    REMOVE_AS_PRIMARY_ALERT_TITLE: function() { return "Remove as Primary Course?"; },
    REMOVE_AS_PRIMARY_ALERT_DESCRIPTION: function(catalogId: string, cohortsCount: number, courseName: string) { return "This <span class=\"bold\">" + courseName + " (" + catalogId + ")</span> has " + cohortsCount + " " + plural(cohortsCount, 0, en, { one: "cohort", other: "cohorts" }) + ". By removing the primary status, they will no longer be marked as cohorts of this course. Are you sure?"; },
    REMOVE_COHORT_STATUS: function() { return "Remove Cohort Status"; },
    REMOVE_COHORT_STATUS_SUCCESS: function(courseName: string) { return "<span class=\"bold\">" + courseName + "</span> is no longer a cohort."; },
    REMOVE_COHORT_STATUS_ALERT_TITLE: function() { return "Remove Cohort Status?"; },
    REMOVE_COHORT_STATUS_ALERT_DESCRIPTION: function(catalogId: string, courseName: string) { return "By doing this, you are removing this course as a cohort of <span class=\"bold\">" + courseName + " (" + catalogId + ")</span>.  This step can't be undone. Are you sure?"; },
    COHORTS_OF_PRIMARY: function(cohortsCount: number, primaryName: string) { return cohortsCount + " " + plural(cohortsCount, 0, en, { one: "Cohort", other: "Cohorts" }) + " of " + primaryName; },
    THIS_IS_PRIMARY: function() { return "This Course is a Primary Course"; },
    MAKE_PRIMARY_CONFIRMATION_MODAL: {
      TITLE: function() { return "You are changing a Production course to be a Primary course intended for cloning a set of cohorts."; },
      ENROLLMENT_TYPE_WARNING: function() { return "Will be changed to closed enrollment and not discoverable if not already set as such"; },
      LMS_LXP_WARNING: function() { return "Will stop syncing to any LMS or LXPs, stopping learner enrollments and completions from being sent"; },
      DESCRIPTION_1: function() { return "Doing so will have the following impact on this course:"; },
      DESCRIPTION_2: function() { return "If this is not suitable to this course, please clone this course and make that as a primary."; },
    },

  },

  LEARNING_CATALOG: {
    BROWSE_CATALOG: function() { return "Browse Catalog"; },
    TITLE: function() { return "Learning Catalog"; },
    SEARCH: function() { return "Search"; },
    LOADING_RESULTS: function() { return "Loading results..."; },
    TOTAL_RESULTS: function(resultCount: number) { return resultCount + " " + plural(resultCount, 0, en, { one: "Result", other: "Results" }); },
    LEARNING_TYPE: function() { return "Learning Type"; },
    SKILLS: function() { return "Skills"; },
    MIN_SEARCH_LENGTH: function(minChars: string) { return "Please enter at least " + minChars + " characters to search"; },
  },

  MENTORING_PROGRAMS: {
    ONE_ON_ONE_PROGRAMS: function() { return "1:1 Programs"; },
    TIER_BADGE: function() { return "Starter"; },
    NO_PROGRAMS_YET: function() { return "No programs yet"; },
    NO_PROGRAMS_YET_SUBTITLE: function() { return "Create your first program to start enabling 1:1 learning experiences across your organization."; },
    CREATE_FIRST_PROGRAM: function() { return "Create Your First Program"; },
    ERRORS: {
      NOT_AUTHORIZED: function() { return "You are not authorized to view this page."; },
      USER_DROPPED: function() { return "You have been unenrolled by the Teaching Team."; },
    },

    PROGRAM_RANGE: function(endDate: string, releasedDate: string) { return releasedDate + " to " + endDate; },
    PROGRAM_START_DATE: {
      NOT_STARTED: function(startDate: string) { return "Starting " + startDate; },
      STARTED: function(startDate: string) { return "Started " + startDate; },
      TOOLTIP: {
        STARTED_AND_HAS_END_DATE: function(endDate: string, startDate: string) { return "Program started on " + startDate + " and will close on " + endDate; },
        NOT_STARTED_AND_HAS_END_DATE: function(endDate: string, startDate: string) { return "Program starts on " + startDate + " and will close on " + endDate; },
        STARTED_AND_HAS_NO_END_DATE: function(startDate: string) { return "Program started on " + startDate + " and does not have a closure date"; },
        NOT_STARTED_AND_HAS_NO_END_DATE: function(startDate: string) { return "Program starts " + startDate + " and does not have a closure date"; },
        CLOSED_PROGRAM: function(endDate: string, startDate: string) { return "Program started on " + startDate + " and closed on " + endDate; },
      },

      NO_DATE_PLACEHOLDER: function() { return "Program Dates (e.g, Started Jan 1, 2025)"; },
    },

    ADD_PROGRAM_DATES: function() { return "Add Program Dates"; },
    NEW_PROGRAM: function() { return "New Program"; },
    CREATE_NEW_PROGRAM: function() { return "Create New Program"; },
    EDIT_PROGRAM_BASICS: function() { return "Edit Program Basics"; },
    PROGRAM_NAME_LABEL: function() { return "Program Name"; },
    PROGRAM_NAME_PLACEHOLDER: function() { return "Enter a program name"; },
    DESCRIPTION_LABEL: function() { return "Program Description (optional)"; },
    DESCRIPTION_PLACEHOLDER: function() { return "Add a description"; },
    PROGRAM_DETAILS: function() { return "Program Details"; },
    EDIT_PROGRAM: function() { return "Edit Program"; },
    VISIT_PROGRAM: function() { return "Click to visit program"; },
    PROGRAM_ADMIN: function() { return "Program Admin"; },
    SETTINGS: {
      TITLE: function() { return "Program Configuration"; },
      TABS: {
        PROGRAM_SETUP: {
          TITLE: function() { return "Program Setup"; },
          DESCRIPTION: function() { return "Configure key details to create the basis of your program structure."; },
          NAME_DESCRIPTION: function() { return "Name and Description"; },
          PROGRAM_DATES: {
            TITLE: function() { return "Program Dates"; },
            RELEASE_DATE: {
              TITLE: function() { return "Release Date"; },
              DESCRIPTION: function() { return "This is when the program opens and participants can access the program workspace."; },
              PLACEHOLDER: function() { return "No date has been selected"; },
              REQUIRED: function() { return "You must select a program release date before match announcement date."; },
            },

            CLOSURE_DATE: {
              TITLE: function() { return "Closure Date"; },
              DESCRIPTION: function() { return "This is when the program ends and participants can no longer access the program workspace."; },
              PLACEHOLDER: function() { return "No date has been selected"; },
              TOOLTIP: function() { return "You must select a program release date before closure date"; },
              ERROR: function() { return "Closure date must be after the program release date"; },
            },

            ERROR_POPOVER: {
              TITLE: function() { return "Please Note:"; },
              DESCRIPTION: function(matchAnnouncementDate: string) { return "Selecting a date beyond the existing Match Auto Run & Announcement Date (" + matchAnnouncementDate + ") will remove it."; },
              CANCEL: function() { return "Cancel"; },
              CONFIRM: function() { return "OK"; },
            },

          },

          PROGRAM_GUIDELINES: {
            TITLE: function() { return "Program Guidelines and Expectations"; },
            DESCRIPTION: function() { return "This will be displayed for all participants on the program workspace. Include information relevant to your program guidelines and expectations such as program purpose, goals, duration, roles and responsibilities, communication guidelines, goal-setting expectations, and conflict resolution processes. Consider linking important program support and resource documentation."; },
          },

          ALIASES: {
            DESCRIPTION: function() { return "Customize terminology for participant roles. "; },
            VALIDATION_ERROR: function() { return "Alias must be a text value"; },
          },

        },

        GUIDANCE: {
          TITLE: function() { return "Guidance"; },
          DESCRIPTION: function() { return "Helpful resources to guide participants through their mentoring experience."; },
          GUIDES_ENABLED: {
            SWITCH_LABEL: function() { return "Guides"; },
            DESCRIPTION: function() { return "Guides are just-in-time resources that help participants build effective relationships. The default set of guides comes from the <a href=\"https://www.centerformentoring.com/\" target=\"_blank\" rel=\"noopener noreferrer\">Center for Mentoring Excellence</a> and includes videos and templates—all fully customizable. Guides are automatically delivered via email, Microsoft Teams, and the participant workspace at optimal times before each session."; },
            WARNING: {
              TITLE: function() { return "Please Note:"; },
              CONTENT: function() { return "Disabling guidance will hide all guides from the platform and stop automated delivery to participants. Continue?"; },
            },

            ARIA_LABEL: {
              TURN_GUIDANCE_ON: function() { return "Turn guidance on"; },
              TURN_GUIDANCE_OFF: function() { return "Turn guidance off"; },
            },

          },

          PARTICIPANT_EXPERIENCE: {
            DESCRIPTION: function() { return "<b>Participant Experience</b><br/><i>Here's how participants experience guides - they can view them in their workspace or open them directly from email and Microsoft Teams notifications."; },
            ALT_LABEL: function() { return "Planning First Meeting"; },
          },

        },

        PROGRAM_PROFILE_SETUP: {
          TITLE: function() { return "Program Profile Setup"; },
          DESCRIPTION_TEXT: function() { return "Enable the fields below to create a \"profile completion\" task for participants."; },
          ORG_LEVEL_FIELDS: {
            TITLE: function() { return "Org Level Fields"; },
            DESCRIPTION_TEXT: function() { return "All of the following fields are displayed to participants. Required fields can be used to help find the best matches."; },
            HEADERS: {
              FIELD_NAME: function() { return "Field Name"; },
              INPUT_TYPE: function() { return "Input Type"; },
              REQUIRED: function() { return "Required?"; },
            },

            NOT_EDITABLE: {
              LABEL: function() { return "Not Editable"; },
              TOOLTIP: function() { return "Field is managed by CSV file but visible to participants in their profiles."; },
            },

            ACCOUNT_LEVEL_FIELDS: {
              INPUT_TYPE_LABEL: {
                IMAGE: function() { return "Image"; },
                TIME_ZONE: function() { return "Time Zone Selector"; },
              },

            },

          },

          PROGRAM_LEVEL_FIELDS: {
            TITLE: function() { return "Program Level Fields"; },
            DESCRIPTION_TEXT: function() { return "Create program-specific questions for your participants. Required fields can be used to help find the best matches."; },
            HEADERS: {
              QUESTION: function() { return "Question"; },
              QUESTION_TYPE: function() { return "Question Type"; },
              REQUIRED: function() { return "Required?"; },
              TIME_ZONE: function() { return "Time Zone"; },
            },

            PLACEHOLDERS: {
              QUESTION_TEXT: function() { return "Question goes here..."; },
              QUESTION_TYPE: function() { return "Select question type"; },
              RESPONSE_OPTIONS: function() { return "Type list of options here, use comma to separate each option"; },
            },

            INPUT_TYPES: {
              DROPDOWN_VALUE: function() { return "Dropdown"; },
              CHECKLIST_VALUE: function() { return "Multi-select Checklist"; },
              SHORT_TEXT_VALUE: function() { return "Short Text"; },
              LONG_TEXT_VALUE: function() { return "Long Text"; },
              TIME_ZONE_VALUE: function() { return "Time Zone Selector"; },
            },

            ADD_QUESTION: function() { return "Add Question"; },
            VALIDATION: {
              REQUIRED_QUESTION_TYPE: function() { return "You must select a question type"; },
              REQUIRED_RESPONSE_OPTIONS: function() { return "You must enter options for this question type"; },
            },

            DISABLED_STATE: {
              MOVE_UP_DOWN: function() { return "Reordering requires a question and question type to be answered"; },
            },

            INLINE_CONFIRMATION: {
              TITLE: function() { return "Delete this question?"; },
              DESCRIPTION: function() { return "This field is being used in a matching rule. This action will both <b>delete this field</b> and <b>delete the matching rule.</b>"; },
              CANCEL: function() { return "Cancel"; },
              DELETE: function() { return "Delete"; },
            },

            REQUIRED_POPOVER: {
              TITLE: function() { return "Please Note:"; },
              DESCRIPTION: function() { return "This field is being used as a matching rule. <br/>This action will remove that rule."; },
              CANCEL: function() { return "Cancel"; },
              OK: function() { return "OK"; },
            },

            ARIA_LABEL: {
              PROGRAM_QUESTION_OPTIONS_MENU: function() { return "Program Question Options Menu"; },
              DELETE_PROGRAM_LEVEL_QUESTION: function() { return "Delete Program Level Question"; },
              MOVE_PROGRAM_LEVEL_QUESTION_UP: function() { return "Move Program Level Question Up"; },
              MOVE_PROGRAM_LEVEL_QUESTION_DOWN: function() { return "Move Program Level Question Down"; },
            },

            SWITCH_QUESTION_TYPE: {
              GENERAL: {
                ARIA_LABEL: function() { return "Switch to Personalize Question Type"; },
                TOOLTIP: function() { return "Personalize question for mentors and mentees"; },
              },

              PERSONALIZE: {
                ARIA_LABEL: function() { return "Switch to General Question Type"; },
                TOOLTIP: function() { return "Switch back to general question"; },
              },

            },

          },

          ARIA_LABEL: {
            ENABLE_FIELD: function(questionText: string) { return "Enable " + questionText; },
            DISABLE_FIELD: function(questionText: string) { return "Disable " + questionText; },
          },

        },

        MATCHING_SETTINGS: {
          MATCHING_TITLE: function() { return "Matching"; },
          DESCRIPTION: function() { return "Configure key details on the timing and requirements for matching participants in your program."; },
          MATCHING_TYPE: {
            TITLE: function() { return "Matching Type"; },
            DESCRIPTION: function() { return "Select a matching type that best supports your program."; },
            OPTIONS: {
              PARTICIPANT_DRIVEN: {
                TITLE: function() { return "Participant-Driven"; },
                DESCRIPTION: function(d) { return d.MenteesAlias + " choose their " + d.mentorAlias; },
                CONTENT: function(d) { return "Participants take the lead. " + d.MenteesAlias + " browse available " + d.mentorsAlias + " and send requests. " + d.MentorsAlias + " set their availability and accept requests to form matches."; },
                SWITCH_CONFIRMATION: {
                  TITLE: function() { return "Change match type to Participant-Driven matching?"; },
                  BODY: function(d) { return "<ul><li>" + d.MenteesAlias + " will browse and request " + d.mentorsAlias + " rather than having a " + d.mentorAlias + " assigned</li><li>Existing connections will not be impacted</li><li>Any customized messages will be reset to defaults</li></ul>"; },
                },

              },

              ASSIGNED: {
                TITLE: function() { return "Assigned"; },
                DESCRIPTION: function() { return "Admins control matching"; },
                CONTENT: function(d) { return d.MentorAlias + "-" + d.menteeAlias + " pairs are automatically assigned by the system or created by admins. Admins define matching rules, set " + d.mentorAlias + " capacity, and control when matches are announced."; },
                SWITCH_CONFIRMATION: {
                  TITLE: function() { return "Change match type to Assigned matching?"; },
                  BODY: function(d) { return "<ul><li>" + d.MenteesAlias + " will no longer be able to browse and request " + d.mentorsAlias + "</li><li>Any pending requests will be withdrawn</li><li>Existing connections will not be impacted</li><li>Any customized messages will be reset to defaults</li></ul>"; },
                },

              },

            },

            CONFIGURATION: {
              TITLE: function() { return "Configuration"; },
              PARTICIPANT_DRIVEN: {
                CONTENT: function() { return "No additional configuration needed for Participant-Driven matching."; },
                DETAILS: function(d) { return d.MenteesAlias + " will browse and request " + d.mentorsAlias + " directly."; },
              },

              ASSIGNED: {
                CONNECTIONS: {
                  SUBTITLE: function(d) { return "Set the maximum number of " + d.menteesAlias + " each " + d.mentorAlias + " can work with at the same time."; },
                  DESCRIPTION: function(d) { return d.MentorsAlias + " may have up to <span id=\"" + d.inputId + "\"></span> " + d.menteesAlias + " at a time."; },
                  WARNING: {
                    TITLE: function() { return "Please Note:"; },
                    CONTENT: function(d) { return "Decreasing this to 1 will remove the ability for " + d.mentorsAlias + " to choose their own capacity limits and update all capacity limits to 1. Would you like to proceed?"; },
                  },

                  ARIA_LABEL: function() { return "Connections Number"; },
                },

                MENTOR_CAPACITY: {
                  TITLE: function(d) { return "Let " + d.mentorsAlias + " choose their own capacity (up to this limit)"; },
                  INFO: function(d) { return "Allows " + d.mentorsAlias + " to choose their own capacity during profile setup. Only available when the maximum is greater than 1."; },
                  WARNING: {
                    TITLE: function() { return "Please Note:"; },
                    CONTENT: function(d) { return "By unchecking this, " + d.mentorsAlias + " will no longer be able to choose their own capacity and all capacity limits will be updated to " + d.maxMentees + "."; },
                  },

                },

                MATCH_ANNOUNCEMENT_DATE: {
                  TITLE: function() { return "Match Auto Run & Announcement Date"; },
                  DESCRIPTION: function() { return "All matched participants will receive an email notifying them of their match.<br/><br/><i>*We will also run auto-matching on this date and time for unmatched participants.*</i>"; },
                  NOTE_NO_DATE: function() { return "<b>Auto-Matching</b><br/><i>If you'd like to utilize auto-matching immediately, you can enable the toggle on your program homepage at any time. This will not impact your match announcement date.</i>"; },
                  PLACEHOLDER: function() { return "No date has been selected"; },
                  TOOLTIP: function() { return "You must select a program release date before match announcement date"; },
                  ERROR_BEFORE_RELEASE_DATE: function() { return "Match announcement date must be after the program release date"; },
                  ERROR_AFTER_CLOSURE_DATE: function() { return "Match announcement date must be before the program closure date"; },
                },

                MATCHING_RULES: {
                  TITLE: function() { return "Matching Rules"; },
                  DESCRIPTION: function() { return "Matching rules play a crucial role in ensuring the best possible matches in a program. They help define the essential qualities and criteria that mentors and mentees should have in common, such as professional background, goals, and communication styles. Use matching rules to create specific matching criteria based on organization and/or program-level fields."; },
                  SELECT_MATCHING_RULES: function() { return "Select Matching Rules"; },
                  FLYOUT_MODAL: {
                    TOOLTIP: {
                      HIDDEN: function() { return "Hidden from User Profile"; },
                      SHOWN: function() { return "Shown in User Profile"; },
                    },

                    TITLE: function() { return "Matching Rules"; },
                    DESCRIPTION: function() { return "Select the matching rules you'd like to configure for your program connections."; },
                    ORG_LEVEL_FIELDS: function() { return "Org Level Fields"; },
                    PROGRAM_LEVEL_FIELDS: function() { return "Program Level Fields"; },
                    EMPTY_FIELDS: {
                      ORG_FIELDS: {
                        NO_FIELDS: function() { return "No org level fields"; },
                        NOTE_CONTENT_WITH_PERMISSIONS: function() { return "Org level fields are configurable in your institution \"Advanced Settings -> Data Configuration -> Organization Profile\""; },
                        NOTE_CONTENT_WITHOUT_PERMISSIONS: function() { return "Org level fields are configurable in your org institution. Reach out to your org admin for assistance."; },
                        OPEN_ADVANCED_SETTINGS: function() { return "Open Advanced Settings"; },
                      },

                      PROGRAM_FIELDS: {
                        NO_FIELDS: function() { return "No program level fields"; },
                        NOTE_CONTENT: function() { return "Program level fields must be marked as \"required\" in order to be used as a matching rule."; },
                      },

                      NOTE: function() { return "Note"; },
                    },

                    CANCEL: function() { return "Cancel"; },
                    SAVE: function() { return "Save"; },
                    ARIA_LABEL: {
                      ENABLE_RULE: function(questionText: string) { return "Enable " + questionText; },
                      DISABLE_RULE: function(questionText: string) { return "Disable " + questionText; },
                      SAVE: function() { return "Save Matching Rules"; },
                    },

                  },

                  LIST: {
                    HEADERS: {
                      RULES: function(rulesCount: number) { return "Rules (" + rulesCount + ")"; },
                      IMPORTANCE_LEVEL: function() { return "Importance Level"; },
                    },

                    EXPRESSION: {
                      DESCRIPTION: function() { return "Participants should be connected if their answers are"; },
                      TIME_ZONE_DESCRIPTION: function() { return "Participants should be connected if their time zones are within"; },
                      TYPES: {
                        SIMILAR: function() { return "similar"; },
                        DIFFERENT: function() { return "different"; },
                      },

                    },

                    IMPORTANCE_LEVEL: {
                      NICE_TO_HAVE: {
                        TITLE: function() { return "Nice to Have"; },
                        DESCRIPTION: function() { return "Lightly considered criteria for all system-generated matches."; },
                      },

                      PREFERRED: {
                        TITLE: function() { return "Preferred"; },
                        DESCRIPTION: function() { return "Moderately considered criteria for all system-generated matches."; },
                      },

                      REQUIRED: {
                        TITLE: function() { return "Required"; },
                        DESCRIPTION: function() { return "Strictly enforced criteria for all system-generated matches."; },
                      },

                    },

                    POPOVER: {
                      LEARN_MORE: function() { return "Learn more about matching rules"; },
                    },

                    PARTICIPANT_QUESTION: {
                      TOOLTIP: function(d) { return select(d.role, { MENTORSHIP_PROGRAM_MENTOR: d.MentorAlias, other: d.MenteeAlias }) + " Question"; },
                    },

                  },

                  INLINE_CONFIRMATION: {
                    TITLE: function() { return "Remove this rule?"; },
                    DESCRIPTION: function(rule: string) { return "Are you sure you'd like to remove the rule \"" + rule + "\"? <br />This action will <b>remove</b> this rule from your active matching rules."; },
                    CANCEL: function() { return "Cancel"; },
                    DELETE: function() { return "Delete"; },
                  },

                  ARIA_LABEL: {
                    MATCHING_RULE_OPTIONS_MENU: function() { return "Matching Rule Options Menu"; },
                    DELETE_MATCHING_RULE: function() { return "Delete Matching Rule"; },
                  },

                },

              },

            },

            ARIA_LABEL: {
              SELECT_MATCHING_TYPE: function(title: string) { return "Select " + title + " Matching Type"; },
            },

          },

        },

        FEEDBACK_SETTINGS: {
          TITLE: function() { return "Feedback"; },
          DESCRIPTION: function() { return "Get insights from participants about their mentoring sessions and overall experience."; },
          SESSION_PULSE_CHECKS: function() { return "Session Pulse Checks"; },
          SESSION_PULSE_CHECKS_DESCRIPTION: function() { return "After each session, participants get a quick 3-question survey about how valuable their time was, whether they're making progress, and how they're feeling about the support they're getting. Participants will receive pulse checks in their workspace and through email and Microsoft Teams."; },
          ARIA_LABEL: {
            TURN_PULSE_CHECKS_ON: function() { return "Turn pulse checks on"; },
            TURN_PULSE_CHECKS_OFF: function() { return "Turn pulse checks off"; },
          },

          WARNING: {
            TITLE: function() { return "Please Note:"; },
            CONTENT: function() { return "Disabling pulse checks will stop automated delivery of pulse checks to participants. Continue?"; },
          },

          PULSE_CHECKS_INFO: {
            TITLE: function() { return "A way to measure engagement and impact"; },
            DESCRIPTION: function(link: string) { return "When enabled, use the <a href=\"" + link + "\">Session Pulse Checks</a> data downloads to gain insight into program participation, engagement levels and employee satisfaction."; },
            ALT_LABEL: function() { return "Session Pulse Check Illustration"; },
          },

        },

        PROGRAM_WRAP_UP: {
          TITLE: function() { return "Program Wrap-Up"; },
          DESCRIPTION: function() { return "Help participants close out their mentorship with intention — celebrating progress and reflecting on the experience together."; },
          PROGRAM_REFLECTIONS: {
            TITLE: function() { return "Program Reflections"; },
            DESCRIPTION: function() { return "When a pair reaches the session below, both participants are notified and invited to review a summary of their mentorship journey and share written reflections."; },
            STARTING_SESSION: function() { return "Send program reflection prompt starting at session"; },
            WARNING: {
              TITLE: function() { return "Please Note:"; },
              CONTENT: function() { return "Disabling program reflections will hide the program summary and prevent participants from submitting their reflections. Continue?"; },
            },

            ARIA_LABEL: {
              TURN_PROGRAM_REFLECTIONS_ON: function() { return "Turn program reflections on"; },
              TURN_PROGRAM_REFLECTIONS_OFF: function() { return "Turn program reflections off"; },
            },

          },

        },

      },

      SAVING: function() { return "Saving"; },
      SAVED: function() { return "Saved!"; },
      THANK_YOU: function() { return "Thank you!"; },
      UPDATE_SUCCESS: function() { return "Program Configuration Updated!"; },
      ARIA_LABEL: {
        SETTINGS_LINK: function() { return "Mentorship Program Settings"; },
        GO_BACK: function() { return "Go back"; },
      },

    },

    MANUALLY_ADD_USERS: function() { return "Manually Add Users"; },
    BULK_UPLOAD: function() { return "Bulk Upload (.csv)"; },
    BULK_UPLOAD_MODAL: {
      TITLE: function() { return "Bulk Upload"; },
      DESCRIPTION: function() { return "You can upload a CSV to add participants to this program and assign roles in bulk. We have a template that can be used for your upload."; },
      NOTE: function() { return "Note:"; },
      NOTE_1: function() { return "The header row is required in your CSV and External ID column should ONLY be used if using SSO with external ID configured."; },
      NOTE_2: function() { return "You can upload users with one type of role at a time."; },
      NOTE_3: function() { return "Uploads will take at least 10 seconds to display."; },
      DOWNLOAD_TEMPLATE: function() { return "Download Template"; },
      UPLOAD_CSV: function() { return "Upload CSV"; },
      PARTICIPANTS_FOUND: function() { return "Below are the participants found within your CSV file. Please review and apply a role to these participants"; },
      EXISTING_USERS_NOTE: function() { return " adding existing users with a different role will result in a role change. Please make sure that the user and role selection is accurate before adding."; },
      NUM_PARTICIPANTS: function(userCount: number) { return userCount + " " + plural(userCount, 0, en, { one: "Participant", other: "Participants" }); },
      APPLY_A_ROLE: function() { return "Apply a role"; },
      NUM_ERRORS_FOUND: function(errorCount: number, participantCount: number) { return errorCount + " " + plural(errorCount, 0, en, { one: "error", other: "errors" }) + " found for " + participantCount + " " + plural(participantCount, 0, en, { one: "participant", other: "participants" }); },
      YOU_CAN_PROCEED: function() { return "You can proceed and these users will not be added."; },
      ROW_NUM: function(rowCount: number) { return "Row " + rowCount; },
      UPLOAD_NEW_CSV: function() { return "Upload New CSV"; },
      CONFIRM: function() { return "Confirm"; },
      ALL_PARTICIPANTS_ADDED: function(newEnrolledCount: number) { return newEnrolledCount + " " + plural(newEnrolledCount, 0, en, { one: "user", other: "users" }) + " added"; },
      SOME_PARTICIPANTS_ADDED: function(existingUsersCount: number, newEnrolledCount: number) { return newEnrolledCount + " " + plural(newEnrolledCount, 0, en, { one: "user has", other: "users have" }) + " been added to the program, " + existingUsersCount + " " + plural(existingUsersCount, 0, en, { one: "user", other: "users" }) + " already " + plural(existingUsersCount, 0, en, { one: "exists", other: "exist" }) + " in the program"; },
      NO_PARTICIPANTS_ADDED: function(existingUsersCount: number) { return existingUsersCount + " " + plural(existingUsersCount, 0, en, { one: "user", other: "users" }) + " already " + plural(existingUsersCount, 0, en, { one: "exists", other: "exist" }) + " in the program"; },
      ERRORS: {
        FIRST_NAME_BLANK: function() { return "First Name Cannot Be Blank"; },
        LAST_NAME_BLANK: function() { return "Last Name Cannot Be Blank"; },
        EMAIL_BLANK: function() { return "Email Cannot Be Blank"; },
        EMAIL_INVALID: function() { return "Invalid Email"; },
        EMAIL_DUPLICATED: function() { return "Duplicated Email"; },
        CSV_INVALID: function() { return "Invalid CSV File"; },
      },

    },

    PARTICIPANTS: {
      ADD: function() { return "Add Participant"; },
      EDIT: function() { return "Edit Participant"; },
      ADD_MANUALLY: function() { return "Add Manually"; },
      ADD_EXISTING: function() { return "Add Existing"; },
      EMPTY: function(d) { return "No " + select(d.role, { MENTORSHIP_PROGRAM_ADMIN: "program admins", MENTORSHIP_PROGRAM_MENTOR: d.mentorsAlias, other: d.menteesAlias }) + " have been added."; },
      NO_RESULTS_FOUND: function() { return "No results found"; },
      X_TOTAL_PARTICIPANTS: function(participantsCount: number) { return participantsCount + " total"; },
      ADD_SUCCESS: function(count: number) { return count + " " + plural(count, 0, en, { one: "participant", other: "participants" }) + " has been added"; },
      PARTICIPANT_MANAGEMENT: function() { return "Participant Management"; },
      PARTICIPANTS: function() { return "Participants"; },
      WARNING: function() { return "You are about to delete a participant. This operation is not reversible."; },
      REMOVE_PARTICIPANT_MODAL: {
        TITLE: function(participant: string) { return "Are you sure you want to remove the following participant: <br/>" + participant; },
        BODY: function() { return "This will delete all of their program related activities. If they are in a connection, their mentor/mentee will be reset to \"unmatched\". This action is final and cannot be undone.<br/><br/>Are you sure?"; },
      },

      CONFIRMATION_MODAL: {
        CHANGE_ROLE: {
          TITLE: function() { return "Change role"; },
          BODY: function(participantName: string) { return "This will unpair all of " + participantName + "'s active connections. This action is final and cannot be undone.<br/><br/>Are you sure?"; },
        },

        MODIFY_OWN_USER: function() { return "You are modifying permissions on your own account and you may lose access to this page if you continue. Are you sure you want to continue?"; },
      },

      PARTICIPANT_NOT_ADDED: function() { return "Participant Not Added"; },
      USER_ALREADY_EXISTS: function() { return "User already exists in this program"; },
      PARTICIPANT_ROW: {
        MATCHED: function() { return "Matched"; },
        UNMATCHED: function() { return "Unmatched"; },
        MATCHED_WITH_CAPACITY: function() { return "Matched (with capacity)"; },
        MATCHED_OVER_CAPACITY: function() { return "Matched (over capacity)"; },
        ASSIGN_MENTOR: function(d) { return "Assign a " + d.MentorAlias; },
        EDIT: function() { return "Edit Name, Email or Role"; },
        REMOVE: function() { return "Remove Participant"; },
        ASSIGN_MENTEES: function(d) { return "Assign " + d.MenteeAlias + "(s)"; },
      },

      TABLE: {
        STATUS: function() { return "Match Status"; },
        AVAILABILITY: function() { return "Availability"; },
        ASSIGNED_MENTOR: function(d) { return "Assigned " + d.MentorAlias; },
        ASSIGNED_MENTEES: function(d) { return "Assigned " + d.MenteesAlias; },
      },

      ARIA_LABEL: {
        PARTICIPANT_MENU: function() { return "Participant Menu"; },
      },

    },

    CONNECTIONS: {
      TITLE: function() { return "Connections"; },
      SEARCH_PLACEHOLDER: function() { return "Search for participant by name or email"; },
      SUCCESS_MESSAGE: function(createdConnectionsCount: number) { return createdConnectionsCount + " " + plural(createdConnectionsCount, 0, en, { one: " connection", other: " connections" }) + " created"; },
      SUCCESS_MESSAGE_NO_CONNECTIONS_WITH_UNMATCHED_TITLE: function() { return "Auto-Matching Complete!"; },
      SUCCESS_MESSAGE_NO_CONNECTIONS_WITH_UNMATCHED: function() { return "0 connections created"; },
      SUCCESS_MESSAGE_CONNECTIONS_WITH_UNMATCHED: function(createdConnectionsCount: number, unmatchedCount: number) { return createdConnectionsCount + " " + plural(createdConnectionsCount, 0, en, { one: " connection", other: " connections" }) + " created, " + unmatchedCount + " " + plural(unmatchedCount, 0, en, { one: " participant", other: " participants" }) + " unmatched"; },
    },

    COMMUNICATIONS: {
      TITLE: function() { return "Communications"; },
      ADD_COMMUNICATION: function() { return "Add Communication"; },
      TABLE: {
        COLUMNS: {
          MESSAGE_TYPE: function() { return "Message Type"; },
          SUBJECT: function() { return "Subject"; },
          TO: function() { return "To"; },
          STATUS: function() { return "Status"; },
        },

        EMPTY: function() { return "No communications have been added"; },
        STATUS: {
          TURN_COMMUNICATION_ON: function() { return "Turn communication on"; },
          TURN_COMMUNICATION_OFF: function() { return "Turn communication off"; },
        },

        OPTIONS: {
          VIEW: function() { return "View"; },
          EDIT: function() { return "Edit"; },
          MAKE_A_COPY: function() { return "Make a Copy"; },
          DELETE: function() { return "Delete"; },
          DELETE_CONFIRMATION_MODAL: {
            TITLE: function() { return "Delete this communication?"; },
            BODY: function() { return "Are you sure you want to delete this communication? This action is final and cannot be undone."; },
            DELETION_SUCCESS: function() { return "Communication has been deleted."; },
          },

        },

        ARIA_LABEL: {
          COMMUNICATION_OPTIONS_MENU: function() { return "Communication Options Menu"; },
        },

      },

      MESSAGE_TYPES: {
        WELCOME_MESSAGE: {
          TITLE: function() { return "Welcome Message"; },
          SENT_ON: function() { return "Automatically sent on enrollment."; },
        },

        PROFILE_COMPLETION_REMINDER: {
          TITLE: function() { return "Reminder: Profile Completion"; },
          SENT_ON: function() { return "Automatically sent 5 days before Match Announcement Date."; },
        },

        MATCH_ANNOUNCEMENT: {
          TITLE: function() { return "Match Announcement"; },
          SENT_ON: {
            ASSIGNED: function() { return "Automatically sent on Match Announcement Date."; },
            PARTICIPANT_DRIVEN: function(d) { return "Automatically sent when " + d.mentorAlias + " accepts the " + d.menteeAlias + " request."; },
          },

        },

      },

      COMMUNICATION_MODAL: {
        ADD_MODE: {
          TITLE: function() { return "Add Communication"; },
          ADD_SUCCESS: function() { return "Communication has been added."; },
          DEFAULT_CUSTOM_TEMPLATES: {
            AUTO: {
              WELCOME_MESSAGE: {
                MENTOR_AND_MENTEE: {
                  SUBJECT: function() { return "Welcome to [PROGRAM_NAME]!"; },
                  BODY: function() { return "<p>Hi [FIRST_NAME],<br><br>We're excited to officially welcome you to [PROGRAM_NAME]!<br><br><strong>What's Next?</strong><br>To help us create the best match for you, we need a little help from you:<br><br>1. <strong>Get started:</strong> [PROGRAM_PROFILE_URL] to share your experience, interests, and what you're looking to achieve in this program.<br>2. <strong>Stay tuned for your match:</strong> We'll notify you as soon as you're matched!<br><br><strong>Why Complete Your Profile?</strong><br>💫 Helps us connect you with someone who shares your interests and goals<br>🎯 Speeds up your matching process<br>✨ Create meaningful connections from the start<br><br>In the meantime, if you have any questions, feel free to reach out to your program administrators.<br><br>[INSERT_PASSWORD_SENTENCE]</p>"; },
                },

              },

              PROFILE_COMPLETION_REMINDER: {
                MENTOR_AND_MENTEE: {
                  SUBJECT: function() { return "[FIRST_NAME], let's find your perfect match"; },
                  BODY: function() { return "<p>Hi [FIRST_NAME],<br><br>Just a friendly reminder to complete your profile in [PROGRAM_NAME].<br><br><strong>Here's why your profile matters:</strong><br>💫 It helps us connect you with someone who shares your interests and goals<br>🎯 Speeds up your matching process<br>✨ Create meaningful connections from the start<br><br>It's quick and easy → [PROGRAM_PROFILE_URL]</p>"; },
                },

              },

              MATCH_ANNOUNCEMENT: {
                MENTOR_AND_MENTEE: {
                  SUBJECT: function() { return "🎉 You've Been Matched in [PROGRAM_NAME]! Let the Journey Begin!"; },
                  BODY: function() { return "Hi [FIRST_NAME],<br><br>We're thrilled to announce that you've been matched! This is the start of a meaningful journey where you'll learn, share, and grow together.<br><br><strong>What's Next?</strong><br>Get started by viewing your match and breaking the ice with a quick hello. Share a bit about yourself, your goals, and what you hope to gain from this experience. Then, schedule your first session by connecting your calendar and finding a time that works for both of you. Let's kick things off!<br><br>[VIEW_MATCH_URL]<br><br><strong>Tips for Success</strong><br><strong>Stay Curious:</strong> Ask questions and explore new perspectives.<br><strong>Be Open:</strong> Great relationships thrive on trust and transparency.<br><strong>Have Fun!</strong> Growth is important, but so is enjoying the process.<br><br>We're here to support you every step of the way. If you have questions or need help, don't hesitate to reach out to your program administrators."; },
                },

              },

            },

            PARTICIPANT_DRIVEN: {
              WELCOME_MESSAGE: {
                MENTOR_AND_MENTEE: {
                  SUBJECT: function() { return "Welcome to [PROGRAM_NAME]!"; },
                  BODY: function(d) { return "<p>Hi [FIRST_NAME],<br><br>We're excited to officially welcome you to [PROGRAM_NAME]!<br><br><strong>What's Next?</strong><br>To get the most out of this experience, we need a little help from you:<br><br>1. <strong>Get started:</strong> [PROGRAM_PROFILE_URL] to share your experience, interests, and what you're looking to achieve in this program.<br>2. <strong>Start connecting:</strong><ul><li><strong>For " + d.MenteesAlias + ":</strong> Explore available " + d.mentorsAlias + " and send requests to those who align with your goals and interests. [FIND_MENTOR_URL]</li><li><strong>For " + d.MentorsAlias + ":</strong> Review connection requests from " + d.menteesAlias + " and accept those that fit your availability and expertise.</li></ul><strong>Why Complete Your Profile?</strong><br>💫 Helps others understand your goals, expertise, and availability<br>🎯 Makes it easier to find great matches<br>✨ Creates meaningful connections from the start<br><br>In the meantime, if you have any questions, feel free to reach out to your program administrators.<br><br>[INSERT_PASSWORD_SENTENCE]</p>"; },
                },

                MENTOR: {
                  SUBJECT: function() { return "Welcome to [PROGRAM_NAME]!"; },
                  BODY: function(d) { return "<p>Hi [FIRST_NAME],<br><br>We're excited to officially welcome you to [PROGRAM_NAME]!<br><br><strong>What's Next?</strong><br>To get the most out of this experience, we need a little help from you:<br><br>1. <strong>Get started:</strong> [PROGRAM_PROFILE_URL] to share your experience, interests, and what you're looking to achieve in this program.<br>2. <strong>Review connection requests:</strong> You'll receive connection requests from " + d.menteesAlias + ". Accept those that fit your availability and expertise.<br><br><strong>Why Complete Your Profile?</strong><br>💫 Helps " + d.menteesAlias + " understand your expertise and availability<br>🎯 Attracts the right connection requests<br>✨ Creates meaningful connections from the start<br><br>In the meantime, if you have any questions, feel free to reach out to your program administrators.<br><br>[INSERT_PASSWORD_SENTENCE]</p>"; },
                },

                MENTEE: {
                  SUBJECT: function() { return "Welcome to [PROGRAM_NAME]!"; },
                  BODY: function(d) { return "<p>Hi [FIRST_NAME],<br><br>We're excited to officially welcome you to [PROGRAM_NAME]!<br><br><strong>What's Next?</strong><br>To get the most out of this experience, we need a little help from you:<br><br>1. <strong>Get started:</strong> [PROGRAM_PROFILE_URL] to share your experience, interests, and what you're looking to achieve in this program.<br>2. <strong>Connect with a " + d.mentorAlias + ":</strong> Explore available " + d.mentorsAlias + " and send requests to those who align with your goals and interests. [FIND_MENTOR_URL]<br><br><strong>Why Complete Your Profile?</strong><br>💫 Helps " + d.mentorsAlias + " understand your goals and background<br>🎯 Increases your chances of getting accepted when you send requests<br>✨ Makes a strong first impression with potential " + d.mentorsAlias + "<br><br>In the meantime, if you have any questions, feel free to reach out to your program administrators.<br><br>[INSERT_PASSWORD_SENTENCE]</p>"; },
                },

              },

              MATCH_ANNOUNCEMENT: {
                MENTOR_AND_MENTEE: {
                  SUBJECT: function() { return "🎉 You've Been Matched in [PROGRAM_NAME]! Let the Journey Begin!"; },
                  BODY: function() { return "Hi [FIRST_NAME],<br><br>We're thrilled to announce that you've been matched with [MATCH_NAME]! This is the start of a meaningful journey where you'll learn, share, and grow together.<br><br><strong>What's Next?</strong><br>Get started by viewing your match and breaking the ice with a quick hello. Share a bit about yourself, your goals, and what you hope to gain from this experience. Then, schedule your first session by connecting your calendar and finding a time that works for both of you. Let's kick things off!<br><br>[VIEW_MATCH_URL]<br><br><strong>Tips for Success</strong><br><strong>Stay Curious:</strong> Ask questions and explore new perspectives.<br><strong>Be Open:</strong> Great relationships thrive on trust and transparency.<br><strong>Have Fun!</strong> Growth is important, but so is enjoying the process.<br><br>We're here to support you every step of the way. If you have questions or need help, don't hesitate to reach out to your program administrators."; },
                },

                MENTOR: {
                  SUBJECT: function() { return "🎉 You've Been Matched in [PROGRAM_NAME]! Let the Journey Begin!"; },
                  BODY: function() { return "Hi [FIRST_NAME],<br><br>You and [MATCH_NAME] are ready to work together!<br><br>We're thrilled to announce that you've been matched! This is the start of a meaningful journey where you'll learn, share, and grow together.<br><br><strong>What's Next?</strong><br>Get started by viewing your match and breaking the ice with a quick hello. Share a bit about yourself, your goals, and what you hope to gain from this experience. Then, schedule your first session by connecting your calendar and finding a time that works for both of you. Let's kick things off!<br><br>[VIEW_MATCH_URL]<br><br><strong>Tips for Success</strong><br><strong>Stay Curious:</strong> Ask questions and explore new perspectives.<br><strong>Be Open:</strong> Great relationships thrive on trust and transparency.<br><strong>Have Fun!</strong> Growth is important, but so is enjoying the process.<br><br>We're here to support you every step of the way. If you have questions or need help, don't hesitate to reach out to your program administrators."; },
                },

                MENTEE: {
                  SUBJECT: function() { return "🎉 You've Been Matched in [PROGRAM_NAME]! Let the Journey Begin!"; },
                  BODY: function() { return "Hi [FIRST_NAME],<br><br>[MATCH_NAME] has accepted your request and is ready to work together!<br><br>We're thrilled to announce that you've been matched! This is the start of a meaningful journey where you'll learn, share, and grow together.<br><br><strong>What's Next?</strong><br>Get started by viewing your match and breaking the ice with a quick hello. Share a bit about yourself, your goals, and what you hope to gain from this experience. Then, schedule your first session by connecting your calendar and finding a time that works for both of you. Let's kick things off!<br><br>[VIEW_MATCH_URL]<br><br><strong>Tips for Success</strong><br><strong>Stay Curious:</strong> Ask questions and explore new perspectives.<br><strong>Be Open:</strong> Great relationships thrive on trust and transparency.<br><strong>Have Fun!</strong> Growth is important, but so is enjoying the process.<br><br>We're here to support you every step of the way. If you have questions or need help, don't hesitate to reach out to your program administrators."; },
                },

              },

            },

          },

        },

        VIEW_MODE: {
          TITLE: function() { return "View Communication"; },
          EMAIL_PREVIEW: {
            HEADER: function() { return "Email:"; },
            SUBJECT: function() { return "Subject:"; },
            FROM: function() { return "From:"; },
            NOVOED_LOGO: function() { return "NovoEd Logo"; },
            COPYRIGHT: function(institutionName: string, year: string) { return "© " + year + " " + institutionName; },
          },

        },

        EDIT_MODE: {
          TITLE: function() { return "Edit Communication"; },
          DELIVERY_SECTION: {
            TO: {
              TITLE: function() { return "To"; },
              OPTIONS: {
                MENTORS: function(d) { return d.MentorsAlias; },
                MENTEES: function(d) { return d.MenteesAlias; },
                MENTORS_AND_MENTEES: function(d) { return d.MentorsAlias + " and " + d.MenteesAlias; },
              },

            },

            MESSAGE_TYPE: {
              TITLE: function() { return "Message Type"; },
            },

          },

          CONTENT_SECTION: {
            SUBJECT: function() { return "Subject"; },
            CONTENT: function() { return "Content"; },
          },

          ERRORS: {
            SUBJECT: function(maxLength: string) { return "Subject line must be " + maxLength + " characters or less."; },
          },

          PLACEHOLDERS: {
            TO: function() { return "Choose who this goes to"; },
            MESSAGE_TYPE: function() { return "Choose a message type"; },
            SUBJECT: function() { return "Enter subject line here"; },
            CONTENT: function() { return "Type your program message here"; },
          },

          DISCARD_CHANGES: {
            TITLE: function() { return "Discard unsaved changes?"; },
            BODY: function() { return "Are you sure you want to discard the changes you made?"; },
          },

          UPDATE_SUCCESS: function() { return "Communication has been updated."; },
        },

        COPY_MODE: {
          TITLE: function() { return "Copy Communication"; },
          COPY_SUCCESS: function() { return "Communication has been added."; },
        },

        DISABLED: function() { return "This communication is turned off"; },
      },

    },

    GUIDES: {
      TITLE: function() { return "Guides"; },
      ADD_GUIDE: function() { return "Add Guide"; },
      COLUMNS: {
        APPEARS_IN: function() { return "Appears In"; },
        TITLE: function() { return "Title"; },
        AUDIENCE: function() { return "Audience"; },
      },

      APPEARS_IN: {
        MY_GOALS: function() { return "My Goals"; },
        PROFILE_COMPLETION: function() { return "Profile Completion"; },
        SINGLE_SESSION: function(sessionNumber: string) { return "Session " + sessionNumber; },
        MULTI_SESSION: function(beginningSessionNumber: string, endSessionNumber: string) { return "Sessions " + beginningSessionNumber + "-" + endSessionNumber; },
      },

      OPTIONS: {
        VIEW: function() { return "View"; },
        EDIT: function() { return "Edit"; },
        MAKE_A_COPY: function() { return "Make a Copy"; },
        DELETE: function() { return "Delete"; },
        DELETE_GUIDE_DIALOG: {
          TITLE: function() { return "Delete this guide?"; },
          BODY: function() { return "Are you sure you want to delete this guide? All content and attachments will be deleted. This action is final and cannot be undone."; },
        },

        GUIDE_DELETED_SUCCESS: function() { return "Guide has been deleted."; },
      },

      CREATE_GUIDE_FLYOUT: {
        GUIDE: function() { return "Guide"; },
        TITLE: function() { return "Title"; },
        TITLE_PLACEHOLDER: function() { return "Enter guide title..."; },
        CONTENT: function() { return "Content"; },
        VIDEO: function() { return "Video"; },
        UPLOAD_ONE_VIDEO: function() { return "Upload up to one video (MP4, MOV, AVI) file up to 750MB in size for this guide."; },
        RELATED_MATERIALS: function() { return "Related Materials"; },
        UPLOAD_ADDITIONAL_RESOURCES: function() { return "Upload any additional resources."; },
        UPLOAD_DOCUMENTS: function() { return "Upload Documents"; },
        DELETE_ATTACHMENT_WARNING: function() { return "Are you sure you want to delete?"; },
        DELIVERY_SECTION: {
          AUDIENCE: function() { return "Audience"; },
          MENTORS_AND_MENTEES: function(d) { return d.MentorsAlias + " and " + d.MenteesAlias; },
          APPEARS_IN: function() { return "Appears In"; },
          MY_GOALS: function() { return "My Goals"; },
          MY_GOALS_HELP_TEXT: function() { return "Always visible in the participant's 'My Goals' section."; },
          PROFILE_COMPLETION: function() { return "Profile Completion"; },
          PROFILE_COMPLETION_HELP_TEXT: function() { return "Automatically delivered after profile is completed."; },
          A_SPECIFIC_SESSION: function() { return "A Specific Session"; },
          A_SPECIFIC_SESSION_HELP_TEXT: function() { return "Automatically sent 24 hours after the previous session, with a reminder sent 48 hours before this session."; },
          FIRST_SESSION_HELP_TEXT: function() { return "Automatically sent 24 hours after profile completion, with a reminder sent 48 hours before this session."; },
          A_RANGE_OF_SESSIONS: function() { return "A Range of Sessions"; },
          TO: function() { return "to"; },
          A_RANGE_OF_SESSIONS_HELP_TEXT: function() { return "Automatically sent 24 hours after the previous session, with a reminder sent 48 hours before the first session in this range. Guide is delivered once for the entire range."; },
        },

        GUIDE_CREATED_SUCCESS: function() { return "Guide has been added."; },
        GUIDE_UPDATED_SUCCESS: function() { return "Guide has been updated."; },
        CONFIRMATION_MODAL: {
          TITLE: function() { return "Discard unsaved changes?"; },
          BODY: function() { return "Are you sure you want to discard the changes you made?"; },
          DISCARD: function() { return "Discard"; },
        },

      },

      NO_GUIDES: function() { return "No guides have been added"; },
      GUIDANCE_DISABLED: {
        TITLE: function() { return "Guides are turned off"; },
        DESCRIPTION: function() { return "Enable guides to automatically deliver expert content and session support to your participants before each session."; },
        NUM_GUIDES_AVAILABLE: function(guidesCount: number) { return "You have <b>" + guidesCount + " " + plural(guidesCount, 0, en, { one: "guide", other: "guides" }) + "</b> available to enable."; },
        TURN_ON: function() { return "Turn on Guides"; },
      },

      RELATED_MATERIALS: function() { return "RELATED MATERIALS"; },
      ARIA_LABEL: {
        PLAY_VIDEO: function(videoTitle: string) { return "Play " + videoTitle + " video"; },
      },

    },

    REPORTING: {
      ANALYTICS: function() { return "Analytics"; },
      DATA_DOWNLOADS: function() { return "Data Downloads"; },
      DATA_DOWNLOADS_TOOLTIP: function() { return "Data downloads will include all information from the program start date through today."; },
      PROGRAM_ENGAGEMENT: function() { return "Program Engagement"; },
      PROGRAM_ENGAGEMENT_DESCRIPTION: function() { return "Gain insight into how mentoring pairs interact through meeting plans, scheduled sessions, action items, and platform visits."; },
      PROGRAM_ENGAGEMENT_ARIA_LABEL: function() { return "Download Program Engagement Report"; },
      PULSE_CHECKS: function() { return "Pulse Checks"; },
      PULSE_CHECKS_DESCRIPTION: function() { return "Track mentoring effectiveness and participant progress through regular feedback insights."; },
      PULSE_CHECKS_ARIA_LABEL: function() { return "Download Session Pulse Checks Report"; },
      DEVELEOPMENT_GOALS: function() { return "Development Goals"; },
      DEVELEOPMENT_GOALS_DESCRIPTION: function(d) { return "Gain valuable insights into the goals established for " + d.menteesAlias + " and monitor their progress effectively."; },
      DEVELEOPMENT_GOALS_ARIA_LABEL: function() { return "Download Development Goals Report"; },
      PARTICIPANT_PROGRAM_PROFILES: function() { return "Participant Program Profiles"; },
      PARTICIPANT_PROGRAM_PROFILES_DESCRIPTION: function(d) { return "View program profile information collected from " + d.mentorsAlias + " and " + d.menteesAlias + "."; },
      PARTICIPANT_PROGRAM_PROFILES_ARIA_LABEL: function() { return "Download Participant Program Profiles Report"; },
      DOWNLOAD: function() { return "Download"; },
      WHATS_INCLUDED: function() { return "What's included in the report?"; },
      DOWNLOAD_INCLUDES: function() { return "Download Includes:"; },
      PROGRAM_ENGAGEMENT_POPOVER: {
        MENTOR_NAME: function(d) { return d.MentorAlias + " Name"; },
        MENTEE_NAME: function(d) { return d.MenteeAlias + " Name"; },
        MATCHED_DATE: function() { return "Matched Date"; },
        MEETING_PLAN_CADENCE: function() { return "Meeting Plan Cadence"; },
        MEETING_PLAN_ENDS_DATE: function() { return "Meeting Plan Ends Date"; },
        MEETING_PLAN_DURATION: function() { return "Meeting Plan Duration"; },
        SESSIONS_TOTAL: function() { return "Sessions - Total"; },
        SESSIONS_PAST: function() { return "Sessions - Past"; },
        SESSIONS_UPCOMING: function() { return "Sessions - Upcoming"; },
        ACTION_ITEMS_TOTAL: function() { return "Action Items - Total"; },
        ACTION_ITEMS_OUTSTANDING: function() { return "Action Items - Outstanding"; },
        ACTION_ITEMS_COMPLETE: function() { return "Action Items - Complete"; },
        ACTION_ITEMS_TOTAL_MENTOR_OWNED: function(d) { return "Action Items - Total " + d.MentorAlias + "-Owned"; },
        ACTION_ITEMS_TOTAL_MENTEE_OWNED: function(d) { return "Action Items - Total " + d.MenteeAlias + "-Owned"; },
        MENTOR_LAST_VISIT: function(d) { return d.MentorAlias + " Last Visit"; },
        MENTEE_LAST_VISIT: function(d) { return d.MenteeAlias + " Last Visit"; },
        LAST_SESSION_DATE: function() { return "Last Session Date"; },
      },

      PULSE_CHECKS_POPOVER: {
        MENTOR_NAME: function(d) { return d.MentorAlias + " name"; },
        MENTEE_NAME: function(d) { return d.MenteeAlias + " name"; },
        SESSION_DATE: function() { return "Session date"; },
        MENTEE_RESPONSE: function(d) { return "The " + d.menteeAlias + "'s responses to the pulse check questions prefixed with \"" + d.MenteeAlias + " - \""; },
        MENTOR_RESPONSE: function(d) { return "The " + d.mentorAlias + "'s responses to their questions prefixed with \"" + d.MentorAlias + " - \""; },
        MENTEE_RESPONSE_DATE: function(d) { return d.MenteeAlias + " response date"; },
        MENTOR_RESPONSE_DATE: function(d) { return d.MentorAlias + " response date"; },
      },

      DEVELOPMENT_GOALS_POPOVER: {
        USERS_EMAIL: function() { return "User's Email - Email address of the user who owns the goal"; },
        EXTERNAL_ID: function() { return "External ID - The user's external ID (in institutions where this is configured)"; },
        FIRST_NAME: function() { return "First Name - First name of the user who owns the goal"; },
        LAST_NAME: function() { return "Last Name - Last name of the user who owns the goal"; },
        GOAL_CREATION_DATE: function() { return "Goal Creation Date - Date when the goal was created"; },
        GOAL: function() { return "Goal – Goal text"; },
        STATUS: function() { return "Status – Current status of the goal"; },
      },

      PARTICIPANT_PROGRAM_PROFILES_POPOVER: {
        USERS_EMAIL: function() { return "User's Email"; },
        EXTERNAL_ID: function() { return "External ID - The user's external ID (in institutions where this is configured)"; },
        FIRST_NAME: function() { return "First Name"; },
        LAST_NAME: function() { return "Last Name"; },
        HEADLINE: function() { return "Headline - The user account headline field"; },
        BIO: function() { return "Bio - The user account short bio field"; },
        CITY: function() { return "City - The city from the user account location fields"; },
        STATE: function() { return "State - The state from the user account location fields"; },
        COUNTRY: function() { return "Country - The country from the user account location fields"; },
        ORG_LEVEL_QUESTIONS: function() { return "Org-level profile questions"; },
        PROGRAM_LEVEL_QUESTIONS: function() { return "Program-level profile questions"; },
      },

      PROGRAM_REFLECTIONS: function() { return "Program Reflections"; },
      PROGRAM_REFLECTIONS_DESCRIPTION: function() { return "Understand participant experiences and program impact through reflection responses."; },
      PROGRAM_REFLECTIONS_ARIA_LABEL: function() { return "Download Program Reflections Report"; },
      PROGRAM_REFLECTIONS_POPOVER: {
        MENTOR_EMAIL: function(d) { return d.MentorAlias + " Email"; },
        MENTEE_EMAIL: function(d) { return d.MenteeAlias + " Email"; },
        MENTOR_FIRST_NAME: function(d) { return d.MentorAlias + " First Name"; },
        MENTOR_LAST_NAME: function(d) { return d.MentorAlias + " Last Name"; },
        MENTEE_FIRST_NAME: function(d) { return d.MenteeAlias + " First Name"; },
        MENTEE_LAST_NAME: function(d) { return d.MenteeAlias + " Last Name"; },
        MENTEE_RESPONSES: function(d) { return "The " + d.menteeAlias + "'s responses to the questions prefixed with \"" + d.MenteeAlias + " - \""; },
        MENTOR_RESPONSES: function(d) { return "The " + d.mentorAlias + "'s responses to the questions prefixed with \"" + d.MentorAlias + " - \""; },
        MENTEE_RESPONSE_DATE_AND_TIME: function(d) { return d.MenteeAlias + " response date and time"; },
        MENTOR_RESPONSE_DATE_AND_TIME: function(d) { return d.MentorAlias + " response date and time"; },
      },

    },

    ROLES: {
      PARTICIPANTS_CATEGORY: {
        TITLE: function() { return "Participant Roles"; },
        MENTOR: function(d) { return d.MentorAlias; },
        MENTEE: function(d) { return d.MenteeAlias; },
        NO_ALIAS_MENTOR: function() { return "Mentor"; },
        NO_ALIAS_MENTEE: function() { return "Mentee"; },
        MENTORS: function(d) { return d.MentorsAlias; },
        MENTEES: function(d) { return d.MenteesAlias; },
        NUM_MENTORS: function(d) { return d.MentorsAlias + " (" + d.mentorsCount + ")"; },
        NUM_MENTEES: function(d) { return d.MenteesAlias + " (" + d.menteesCount + ")"; },
      },

      ADMIN_CATEGORY: {
        TITLE: function() { return "Admin"; },
        ADMINS: function() { return "Program Admins"; },
        NUM_ADMINS: function(adminsCount: number) { return "Program Admins (" + adminsCount + ")"; },
      },

    },

    CONNECTIONS_TABLE: {
      COLUMNS: {
        TITLE: function(d) { return "Connections (" + d.MentorAlias + " 🔗 " + d.MenteeAlias + ")"; },
      },

      ROWS: {
        MENU: {
          UNPAIR_CONNECTION: {
            TITLE: function() { return "Unpair Connection"; },
            CONFIRMATION_MODAL: {
              CONTENT: function(menteeFullName: string, mentorFullName: string) { return "You are about to unpair " + mentorFullName + " and " + menteeFullName + ". This action cannot be undone. Are you sure you'd like to proceed?"; },
              CONFIRM_BUTTON_LABEL: function() { return "Yes, unpair connection"; },
              SUCCESS_MESSAGE: function() { return "Connection unpaired"; },
            },

          },

        },

        CONNECTION_TYPE: {
          MANUAL_TOOLTIP: function(connectionDate: string, connectionTime: string) { return "Manually connected on " + connectionDate + " at " + connectionTime; },
          AUTO_TOOLTIP: function(connectionDate: string, connectionTime: string) { return "Auto-generated on " + connectionDate + " at " + connectionTime; },
          REQUEST_TOOLTIP: function(connectionDate: string, connectionTime: string) { return "Connected on " + connectionDate + " at " + connectionTime; },
        },

      },

      EMPTY: function() { return "No connections have been created"; },
      ARIA_LABEL: {
        CONNECTION_OPTIONS_MENU: function() { return "Connection Options Menu"; },
      },

    },

    CREATE_CONNECTION_FLYOUT_MODAL: {
      ASSIGN_MENTOR: {
        TITLE: function(d) { return "Assign a " + d.MentorAlias + " for:"; },
        MENTORS_TABLE: {
          COLUMNS: {
            TITLE: function() { return "MENTORS"; },
          },

        },

        CONFIRMATION_MODAL: {
          CONTENT: function(d) { return d.mentorFirstName + " already has " + d.numberOfConnections + " " + plural(d.numberOfConnections, 0, en, { one: d.menteeAlias, other: d.menteesAlias }) + ". Are you sure you'd like to assign " + d.menteeFirstName + " to " + d.mentorFirstName + "?"; },
        },

      },

      ASSIGN_MENTEES: {
        TITLE: function(d) { return "Assign " + d.MenteeAlias + "(s)"; },
        MENTEES_TABLE: {
          COLUMNS: {
            TITLE: function() { return "MENTEES"; },
          },

        },

        CONFIRMATION_MODAL: {
          CONTENT: function(d) { return d.mentorFirstName + " already has " + d.numberOfConnections + " " + plural(d.numberOfConnections, 0, en, { one: d.menteeAlias, other: d.menteesAlias }) + ". Are you sure you want to assign " + d.newTotalMentees + " more " + plural(d.newTotalMentees, 0, en, { one: d.menteeAlias, other: d.menteesAlias }) + " to " + d.mentorFirstName + "? This will put " + d.mentorFirstName + " over capacity."; },
        },

      },

      SEARCH_PLACEHOLDER: function() { return "Search for participant by name or email"; },
      CANCEL: function() { return "Cancel"; },
      SAVE: function() { return "Apply"; },
    },

    PROGRAM_HEADER_MENU: {
      AUTO_MATCHING: {
        BUTTON: {
          DEFAULT: function(isAutoMatchingEnabled: string) { return "Auto-Matching is " + select(isAutoMatchingEnabled, { true: "on", other: "off" }); },
          DEFAULT_FUTURE: function(date: string) { return "Auto-matching is scheduled to run " + date; },
          IN_PROGRESS: function() { return "Generating connections..."; },
          COMPLETED: function(lastUpdatedDate: string, lastUpdatedTime: string) { return "Last updated on " + lastUpdatedDate + " at " + lastUpdatedTime; },
        },

        MODAL: {
          TITLE: function() { return "Auto-Matching"; },
          TOGGLE_LABEL: function(isAutoMatchingEnabled: string) { return "Auto-Matching is " + select(isAutoMatchingEnabled, { true: "", other: "not" }) + " running"; },
          TOGGLE_INFO: function() { return "When enabled, the system will immediately create connections with consideration of any matching rules and automatically connect any newly available participants on an ongoing basis."; },
          CONTENT: function() { return "Automatically connect unmatched participants."; },
          RULES: {
            TOTAL_RULES_APPLIED: function(totalRulesCount: number) { return totalRulesCount + " " + plural(totalRulesCount, 0, en, { one: " rule", other: " rules" }) + " applied"; },
            EDIT: function() { return "Edit"; },
            CREATE_RULES: function() { return "Create rules"; },
            ARIA_LABEL: {
              EDIT: function() { return "Edit Matching Rules"; },
              CREATE: function() { return "Create Matching Rules"; },
            },

          },

          MATCH_ANNOUNCEMENT_DATE: {
            NOT_SET: function() { return "Set match auto run and announcement date"; },
            SET_DATE: function() { return "Set Date"; },
            ANNOUNCED_ON: function(date: string, hasMatchDatePassed: string) { return "Your match auto run and announcement date " + select(hasMatchDatePassed, { true: "completed on", other: "is scheduled for" }) + " <span class=\"bold\">" + date + "</span>"; },
            EDIT: function() { return "Edit"; },
            TOOLTIP: function() { return "All matched participants will receive an email notifying them of their match on this date.<br/></br>*We will also run auto-matching on this date and time for unmatched participants.*"; },
            ARIA_LABEL: {
              SET_DATE: function() { return "Set Match Announcement Date"; },
            },

          },

          ARIA_LABEL: {
            ENABLE_AUTO_MATCHING: function() { return "Enable Auto Matching"; },
            DISABLE_AUTO_MATCHING: function() { return "Disable Auto Matching"; },
          },

        },

      },

      EDIT: {
        EDIT_HEADER: function() { return "Edit Header"; },
        CLONE_PROGRAM: function() { return "Clone Program"; },
        CLONING_IN_PROGRESS: function() { return "Cloning in progress..."; },
        UPLOAD_A_BACKGROUND_IMAGE: function() { return "Upload a Background Image"; },
        EDIT_BACKGROUND_IMAGE: function() { return "Edit Background Image"; },
        UPLOAD_NEW_IMAGE: function() { return "Upload New Image"; },
        REMOVE_BACKGROUND_IMAGE: function() { return "Remove Background Image"; },
        TITLE_TEXT_BLACK: function() { return "Change the title text to black"; },
        TITLE_TEXT_WHITE: function() { return "Change the title text to white"; },
      },

      CLONE: {
        MODAL_TITLE: function() { return "Clone New Program"; },
        STEPS: {
          STEP_ONE: {
            NAME: function() { return "Program Information"; },
            TITLE: function() { return "Enter New Program Basics"; },
            DESCRIPTION: function() { return "You are cloning the following program:"; },
            INFO: {
              PROGRAM_NAME: function() { return "Program Name"; },
              RELEASE_DATE: function() { return "Release Date"; },
              END_DATE: function() { return "End Date"; },
              ADMIN_USERS: function() { return "Admin Users"; },
            },

            FORM: {
              SOURCE_PROGRAM_INFO_TITLE: function() { return "Source Program"; },
              NAME_PLACEHOLDER: function() { return "Enter a name for the cloned program"; },
              DESCRIPTION_PLACEHOLDER: function() { return "Optional description"; },
              NEW_PROGRAM: function() { return "New Program"; },
              OPTIONAL: function() { return "optional"; },
              PROGRAM_DESCRIPTION: function() { return "Program Description (optional)"; },
            },

          },

          STEP_TWO: {
            NAME: function() { return "User Management"; },
            OPTIONAL_LABEL: function() { return "Optional"; },
            TITLE: function() { return "Review Admin Users"; },
            DESCRIPTION: function() { return "Update admin users for this clone."; },
            COUNTER: function(selected: string, total: string) { return selected + " of " + total + " selected"; },
            SELECT_ALL: function() { return "Select All"; },
            UNSELECT_ALL: function() { return "Unselect All"; },
            NO_ADMINS: function() { return "No Admin Users"; },
            LOADING: function() { return "Loading admins..."; },
          },

          STEP_THREE: {
            NAME: function() { return "Review"; },
            TITLE: function() { return "Review Clone Information"; },
            DESCRIPTION: function() { return "Review the details below for your new program and confirm everything is correct."; },
            CLONED_PROGRAM_SECTION_TITLE: function() { return "Cloned Program Information"; },
            EDIT: function() { return "Edit"; },
          },

        },

        ACTIONS: {
          START_CLONE: function() { return "Start Clone"; },
          CLONING: function() { return "Cloning..."; },
        },

        ALERT: {
          SUCCESS_TITLE: function() { return "Cloning in Progress"; },
          SUCCESS_MESSAGE: function() { return "Small programs take minutes, while larger ones with hundreds of guides/communications may take up to an hour. We will send you an email once it's ready."; },
          ERROR_TITLE: function() { return "Clone Failed"; },
          ERROR_MESSAGE: function() { return "We couldn't clone the program. Please try again."; },
          COMPLETED_TITLE: function() { return "Program Cloned"; },
          COMPLETED_MESSAGE: function(programName: string) { return "Your clone is completed: <b>" + programName + "</b>"; },
          OPEN_PROGRAM: function() { return "Open Program"; },
        },

      },

    },

    TEMPLATES: {
      SETTINGS: {
        NAVIGATE_AWAY: {
          UNSAVED_CHANGES: function() { return "You have unsaved changes, are you sure?"; },
          INCOMPLETE_QUESTIONS: function() { return "You have incomplete questions. Are you sure you'd like to leave? Incomplete questions will be discarded."; },
        },

      },

    },

    PARTICIPANT_HOME: {
      COMMON: {
        TOOLTIP: {
          CHANGE_OWNER: function(newAssigneeName: string) { return "Change Owner to " + newAssigneeName; },
        },

      },

      WORKSPACE_TITLE: function(firstName: string, secondName: string) { return "Workspace - " + firstName + " & " + secondName; },
      REQUESTS_PANEL: {
        TITLE: function() { return "Requests"; },
        REQUESTED: function(requestDate: string) { return "Requested on " + requestDate; },
        MENTOR_REQUEST_ARIA_LABEL: function(mentorName: string) { return "You have requested to be mentored by " + mentorName; },
      },

      GET_STARTED: {
        TITLE: function() { return "Get Started"; },
        LIST: {
          COMPLETE_YOUR_PROFILE: {
            TITLE: function() { return "Complete your program profile"; },
            COMPLETE_BY_DATE: function(dueDate: string) { return "Complete by " + dueDate; },
            NEW_INFO_NEEDED: function() { return "Looks like there's new information needed in your profile!"; },
          },

          REVIEW_YOUR_PROFILE: {
            TITLE: function() { return "Review your program profile"; },
          },

          WAIT_TO_BE_CONNECTED: {
            TITLE: function() { return "Wait to be connected"; },
            UPCOMING_MATCH_DATE: function(matchDate: string) { return "You will receive your match on " + matchDate; },
            PASSED_MATCH_DATE_WITH_CONNECTION: function(matchDate: string) { return "You received your match on " + matchDate; },
            PASSED_MATCH_DATE_WITHOUT_CONNECTION: function() { return "Hang tight! We're still looking for a match for you. Please contact your program administrator if necessary."; },
          },

          PLAN_FIRST_SESSION: {
            TITLE: function() { return "Schedule your first session"; },
            CONTENT: function() { return "Get started by scheduling and preparing for your first session."; },
            ADD_SESSION: function() { return "Add Session"; },
          },

          FIND_A_MENTOR: {
            TITLE: function(d) { return "Find your " + d.mentorAlias; },
            CONTENT: function() { return "Find someone who aligns with your interests."; },
            BROWSE_MENTORS: function(d) { return "Find " + d.MentorAlias; },
          },

          REVIEW_MENTEE_REQUESTS: {
            TITLE: function(d) { return "Review " + d.menteeAlias + " requests"; },
            CONTENT: function(d) { return "Review " + d.menteeAlias + " requests when they come in, accept or decline based on your preferences."; },
          },

        },

        PROFILE_MODAL: {
          CTA_BUTTON: {
            GET_STARTED: function() { return "Get Started"; },
            CONTINUE: function() { return "Continue"; },
            EDIT_PROFILE: function() { return "Edit Profile"; },
          },

          TITLE: {
            DEFAULT: function() { return "Profile"; },
            COMPLETE_PROFILE: function() { return "Complete your program profile!"; },
            REVIEW_PROFILE: function() { return "Review your program profile!"; },
            EDIT_PROFILE: function() { return "Edit Profile"; },
          },

          SUBTITLE: function() { return "Your Profile Information"; },
          DESCRIPTION: function() { return "Review and edit your profile information. Any required fields will be marked with <span class=\"label text-danger\">*</span>. <br/>These fields may be used for finding you a match."; },
          ORG_QUESTIONS: {
            ACCOUNT_FIELDS: {
              PROFILE_PHOTO: {
                TITLE: function() { return "Profile Photo"; },
                UPLOAD_PHOTO: function() { return "Upload Photo"; },
              },

            },

            TIME_ZONE_QUESTION: {
              NOTE: function() { return "This timezone is used for matching only and won't change your platform settings."; },
            },

          },

          PROGRAM_QUESTIONS: {
            TITLE: function() { return "Program Questions"; },
            DESCRIPTION: function() { return "The following are program specific questions that will be used to facilitate matching and visible to others."; },
            MENTOR_CAPACITY: {
              TITLE: function(d) { return "How many " + d.menteesAlias + " can you support?"; },
              NOTE: function() { return "You can change this later if your availability changes."; },
              WARNING: {
                TITLE: function() { return "Please Note:"; },
                CONTENT_OVER_CAPACITY: function() { return "With this new limit, you will be over capacity. Your existing connections won't be affected."; },
                CONTENT_AT_CAPACITY: function() { return "With this new limit, you won't have room for anyone new. We'll close out pending requests and pause new ones until you create space. Your existing connections won't be affected."; },
              },

            },

          },

          PLACEHOLDERS: {
            DROPDOWN: function() { return "Select an option"; },
          },

          SAVE: function() { return "Save"; },
          UNSAVED_CHANGES: function() { return "Your latest changes and edits will not be saved."; },
        },

        STATUS_BADGE: {
          NOT_STARTED: function() { return "Not Started"; },
          IN_PROGRESS: function() { return "In Progress"; },
          COMPLETE: function() { return "Complete"; },
        },

        FIND_A_MENTOR_MODAL: {
          TITLE: function(d) { return "Find Your " + d.MentorAlias; },
          SEARCH_PLACEHOLDER: function() { return "Search by name or email"; },
          CONTENT: {
            EMPTY: function(d) { return "Stay tuned—" + d.mentorsAlias + " will be here<br />soon."; },
            LOADING_RESULTS: function() { return "Loading results..."; },
            RESULTS_COUNT: function(resultsCount: number) { return resultsCount + " " + plural(resultsCount, 0, en, { one: "Result", other: "Results" }); },
            MENTOR_CARD: {
              STATUS: {
                AVAILABLE: function() { return "Available"; },
                UNAVAILABLE: function() { return "Unavailable"; },
              },

              CONNECTION_REQUESTED: function() { return "Requested"; },
            },

          },

          FILTERS: {
            TIME_ZONE: {
              ANY_TIME_ZONE: function() { return "Any time zone"; },
              SAME_TIME_ZONE: function() { return "± 0 hours (same time zone)"; },
              PLUS_X_HOUR: function(x: string) { return "± " + x + " " + plural(x, 0, en, { one: "hour", other: "hours" }); },
              TITLE: {
                ANY_TIME_ZONE: function() { return "Time Zone"; },
                SAME_TIME_ZONE: function() { return "Time Zone (Same)"; },
                PLUS_X_HOUR: function(x: string) { return "Time Zone (± " + x + " " + plural(x, 0, en, { one: "hr", other: "hrs" }) + ")"; },
              },

            },

          },

        },

      },

      EXPIRED_TOKEN: {
        MS_TEAMS: function(email: string) { return "Your Microsoft account needs to be re-authenticated with " + email + " in order to include MS Teams meetings for your sessions."; },
        ZOOM: function(email: string) { return "Your Zoom account needs to be re-authenticated with " + email + "."; },
        MS_CALENDAR: function(email: string) { return "Your Microsoft account needs to be re-authenticated with " + email + " for calendar events to be created."; },
        BUTTON: function() { return "Authenticate"; },
      },

      NEXT_SESSION: {
        TITLE: function() { return "Next Session"; },
        STILL_WAITING: function() { return "Still waiting for the next session..."; },
        ADD_SESSION: function() { return "Add Session"; },
        PLACEHOLDER: {
          DATE_ALT_IMAGE: function() { return "Next Session Date"; },
        },

      },

      SESSIONS: {
        TITLE: function(totalSessionsCount: number) { return "Sessions (" + totalSessionsCount + ")"; },
        UPCOMING: function(upcomingSessionsCount: number) { return "Upcoming (" + upcomingSessionsCount + ")"; },
        PAST: function(pastSessionsCount: number) { return " Past (" + pastSessionsCount + ")"; },
        ADD_SESSION: function() { return "+ Add Session"; },
        NO_UPCOMING_SESSIONS: function() { return "No upcoming sessions"; },
        NO_PAST_SESSIONS: function() { return "No past sessions"; },
        PENDING_FEEDBACK: function() { return "Pending Session Feedback"; },
        ARIA_LABEL: {
          VIEW_DETAILS: function(sessionName: string) { return "View " + sessionName + " details"; },
        },

      },

      ACTION_ITEMS: {
        TITLE: function() { return "Action Items"; },
        ALT_IMAGE: function() { return "Action Items"; },
        DESCRIPTION: function(d) { return "Action items is a shared place to keep track of follow-ups between " + d.mentorAlias + " and " + d.menteesAlias + "."; },
        COMPLETED_ITEMS: function(completedCount: number) { return "COMPLETED ITEMS (" + completedCount + ")"; },
        ITEM: {
          ADD_BUTTON: function() { return "Add action item here"; },
          TOOLTIP: {
            MARK_COMPLETE: function() { return "Mark Complete"; },
            MARK_UNCOMPLETE: function() { return "Mark Uncompleted"; },
            ADDED_ON_SESSION: function(sessionName: string) { return "Added on " + sessionName; },
            DATE_FORMAT: function() { return "MM/DD/YY [at] h:mma"; },
            COMPLETED_BY: function(completedAt: string, completedBy: string) { return "Marked Complete by " + completedBy + " on " + completedAt; },
            DELETE_ACTION_ITEM: function() { return "Delete Action Item"; },
          },

        },

        ARIA_LABEL: {
          ACTION_ITEM_STATUS: function() { return "Action Item Status"; },
          UPDATE_ACTION_ITEM: function() { return "Update Action Item"; },
          ADD_ACTION_ITEM: function() { return "Add Action Item"; },
          SESSION_MENU_OPTION: function(sessionName: string) { return "Open " + sessionName + " details"; },
          ADDED_ACTION_ITEM: function(actionItemName: string, actionItemOwner: string) { return "Added new action item " + actionItemName + " to " + actionItemOwner; },
        },

      },

      GUIDELINES_AND_EXPECTATIONS: {
        TITLE: function() { return "Program Guidelines and Expectations"; },
      },

      CONNECTION_DETAILS: {
        NO_CONNECTION: function(d) { return "Pending " + select(d.role, { MENTORSHIP_PROGRAM_MENTOR: d.MenteeAlias, other: d.MentorAlias }); },
        PROGRAM_PROFILE: {
          TITLE: function() { return "PROGRAM PROFILE"; },
        },

      },

      MATCH_CELEBRATION: {
        TITLE: function() { return "Congratulations!"; },
        AUTO_MATCHING: {
          SINGLE_MENTEE: function(downcasedSingularized: string) { return "You've been assigned a " + downcasedSingularized + ". Go take a look at their profile to learn more about them."; },
          MULTIPLE_MENTEES: function(mentees: number) { return "You've been assigned " + plural(mentees, 0, en, { one: " mentee", other: number("en", mentees, 0) + " mentees" }) + ". Get started by going to your connection space to learn more about them."; },
        },

        PARTICIPANT_DRIVEN: {
          TEXT: function(connectionName: string) { return "You and " + connectionName + " are now connected."; },
        },

        ALT_IMAGE: function() { return "Celebration Image"; },
      },

      REMAINING_QUESTIONS_MODAL: {
        COMPLETED: {
          TITLE: function() { return "All done!"; },
          PARTICIPANT_DRIVEN: {
            MENTEE: function(d) { return "You're all set! Now you can start browsing " + d.mentorsAlias + " and request connections."; },
            MENTOR: function(d) { return "You're all set! You're ready to receive connection requests from " + d.menteesAlias + "."; },
            ALREADY_MATCHED: function(d) { return "Looks like you're already connected with a " + select(d.role, { MENTORSHIP_PROGRAM_MENTOR: d.menteeAlias, other: d.mentorAlias }) + "."; },
            GUIDE_DESCRIPTION: function() { return " While you're here, check out this guide to help you prepare."; },
          },

          AUTO_MATCHING: {
            NO_MATCH_DATE: function() { return "You're all set! Now sit back and relax—your matches will be announced soon."; },
            MATCH_DATE_PASSED: function() { return "Looks like connections have already been announced. You may have been matched with the information that was already provided."; },
            MATCH_DATE_UPCOMING: function(timeLeft: string, timeUnit: string) { return "You're set to be matched. <b>" + timeLeft + " " + plural(timeLeft, 0, en, { one: timeUnit, other: timeUnit + "s" }) + "</b> left until connections are announced!"; },
            MATCH_DATE_UPCOMING_MONTHS_DAYS: function(daysLeft: string, daysUnit: string, monthsLeft: string, monthsUnit: string) { return "You're set to be matched. <b>" + monthsLeft + " " + plural(monthsLeft, 0, en, { one: monthsUnit, other: monthsUnit + "s" }) + " and " + daysLeft + " " + plural(daysLeft, 0, en, { one: daysUnit, other: daysUnit + "s" }) + "</b> left until connections are announced!"; },
            GUIDE_DESCRIPTION: function() { return " Now that you've completed your profile, take a look at this guide while you wait to be connected."; },
          },

        },

        IN_PROGRESS: {
          TITLE: function(remainingQuestions: string) { return remainingQuestions + " " + plural(remainingQuestions, 0, en, { one: " Required Question", other: " Required Questions" }) + " Remaining"; },
          PARTICIPANT_DRIVEN: {
            MENTEE: function(d) { return "Complete your profile to begin browsing " + d.mentorsAlias + "!"; },
            MENTOR: function(d) { return "Complete your profile so " + d.menteesAlias + " can learn more about you!"; },
            ALREADY_MATCHED: function() { return "Complete your profile to make the most of your experience!"; },
          },

          AUTO_MATCHING: {
            NO_MATCH_DATE: function() { return "Complete your profile for the most optimal match!"; },
            MATCH_DATE_PASSED: function() { return "Looks like connections have already been announced. Complete your profile for the most optimal future matches."; },
            MATCH_DATE_UPCOMING: function(timeLeft: string, timeUnit: string) { return "<b>" + timeLeft + " " + plural(timeLeft, 0, en, { one: timeUnit, other: timeUnit + "s" }) + "</b> left until connections are announced. Complete your profile before then for the most optimal match!"; },
            MATCH_DATE_UPCOMING_MONTHS_DAYS: function(daysLeft: string, daysUnit: string, monthsLeft: string, monthsUnit: string) { return "<b>" + monthsLeft + " " + plural(monthsLeft, 0, en, { one: monthsUnit, other: monthsUnit + "s" }) + " and " + daysLeft + " " + plural(daysLeft, 0, en, { one: daysUnit, other: daysUnit + "s" }) + "</b> left until connections are announced. Complete your profile before then for the most optimal match!"; },
          },

        },

        TIME_UNIT: {
          MINUTE: function() { return "minute"; },
          HOUR: function() { return "hour"; },
          DAY: function() { return "day"; },
          MONTH: function() { return "month"; },
        },

      },

      UNRELEASED_FEATURE: {
        TITLE: function() { return "You're early"; },
        DESCRIPTION: function(date: string) { return "This program hasn't been released yet. Come back after <b>" + date + "</b> to begin viewing content."; },
        DESCRIPTION_NO_DATE: function() { return "This program hasn't been released yet. Come back later to begin viewing content."; },
      },

      PROGRAM_CLOSED: {
        TITLE: function() { return "Program Closed"; },
        DESCRIPTION: function() { return "Your access to program content has ended."; },
        BACK_TO_DASHBOARD: function() { return "Back to Dashboard"; },
      },

      UNENROLLED: {
        TITLE: function() { return "Program Unavailable"; },
        DESCRIPTION: function() { return "You have been unenrolled by your program administrator."; },
        BACK_TO_DASHBOARD: function() { return "Back to Dashboard"; },
      },

      PLAN_SESSION_FLYOUT: {
        HEADER: function() { return "Session"; },
        TITLE: function() { return "Title"; },
        DEFAULT_TITLE: function(firstName: string, secondName: string) { return firstName + "-" + secondName + " Session"; },
        EDIT_MODE: {
          HEADER: function() { return "Create Meeting Plan"; },
          HEADER_EDIT: function() { return "Session"; },
          DESCRIPTION: function() { return "Define a consistent cadence for your future meetings so you can check in with one another on a regular basis."; },
          TITLE: function() { return "Title"; },
          SUBTITLE: function() { return "Edit"; },
          LOCATION: function() { return "Location"; },
          VIRTUAL_MEETING: function() { return "Virtual Meeting"; },
          RECURRENCE_TITLE: function() { return "How often will you meet?"; },
          NEXT_MEETING: function() { return "Starts On"; },
          DATE_AND_TIME: function() { return "Date and Time"; },
          TIMEZONE: function() { return "Time Zone"; },
          DURATION: function() { return "Duration"; },
          OPTIONAL_MEETING_PLAN: {
            TITLE: function() { return "Create Meeting Plan (Optional)"; },
            DESCRIPTION: function() { return "Define a consistent cadence for your future meetings so you can check in with one another on a regular basis."; },
          },

          CADENCE: function() { return "Cadence"; },
          CADENCE_PLACEHOLDER: function() { return "How often would you like to meet?"; },
          CADENCE_OPTIONS: {
            WEEKLY: function() { return "Weekly"; },
            BI_WEEKLY: function() { return "Bi-weekly"; },
            MONTHLY: function() { return "Monthly"; },
          },

          ENDS_ON: function() { return "Ends on"; },
          ENDS_ON_PLACEHOLDER: function() { return "Select a date"; },
          ENDS_ON_TOOLTIP: function() { return "This date applies to all sessions in your meeting plan."; },
          CANCEL: function() { return "Cancel"; },
          CREATE_SESSIONS: function() { return "Create Sessions"; },
          CREATING_SESSIONS: function() { return "Creating Sessions..."; },
          ADD: function() { return "Add"; },
          ADDING: function() { return "Adding..."; },
          SAVE: function() { return "Save"; },
          SAVING: function() { return "Saving..."; },
          UPDATE_ALL_REMAINING_SESSIONS: function() { return "Update All Remaining Sessions"; },
          UPDATE_ALL: function() { return "Update All"; },
          UPDATING: function() { return "Updating..."; },
          OPTIONAL_RECURRENCE_TITLE: function() { return "Create Meeting Plan (optional)"; },
          OPTIONAL_RECURRENCE_DESCRIPTION: function() { return "Define a consistent cadence for your future meetings so you can check in with one another on a regular basis."; },
          PREVIEW_TEXT: {
            NEW: {
              WEEKLY: function(closureDateText: string, dayOfWeek: string, endDate: string) { return "Your sessions will be <b>weekly</b> on <b>" + dayOfWeek + "</b> until <b>" + endDate + " " + closureDateText + "</b>"; },
              BI_WEEKLY: function(closureDateText: string, dayOfWeek: string, endDate: string) { return "Your sessions will be <b>every 2 weeks</b> on <b>" + dayOfWeek + "</b> until <b>" + endDate + " " + closureDateText + "</b>"; },
              MONTHLY: function(closureDateText: string, dayOfWeek: string, endDate: string, nthWeek: string) { return "Your sessions will be <b>monthly</b> on <b>the " + nthWeek + " " + dayOfWeek + "</b> until <b>" + endDate + " " + closureDateText + "</b>"; },
              DEFAULT: function(dayOfWeek: string, endDateText: string) { return "Your sessions will be on " + dayOfWeek + " until " + endDateText; },
            },

            EDIT: {
              WEEKLY: function(closureDateText: string, dayOfWeek: string, endDate: string) { return "Remaining sessions will be updated to <b>weekly</b> on <b>" + dayOfWeek + "</b> until <b>" + endDate + " " + closureDateText + "</b>"; },
              WEEKLY_NO_END_DATE: function(dayOfWeek: string) { return "Remaining sessions will be updated to <b>weekly</b> on <b>" + dayOfWeek + "</b>"; },
              BI_WEEKLY: function(closureDateText: string, dayOfWeek: string, endDate: string) { return "Remaining sessions will be updated to every <b>2 weeks</b> on <b>" + dayOfWeek + "</b> until <b>" + endDate + " " + closureDateText + "</b>"; },
              BI_WEEKLY_NO_END_DATE: function(dayOfWeek: string) { return "Remaining sessions will be updated to every <b>2 weeks</b> on <b>" + dayOfWeek + "</b>"; },
              MONTHLY: function(closureDateText: string, dayOfWeek: string, endDate: string, nthWeek: string) { return "Remaining sessions will be updated to <b>monthly</b> on <b>the " + nthWeek + " " + dayOfWeek + "</b> until <b>" + endDate + " " + closureDateText + "</b>"; },
              MONTHLY_NO_END_DATE: function(dayOfWeek: string, nthWeek: string) { return "Remaining sessions will be updated to <b>monthly</b> on <b>the " + nthWeek + " " + dayOfWeek + "</b>"; },
              DEFAULT_CADENCE: function(closureDateText: string, dayOfWeek: string) { return "Remaining sessions will be updated on " + dayOfWeek + " until " + closureDateText; },
              ONLY_END_DATE: function(endDate: string) { return "Remaining sessions will be updated to run until <b>" + endDate + "</b>"; },
            },

            NTH_WEEK: {
              FIRST: function() { return "first"; },
              SECOND: function() { return "second"; },
              THIRD: function() { return "third"; },
              FOURTH: function() { return "fourth"; },
              LAST: function() { return "last"; },
            },

            PROGRAM_CLOSURE_DATE: function() { return "(program closure date)"; },
            SELECTED_END_DATE: function() { return "the selected end date"; },
          },

          RECURRENCE_TOGGLE: {
            WEEKLY: function(dayOfWeek: string) { return "Weekly on " + dayOfWeek; },
            BI_WEEKLY: function(dayOfWeek: string) { return "Every 2 weeks on " + dayOfWeek; },
            MONTHLY: function(dayOfWeek: string, nthWeek: string) { return "Monthly on the " + nthWeek + " " + dayOfWeek; },
          },

          APPLY_CHANGES_MODAL: {
            HEADER: function() { return "Apply changes to"; },
            SINGLE_SESSION: function() { return "This session only"; },
            REMAINING_SESSIONS: function() { return "All remaining sessions"; },
            CANCEL: function() { return "Cancel"; },
            SAVE: function() { return "Save"; },
          },

          CADENCE_WARNING_MODAL: {
            TITLE: function() { return "Are you sure?"; },
            DESCRIPTION_ABOVE: function() { return "It looks like content exists in the following sessions:"; },
            DESCRIPTION_BELOW: function() { return "Changing this cadence may override content from these. If you proceed, this content may be deleted."; },
            CANCEL: function() { return "Cancel"; },
            CONFIRM: function() { return "Update Sessions"; },
          },

          SCHEDULING_WITH_AVAILABILITY: {
            BUTTON: function() { return "View suggested meeting times"; },
            ARIA_LABEL: function() { return "Scheduling with Availability"; },
            ERROR: {
              TITLE: function() { return "Something went wrong..."; },
              DESCRIPTION: function() { return "We're having trouble loading this right now. Please try refreshing or check back in a moment."; },
            },

            AVAILABILITY_CALENDAR: {
              HEADER: {
                TODAY: function() { return "Today"; },
                NEXT_WEEK: function() { return "Next Week"; },
                PREVIOUS_WEEK: function() { return "Previous Week"; },
              },

              NOTE: {
                BOTH_CONNECTED: function(participant: string) { return "Suggested times are based on your and " + participant + "'s availability"; },
                ONE_CONNECTED: function() { return "Suggested times are based on your availability"; },
              },

            },

          },

        },

        MEETING_LINK: {
          JOIN_MS_TEAMS_MEETING: function() { return "Join MS Teams Meeting"; },
          JOIN_ZOOM_MEETING: function() { return "Join Zoom Meeting"; },
        },

        VIRTUAL_MEETING: {
          TITLE: function() { return "Virtual Meeting"; },
          MS_CALENDAR_TITLE: function() { return "Microsoft 365 Calendar"; },
          TOOLTIP: function() { return "Enable Integrations"; },
          SUCCESS_MESSAGE: function() { return "Account connected."; },
          CONNECT: {
            ALL: function() { return "Connect Accounts"; },
            ALL_EXPIRED: function() { return "Re-connect Accounts"; },
            MS_TEAMS: function() { return "Connect to Microsoft Teams"; },
            MS_TEAMS_EXPIRED: function() { return "Re-connect to Microsoft Teams"; },
            ZOOM: function() { return "Connect to Zoom"; },
            ZOOM_EXPIRED: function() { return "Re-connect to Zoom"; },
            MS_CALENDAR: function() { return "Connect Account"; },
            MS_CALENDAR_EXPIRED: function() { return "Re-connect Account"; },
          },

          REAUTHENTICATE: {
            TITLE: function() { return "Your OAUTH token needs to be validated to connect to your calendar."; },
            LINK: function() { return "Go authenticate it now."; },
          },

          MAKE_VIRTUAL_MEETING: {
            ALL: function() { return "Make this a Virtual Meeting"; },
            MS_TEAMS: function() { return "Make this a Teams Meeting"; },
            ZOOM: function() { return "Make this a Zoom Meeting"; },
            DROPDOWN: {
              MS_TEAMS: function() { return "Microsoft Teams"; },
              ZOOM: function() { return "Zoom"; },
            },

          },

          JOIN_VIRTUAL_MEETING: {
            MS_TEAMS: function() { return "Join Teams Meeting"; },
            ZOOM: function() { return "Join Zoom Meeting"; },
            REMOVE_VIRTUAL_MEETING: function() { return "Remove Virtual Meeting"; },
            TOOLTIP: {
              MEETING_TEXT: function() { return "Meeting link will be<br />automatically generated after session is added."; },
            },

          },

        },

        ENABLE_INTEGRATIONS_MODAL: {
          TITLE: function() { return "Enable Integrations"; },
          MS_TEAMS: {
            TITLE: function() { return "Microsoft Teams Virtual Meetings"; },
            DESCRIPTION: function() { return "Connect your Microsoft Teams account so you can include Teams meetings links for your sessions."; },
            AUTHENTICATED_EMAIL: function(email: string) { return "Currently syncing with <b>" + email + "</b> for calendar events."; },
          },

          MS_CALENDAR: {
            TITLE: function() { return "Microsoft 365 Calendar"; },
            DESCRIPTION: function() { return "Connect your Microsoft 365 Calendar to have calendar events created for your sessions and view suggested meeting times."; },
            AUTHENTICATED_EMAIL: function(email: string) { return "Currently syncing with <b>" + email + "</b> for calendar events."; },
          },

          ZOOM: {
            TITLE: function() { return "Zoom"; },
            DESCRIPTION: function() { return "Connect your Zoom account so you can include Zoom meeting links for your sessions."; },
            AUTHENTICATED_EMAIL: function(email: string) { return "Currently syncing with <b>" + email + "</b>."; },
          },

          AUTHENTICATE: function() { return "Authenticate"; },
          CONNECTED: function() { return "Connected"; },
        },

        EDIT_SESSION_TOOLTIP: function() { return "Edit Session"; },
        DATE_AND_TIME: function() { return "Date and Time"; },
        SESSION_DETAILS: function() { return "Session Details"; },
        SESSION_DETAILS_DESCRIPTION: function() { return "Get started with planning your session or adding notes on what you discussed in your previous session."; },
        SESSION_DETAILS_PLACEHOLDER: function() { return "Your space to collaborate on a session agenda! List out any topics of interest for this session."; },
        CONFIRMATION_MODAL: {
          HEADER: function() { return "Discard unsaved changes?"; },
          BODY: function() { return "Are you sure you want to discard the changes you made?"; },
        },

        OPTIONS: {
          DELETE_SESSION: function() { return "Delete Session"; },
          DELETE_THIS_SESSION: function() { return "Are you sure you'd like to delete this session?"; },
          DELETE_DESCRIPTION: function() { return "All session related information will be discarded. This action is final and cannot be undone. <br /><br />Are you sure?"; },
          CONFIGURE_INTEGRATIONS: function() { return "Configure Integrations"; },
        },

        UPDATE_SUCCESS_MESSAGE: function() { return "Session has been updated"; },
        CREATE_MEETING_PLAN_SUCCESS: function(numSessions: string) { return numSessions + " " + plural(numSessions, 0, en, { one: "session", other: "sessions" }) + " created"; },
        UPDATE_MEETING_PLAN_SUCCESS: function() { return "Remaining sessions have been updated."; },
        ADD_SUCCESS_MESSAGE: function() { return "Session added"; },
        ARIA_LABEL: {
          SESSION_OPTIONS_MENU: function() { return "Session Options Menu"; },
          SAVE_SESSION: function() { return "Save Session"; },
        },

      },

      NEXT_STEPS: {
        TITLE: function() { return "Next Steps"; },
        CREATE_MEETING_PLAN: {
          TITLE: function() { return "Create Meeting Plan"; },
          CONTENT: function() { return "Align on availability, cadence and structure for a successful engagement."; },
          TOOLTIP: function() { return "Create Plan"; },
        },

        SESSION_PULSE_CHECK_STEP: {
          TITLE: function(connectionName: string) { return "Tell us how your last session with " + connectionName + " went!"; },
          SUBTITLE: function() { return "This quick survey will only take a moment."; },
          TOOLTIP: function() { return "Share Feedback"; },
          ARIA_LABEL: {
            OPEN_SESSION_PULSE_CHECK: function(sessionTitle: string) { return "Open " + sessionTitle + " Session Pulse Check"; },
          },

        },

        PROGRAM_REFLECTIONS: {
          TITLE: function() { return "Reflect on your progress together"; },
          CONTENT: function(connectionName: string) { return "Look back on what you and " + connectionName + " have accomplished. Take a few minutes to reflect and share your thoughts."; },
          TOOLTIP: function() { return "View Program Reflection"; },
          ARIA_LABEL: function() { return "Open Program Reflections"; },
        },

      },

      SESSION_PULSE_CHECK: {
        TITLE: function() { return "Session Pulse Check"; },
        FORM: {
          DESCRIPTION: function(connectionName: string) { return "This feedback won't be shared directly with " + connectionName + ", but is valuable for program admins to learn how matches are working out for participants."; },
          SESSION_NAME_TITLE: function() { return "Session Name"; },
          SESSION_DATE_TIME_TITLE: function() { return "Date and Time"; },
          PULSE_CHECK_SCALE_LABELS: {
            DISAGREE: function() { return "Strongly Disagree"; },
            AGREE: function() { return "Strongly Agree"; },
          },

          ARIA_LABEL: {
            LIKERT_SCALE_QUESTION: function(limitMax: string, limitMin: string, questionText: string) { return "How much do you agree with " + questionText + ", pick from " + limitMin + " (strongly disagree) to " + limitMax + " (strongly agree)?"; },
          },

        },

        CONFIRMATION: {
          TITLE: function() { return "You're all set!"; },
          ALREADY_RESPONDED: function() { return "It seems your awesome feedback already found a home in our feedback collection!"; },
          SUCCESS: function() { return "Hooray! Your feedback just leveled us up!"; },
        },

        CANCEL: {
          TITLE: function() { return "Discard unsaved changes?"; },
          BODY: function() { return "Are you sure you want to discard the changes you made?"; },
        },

        CTA: {
          TITLE: function() { return "This session has ended! How was it?"; },
          DESCRIPTION: function() { return "We'd love to hear how things went! This quick survey will only take a moment."; },
          BUTTON: function() { return "Share Feedback"; },
        },

      },

      GOALS: {
        TITLE: function() { return "Goals"; },
        MY_GOALS_TITLE: function(totalGoalsCount: number) { return "My Goals (" + totalGoalsCount + ")"; },
        CONNECTION_GOALS_TITLE: function(connectionFirstName: string, totalGoalsCount: number) { return connectionFirstName + "'s Goals (" + totalGoalsCount + ")"; },
        ITEM: {
          ADD_BUTTON: function() { return "Add goal here"; },
          STATUS: {
            TITLE: function() { return "Change Status"; },
            JUST_STARTING: function() { return "Just Starting"; },
            MAKING_PROGRESS: function() { return "Making Progress"; },
            SUBSTANTIAL_PROGRESS: function() { return "Substantial Progress"; },
          },

          TOOLTIP: {
            CHANGE_STATUS: function() { return "Change Status"; },
            DELETE_GOAL: function() { return "Delete Goal"; },
          },

        },

        EMPTY_LIST: function(menteeFirstName: string) { return "No goals have been added for " + menteeFirstName; },
        ARIA_LABEL: {
          UPDATE_GOAL: function() { return "Update Goal"; },
          ADD_GOAL: function() { return "Add Goal"; },
        },

      },

      GUIDANCE_SECTION: {
        SHOW_MORE: function(remainingCount: number) { return "+" + remainingCount + " more"; },
        SHOW_LESS: function() { return "Show less"; },
        ARIA_LABEL: {
          SHOW_GUIDE: function(guideTitle: string) { return "Show " + guideTitle + " guide"; },
          SHOW_LESS_GUIDES: function() { return "Show less guides"; },
          SHOW_MORE_GUIDES: function(guidesCount: number) { return "Show " + guidesCount + " more guides"; },
        },

      },

      ARIA_LABEL: {
        GO_BACK_TO_MY_MENTEES: function(d) { return "Go back to my " + d.menteesAlias; },
      },

      MENTOR_REQUEST_MODAL: {
        BACK: function() { return "Back"; },
        MENTEE_VIEW: {
          TITLE: function(d) { return "Request " + d.mentorName + " as your " + d.MentorAlias + "!"; },
          PENDING_REQUEST_TITLE: function() { return "Request Pending"; },
          AVAILABLE_DESCRIPTION: function(mentorName: string) { return "Write a message to " + mentorName + " asking if they're interested in this opportunity to work together! Please provide a brief message to introduce yourself and explain why you'd like to connect."; },
          UNAVAILABLE_DESCRIPTION: function(d) { return "It seems that " + d.mentorName + " is currently unavailable. We encourage you to explore other " + d.mentorsAlias + " who may be able to assist you on your journey."; },
          PENDING_REQUEST_DESCRIPTION: function(mentorName: string) { return "You've already sent a request to " + mentorName + ". You'll be notified when they respond."; },
          MESSAGE: function(mentor: string) { return "Hello! I'd like to work with you as my " + mentor + ". I think your experience could be valuable for my development."; },
          SEND_REQUEST: function() { return "Send Request"; },
          SENDING_REQUEST: function() { return "Sending Request..."; },
          SUCCESS_ALERT: function(fullName: string) { return "Request sent to " + fullName + "."; },
          CONTINUE_BROWSING: function() { return "Continue Browsing"; },
          WITHDRAW_REQUEST: function() { return "Withdraw Request"; },
          ACCEPT_REQUEST: function() { return "Yes, Let’s Work Together!"; },
          REJECT_REQUEST: function() { return "Not Right Now"; },
          REQUEST_SENT_TITLE: function() { return "Request Sent"; },
          REQUEST_CLOSED_TITLE: function() { return "Request Closed"; },
          REQUEST_CLOSED_MESSAGE: function(firstName: string) { return firstName + " has responded to your request and unfortunately isn't available to work together at this time."; },
          WITHDRAW_SUCCESS_ALERT: function() { return "Request has been withdrawn."; },
          REQUEST_WITHDRAWN: {
            TITLE: function() { return "Request Withdrawn"; },
            BODY: function() { return "This request is no longer available."; },
          },

          REQUEST_NOT_AVAILABLE: {
            TITLE: function() { return "Request Unavailable"; },
            BODY: function() { return "This request is no longer available."; },
          },

          WITHDRAW_CONFIRMATION_DIALOG: {
            TITLE: function() { return "Are you sure?"; },
            BODY: function(mentorName: string) { return "Withdrawing this request will remove your request to work with " + mentorName + ". Are you sure you'd like to continue?"; },
            CANCEL: function() { return "Cancel"; },
            WITHDRAW: function() { return "Withdraw Request"; },
          },

          DISCARD_CHANGES: {
            TITLE: function() { return "Discard unsaved changes?"; },
            BODY: function() { return "Are you sure you want to discard the changes you made?"; },
            CANCEL: function() { return "Cancel"; },
            DISCARD: function() { return "Discard"; },
          },

        },

        MENTOR_VIEW: {
          TITLE: function(d) { return d.menteeName + " requested you as their " + d.mentorAlias + "!"; },
          REQUEST_RECEIVED_TITLE: function() { return "Request Received"; },
          MENTOR_REQUEST_NOTIFICATION: function(d) { return "<b>" + d.fullName + "</b> requested you as their " + d.mentorAlias + "."; },
          REJECT_REQUEST_ALERT_SUCCESS: function(firstName: string) { return "We'll let " + firstName + " know you're unavailable to work together."; },
          REACHING_YOUR_LIMIT_MODAL: {
            HEADER: function() { return "You're reaching your limit"; },
            BODY: function(limit: string, profileSettingsLink: string) { return "Accepting this request means you'll be at your maximum of " + limit + " " + plural(limit, 0, en, { one: " person", other: " people" }) + ". We'll decline any pending requests and pause new ones until you have an opening. You can always adjust your limit in your <a href=\"" + profileSettingsLink + "\" target=\"_self\" style=\"color: #0E72ED\">profile settings</a>. Continue?"; },
            FOOTER: {
              CANCEL: function() { return "Cancel"; },
              CONTINUE: function() { return "Continue"; },
            },

          },

        },

        ARIA_LABEL: {
          BACK: function(d) { return "Go back to Find Your " + d.mentorAlias; },
          CAROUSEL: {
            PREVIOUS_BUTTON: function() { return "Go to previous item"; },
            NEXT_BUTTON: function() { return "Go to next item"; },
          },

        },

      },

      REFLECTION_WORKSPACE: {
        HEADER: function() { return "Program Reflection"; },
        LOOKING_BACK: function() { return "Looking Back"; },
        SUBTITLE: function() { return "The work you did together"; },
        STATS: {
          MONTHS: function(count: number) { return plural(count, 0, en, { one: "Month", other: "Months" }); },
          WEEKS: function(count: number) { return plural(count, 0, en, { one: "Week", other: "Weeks" }); },
          DAYS: function(count: number) { return plural(count, 0, en, { one: "Day", other: "Days" }); },
          SESSIONS: function(count: number) { return plural(count, 0, en, { one: "Session", other: "Sessions" }); },
          HOURS: function(count: number) { return plural(count, 0, en, { one: "Hour", other: "Hours" }); },
        },

        GOALS: {
          HEADER: function(count: number) { return "<span class=\"semi-bold\">" + count + " " + plural(count, 0, en, { one: "goal", other: "goals" }) + "</span> explored together. Here's how each one went."; },
          SHOW_MORE: function(count: number) { return "+" + count + " More"; },
          SHOW_LESS: function() { return "Show Less"; },
        },

        ACTION_ITEMS: {
          HEADER: function(count: number) { return "Together you completed <span class=\"semi-bold\">" + count + " " + plural(count, 0, en, { one: "action item", other: "action items" }) + "</span> along the way."; },
          SHOW_MORE: function(count: number) { return "+" + count + " More"; },
          SHOW_LESS: function() { return "Show Less"; },
        },

        SHARED_REFLECTIONS: {
          HEADING: function() { return "Shared Reflections"; },
          SUBHEADING: function() { return "In your own words"; },
          CARD_TITLE: function() { return "Add Your Reflection"; },
          CARD_SUBTITLE: function() { return "Add your perspective to complete the story."; },
          FOOTER_NOTE: function(name: string) { return "Your response will be visible to " + name + " and your program admin once submitted."; },
          NOW_IT_IS_YOUR_TURN: function() { return "Now it's your turn"; },
          READ_MORE: function() { return "Read More"; },
        },

        BANNER: {
          TITLE: function() { return "Program Reflection"; },
          DESCRIPTION: function() { return "Look back on your journey together"; },
        },

      },

    },

    MY_MENTEES: function(d) { return "My " + d.MenteesAlias; },
    ARIA_LABEL: {
      CLEAR_SEARCH: function() { return "Clear Search"; },
      ACCESS_PROGRAM: function(programName: string) { return "Access the " + programName + " program"; },
      PROGRAM_MENU_OPTIONS: function(programName: string) { return "Open " + programName + " program menu options"; },
    },

    AVATAR: {
      MENTOR_AVAILABILITY: {
        AVAILABLE: function(availability: string) { return availability + " open " + plural(availability, 0, en, { one: "spot", other: "spots" }); },
        UNAVAILABLE: function() { return "Unavailable"; },
      },

    },

    TIME_ZONE_OFFSET_INPUT: {
      TOOLTIP_TEXT_ON_DISABLED_UP: function() { return "Matches beyond ± 8 hours have minimal schedule overlap.<br />Consider removing this rule if greater flexibility is needed."; },
    },

    PROGRAM_THUMBNAIL: {
      ALT_TEXT: function() { return "Program Thumbnail"; },
    },

  },

  DISCUSSIONS_AUTO_TRANSLATION: {
    TRANSLATE: function() { return "Translate"; },
    TRANSLATING: function() { return "Translating..."; },
    TURN_OFF_TRANSLATION: function() { return "Turn off Translation"; },
    ERROR: function() { return "Unable to display translation."; },
    RETRY: function() { return "Please try again by refreshing this page."; },
  },

  AUTO_TRANSLATION: {
    SUBMISSION: {
      TURN_ON_TRANSLATION: function() { return "<b>Translate Submission</b> <br />Please Note: Only text content in the submission will be translated. Any files, audio or videos in it will not be translated."; },
    },

    VIDEO_CAPTIONS: {
      TRANSLATING: function() { return "Translating..."; },
      TOOLTIP: {
        TRANSLATING_CAPTIONS: function() { return "Translating Captions"; },
        CAPTIONS_TRANSLATED: function() { return "Captions Translated"; },
        CANNOT_TRANSLATE: function() { return "Captions could not be translated"; },
      },

    },

  },

};